import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  Upload: any;
};


export type AccessToken = {
  __typename?: 'AccessToken';
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  id: Scalars['ID'];
  isPasswordProtected?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<User>;
  patient?: Maybe<Patient>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type AccessTokenCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  isPasswordProtected?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<UserRelateToOneForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type AccessTokenManyRelationFilter = {
  every?: Maybe<AccessTokenWhereInput>;
  none?: Maybe<AccessTokenWhereInput>;
  some?: Maybe<AccessTokenWhereInput>;
};

export type AccessTokenOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isPasswordProtected?: Maybe<OrderDirection>;
  scopes?: Maybe<OrderDirection>;
  updatedAt?: Maybe<OrderDirection>;
  validFrom?: Maybe<OrderDirection>;
  validTo?: Maybe<OrderDirection>;
};

export type AccessTokenRelateToManyForCreateInput = {
  connect?: Maybe<Array<AccessTokenWhereUniqueInput>>;
  create?: Maybe<Array<AccessTokenCreateInput>>;
};

export type AccessTokenRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AccessTokenWhereUniqueInput>>;
  create?: Maybe<Array<AccessTokenCreateInput>>;
  disconnect?: Maybe<Array<AccessTokenWhereUniqueInput>>;
  set?: Maybe<Array<AccessTokenWhereUniqueInput>>;
};

export type AccessTokenUpdateArgs = {
  data: AccessTokenUpdateInput;
  where: AccessTokenWhereUniqueInput;
};

export type AccessTokenUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  isPasswordProtected?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<UserRelateToOneForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  scopes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type AccessTokenWhereInput = {
  AND?: Maybe<Array<AccessTokenWhereInput>>;
  NOT?: Maybe<Array<AccessTokenWhereInput>>;
  OR?: Maybe<Array<AccessTokenWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  id?: Maybe<IdFilter>;
  isPasswordProtected?: Maybe<BooleanFilter>;
  owner?: Maybe<UserWhereInput>;
  patient?: Maybe<PatientWhereInput>;
  scopes?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  validFrom?: Maybe<DateTimeNullableFilter>;
  validTo?: Maybe<DateTimeNullableFilter>;
};

export type AccessTokenWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Account = {
  __typename?: 'Account';
  access_token?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  idToken?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerAccountId?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  sessionState?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type AccountCreateInput = {
  access_token?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  idToken?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerAccountId?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  sessionState?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type AccountManyRelationFilter = {
  every?: Maybe<AccountWhereInput>;
  none?: Maybe<AccountWhereInput>;
  some?: Maybe<AccountWhereInput>;
};

export type AccountOrderByInput = {
  access_token?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  expiresAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  idToken?: Maybe<OrderDirection>;
  provider?: Maybe<OrderDirection>;
  providerAccountId?: Maybe<OrderDirection>;
  refresh_token?: Maybe<OrderDirection>;
  scope?: Maybe<OrderDirection>;
  sessionState?: Maybe<OrderDirection>;
  tokenType?: Maybe<OrderDirection>;
  type?: Maybe<OrderDirection>;
};

export type AccountRelateToManyForCreateInput = {
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  create?: Maybe<Array<AccountCreateInput>>;
};

export type AccountRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  create?: Maybe<Array<AccountCreateInput>>;
  disconnect?: Maybe<Array<AccountWhereUniqueInput>>;
  set?: Maybe<Array<AccountWhereUniqueInput>>;
};

export type AccountUpdateArgs = {
  data: AccountUpdateInput;
  where: AccountWhereUniqueInput;
};

export type AccountUpdateInput = {
  access_token?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  idToken?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerAccountId?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  sessionState?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type AccountWhereInput = {
  AND?: Maybe<Array<AccountWhereInput>>;
  NOT?: Maybe<Array<AccountWhereInput>>;
  OR?: Maybe<Array<AccountWhereInput>>;
  access_token?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  expiresAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  idToken?: Maybe<StringFilter>;
  provider?: Maybe<StringFilter>;
  providerAccountId?: Maybe<StringFilter>;
  refresh_token?: Maybe<StringFilter>;
  scope?: Maybe<StringFilter>;
  sessionState?: Maybe<StringFilter>;
  tokenType?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
  user?: Maybe<UserWhereInput>;
};

export type AccountWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  providerAccountId?: Maybe<Scalars['String']>;
};

export type ActiveIngredient = {
  __typename?: 'ActiveIngredient';
  createdAt?: Maybe<Scalars['DateTime']>;
  drugCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ingredientName?: Maybe<Scalars['String']>;
  medication?: Maybe<Medication>;
  strengthUnit?: Maybe<Scalars['String']>;
  strengthValue?: Maybe<Scalars['String']>;
};

export type ActiveIngredientCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  drugCode?: Maybe<Scalars['String']>;
  ingredientName?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForCreateInput>;
  strengthUnit?: Maybe<Scalars['String']>;
  strengthValue?: Maybe<Scalars['String']>;
};

export type ActiveIngredientManyRelationFilter = {
  every?: Maybe<ActiveIngredientWhereInput>;
  none?: Maybe<ActiveIngredientWhereInput>;
  some?: Maybe<ActiveIngredientWhereInput>;
};

export type ActiveIngredientOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  drugCode?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  ingredientName?: Maybe<OrderDirection>;
  strengthUnit?: Maybe<OrderDirection>;
  strengthValue?: Maybe<OrderDirection>;
};

export type ActiveIngredientRelateToManyForCreateInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  create?: Maybe<Array<ActiveIngredientCreateInput>>;
};

export type ActiveIngredientRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  create?: Maybe<Array<ActiveIngredientCreateInput>>;
  disconnect?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
  set?: Maybe<Array<ActiveIngredientWhereUniqueInput>>;
};

export type ActiveIngredientUpdateArgs = {
  data: ActiveIngredientUpdateInput;
  where: ActiveIngredientWhereUniqueInput;
};

export type ActiveIngredientUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  drugCode?: Maybe<Scalars['String']>;
  ingredientName?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForUpdateInput>;
  strengthUnit?: Maybe<Scalars['String']>;
  strengthValue?: Maybe<Scalars['String']>;
};

export type ActiveIngredientWhereInput = {
  AND?: Maybe<Array<ActiveIngredientWhereInput>>;
  NOT?: Maybe<Array<ActiveIngredientWhereInput>>;
  OR?: Maybe<Array<ActiveIngredientWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  drugCode?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  ingredientName?: Maybe<StringFilter>;
  medication?: Maybe<MedicationWhereInput>;
  strengthUnit?: Maybe<StringFilter>;
  strengthValue?: Maybe<StringFilter>;
};

export type ActiveIngredientWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEvent>;
  id: Scalars['ID'];
  locality?: Maybe<Scalars['String']>;
  pharmacyLocation?: Maybe<PharmacyLocation>;
  postalCode?: Maybe<Scalars['String']>;
  premise?: Maybe<Scalars['String']>;
  thoroughfare?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type AddressCreateInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicRelateToOneForCreateInput>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEventRelateToOneForCreateInput>;
  locality?: Maybe<Scalars['String']>;
  pharmacyLocation?: Maybe<PharmacyLocationRelateToOneForCreateInput>;
  postalCode?: Maybe<Scalars['String']>;
  premise?: Maybe<Scalars['String']>;
  thoroughfare?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type AddressOrderByInput = {
  addressLine1?: Maybe<OrderDirection>;
  addressLine2?: Maybe<OrderDirection>;
  administrativeArea?: Maybe<OrderDirection>;
  country?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  locality?: Maybe<OrderDirection>;
  postalCode?: Maybe<OrderDirection>;
  premise?: Maybe<OrderDirection>;
  thoroughfare?: Maybe<OrderDirection>;
};

export type AddressRelateToOneForCreateInput = {
  connect?: Maybe<AddressWhereUniqueInput>;
  create?: Maybe<AddressCreateInput>;
};

export type AddressRelateToOneForUpdateInput = {
  connect?: Maybe<AddressWhereUniqueInput>;
  create?: Maybe<AddressCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type AddressUpdateArgs = {
  data: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEventRelateToOneForUpdateInput>;
  locality?: Maybe<Scalars['String']>;
  pharmacyLocation?: Maybe<PharmacyLocationRelateToOneForUpdateInput>;
  postalCode?: Maybe<Scalars['String']>;
  premise?: Maybe<Scalars['String']>;
  thoroughfare?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type AddressWhereInput = {
  AND?: Maybe<Array<AddressWhereInput>>;
  NOT?: Maybe<Array<AddressWhereInput>>;
  OR?: Maybe<Array<AddressWhereInput>>;
  addressLine1?: Maybe<StringFilter>;
  addressLine2?: Maybe<StringFilter>;
  administrativeArea?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicWhereInput>;
  country?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<CalendarEventWhereInput>;
  id?: Maybe<IdFilter>;
  locality?: Maybe<StringFilter>;
  pharmacyLocation?: Maybe<PharmacyLocationWhereInput>;
  postalCode?: Maybe<StringFilter>;
  premise?: Maybe<StringFilter>;
  thoroughfare?: Maybe<StringFilter>;
  user?: Maybe<UserWhereInput>;
};

export type AddressWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AdministrativeArea = {
  __typename?: 'AdministrativeArea';
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AdministrativeAreaCreateInput = {
  country?: Maybe<CountryRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AdministrativeAreaManyRelationFilter = {
  every?: Maybe<AdministrativeAreaWhereInput>;
  none?: Maybe<AdministrativeAreaWhereInput>;
  some?: Maybe<AdministrativeAreaWhereInput>;
};

export type AdministrativeAreaOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  value?: Maybe<OrderDirection>;
};

export type AdministrativeAreaRelateToManyForCreateInput = {
  connect?: Maybe<Array<AdministrativeAreaWhereUniqueInput>>;
  create?: Maybe<Array<AdministrativeAreaCreateInput>>;
};

export type AdministrativeAreaRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AdministrativeAreaWhereUniqueInput>>;
  create?: Maybe<Array<AdministrativeAreaCreateInput>>;
  disconnect?: Maybe<Array<AdministrativeAreaWhereUniqueInput>>;
  set?: Maybe<Array<AdministrativeAreaWhereUniqueInput>>;
};

export type AdministrativeAreaUpdateArgs = {
  data: AdministrativeAreaUpdateInput;
  where: AdministrativeAreaWhereUniqueInput;
};

export type AdministrativeAreaUpdateInput = {
  country?: Maybe<CountryRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AdministrativeAreaWhereInput = {
  AND?: Maybe<Array<AdministrativeAreaWhereInput>>;
  NOT?: Maybe<Array<AdministrativeAreaWhereInput>>;
  OR?: Maybe<Array<AdministrativeAreaWhereInput>>;
  country?: Maybe<CountryWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  isActive?: Maybe<BooleanFilter>;
  label?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type AdministrativeAreaWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AllergyItem = {
  __typename?: 'AllergyItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  onsetDate?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<Patient>;
  reaction?: Maybe<Scalars['String']>;
};

export type AllergyItemCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  onsetDate?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  reaction?: Maybe<Scalars['String']>;
};

export type AllergyItemManyRelationFilter = {
  every?: Maybe<AllergyItemWhereInput>;
  none?: Maybe<AllergyItemWhereInput>;
  some?: Maybe<AllergyItemWhereInput>;
};

export type AllergyItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  onsetDate?: Maybe<OrderDirection>;
  reaction?: Maybe<OrderDirection>;
};

export type AllergyItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<AllergyItemWhereUniqueInput>>;
  create?: Maybe<Array<AllergyItemCreateInput>>;
};

export type AllergyItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AllergyItemWhereUniqueInput>>;
  create?: Maybe<Array<AllergyItemCreateInput>>;
  disconnect?: Maybe<Array<AllergyItemWhereUniqueInput>>;
  set?: Maybe<Array<AllergyItemWhereUniqueInput>>;
};

export type AllergyItemUpdateArgs = {
  data: AllergyItemUpdateInput;
  where: AllergyItemWhereUniqueInput;
};

export type AllergyItemUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  onsetDate?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  reaction?: Maybe<Scalars['String']>;
};

export type AllergyItemWhereInput = {
  AND?: Maybe<Array<AllergyItemWhereInput>>;
  NOT?: Maybe<Array<AllergyItemWhereInput>>;
  OR?: Maybe<Array<AllergyItemWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  name?: Maybe<StringFilter>;
  onsetDate?: Maybe<DateTimeNullableFilter>;
  patient?: Maybe<PatientWhereInput>;
  reaction?: Maybe<StringFilter>;
};

export type AllergyItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Appointment = {
  __typename?: 'Appointment';
  billing?: Maybe<AppointmentBilling>;
  booking?: Maybe<Booking>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chat?: Maybe<Chat>;
  clinic?: Maybe<Clinic>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  draft?: Maybe<AppointmentDraft>;
  endedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEvent>;
  faxes?: Maybe<Array<Fax>>;
  faxesCount?: Maybe<Scalars['Int']>;
  forms?: Maybe<Array<Form>>;
  formsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isInvalidHealthCard?: Maybe<Scalars['Boolean']>;
  isMissed?: Maybe<Scalars['Boolean']>;
  isSigned?: Maybe<Scalars['Boolean']>;
  lastDoctorActivity?: Maybe<Scalars['DateTime']>;
  lastPatientActivity?: Maybe<Scalars['DateTime']>;
  medicationItems?: Maybe<Array<MedicationItem>>;
  medicationItemsCount?: Maybe<Scalars['Int']>;
  member?: Maybe<Member>;
  note?: Maybe<Scalars['String']>;
  noteMdx?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<AppointmentNote>>;
  notesCount?: Maybe<Scalars['Int']>;
  patient?: Maybe<Patient>;
  prescription?: Maybe<Prescription>;
  reason?: Maybe<Scalars['String']>;
  rescheduledAt?: Maybe<Scalars['DateTime']>;
  scheduledEndsAt?: Maybe<Scalars['DateTime']>;
  scheduledStartsAt?: Maybe<Scalars['DateTime']>;
  sessions?: Maybe<Array<AppointmentSession>>;
  sessionsCount?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Appointment_Summary_Document>;
  summaryString?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<Task>>;
  tasksCount?: Maybe<Scalars['Int']>;
  testOrders?: Maybe<Array<TestOrder>>;
  testOrdersCount?: Maybe<Scalars['Int']>;
  vitalsData?: Maybe<AppointmentVital>;
};


export type AppointmentFaxesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type AppointmentFaxesCountArgs = {
  where?: FaxWhereInput;
};


export type AppointmentFormsArgs = {
  cursor?: Maybe<FormWhereUniqueInput>;
  orderBy?: Array<FormOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormWhereInput;
};


export type AppointmentFormsCountArgs = {
  where?: FormWhereInput;
};


export type AppointmentMedicationItemsArgs = {
  cursor?: Maybe<MedicationItemWhereUniqueInput>;
  orderBy?: Array<MedicationItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MedicationItemWhereInput;
};


export type AppointmentMedicationItemsCountArgs = {
  where?: MedicationItemWhereInput;
};


export type AppointmentNotesArgs = {
  cursor?: Maybe<AppointmentNoteWhereUniqueInput>;
  orderBy?: Array<AppointmentNoteOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentNoteWhereInput;
};


export type AppointmentNotesCountArgs = {
  where?: AppointmentNoteWhereInput;
};


export type AppointmentSessionsArgs = {
  cursor?: Maybe<AppointmentSessionWhereUniqueInput>;
  orderBy?: Array<AppointmentSessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentSessionWhereInput;
};


export type AppointmentSessionsCountArgs = {
  where?: AppointmentSessionWhereInput;
};


export type AppointmentTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  orderBy?: Array<TaskOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TaskWhereInput;
};


export type AppointmentTasksCountArgs = {
  where?: TaskWhereInput;
};


export type AppointmentTestOrdersArgs = {
  cursor?: Maybe<TestOrderWhereUniqueInput>;
  orderBy?: Array<TestOrderOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TestOrderWhereInput;
};


export type AppointmentTestOrdersCountArgs = {
  where?: TestOrderWhereInput;
};

export type AppointmentBilling = {
  __typename?: 'AppointmentBilling';
  accountingNumber?: Maybe<Scalars['String']>;
  appointment?: Maybe<Appointment>;
  billingClinic?: Maybe<Clinic>;
  billingItems?: Maybe<Array<AppointmentBillingItem>>;
  billingItemsCount?: Maybe<Scalars['Int']>;
  clinic?: Maybe<Clinic>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  exception?: Maybe<AppointmentBillingException>;
  id: Scalars['ID'];
  isManualReviewRequired?: Maybe<Scalars['Boolean']>;
  referringDoctorNumber?: Maybe<Scalars['String']>;
  remittanceAdvice?: Maybe<RemittanceAdvice>;
  status?: Maybe<AppointmentBillingStatusType>;
  submission?: Maybe<BillingSubmission>;
};


export type AppointmentBillingBillingItemsArgs = {
  cursor?: Maybe<AppointmentBillingItemWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingItemWhereInput;
};


export type AppointmentBillingBillingItemsCountArgs = {
  where?: AppointmentBillingItemWhereInput;
};

export type AppointmentBillingCreateInput = {
  accountingNumber?: Maybe<Scalars['String']>;
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  billingClinic?: Maybe<ClinicRelateToOneForCreateInput>;
  billingItems?: Maybe<AppointmentBillingItemRelateToManyForCreateInput>;
  clinic?: Maybe<ClinicRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  exception?: Maybe<AppointmentBillingExceptionRelateToOneForCreateInput>;
  isManualReviewRequired?: Maybe<Scalars['Boolean']>;
  referringDoctorNumber?: Maybe<Scalars['String']>;
  remittanceAdvice?: Maybe<RemittanceAdviceRelateToOneForCreateInput>;
  status?: Maybe<AppointmentBillingStatusType>;
  submission?: Maybe<BillingSubmissionRelateToOneForCreateInput>;
};

export type AppointmentBillingException = {
  __typename?: 'AppointmentBillingException';
  author?: Maybe<User>;
  billing?: Maybe<AppointmentBilling>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
};

export type AppointmentBillingExceptionCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  billing?: Maybe<AppointmentBillingRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentBillingExceptionOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type AppointmentBillingExceptionRelateToOneForCreateInput = {
  connect?: Maybe<AppointmentBillingExceptionWhereUniqueInput>;
  create?: Maybe<AppointmentBillingExceptionCreateInput>;
};

export type AppointmentBillingExceptionRelateToOneForUpdateInput = {
  connect?: Maybe<AppointmentBillingExceptionWhereUniqueInput>;
  create?: Maybe<AppointmentBillingExceptionCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type AppointmentBillingExceptionUpdateArgs = {
  data: AppointmentBillingExceptionUpdateInput;
  where: AppointmentBillingExceptionWhereUniqueInput;
};

export type AppointmentBillingExceptionUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  billing?: Maybe<AppointmentBillingRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentBillingExceptionWhereInput = {
  AND?: Maybe<Array<AppointmentBillingExceptionWhereInput>>;
  NOT?: Maybe<Array<AppointmentBillingExceptionWhereInput>>;
  OR?: Maybe<Array<AppointmentBillingExceptionWhereInput>>;
  author?: Maybe<UserWhereInput>;
  billing?: Maybe<AppointmentBillingWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
};

export type AppointmentBillingExceptionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentBillingItem = {
  __typename?: 'AppointmentBillingItem';
  billing?: Maybe<AppointmentBilling>;
  claim?: Maybe<BillingClaim>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<BillingDiagnosis>;
  id: Scalars['ID'];
  premium?: Maybe<BillingPremium>;
  units?: Maybe<Scalars['Int']>;
};

export type AppointmentBillingItemCreateInput = {
  billing?: Maybe<AppointmentBillingRelateToOneForCreateInput>;
  claim?: Maybe<BillingClaimRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<BillingDiagnosisRelateToOneForCreateInput>;
  premium?: Maybe<BillingPremiumRelateToOneForCreateInput>;
  units?: Maybe<Scalars['Int']>;
};

export type AppointmentBillingItemManyRelationFilter = {
  every?: Maybe<AppointmentBillingItemWhereInput>;
  none?: Maybe<AppointmentBillingItemWhereInput>;
  some?: Maybe<AppointmentBillingItemWhereInput>;
};

export type AppointmentBillingItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  units?: Maybe<OrderDirection>;
};

export type AppointmentBillingItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<AppointmentBillingItemWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentBillingItemCreateInput>>;
};

export type AppointmentBillingItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AppointmentBillingItemWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentBillingItemCreateInput>>;
  disconnect?: Maybe<Array<AppointmentBillingItemWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentBillingItemWhereUniqueInput>>;
};

export type AppointmentBillingItemUpdateArgs = {
  data: AppointmentBillingItemUpdateInput;
  where: AppointmentBillingItemWhereUniqueInput;
};

export type AppointmentBillingItemUpdateInput = {
  billing?: Maybe<AppointmentBillingRelateToOneForUpdateInput>;
  claim?: Maybe<BillingClaimRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<BillingDiagnosisRelateToOneForUpdateInput>;
  premium?: Maybe<BillingPremiumRelateToOneForUpdateInput>;
  units?: Maybe<Scalars['Int']>;
};

export type AppointmentBillingItemWhereInput = {
  AND?: Maybe<Array<AppointmentBillingItemWhereInput>>;
  NOT?: Maybe<Array<AppointmentBillingItemWhereInput>>;
  OR?: Maybe<Array<AppointmentBillingItemWhereInput>>;
  billing?: Maybe<AppointmentBillingWhereInput>;
  claim?: Maybe<BillingClaimWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  diagnosis?: Maybe<BillingDiagnosisWhereInput>;
  id?: Maybe<IdFilter>;
  premium?: Maybe<BillingPremiumWhereInput>;
  units?: Maybe<IntNullableFilter>;
};

export type AppointmentBillingItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentBillingManyRelationFilter = {
  every?: Maybe<AppointmentBillingWhereInput>;
  none?: Maybe<AppointmentBillingWhereInput>;
  some?: Maybe<AppointmentBillingWhereInput>;
};

export type AppointmentBillingOrderByInput = {
  accountingNumber?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isManualReviewRequired?: Maybe<OrderDirection>;
  referringDoctorNumber?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
};

export type AppointmentBillingRelateToManyForCreateInput = {
  connect?: Maybe<Array<AppointmentBillingWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentBillingCreateInput>>;
};

export type AppointmentBillingRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AppointmentBillingWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentBillingCreateInput>>;
  disconnect?: Maybe<Array<AppointmentBillingWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentBillingWhereUniqueInput>>;
};

export type AppointmentBillingRelateToOneForCreateInput = {
  connect?: Maybe<AppointmentBillingWhereUniqueInput>;
  create?: Maybe<AppointmentBillingCreateInput>;
};

export type AppointmentBillingRelateToOneForUpdateInput = {
  connect?: Maybe<AppointmentBillingWhereUniqueInput>;
  create?: Maybe<AppointmentBillingCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export enum AppointmentBillingStatusType {
  MarkedAsPaid = 'MARKED_AS_PAID',
  MarkedAsWriteOff = 'MARKED_AS_WRITE_OFF',
  Open = 'OPEN',
  Paid = 'PAID',
  PartlyPaid = 'PARTLY_PAID',
  Processing = 'PROCESSING',
  ProcessingError = 'PROCESSING_ERROR',
  ProcessingFailed = 'PROCESSING_FAILED',
  ProcessingFailedResubmission = 'PROCESSING_FAILED_RESUBMISSION',
  ProcessingFailedSubmission = 'PROCESSING_FAILED_SUBMISSION',
  ProcessingPayment = 'PROCESSING_PAYMENT',
  ProcessingPaymentFailed = 'PROCESSING_PAYMENT_FAILED',
  ProcessingPaymentSuccess = 'PROCESSING_PAYMENT_SUCCESS',
  ProcessingResubmitted = 'PROCESSING_RESUBMITTED',
  ProcessingStarted = 'PROCESSING_STARTED',
  ProcessingSubmitted = 'PROCESSING_SUBMITTED',
  Rejected = 'REJECTED',
  Resubmitted = 'RESUBMITTED',
  Submitted = 'SUBMITTED'
}

export type AppointmentBillingStatusTypeNullableFilter = {
  equals?: Maybe<AppointmentBillingStatusType>;
  in?: Maybe<Array<AppointmentBillingStatusType>>;
  not?: Maybe<AppointmentBillingStatusTypeNullableFilter>;
  notIn?: Maybe<Array<AppointmentBillingStatusType>>;
};

export type AppointmentBillingUpdateArgs = {
  data: AppointmentBillingUpdateInput;
  where: AppointmentBillingWhereUniqueInput;
};

export type AppointmentBillingUpdateInput = {
  accountingNumber?: Maybe<Scalars['String']>;
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  billingClinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  billingItems?: Maybe<AppointmentBillingItemRelateToManyForUpdateInput>;
  clinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  exception?: Maybe<AppointmentBillingExceptionRelateToOneForUpdateInput>;
  isManualReviewRequired?: Maybe<Scalars['Boolean']>;
  referringDoctorNumber?: Maybe<Scalars['String']>;
  remittanceAdvice?: Maybe<RemittanceAdviceRelateToOneForUpdateInput>;
  status?: Maybe<AppointmentBillingStatusType>;
  submission?: Maybe<BillingSubmissionRelateToOneForUpdateInput>;
};

export type AppointmentBillingWhereInput = {
  AND?: Maybe<Array<AppointmentBillingWhereInput>>;
  NOT?: Maybe<Array<AppointmentBillingWhereInput>>;
  OR?: Maybe<Array<AppointmentBillingWhereInput>>;
  accountingNumber?: Maybe<StringFilter>;
  appointment?: Maybe<AppointmentWhereInput>;
  billingClinic?: Maybe<ClinicWhereInput>;
  billingItems?: Maybe<AppointmentBillingItemManyRelationFilter>;
  clinic?: Maybe<ClinicWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  exception?: Maybe<AppointmentBillingExceptionWhereInput>;
  id?: Maybe<IdFilter>;
  isManualReviewRequired?: Maybe<BooleanFilter>;
  referringDoctorNumber?: Maybe<StringFilter>;
  remittanceAdvice?: Maybe<RemittanceAdviceWhereInput>;
  status?: Maybe<AppointmentBillingStatusTypeNullableFilter>;
  submission?: Maybe<BillingSubmissionWhereInput>;
};

export type AppointmentBillingWhereUniqueInput = {
  accountingNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentCreateInput = {
  billing?: Maybe<AppointmentBillingRelateToOneForCreateInput>;
  booking?: Maybe<BookingRelateToOneForCreateInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chat?: Maybe<ChatRelateToOneForCreateInput>;
  clinic?: Maybe<ClinicRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  draft?: Maybe<AppointmentDraftRelateToOneForCreateInput>;
  endedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEventRelateToOneForCreateInput>;
  faxes?: Maybe<FaxRelateToManyForCreateInput>;
  forms?: Maybe<FormRelateToManyForCreateInput>;
  isInvalidHealthCard?: Maybe<Scalars['Boolean']>;
  isMissed?: Maybe<Scalars['Boolean']>;
  isSigned?: Maybe<Scalars['Boolean']>;
  lastDoctorActivity?: Maybe<Scalars['DateTime']>;
  lastPatientActivity?: Maybe<Scalars['DateTime']>;
  medicationItems?: Maybe<MedicationItemRelateToManyForCreateInput>;
  member?: Maybe<MemberRelateToOneForCreateInput>;
  note?: Maybe<Scalars['String']>;
  noteMdx?: Maybe<Scalars['String']>;
  notes?: Maybe<AppointmentNoteRelateToManyForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  prescription?: Maybe<PrescriptionRelateToOneForCreateInput>;
  reason?: Maybe<Scalars['String']>;
  rescheduledAt?: Maybe<Scalars['DateTime']>;
  scheduledEndsAt?: Maybe<Scalars['DateTime']>;
  scheduledStartsAt?: Maybe<Scalars['DateTime']>;
  sessions?: Maybe<AppointmentSessionRelateToManyForCreateInput>;
  signedAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['JSON']>;
  summaryString?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskRelateToManyForCreateInput>;
  testOrders?: Maybe<TestOrderRelateToManyForCreateInput>;
  vitalsData?: Maybe<AppointmentVitalRelateToOneForCreateInput>;
};

export type AppointmentDraft = {
  __typename?: 'AppointmentDraft';
  appointment?: Maybe<Appointment>;
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lastEditedAt?: Maybe<Scalars['DateTime']>;
  savedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentDraftCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  author?: Maybe<UserRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  lastEditedAt?: Maybe<Scalars['DateTime']>;
  savedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentDraftOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  lastEditedAt?: Maybe<OrderDirection>;
  savedAt?: Maybe<OrderDirection>;
};

export type AppointmentDraftRelateToOneForCreateInput = {
  connect?: Maybe<AppointmentDraftWhereUniqueInput>;
  create?: Maybe<AppointmentDraftCreateInput>;
};

export type AppointmentDraftRelateToOneForUpdateInput = {
  connect?: Maybe<AppointmentDraftWhereUniqueInput>;
  create?: Maybe<AppointmentDraftCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type AppointmentDraftUpdateArgs = {
  data: AppointmentDraftUpdateInput;
  where: AppointmentDraftWhereUniqueInput;
};

export type AppointmentDraftUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  author?: Maybe<UserRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  lastEditedAt?: Maybe<Scalars['DateTime']>;
  savedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentDraftWhereInput = {
  AND?: Maybe<Array<AppointmentDraftWhereInput>>;
  NOT?: Maybe<Array<AppointmentDraftWhereInput>>;
  OR?: Maybe<Array<AppointmentDraftWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  author?: Maybe<UserWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  lastEditedAt?: Maybe<DateTimeNullableFilter>;
  savedAt?: Maybe<DateTimeNullableFilter>;
};

export type AppointmentDraftWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentManyRelationFilter = {
  every?: Maybe<AppointmentWhereInput>;
  none?: Maybe<AppointmentWhereInput>;
  some?: Maybe<AppointmentWhereInput>;
};

export type AppointmentNote = {
  __typename?: 'AppointmentNote';
  appointment?: Maybe<Appointment>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  patient?: Maybe<Patient>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AppointmentNoteCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AppointmentNoteManyRelationFilter = {
  every?: Maybe<AppointmentNoteWhereInput>;
  none?: Maybe<AppointmentNoteWhereInput>;
  some?: Maybe<AppointmentNoteWhereInput>;
};

export type AppointmentNoteOrderByInput = {
  content?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  summary?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
};

export type AppointmentNoteRelateToManyForCreateInput = {
  connect?: Maybe<Array<AppointmentNoteWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentNoteCreateInput>>;
};

export type AppointmentNoteRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AppointmentNoteWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentNoteCreateInput>>;
  disconnect?: Maybe<Array<AppointmentNoteWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentNoteWhereUniqueInput>>;
};

export type AppointmentNoteUpdateArgs = {
  data: AppointmentNoteUpdateInput;
  where: AppointmentNoteWhereUniqueInput;
};

export type AppointmentNoteUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AppointmentNoteWhereInput = {
  AND?: Maybe<Array<AppointmentNoteWhereInput>>;
  NOT?: Maybe<Array<AppointmentNoteWhereInput>>;
  OR?: Maybe<Array<AppointmentNoteWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  content?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  patient?: Maybe<PatientWhereInput>;
  summary?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
};

export type AppointmentNoteWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentOrderByInput = {
  cancelledAt?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  endedAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isInvalidHealthCard?: Maybe<OrderDirection>;
  isMissed?: Maybe<OrderDirection>;
  isSigned?: Maybe<OrderDirection>;
  lastDoctorActivity?: Maybe<OrderDirection>;
  lastPatientActivity?: Maybe<OrderDirection>;
  note?: Maybe<OrderDirection>;
  noteMdx?: Maybe<OrderDirection>;
  reason?: Maybe<OrderDirection>;
  rescheduledAt?: Maybe<OrderDirection>;
  scheduledEndsAt?: Maybe<OrderDirection>;
  scheduledStartsAt?: Maybe<OrderDirection>;
  signedAt?: Maybe<OrderDirection>;
  startedAt?: Maybe<OrderDirection>;
  summaryString?: Maybe<OrderDirection>;
};

export type AppointmentRelateToManyForCreateInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentCreateInput>>;
};

export type AppointmentRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentCreateInput>>;
  disconnect?: Maybe<Array<AppointmentWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentWhereUniqueInput>>;
};

export type AppointmentRelateToOneForCreateInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  create?: Maybe<AppointmentCreateInput>;
};

export type AppointmentRelateToOneForUpdateInput = {
  connect?: Maybe<AppointmentWhereUniqueInput>;
  create?: Maybe<AppointmentCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type AppointmentRequest = {
  __typename?: 'AppointmentRequest';
  clinic?: Maybe<Clinic>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  event?: Maybe<CalendarEvent>;
  followUpTo?: Maybe<Appointment>;
  id: Scalars['ID'];
  member?: Maybe<Member>;
  patient?: Maybe<Patient>;
  reason?: Maybe<Scalars['String']>;
};

export type AppointmentRequestCreateInput = {
  clinic?: Maybe<ClinicRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  event?: Maybe<CalendarEventRelateToOneForCreateInput>;
  followUpTo?: Maybe<AppointmentRelateToOneForCreateInput>;
  member?: Maybe<MemberRelateToOneForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  reason?: Maybe<Scalars['String']>;
};

export type AppointmentRequestManyRelationFilter = {
  every?: Maybe<AppointmentRequestWhereInput>;
  none?: Maybe<AppointmentRequestWhereInput>;
  some?: Maybe<AppointmentRequestWhereInput>;
};

export type AppointmentRequestOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  reason?: Maybe<OrderDirection>;
};

export type AppointmentRequestRelateToManyForCreateInput = {
  connect?: Maybe<Array<AppointmentRequestWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentRequestCreateInput>>;
};

export type AppointmentRequestRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AppointmentRequestWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentRequestCreateInput>>;
  disconnect?: Maybe<Array<AppointmentRequestWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentRequestWhereUniqueInput>>;
};

export type AppointmentRequestRelateToOneForCreateInput = {
  connect?: Maybe<AppointmentRequestWhereUniqueInput>;
  create?: Maybe<AppointmentRequestCreateInput>;
};

export type AppointmentRequestRelateToOneForUpdateInput = {
  connect?: Maybe<AppointmentRequestWhereUniqueInput>;
  create?: Maybe<AppointmentRequestCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type AppointmentRequestUpdateArgs = {
  data: AppointmentRequestUpdateInput;
  where: AppointmentRequestWhereUniqueInput;
};

export type AppointmentRequestUpdateInput = {
  clinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  event?: Maybe<CalendarEventRelateToOneForUpdateInput>;
  followUpTo?: Maybe<AppointmentRelateToOneForUpdateInput>;
  member?: Maybe<MemberRelateToOneForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  reason?: Maybe<Scalars['String']>;
};

export type AppointmentRequestWhereInput = {
  AND?: Maybe<Array<AppointmentRequestWhereInput>>;
  NOT?: Maybe<Array<AppointmentRequestWhereInput>>;
  OR?: Maybe<Array<AppointmentRequestWhereInput>>;
  clinic?: Maybe<ClinicWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  event?: Maybe<CalendarEventWhereInput>;
  followUpTo?: Maybe<AppointmentWhereInput>;
  id?: Maybe<IdFilter>;
  member?: Maybe<MemberWhereInput>;
  patient?: Maybe<PatientWhereInput>;
  reason?: Maybe<StringFilter>;
};

export type AppointmentRequestWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentSession = {
  __typename?: 'AppointmentSession';
  appointment?: Maybe<Appointment>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  duration?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<SessionEvent>>;
  historyCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<Patient>;
  startedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
};


export type AppointmentSessionHistoryArgs = {
  cursor?: Maybe<SessionEventWhereUniqueInput>;
  orderBy?: Array<SessionEventOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: SessionEventWhereInput;
};


export type AppointmentSessionHistoryCountArgs = {
  where?: SessionEventWhereInput;
};

export type AppointmentSessionCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  duration?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<SessionEventRelateToManyForCreateInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
};

export type AppointmentSessionManyRelationFilter = {
  every?: Maybe<AppointmentSessionWhereInput>;
  none?: Maybe<AppointmentSessionWhereInput>;
  some?: Maybe<AppointmentSessionWhereInput>;
};

export type AppointmentSessionOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  duration?: Maybe<OrderDirection>;
  endedAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  startedAt?: Maybe<OrderDirection>;
  subscriptionId?: Maybe<OrderDirection>;
};

export type AppointmentSessionRelateToManyForCreateInput = {
  connect?: Maybe<Array<AppointmentSessionWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentSessionCreateInput>>;
};

export type AppointmentSessionRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AppointmentSessionWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentSessionCreateInput>>;
  disconnect?: Maybe<Array<AppointmentSessionWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentSessionWhereUniqueInput>>;
};

export type AppointmentSessionRelateToOneForCreateInput = {
  connect?: Maybe<AppointmentSessionWhereUniqueInput>;
  create?: Maybe<AppointmentSessionCreateInput>;
};

export type AppointmentSessionRelateToOneForUpdateInput = {
  connect?: Maybe<AppointmentSessionWhereUniqueInput>;
  create?: Maybe<AppointmentSessionCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type AppointmentSessionUpdateArgs = {
  data: AppointmentSessionUpdateInput;
  where: AppointmentSessionWhereUniqueInput;
};

export type AppointmentSessionUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  duration?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<SessionEventRelateToManyForUpdateInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['String']>;
};

export type AppointmentSessionWhereInput = {
  AND?: Maybe<Array<AppointmentSessionWhereInput>>;
  NOT?: Maybe<Array<AppointmentSessionWhereInput>>;
  OR?: Maybe<Array<AppointmentSessionWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  duration?: Maybe<IntNullableFilter>;
  endedAt?: Maybe<DateTimeNullableFilter>;
  history?: Maybe<SessionEventManyRelationFilter>;
  id?: Maybe<IdFilter>;
  isActive?: Maybe<BooleanFilter>;
  patient?: Maybe<PatientWhereInput>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  subscriptionId?: Maybe<StringFilter>;
};

export type AppointmentSessionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentUpdateArgs = {
  data: AppointmentUpdateInput;
  where: AppointmentWhereUniqueInput;
};

export type AppointmentUpdateInput = {
  billing?: Maybe<AppointmentBillingRelateToOneForUpdateInput>;
  booking?: Maybe<BookingRelateToOneForUpdateInput>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  chat?: Maybe<ChatRelateToOneForUpdateInput>;
  clinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  draft?: Maybe<AppointmentDraftRelateToOneForUpdateInput>;
  endedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEventRelateToOneForUpdateInput>;
  faxes?: Maybe<FaxRelateToManyForUpdateInput>;
  forms?: Maybe<FormRelateToManyForUpdateInput>;
  isInvalidHealthCard?: Maybe<Scalars['Boolean']>;
  isMissed?: Maybe<Scalars['Boolean']>;
  isSigned?: Maybe<Scalars['Boolean']>;
  lastDoctorActivity?: Maybe<Scalars['DateTime']>;
  lastPatientActivity?: Maybe<Scalars['DateTime']>;
  medicationItems?: Maybe<MedicationItemRelateToManyForUpdateInput>;
  member?: Maybe<MemberRelateToOneForUpdateInput>;
  note?: Maybe<Scalars['String']>;
  noteMdx?: Maybe<Scalars['String']>;
  notes?: Maybe<AppointmentNoteRelateToManyForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  prescription?: Maybe<PrescriptionRelateToOneForUpdateInput>;
  reason?: Maybe<Scalars['String']>;
  rescheduledAt?: Maybe<Scalars['DateTime']>;
  scheduledEndsAt?: Maybe<Scalars['DateTime']>;
  scheduledStartsAt?: Maybe<Scalars['DateTime']>;
  sessions?: Maybe<AppointmentSessionRelateToManyForUpdateInput>;
  signedAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['JSON']>;
  summaryString?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskRelateToManyForUpdateInput>;
  testOrders?: Maybe<TestOrderRelateToManyForUpdateInput>;
  vitalsData?: Maybe<AppointmentVitalRelateToOneForUpdateInput>;
};

export type AppointmentVital = {
  __typename?: 'AppointmentVital';
  appointment?: Maybe<Appointment>;
  bloodPressure?: Maybe<Scalars['String']>;
  cm?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  headCm?: Maybe<Scalars['Int']>;
  heartRate?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  kg?: Maybe<Scalars['Float']>;
  meters?: Maybe<Scalars['Int']>;
  oxygenSaturation?: Maybe<Scalars['Int']>;
  patient?: Maybe<Patient>;
  resp?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
};

export type AppointmentVitalCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  bloodPressure?: Maybe<Scalars['String']>;
  cm?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  headCm?: Maybe<Scalars['Int']>;
  heartRate?: Maybe<Scalars['Int']>;
  kg?: Maybe<Scalars['Float']>;
  meters?: Maybe<Scalars['Int']>;
  oxygenSaturation?: Maybe<Scalars['Int']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  resp?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
};

export type AppointmentVitalManyRelationFilter = {
  every?: Maybe<AppointmentVitalWhereInput>;
  none?: Maybe<AppointmentVitalWhereInput>;
  some?: Maybe<AppointmentVitalWhereInput>;
};

export type AppointmentVitalOrderByInput = {
  bloodPressure?: Maybe<OrderDirection>;
  cm?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  headCm?: Maybe<OrderDirection>;
  heartRate?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  kg?: Maybe<OrderDirection>;
  meters?: Maybe<OrderDirection>;
  oxygenSaturation?: Maybe<OrderDirection>;
  resp?: Maybe<OrderDirection>;
  temperature?: Maybe<OrderDirection>;
};

export type AppointmentVitalRelateToManyForCreateInput = {
  connect?: Maybe<Array<AppointmentVitalWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentVitalCreateInput>>;
};

export type AppointmentVitalRelateToManyForUpdateInput = {
  connect?: Maybe<Array<AppointmentVitalWhereUniqueInput>>;
  create?: Maybe<Array<AppointmentVitalCreateInput>>;
  disconnect?: Maybe<Array<AppointmentVitalWhereUniqueInput>>;
  set?: Maybe<Array<AppointmentVitalWhereUniqueInput>>;
};

export type AppointmentVitalRelateToOneForCreateInput = {
  connect?: Maybe<AppointmentVitalWhereUniqueInput>;
  create?: Maybe<AppointmentVitalCreateInput>;
};

export type AppointmentVitalRelateToOneForUpdateInput = {
  connect?: Maybe<AppointmentVitalWhereUniqueInput>;
  create?: Maybe<AppointmentVitalCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type AppointmentVitalUpdateArgs = {
  data: AppointmentVitalUpdateInput;
  where: AppointmentVitalWhereUniqueInput;
};

export type AppointmentVitalUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  bloodPressure?: Maybe<Scalars['String']>;
  cm?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  headCm?: Maybe<Scalars['Int']>;
  heartRate?: Maybe<Scalars['Int']>;
  kg?: Maybe<Scalars['Float']>;
  meters?: Maybe<Scalars['Int']>;
  oxygenSaturation?: Maybe<Scalars['Int']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  resp?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
};

export type AppointmentVitalWhereInput = {
  AND?: Maybe<Array<AppointmentVitalWhereInput>>;
  NOT?: Maybe<Array<AppointmentVitalWhereInput>>;
  OR?: Maybe<Array<AppointmentVitalWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  bloodPressure?: Maybe<StringFilter>;
  cm?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  headCm?: Maybe<IntNullableFilter>;
  heartRate?: Maybe<IntNullableFilter>;
  id?: Maybe<IdFilter>;
  kg?: Maybe<FloatNullableFilter>;
  meters?: Maybe<IntNullableFilter>;
  oxygenSaturation?: Maybe<IntNullableFilter>;
  patient?: Maybe<PatientWhereInput>;
  resp?: Maybe<IntNullableFilter>;
  temperature?: Maybe<FloatNullableFilter>;
};

export type AppointmentVitalWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AppointmentWhereInput = {
  AND?: Maybe<Array<AppointmentWhereInput>>;
  NOT?: Maybe<Array<AppointmentWhereInput>>;
  OR?: Maybe<Array<AppointmentWhereInput>>;
  billing?: Maybe<AppointmentBillingWhereInput>;
  booking?: Maybe<BookingWhereInput>;
  cancelledAt?: Maybe<DateTimeNullableFilter>;
  chat?: Maybe<ChatWhereInput>;
  clinic?: Maybe<ClinicWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  draft?: Maybe<AppointmentDraftWhereInput>;
  endedAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<CalendarEventWhereInput>;
  faxes?: Maybe<FaxManyRelationFilter>;
  forms?: Maybe<FormManyRelationFilter>;
  id?: Maybe<IdFilter>;
  isInvalidHealthCard?: Maybe<BooleanFilter>;
  isMissed?: Maybe<BooleanFilter>;
  isSigned?: Maybe<BooleanFilter>;
  lastDoctorActivity?: Maybe<DateTimeNullableFilter>;
  lastPatientActivity?: Maybe<DateTimeNullableFilter>;
  medicationItems?: Maybe<MedicationItemManyRelationFilter>;
  member?: Maybe<MemberWhereInput>;
  note?: Maybe<StringFilter>;
  noteMdx?: Maybe<StringFilter>;
  notes?: Maybe<AppointmentNoteManyRelationFilter>;
  patient?: Maybe<PatientWhereInput>;
  prescription?: Maybe<PrescriptionWhereInput>;
  reason?: Maybe<StringFilter>;
  rescheduledAt?: Maybe<DateTimeNullableFilter>;
  scheduledEndsAt?: Maybe<DateTimeNullableFilter>;
  scheduledStartsAt?: Maybe<DateTimeNullableFilter>;
  sessions?: Maybe<AppointmentSessionManyRelationFilter>;
  signedAt?: Maybe<DateTimeNullableFilter>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  summaryString?: Maybe<StringFilter>;
  tasks?: Maybe<TaskManyRelationFilter>;
  testOrders?: Maybe<TestOrderManyRelationFilter>;
  vitalsData?: Maybe<AppointmentVitalWhereInput>;
};

export type AppointmentWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Appointment_Summary_Document = {
  __typename?: 'Appointment_summary_Document';
  document: Scalars['JSON'];
};


export type Appointment_Summary_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type Archive = {
  __typename?: 'Archive';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  items?: Maybe<Array<ArchiveItem>>;
  itemsCount?: Maybe<Scalars['Int']>;
  misc?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
};


export type ArchiveItemsArgs = {
  cursor?: Maybe<ArchiveItemWhereUniqueInput>;
  orderBy?: Array<ArchiveItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ArchiveItemWhereInput;
};


export type ArchiveItemsCountArgs = {
  where?: ArchiveItemWhereInput;
};

export type ArchiveCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<ArchiveItemRelateToManyForCreateInput>;
  misc?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<UserRelateToOneForCreateInput>;
};

export type ArchiveItem = {
  __typename?: 'ArchiveItem';
  archive?: Maybe<Archive>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  file?: Maybe<File>;
  id: Scalars['ID'];
};

export type ArchiveItemCreateInput = {
  archive?: Maybe<ArchiveRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
};

export type ArchiveItemManyRelationFilter = {
  every?: Maybe<ArchiveItemWhereInput>;
  none?: Maybe<ArchiveItemWhereInput>;
  some?: Maybe<ArchiveItemWhereInput>;
};

export type ArchiveItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  deletedAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type ArchiveItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<ArchiveItemWhereUniqueInput>>;
  create?: Maybe<Array<ArchiveItemCreateInput>>;
};

export type ArchiveItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ArchiveItemWhereUniqueInput>>;
  create?: Maybe<Array<ArchiveItemCreateInput>>;
  disconnect?: Maybe<Array<ArchiveItemWhereUniqueInput>>;
  set?: Maybe<Array<ArchiveItemWhereUniqueInput>>;
};

export type ArchiveItemRelateToOneForCreateInput = {
  connect?: Maybe<ArchiveItemWhereUniqueInput>;
  create?: Maybe<ArchiveItemCreateInput>;
};

export type ArchiveItemRelateToOneForUpdateInput = {
  connect?: Maybe<ArchiveItemWhereUniqueInput>;
  create?: Maybe<ArchiveItemCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ArchiveItemUpdateArgs = {
  data: ArchiveItemUpdateInput;
  where: ArchiveItemWhereUniqueInput;
};

export type ArchiveItemUpdateInput = {
  archive?: Maybe<ArchiveRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<UserRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
};

export type ArchiveItemWhereInput = {
  AND?: Maybe<Array<ArchiveItemWhereInput>>;
  NOT?: Maybe<Array<ArchiveItemWhereInput>>;
  OR?: Maybe<Array<ArchiveItemWhereInput>>;
  archive?: Maybe<ArchiveWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  deletedBy?: Maybe<UserWhereInput>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
};

export type ArchiveItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type ArchiveManyRelationFilter = {
  every?: Maybe<ArchiveWhereInput>;
  none?: Maybe<ArchiveWhereInput>;
  some?: Maybe<ArchiveWhereInput>;
};

export type ArchiveOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
};

export type ArchiveRelateToManyForCreateInput = {
  connect?: Maybe<Array<ArchiveWhereUniqueInput>>;
  create?: Maybe<Array<ArchiveCreateInput>>;
};

export type ArchiveRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ArchiveWhereUniqueInput>>;
  create?: Maybe<Array<ArchiveCreateInput>>;
  disconnect?: Maybe<Array<ArchiveWhereUniqueInput>>;
  set?: Maybe<Array<ArchiveWhereUniqueInput>>;
};

export type ArchiveRelateToOneForCreateInput = {
  connect?: Maybe<ArchiveWhereUniqueInput>;
  create?: Maybe<ArchiveCreateInput>;
};

export type ArchiveRelateToOneForUpdateInput = {
  connect?: Maybe<ArchiveWhereUniqueInput>;
  create?: Maybe<ArchiveCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ArchiveUpdateArgs = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ArchiveUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<ArchiveItemRelateToManyForUpdateInput>;
  misc?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<UserRelateToOneForUpdateInput>;
};

export type ArchiveWhereInput = {
  AND?: Maybe<Array<ArchiveWhereInput>>;
  NOT?: Maybe<Array<ArchiveWhereInput>>;
  OR?: Maybe<Array<ArchiveWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  items?: Maybe<ArchiveItemManyRelationFilter>;
  name?: Maybe<StringFilter>;
  owner?: Maybe<UserWhereInput>;
};

export type ArchiveWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type AuthenticatedItem = User;

export type BillingClaim = {
  __typename?: 'BillingClaim';
  amount?: Maybe<Scalars['Int']>;
  appointmentBillingItems?: Maybe<Array<AppointmentBillingItem>>;
  appointmentBillingItemsCount?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  feeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type BillingClaimAppointmentBillingItemsArgs = {
  cursor?: Maybe<AppointmentBillingItemWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingItemWhereInput;
};


export type BillingClaimAppointmentBillingItemsCountArgs = {
  where?: AppointmentBillingItemWhereInput;
};

export type BillingClaimCreateInput = {
  amount?: Maybe<Scalars['Int']>;
  appointmentBillingItems?: Maybe<AppointmentBillingItemRelateToManyForCreateInput>;
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  feeCode?: Maybe<Scalars['String']>;
};

export type BillingClaimOrderByInput = {
  amount?: Maybe<OrderDirection>;
  category?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  feeCode?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type BillingClaimRelateToOneForCreateInput = {
  connect?: Maybe<BillingClaimWhereUniqueInput>;
  create?: Maybe<BillingClaimCreateInput>;
};

export type BillingClaimRelateToOneForUpdateInput = {
  connect?: Maybe<BillingClaimWhereUniqueInput>;
  create?: Maybe<BillingClaimCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type BillingClaimUpdateArgs = {
  data: BillingClaimUpdateInput;
  where: BillingClaimWhereUniqueInput;
};

export type BillingClaimUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
  appointmentBillingItems?: Maybe<AppointmentBillingItemRelateToManyForUpdateInput>;
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  feeCode?: Maybe<Scalars['String']>;
};

export type BillingClaimWhereInput = {
  AND?: Maybe<Array<BillingClaimWhereInput>>;
  NOT?: Maybe<Array<BillingClaimWhereInput>>;
  OR?: Maybe<Array<BillingClaimWhereInput>>;
  amount?: Maybe<IntNullableFilter>;
  appointmentBillingItems?: Maybe<AppointmentBillingItemManyRelationFilter>;
  category?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  feeCode?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
};

export type BillingClaimWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type BillingDiagnosis = {
  __typename?: 'BillingDiagnosis';
  appointmentBillingItems?: Maybe<Array<AppointmentBillingItem>>;
  appointmentBillingItemsCount?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type BillingDiagnosisAppointmentBillingItemsArgs = {
  cursor?: Maybe<AppointmentBillingItemWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingItemWhereInput;
};


export type BillingDiagnosisAppointmentBillingItemsCountArgs = {
  where?: AppointmentBillingItemWhereInput;
};

export type BillingDiagnosisCreateInput = {
  appointmentBillingItems?: Maybe<AppointmentBillingItemRelateToManyForCreateInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
};

export type BillingDiagnosisOrderByInput = {
  code?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type BillingDiagnosisRelateToOneForCreateInput = {
  connect?: Maybe<BillingDiagnosisWhereUniqueInput>;
  create?: Maybe<BillingDiagnosisCreateInput>;
};

export type BillingDiagnosisRelateToOneForUpdateInput = {
  connect?: Maybe<BillingDiagnosisWhereUniqueInput>;
  create?: Maybe<BillingDiagnosisCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type BillingDiagnosisUpdateArgs = {
  data: BillingDiagnosisUpdateInput;
  where: BillingDiagnosisWhereUniqueInput;
};

export type BillingDiagnosisUpdateInput = {
  appointmentBillingItems?: Maybe<AppointmentBillingItemRelateToManyForUpdateInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
};

export type BillingDiagnosisWhereInput = {
  AND?: Maybe<Array<BillingDiagnosisWhereInput>>;
  NOT?: Maybe<Array<BillingDiagnosisWhereInput>>;
  OR?: Maybe<Array<BillingDiagnosisWhereInput>>;
  appointmentBillingItems?: Maybe<AppointmentBillingItemManyRelationFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
};

export type BillingDiagnosisWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type BillingPremium = {
  __typename?: 'BillingPremium';
  amount?: Maybe<Scalars['String']>;
  appointmentBillingItems?: Maybe<Array<AppointmentBillingItem>>;
  appointmentBillingItemsCount?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  feeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type BillingPremiumAppointmentBillingItemsArgs = {
  cursor?: Maybe<AppointmentBillingItemWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingItemWhereInput;
};


export type BillingPremiumAppointmentBillingItemsCountArgs = {
  where?: AppointmentBillingItemWhereInput;
};

export type BillingPremiumCreateInput = {
  amount?: Maybe<Scalars['String']>;
  appointmentBillingItems?: Maybe<AppointmentBillingItemRelateToManyForCreateInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  feeCode?: Maybe<Scalars['String']>;
};

export type BillingPremiumOrderByInput = {
  amount?: Maybe<OrderDirection>;
  code?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  feeCode?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type BillingPremiumRelateToOneForCreateInput = {
  connect?: Maybe<BillingPremiumWhereUniqueInput>;
  create?: Maybe<BillingPremiumCreateInput>;
};

export type BillingPremiumRelateToOneForUpdateInput = {
  connect?: Maybe<BillingPremiumWhereUniqueInput>;
  create?: Maybe<BillingPremiumCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type BillingPremiumUpdateArgs = {
  data: BillingPremiumUpdateInput;
  where: BillingPremiumWhereUniqueInput;
};

export type BillingPremiumUpdateInput = {
  amount?: Maybe<Scalars['String']>;
  appointmentBillingItems?: Maybe<AppointmentBillingItemRelateToManyForUpdateInput>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  feeCode?: Maybe<Scalars['String']>;
};

export type BillingPremiumWhereInput = {
  AND?: Maybe<Array<BillingPremiumWhereInput>>;
  NOT?: Maybe<Array<BillingPremiumWhereInput>>;
  OR?: Maybe<Array<BillingPremiumWhereInput>>;
  amount?: Maybe<StringFilter>;
  appointmentBillingItems?: Maybe<AppointmentBillingItemManyRelationFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  feeCode?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
};

export type BillingPremiumWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type BillingSubmission = {
  __typename?: 'BillingSubmission';
  actor?: Maybe<BillingSubmissionActorType>;
  amountCharged?: Maybe<Scalars['Int']>;
  amountPaid?: Maybe<Scalars['Int']>;
  amountSubmitted?: Maybe<Scalars['Int']>;
  billing?: Maybe<AppointmentBilling>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  explanatoryItems?: Maybe<Scalars['JSON']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  paidBy?: Maybe<User>;
  providerNumber?: Maybe<Scalars['String']>;
  responseDump?: Maybe<Scalars['JSON']>;
  resultCode?: Maybe<Scalars['String']>;
  resultMessage?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<BillingSubmissionStatusType>;
  submittedBy?: Maybe<User>;
};

export enum BillingSubmissionActorType {
  Group = 'GROUP',
  Provider = 'PROVIDER'
}

export type BillingSubmissionActorTypeNullableFilter = {
  equals?: Maybe<BillingSubmissionActorType>;
  in?: Maybe<Array<BillingSubmissionActorType>>;
  not?: Maybe<BillingSubmissionActorTypeNullableFilter>;
  notIn?: Maybe<Array<BillingSubmissionActorType>>;
};

export type BillingSubmissionCreateInput = {
  actor?: Maybe<BillingSubmissionActorType>;
  amountCharged?: Maybe<Scalars['Int']>;
  amountPaid?: Maybe<Scalars['Int']>;
  amountSubmitted?: Maybe<Scalars['Int']>;
  billing?: Maybe<AppointmentBillingRelateToOneForCreateInput>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  explanatoryItems?: Maybe<Scalars['JSON']>;
  filename?: Maybe<Scalars['String']>;
  paidBy?: Maybe<UserRelateToOneForCreateInput>;
  providerNumber?: Maybe<Scalars['String']>;
  responseDump?: Maybe<Scalars['JSON']>;
  resultCode?: Maybe<Scalars['String']>;
  resultMessage?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<BillingSubmissionStatusType>;
  submittedBy?: Maybe<UserRelateToOneForCreateInput>;
};

export type BillingSubmissionManyRelationFilter = {
  every?: Maybe<BillingSubmissionWhereInput>;
  none?: Maybe<BillingSubmissionWhereInput>;
  some?: Maybe<BillingSubmissionWhereInput>;
};

export type BillingSubmissionOrderByInput = {
  actor?: Maybe<OrderDirection>;
  amountCharged?: Maybe<OrderDirection>;
  amountPaid?: Maybe<OrderDirection>;
  amountSubmitted?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  filename?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  providerNumber?: Maybe<OrderDirection>;
  resultCode?: Maybe<OrderDirection>;
  resultMessage?: Maybe<OrderDirection>;
  sequenceNumber?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
};

export type BillingSubmissionRelateToManyForCreateInput = {
  connect?: Maybe<Array<BillingSubmissionWhereUniqueInput>>;
  create?: Maybe<Array<BillingSubmissionCreateInput>>;
};

export type BillingSubmissionRelateToManyForUpdateInput = {
  connect?: Maybe<Array<BillingSubmissionWhereUniqueInput>>;
  create?: Maybe<Array<BillingSubmissionCreateInput>>;
  disconnect?: Maybe<Array<BillingSubmissionWhereUniqueInput>>;
  set?: Maybe<Array<BillingSubmissionWhereUniqueInput>>;
};

export type BillingSubmissionRelateToOneForCreateInput = {
  connect?: Maybe<BillingSubmissionWhereUniqueInput>;
  create?: Maybe<BillingSubmissionCreateInput>;
};

export type BillingSubmissionRelateToOneForUpdateInput = {
  connect?: Maybe<BillingSubmissionWhereUniqueInput>;
  create?: Maybe<BillingSubmissionCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export enum BillingSubmissionStatusType {
  MarkedAsPaid = 'MARKED_AS_PAID',
  MarkedAsWriteOff = 'MARKED_AS_WRITE_OFF',
  Open = 'OPEN',
  Paid = 'PAID',
  PartlyPaid = 'PARTLY_PAID',
  Processing = 'PROCESSING',
  ProcessingFailed = 'PROCESSING_FAILED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type BillingSubmissionStatusTypeNullableFilter = {
  equals?: Maybe<BillingSubmissionStatusType>;
  in?: Maybe<Array<BillingSubmissionStatusType>>;
  not?: Maybe<BillingSubmissionStatusTypeNullableFilter>;
  notIn?: Maybe<Array<BillingSubmissionStatusType>>;
};

export type BillingSubmissionUpdateArgs = {
  data: BillingSubmissionUpdateInput;
  where: BillingSubmissionWhereUniqueInput;
};

export type BillingSubmissionUpdateInput = {
  actor?: Maybe<BillingSubmissionActorType>;
  amountCharged?: Maybe<Scalars['Int']>;
  amountPaid?: Maybe<Scalars['Int']>;
  amountSubmitted?: Maybe<Scalars['Int']>;
  billing?: Maybe<AppointmentBillingRelateToOneForUpdateInput>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  explanatoryItems?: Maybe<Scalars['JSON']>;
  filename?: Maybe<Scalars['String']>;
  paidBy?: Maybe<UserRelateToOneForUpdateInput>;
  providerNumber?: Maybe<Scalars['String']>;
  responseDump?: Maybe<Scalars['JSON']>;
  resultCode?: Maybe<Scalars['String']>;
  resultMessage?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<BillingSubmissionStatusType>;
  submittedBy?: Maybe<UserRelateToOneForUpdateInput>;
};

export type BillingSubmissionWhereInput = {
  AND?: Maybe<Array<BillingSubmissionWhereInput>>;
  NOT?: Maybe<Array<BillingSubmissionWhereInput>>;
  OR?: Maybe<Array<BillingSubmissionWhereInput>>;
  actor?: Maybe<BillingSubmissionActorTypeNullableFilter>;
  amountCharged?: Maybe<IntNullableFilter>;
  amountPaid?: Maybe<IntNullableFilter>;
  amountSubmitted?: Maybe<IntNullableFilter>;
  billing?: Maybe<AppointmentBillingWhereInput>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  filename?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  paidBy?: Maybe<UserWhereInput>;
  providerNumber?: Maybe<StringFilter>;
  resultCode?: Maybe<StringFilter>;
  resultMessage?: Maybe<StringFilter>;
  sequenceNumber?: Maybe<IntFilter>;
  status?: Maybe<BillingSubmissionStatusTypeNullableFilter>;
  submittedBy?: Maybe<UserWhereInput>;
};

export type BillingSubmissionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type BirdSummaryIntent = {
  __typename?: 'BirdSummaryIntent';
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: Maybe<BirdSummaryIntentStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  summaryObjectKey?: Maybe<Scalars['String']>;
  uploadObjectKey?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type BirdSummaryIntentCreateInput = {
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<BirdSummaryIntentStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  summaryObjectKey?: Maybe<Scalars['String']>;
  uploadObjectKey?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type BirdSummaryIntentOrderByInput = {
  bucket?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  email?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
  statusMessage?: Maybe<OrderDirection>;
  summaryObjectKey?: Maybe<OrderDirection>;
  uploadObjectKey?: Maybe<OrderDirection>;
  userId?: Maybe<OrderDirection>;
};

export enum BirdSummaryIntentStatusType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING'
}

export type BirdSummaryIntentStatusTypeNullableFilter = {
  equals?: Maybe<BirdSummaryIntentStatusType>;
  in?: Maybe<Array<BirdSummaryIntentStatusType>>;
  not?: Maybe<BirdSummaryIntentStatusTypeNullableFilter>;
  notIn?: Maybe<Array<BirdSummaryIntentStatusType>>;
};

export type BirdSummaryIntentUpdateArgs = {
  data: BirdSummaryIntentUpdateInput;
  where: BirdSummaryIntentWhereUniqueInput;
};

export type BirdSummaryIntentUpdateInput = {
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  status?: Maybe<BirdSummaryIntentStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  summaryObjectKey?: Maybe<Scalars['String']>;
  uploadObjectKey?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type BirdSummaryIntentWhereInput = {
  AND?: Maybe<Array<BirdSummaryIntentWhereInput>>;
  NOT?: Maybe<Array<BirdSummaryIntentWhereInput>>;
  OR?: Maybe<Array<BirdSummaryIntentWhereInput>>;
  bucket?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  email?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  status?: Maybe<BirdSummaryIntentStatusTypeNullableFilter>;
  statusMessage?: Maybe<StringFilter>;
  summaryObjectKey?: Maybe<StringFilter>;
  uploadObjectKey?: Maybe<StringFilter>;
  userId?: Maybe<StringFilter>;
};

export type BirdSummaryIntentWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  summaryObjectKey?: Maybe<Scalars['String']>;
  uploadObjectKey?: Maybe<Scalars['String']>;
};

export type Booking = {
  __typename?: 'Booking';
  appointment?: Maybe<Appointment>;
  calendar?: Maybe<Calendar>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  durationMins?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEvent>;
  id: Scalars['ID'];
  isCancelled?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  startsAt?: Maybe<Scalars['DateTime']>;
  tzTarget?: Maybe<Scalars['String']>;
};

export type BookingCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  calendar?: Maybe<CalendarRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  durationMins?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEventRelateToOneForCreateInput>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  startsAt?: Maybe<Scalars['DateTime']>;
  tzTarget?: Maybe<Scalars['String']>;
};

export type BookingManyRelationFilter = {
  every?: Maybe<BookingWhereInput>;
  none?: Maybe<BookingWhereInput>;
  some?: Maybe<BookingWhereInput>;
};

export type BookingOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  durationMins?: Maybe<OrderDirection>;
  endsAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isCancelled?: Maybe<OrderDirection>;
  isConfirmed?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  startsAt?: Maybe<OrderDirection>;
  tzTarget?: Maybe<OrderDirection>;
};

export type BookingRelateToManyForCreateInput = {
  connect?: Maybe<Array<BookingWhereUniqueInput>>;
  create?: Maybe<Array<BookingCreateInput>>;
};

export type BookingRelateToManyForUpdateInput = {
  connect?: Maybe<Array<BookingWhereUniqueInput>>;
  create?: Maybe<Array<BookingCreateInput>>;
  disconnect?: Maybe<Array<BookingWhereUniqueInput>>;
  set?: Maybe<Array<BookingWhereUniqueInput>>;
};

export type BookingRelateToOneForCreateInput = {
  connect?: Maybe<BookingWhereUniqueInput>;
  create?: Maybe<BookingCreateInput>;
};

export type BookingRelateToOneForUpdateInput = {
  connect?: Maybe<BookingWhereUniqueInput>;
  create?: Maybe<BookingCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type BookingUpdateArgs = {
  data: BookingUpdateInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  calendar?: Maybe<CalendarRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  durationMins?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<CalendarEventRelateToOneForUpdateInput>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  startsAt?: Maybe<Scalars['DateTime']>;
  tzTarget?: Maybe<Scalars['String']>;
};

export type BookingWhereInput = {
  AND?: Maybe<Array<BookingWhereInput>>;
  NOT?: Maybe<Array<BookingWhereInput>>;
  OR?: Maybe<Array<BookingWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  calendar?: Maybe<CalendarWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  durationMins?: Maybe<IntFilter>;
  endsAt?: Maybe<DateTimeNullableFilter>;
  event?: Maybe<CalendarEventWhereInput>;
  id?: Maybe<IdFilter>;
  isCancelled?: Maybe<BooleanFilter>;
  isConfirmed?: Maybe<BooleanFilter>;
  name?: Maybe<StringFilter>;
  patient?: Maybe<PatientWhereInput>;
  startsAt?: Maybe<DateTimeNullableFilter>;
  tzTarget?: Maybe<StringFilter>;
};

export type BookingWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type BooleanFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<BooleanFilter>;
};

export type Calendar = {
  __typename?: 'Calendar';
  acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>;
  bookings?: Maybe<Array<Booking>>;
  bookingsCount?: Maybe<Scalars['Int']>;
  clinic?: Maybe<Clinic>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultSchedule?: Maybe<Schedule>;
  doctor?: Maybe<Doctor>;
  events?: Maybe<Array<CalendarEvent>>;
  eventsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  member?: Maybe<Member>;
  name?: Maybe<Scalars['String']>;
  schedules?: Maybe<Array<Schedule>>;
  schedulesCount?: Maybe<Scalars['Int']>;
};


export type CalendarBookingsArgs = {
  cursor?: Maybe<BookingWhereUniqueInput>;
  orderBy?: Array<BookingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BookingWhereInput;
};


export type CalendarBookingsCountArgs = {
  where?: BookingWhereInput;
};


export type CalendarEventsArgs = {
  cursor?: Maybe<CalendarEventWhereUniqueInput>;
  orderBy?: Array<CalendarEventOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CalendarEventWhereInput;
};


export type CalendarEventsCountArgs = {
  where?: CalendarEventWhereInput;
};


export type CalendarSchedulesArgs = {
  cursor?: Maybe<ScheduleWhereUniqueInput>;
  orderBy?: Array<ScheduleOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ScheduleWhereInput;
};


export type CalendarSchedulesCountArgs = {
  where?: ScheduleWhereInput;
};

export enum CalendarAcceptingNewPatientType {
  No = 'NO',
  RequestedOnly = 'REQUESTED_ONLY',
  Yes = 'YES'
}

export type CalendarAcceptingNewPatientTypeNullableFilter = {
  equals?: Maybe<CalendarAcceptingNewPatientType>;
  in?: Maybe<Array<CalendarAcceptingNewPatientType>>;
  not?: Maybe<CalendarAcceptingNewPatientTypeNullableFilter>;
  notIn?: Maybe<Array<CalendarAcceptingNewPatientType>>;
};

export type CalendarCreateInput = {
  acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>;
  bookings?: Maybe<BookingRelateToManyForCreateInput>;
  clinic?: Maybe<ClinicRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultSchedule?: Maybe<ScheduleRelateToOneForCreateInput>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  events?: Maybe<CalendarEventRelateToManyForCreateInput>;
  member?: Maybe<MemberRelateToOneForCreateInput>;
  name?: Maybe<Scalars['String']>;
  schedules?: Maybe<ScheduleRelateToManyForCreateInput>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  address?: Maybe<Address>;
  appointmentRequests?: Maybe<Array<AppointmentRequest>>;
  appointmentRequestsCount?: Maybe<Scalars['Int']>;
  appointments?: Maybe<Array<Appointment>>;
  appointmentsCount?: Maybe<Scalars['Int']>;
  bookings?: Maybe<Array<Booking>>;
  bookingsCount?: Maybe<Scalars['Int']>;
  calendar?: Maybe<Calendar>;
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doctor?: Maybe<Doctor>;
  durationMins?: Maybe<Scalars['Int']>;
  eventType?: Maybe<CalendarEventType>;
  facilityMasterNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAcceptingInPerson?: Maybe<Scalars['Boolean']>;
  isAcceptingVirtual?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConfirmationRequired?: Maybe<Scalars['Boolean']>;
  serviceLocationIndicator?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type CalendarEventAppointmentRequestsArgs = {
  cursor?: Maybe<AppointmentRequestWhereUniqueInput>;
  orderBy?: Array<AppointmentRequestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentRequestWhereInput;
};


export type CalendarEventAppointmentRequestsCountArgs = {
  where?: AppointmentRequestWhereInput;
};


export type CalendarEventAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  orderBy?: Array<AppointmentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentWhereInput;
};


export type CalendarEventAppointmentsCountArgs = {
  where?: AppointmentWhereInput;
};


export type CalendarEventBookingsArgs = {
  cursor?: Maybe<BookingWhereUniqueInput>;
  orderBy?: Array<BookingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BookingWhereInput;
};


export type CalendarEventBookingsCountArgs = {
  where?: BookingWhereInput;
};

export type CalendarEventCreateInput = {
  address?: Maybe<AddressRelateToOneForCreateInput>;
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForCreateInput>;
  appointments?: Maybe<AppointmentRelateToManyForCreateInput>;
  bookings?: Maybe<BookingRelateToManyForCreateInput>;
  calendar?: Maybe<CalendarRelateToOneForCreateInput>;
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  durationMins?: Maybe<Scalars['Int']>;
  eventType?: Maybe<CalendarEventTypeRelateToOneForCreateInput>;
  facilityMasterNumber?: Maybe<Scalars['String']>;
  isAcceptingInPerson?: Maybe<Scalars['Boolean']>;
  isAcceptingVirtual?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConfirmationRequired?: Maybe<Scalars['Boolean']>;
  serviceLocationIndicator?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CalendarEventManyRelationFilter = {
  every?: Maybe<CalendarEventWhereInput>;
  none?: Maybe<CalendarEventWhereInput>;
  some?: Maybe<CalendarEventWhereInput>;
};

export type CalendarEventOrderByInput = {
  companyName?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  durationMins?: Maybe<OrderDirection>;
  facilityMasterNumber?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isAcceptingInPerson?: Maybe<OrderDirection>;
  isAcceptingVirtual?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  isConfirmationRequired?: Maybe<OrderDirection>;
  serviceLocationIndicator?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
};

export type CalendarEventRelateToManyForCreateInput = {
  connect?: Maybe<Array<CalendarEventWhereUniqueInput>>;
  create?: Maybe<Array<CalendarEventCreateInput>>;
};

export type CalendarEventRelateToManyForUpdateInput = {
  connect?: Maybe<Array<CalendarEventWhereUniqueInput>>;
  create?: Maybe<Array<CalendarEventCreateInput>>;
  disconnect?: Maybe<Array<CalendarEventWhereUniqueInput>>;
  set?: Maybe<Array<CalendarEventWhereUniqueInput>>;
};

export type CalendarEventRelateToOneForCreateInput = {
  connect?: Maybe<CalendarEventWhereUniqueInput>;
  create?: Maybe<CalendarEventCreateInput>;
};

export type CalendarEventRelateToOneForUpdateInput = {
  connect?: Maybe<CalendarEventWhereUniqueInput>;
  create?: Maybe<CalendarEventCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type CalendarEventType = {
  __typename?: 'CalendarEventType';
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<Array<CalendarEvent>>;
  eventsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isPrivate?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type CalendarEventTypeEventsArgs = {
  cursor?: Maybe<CalendarEventWhereUniqueInput>;
  orderBy?: Array<CalendarEventOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CalendarEventWhereInput;
};


export type CalendarEventTypeEventsCountArgs = {
  where?: CalendarEventWhereInput;
};

export type CalendarEventTypeCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<CalendarEventRelateToManyForCreateInput>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CalendarEventTypeOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isPrivate?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  value?: Maybe<OrderDirection>;
};

export type CalendarEventTypeRelateToOneForCreateInput = {
  connect?: Maybe<CalendarEventTypeWhereUniqueInput>;
  create?: Maybe<CalendarEventTypeCreateInput>;
};

export type CalendarEventTypeRelateToOneForUpdateInput = {
  connect?: Maybe<CalendarEventTypeWhereUniqueInput>;
  create?: Maybe<CalendarEventTypeCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type CalendarEventTypeUpdateArgs = {
  data: CalendarEventTypeUpdateInput;
  where: CalendarEventTypeWhereUniqueInput;
};

export type CalendarEventTypeUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<CalendarEventRelateToManyForUpdateInput>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CalendarEventTypeWhereInput = {
  AND?: Maybe<Array<CalendarEventTypeWhereInput>>;
  NOT?: Maybe<Array<CalendarEventTypeWhereInput>>;
  OR?: Maybe<Array<CalendarEventTypeWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  events?: Maybe<CalendarEventManyRelationFilter>;
  id?: Maybe<IdFilter>;
  isPrivate?: Maybe<BooleanFilter>;
  label?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type CalendarEventTypeWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type CalendarEventUpdateArgs = {
  data: CalendarEventUpdateInput;
  where: CalendarEventWhereUniqueInput;
};

export type CalendarEventUpdateInput = {
  address?: Maybe<AddressRelateToOneForUpdateInput>;
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForUpdateInput>;
  appointments?: Maybe<AppointmentRelateToManyForUpdateInput>;
  bookings?: Maybe<BookingRelateToManyForUpdateInput>;
  calendar?: Maybe<CalendarRelateToOneForUpdateInput>;
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  durationMins?: Maybe<Scalars['Int']>;
  eventType?: Maybe<CalendarEventTypeRelateToOneForUpdateInput>;
  facilityMasterNumber?: Maybe<Scalars['String']>;
  isAcceptingInPerson?: Maybe<Scalars['Boolean']>;
  isAcceptingVirtual?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isConfirmationRequired?: Maybe<Scalars['Boolean']>;
  serviceLocationIndicator?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CalendarEventWhereInput = {
  AND?: Maybe<Array<CalendarEventWhereInput>>;
  NOT?: Maybe<Array<CalendarEventWhereInput>>;
  OR?: Maybe<Array<CalendarEventWhereInput>>;
  address?: Maybe<AddressWhereInput>;
  appointmentRequests?: Maybe<AppointmentRequestManyRelationFilter>;
  appointments?: Maybe<AppointmentManyRelationFilter>;
  bookings?: Maybe<BookingManyRelationFilter>;
  calendar?: Maybe<CalendarWhereInput>;
  companyName?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  durationMins?: Maybe<IntFilter>;
  eventType?: Maybe<CalendarEventTypeWhereInput>;
  facilityMasterNumber?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  isAcceptingInPerson?: Maybe<BooleanFilter>;
  isAcceptingVirtual?: Maybe<BooleanFilter>;
  isActive?: Maybe<BooleanFilter>;
  isConfirmationRequired?: Maybe<BooleanFilter>;
  serviceLocationIndicator?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
};

export type CalendarEventWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type CalendarOrderByInput = {
  acceptingNewPatients?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
};

export type CalendarRelateToOneForCreateInput = {
  connect?: Maybe<CalendarWhereUniqueInput>;
  create?: Maybe<CalendarCreateInput>;
};

export type CalendarRelateToOneForUpdateInput = {
  connect?: Maybe<CalendarWhereUniqueInput>;
  create?: Maybe<CalendarCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type CalendarUpdateArgs = {
  data: CalendarUpdateInput;
  where: CalendarWhereUniqueInput;
};

export type CalendarUpdateInput = {
  acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>;
  bookings?: Maybe<BookingRelateToManyForUpdateInput>;
  clinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultSchedule?: Maybe<ScheduleRelateToOneForUpdateInput>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  events?: Maybe<CalendarEventRelateToManyForUpdateInput>;
  member?: Maybe<MemberRelateToOneForUpdateInput>;
  name?: Maybe<Scalars['String']>;
  schedules?: Maybe<ScheduleRelateToManyForUpdateInput>;
};

export type CalendarWhereInput = {
  AND?: Maybe<Array<CalendarWhereInput>>;
  NOT?: Maybe<Array<CalendarWhereInput>>;
  OR?: Maybe<Array<CalendarWhereInput>>;
  acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientTypeNullableFilter>;
  bookings?: Maybe<BookingManyRelationFilter>;
  clinic?: Maybe<ClinicWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  defaultSchedule?: Maybe<ScheduleWhereInput>;
  doctor?: Maybe<DoctorWhereInput>;
  events?: Maybe<CalendarEventManyRelationFilter>;
  id?: Maybe<IdFilter>;
  member?: Maybe<MemberWhereInput>;
  name?: Maybe<StringFilter>;
  schedules?: Maybe<ScheduleManyRelationFilter>;
};

export type CalendarWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Chat = {
  __typename?: 'Chat';
  appointment?: Maybe<Appointment>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<Array<Doctor>>;
  doctorsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  messages?: Maybe<Array<ChatMessage>>;
  messagesCount?: Maybe<Scalars['Int']>;
  patient?: Maybe<Patient>;
};


export type ChatDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type ChatDoctorsCountArgs = {
  where?: DoctorWhereInput;
};


export type ChatMessagesArgs = {
  cursor?: Maybe<ChatMessageWhereUniqueInput>;
  orderBy?: Array<ChatMessageOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ChatMessageWhereInput;
};


export type ChatMessagesCountArgs = {
  where?: ChatMessageWhereInput;
};

export type ChatCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForCreateInput>;
  messages?: Maybe<ChatMessageRelateToManyForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  author?: Maybe<User>;
  chat?: Maybe<Chat>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  readAt?: Maybe<Scalars['DateTime']>;
  replyTo?: Maybe<ChatMessage>;
  text?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ChatMessageCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  chat?: Maybe<ChatRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  readAt?: Maybe<Scalars['DateTime']>;
  replyTo?: Maybe<ChatMessageRelateToOneForCreateInput>;
  text?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ChatMessageManyRelationFilter = {
  every?: Maybe<ChatMessageWhereInput>;
  none?: Maybe<ChatMessageWhereInput>;
  some?: Maybe<ChatMessageWhereInput>;
};

export type ChatMessageOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  readAt?: Maybe<OrderDirection>;
  text?: Maybe<OrderDirection>;
  uuid?: Maybe<OrderDirection>;
};

export type ChatMessageRelateToManyForCreateInput = {
  connect?: Maybe<Array<ChatMessageWhereUniqueInput>>;
  create?: Maybe<Array<ChatMessageCreateInput>>;
};

export type ChatMessageRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ChatMessageWhereUniqueInput>>;
  create?: Maybe<Array<ChatMessageCreateInput>>;
  disconnect?: Maybe<Array<ChatMessageWhereUniqueInput>>;
  set?: Maybe<Array<ChatMessageWhereUniqueInput>>;
};

export type ChatMessageRelateToOneForCreateInput = {
  connect?: Maybe<ChatMessageWhereUniqueInput>;
  create?: Maybe<ChatMessageCreateInput>;
};

export type ChatMessageRelateToOneForUpdateInput = {
  connect?: Maybe<ChatMessageWhereUniqueInput>;
  create?: Maybe<ChatMessageCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ChatMessageUpdateArgs = {
  data: ChatMessageUpdateInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  chat?: Maybe<ChatRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  readAt?: Maybe<Scalars['DateTime']>;
  replyTo?: Maybe<ChatMessageRelateToOneForUpdateInput>;
  text?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ChatMessageWhereInput = {
  AND?: Maybe<Array<ChatMessageWhereInput>>;
  NOT?: Maybe<Array<ChatMessageWhereInput>>;
  OR?: Maybe<Array<ChatMessageWhereInput>>;
  author?: Maybe<UserWhereInput>;
  chat?: Maybe<ChatWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  readAt?: Maybe<DateTimeNullableFilter>;
  replyTo?: Maybe<ChatMessageWhereInput>;
  text?: Maybe<StringFilter>;
  uuid?: Maybe<StringFilter>;
};

export type ChatMessageWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type ChatOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type ChatRelateToOneForCreateInput = {
  connect?: Maybe<ChatWhereUniqueInput>;
  create?: Maybe<ChatCreateInput>;
};

export type ChatRelateToOneForUpdateInput = {
  connect?: Maybe<ChatWhereUniqueInput>;
  create?: Maybe<ChatCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ChatUpdateArgs = {
  data: ChatUpdateInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForUpdateInput>;
  messages?: Maybe<ChatMessageRelateToManyForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
};

export type ChatWhereInput = {
  AND?: Maybe<Array<ChatWhereInput>>;
  NOT?: Maybe<Array<ChatWhereInput>>;
  OR?: Maybe<Array<ChatWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctors?: Maybe<DoctorManyRelationFilter>;
  id?: Maybe<IdFilter>;
  messages?: Maybe<ChatMessageManyRelationFilter>;
  patient?: Maybe<PatientWhereInput>;
};

export type ChatWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Clinic = {
  __typename?: 'Clinic';
  address?: Maybe<Address>;
  appointmentRequests?: Maybe<Array<AppointmentRequest>>;
  appointmentRequestsCount?: Maybe<Scalars['Int']>;
  appointments?: Maybe<Array<Appointment>>;
  appointmentsCount?: Maybe<Scalars['Int']>;
  billings?: Maybe<Array<AppointmentBilling>>;
  billingsCount?: Maybe<Scalars['Int']>;
  calendar?: Maybe<Calendar>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  facilityMasterNumber?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  leaseAgreement?: Maybe<LeaseAgreement>;
  members?: Maybe<Array<Member>>;
  membersCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ohipGroupNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  serviceLocationIndicator?: Maybe<Scalars['String']>;
};


export type ClinicAppointmentRequestsArgs = {
  cursor?: Maybe<AppointmentRequestWhereUniqueInput>;
  orderBy?: Array<AppointmentRequestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentRequestWhereInput;
};


export type ClinicAppointmentRequestsCountArgs = {
  where?: AppointmentRequestWhereInput;
};


export type ClinicAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  orderBy?: Array<AppointmentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentWhereInput;
};


export type ClinicAppointmentsCountArgs = {
  where?: AppointmentWhereInput;
};


export type ClinicBillingsArgs = {
  cursor?: Maybe<AppointmentBillingWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingWhereInput;
};


export type ClinicBillingsCountArgs = {
  where?: AppointmentBillingWhereInput;
};


export type ClinicMembersArgs = {
  cursor?: Maybe<MemberWhereUniqueInput>;
  orderBy?: Array<MemberOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MemberWhereInput;
};


export type ClinicMembersCountArgs = {
  where?: MemberWhereInput;
};

export type ClinicCreateInput = {
  address?: Maybe<AddressRelateToOneForCreateInput>;
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForCreateInput>;
  appointments?: Maybe<AppointmentRelateToManyForCreateInput>;
  billings?: Maybe<AppointmentBillingRelateToManyForCreateInput>;
  calendar?: Maybe<CalendarRelateToOneForCreateInput>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  facilityMasterNumber?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leaseAgreement?: Maybe<LeaseAgreementRelateToOneForCreateInput>;
  members?: Maybe<MemberRelateToManyForCreateInput>;
  name?: Maybe<Scalars['String']>;
  ohipGroupNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  serviceLocationIndicator?: Maybe<Scalars['String']>;
};

export type ClinicManyRelationFilter = {
  every?: Maybe<ClinicWhereInput>;
  none?: Maybe<ClinicWhereInput>;
  some?: Maybe<ClinicWhereInput>;
};

export type ClinicOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  facilityMasterNumber?: Maybe<OrderDirection>;
  faxNumber?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  ohipGroupNumber?: Maybe<OrderDirection>;
  phoneNumber?: Maybe<OrderDirection>;
  serviceLocationIndicator?: Maybe<OrderDirection>;
};

export type ClinicRelateToManyForCreateInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  create?: Maybe<Array<ClinicCreateInput>>;
};

export type ClinicRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
  create?: Maybe<Array<ClinicCreateInput>>;
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
};

export type ClinicRelateToOneForCreateInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  create?: Maybe<ClinicCreateInput>;
};

export type ClinicRelateToOneForUpdateInput = {
  connect?: Maybe<ClinicWhereUniqueInput>;
  create?: Maybe<ClinicCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ClinicUpdateArgs = {
  data: ClinicUpdateInput;
  where: ClinicWhereUniqueInput;
};

export type ClinicUpdateInput = {
  address?: Maybe<AddressRelateToOneForUpdateInput>;
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForUpdateInput>;
  appointments?: Maybe<AppointmentRelateToManyForUpdateInput>;
  billings?: Maybe<AppointmentBillingRelateToManyForUpdateInput>;
  calendar?: Maybe<CalendarRelateToOneForUpdateInput>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  facilityMasterNumber?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  leaseAgreement?: Maybe<LeaseAgreementRelateToOneForUpdateInput>;
  members?: Maybe<MemberRelateToManyForUpdateInput>;
  name?: Maybe<Scalars['String']>;
  ohipGroupNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  serviceLocationIndicator?: Maybe<Scalars['String']>;
};

export type ClinicWhereInput = {
  AND?: Maybe<Array<ClinicWhereInput>>;
  NOT?: Maybe<Array<ClinicWhereInput>>;
  OR?: Maybe<Array<ClinicWhereInput>>;
  address?: Maybe<AddressWhereInput>;
  appointmentRequests?: Maybe<AppointmentRequestManyRelationFilter>;
  appointments?: Maybe<AppointmentManyRelationFilter>;
  billings?: Maybe<AppointmentBillingManyRelationFilter>;
  calendar?: Maybe<CalendarWhereInput>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  facilityMasterNumber?: Maybe<StringFilter>;
  faxNumber?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  isActive?: Maybe<BooleanFilter>;
  leaseAgreement?: Maybe<LeaseAgreementWhereInput>;
  members?: Maybe<MemberManyRelationFilter>;
  name?: Maybe<StringFilter>;
  ohipGroupNumber?: Maybe<StringFilter>;
  phoneNumber?: Maybe<StringFilter>;
  serviceLocationIndicator?: Maybe<StringFilter>;
};

export type ClinicWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

/**
 * Mirrors the formatting options [Cloudinary provides](https://cloudinary.com/documentation/image_transformation_reference).
 * All options are strings as they ultimately end up in a URL.
 */
export type CloudinaryImageFormat = {
  angle?: Maybe<Scalars['String']>;
  aspect_ratio?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  border?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  color_space?: Maybe<Scalars['String']>;
  crop?: Maybe<Scalars['String']>;
  default_image?: Maybe<Scalars['String']>;
  delay?: Maybe<Scalars['String']>;
  density?: Maybe<Scalars['String']>;
  dpr?: Maybe<Scalars['String']>;
  effect?: Maybe<Scalars['String']>;
  fetch_format?: Maybe<Scalars['String']>;
  flags?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  gravity?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['String']>;
  overlay?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
  /**  Rewrites the filename to be this pretty string. Do not include `/` or `.` */
  prettyName?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['String']>;
  radius?: Maybe<Scalars['String']>;
  transformation?: Maybe<Scalars['String']>;
  underlay?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
  y?: Maybe<Scalars['String']>;
  zoom?: Maybe<Scalars['String']>;
};

export type CloudinaryImage_File = {
  __typename?: 'CloudinaryImage_File';
  encoding?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mimetype?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  publicUrl?: Maybe<Scalars['String']>;
  publicUrlTransformed?: Maybe<Scalars['String']>;
};


export type CloudinaryImage_FilePublicUrlTransformedArgs = {
  transformation?: Maybe<CloudinaryImageFormat>;
};

export type Company = {
  __typename?: 'Company';
  clinics?: Maybe<Array<Clinic>>;
  clinicsCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxes?: Maybe<Array<Fax>>;
  faxesCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  logo?: Maybe<CompanyLogo>;
  masterLicense?: Maybe<MasterLicense>;
  operatingName?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
  patients?: Maybe<Array<Patient>>;
  patientsCount?: Maybe<Scalars['Int']>;
  stepperProg?: Maybe<StepperProg>;
  submissions?: Maybe<Array<BillingSubmission>>;
  submissionsCount?: Maybe<Scalars['Int']>;
  tasks?: Maybe<Array<Task>>;
  tasksCount?: Maybe<Scalars['Int']>;
  userInvites?: Maybe<Array<UserInvite>>;
  userInvitesCount?: Maybe<Scalars['Int']>;
};


export type CompanyClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  orderBy?: Array<ClinicOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ClinicWhereInput;
};


export type CompanyClinicsCountArgs = {
  where?: ClinicWhereInput;
};


export type CompanyFaxesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type CompanyFaxesCountArgs = {
  where?: FaxWhereInput;
};


export type CompanyPatientsArgs = {
  cursor?: Maybe<PatientWhereUniqueInput>;
  orderBy?: Array<PatientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PatientWhereInput;
};


export type CompanyPatientsCountArgs = {
  where?: PatientWhereInput;
};


export type CompanySubmissionsArgs = {
  cursor?: Maybe<BillingSubmissionWhereUniqueInput>;
  orderBy?: Array<BillingSubmissionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BillingSubmissionWhereInput;
};


export type CompanySubmissionsCountArgs = {
  where?: BillingSubmissionWhereInput;
};


export type CompanyTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  orderBy?: Array<TaskOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TaskWhereInput;
};


export type CompanyTasksCountArgs = {
  where?: TaskWhereInput;
};


export type CompanyUserInvitesArgs = {
  cursor?: Maybe<UserInviteWhereUniqueInput>;
  orderBy?: Array<UserInviteOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserInviteWhereInput;
};


export type CompanyUserInvitesCountArgs = {
  where?: UserInviteWhereInput;
};

export type CompanyCreateInput = {
  clinics?: Maybe<ClinicRelateToManyForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxes?: Maybe<FaxRelateToManyForCreateInput>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  logo?: Maybe<CompanyLogoRelateToOneForCreateInput>;
  masterLicense?: Maybe<MasterLicenseRelateToOneForCreateInput>;
  operatingName?: Maybe<Scalars['String']>;
  owner?: Maybe<UserRelateToOneForCreateInput>;
  patients?: Maybe<PatientRelateToManyForCreateInput>;
  stepperProg?: Maybe<StepperProgRelateToOneForCreateInput>;
  submissions?: Maybe<BillingSubmissionRelateToManyForCreateInput>;
  tasks?: Maybe<TaskRelateToManyForCreateInput>;
  userInvites?: Maybe<UserInviteRelateToManyForCreateInput>;
};

export type CompanyLogo = {
  __typename?: 'CompanyLogo';
  altText?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  owner?: Maybe<User>;
  src?: Maybe<CloudinaryImage_File>;
};

export type CompanyLogoCreateInput = {
  altText?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  owner?: Maybe<UserRelateToOneForCreateInput>;
  src?: Maybe<Scalars['Upload']>;
};

export type CompanyLogoOrderByInput = {
  altText?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type CompanyLogoRelateToOneForCreateInput = {
  connect?: Maybe<CompanyLogoWhereUniqueInput>;
  create?: Maybe<CompanyLogoCreateInput>;
};

export type CompanyLogoRelateToOneForUpdateInput = {
  connect?: Maybe<CompanyLogoWhereUniqueInput>;
  create?: Maybe<CompanyLogoCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type CompanyLogoUpdateArgs = {
  data: CompanyLogoUpdateInput;
  where: CompanyLogoWhereUniqueInput;
};

export type CompanyLogoUpdateInput = {
  altText?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  owner?: Maybe<UserRelateToOneForUpdateInput>;
  src?: Maybe<Scalars['Upload']>;
};

export type CompanyLogoWhereInput = {
  AND?: Maybe<Array<CompanyLogoWhereInput>>;
  NOT?: Maybe<Array<CompanyLogoWhereInput>>;
  OR?: Maybe<Array<CompanyLogoWhereInput>>;
  altText?: Maybe<StringFilter>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  owner?: Maybe<UserWhereInput>;
};

export type CompanyLogoWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type CompanyManyRelationFilter = {
  every?: Maybe<CompanyWhereInput>;
  none?: Maybe<CompanyWhereInput>;
  some?: Maybe<CompanyWhereInput>;
};

export type CompanyMemberWithRoles = {
  __typename?: 'CompanyMemberWithRoles';
  faxNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  roles: Array<Scalars['String']>;
  user: User;
  userId: Scalars['ID'];
};

export type CompanyOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isOnboarded?: Maybe<OrderDirection>;
  isVerified?: Maybe<OrderDirection>;
  legalName?: Maybe<OrderDirection>;
  operatingName?: Maybe<OrderDirection>;
};

export type CompanyRelateToManyForCreateInput = {
  connect?: Maybe<Array<CompanyWhereUniqueInput>>;
  create?: Maybe<Array<CompanyCreateInput>>;
};

export type CompanyRelateToManyForUpdateInput = {
  connect?: Maybe<Array<CompanyWhereUniqueInput>>;
  create?: Maybe<Array<CompanyCreateInput>>;
  disconnect?: Maybe<Array<CompanyWhereUniqueInput>>;
  set?: Maybe<Array<CompanyWhereUniqueInput>>;
};

export type CompanyRelateToOneForCreateInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  create?: Maybe<CompanyCreateInput>;
};

export type CompanyRelateToOneForUpdateInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  create?: Maybe<CompanyCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type CompanyUpdateArgs = {
  data: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyUpdateInput = {
  clinics?: Maybe<ClinicRelateToManyForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxes?: Maybe<FaxRelateToManyForUpdateInput>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  logo?: Maybe<CompanyLogoRelateToOneForUpdateInput>;
  masterLicense?: Maybe<MasterLicenseRelateToOneForUpdateInput>;
  operatingName?: Maybe<Scalars['String']>;
  owner?: Maybe<UserRelateToOneForUpdateInput>;
  patients?: Maybe<PatientRelateToManyForUpdateInput>;
  stepperProg?: Maybe<StepperProgRelateToOneForUpdateInput>;
  submissions?: Maybe<BillingSubmissionRelateToManyForUpdateInput>;
  tasks?: Maybe<TaskRelateToManyForUpdateInput>;
  userInvites?: Maybe<UserInviteRelateToManyForUpdateInput>;
};

export type CompanyWhereInput = {
  AND?: Maybe<Array<CompanyWhereInput>>;
  NOT?: Maybe<Array<CompanyWhereInput>>;
  OR?: Maybe<Array<CompanyWhereInput>>;
  clinics?: Maybe<ClinicManyRelationFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  faxes?: Maybe<FaxManyRelationFilter>;
  id?: Maybe<IdFilter>;
  isOnboarded?: Maybe<BooleanFilter>;
  isVerified?: Maybe<BooleanFilter>;
  legalName?: Maybe<StringFilter>;
  logo?: Maybe<CompanyLogoWhereInput>;
  masterLicense?: Maybe<MasterLicenseWhereInput>;
  operatingName?: Maybe<StringFilter>;
  owner?: Maybe<UserWhereInput>;
  patients?: Maybe<PatientManyRelationFilter>;
  stepperProg?: Maybe<StepperProgWhereInput>;
  submissions?: Maybe<BillingSubmissionManyRelationFilter>;
  tasks?: Maybe<TaskManyRelationFilter>;
  userInvites?: Maybe<UserInviteManyRelationFilter>;
};

export type CompanyWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Contract = {
  __typename?: 'Contract';
  author?: Maybe<User>;
  body?: Maybe<Contract_Body_Document>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  effectiveFrom?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  signedBy?: Maybe<Array<User>>;
  signedByCount?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};


export type ContractSignedByArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserWhereInput;
};


export type ContractSignedByCountArgs = {
  where?: UserWhereInput;
};

export type ContractCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  body?: Maybe<Scalars['JSON']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  effectiveFrom?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  signedBy?: Maybe<UserRelateToManyForCreateInput>;
  slug?: Maybe<Scalars['String']>;
};

export type ContractManyRelationFilter = {
  every?: Maybe<ContractWhereInput>;
  none?: Maybe<ContractWhereInput>;
  some?: Maybe<ContractWhereInput>;
};

export type ContractOrderByInput = {
  content?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  effectiveFrom?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  lastUpdated?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  slug?: Maybe<OrderDirection>;
};

export type ContractRelateToManyForCreateInput = {
  connect?: Maybe<Array<ContractWhereUniqueInput>>;
  create?: Maybe<Array<ContractCreateInput>>;
};

export type ContractRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ContractWhereUniqueInput>>;
  create?: Maybe<Array<ContractCreateInput>>;
  disconnect?: Maybe<Array<ContractWhereUniqueInput>>;
  set?: Maybe<Array<ContractWhereUniqueInput>>;
};

export type ContractUpdateArgs = {
  data: ContractUpdateInput;
  where: ContractWhereUniqueInput;
};

export type ContractUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  body?: Maybe<Scalars['JSON']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  effectiveFrom?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  signedBy?: Maybe<UserRelateToManyForUpdateInput>;
  slug?: Maybe<Scalars['String']>;
};

export type ContractWhereInput = {
  AND?: Maybe<Array<ContractWhereInput>>;
  NOT?: Maybe<Array<ContractWhereInput>>;
  OR?: Maybe<Array<ContractWhereInput>>;
  author?: Maybe<UserWhereInput>;
  content?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  effectiveFrom?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  isActive?: Maybe<BooleanFilter>;
  lastUpdated?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<StringFilter>;
  signedBy?: Maybe<UserManyRelationFilter>;
  slug?: Maybe<StringFilter>;
};

export type ContractWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type Contract_Body_Document = {
  __typename?: 'Contract_body_Document';
  document: Scalars['JSON'];
};


export type Contract_Body_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean'];
};

export type Country = {
  __typename?: 'Country';
  administrativeAreas?: Maybe<Array<AdministrativeArea>>;
  administrativeAreasCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type CountryAdministrativeAreasArgs = {
  cursor?: Maybe<AdministrativeAreaWhereUniqueInput>;
  orderBy?: Array<AdministrativeAreaOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AdministrativeAreaWhereInput;
};


export type CountryAdministrativeAreasCountArgs = {
  where?: AdministrativeAreaWhereInput;
};

export type CountryCreateInput = {
  administrativeAreas?: Maybe<AdministrativeAreaRelateToManyForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CountryOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  value?: Maybe<OrderDirection>;
};

export type CountryRelateToOneForCreateInput = {
  connect?: Maybe<CountryWhereUniqueInput>;
  create?: Maybe<CountryCreateInput>;
};

export type CountryRelateToOneForUpdateInput = {
  connect?: Maybe<CountryWhereUniqueInput>;
  create?: Maybe<CountryCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type CountryUpdateArgs = {
  data: CountryUpdateInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateInput = {
  administrativeAreas?: Maybe<AdministrativeAreaRelateToManyForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CountryWhereInput = {
  AND?: Maybe<Array<CountryWhereInput>>;
  NOT?: Maybe<Array<CountryWhereInput>>;
  OR?: Maybe<Array<CountryWhereInput>>;
  administrativeAreas?: Maybe<AdministrativeAreaManyRelationFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  isActive?: Maybe<BooleanFilter>;
  label?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type CountryWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  author?: Maybe<User>;
  centsOff?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type CouponCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  centsOff?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type CouponOrderByInput = {
  centsOff?: Maybe<OrderDirection>;
  code?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  percentOff?: Maybe<OrderDirection>;
  validFrom?: Maybe<OrderDirection>;
  validTo?: Maybe<OrderDirection>;
};

export type CouponUpdateArgs = {
  data: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};

export type CouponUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  centsOff?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type CouponWhereInput = {
  AND?: Maybe<Array<CouponWhereInput>>;
  NOT?: Maybe<Array<CouponWhereInput>>;
  OR?: Maybe<Array<CouponWhereInput>>;
  author?: Maybe<UserWhereInput>;
  centsOff?: Maybe<IntNullableFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  isActive?: Maybe<BooleanFilter>;
  name?: Maybe<StringFilter>;
  percentOff?: Maybe<IntNullableFilter>;
  validFrom?: Maybe<DateTimeNullableFilter>;
  validTo?: Maybe<DateTimeNullableFilter>;
};

export type CouponWhereUniqueInput = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type DataImport = {
  __typename?: 'DataImport';
  createdAt?: Maybe<Scalars['DateTime']>;
  fileKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
};

export type DataImportCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fileKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  owner?: Maybe<UserRelateToOneForCreateInput>;
};

export type DataImportIntent = {
  __typename?: 'DataImportIntent';
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportItems?: Maybe<Array<DataImportItem>>;
  dataImportItemsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  member?: Maybe<Member>;
  owner?: Maybe<User>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<DataImportIntentStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
};


export type DataImportIntentDataImportItemsArgs = {
  cursor?: Maybe<DataImportItemWhereUniqueInput>;
  orderBy?: Array<DataImportItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportItemWhereInput;
};


export type DataImportIntentDataImportItemsCountArgs = {
  where?: DataImportItemWhereInput;
};

export type DataImportIntentCreateInput = {
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportItems?: Maybe<DataImportItemRelateToManyForCreateInput>;
  member?: Maybe<MemberRelateToOneForCreateInput>;
  owner?: Maybe<UserRelateToOneForCreateInput>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<DataImportIntentStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
};

export type DataImportIntentManyRelationFilter = {
  every?: Maybe<DataImportIntentWhereInput>;
  none?: Maybe<DataImportIntentWhereInput>;
  some?: Maybe<DataImportIntentWhereInput>;
};

export type DataImportIntentOrderByInput = {
  bucket?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  source?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
  statusMessage?: Maybe<OrderDirection>;
};

export type DataImportIntentRelateToManyForCreateInput = {
  connect?: Maybe<Array<DataImportIntentWhereUniqueInput>>;
  create?: Maybe<Array<DataImportIntentCreateInput>>;
};

export type DataImportIntentRelateToManyForUpdateInput = {
  connect?: Maybe<Array<DataImportIntentWhereUniqueInput>>;
  create?: Maybe<Array<DataImportIntentCreateInput>>;
  disconnect?: Maybe<Array<DataImportIntentWhereUniqueInput>>;
  set?: Maybe<Array<DataImportIntentWhereUniqueInput>>;
};

export type DataImportIntentRelateToOneForCreateInput = {
  connect?: Maybe<DataImportIntentWhereUniqueInput>;
  create?: Maybe<DataImportIntentCreateInput>;
};

export type DataImportIntentRelateToOneForUpdateInput = {
  connect?: Maybe<DataImportIntentWhereUniqueInput>;
  create?: Maybe<DataImportIntentCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export enum DataImportIntentStatusType {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  Uploaded = 'UPLOADED'
}

export type DataImportIntentStatusTypeNullableFilter = {
  equals?: Maybe<DataImportIntentStatusType>;
  in?: Maybe<Array<DataImportIntentStatusType>>;
  not?: Maybe<DataImportIntentStatusTypeNullableFilter>;
  notIn?: Maybe<Array<DataImportIntentStatusType>>;
};

export type DataImportIntentUpdateArgs = {
  data: DataImportIntentUpdateInput;
  where: DataImportIntentWhereUniqueInput;
};

export type DataImportIntentUpdateInput = {
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportItems?: Maybe<DataImportItemRelateToManyForUpdateInput>;
  member?: Maybe<MemberRelateToOneForUpdateInput>;
  owner?: Maybe<UserRelateToOneForUpdateInput>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<DataImportIntentStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
};

export type DataImportIntentWhereInput = {
  AND?: Maybe<Array<DataImportIntentWhereInput>>;
  NOT?: Maybe<Array<DataImportIntentWhereInput>>;
  OR?: Maybe<Array<DataImportIntentWhereInput>>;
  bucket?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  dataImportItems?: Maybe<DataImportItemManyRelationFilter>;
  id?: Maybe<IdFilter>;
  member?: Maybe<MemberWhereInput>;
  owner?: Maybe<UserWhereInput>;
  source?: Maybe<StringFilter>;
  status?: Maybe<DataImportIntentStatusTypeNullableFilter>;
  statusMessage?: Maybe<StringFilter>;
};

export type DataImportIntentWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type DataImportItem = {
  __typename?: 'DataImportItem';
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntent?: Maybe<DataImportIntent>;
  email?: Maybe<Scalars['String']>;
  healthCardNumber?: Maybe<Scalars['String']>;
  healthCardProvince?: Maybe<Scalars['String']>;
  healthCardVersionCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  status?: Maybe<DataImportItemStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  uploadUuid?: Maybe<Scalars['String']>;
};

export type DataImportItemCreateInput = {
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntent?: Maybe<DataImportIntentRelateToOneForCreateInput>;
  email?: Maybe<Scalars['String']>;
  healthCardNumber?: Maybe<Scalars['String']>;
  healthCardProvince?: Maybe<Scalars['String']>;
  healthCardVersionCode?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  status?: Maybe<DataImportItemStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  uploadUuid?: Maybe<Scalars['String']>;
};

export type DataImportItemManyRelationFilter = {
  every?: Maybe<DataImportItemWhereInput>;
  none?: Maybe<DataImportItemWhereInput>;
  some?: Maybe<DataImportItemWhereInput>;
};

export type DataImportItemOrderByInput = {
  bucket?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  email?: Maybe<OrderDirection>;
  healthCardNumber?: Maybe<OrderDirection>;
  healthCardProvince?: Maybe<OrderDirection>;
  healthCardVersionCode?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  key?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
  statusMessage?: Maybe<OrderDirection>;
  uploadUuid?: Maybe<OrderDirection>;
};

export type DataImportItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<DataImportItemWhereUniqueInput>>;
  create?: Maybe<Array<DataImportItemCreateInput>>;
};

export type DataImportItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<DataImportItemWhereUniqueInput>>;
  create?: Maybe<Array<DataImportItemCreateInput>>;
  disconnect?: Maybe<Array<DataImportItemWhereUniqueInput>>;
  set?: Maybe<Array<DataImportItemWhereUniqueInput>>;
};

export enum DataImportItemStatusType {
  Failed = 'FAILED',
  Found = 'FOUND',
  Initiated = 'INITIATED',
  New = 'NEW'
}

export type DataImportItemStatusTypeNullableFilter = {
  equals?: Maybe<DataImportItemStatusType>;
  in?: Maybe<Array<DataImportItemStatusType>>;
  not?: Maybe<DataImportItemStatusTypeNullableFilter>;
  notIn?: Maybe<Array<DataImportItemStatusType>>;
};

export type DataImportItemUpdateArgs = {
  data: DataImportItemUpdateInput;
  where: DataImportItemWhereUniqueInput;
};

export type DataImportItemUpdateInput = {
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntent?: Maybe<DataImportIntentRelateToOneForUpdateInput>;
  email?: Maybe<Scalars['String']>;
  healthCardNumber?: Maybe<Scalars['String']>;
  healthCardProvince?: Maybe<Scalars['String']>;
  healthCardVersionCode?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  status?: Maybe<DataImportItemStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  uploadUuid?: Maybe<Scalars['String']>;
};

export type DataImportItemWhereInput = {
  AND?: Maybe<Array<DataImportItemWhereInput>>;
  NOT?: Maybe<Array<DataImportItemWhereInput>>;
  OR?: Maybe<Array<DataImportItemWhereInput>>;
  bucket?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  dataImportIntent?: Maybe<DataImportIntentWhereInput>;
  email?: Maybe<StringFilter>;
  healthCardNumber?: Maybe<StringFilter>;
  healthCardProvince?: Maybe<StringFilter>;
  healthCardVersionCode?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  key?: Maybe<StringFilter>;
  patient?: Maybe<PatientWhereInput>;
  status?: Maybe<DataImportItemStatusTypeNullableFilter>;
  statusMessage?: Maybe<StringFilter>;
  uploadUuid?: Maybe<StringFilter>;
};

export type DataImportItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type DataImportManyRelationFilter = {
  every?: Maybe<DataImportWhereInput>;
  none?: Maybe<DataImportWhereInput>;
  some?: Maybe<DataImportWhereInput>;
};

export type DataImportOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  fileKey?: Maybe<OrderDirection>;
  fileName?: Maybe<OrderDirection>;
  fileSize?: Maybe<OrderDirection>;
  fileType?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  notes?: Maybe<OrderDirection>;
};

export type DataImportRelateToManyForCreateInput = {
  connect?: Maybe<Array<DataImportWhereUniqueInput>>;
  create?: Maybe<Array<DataImportCreateInput>>;
};

export type DataImportRelateToManyForUpdateInput = {
  connect?: Maybe<Array<DataImportWhereUniqueInput>>;
  create?: Maybe<Array<DataImportCreateInput>>;
  disconnect?: Maybe<Array<DataImportWhereUniqueInput>>;
  set?: Maybe<Array<DataImportWhereUniqueInput>>;
};

export type DataImportUpdateArgs = {
  data: DataImportUpdateInput;
  where: DataImportWhereUniqueInput;
};

export type DataImportUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fileKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  owner?: Maybe<UserRelateToOneForUpdateInput>;
};

export type DataImportWhereInput = {
  AND?: Maybe<Array<DataImportWhereInput>>;
  NOT?: Maybe<Array<DataImportWhereInput>>;
  OR?: Maybe<Array<DataImportWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  fileKey?: Maybe<StringFilter>;
  fileName?: Maybe<StringFilter>;
  fileSize?: Maybe<IntNullableFilter>;
  fileType?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  notes?: Maybe<StringFilter>;
  owner?: Maybe<UserWhereInput>;
};

export type DataImportWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};


export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<DateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<DateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type Doctor = {
  __typename?: 'Doctor';
  appointmentRequests?: Maybe<Array<AppointmentRequest>>;
  appointmentRequestsCount?: Maybe<Scalars['Int']>;
  appointmentSessions?: Maybe<Array<AppointmentSession>>;
  appointmentSessionsCount?: Maybe<Scalars['Int']>;
  appointments?: Maybe<Array<Appointment>>;
  appointmentsCount?: Maybe<Scalars['Int']>;
  billings?: Maybe<Array<AppointmentBilling>>;
  billingsCount?: Maybe<Scalars['Int']>;
  bookings?: Maybe<Array<Booking>>;
  bookingsCount?: Maybe<Scalars['Int']>;
  calendar?: Maybe<Calendar>;
  calendarEvents?: Maybe<Array<CalendarEvent>>;
  calendarEventsCount?: Maybe<Scalars['Int']>;
  caringForPatients?: Maybe<Array<Patient>>;
  caringForPatientsCount?: Maybe<Scalars['Int']>;
  clinicFMN?: Maybe<Scalars['String']>;
  clinicFaxNumber?: Maybe<Scalars['String']>;
  clinicName?: Maybe<Scalars['String']>;
  clinicOHIPBillingCode?: Maybe<Scalars['String']>;
  clinicPhoneNumber?: Maybe<Scalars['String']>;
  clinicSLI?: Maybe<Scalars['String']>;
  contractSignedOn?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctorSince?: Maybe<Scalars['DateTime']>;
  doctorSpecialty?: Maybe<DoctorSpecialty>;
  doctorSubSpecialties?: Maybe<Array<DoctorSubSpecialty>>;
  doctorSubSpecialtiesCount?: Maybe<Scalars['Int']>;
  documents?: Maybe<Array<Document>>;
  documentsCount?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  faxes?: Maybe<Array<Fax>>;
  faxesCount?: Maybe<Scalars['Int']>;
  forms?: Maybe<Array<Form>>;
  formsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  interactedPatients?: Maybe<Array<Patient>>;
  interactedPatientsCount?: Maybe<Scalars['Int']>;
  isCompleteProfile?: Maybe<Scalars['Boolean']>;
  isGoSecureGranted?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Language>>;
  languagesCount?: Maybe<Scalars['Int']>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseProvider?: Maybe<Scalars['String']>;
  medicalLiabilityNumber?: Maybe<Scalars['String']>;
  medicalLiabilityProvider?: Maybe<Scalars['String']>;
  medicationItems?: Maybe<Array<MedicationItem>>;
  medicationItemsCount?: Maybe<Scalars['Int']>;
  ohipGroup?: Maybe<Scalars['String']>;
  ohipPractitionerNumber?: Maybe<Scalars['String']>;
  ohipSpecialityCode?: Maybe<Scalars['String']>;
  patients?: Maybe<Array<Patient>>;
  patientsCount?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<Array<Prescription>>;
  prescriptionsCount?: Maybe<Scalars['Int']>;
  proofOfIdentification?: Maybe<ProofOfIdentification>;
  proofOfInsurance?: Maybe<ProofOfInsurance>;
  proofOfLicense?: Maybe<ProofOfLicense>;
  province?: Maybe<Scalars['String']>;
  savedByPatients?: Maybe<Array<Patient>>;
  savedByPatientsCount?: Maybe<Scalars['Int']>;
  signature?: Maybe<Signature>;
  summary?: Maybe<Scalars['String']>;
  testOrders?: Maybe<Array<TestOrder>>;
  testOrdersCount?: Maybe<Scalars['Int']>;
  testsBatches?: Maybe<Array<TestsBatch>>;
  testsBatchesCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  vaccinations?: Maybe<Array<Vaccination>>;
  vaccinationsCount?: Maybe<Scalars['Int']>;
};


export type DoctorAppointmentRequestsArgs = {
  cursor?: Maybe<AppointmentRequestWhereUniqueInput>;
  orderBy?: Array<AppointmentRequestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentRequestWhereInput;
};


export type DoctorAppointmentRequestsCountArgs = {
  where?: AppointmentRequestWhereInput;
};


export type DoctorAppointmentSessionsArgs = {
  cursor?: Maybe<AppointmentSessionWhereUniqueInput>;
  orderBy?: Array<AppointmentSessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentSessionWhereInput;
};


export type DoctorAppointmentSessionsCountArgs = {
  where?: AppointmentSessionWhereInput;
};


export type DoctorAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  orderBy?: Array<AppointmentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentWhereInput;
};


export type DoctorAppointmentsCountArgs = {
  where?: AppointmentWhereInput;
};


export type DoctorBillingsArgs = {
  cursor?: Maybe<AppointmentBillingWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingWhereInput;
};


export type DoctorBillingsCountArgs = {
  where?: AppointmentBillingWhereInput;
};


export type DoctorBookingsArgs = {
  cursor?: Maybe<BookingWhereUniqueInput>;
  orderBy?: Array<BookingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BookingWhereInput;
};


export type DoctorBookingsCountArgs = {
  where?: BookingWhereInput;
};


export type DoctorCalendarEventsArgs = {
  cursor?: Maybe<CalendarEventWhereUniqueInput>;
  orderBy?: Array<CalendarEventOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CalendarEventWhereInput;
};


export type DoctorCalendarEventsCountArgs = {
  where?: CalendarEventWhereInput;
};


export type DoctorCaringForPatientsArgs = {
  cursor?: Maybe<PatientWhereUniqueInput>;
  orderBy?: Array<PatientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PatientWhereInput;
};


export type DoctorCaringForPatientsCountArgs = {
  where?: PatientWhereInput;
};


export type DoctorDoctorSubSpecialtiesArgs = {
  cursor?: Maybe<DoctorSubSpecialtyWhereUniqueInput>;
  orderBy?: Array<DoctorSubSpecialtyOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorSubSpecialtyWhereInput;
};


export type DoctorDoctorSubSpecialtiesCountArgs = {
  where?: DoctorSubSpecialtyWhereInput;
};


export type DoctorDocumentsArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  orderBy?: Array<DocumentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DocumentWhereInput;
};


export type DoctorDocumentsCountArgs = {
  where?: DocumentWhereInput;
};


export type DoctorFaxesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type DoctorFaxesCountArgs = {
  where?: FaxWhereInput;
};


export type DoctorFormsArgs = {
  cursor?: Maybe<FormWhereUniqueInput>;
  orderBy?: Array<FormOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormWhereInput;
};


export type DoctorFormsCountArgs = {
  where?: FormWhereInput;
};


export type DoctorInteractedPatientsArgs = {
  cursor?: Maybe<PatientWhereUniqueInput>;
  orderBy?: Array<PatientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PatientWhereInput;
};


export type DoctorInteractedPatientsCountArgs = {
  where?: PatientWhereInput;
};


export type DoctorLanguagesArgs = {
  cursor?: Maybe<LanguageWhereUniqueInput>;
  orderBy?: Array<LanguageOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: LanguageWhereInput;
};


export type DoctorLanguagesCountArgs = {
  where?: LanguageWhereInput;
};


export type DoctorMedicationItemsArgs = {
  cursor?: Maybe<MedicationItemWhereUniqueInput>;
  orderBy?: Array<MedicationItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MedicationItemWhereInput;
};


export type DoctorMedicationItemsCountArgs = {
  where?: MedicationItemWhereInput;
};


export type DoctorPatientsArgs = {
  cursor?: Maybe<PatientWhereUniqueInput>;
  orderBy?: Array<PatientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PatientWhereInput;
};


export type DoctorPatientsCountArgs = {
  where?: PatientWhereInput;
};


export type DoctorPrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  orderBy?: Array<PrescriptionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PrescriptionWhereInput;
};


export type DoctorPrescriptionsCountArgs = {
  where?: PrescriptionWhereInput;
};


export type DoctorSavedByPatientsArgs = {
  cursor?: Maybe<PatientWhereUniqueInput>;
  orderBy?: Array<PatientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PatientWhereInput;
};


export type DoctorSavedByPatientsCountArgs = {
  where?: PatientWhereInput;
};


export type DoctorTestOrdersArgs = {
  cursor?: Maybe<TestOrderWhereUniqueInput>;
  orderBy?: Array<TestOrderOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TestOrderWhereInput;
};


export type DoctorTestOrdersCountArgs = {
  where?: TestOrderWhereInput;
};


export type DoctorTestsBatchesArgs = {
  cursor?: Maybe<TestsBatchWhereUniqueInput>;
  orderBy?: Array<TestsBatchOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TestsBatchWhereInput;
};


export type DoctorTestsBatchesCountArgs = {
  where?: TestsBatchWhereInput;
};


export type DoctorVaccinationsArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  orderBy?: Array<VaccinationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: VaccinationWhereInput;
};


export type DoctorVaccinationsCountArgs = {
  where?: VaccinationWhereInput;
};

export type DoctorCreateInput = {
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForCreateInput>;
  appointmentSessions?: Maybe<AppointmentSessionRelateToManyForCreateInput>;
  appointments?: Maybe<AppointmentRelateToManyForCreateInput>;
  billings?: Maybe<AppointmentBillingRelateToManyForCreateInput>;
  bookings?: Maybe<BookingRelateToManyForCreateInput>;
  calendar?: Maybe<CalendarRelateToOneForCreateInput>;
  calendarEvents?: Maybe<CalendarEventRelateToManyForCreateInput>;
  caringForPatients?: Maybe<PatientRelateToManyForCreateInput>;
  clinicFMN?: Maybe<Scalars['String']>;
  clinicFaxNumber?: Maybe<Scalars['String']>;
  clinicName?: Maybe<Scalars['String']>;
  clinicOHIPBillingCode?: Maybe<Scalars['String']>;
  clinicPhoneNumber?: Maybe<Scalars['String']>;
  clinicSLI?: Maybe<Scalars['String']>;
  contractSignedOn?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctorSince?: Maybe<Scalars['DateTime']>;
  doctorSpecialty?: Maybe<DoctorSpecialtyRelateToOneForCreateInput>;
  doctorSubSpecialties?: Maybe<DoctorSubSpecialtyRelateToManyForCreateInput>;
  documents?: Maybe<DocumentRelateToManyForCreateInput>;
  email?: Maybe<Scalars['String']>;
  faxes?: Maybe<FaxRelateToManyForCreateInput>;
  forms?: Maybe<FormRelateToManyForCreateInput>;
  interactedPatients?: Maybe<PatientRelateToManyForCreateInput>;
  isCompleteProfile?: Maybe<Scalars['Boolean']>;
  isGoSecureGranted?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<LanguageRelateToManyForCreateInput>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseProvider?: Maybe<Scalars['String']>;
  medicalLiabilityNumber?: Maybe<Scalars['String']>;
  medicalLiabilityProvider?: Maybe<Scalars['String']>;
  medicationItems?: Maybe<MedicationItemRelateToManyForCreateInput>;
  ohipGroup?: Maybe<Scalars['String']>;
  ohipPractitionerNumber?: Maybe<Scalars['String']>;
  ohipSpecialityCode?: Maybe<Scalars['String']>;
  patients?: Maybe<PatientRelateToManyForCreateInput>;
  prescriptions?: Maybe<PrescriptionRelateToManyForCreateInput>;
  proofOfIdentification?: Maybe<ProofOfIdentificationRelateToOneForCreateInput>;
  proofOfInsurance?: Maybe<ProofOfInsuranceRelateToOneForCreateInput>;
  proofOfLicense?: Maybe<ProofOfLicenseRelateToOneForCreateInput>;
  province?: Maybe<Scalars['String']>;
  savedByPatients?: Maybe<PatientRelateToManyForCreateInput>;
  signature?: Maybe<SignatureRelateToOneForCreateInput>;
  summary?: Maybe<Scalars['String']>;
  testOrders?: Maybe<TestOrderRelateToManyForCreateInput>;
  testsBatches?: Maybe<TestsBatchRelateToManyForCreateInput>;
  user?: Maybe<UserRelateToOneForCreateInput>;
  vaccinations?: Maybe<VaccinationRelateToManyForCreateInput>;
};

export type DoctorManyRelationFilter = {
  every?: Maybe<DoctorWhereInput>;
  none?: Maybe<DoctorWhereInput>;
  some?: Maybe<DoctorWhereInput>;
};

export type DoctorOrderByInput = {
  clinicFMN?: Maybe<OrderDirection>;
  clinicFaxNumber?: Maybe<OrderDirection>;
  clinicName?: Maybe<OrderDirection>;
  clinicOHIPBillingCode?: Maybe<OrderDirection>;
  clinicPhoneNumber?: Maybe<OrderDirection>;
  clinicSLI?: Maybe<OrderDirection>;
  contractSignedOn?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  doctorSince?: Maybe<OrderDirection>;
  email?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isCompleteProfile?: Maybe<OrderDirection>;
  isGoSecureGranted?: Maybe<OrderDirection>;
  isVerified?: Maybe<OrderDirection>;
  licenseNumber?: Maybe<OrderDirection>;
  licenseProvider?: Maybe<OrderDirection>;
  medicalLiabilityNumber?: Maybe<OrderDirection>;
  medicalLiabilityProvider?: Maybe<OrderDirection>;
  ohipGroup?: Maybe<OrderDirection>;
  ohipPractitionerNumber?: Maybe<OrderDirection>;
  ohipSpecialityCode?: Maybe<OrderDirection>;
  province?: Maybe<OrderDirection>;
  summary?: Maybe<OrderDirection>;
};

export type DoctorRelateToManyForCreateInput = {
  connect?: Maybe<Array<DoctorWhereUniqueInput>>;
  create?: Maybe<Array<DoctorCreateInput>>;
};

export type DoctorRelateToManyForUpdateInput = {
  connect?: Maybe<Array<DoctorWhereUniqueInput>>;
  create?: Maybe<Array<DoctorCreateInput>>;
  disconnect?: Maybe<Array<DoctorWhereUniqueInput>>;
  set?: Maybe<Array<DoctorWhereUniqueInput>>;
};

export type DoctorRelateToOneForCreateInput = {
  connect?: Maybe<DoctorWhereUniqueInput>;
  create?: Maybe<DoctorCreateInput>;
};

export type DoctorRelateToOneForUpdateInput = {
  connect?: Maybe<DoctorWhereUniqueInput>;
  create?: Maybe<DoctorCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type DoctorSpecialty = {
  __typename?: 'DoctorSpecialty';
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<Array<Doctor>>;
  doctorsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type DoctorSpecialtyDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type DoctorSpecialtyDoctorsCountArgs = {
  where?: DoctorWhereInput;
};

export type DoctorSpecialtyCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForCreateInput>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DoctorSpecialtyOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  value?: Maybe<OrderDirection>;
};

export type DoctorSpecialtyRelateToOneForCreateInput = {
  connect?: Maybe<DoctorSpecialtyWhereUniqueInput>;
  create?: Maybe<DoctorSpecialtyCreateInput>;
};

export type DoctorSpecialtyRelateToOneForUpdateInput = {
  connect?: Maybe<DoctorSpecialtyWhereUniqueInput>;
  create?: Maybe<DoctorSpecialtyCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type DoctorSpecialtyUpdateArgs = {
  data: DoctorSpecialtyUpdateInput;
  where: DoctorSpecialtyWhereUniqueInput;
};

export type DoctorSpecialtyUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForUpdateInput>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DoctorSpecialtyWhereInput = {
  AND?: Maybe<Array<DoctorSpecialtyWhereInput>>;
  NOT?: Maybe<Array<DoctorSpecialtyWhereInput>>;
  OR?: Maybe<Array<DoctorSpecialtyWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctors?: Maybe<DoctorManyRelationFilter>;
  id?: Maybe<IdFilter>;
  label?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type DoctorSpecialtyWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type DoctorSubSpecialty = {
  __typename?: 'DoctorSubSpecialty';
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<Array<Doctor>>;
  doctorsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type DoctorSubSpecialtyDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type DoctorSubSpecialtyDoctorsCountArgs = {
  where?: DoctorWhereInput;
};

export type DoctorSubSpecialtyCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForCreateInput>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DoctorSubSpecialtyManyRelationFilter = {
  every?: Maybe<DoctorSubSpecialtyWhereInput>;
  none?: Maybe<DoctorSubSpecialtyWhereInput>;
  some?: Maybe<DoctorSubSpecialtyWhereInput>;
};

export type DoctorSubSpecialtyOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  value?: Maybe<OrderDirection>;
};

export type DoctorSubSpecialtyRelateToManyForCreateInput = {
  connect?: Maybe<Array<DoctorSubSpecialtyWhereUniqueInput>>;
  create?: Maybe<Array<DoctorSubSpecialtyCreateInput>>;
};

export type DoctorSubSpecialtyRelateToManyForUpdateInput = {
  connect?: Maybe<Array<DoctorSubSpecialtyWhereUniqueInput>>;
  create?: Maybe<Array<DoctorSubSpecialtyCreateInput>>;
  disconnect?: Maybe<Array<DoctorSubSpecialtyWhereUniqueInput>>;
  set?: Maybe<Array<DoctorSubSpecialtyWhereUniqueInput>>;
};

export type DoctorSubSpecialtyUpdateArgs = {
  data: DoctorSubSpecialtyUpdateInput;
  where: DoctorSubSpecialtyWhereUniqueInput;
};

export type DoctorSubSpecialtyUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForUpdateInput>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DoctorSubSpecialtyWhereInput = {
  AND?: Maybe<Array<DoctorSubSpecialtyWhereInput>>;
  NOT?: Maybe<Array<DoctorSubSpecialtyWhereInput>>;
  OR?: Maybe<Array<DoctorSubSpecialtyWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctors?: Maybe<DoctorManyRelationFilter>;
  id?: Maybe<IdFilter>;
  label?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type DoctorSubSpecialtyWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type DoctorUpdateArgs = {
  data: DoctorUpdateInput;
  where: DoctorWhereUniqueInput;
};

export type DoctorUpdateInput = {
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForUpdateInput>;
  appointmentSessions?: Maybe<AppointmentSessionRelateToManyForUpdateInput>;
  appointments?: Maybe<AppointmentRelateToManyForUpdateInput>;
  billings?: Maybe<AppointmentBillingRelateToManyForUpdateInput>;
  bookings?: Maybe<BookingRelateToManyForUpdateInput>;
  calendar?: Maybe<CalendarRelateToOneForUpdateInput>;
  calendarEvents?: Maybe<CalendarEventRelateToManyForUpdateInput>;
  caringForPatients?: Maybe<PatientRelateToManyForUpdateInput>;
  clinicFMN?: Maybe<Scalars['String']>;
  clinicFaxNumber?: Maybe<Scalars['String']>;
  clinicName?: Maybe<Scalars['String']>;
  clinicOHIPBillingCode?: Maybe<Scalars['String']>;
  clinicPhoneNumber?: Maybe<Scalars['String']>;
  clinicSLI?: Maybe<Scalars['String']>;
  contractSignedOn?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctorSince?: Maybe<Scalars['DateTime']>;
  doctorSpecialty?: Maybe<DoctorSpecialtyRelateToOneForUpdateInput>;
  doctorSubSpecialties?: Maybe<DoctorSubSpecialtyRelateToManyForUpdateInput>;
  documents?: Maybe<DocumentRelateToManyForUpdateInput>;
  email?: Maybe<Scalars['String']>;
  faxes?: Maybe<FaxRelateToManyForUpdateInput>;
  forms?: Maybe<FormRelateToManyForUpdateInput>;
  interactedPatients?: Maybe<PatientRelateToManyForUpdateInput>;
  isCompleteProfile?: Maybe<Scalars['Boolean']>;
  isGoSecureGranted?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<LanguageRelateToManyForUpdateInput>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseProvider?: Maybe<Scalars['String']>;
  medicalLiabilityNumber?: Maybe<Scalars['String']>;
  medicalLiabilityProvider?: Maybe<Scalars['String']>;
  medicationItems?: Maybe<MedicationItemRelateToManyForUpdateInput>;
  ohipGroup?: Maybe<Scalars['String']>;
  ohipPractitionerNumber?: Maybe<Scalars['String']>;
  ohipSpecialityCode?: Maybe<Scalars['String']>;
  patients?: Maybe<PatientRelateToManyForUpdateInput>;
  prescriptions?: Maybe<PrescriptionRelateToManyForUpdateInput>;
  proofOfIdentification?: Maybe<ProofOfIdentificationRelateToOneForUpdateInput>;
  proofOfInsurance?: Maybe<ProofOfInsuranceRelateToOneForUpdateInput>;
  proofOfLicense?: Maybe<ProofOfLicenseRelateToOneForUpdateInput>;
  province?: Maybe<Scalars['String']>;
  savedByPatients?: Maybe<PatientRelateToManyForUpdateInput>;
  signature?: Maybe<SignatureRelateToOneForUpdateInput>;
  summary?: Maybe<Scalars['String']>;
  testOrders?: Maybe<TestOrderRelateToManyForUpdateInput>;
  testsBatches?: Maybe<TestsBatchRelateToManyForUpdateInput>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
  vaccinations?: Maybe<VaccinationRelateToManyForUpdateInput>;
};

export type DoctorWhereInput = {
  AND?: Maybe<Array<DoctorWhereInput>>;
  NOT?: Maybe<Array<DoctorWhereInput>>;
  OR?: Maybe<Array<DoctorWhereInput>>;
  appointmentRequests?: Maybe<AppointmentRequestManyRelationFilter>;
  appointmentSessions?: Maybe<AppointmentSessionManyRelationFilter>;
  appointments?: Maybe<AppointmentManyRelationFilter>;
  billings?: Maybe<AppointmentBillingManyRelationFilter>;
  bookings?: Maybe<BookingManyRelationFilter>;
  calendar?: Maybe<CalendarWhereInput>;
  calendarEvents?: Maybe<CalendarEventManyRelationFilter>;
  caringForPatients?: Maybe<PatientManyRelationFilter>;
  clinicFMN?: Maybe<StringFilter>;
  clinicFaxNumber?: Maybe<StringFilter>;
  clinicName?: Maybe<StringFilter>;
  clinicOHIPBillingCode?: Maybe<StringFilter>;
  clinicPhoneNumber?: Maybe<StringFilter>;
  clinicSLI?: Maybe<StringFilter>;
  contractSignedOn?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctorSince?: Maybe<DateTimeNullableFilter>;
  doctorSpecialty?: Maybe<DoctorSpecialtyWhereInput>;
  doctorSubSpecialties?: Maybe<DoctorSubSpecialtyManyRelationFilter>;
  documents?: Maybe<DocumentManyRelationFilter>;
  email?: Maybe<StringFilter>;
  faxes?: Maybe<FaxManyRelationFilter>;
  forms?: Maybe<FormManyRelationFilter>;
  id?: Maybe<IdFilter>;
  interactedPatients?: Maybe<PatientManyRelationFilter>;
  isCompleteProfile?: Maybe<BooleanFilter>;
  isGoSecureGranted?: Maybe<BooleanFilter>;
  isVerified?: Maybe<BooleanFilter>;
  languages?: Maybe<LanguageManyRelationFilter>;
  licenseNumber?: Maybe<StringFilter>;
  licenseProvider?: Maybe<StringFilter>;
  medicalLiabilityNumber?: Maybe<StringFilter>;
  medicalLiabilityProvider?: Maybe<StringFilter>;
  medicationItems?: Maybe<MedicationItemManyRelationFilter>;
  ohipGroup?: Maybe<StringFilter>;
  ohipPractitionerNumber?: Maybe<StringFilter>;
  ohipSpecialityCode?: Maybe<StringFilter>;
  patients?: Maybe<PatientManyRelationFilter>;
  prescriptions?: Maybe<PrescriptionManyRelationFilter>;
  proofOfIdentification?: Maybe<ProofOfIdentificationWhereInput>;
  proofOfInsurance?: Maybe<ProofOfInsuranceWhereInput>;
  proofOfLicense?: Maybe<ProofOfLicenseWhereInput>;
  province?: Maybe<StringFilter>;
  savedByPatients?: Maybe<PatientManyRelationFilter>;
  signature?: Maybe<SignatureWhereInput>;
  summary?: Maybe<StringFilter>;
  testOrders?: Maybe<TestOrderManyRelationFilter>;
  testsBatches?: Maybe<TestsBatchManyRelationFilter>;
  user?: Maybe<UserWhereInput>;
  vaccinations?: Maybe<VaccinationManyRelationFilter>;
};

export type DoctorWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Document = {
  __typename?: 'Document';
  addedAt?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<FileFieldOutput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  file?: Maybe<File>;
  form?: Maybe<Form>;
  id: Scalars['ID'];
  patient?: Maybe<Patient>;
  title?: Maybe<Scalars['String']>;
};

export type DocumentCreateInput = {
  addedAt?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<FileFieldInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  form?: Maybe<FormRelateToOneForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  title?: Maybe<Scalars['String']>;
};

export type DocumentManyRelationFilter = {
  every?: Maybe<DocumentWhereInput>;
  none?: Maybe<DocumentWhereInput>;
  some?: Maybe<DocumentWhereInput>;
};

export type DocumentOrderByInput = {
  addedAt?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
};

export type DocumentRelateToManyForCreateInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  create?: Maybe<Array<DocumentCreateInput>>;
};

export type DocumentRelateToManyForUpdateInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  create?: Maybe<Array<DocumentCreateInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
};

export type DocumentRelateToOneForCreateInput = {
  connect?: Maybe<DocumentWhereUniqueInput>;
  create?: Maybe<DocumentCreateInput>;
};

export type DocumentRelateToOneForUpdateInput = {
  connect?: Maybe<DocumentWhereUniqueInput>;
  create?: Maybe<DocumentCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type DocumentUpdateArgs = {
  data: DocumentUpdateInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateInput = {
  addedAt?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<FileFieldInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  form?: Maybe<FormRelateToOneForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  title?: Maybe<Scalars['String']>;
};

export type DocumentWhereInput = {
  AND?: Maybe<Array<DocumentWhereInput>>;
  NOT?: Maybe<Array<DocumentWhereInput>>;
  OR?: Maybe<Array<DocumentWhereInput>>;
  addedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  file?: Maybe<FileWhereInput>;
  form?: Maybe<FormWhereInput>;
  id?: Maybe<IdFilter>;
  patient?: Maybe<PatientWhereInput>;
  title?: Maybe<StringFilter>;
};

export type DocumentWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homePhoneNumberString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  relation?: Maybe<Scalars['String']>;
};

export type EmergencyContactCreateInput = {
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homePhoneNumberString?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  relation?: Maybe<Scalars['String']>;
};

export type EmergencyContactManyRelationFilter = {
  every?: Maybe<EmergencyContactWhereInput>;
  none?: Maybe<EmergencyContactWhereInput>;
  some?: Maybe<EmergencyContactWhereInput>;
};

export type EmergencyContactOrderByInput = {
  cellPhoneNumberString?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  email?: Maybe<OrderDirection>;
  firstName?: Maybe<OrderDirection>;
  homePhoneNumberString?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  lastName?: Maybe<OrderDirection>;
  relation?: Maybe<OrderDirection>;
};

export type EmergencyContactRelateToManyForCreateInput = {
  connect?: Maybe<Array<EmergencyContactWhereUniqueInput>>;
  create?: Maybe<Array<EmergencyContactCreateInput>>;
};

export type EmergencyContactRelateToManyForUpdateInput = {
  connect?: Maybe<Array<EmergencyContactWhereUniqueInput>>;
  create?: Maybe<Array<EmergencyContactCreateInput>>;
  disconnect?: Maybe<Array<EmergencyContactWhereUniqueInput>>;
  set?: Maybe<Array<EmergencyContactWhereUniqueInput>>;
};

export type EmergencyContactUpdateArgs = {
  data: EmergencyContactUpdateInput;
  where: EmergencyContactWhereUniqueInput;
};

export type EmergencyContactUpdateInput = {
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homePhoneNumberString?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  relation?: Maybe<Scalars['String']>;
};

export type EmergencyContactWhereInput = {
  AND?: Maybe<Array<EmergencyContactWhereInput>>;
  NOT?: Maybe<Array<EmergencyContactWhereInput>>;
  OR?: Maybe<Array<EmergencyContactWhereInput>>;
  cellPhoneNumberString?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  email?: Maybe<StringFilter>;
  firstName?: Maybe<StringFilter>;
  homePhoneNumberString?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  lastName?: Maybe<StringFilter>;
  patient?: Maybe<PatientWhereInput>;
  relation?: Maybe<StringFilter>;
};

export type EmergencyContactWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Fax = {
  __typename?: 'Fax';
  appointment?: Maybe<Appointment>;
  attachment?: Maybe<FileFieldOutput>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  faxBlastItem?: Maybe<FaxBlastItem>;
  file?: Maybe<File>;
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  patient?: Maybe<Patient>;
  pharmacyLocation?: Maybe<PharmacyLocation>;
  replyTo?: Maybe<InboundFax>;
  sentBy?: Maybe<Member>;
  status?: Maybe<FaxStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  telnyxFaxId?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type FaxBlast = {
  __typename?: 'FaxBlast';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  faxBlastItems?: Maybe<Array<FaxBlastItem>>;
  faxBlastItemsCount?: Maybe<Scalars['Int']>;
  file?: Maybe<File>;
  id: Scalars['ID'];
  latestProcessedCount?: Maybe<Scalars['Int']>;
  latestProcessingCount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};


export type FaxBlastFaxBlastItemsArgs = {
  cursor?: Maybe<FaxBlastItemWhereUniqueInput>;
  orderBy?: Array<FaxBlastItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxBlastItemWhereInput;
};


export type FaxBlastFaxBlastItemsCountArgs = {
  where?: FaxBlastItemWhereInput;
};

export type FaxBlastCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  faxBlastItems?: Maybe<FaxBlastItemRelateToManyForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  latestProcessedCount?: Maybe<Scalars['Int']>;
  latestProcessingCount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type FaxBlastItem = {
  __typename?: 'FaxBlastItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  fax?: Maybe<Fax>;
  faxBlast?: Maybe<FaxBlast>;
  faxRecipient?: Maybe<FaxRecipient>;
  file?: Maybe<File>;
  id: Scalars['ID'];
};

export type FaxBlastItemCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fax?: Maybe<FaxRelateToOneForCreateInput>;
  faxBlast?: Maybe<FaxBlastRelateToOneForCreateInput>;
  faxRecipient?: Maybe<FaxRecipientRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
};

export type FaxBlastItemManyRelationFilter = {
  every?: Maybe<FaxBlastItemWhereInput>;
  none?: Maybe<FaxBlastItemWhereInput>;
  some?: Maybe<FaxBlastItemWhereInput>;
};

export type FaxBlastItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type FaxBlastItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<FaxBlastItemWhereUniqueInput>>;
  create?: Maybe<Array<FaxBlastItemCreateInput>>;
};

export type FaxBlastItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<FaxBlastItemWhereUniqueInput>>;
  create?: Maybe<Array<FaxBlastItemCreateInput>>;
  disconnect?: Maybe<Array<FaxBlastItemWhereUniqueInput>>;
  set?: Maybe<Array<FaxBlastItemWhereUniqueInput>>;
};

export type FaxBlastItemRelateToOneForCreateInput = {
  connect?: Maybe<FaxBlastItemWhereUniqueInput>;
  create?: Maybe<FaxBlastItemCreateInput>;
};

export type FaxBlastItemRelateToOneForUpdateInput = {
  connect?: Maybe<FaxBlastItemWhereUniqueInput>;
  create?: Maybe<FaxBlastItemCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type FaxBlastItemUpdateArgs = {
  data: FaxBlastItemUpdateInput;
  where: FaxBlastItemWhereUniqueInput;
};

export type FaxBlastItemUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  fax?: Maybe<FaxRelateToOneForUpdateInput>;
  faxBlast?: Maybe<FaxBlastRelateToOneForUpdateInput>;
  faxRecipient?: Maybe<FaxRecipientRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
};

export type FaxBlastItemWhereInput = {
  AND?: Maybe<Array<FaxBlastItemWhereInput>>;
  NOT?: Maybe<Array<FaxBlastItemWhereInput>>;
  OR?: Maybe<Array<FaxBlastItemWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  fax?: Maybe<FaxWhereInput>;
  faxBlast?: Maybe<FaxBlastWhereInput>;
  faxRecipient?: Maybe<FaxRecipientWhereInput>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
};

export type FaxBlastItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type FaxBlastManyRelationFilter = {
  every?: Maybe<FaxBlastWhereInput>;
  none?: Maybe<FaxBlastWhereInput>;
  some?: Maybe<FaxBlastWhereInput>;
};

export type FaxBlastOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  latestProcessedCount?: Maybe<OrderDirection>;
  latestProcessingCount?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
};

export type FaxBlastRelateToManyForCreateInput = {
  connect?: Maybe<Array<FaxBlastWhereUniqueInput>>;
  create?: Maybe<Array<FaxBlastCreateInput>>;
};

export type FaxBlastRelateToManyForUpdateInput = {
  connect?: Maybe<Array<FaxBlastWhereUniqueInput>>;
  create?: Maybe<Array<FaxBlastCreateInput>>;
  disconnect?: Maybe<Array<FaxBlastWhereUniqueInput>>;
  set?: Maybe<Array<FaxBlastWhereUniqueInput>>;
};

export type FaxBlastRelateToOneForCreateInput = {
  connect?: Maybe<FaxBlastWhereUniqueInput>;
  create?: Maybe<FaxBlastCreateInput>;
};

export type FaxBlastRelateToOneForUpdateInput = {
  connect?: Maybe<FaxBlastWhereUniqueInput>;
  create?: Maybe<FaxBlastCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type FaxBlastUpdateArgs = {
  data: FaxBlastUpdateInput;
  where: FaxBlastWhereUniqueInput;
};

export type FaxBlastUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  faxBlastItems?: Maybe<FaxBlastItemRelateToManyForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  latestProcessedCount?: Maybe<Scalars['Int']>;
  latestProcessingCount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type FaxBlastWhereInput = {
  AND?: Maybe<Array<FaxBlastWhereInput>>;
  NOT?: Maybe<Array<FaxBlastWhereInput>>;
  OR?: Maybe<Array<FaxBlastWhereInput>>;
  author?: Maybe<UserWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  faxBlastItems?: Maybe<FaxBlastItemManyRelationFilter>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
  latestProcessedCount?: Maybe<IntNullableFilter>;
  latestProcessingCount?: Maybe<IntNullableFilter>;
  title?: Maybe<StringFilter>;
};

export type FaxBlastWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type FaxCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  attachment?: Maybe<FileFieldInput>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  faxBlastItem?: Maybe<FaxBlastItemRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  from?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  pharmacyLocation?: Maybe<PharmacyLocationRelateToOneForCreateInput>;
  replyTo?: Maybe<InboundFaxRelateToOneForCreateInput>;
  sentBy?: Maybe<MemberRelateToOneForCreateInput>;
  status?: Maybe<FaxStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  telnyxFaxId?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type FaxManyRelationFilter = {
  every?: Maybe<FaxWhereInput>;
  none?: Maybe<FaxWhereInput>;
  some?: Maybe<FaxWhereInput>;
};

export type FaxOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  from?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
  statusMessage?: Maybe<OrderDirection>;
  telnyxFaxId?: Maybe<OrderDirection>;
  to?: Maybe<OrderDirection>;
};

export type FaxRecipient = {
  __typename?: 'FaxRecipient';
  cpsoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxBlastItems?: Maybe<Array<FaxBlastItem>>;
  faxBlastItemsCount?: Maybe<Scalars['Int']>;
  faxNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isUnsubscribed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
};


export type FaxRecipientFaxBlastItemsArgs = {
  cursor?: Maybe<FaxBlastItemWhereUniqueInput>;
  orderBy?: Array<FaxBlastItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxBlastItemWhereInput;
};


export type FaxRecipientFaxBlastItemsCountArgs = {
  where?: FaxBlastItemWhereInput;
};

export type FaxRecipientCreateInput = {
  cpsoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxBlastItems?: Maybe<FaxBlastItemRelateToManyForCreateInput>;
  faxNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isUnsubscribed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
};

export type FaxRecipientOrderByInput = {
  cpsoId?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  faxNumber?: Maybe<OrderDirection>;
  firstName?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isUnsubscribed?: Maybe<OrderDirection>;
  lastName?: Maybe<OrderDirection>;
  unsubscribedAt?: Maybe<OrderDirection>;
};

export type FaxRecipientRelateToOneForCreateInput = {
  connect?: Maybe<FaxRecipientWhereUniqueInput>;
  create?: Maybe<FaxRecipientCreateInput>;
};

export type FaxRecipientRelateToOneForUpdateInput = {
  connect?: Maybe<FaxRecipientWhereUniqueInput>;
  create?: Maybe<FaxRecipientCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type FaxRecipientUpdateArgs = {
  data: FaxRecipientUpdateInput;
  where: FaxRecipientWhereUniqueInput;
};

export type FaxRecipientUpdateInput = {
  cpsoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxBlastItems?: Maybe<FaxBlastItemRelateToManyForUpdateInput>;
  faxNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isUnsubscribed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
};

export type FaxRecipientWhereInput = {
  AND?: Maybe<Array<FaxRecipientWhereInput>>;
  NOT?: Maybe<Array<FaxRecipientWhereInput>>;
  OR?: Maybe<Array<FaxRecipientWhereInput>>;
  cpsoId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  faxBlastItems?: Maybe<FaxBlastItemManyRelationFilter>;
  faxNumber?: Maybe<StringFilter>;
  firstName?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  isUnsubscribed?: Maybe<BooleanFilter>;
  lastName?: Maybe<StringFilter>;
  unsubscribedAt?: Maybe<DateTimeNullableFilter>;
};

export type FaxRecipientWhereUniqueInput = {
  cpsoId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type FaxRelateToManyForCreateInput = {
  connect?: Maybe<Array<FaxWhereUniqueInput>>;
  create?: Maybe<Array<FaxCreateInput>>;
};

export type FaxRelateToManyForUpdateInput = {
  connect?: Maybe<Array<FaxWhereUniqueInput>>;
  create?: Maybe<Array<FaxCreateInput>>;
  disconnect?: Maybe<Array<FaxWhereUniqueInput>>;
  set?: Maybe<Array<FaxWhereUniqueInput>>;
};

export type FaxRelateToOneForCreateInput = {
  connect?: Maybe<FaxWhereUniqueInput>;
  create?: Maybe<FaxCreateInput>;
};

export type FaxRelateToOneForUpdateInput = {
  connect?: Maybe<FaxWhereUniqueInput>;
  create?: Maybe<FaxCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export enum FaxStatusType {
  Failed = 'failed',
  Processing = 'processing',
  Queued = 'queued',
  Successful = 'successful'
}

export type FaxStatusTypeNullableFilter = {
  equals?: Maybe<FaxStatusType>;
  in?: Maybe<Array<FaxStatusType>>;
  not?: Maybe<FaxStatusTypeNullableFilter>;
  notIn?: Maybe<Array<FaxStatusType>>;
};

export type FaxUpdateArgs = {
  data: FaxUpdateInput;
  where: FaxWhereUniqueInput;
};

export type FaxUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  attachment?: Maybe<FileFieldInput>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  faxBlastItem?: Maybe<FaxBlastItemRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  from?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  pharmacyLocation?: Maybe<PharmacyLocationRelateToOneForUpdateInput>;
  replyTo?: Maybe<InboundFaxRelateToOneForUpdateInput>;
  sentBy?: Maybe<MemberRelateToOneForUpdateInput>;
  status?: Maybe<FaxStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  telnyxFaxId?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type FaxWhereInput = {
  AND?: Maybe<Array<FaxWhereInput>>;
  NOT?: Maybe<Array<FaxWhereInput>>;
  OR?: Maybe<Array<FaxWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  faxBlastItem?: Maybe<FaxBlastItemWhereInput>;
  file?: Maybe<FileWhereInput>;
  from?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  patient?: Maybe<PatientWhereInput>;
  pharmacyLocation?: Maybe<PharmacyLocationWhereInput>;
  replyTo?: Maybe<InboundFaxWhereInput>;
  sentBy?: Maybe<MemberWhereInput>;
  status?: Maybe<FaxStatusTypeNullableFilter>;
  statusMessage?: Maybe<StringFilter>;
  telnyxFaxId?: Maybe<StringFilter>;
  to?: Maybe<StringFilter>;
};

export type FaxWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type FeedbackItem = {
  __typename?: 'FeedbackItem';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  summary?: Maybe<Scalars['String']>;
};

export type FeedbackItemCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
};

export type FeedbackItemManyRelationFilter = {
  every?: Maybe<FeedbackItemWhereInput>;
  none?: Maybe<FeedbackItemWhereInput>;
  some?: Maybe<FeedbackItemWhereInput>;
};

export type FeedbackItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  summary?: Maybe<OrderDirection>;
};

export type FeedbackItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<FeedbackItemWhereUniqueInput>>;
  create?: Maybe<Array<FeedbackItemCreateInput>>;
};

export type FeedbackItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<FeedbackItemWhereUniqueInput>>;
  create?: Maybe<Array<FeedbackItemCreateInput>>;
  disconnect?: Maybe<Array<FeedbackItemWhereUniqueInput>>;
  set?: Maybe<Array<FeedbackItemWhereUniqueInput>>;
};

export type FeedbackItemUpdateArgs = {
  data: FeedbackItemUpdateInput;
  where: FeedbackItemWhereUniqueInput;
};

export type FeedbackItemUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
};

export type FeedbackItemWhereInput = {
  AND?: Maybe<Array<FeedbackItemWhereInput>>;
  NOT?: Maybe<Array<FeedbackItemWhereInput>>;
  OR?: Maybe<Array<FeedbackItemWhereInput>>;
  author?: Maybe<UserWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  summary?: Maybe<StringFilter>;
};

export type FeedbackItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type File = {
  __typename?: 'File';
  archiveItem?: Maybe<ArchiveItem>;
  createdAt?: Maybe<Scalars['DateTime']>;
  document?: Maybe<Document>;
  fax?: Maybe<Fax>;
  faxBlast?: Maybe<FaxBlast>;
  faxBlastItem?: Maybe<FaxBlastItem>;
  fileKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inboundFax?: Maybe<InboundFax>;
  leaseAgreement?: Maybe<LeaseAgreement>;
  masterLicense?: Maybe<MasterLicense>;
  owner?: Maybe<User>;
  proofOfIdentification?: Maybe<ProofOfIdentification>;
  proofOfInsurance?: Maybe<ProofOfInsurance>;
  proofOfLicense?: Maybe<ProofOfLicense>;
  signature?: Maybe<Signature>;
};

export type FileCreateInput = {
  archiveItem?: Maybe<ArchiveItemRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  document?: Maybe<DocumentRelateToOneForCreateInput>;
  fax?: Maybe<FaxRelateToOneForCreateInput>;
  faxBlast?: Maybe<FaxBlastRelateToOneForCreateInput>;
  faxBlastItem?: Maybe<FaxBlastItemRelateToOneForCreateInput>;
  fileKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  inboundFax?: Maybe<InboundFaxRelateToOneForCreateInput>;
  leaseAgreement?: Maybe<LeaseAgreementRelateToOneForCreateInput>;
  masterLicense?: Maybe<MasterLicenseRelateToOneForCreateInput>;
  owner?: Maybe<UserRelateToOneForCreateInput>;
  proofOfIdentification?: Maybe<ProofOfIdentificationRelateToOneForCreateInput>;
  proofOfInsurance?: Maybe<ProofOfInsuranceRelateToOneForCreateInput>;
  proofOfLicense?: Maybe<ProofOfLicenseRelateToOneForCreateInput>;
  signature?: Maybe<SignatureRelateToOneForCreateInput>;
};

export type FileFieldInput = {
  upload: Scalars['Upload'];
};

export type FileFieldOutput = {
  __typename?: 'FileFieldOutput';
  filename: Scalars['String'];
  filesize: Scalars['Int'];
  url: Scalars['String'];
};

export type FileManyRelationFilter = {
  every?: Maybe<FileWhereInput>;
  none?: Maybe<FileWhereInput>;
  some?: Maybe<FileWhereInput>;
};

export type FileOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  fileKey?: Maybe<OrderDirection>;
  fileName?: Maybe<OrderDirection>;
  fileSize?: Maybe<OrderDirection>;
  fileType?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type FileRelateToManyForCreateInput = {
  connect?: Maybe<Array<FileWhereUniqueInput>>;
  create?: Maybe<Array<FileCreateInput>>;
};

export type FileRelateToManyForUpdateInput = {
  connect?: Maybe<Array<FileWhereUniqueInput>>;
  create?: Maybe<Array<FileCreateInput>>;
  disconnect?: Maybe<Array<FileWhereUniqueInput>>;
  set?: Maybe<Array<FileWhereUniqueInput>>;
};

export type FileRelateToOneForCreateInput = {
  connect?: Maybe<FileWhereUniqueInput>;
  create?: Maybe<FileCreateInput>;
};

export type FileRelateToOneForUpdateInput = {
  connect?: Maybe<FileWhereUniqueInput>;
  create?: Maybe<FileCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type FileUpdateArgs = {
  data: FileUpdateInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateInput = {
  archiveItem?: Maybe<ArchiveItemRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  document?: Maybe<DocumentRelateToOneForUpdateInput>;
  fax?: Maybe<FaxRelateToOneForUpdateInput>;
  faxBlast?: Maybe<FaxBlastRelateToOneForUpdateInput>;
  faxBlastItem?: Maybe<FaxBlastItemRelateToOneForUpdateInput>;
  fileKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  inboundFax?: Maybe<InboundFaxRelateToOneForUpdateInput>;
  leaseAgreement?: Maybe<LeaseAgreementRelateToOneForUpdateInput>;
  masterLicense?: Maybe<MasterLicenseRelateToOneForUpdateInput>;
  owner?: Maybe<UserRelateToOneForUpdateInput>;
  proofOfIdentification?: Maybe<ProofOfIdentificationRelateToOneForUpdateInput>;
  proofOfInsurance?: Maybe<ProofOfInsuranceRelateToOneForUpdateInput>;
  proofOfLicense?: Maybe<ProofOfLicenseRelateToOneForUpdateInput>;
  signature?: Maybe<SignatureRelateToOneForUpdateInput>;
};

export type FileWhereInput = {
  AND?: Maybe<Array<FileWhereInput>>;
  NOT?: Maybe<Array<FileWhereInput>>;
  OR?: Maybe<Array<FileWhereInput>>;
  archiveItem?: Maybe<ArchiveItemWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  document?: Maybe<DocumentWhereInput>;
  fax?: Maybe<FaxWhereInput>;
  faxBlast?: Maybe<FaxBlastWhereInput>;
  faxBlastItem?: Maybe<FaxBlastItemWhereInput>;
  fileKey?: Maybe<StringFilter>;
  fileName?: Maybe<StringFilter>;
  fileSize?: Maybe<IntNullableFilter>;
  fileType?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  inboundFax?: Maybe<InboundFaxWhereInput>;
  leaseAgreement?: Maybe<LeaseAgreementWhereInput>;
  masterLicense?: Maybe<MasterLicenseWhereInput>;
  owner?: Maybe<UserWhereInput>;
  proofOfIdentification?: Maybe<ProofOfIdentificationWhereInput>;
  proofOfInsurance?: Maybe<ProofOfInsuranceWhereInput>;
  proofOfLicense?: Maybe<ProofOfLicenseWhereInput>;
  signature?: Maybe<SignatureWhereInput>;
};

export type FileWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type FloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<FloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type Form = {
  __typename?: 'Form';
  appointment?: Maybe<Appointment>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  document?: Maybe<Document>;
  formFields?: Maybe<Scalars['JSON']>;
  formType?: Maybe<FormType>;
  id: Scalars['ID'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  slug?: Maybe<Scalars['String']>;
};

export type FormCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  document?: Maybe<DocumentRelateToOneForCreateInput>;
  formFields?: Maybe<Scalars['JSON']>;
  formType?: Maybe<FormTypeRelateToOneForCreateInput>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  slug?: Maybe<Scalars['String']>;
};

export type FormManyRelationFilter = {
  every?: Maybe<FormWhereInput>;
  none?: Maybe<FormWhereInput>;
  some?: Maybe<FormWhereInput>;
};

export type FormOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  issuedAt?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  slug?: Maybe<OrderDirection>;
};

export type FormRelateToManyForCreateInput = {
  connect?: Maybe<Array<FormWhereUniqueInput>>;
  create?: Maybe<Array<FormCreateInput>>;
};

export type FormRelateToManyForUpdateInput = {
  connect?: Maybe<Array<FormWhereUniqueInput>>;
  create?: Maybe<Array<FormCreateInput>>;
  disconnect?: Maybe<Array<FormWhereUniqueInput>>;
  set?: Maybe<Array<FormWhereUniqueInput>>;
};

export type FormRelateToOneForCreateInput = {
  connect?: Maybe<FormWhereUniqueInput>;
  create?: Maybe<FormCreateInput>;
};

export type FormRelateToOneForUpdateInput = {
  connect?: Maybe<FormWhereUniqueInput>;
  create?: Maybe<FormCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type FormTest = {
  __typename?: 'FormTest';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  testFor?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FormTestCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  label?: Maybe<Scalars['String']>;
  testFor?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FormTestManyRelationFilter = {
  every?: Maybe<FormTestWhereInput>;
  none?: Maybe<FormTestWhereInput>;
  some?: Maybe<FormTestWhereInput>;
};

export type FormTestOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  testFor?: Maybe<OrderDirection>;
  value?: Maybe<OrderDirection>;
};

export type FormTestRelateToManyForCreateInput = {
  connect?: Maybe<Array<FormTestWhereUniqueInput>>;
  create?: Maybe<Array<FormTestCreateInput>>;
};

export type FormTestRelateToManyForUpdateInput = {
  connect?: Maybe<Array<FormTestWhereUniqueInput>>;
  create?: Maybe<Array<FormTestCreateInput>>;
  disconnect?: Maybe<Array<FormTestWhereUniqueInput>>;
  set?: Maybe<Array<FormTestWhereUniqueInput>>;
};

export type FormTestUpdateArgs = {
  data: FormTestUpdateInput;
  where: FormTestWhereUniqueInput;
};

export type FormTestUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  label?: Maybe<Scalars['String']>;
  testFor?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FormTestWhereInput = {
  AND?: Maybe<Array<FormTestWhereInput>>;
  NOT?: Maybe<Array<FormTestWhereInput>>;
  OR?: Maybe<Array<FormTestWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  label?: Maybe<StringFilter>;
  testFor?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type FormTestWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type FormType = {
  __typename?: 'FormType';
  createdAt?: Maybe<Scalars['DateTime']>;
  forms?: Maybe<Array<Form>>;
  formsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  testsBatches?: Maybe<Array<TestsBatch>>;
  testsBatchesCount?: Maybe<Scalars['Int']>;
};


export type FormTypeFormsArgs = {
  cursor?: Maybe<FormWhereUniqueInput>;
  orderBy?: Array<FormOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormWhereInput;
};


export type FormTypeFormsCountArgs = {
  where?: FormWhereInput;
};


export type FormTypeTestsBatchesArgs = {
  cursor?: Maybe<TestsBatchWhereUniqueInput>;
  orderBy?: Array<TestsBatchOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TestsBatchWhereInput;
};


export type FormTypeTestsBatchesCountArgs = {
  where?: TestsBatchWhereInput;
};

export type FormTypeCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  forms?: Maybe<FormRelateToManyForCreateInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  testsBatches?: Maybe<TestsBatchRelateToManyForCreateInput>;
};

export type FormTypeOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  slug?: Maybe<OrderDirection>;
};

export type FormTypeRelateToOneForCreateInput = {
  connect?: Maybe<FormTypeWhereUniqueInput>;
  create?: Maybe<FormTypeCreateInput>;
};

export type FormTypeRelateToOneForUpdateInput = {
  connect?: Maybe<FormTypeWhereUniqueInput>;
  create?: Maybe<FormTypeCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type FormTypeUpdateArgs = {
  data: FormTypeUpdateInput;
  where: FormTypeWhereUniqueInput;
};

export type FormTypeUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  forms?: Maybe<FormRelateToManyForUpdateInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  testsBatches?: Maybe<TestsBatchRelateToManyForUpdateInput>;
};

export type FormTypeWhereInput = {
  AND?: Maybe<Array<FormTypeWhereInput>>;
  NOT?: Maybe<Array<FormTypeWhereInput>>;
  OR?: Maybe<Array<FormTypeWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  forms?: Maybe<FormManyRelationFilter>;
  id?: Maybe<IdFilter>;
  isActive?: Maybe<BooleanFilter>;
  name?: Maybe<StringFilter>;
  slug?: Maybe<StringFilter>;
  testsBatches?: Maybe<TestsBatchManyRelationFilter>;
};

export type FormTypeWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type FormUpdateArgs = {
  data: FormUpdateInput;
  where: FormWhereUniqueInput;
};

export type FormUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  document?: Maybe<DocumentRelateToOneForUpdateInput>;
  formFields?: Maybe<Scalars['JSON']>;
  formType?: Maybe<FormTypeRelateToOneForUpdateInput>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  slug?: Maybe<Scalars['String']>;
};

export type FormWhereInput = {
  AND?: Maybe<Array<FormWhereInput>>;
  NOT?: Maybe<Array<FormWhereInput>>;
  OR?: Maybe<Array<FormWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  document?: Maybe<DocumentWhereInput>;
  formType?: Maybe<FormTypeWhereInput>;
  id?: Maybe<IdFilter>;
  issuedAt?: Maybe<DateTimeNullableFilter>;
  name?: Maybe<StringFilter>;
  patient?: Maybe<PatientWhereInput>;
  slug?: Maybe<StringFilter>;
};

export type FormWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type HealthCard = {
  __typename?: 'HealthCard';
  createdAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  insurancePolicyNumber?: Maybe<Scalars['String']>;
  insuranceProvider?: Maybe<Scalars['String']>;
  isValid?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<Patient>;
  stateDescriptor?: Maybe<Scalars['String']>;
  userInvite?: Maybe<UserInvite>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validationCode?: Maybe<Scalars['String']>;
  versionCode?: Maybe<Scalars['String']>;
};

export type HealthCardCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  insurancePolicyNumber?: Maybe<Scalars['String']>;
  insuranceProvider?: Maybe<Scalars['String']>;
  isValid?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  stateDescriptor?: Maybe<Scalars['String']>;
  userInvite?: Maybe<UserInviteRelateToOneForCreateInput>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validationCode?: Maybe<Scalars['String']>;
  versionCode?: Maybe<Scalars['String']>;
};

export type HealthCardManyRelationFilter = {
  every?: Maybe<HealthCardWhereInput>;
  none?: Maybe<HealthCardWhereInput>;
  some?: Maybe<HealthCardWhereInput>;
};

export type HealthCardOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  expiryDate?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  insurancePolicyNumber?: Maybe<OrderDirection>;
  insuranceProvider?: Maybe<OrderDirection>;
  isValid?: Maybe<OrderDirection>;
  stateDescriptor?: Maybe<OrderDirection>;
  validatedAt?: Maybe<OrderDirection>;
  validationCode?: Maybe<OrderDirection>;
  versionCode?: Maybe<OrderDirection>;
};

export type HealthCardRelateToManyForCreateInput = {
  connect?: Maybe<Array<HealthCardWhereUniqueInput>>;
  create?: Maybe<Array<HealthCardCreateInput>>;
};

export type HealthCardRelateToManyForUpdateInput = {
  connect?: Maybe<Array<HealthCardWhereUniqueInput>>;
  create?: Maybe<Array<HealthCardCreateInput>>;
  disconnect?: Maybe<Array<HealthCardWhereUniqueInput>>;
  set?: Maybe<Array<HealthCardWhereUniqueInput>>;
};

export type HealthCardRelateToOneForCreateInput = {
  connect?: Maybe<HealthCardWhereUniqueInput>;
  create?: Maybe<HealthCardCreateInput>;
};

export type HealthCardRelateToOneForUpdateInput = {
  connect?: Maybe<HealthCardWhereUniqueInput>;
  create?: Maybe<HealthCardCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type HealthCardUpdateArgs = {
  data: HealthCardUpdateInput;
  where: HealthCardWhereUniqueInput;
};

export type HealthCardUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  insurancePolicyNumber?: Maybe<Scalars['String']>;
  insuranceProvider?: Maybe<Scalars['String']>;
  isValid?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  stateDescriptor?: Maybe<Scalars['String']>;
  userInvite?: Maybe<UserInviteRelateToOneForUpdateInput>;
  validatedAt?: Maybe<Scalars['DateTime']>;
  validationCode?: Maybe<Scalars['String']>;
  versionCode?: Maybe<Scalars['String']>;
};

export type HealthCardWhereInput = {
  AND?: Maybe<Array<HealthCardWhereInput>>;
  NOT?: Maybe<Array<HealthCardWhereInput>>;
  OR?: Maybe<Array<HealthCardWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  expiryDate?: Maybe<DateTimeFilter>;
  id?: Maybe<IdFilter>;
  insurancePolicyNumber?: Maybe<StringFilter>;
  insuranceProvider?: Maybe<StringFilter>;
  isValid?: Maybe<BooleanFilter>;
  patient?: Maybe<PatientWhereInput>;
  stateDescriptor?: Maybe<StringFilter>;
  userInvite?: Maybe<UserInviteWhereInput>;
  validatedAt?: Maybe<DateTimeNullableFilter>;
  validationCode?: Maybe<StringFilter>;
  versionCode?: Maybe<StringFilter>;
};

export type HealthCardWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type HealthCondition = {
  __typename?: 'HealthCondition';
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<User>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  relation?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type HealthConditionCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosedAt?: Maybe<Scalars['DateTime']>;
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<UserRelateToOneForCreateInput>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  relation?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type HealthConditionManyRelationFilter = {
  every?: Maybe<HealthConditionWhereInput>;
  none?: Maybe<HealthConditionWhereInput>;
  some?: Maybe<HealthConditionWhereInput>;
};

export type HealthConditionOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  diagnosedAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  inactivatedAt?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  relation?: Maybe<OrderDirection>;
  source?: Maybe<OrderDirection>;
};

export type HealthConditionRelateToManyForCreateInput = {
  connect?: Maybe<Array<HealthConditionWhereUniqueInput>>;
  create?: Maybe<Array<HealthConditionCreateInput>>;
};

export type HealthConditionRelateToManyForUpdateInput = {
  connect?: Maybe<Array<HealthConditionWhereUniqueInput>>;
  create?: Maybe<Array<HealthConditionCreateInput>>;
  disconnect?: Maybe<Array<HealthConditionWhereUniqueInput>>;
  set?: Maybe<Array<HealthConditionWhereUniqueInput>>;
};

export type HealthConditionUpdateArgs = {
  data: HealthConditionUpdateInput;
  where: HealthConditionWhereUniqueInput;
};

export type HealthConditionUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosedAt?: Maybe<Scalars['DateTime']>;
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<UserRelateToOneForUpdateInput>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  relation?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type HealthConditionWhereInput = {
  AND?: Maybe<Array<HealthConditionWhereInput>>;
  NOT?: Maybe<Array<HealthConditionWhereInput>>;
  OR?: Maybe<Array<HealthConditionWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  diagnosedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  inactivatedAt?: Maybe<DateTimeNullableFilter>;
  inactivatedBy?: Maybe<UserWhereInput>;
  name?: Maybe<StringFilter>;
  patient?: Maybe<PatientWhereInput>;
  relation?: Maybe<StringFilter>;
  source?: Maybe<StringNullableFilter>;
};

export type HealthConditionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type IdFilter = {
  equals?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  gte?: Maybe<Scalars['ID']>;
  in?: Maybe<Array<Scalars['ID']>>;
  lt?: Maybe<Scalars['ID']>;
  lte?: Maybe<Scalars['ID']>;
  not?: Maybe<IdFilter>;
  notIn?: Maybe<Array<Scalars['ID']>>;
};

export type InboundFax = {
  __typename?: 'InboundFax';
  faxId?: Maybe<Scalars['String']>;
  file?: Maybe<File>;
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  member?: Maybe<Member>;
  patient?: Maybe<Patient>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  replies?: Maybe<Array<Fax>>;
  repliesCount?: Maybe<Scalars['Int']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<InboundFaxStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  testOrder?: Maybe<TestOrder>;
  to?: Maybe<Scalars['String']>;
};


export type InboundFaxRepliesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type InboundFaxRepliesCountArgs = {
  where?: FaxWhereInput;
};

export type InboundFaxCreateInput = {
  faxId?: Maybe<Scalars['String']>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  from?: Maybe<Scalars['String']>;
  member?: Maybe<MemberRelateToOneForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  replies?: Maybe<FaxRelateToManyForCreateInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<InboundFaxStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  testOrder?: Maybe<TestOrderRelateToOneForCreateInput>;
  to?: Maybe<Scalars['String']>;
};

export type InboundFaxManyRelationFilter = {
  every?: Maybe<InboundFaxWhereInput>;
  none?: Maybe<InboundFaxWhereInput>;
  some?: Maybe<InboundFaxWhereInput>;
};

export type InboundFaxOrderByInput = {
  faxId?: Maybe<OrderDirection>;
  from?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  receivedAt?: Maybe<OrderDirection>;
  resolvedAt?: Maybe<OrderDirection>;
  reviewedAt?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
  statusMessage?: Maybe<OrderDirection>;
  to?: Maybe<OrderDirection>;
};

export type InboundFaxRelateToManyForCreateInput = {
  connect?: Maybe<Array<InboundFaxWhereUniqueInput>>;
  create?: Maybe<Array<InboundFaxCreateInput>>;
};

export type InboundFaxRelateToManyForUpdateInput = {
  connect?: Maybe<Array<InboundFaxWhereUniqueInput>>;
  create?: Maybe<Array<InboundFaxCreateInput>>;
  disconnect?: Maybe<Array<InboundFaxWhereUniqueInput>>;
  set?: Maybe<Array<InboundFaxWhereUniqueInput>>;
};

export type InboundFaxRelateToOneForCreateInput = {
  connect?: Maybe<InboundFaxWhereUniqueInput>;
  create?: Maybe<InboundFaxCreateInput>;
};

export type InboundFaxRelateToOneForUpdateInput = {
  connect?: Maybe<InboundFaxWhereUniqueInput>;
  create?: Maybe<InboundFaxCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export enum InboundFaxStatusType {
  Failed = 'failed',
  Received = 'received'
}

export type InboundFaxStatusTypeNullableFilter = {
  equals?: Maybe<InboundFaxStatusType>;
  in?: Maybe<Array<InboundFaxStatusType>>;
  not?: Maybe<InboundFaxStatusTypeNullableFilter>;
  notIn?: Maybe<Array<InboundFaxStatusType>>;
};

export type InboundFaxUpdateArgs = {
  data: InboundFaxUpdateInput;
  where: InboundFaxWhereUniqueInput;
};

export type InboundFaxUpdateInput = {
  faxId?: Maybe<Scalars['String']>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  from?: Maybe<Scalars['String']>;
  member?: Maybe<MemberRelateToOneForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  replies?: Maybe<FaxRelateToManyForUpdateInput>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<InboundFaxStatusType>;
  statusMessage?: Maybe<Scalars['String']>;
  testOrder?: Maybe<TestOrderRelateToOneForUpdateInput>;
  to?: Maybe<Scalars['String']>;
};

export type InboundFaxWhereInput = {
  AND?: Maybe<Array<InboundFaxWhereInput>>;
  NOT?: Maybe<Array<InboundFaxWhereInput>>;
  OR?: Maybe<Array<InboundFaxWhereInput>>;
  faxId?: Maybe<StringFilter>;
  file?: Maybe<FileWhereInput>;
  from?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  member?: Maybe<MemberWhereInput>;
  patient?: Maybe<PatientWhereInput>;
  receivedAt?: Maybe<DateTimeNullableFilter>;
  replies?: Maybe<FaxManyRelationFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  reviewedAt?: Maybe<DateTimeNullableFilter>;
  status?: Maybe<InboundFaxStatusTypeNullableFilter>;
  statusMessage?: Maybe<StringFilter>;
  testOrder?: Maybe<TestOrderWhereInput>;
  to?: Maybe<StringFilter>;
};

export type InboundFaxWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<IntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<IntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};


export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fieldMeta?: Maybe<Scalars['JSON']>;
  isFilterable: Scalars['Boolean'];
  isNonNull?: Maybe<Array<KeystoneAdminUiFieldMetaIsNonNull>>;
  isOrderable: Scalars['Boolean'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export enum KeystoneAdminUiFieldMetaIsNonNull {
  Create = 'create',
  Read = 'read',
  Update = 'update'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiGraphQl = {
  __typename?: 'KeystoneAdminUIGraphQL';
  names: KeystoneAdminUiGraphQlNames;
};

export type KeystoneAdminUiGraphQlNames = {
  __typename?: 'KeystoneAdminUIGraphQLNames';
  createInputName: Scalars['String'];
  createManyMutationName: Scalars['String'];
  createMutationName: Scalars['String'];
  deleteManyMutationName: Scalars['String'];
  deleteMutationName: Scalars['String'];
  itemQueryName: Scalars['String'];
  listOrderName: Scalars['String'];
  listQueryCountName: Scalars['String'];
  listQueryName: Scalars['String'];
  outputTypeName: Scalars['String'];
  relateToManyForCreateInputName: Scalars['String'];
  relateToManyForUpdateInputName: Scalars['String'];
  relateToOneForCreateInputName: Scalars['String'];
  relateToOneForUpdateInputName: Scalars['String'];
  updateInputName: Scalars['String'];
  updateManyInputName: Scalars['String'];
  updateManyMutationName: Scalars['String'];
  updateMutationName: Scalars['String'];
  whereInputName: Scalars['String'];
  whereUniqueInputName: Scalars['String'];
};

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  graphql: KeystoneAdminUiGraphQl;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean'];
  hideDelete: Scalars['Boolean'];
  initialColumns: Array<Scalars['String']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean'];
  isSingleton: Scalars['Boolean'];
  itemQueryName: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  labelField: Scalars['String'];
  listQueryName: Scalars['String'];
  pageSize: Scalars['Int'];
  path: Scalars['String'];
  plural: Scalars['String'];
  singular: Scalars['String'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export type Language = {
  __typename?: 'Language';
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<Array<Doctor>>;
  doctorsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type LanguageDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type LanguageDoctorsCountArgs = {
  where?: DoctorWhereInput;
};

export type LanguageCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForCreateInput>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type LanguageManyRelationFilter = {
  every?: Maybe<LanguageWhereInput>;
  none?: Maybe<LanguageWhereInput>;
  some?: Maybe<LanguageWhereInput>;
};

export type LanguageOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  value?: Maybe<OrderDirection>;
};

export type LanguageRelateToManyForCreateInput = {
  connect?: Maybe<Array<LanguageWhereUniqueInput>>;
  create?: Maybe<Array<LanguageCreateInput>>;
};

export type LanguageRelateToManyForUpdateInput = {
  connect?: Maybe<Array<LanguageWhereUniqueInput>>;
  create?: Maybe<Array<LanguageCreateInput>>;
  disconnect?: Maybe<Array<LanguageWhereUniqueInput>>;
  set?: Maybe<Array<LanguageWhereUniqueInput>>;
};

export type LanguageUpdateArgs = {
  data: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctors?: Maybe<DoctorRelateToManyForUpdateInput>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type LanguageWhereInput = {
  AND?: Maybe<Array<LanguageWhereInput>>;
  NOT?: Maybe<Array<LanguageWhereInput>>;
  OR?: Maybe<Array<LanguageWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctors?: Maybe<DoctorManyRelationFilter>;
  id?: Maybe<IdFilter>;
  label?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type LanguageWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type LeaseAgreement = {
  __typename?: 'LeaseAgreement';
  altText?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<File>;
  id: Scalars['ID'];
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type LeaseAgreementCreateInput = {
  altText?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type LeaseAgreementOrderByInput = {
  altText?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isVerified?: Maybe<OrderDirection>;
};

export type LeaseAgreementRelateToOneForCreateInput = {
  connect?: Maybe<LeaseAgreementWhereUniqueInput>;
  create?: Maybe<LeaseAgreementCreateInput>;
};

export type LeaseAgreementRelateToOneForUpdateInput = {
  connect?: Maybe<LeaseAgreementWhereUniqueInput>;
  create?: Maybe<LeaseAgreementCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type LeaseAgreementUpdateArgs = {
  data: LeaseAgreementUpdateInput;
  where: LeaseAgreementWhereUniqueInput;
};

export type LeaseAgreementUpdateInput = {
  altText?: Maybe<Scalars['String']>;
  clinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type LeaseAgreementWhereInput = {
  AND?: Maybe<Array<LeaseAgreementWhereInput>>;
  NOT?: Maybe<Array<LeaseAgreementWhereInput>>;
  OR?: Maybe<Array<LeaseAgreementWhereInput>>;
  altText?: Maybe<StringFilter>;
  clinic?: Maybe<ClinicWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
  isVerified?: Maybe<BooleanFilter>;
};

export type LeaseAgreementWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type LifestyleItem = {
  __typename?: 'LifestyleItem';
  activity?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<User>;
  item?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
};

export type LifestyleItemCreateInput = {
  activity?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequency?: Maybe<Scalars['String']>;
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<UserRelateToOneForCreateInput>;
  item?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
};

export type LifestyleItemManyRelationFilter = {
  every?: Maybe<LifestyleItemWhereInput>;
  none?: Maybe<LifestyleItemWhereInput>;
  some?: Maybe<LifestyleItemWhereInput>;
};

export type LifestyleItemOrderByInput = {
  activity?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  frequency?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  inactivatedAt?: Maybe<OrderDirection>;
  item?: Maybe<OrderDirection>;
};

export type LifestyleItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<LifestyleItemWhereUniqueInput>>;
  create?: Maybe<Array<LifestyleItemCreateInput>>;
};

export type LifestyleItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<LifestyleItemWhereUniqueInput>>;
  create?: Maybe<Array<LifestyleItemCreateInput>>;
  disconnect?: Maybe<Array<LifestyleItemWhereUniqueInput>>;
  set?: Maybe<Array<LifestyleItemWhereUniqueInput>>;
};

export type LifestyleItemUpdateArgs = {
  data: LifestyleItemUpdateInput;
  where: LifestyleItemWhereUniqueInput;
};

export type LifestyleItemUpdateInput = {
  activity?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frequency?: Maybe<Scalars['String']>;
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<UserRelateToOneForUpdateInput>;
  item?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
};

export type LifestyleItemWhereInput = {
  AND?: Maybe<Array<LifestyleItemWhereInput>>;
  NOT?: Maybe<Array<LifestyleItemWhereInput>>;
  OR?: Maybe<Array<LifestyleItemWhereInput>>;
  activity?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  frequency?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  inactivatedAt?: Maybe<DateTimeNullableFilter>;
  inactivatedBy?: Maybe<UserWhereInput>;
  item?: Maybe<StringFilter>;
  patient?: Maybe<PatientWhereInput>;
};

export type LifestyleItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type LuReason = {
  __typename?: 'LuReason';
  authorizationPeriod?: Maybe<Scalars['String']>;
  clinicalCriteria?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  medication?: Maybe<Medication>;
};

export type LuReasonCreateInput = {
  authorizationPeriod?: Maybe<Scalars['String']>;
  clinicalCriteria?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForCreateInput>;
};

export type LuReasonManyRelationFilter = {
  every?: Maybe<LuReasonWhereInput>;
  none?: Maybe<LuReasonWhereInput>;
  some?: Maybe<LuReasonWhereInput>;
};

export type LuReasonOrderByInput = {
  authorizationPeriod?: Maybe<OrderDirection>;
  clinicalCriteria?: Maybe<OrderDirection>;
  code?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type LuReasonRelateToManyForCreateInput = {
  connect?: Maybe<Array<LuReasonWhereUniqueInput>>;
  create?: Maybe<Array<LuReasonCreateInput>>;
};

export type LuReasonRelateToManyForUpdateInput = {
  connect?: Maybe<Array<LuReasonWhereUniqueInput>>;
  create?: Maybe<Array<LuReasonCreateInput>>;
  disconnect?: Maybe<Array<LuReasonWhereUniqueInput>>;
  set?: Maybe<Array<LuReasonWhereUniqueInput>>;
};

export type LuReasonUpdateArgs = {
  data: LuReasonUpdateInput;
  where: LuReasonWhereUniqueInput;
};

export type LuReasonUpdateInput = {
  authorizationPeriod?: Maybe<Scalars['String']>;
  clinicalCriteria?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForUpdateInput>;
};

export type LuReasonWhereInput = {
  AND?: Maybe<Array<LuReasonWhereInput>>;
  NOT?: Maybe<Array<LuReasonWhereInput>>;
  OR?: Maybe<Array<LuReasonWhereInput>>;
  authorizationPeriod?: Maybe<StringFilter>;
  clinicalCriteria?: Maybe<StringFilter>;
  code?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  medication?: Maybe<MedicationWhereInput>;
};

export type LuReasonWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type MasterLicense = {
  __typename?: 'MasterLicense';
  altText?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<File>;
  id: Scalars['ID'];
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type MasterLicenseCreateInput = {
  altText?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type MasterLicenseOrderByInput = {
  altText?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isVerified?: Maybe<OrderDirection>;
};

export type MasterLicenseRelateToOneForCreateInput = {
  connect?: Maybe<MasterLicenseWhereUniqueInput>;
  create?: Maybe<MasterLicenseCreateInput>;
};

export type MasterLicenseRelateToOneForUpdateInput = {
  connect?: Maybe<MasterLicenseWhereUniqueInput>;
  create?: Maybe<MasterLicenseCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type MasterLicenseUpdateArgs = {
  data: MasterLicenseUpdateInput;
  where: MasterLicenseWhereUniqueInput;
};

export type MasterLicenseUpdateInput = {
  altText?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type MasterLicenseWhereInput = {
  AND?: Maybe<Array<MasterLicenseWhereInput>>;
  NOT?: Maybe<Array<MasterLicenseWhereInput>>;
  OR?: Maybe<Array<MasterLicenseWhereInput>>;
  altText?: Maybe<StringFilter>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
  isVerified?: Maybe<BooleanFilter>;
};

export type MasterLicenseWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Medication = {
  __typename?: 'Medication';
  activeIngredients?: Maybe<Array<ActiveIngredient>>;
  activeIngredientsCount?: Maybe<Scalars['Int']>;
  brandName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  drugCode?: Maybe<Scalars['String']>;
  drugIdentificationNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  luReasons?: Maybe<Array<LuReason>>;
  luReasonsCount?: Maybe<Scalars['Int']>;
  medicationItems?: Maybe<Array<MedicationItem>>;
  medicationItemsCount?: Maybe<Scalars['Int']>;
  prescriptionItems?: Maybe<Array<PrescriptionItem>>;
  prescriptionItemsCount?: Maybe<Scalars['Int']>;
  vaccinations?: Maybe<Array<Vaccination>>;
  vaccinationsCount?: Maybe<Scalars['Int']>;
};


export type MedicationActiveIngredientsArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  orderBy?: Array<ActiveIngredientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ActiveIngredientWhereInput;
};


export type MedicationActiveIngredientsCountArgs = {
  where?: ActiveIngredientWhereInput;
};


export type MedicationLuReasonsArgs = {
  cursor?: Maybe<LuReasonWhereUniqueInput>;
  orderBy?: Array<LuReasonOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: LuReasonWhereInput;
};


export type MedicationLuReasonsCountArgs = {
  where?: LuReasonWhereInput;
};


export type MedicationMedicationItemsArgs = {
  cursor?: Maybe<MedicationItemWhereUniqueInput>;
  orderBy?: Array<MedicationItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MedicationItemWhereInput;
};


export type MedicationMedicationItemsCountArgs = {
  where?: MedicationItemWhereInput;
};


export type MedicationPrescriptionItemsArgs = {
  cursor?: Maybe<PrescriptionItemWhereUniqueInput>;
  orderBy?: Array<PrescriptionItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PrescriptionItemWhereInput;
};


export type MedicationPrescriptionItemsCountArgs = {
  where?: PrescriptionItemWhereInput;
};


export type MedicationVaccinationsArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  orderBy?: Array<VaccinationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: VaccinationWhereInput;
};


export type MedicationVaccinationsCountArgs = {
  where?: VaccinationWhereInput;
};

export type MedicationCreateInput = {
  activeIngredients?: Maybe<ActiveIngredientRelateToManyForCreateInput>;
  brandName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  drugCode?: Maybe<Scalars['String']>;
  drugIdentificationNumber?: Maybe<Scalars['String']>;
  luReasons?: Maybe<LuReasonRelateToManyForCreateInput>;
  medicationItems?: Maybe<MedicationItemRelateToManyForCreateInput>;
  prescriptionItems?: Maybe<PrescriptionItemRelateToManyForCreateInput>;
  vaccinations?: Maybe<VaccinationRelateToManyForCreateInput>;
};

export type MedicationItem = {
  __typename?: 'MedicationItem';
  appointment?: Maybe<Appointment>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  id: Scalars['ID'];
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<User>;
  instructions?: Maybe<Scalars['String']>;
  medication?: Maybe<Medication>;
  patient?: Maybe<Patient>;
  prescribedAt?: Maybe<Scalars['DateTime']>;
  refills?: Maybe<Scalars['Int']>;
};

export type MedicationItemCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<UserRelateToOneForCreateInput>;
  instructions?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  prescribedAt?: Maybe<Scalars['DateTime']>;
  refills?: Maybe<Scalars['Int']>;
};

export type MedicationItemManyRelationFilter = {
  every?: Maybe<MedicationItemWhereInput>;
  none?: Maybe<MedicationItemWhereInput>;
  some?: Maybe<MedicationItemWhereInput>;
};

export type MedicationItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  inactivatedAt?: Maybe<OrderDirection>;
  instructions?: Maybe<OrderDirection>;
  prescribedAt?: Maybe<OrderDirection>;
  refills?: Maybe<OrderDirection>;
};

export type MedicationItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<MedicationItemWhereUniqueInput>>;
  create?: Maybe<Array<MedicationItemCreateInput>>;
};

export type MedicationItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<MedicationItemWhereUniqueInput>>;
  create?: Maybe<Array<MedicationItemCreateInput>>;
  disconnect?: Maybe<Array<MedicationItemWhereUniqueInput>>;
  set?: Maybe<Array<MedicationItemWhereUniqueInput>>;
};

export type MedicationItemUpdateArgs = {
  data: MedicationItemUpdateInput;
  where: MedicationItemWhereUniqueInput;
};

export type MedicationItemUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  inactivatedBy?: Maybe<UserRelateToOneForUpdateInput>;
  instructions?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  prescribedAt?: Maybe<Scalars['DateTime']>;
  refills?: Maybe<Scalars['Int']>;
};

export type MedicationItemWhereInput = {
  AND?: Maybe<Array<MedicationItemWhereInput>>;
  NOT?: Maybe<Array<MedicationItemWhereInput>>;
  OR?: Maybe<Array<MedicationItemWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  id?: Maybe<IdFilter>;
  inactivatedAt?: Maybe<DateTimeNullableFilter>;
  inactivatedBy?: Maybe<UserWhereInput>;
  instructions?: Maybe<StringFilter>;
  medication?: Maybe<MedicationWhereInput>;
  patient?: Maybe<PatientWhereInput>;
  prescribedAt?: Maybe<DateTimeNullableFilter>;
  refills?: Maybe<IntNullableFilter>;
};

export type MedicationItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type MedicationOrderByInput = {
  brandName?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  drugCode?: Maybe<OrderDirection>;
  drugIdentificationNumber?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type MedicationRelateToOneForCreateInput = {
  connect?: Maybe<MedicationWhereUniqueInput>;
  create?: Maybe<MedicationCreateInput>;
};

export type MedicationRelateToOneForUpdateInput = {
  connect?: Maybe<MedicationWhereUniqueInput>;
  create?: Maybe<MedicationCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type MedicationUpdateArgs = {
  data: MedicationUpdateInput;
  where: MedicationWhereUniqueInput;
};

export type MedicationUpdateInput = {
  activeIngredients?: Maybe<ActiveIngredientRelateToManyForUpdateInput>;
  brandName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  drugCode?: Maybe<Scalars['String']>;
  drugIdentificationNumber?: Maybe<Scalars['String']>;
  luReasons?: Maybe<LuReasonRelateToManyForUpdateInput>;
  medicationItems?: Maybe<MedicationItemRelateToManyForUpdateInput>;
  prescriptionItems?: Maybe<PrescriptionItemRelateToManyForUpdateInput>;
  vaccinations?: Maybe<VaccinationRelateToManyForUpdateInput>;
};

export type MedicationWhereInput = {
  AND?: Maybe<Array<MedicationWhereInput>>;
  NOT?: Maybe<Array<MedicationWhereInput>>;
  OR?: Maybe<Array<MedicationWhereInput>>;
  activeIngredients?: Maybe<ActiveIngredientManyRelationFilter>;
  brandName?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  drugCode?: Maybe<StringFilter>;
  drugIdentificationNumber?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  luReasons?: Maybe<LuReasonManyRelationFilter>;
  medicationItems?: Maybe<MedicationItemManyRelationFilter>;
  prescriptionItems?: Maybe<PrescriptionItemManyRelationFilter>;
  vaccinations?: Maybe<VaccinationManyRelationFilter>;
};

export type MedicationWhereUniqueInput = {
  drugCode?: Maybe<Scalars['String']>;
  drugIdentificationNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type Member = {
  __typename?: 'Member';
  appointmentRequests?: Maybe<Array<AppointmentRequest>>;
  appointmentRequestsCount?: Maybe<Scalars['Int']>;
  appointments?: Maybe<Array<Appointment>>;
  appointmentsCount?: Maybe<Scalars['Int']>;
  calendar?: Maybe<Calendar>;
  clinic?: Maybe<Clinic>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntents?: Maybe<Array<DataImportIntent>>;
  dataImportIntentsCount?: Maybe<Scalars['Int']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  faxNumber?: Maybe<Scalars['String']>;
  faxes?: Maybe<Array<Fax>>;
  faxesCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  inboundFaxes?: Maybe<Array<InboundFax>>;
  inboundFaxesCount?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Role>;
  roleAlias?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<Task>>;
  tasksCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};


export type MemberAppointmentRequestsArgs = {
  cursor?: Maybe<AppointmentRequestWhereUniqueInput>;
  orderBy?: Array<AppointmentRequestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentRequestWhereInput;
};


export type MemberAppointmentRequestsCountArgs = {
  where?: AppointmentRequestWhereInput;
};


export type MemberAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  orderBy?: Array<AppointmentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentWhereInput;
};


export type MemberAppointmentsCountArgs = {
  where?: AppointmentWhereInput;
};


export type MemberDataImportIntentsArgs = {
  cursor?: Maybe<DataImportIntentWhereUniqueInput>;
  orderBy?: Array<DataImportIntentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportIntentWhereInput;
};


export type MemberDataImportIntentsCountArgs = {
  where?: DataImportIntentWhereInput;
};


export type MemberFaxesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type MemberFaxesCountArgs = {
  where?: FaxWhereInput;
};


export type MemberInboundFaxesArgs = {
  cursor?: Maybe<InboundFaxWhereUniqueInput>;
  orderBy?: Array<InboundFaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: InboundFaxWhereInput;
};


export type MemberInboundFaxesCountArgs = {
  where?: InboundFaxWhereInput;
};


export type MemberTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  orderBy?: Array<TaskOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TaskWhereInput;
};


export type MemberTasksCountArgs = {
  where?: TaskWhereInput;
};

export type MemberCreateInput = {
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForCreateInput>;
  appointments?: Maybe<AppointmentRelateToManyForCreateInput>;
  calendar?: Maybe<CalendarRelateToOneForCreateInput>;
  clinic?: Maybe<ClinicRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntents?: Maybe<DataImportIntentRelateToManyForCreateInput>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  faxNumber?: Maybe<Scalars['String']>;
  faxes?: Maybe<FaxRelateToManyForCreateInput>;
  inboundFaxes?: Maybe<InboundFaxRelateToManyForCreateInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  role?: Maybe<RoleRelateToOneForCreateInput>;
  roleAlias?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskRelateToManyForCreateInput>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type MemberManyRelationFilter = {
  every?: Maybe<MemberWhereInput>;
  none?: Maybe<MemberWhereInput>;
  some?: Maybe<MemberWhereInput>;
};

export type MemberOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  deactivatedAt?: Maybe<OrderDirection>;
  faxNumber?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  roleAlias?: Maybe<OrderDirection>;
};

export type MemberRelateToManyForCreateInput = {
  connect?: Maybe<Array<MemberWhereUniqueInput>>;
  create?: Maybe<Array<MemberCreateInput>>;
};

export type MemberRelateToManyForUpdateInput = {
  connect?: Maybe<Array<MemberWhereUniqueInput>>;
  create?: Maybe<Array<MemberCreateInput>>;
  disconnect?: Maybe<Array<MemberWhereUniqueInput>>;
  set?: Maybe<Array<MemberWhereUniqueInput>>;
};

export type MemberRelateToOneForCreateInput = {
  connect?: Maybe<MemberWhereUniqueInput>;
  create?: Maybe<MemberCreateInput>;
};

export type MemberRelateToOneForUpdateInput = {
  connect?: Maybe<MemberWhereUniqueInput>;
  create?: Maybe<MemberCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type MemberUpdateArgs = {
  data: MemberUpdateInput;
  where: MemberWhereUniqueInput;
};

export type MemberUpdateInput = {
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForUpdateInput>;
  appointments?: Maybe<AppointmentRelateToManyForUpdateInput>;
  calendar?: Maybe<CalendarRelateToOneForUpdateInput>;
  clinic?: Maybe<ClinicRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntents?: Maybe<DataImportIntentRelateToManyForUpdateInput>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  faxNumber?: Maybe<Scalars['String']>;
  faxes?: Maybe<FaxRelateToManyForUpdateInput>;
  inboundFaxes?: Maybe<InboundFaxRelateToManyForUpdateInput>;
  isActive?: Maybe<Scalars['Boolean']>;
  role?: Maybe<RoleRelateToOneForUpdateInput>;
  roleAlias?: Maybe<Scalars['String']>;
  tasks?: Maybe<TaskRelateToManyForUpdateInput>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type MemberWhereInput = {
  AND?: Maybe<Array<MemberWhereInput>>;
  NOT?: Maybe<Array<MemberWhereInput>>;
  OR?: Maybe<Array<MemberWhereInput>>;
  appointmentRequests?: Maybe<AppointmentRequestManyRelationFilter>;
  appointments?: Maybe<AppointmentManyRelationFilter>;
  calendar?: Maybe<CalendarWhereInput>;
  clinic?: Maybe<ClinicWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  dataImportIntents?: Maybe<DataImportIntentManyRelationFilter>;
  deactivatedAt?: Maybe<DateTimeNullableFilter>;
  faxNumber?: Maybe<StringFilter>;
  faxes?: Maybe<FaxManyRelationFilter>;
  id?: Maybe<IdFilter>;
  inboundFaxes?: Maybe<InboundFaxManyRelationFilter>;
  isActive?: Maybe<BooleanFilter>;
  role?: Maybe<RoleWhereInput>;
  roleAlias?: Maybe<StringFilter>;
  tasks?: Maybe<TaskManyRelationFilter>;
  user?: Maybe<UserWhereInput>;
};

export type MemberWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite?: Maybe<User>;
  addChatMessage?: Maybe<ChatMessage>;
  addClinic?: Maybe<Clinic>;
  addCompany?: Maybe<Company>;
  addMember?: Maybe<Member>;
  addPatientToCompany?: Maybe<Patient>;
  backfillMyStripe?: Maybe<User>;
  cancelAppointmentRequest?: Maybe<AppointmentRequest>;
  cancelCompanyOnboarding?: Maybe<Company>;
  completeAppointment?: Maybe<Appointment>;
  completeCompanyOnboarding?: Maybe<Scalars['Boolean']>;
  completeMyStepProg?: Maybe<StepperStepProg>;
  createAccessToken?: Maybe<AccessToken>;
  createAccessTokens?: Maybe<Array<Maybe<AccessToken>>>;
  createAccount?: Maybe<Account>;
  createAccounts?: Maybe<Array<Maybe<Account>>>;
  createActiveIngredient?: Maybe<ActiveIngredient>;
  createActiveIngredients?: Maybe<Array<Maybe<ActiveIngredient>>>;
  createAddress?: Maybe<Address>;
  createAddresses?: Maybe<Array<Maybe<Address>>>;
  createAdministrativeArea?: Maybe<AdministrativeArea>;
  createAdministrativeAreas?: Maybe<Array<Maybe<AdministrativeArea>>>;
  createAllergyItem?: Maybe<AllergyItem>;
  createAllergyItems?: Maybe<Array<Maybe<AllergyItem>>>;
  createAppointment?: Maybe<Appointment>;
  createAppointmentBilling?: Maybe<AppointmentBilling>;
  createAppointmentBillingException?: Maybe<AppointmentBillingException>;
  createAppointmentBillingExceptions?: Maybe<Array<Maybe<AppointmentBillingException>>>;
  createAppointmentBillingItem?: Maybe<AppointmentBillingItem>;
  createAppointmentBillingItems?: Maybe<Array<Maybe<AppointmentBillingItem>>>;
  createAppointmentBillings?: Maybe<Array<Maybe<AppointmentBilling>>>;
  createAppointmentDraft?: Maybe<AppointmentDraft>;
  createAppointmentDrafts?: Maybe<Array<Maybe<AppointmentDraft>>>;
  createAppointmentNote?: Maybe<AppointmentNote>;
  createAppointmentNotes?: Maybe<Array<Maybe<AppointmentNote>>>;
  createAppointmentRequest?: Maybe<AppointmentRequest>;
  createAppointmentRequests?: Maybe<Array<Maybe<AppointmentRequest>>>;
  createAppointmentSession?: Maybe<AppointmentSession>;
  createAppointmentSessions?: Maybe<Array<Maybe<AppointmentSession>>>;
  createAppointmentVital?: Maybe<AppointmentVital>;
  createAppointmentVitals?: Maybe<Array<Maybe<AppointmentVital>>>;
  createAppointments?: Maybe<Array<Maybe<Appointment>>>;
  createArchive?: Maybe<Archive>;
  createArchiveItem?: Maybe<ArchiveItem>;
  createArchiveItems?: Maybe<Array<Maybe<ArchiveItem>>>;
  createArchives?: Maybe<Array<Maybe<Archive>>>;
  createBillingClaim?: Maybe<BillingClaim>;
  createBillingClaims?: Maybe<Array<Maybe<BillingClaim>>>;
  createBillingDiagnoses?: Maybe<Array<Maybe<BillingDiagnosis>>>;
  createBillingDiagnosis?: Maybe<BillingDiagnosis>;
  createBillingPremium?: Maybe<BillingPremium>;
  createBillingPremiums?: Maybe<Array<Maybe<BillingPremium>>>;
  createBillingSubmission?: Maybe<BillingSubmission>;
  createBillingSubmissions?: Maybe<Array<Maybe<BillingSubmission>>>;
  createBirdSummaryIntent?: Maybe<BirdSummaryIntent>;
  createBirdSummaryIntents?: Maybe<Array<Maybe<BirdSummaryIntent>>>;
  createBooking?: Maybe<Booking>;
  createBookings?: Maybe<Array<Maybe<Booking>>>;
  createBucketFile?: Maybe<File>;
  createCalendar?: Maybe<Calendar>;
  createCalendarEvent?: Maybe<CalendarEvent>;
  createCalendarEventBooking?: Maybe<Booking>;
  createCalendarEventType?: Maybe<CalendarEventType>;
  createCalendarEventTypes?: Maybe<Array<Maybe<CalendarEventType>>>;
  createCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  createCalendars?: Maybe<Array<Maybe<Calendar>>>;
  createChat?: Maybe<Chat>;
  createChatMessage?: Maybe<ChatMessage>;
  createChatMessages?: Maybe<Array<Maybe<ChatMessage>>>;
  createChats?: Maybe<Array<Maybe<Chat>>>;
  createClinic?: Maybe<Clinic>;
  createClinics?: Maybe<Array<Maybe<Clinic>>>;
  createCompanies?: Maybe<Array<Maybe<Company>>>;
  createCompany?: Maybe<Company>;
  createCompanyLogo?: Maybe<CompanyLogo>;
  createCompanyLogos?: Maybe<Array<Maybe<CompanyLogo>>>;
  createContract?: Maybe<Contract>;
  createContracts?: Maybe<Array<Maybe<Contract>>>;
  createCountries?: Maybe<Array<Maybe<Country>>>;
  createCountry?: Maybe<Country>;
  createCoupon?: Maybe<Coupon>;
  createCoupons?: Maybe<Array<Maybe<Coupon>>>;
  createDataImport?: Maybe<DataImport>;
  createDataImportIntent?: Maybe<DataImportIntent>;
  createDataImportIntents?: Maybe<Array<Maybe<DataImportIntent>>>;
  createDataImportItem?: Maybe<DataImportItem>;
  createDataImportItems?: Maybe<Array<Maybe<DataImportItem>>>;
  createDataImports?: Maybe<Array<Maybe<DataImport>>>;
  createDoctor?: Maybe<Doctor>;
  createDoctorCalendarEventBooking?: Maybe<Booking>;
  createDoctorSpecialties?: Maybe<Array<Maybe<DoctorSpecialty>>>;
  createDoctorSpecialty?: Maybe<DoctorSpecialty>;
  createDoctorSubSpecialties?: Maybe<Array<Maybe<DoctorSubSpecialty>>>;
  createDoctorSubSpecialty?: Maybe<DoctorSubSpecialty>;
  createDoctors?: Maybe<Array<Maybe<Doctor>>>;
  createDocument?: Maybe<Document>;
  createDocuments?: Maybe<Array<Maybe<Document>>>;
  createEmergencyContact?: Maybe<EmergencyContact>;
  createEmergencyContacts?: Maybe<Array<Maybe<EmergencyContact>>>;
  createFax?: Maybe<Fax>;
  createFaxBlast?: Maybe<FaxBlast>;
  createFaxBlastItem?: Maybe<FaxBlastItem>;
  createFaxBlastItems?: Maybe<Array<Maybe<FaxBlastItem>>>;
  createFaxBlasts?: Maybe<Array<Maybe<FaxBlast>>>;
  createFaxRecipient?: Maybe<FaxRecipient>;
  createFaxRecipients?: Maybe<Array<Maybe<FaxRecipient>>>;
  createFaxes?: Maybe<Array<Maybe<Fax>>>;
  createFeedbackItem?: Maybe<FeedbackItem>;
  createFeedbackItems?: Maybe<Array<Maybe<FeedbackItem>>>;
  createFile?: Maybe<File>;
  createFiles?: Maybe<Array<Maybe<File>>>;
  createForm?: Maybe<Form>;
  createFormTest?: Maybe<FormTest>;
  createFormTests?: Maybe<Array<Maybe<FormTest>>>;
  createFormType?: Maybe<FormType>;
  createFormTypes?: Maybe<Array<Maybe<FormType>>>;
  createForms?: Maybe<Array<Maybe<Form>>>;
  createHealthCard?: Maybe<HealthCard>;
  createHealthCards?: Maybe<Array<Maybe<HealthCard>>>;
  createHealthCondition?: Maybe<HealthCondition>;
  createHealthConditions?: Maybe<Array<Maybe<HealthCondition>>>;
  createInboundFax?: Maybe<InboundFax>;
  createInboundFaxes?: Maybe<Array<Maybe<InboundFax>>>;
  createLanguage?: Maybe<Language>;
  createLanguages?: Maybe<Array<Maybe<Language>>>;
  createLeaseAgreement?: Maybe<LeaseAgreement>;
  createLeaseAgreements?: Maybe<Array<Maybe<LeaseAgreement>>>;
  createLifestyleItem?: Maybe<LifestyleItem>;
  createLifestyleItems?: Maybe<Array<Maybe<LifestyleItem>>>;
  createLuReason?: Maybe<LuReason>;
  createLuReasons?: Maybe<Array<Maybe<LuReason>>>;
  createMasterLicense?: Maybe<MasterLicense>;
  createMasterLicenses?: Maybe<Array<Maybe<MasterLicense>>>;
  createMedicalHistoryLink?: Maybe<AccessToken>;
  createMedication?: Maybe<Medication>;
  createMedicationItem?: Maybe<MedicationItem>;
  createMedicationItems?: Maybe<Array<Maybe<MedicationItem>>>;
  createMedications?: Maybe<Array<Maybe<Medication>>>;
  createMember?: Maybe<Member>;
  createMemberDataImportIntent?: Maybe<DataImportIntent>;
  createMembers?: Maybe<Array<Maybe<Member>>>;
  createNotificationDispatch?: Maybe<NotificationDispatch>;
  createNotificationDispatchItem?: Maybe<NotificationDispatchItem>;
  createNotificationDispatchItems?: Maybe<Array<Maybe<NotificationDispatchItem>>>;
  createNotificationDispatches?: Maybe<Array<Maybe<NotificationDispatch>>>;
  createOrUpdateTask?: Maybe<Task>;
  createPatient?: Maybe<Patient>;
  createPatients?: Maybe<Array<Maybe<Patient>>>;
  createPharmacies?: Maybe<Array<Maybe<Pharmacy>>>;
  createPharmacy?: Maybe<Pharmacy>;
  createPharmacyLocation?: Maybe<PharmacyLocation>;
  createPharmacyLocations?: Maybe<Array<Maybe<PharmacyLocation>>>;
  createPrescription?: Maybe<Prescription>;
  createPrescriptionItem?: Maybe<PrescriptionItem>;
  createPrescriptionItems?: Maybe<Array<Maybe<PrescriptionItem>>>;
  createPrescriptions?: Maybe<Array<Maybe<Prescription>>>;
  createProfilePhoto?: Maybe<ProfilePhoto>;
  createProfilePhotos?: Maybe<Array<Maybe<ProfilePhoto>>>;
  createPrompt?: Maybe<Prompt>;
  createPrompts?: Maybe<Array<Maybe<Prompt>>>;
  createProofOfIdentification?: Maybe<ProofOfIdentification>;
  createProofOfIdentifications?: Maybe<Array<Maybe<ProofOfIdentification>>>;
  createProofOfInsurance?: Maybe<ProofOfInsurance>;
  createProofOfInsurances?: Maybe<Array<Maybe<ProofOfInsurance>>>;
  createProofOfLicense?: Maybe<ProofOfLicense>;
  createProofOfLicenses?: Maybe<Array<Maybe<ProofOfLicense>>>;
  createRecurringSlot?: Maybe<RecurringSlot>;
  createRecurringSlots?: Maybe<Array<Maybe<RecurringSlot>>>;
  createRemittanceAdvice?: Maybe<RemittanceAdvice>;
  createRemittanceAdviceRequest?: Maybe<RemittanceAdviceRequest>;
  createRemittanceAdviceRequests?: Maybe<Array<Maybe<RemittanceAdviceRequest>>>;
  createRemittanceAdvices?: Maybe<Array<Maybe<RemittanceAdvice>>>;
  createRole?: Maybe<Role>;
  createRoles?: Maybe<Array<Maybe<Role>>>;
  createSchedule?: Maybe<Schedule>;
  createSchedules?: Maybe<Array<Maybe<Schedule>>>;
  createScreeningTest?: Maybe<ScreeningTest>;
  createScreeningTests?: Maybe<Array<Maybe<ScreeningTest>>>;
  createSession?: Maybe<Session>;
  createSessionEvent?: Maybe<SessionEvent>;
  createSessionEvents?: Maybe<Array<Maybe<SessionEvent>>>;
  createSessions?: Maybe<Array<Maybe<Session>>>;
  createSignature?: Maybe<Signature>;
  createSignatures?: Maybe<Array<Maybe<Signature>>>;
  createStepper?: Maybe<Stepper>;
  createStepperProg?: Maybe<StepperProg>;
  createStepperProgs?: Maybe<Array<Maybe<StepperProg>>>;
  createStepperStep?: Maybe<StepperStep>;
  createStepperStepProg?: Maybe<StepperStepProg>;
  createStepperStepProgs?: Maybe<Array<Maybe<StepperStepProg>>>;
  createStepperSteps?: Maybe<Array<Maybe<StepperStep>>>;
  createSteppers?: Maybe<Array<Maybe<Stepper>>>;
  createTask?: Maybe<Task>;
  createTasks?: Maybe<Array<Maybe<Task>>>;
  createTestOrder?: Maybe<TestOrder>;
  createTestOrders?: Maybe<Array<Maybe<TestOrder>>>;
  createTestsBatch?: Maybe<TestsBatch>;
  createTestsBatches?: Maybe<Array<Maybe<TestsBatch>>>;
  createTimeInterval?: Maybe<TimeInterval>;
  createTimeIntervals?: Maybe<Array<Maybe<TimeInterval>>>;
  createUser?: Maybe<User>;
  createUserInvite?: Maybe<UserInvite>;
  createUserInvites?: Maybe<Array<Maybe<UserInvite>>>;
  createUserSession?: Maybe<UserSession>;
  createUserSessions?: Maybe<Array<Maybe<UserSession>>>;
  createUsers?: Maybe<Array<Maybe<User>>>;
  createVaccination?: Maybe<Vaccination>;
  createVaccinations?: Maybe<Array<Maybe<Vaccination>>>;
  createVerificationToken?: Maybe<VerificationToken>;
  createVerificationTokens?: Maybe<Array<Maybe<VerificationToken>>>;
  createWalkInAppointment?: Maybe<Appointment>;
  deleteAccessToken?: Maybe<AccessToken>;
  deleteAccessTokens?: Maybe<Array<Maybe<AccessToken>>>;
  deleteAccount?: Maybe<Account>;
  deleteAccounts?: Maybe<Array<Maybe<Account>>>;
  deleteActiveIngredient?: Maybe<ActiveIngredient>;
  deleteActiveIngredients?: Maybe<Array<Maybe<ActiveIngredient>>>;
  deleteAddress?: Maybe<Address>;
  deleteAddresses?: Maybe<Array<Maybe<Address>>>;
  deleteAdministrativeArea?: Maybe<AdministrativeArea>;
  deleteAdministrativeAreas?: Maybe<Array<Maybe<AdministrativeArea>>>;
  deleteAllergyItem?: Maybe<AllergyItem>;
  deleteAllergyItems?: Maybe<Array<Maybe<AllergyItem>>>;
  deleteAppointment?: Maybe<Appointment>;
  deleteAppointmentBilling?: Maybe<AppointmentBilling>;
  deleteAppointmentBillingException?: Maybe<AppointmentBillingException>;
  deleteAppointmentBillingExceptions?: Maybe<Array<Maybe<AppointmentBillingException>>>;
  deleteAppointmentBillingItem?: Maybe<AppointmentBillingItem>;
  deleteAppointmentBillingItems?: Maybe<Array<Maybe<AppointmentBillingItem>>>;
  deleteAppointmentBillings?: Maybe<Array<Maybe<AppointmentBilling>>>;
  deleteAppointmentDraft?: Maybe<AppointmentDraft>;
  deleteAppointmentDrafts?: Maybe<Array<Maybe<AppointmentDraft>>>;
  deleteAppointmentNote?: Maybe<AppointmentNote>;
  deleteAppointmentNotes?: Maybe<Array<Maybe<AppointmentNote>>>;
  deleteAppointmentRequest?: Maybe<AppointmentRequest>;
  deleteAppointmentRequests?: Maybe<Array<Maybe<AppointmentRequest>>>;
  deleteAppointmentSession?: Maybe<AppointmentSession>;
  deleteAppointmentSessions?: Maybe<Array<Maybe<AppointmentSession>>>;
  deleteAppointmentVital?: Maybe<AppointmentVital>;
  deleteAppointmentVitals?: Maybe<Array<Maybe<AppointmentVital>>>;
  deleteAppointments?: Maybe<Array<Maybe<Appointment>>>;
  deleteArchive?: Maybe<Archive>;
  deleteArchiveItem?: Maybe<ArchiveItem>;
  deleteArchiveItems?: Maybe<Array<Maybe<ArchiveItem>>>;
  deleteArchives?: Maybe<Array<Maybe<Archive>>>;
  deleteBillingClaim?: Maybe<BillingClaim>;
  deleteBillingClaims?: Maybe<Array<Maybe<BillingClaim>>>;
  deleteBillingDiagnoses?: Maybe<Array<Maybe<BillingDiagnosis>>>;
  deleteBillingDiagnosis?: Maybe<BillingDiagnosis>;
  deleteBillingPremium?: Maybe<BillingPremium>;
  deleteBillingPremiums?: Maybe<Array<Maybe<BillingPremium>>>;
  deleteBillingSubmission?: Maybe<BillingSubmission>;
  deleteBillingSubmissions?: Maybe<Array<Maybe<BillingSubmission>>>;
  deleteBirdSummaryIntent?: Maybe<BirdSummaryIntent>;
  deleteBirdSummaryIntents?: Maybe<Array<Maybe<BirdSummaryIntent>>>;
  deleteBooking?: Maybe<Booking>;
  deleteBookings?: Maybe<Array<Maybe<Booking>>>;
  deleteCalendar?: Maybe<Calendar>;
  deleteCalendarEvent?: Maybe<CalendarEvent>;
  deleteCalendarEventType?: Maybe<CalendarEventType>;
  deleteCalendarEventTypes?: Maybe<Array<Maybe<CalendarEventType>>>;
  deleteCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  deleteCalendars?: Maybe<Array<Maybe<Calendar>>>;
  deleteChat?: Maybe<Chat>;
  deleteChatMessage?: Maybe<ChatMessage>;
  deleteChatMessages?: Maybe<Array<Maybe<ChatMessage>>>;
  deleteChats?: Maybe<Array<Maybe<Chat>>>;
  deleteClinic?: Maybe<Clinic>;
  deleteClinics?: Maybe<Array<Maybe<Clinic>>>;
  deleteCompanies?: Maybe<Array<Maybe<Company>>>;
  deleteCompany?: Maybe<Company>;
  deleteCompanyLogo?: Maybe<CompanyLogo>;
  deleteCompanyLogos?: Maybe<Array<Maybe<CompanyLogo>>>;
  deleteContract?: Maybe<Contract>;
  deleteContracts?: Maybe<Array<Maybe<Contract>>>;
  deleteCountries?: Maybe<Array<Maybe<Country>>>;
  deleteCountry?: Maybe<Country>;
  deleteCoupon?: Maybe<Coupon>;
  deleteCoupons?: Maybe<Array<Maybe<Coupon>>>;
  deleteDataImport?: Maybe<DataImport>;
  deleteDataImportIntent?: Maybe<DataImportIntent>;
  deleteDataImportIntents?: Maybe<Array<Maybe<DataImportIntent>>>;
  deleteDataImportItem?: Maybe<DataImportItem>;
  deleteDataImportItems?: Maybe<Array<Maybe<DataImportItem>>>;
  deleteDataImports?: Maybe<Array<Maybe<DataImport>>>;
  deleteDoctor?: Maybe<Doctor>;
  deleteDoctorSpecialties?: Maybe<Array<Maybe<DoctorSpecialty>>>;
  deleteDoctorSpecialty?: Maybe<DoctorSpecialty>;
  deleteDoctorSubSpecialties?: Maybe<Array<Maybe<DoctorSubSpecialty>>>;
  deleteDoctorSubSpecialty?: Maybe<DoctorSubSpecialty>;
  deleteDoctors?: Maybe<Array<Maybe<Doctor>>>;
  deleteDocument?: Maybe<Document>;
  deleteDocuments?: Maybe<Array<Maybe<Document>>>;
  deleteEmergencyContact?: Maybe<EmergencyContact>;
  deleteEmergencyContacts?: Maybe<Array<Maybe<EmergencyContact>>>;
  deleteFax?: Maybe<Fax>;
  deleteFaxBlast?: Maybe<FaxBlast>;
  deleteFaxBlastItem?: Maybe<FaxBlastItem>;
  deleteFaxBlastItems?: Maybe<Array<Maybe<FaxBlastItem>>>;
  deleteFaxBlasts?: Maybe<Array<Maybe<FaxBlast>>>;
  deleteFaxRecipient?: Maybe<FaxRecipient>;
  deleteFaxRecipients?: Maybe<Array<Maybe<FaxRecipient>>>;
  deleteFaxes?: Maybe<Array<Maybe<Fax>>>;
  deleteFeedbackItem?: Maybe<FeedbackItem>;
  deleteFeedbackItems?: Maybe<Array<Maybe<FeedbackItem>>>;
  deleteFile?: Maybe<File>;
  deleteFiles?: Maybe<Array<Maybe<File>>>;
  deleteForm?: Maybe<Form>;
  deleteFormTest?: Maybe<FormTest>;
  deleteFormTests?: Maybe<Array<Maybe<FormTest>>>;
  deleteFormType?: Maybe<FormType>;
  deleteFormTypes?: Maybe<Array<Maybe<FormType>>>;
  deleteForms?: Maybe<Array<Maybe<Form>>>;
  deleteHealthCard?: Maybe<HealthCard>;
  deleteHealthCards?: Maybe<Array<Maybe<HealthCard>>>;
  deleteHealthCondition?: Maybe<HealthCondition>;
  deleteHealthConditions?: Maybe<Array<Maybe<HealthCondition>>>;
  deleteInboundFax?: Maybe<InboundFax>;
  deleteInboundFaxes?: Maybe<Array<Maybe<InboundFax>>>;
  deleteLanguage?: Maybe<Language>;
  deleteLanguages?: Maybe<Array<Maybe<Language>>>;
  deleteLeaseAgreement?: Maybe<LeaseAgreement>;
  deleteLeaseAgreements?: Maybe<Array<Maybe<LeaseAgreement>>>;
  deleteLifestyleItem?: Maybe<LifestyleItem>;
  deleteLifestyleItems?: Maybe<Array<Maybe<LifestyleItem>>>;
  deleteLuReason?: Maybe<LuReason>;
  deleteLuReasons?: Maybe<Array<Maybe<LuReason>>>;
  deleteMasterLicense?: Maybe<MasterLicense>;
  deleteMasterLicenses?: Maybe<Array<Maybe<MasterLicense>>>;
  deleteMedication?: Maybe<Medication>;
  deleteMedicationItem?: Maybe<MedicationItem>;
  deleteMedicationItems?: Maybe<Array<Maybe<MedicationItem>>>;
  deleteMedications?: Maybe<Array<Maybe<Medication>>>;
  deleteMember?: Maybe<Member>;
  deleteMembers?: Maybe<Array<Maybe<Member>>>;
  deleteNotificationDispatch?: Maybe<NotificationDispatch>;
  deleteNotificationDispatchItem?: Maybe<NotificationDispatchItem>;
  deleteNotificationDispatchItems?: Maybe<Array<Maybe<NotificationDispatchItem>>>;
  deleteNotificationDispatches?: Maybe<Array<Maybe<NotificationDispatch>>>;
  deletePatient?: Maybe<Patient>;
  deletePatients?: Maybe<Array<Maybe<Patient>>>;
  deletePharmacies?: Maybe<Array<Maybe<Pharmacy>>>;
  deletePharmacy?: Maybe<Pharmacy>;
  deletePharmacyLocation?: Maybe<PharmacyLocation>;
  deletePharmacyLocations?: Maybe<Array<Maybe<PharmacyLocation>>>;
  deletePrescription?: Maybe<Prescription>;
  deletePrescriptionItem?: Maybe<PrescriptionItem>;
  deletePrescriptionItems?: Maybe<Array<Maybe<PrescriptionItem>>>;
  deletePrescriptions?: Maybe<Array<Maybe<Prescription>>>;
  deleteProfilePhoto?: Maybe<ProfilePhoto>;
  deleteProfilePhotos?: Maybe<Array<Maybe<ProfilePhoto>>>;
  deletePrompt?: Maybe<Prompt>;
  deletePrompts?: Maybe<Array<Maybe<Prompt>>>;
  deleteProofOfIdentification?: Maybe<ProofOfIdentification>;
  deleteProofOfIdentifications?: Maybe<Array<Maybe<ProofOfIdentification>>>;
  deleteProofOfInsurance?: Maybe<ProofOfInsurance>;
  deleteProofOfInsurances?: Maybe<Array<Maybe<ProofOfInsurance>>>;
  deleteProofOfLicense?: Maybe<ProofOfLicense>;
  deleteProofOfLicenses?: Maybe<Array<Maybe<ProofOfLicense>>>;
  deleteRecurringSlot?: Maybe<RecurringSlot>;
  deleteRecurringSlots?: Maybe<Array<Maybe<RecurringSlot>>>;
  deleteRemittanceAdvice?: Maybe<RemittanceAdvice>;
  deleteRemittanceAdviceRequest?: Maybe<RemittanceAdviceRequest>;
  deleteRemittanceAdviceRequests?: Maybe<Array<Maybe<RemittanceAdviceRequest>>>;
  deleteRemittanceAdvices?: Maybe<Array<Maybe<RemittanceAdvice>>>;
  deleteRole?: Maybe<Role>;
  deleteRoles?: Maybe<Array<Maybe<Role>>>;
  deleteSchedule?: Maybe<Schedule>;
  deleteSchedules?: Maybe<Array<Maybe<Schedule>>>;
  deleteScreeningTest?: Maybe<ScreeningTest>;
  deleteScreeningTests?: Maybe<Array<Maybe<ScreeningTest>>>;
  deleteSession?: Maybe<Session>;
  deleteSessionEvent?: Maybe<SessionEvent>;
  deleteSessionEvents?: Maybe<Array<Maybe<SessionEvent>>>;
  deleteSessions?: Maybe<Array<Maybe<Session>>>;
  deleteSignature?: Maybe<Signature>;
  deleteSignatures?: Maybe<Array<Maybe<Signature>>>;
  deleteStepper?: Maybe<Stepper>;
  deleteStepperProg?: Maybe<StepperProg>;
  deleteStepperProgs?: Maybe<Array<Maybe<StepperProg>>>;
  deleteStepperStep?: Maybe<StepperStep>;
  deleteStepperStepProg?: Maybe<StepperStepProg>;
  deleteStepperStepProgs?: Maybe<Array<Maybe<StepperStepProg>>>;
  deleteStepperSteps?: Maybe<Array<Maybe<StepperStep>>>;
  deleteSteppers?: Maybe<Array<Maybe<Stepper>>>;
  deleteTask?: Maybe<Task>;
  deleteTasks?: Maybe<Array<Maybe<Task>>>;
  deleteTestOrder?: Maybe<TestOrder>;
  deleteTestOrders?: Maybe<Array<Maybe<TestOrder>>>;
  deleteTestsBatch?: Maybe<TestsBatch>;
  deleteTestsBatches?: Maybe<Array<Maybe<TestsBatch>>>;
  deleteTimeInterval?: Maybe<TimeInterval>;
  deleteTimeIntervals?: Maybe<Array<Maybe<TimeInterval>>>;
  deleteUser?: Maybe<User>;
  deleteUserInvite?: Maybe<UserInvite>;
  deleteUserInvites?: Maybe<Array<Maybe<UserInvite>>>;
  deleteUserSession?: Maybe<UserSession>;
  deleteUserSessions?: Maybe<Array<Maybe<UserSession>>>;
  deleteUsers?: Maybe<Array<Maybe<User>>>;
  deleteVaccination?: Maybe<Vaccination>;
  deleteVaccinations?: Maybe<Array<Maybe<Vaccination>>>;
  deleteVerificationToken?: Maybe<VerificationToken>;
  deleteVerificationTokens?: Maybe<Array<Maybe<VerificationToken>>>;
  endSession: Scalars['Boolean'];
  inviteUserByDoctor?: Maybe<UserInvite>;
  issueForm?: Maybe<Form>;
  logUserSession?: Maybe<UserSession>;
  markAppointmentCancelled?: Maybe<Appointment>;
  markAppointmentMissed?: Maybe<Appointment>;
  markBilling?: Maybe<AppointmentBilling>;
  moveFileToArchive?: Maybe<ArchiveItem>;
  orderFaxNumber?: Maybe<User>;
  patientCancelAppointment?: Maybe<Appointment>;
  playgroundSendFax?: Maybe<InboundFax>;
  reSubmitMyClaimsInCompany?: Maybe<GenericResponse>;
  refreshRemittances?: Maybe<RemittanceAdviceRequest>;
  removeClinic?: Maybe<Clinic>;
  removeCompanyMember?: Maybe<CompanyMemberWithRoles>;
  removePatientFromCompany?: Maybe<Patient>;
  reportAdverseReaction?: Maybe<NotificationDispatchItem>;
  resendFax?: Maybe<Fax>;
  resendUserInviteByDoctor?: Maybe<UserInvite>;
  resolveTask?: Maybe<Task>;
  retrySubmission?: Maybe<AppointmentBilling>;
  sendFax?: Maybe<Fax>;
  startFaxBlast?: Maybe<FaxBlast>;
  submitMyClaimsInCompany?: Maybe<GenericResponse>;
  summarizeDocument?: Maybe<Scalars['JSON']>;
  unmarkBilling?: Maybe<AppointmentBilling>;
  updateAccessToken?: Maybe<AccessToken>;
  updateAccessTokens?: Maybe<Array<Maybe<AccessToken>>>;
  updateAccount?: Maybe<Account>;
  updateAccounts?: Maybe<Array<Maybe<Account>>>;
  updateActiveIngredient?: Maybe<ActiveIngredient>;
  updateActiveIngredients?: Maybe<Array<Maybe<ActiveIngredient>>>;
  updateAddress?: Maybe<Address>;
  updateAddresses?: Maybe<Array<Maybe<Address>>>;
  updateAdministrativeArea?: Maybe<AdministrativeArea>;
  updateAdministrativeAreas?: Maybe<Array<Maybe<AdministrativeArea>>>;
  updateAllergyItem?: Maybe<AllergyItem>;
  updateAllergyItems?: Maybe<Array<Maybe<AllergyItem>>>;
  updateAppointment?: Maybe<Appointment>;
  updateAppointmentBilling?: Maybe<AppointmentBilling>;
  updateAppointmentBillingException?: Maybe<AppointmentBillingException>;
  updateAppointmentBillingExceptions?: Maybe<Array<Maybe<AppointmentBillingException>>>;
  updateAppointmentBillingItem?: Maybe<AppointmentBillingItem>;
  updateAppointmentBillingItems?: Maybe<Array<Maybe<AppointmentBillingItem>>>;
  updateAppointmentBillings?: Maybe<Array<Maybe<AppointmentBilling>>>;
  updateAppointmentDraft?: Maybe<AppointmentDraft>;
  updateAppointmentDrafts?: Maybe<Array<Maybe<AppointmentDraft>>>;
  updateAppointmentNote?: Maybe<AppointmentNote>;
  updateAppointmentNotes?: Maybe<Array<Maybe<AppointmentNote>>>;
  updateAppointmentRequest?: Maybe<AppointmentRequest>;
  updateAppointmentRequests?: Maybe<Array<Maybe<AppointmentRequest>>>;
  updateAppointmentSession?: Maybe<AppointmentSession>;
  updateAppointmentSessions?: Maybe<Array<Maybe<AppointmentSession>>>;
  updateAppointmentVital?: Maybe<AppointmentVital>;
  updateAppointmentVitals?: Maybe<Array<Maybe<AppointmentVital>>>;
  updateAppointments?: Maybe<Array<Maybe<Appointment>>>;
  updateArchive?: Maybe<Archive>;
  updateArchiveItem?: Maybe<ArchiveItem>;
  updateArchiveItems?: Maybe<Array<Maybe<ArchiveItem>>>;
  updateArchives?: Maybe<Array<Maybe<Archive>>>;
  updateBillingClaim?: Maybe<BillingClaim>;
  updateBillingClaims?: Maybe<Array<Maybe<BillingClaim>>>;
  updateBillingDiagnoses?: Maybe<Array<Maybe<BillingDiagnosis>>>;
  updateBillingDiagnosis?: Maybe<BillingDiagnosis>;
  updateBillingPremium?: Maybe<BillingPremium>;
  updateBillingPremiums?: Maybe<Array<Maybe<BillingPremium>>>;
  updateBillingSubmission?: Maybe<BillingSubmission>;
  updateBillingSubmissions?: Maybe<Array<Maybe<BillingSubmission>>>;
  updateBirdSummaryIntent?: Maybe<BirdSummaryIntent>;
  updateBirdSummaryIntents?: Maybe<Array<Maybe<BirdSummaryIntent>>>;
  updateBooking?: Maybe<Booking>;
  updateBookings?: Maybe<Array<Maybe<Booking>>>;
  updateCalendar?: Maybe<Calendar>;
  updateCalendarEvent?: Maybe<CalendarEvent>;
  updateCalendarEventType?: Maybe<CalendarEventType>;
  updateCalendarEventTypes?: Maybe<Array<Maybe<CalendarEventType>>>;
  updateCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  updateCalendars?: Maybe<Array<Maybe<Calendar>>>;
  updateChat?: Maybe<Chat>;
  updateChatMessage?: Maybe<ChatMessage>;
  updateChatMessages?: Maybe<Array<Maybe<ChatMessage>>>;
  updateChats?: Maybe<Array<Maybe<Chat>>>;
  updateClinic?: Maybe<Clinic>;
  updateClinics?: Maybe<Array<Maybe<Clinic>>>;
  updateCompanies?: Maybe<Array<Maybe<Company>>>;
  updateCompany?: Maybe<Company>;
  updateCompanyLogo?: Maybe<CompanyLogo>;
  updateCompanyLogos?: Maybe<Array<Maybe<CompanyLogo>>>;
  updateContract?: Maybe<Contract>;
  updateContracts?: Maybe<Array<Maybe<Contract>>>;
  updateCountries?: Maybe<Array<Maybe<Country>>>;
  updateCountry?: Maybe<Country>;
  updateCoupon?: Maybe<Coupon>;
  updateCoupons?: Maybe<Array<Maybe<Coupon>>>;
  updateDataImport?: Maybe<DataImport>;
  updateDataImportIntent?: Maybe<DataImportIntent>;
  updateDataImportIntents?: Maybe<Array<Maybe<DataImportIntent>>>;
  updateDataImportItem?: Maybe<DataImportItem>;
  updateDataImportItems?: Maybe<Array<Maybe<DataImportItem>>>;
  updateDataImports?: Maybe<Array<Maybe<DataImport>>>;
  updateDoctor?: Maybe<Doctor>;
  updateDoctorSpecialties?: Maybe<Array<Maybe<DoctorSpecialty>>>;
  updateDoctorSpecialty?: Maybe<DoctorSpecialty>;
  updateDoctorSubSpecialties?: Maybe<Array<Maybe<DoctorSubSpecialty>>>;
  updateDoctorSubSpecialty?: Maybe<DoctorSubSpecialty>;
  updateDoctors?: Maybe<Array<Maybe<Doctor>>>;
  updateDocument?: Maybe<Document>;
  updateDocuments?: Maybe<Array<Maybe<Document>>>;
  updateEmergencyContact?: Maybe<EmergencyContact>;
  updateEmergencyContacts?: Maybe<Array<Maybe<EmergencyContact>>>;
  updateFax?: Maybe<Fax>;
  updateFaxBlast?: Maybe<FaxBlast>;
  updateFaxBlastItem?: Maybe<FaxBlastItem>;
  updateFaxBlastItems?: Maybe<Array<Maybe<FaxBlastItem>>>;
  updateFaxBlasts?: Maybe<Array<Maybe<FaxBlast>>>;
  updateFaxRecipient?: Maybe<FaxRecipient>;
  updateFaxRecipients?: Maybe<Array<Maybe<FaxRecipient>>>;
  updateFaxes?: Maybe<Array<Maybe<Fax>>>;
  updateFeedbackItem?: Maybe<FeedbackItem>;
  updateFeedbackItems?: Maybe<Array<Maybe<FeedbackItem>>>;
  updateFile?: Maybe<File>;
  updateFiles?: Maybe<Array<Maybe<File>>>;
  updateForm?: Maybe<Form>;
  updateFormTest?: Maybe<FormTest>;
  updateFormTests?: Maybe<Array<Maybe<FormTest>>>;
  updateFormType?: Maybe<FormType>;
  updateFormTypes?: Maybe<Array<Maybe<FormType>>>;
  updateForms?: Maybe<Array<Maybe<Form>>>;
  updateHealthCard?: Maybe<HealthCard>;
  updateHealthCards?: Maybe<Array<Maybe<HealthCard>>>;
  updateHealthCondition?: Maybe<HealthCondition>;
  updateHealthConditions?: Maybe<Array<Maybe<HealthCondition>>>;
  updateInboundFax?: Maybe<InboundFax>;
  updateInboundFaxes?: Maybe<Array<Maybe<InboundFax>>>;
  updateLanguage?: Maybe<Language>;
  updateLanguages?: Maybe<Array<Maybe<Language>>>;
  updateLeaseAgreement?: Maybe<LeaseAgreement>;
  updateLeaseAgreements?: Maybe<Array<Maybe<LeaseAgreement>>>;
  updateLifestyleItem?: Maybe<LifestyleItem>;
  updateLifestyleItems?: Maybe<Array<Maybe<LifestyleItem>>>;
  updateLuReason?: Maybe<LuReason>;
  updateLuReasons?: Maybe<Array<Maybe<LuReason>>>;
  updateMasterLicense?: Maybe<MasterLicense>;
  updateMasterLicenses?: Maybe<Array<Maybe<MasterLicense>>>;
  updateMedication?: Maybe<Medication>;
  updateMedicationItem?: Maybe<MedicationItem>;
  updateMedicationItems?: Maybe<Array<Maybe<MedicationItem>>>;
  updateMedications?: Maybe<Array<Maybe<Medication>>>;
  updateMember?: Maybe<Member>;
  updateMembers?: Maybe<Array<Maybe<Member>>>;
  updateNotificationDispatch?: Maybe<NotificationDispatch>;
  updateNotificationDispatchItem?: Maybe<NotificationDispatchItem>;
  updateNotificationDispatchItems?: Maybe<Array<Maybe<NotificationDispatchItem>>>;
  updateNotificationDispatches?: Maybe<Array<Maybe<NotificationDispatch>>>;
  updatePatient?: Maybe<Patient>;
  updatePatients?: Maybe<Array<Maybe<Patient>>>;
  updatePharmacies?: Maybe<Array<Maybe<Pharmacy>>>;
  updatePharmacy?: Maybe<Pharmacy>;
  updatePharmacyLocation?: Maybe<PharmacyLocation>;
  updatePharmacyLocations?: Maybe<Array<Maybe<PharmacyLocation>>>;
  updatePrescription?: Maybe<Prescription>;
  updatePrescriptionItem?: Maybe<PrescriptionItem>;
  updatePrescriptionItems?: Maybe<Array<Maybe<PrescriptionItem>>>;
  updatePrescriptions?: Maybe<Array<Maybe<Prescription>>>;
  updateProfilePhoto?: Maybe<ProfilePhoto>;
  updateProfilePhotos?: Maybe<Array<Maybe<ProfilePhoto>>>;
  updatePrompt?: Maybe<Prompt>;
  updatePrompts?: Maybe<Array<Maybe<Prompt>>>;
  updateProofOfIdentification?: Maybe<ProofOfIdentification>;
  updateProofOfIdentifications?: Maybe<Array<Maybe<ProofOfIdentification>>>;
  updateProofOfInsurance?: Maybe<ProofOfInsurance>;
  updateProofOfInsurances?: Maybe<Array<Maybe<ProofOfInsurance>>>;
  updateProofOfLicense?: Maybe<ProofOfLicense>;
  updateProofOfLicenses?: Maybe<Array<Maybe<ProofOfLicense>>>;
  updateRecurringSlot?: Maybe<RecurringSlot>;
  updateRecurringSlots?: Maybe<Array<Maybe<RecurringSlot>>>;
  updateRemittanceAdvice?: Maybe<RemittanceAdvice>;
  updateRemittanceAdviceRequest?: Maybe<RemittanceAdviceRequest>;
  updateRemittanceAdviceRequests?: Maybe<Array<Maybe<RemittanceAdviceRequest>>>;
  updateRemittanceAdvices?: Maybe<Array<Maybe<RemittanceAdvice>>>;
  updateRole?: Maybe<Role>;
  updateRoles?: Maybe<Array<Maybe<Role>>>;
  updateSchedule?: Maybe<Schedule>;
  updateSchedules?: Maybe<Array<Maybe<Schedule>>>;
  updateScreeningTest?: Maybe<ScreeningTest>;
  updateScreeningTests?: Maybe<Array<Maybe<ScreeningTest>>>;
  updateSession?: Maybe<Session>;
  updateSessionEvent?: Maybe<SessionEvent>;
  updateSessionEvents?: Maybe<Array<Maybe<SessionEvent>>>;
  updateSessions?: Maybe<Array<Maybe<Session>>>;
  updateSignature?: Maybe<Signature>;
  updateSignatures?: Maybe<Array<Maybe<Signature>>>;
  updateStepper?: Maybe<Stepper>;
  updateStepperProg?: Maybe<StepperProg>;
  updateStepperProgs?: Maybe<Array<Maybe<StepperProg>>>;
  updateStepperStep?: Maybe<StepperStep>;
  updateStepperStepProg?: Maybe<StepperStepProg>;
  updateStepperStepProgs?: Maybe<Array<Maybe<StepperStepProg>>>;
  updateStepperSteps?: Maybe<Array<Maybe<StepperStep>>>;
  updateSteppers?: Maybe<Array<Maybe<Stepper>>>;
  updateTask?: Maybe<Task>;
  updateTasks?: Maybe<Array<Maybe<Task>>>;
  updateTestOrder?: Maybe<TestOrder>;
  updateTestOrders?: Maybe<Array<Maybe<TestOrder>>>;
  updateTestsBatch?: Maybe<TestsBatch>;
  updateTestsBatches?: Maybe<Array<Maybe<TestsBatch>>>;
  updateTimeInterval?: Maybe<TimeInterval>;
  updateTimeIntervals?: Maybe<Array<Maybe<TimeInterval>>>;
  updateUser?: Maybe<User>;
  updateUserInvite?: Maybe<UserInvite>;
  updateUserInvites?: Maybe<Array<Maybe<UserInvite>>>;
  updateUserSession?: Maybe<UserSession>;
  updateUserSessions?: Maybe<Array<Maybe<UserSession>>>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
  updateVaccination?: Maybe<Vaccination>;
  updateVaccinations?: Maybe<Array<Maybe<Vaccination>>>;
  updateVerificationToken?: Maybe<VerificationToken>;
  updateVerificationTokens?: Maybe<Array<Maybe<VerificationToken>>>;
  uploadBlastList?: Maybe<FaxBlast>;
  uploadDataImport?: Maybe<DataImport>;
  validateHealthCard?: Maybe<HealthCard>;
};


export type MutationAcceptInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationAddChatMessageArgs = {
  chatId: Scalars['ID'];
  replyToMessageId?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};


export type MutationAddClinicArgs = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea: Scalars['String'];
  clinicDescription?: Maybe<Scalars['String']>;
  clinicMemberRole?: Maybe<RoleNameType>;
  clinicMemberRoleAlias?: Maybe<Scalars['String']>;
  clinicName: Scalars['String'];
  clinicPhoneNumber: Scalars['String'];
  companyId: Scalars['ID'];
  country: Scalars['String'];
  facilityMasterNumber?: Maybe<Scalars['String']>;
  leaseAgreement?: Maybe<Scalars['Upload']>;
  locality: Scalars['String'];
  ohipGroupNumber: Scalars['String'];
  postalCode: Scalars['String'];
  serviceLocationIndicator?: Maybe<Scalars['String']>;
};


export type MutationAddCompanyArgs = {
  legalName: Scalars['String'];
  operatingName: Scalars['String'];
};


export type MutationAddMemberArgs = {
  clinicId: Scalars['ID'];
  clinicMemberRole: RoleNameType;
  clinicMemberRoleAlias?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddPatientToCompanyArgs = {
  cellPhoneNumberString: Scalars['String'];
  companyId: Scalars['ID'];
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};


export type MutationCancelAppointmentRequestArgs = {
  appointmentRequestId: Scalars['ID'];
};


export type MutationCancelCompanyOnboardingArgs = {
  companyId: Scalars['ID'];
  stepperProgId: Scalars['ID'];
};


export type MutationCompleteAppointmentArgs = {
  appointmentId: Scalars['ID'];
  faxFile?: Maybe<Scalars['Upload']>;
};


export type MutationCompleteCompanyOnboardingArgs = {
  stepperProgId: Scalars['ID'];
};


export type MutationCompleteMyStepProgArgs = {
  stepId: Scalars['ID'];
};


export type MutationCreateAccessTokenArgs = {
  data: AccessTokenCreateInput;
};


export type MutationCreateAccessTokensArgs = {
  data: Array<AccessTokenCreateInput>;
};


export type MutationCreateAccountArgs = {
  data: AccountCreateInput;
};


export type MutationCreateAccountsArgs = {
  data: Array<AccountCreateInput>;
};


export type MutationCreateActiveIngredientArgs = {
  data: ActiveIngredientCreateInput;
};


export type MutationCreateActiveIngredientsArgs = {
  data: Array<ActiveIngredientCreateInput>;
};


export type MutationCreateAddressArgs = {
  data: AddressCreateInput;
};


export type MutationCreateAddressesArgs = {
  data: Array<AddressCreateInput>;
};


export type MutationCreateAdministrativeAreaArgs = {
  data: AdministrativeAreaCreateInput;
};


export type MutationCreateAdministrativeAreasArgs = {
  data: Array<AdministrativeAreaCreateInput>;
};


export type MutationCreateAllergyItemArgs = {
  data: AllergyItemCreateInput;
};


export type MutationCreateAllergyItemsArgs = {
  data: Array<AllergyItemCreateInput>;
};


export type MutationCreateAppointmentArgs = {
  data: AppointmentCreateInput;
};


export type MutationCreateAppointmentBillingArgs = {
  data: AppointmentBillingCreateInput;
};


export type MutationCreateAppointmentBillingExceptionArgs = {
  data: AppointmentBillingExceptionCreateInput;
};


export type MutationCreateAppointmentBillingExceptionsArgs = {
  data: Array<AppointmentBillingExceptionCreateInput>;
};


export type MutationCreateAppointmentBillingItemArgs = {
  data: AppointmentBillingItemCreateInput;
};


export type MutationCreateAppointmentBillingItemsArgs = {
  data: Array<AppointmentBillingItemCreateInput>;
};


export type MutationCreateAppointmentBillingsArgs = {
  data: Array<AppointmentBillingCreateInput>;
};


export type MutationCreateAppointmentDraftArgs = {
  data: AppointmentDraftCreateInput;
};


export type MutationCreateAppointmentDraftsArgs = {
  data: Array<AppointmentDraftCreateInput>;
};


export type MutationCreateAppointmentNoteArgs = {
  data: AppointmentNoteCreateInput;
};


export type MutationCreateAppointmentNotesArgs = {
  data: Array<AppointmentNoteCreateInput>;
};


export type MutationCreateAppointmentRequestArgs = {
  data: AppointmentRequestCreateInput;
};


export type MutationCreateAppointmentRequestsArgs = {
  data: Array<AppointmentRequestCreateInput>;
};


export type MutationCreateAppointmentSessionArgs = {
  data: AppointmentSessionCreateInput;
};


export type MutationCreateAppointmentSessionsArgs = {
  data: Array<AppointmentSessionCreateInput>;
};


export type MutationCreateAppointmentVitalArgs = {
  data: AppointmentVitalCreateInput;
};


export type MutationCreateAppointmentVitalsArgs = {
  data: Array<AppointmentVitalCreateInput>;
};


export type MutationCreateAppointmentsArgs = {
  data: Array<AppointmentCreateInput>;
};


export type MutationCreateArchiveArgs = {
  data: ArchiveCreateInput;
};


export type MutationCreateArchiveItemArgs = {
  data: ArchiveItemCreateInput;
};


export type MutationCreateArchiveItemsArgs = {
  data: Array<ArchiveItemCreateInput>;
};


export type MutationCreateArchivesArgs = {
  data: Array<ArchiveCreateInput>;
};


export type MutationCreateBillingClaimArgs = {
  data: BillingClaimCreateInput;
};


export type MutationCreateBillingClaimsArgs = {
  data: Array<BillingClaimCreateInput>;
};


export type MutationCreateBillingDiagnosesArgs = {
  data: Array<BillingDiagnosisCreateInput>;
};


export type MutationCreateBillingDiagnosisArgs = {
  data: BillingDiagnosisCreateInput;
};


export type MutationCreateBillingPremiumArgs = {
  data: BillingPremiumCreateInput;
};


export type MutationCreateBillingPremiumsArgs = {
  data: Array<BillingPremiumCreateInput>;
};


export type MutationCreateBillingSubmissionArgs = {
  data: BillingSubmissionCreateInput;
};


export type MutationCreateBillingSubmissionsArgs = {
  data: Array<BillingSubmissionCreateInput>;
};


export type MutationCreateBirdSummaryIntentArgs = {
  data: BirdSummaryIntentCreateInput;
};


export type MutationCreateBirdSummaryIntentsArgs = {
  data: Array<BirdSummaryIntentCreateInput>;
};


export type MutationCreateBookingArgs = {
  data: BookingCreateInput;
};


export type MutationCreateBookingsArgs = {
  data: Array<BookingCreateInput>;
};


export type MutationCreateBucketFileArgs = {
  documentId?: Maybe<Scalars['ID']>;
  faxBlastId?: Maybe<Scalars['ID']>;
  faxId?: Maybe<Scalars['ID']>;
  fileKey: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  fileType: Scalars['String'];
  leaseAgreementId?: Maybe<Scalars['ID']>;
  masterLicenseId?: Maybe<Scalars['ID']>;
  proofOfIdentificationId?: Maybe<Scalars['ID']>;
  proofOfInsuranceId?: Maybe<Scalars['ID']>;
  proofOfLicenseId?: Maybe<Scalars['ID']>;
  signatureId?: Maybe<Scalars['ID']>;
};


export type MutationCreateCalendarArgs = {
  data: CalendarCreateInput;
};


export type MutationCreateCalendarEventArgs = {
  data: CalendarEventCreateInput;
};


export type MutationCreateCalendarEventBookingArgs = {
  clinicId?: Maybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  memberId?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  tzTarget?: Maybe<Scalars['String']>;
};


export type MutationCreateCalendarEventTypeArgs = {
  data: CalendarEventTypeCreateInput;
};


export type MutationCreateCalendarEventTypesArgs = {
  data: Array<CalendarEventTypeCreateInput>;
};


export type MutationCreateCalendarEventsArgs = {
  data: Array<CalendarEventCreateInput>;
};


export type MutationCreateCalendarsArgs = {
  data: Array<CalendarCreateInput>;
};


export type MutationCreateChatArgs = {
  data: ChatCreateInput;
};


export type MutationCreateChatMessageArgs = {
  data: ChatMessageCreateInput;
};


export type MutationCreateChatMessagesArgs = {
  data: Array<ChatMessageCreateInput>;
};


export type MutationCreateChatsArgs = {
  data: Array<ChatCreateInput>;
};


export type MutationCreateClinicArgs = {
  data: ClinicCreateInput;
};


export type MutationCreateClinicsArgs = {
  data: Array<ClinicCreateInput>;
};


export type MutationCreateCompaniesArgs = {
  data: Array<CompanyCreateInput>;
};


export type MutationCreateCompanyArgs = {
  data: CompanyCreateInput;
};


export type MutationCreateCompanyLogoArgs = {
  data: CompanyLogoCreateInput;
};


export type MutationCreateCompanyLogosArgs = {
  data: Array<CompanyLogoCreateInput>;
};


export type MutationCreateContractArgs = {
  data: ContractCreateInput;
};


export type MutationCreateContractsArgs = {
  data: Array<ContractCreateInput>;
};


export type MutationCreateCountriesArgs = {
  data: Array<CountryCreateInput>;
};


export type MutationCreateCountryArgs = {
  data: CountryCreateInput;
};


export type MutationCreateCouponArgs = {
  data: CouponCreateInput;
};


export type MutationCreateCouponsArgs = {
  data: Array<CouponCreateInput>;
};


export type MutationCreateDataImportArgs = {
  data: DataImportCreateInput;
};


export type MutationCreateDataImportIntentArgs = {
  data: DataImportIntentCreateInput;
};


export type MutationCreateDataImportIntentsArgs = {
  data: Array<DataImportIntentCreateInput>;
};


export type MutationCreateDataImportItemArgs = {
  data: DataImportItemCreateInput;
};


export type MutationCreateDataImportItemsArgs = {
  data: Array<DataImportItemCreateInput>;
};


export type MutationCreateDataImportsArgs = {
  data: Array<DataImportCreateInput>;
};


export type MutationCreateDoctorArgs = {
  data: DoctorCreateInput;
};


export type MutationCreateDoctorCalendarEventBookingArgs = {
  clinicId?: Maybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  memberId?: Maybe<Scalars['ID']>;
  patientId?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  tzTarget?: Maybe<Scalars['String']>;
};


export type MutationCreateDoctorSpecialtiesArgs = {
  data: Array<DoctorSpecialtyCreateInput>;
};


export type MutationCreateDoctorSpecialtyArgs = {
  data: DoctorSpecialtyCreateInput;
};


export type MutationCreateDoctorSubSpecialtiesArgs = {
  data: Array<DoctorSubSpecialtyCreateInput>;
};


export type MutationCreateDoctorSubSpecialtyArgs = {
  data: DoctorSubSpecialtyCreateInput;
};


export type MutationCreateDoctorsArgs = {
  data: Array<DoctorCreateInput>;
};


export type MutationCreateDocumentArgs = {
  data: DocumentCreateInput;
};


export type MutationCreateDocumentsArgs = {
  data: Array<DocumentCreateInput>;
};


export type MutationCreateEmergencyContactArgs = {
  data: EmergencyContactCreateInput;
};


export type MutationCreateEmergencyContactsArgs = {
  data: Array<EmergencyContactCreateInput>;
};


export type MutationCreateFaxArgs = {
  data: FaxCreateInput;
};


export type MutationCreateFaxBlastArgs = {
  data: FaxBlastCreateInput;
};


export type MutationCreateFaxBlastItemArgs = {
  data: FaxBlastItemCreateInput;
};


export type MutationCreateFaxBlastItemsArgs = {
  data: Array<FaxBlastItemCreateInput>;
};


export type MutationCreateFaxBlastsArgs = {
  data: Array<FaxBlastCreateInput>;
};


export type MutationCreateFaxRecipientArgs = {
  data: FaxRecipientCreateInput;
};


export type MutationCreateFaxRecipientsArgs = {
  data: Array<FaxRecipientCreateInput>;
};


export type MutationCreateFaxesArgs = {
  data: Array<FaxCreateInput>;
};


export type MutationCreateFeedbackItemArgs = {
  data: FeedbackItemCreateInput;
};


export type MutationCreateFeedbackItemsArgs = {
  data: Array<FeedbackItemCreateInput>;
};


export type MutationCreateFileArgs = {
  data: FileCreateInput;
};


export type MutationCreateFilesArgs = {
  data: Array<FileCreateInput>;
};


export type MutationCreateFormArgs = {
  data: FormCreateInput;
};


export type MutationCreateFormTestArgs = {
  data: FormTestCreateInput;
};


export type MutationCreateFormTestsArgs = {
  data: Array<FormTestCreateInput>;
};


export type MutationCreateFormTypeArgs = {
  data: FormTypeCreateInput;
};


export type MutationCreateFormTypesArgs = {
  data: Array<FormTypeCreateInput>;
};


export type MutationCreateFormsArgs = {
  data: Array<FormCreateInput>;
};


export type MutationCreateHealthCardArgs = {
  data: HealthCardCreateInput;
};


export type MutationCreateHealthCardsArgs = {
  data: Array<HealthCardCreateInput>;
};


export type MutationCreateHealthConditionArgs = {
  data: HealthConditionCreateInput;
};


export type MutationCreateHealthConditionsArgs = {
  data: Array<HealthConditionCreateInput>;
};


export type MutationCreateInboundFaxArgs = {
  data: InboundFaxCreateInput;
};


export type MutationCreateInboundFaxesArgs = {
  data: Array<InboundFaxCreateInput>;
};


export type MutationCreateLanguageArgs = {
  data: LanguageCreateInput;
};


export type MutationCreateLanguagesArgs = {
  data: Array<LanguageCreateInput>;
};


export type MutationCreateLeaseAgreementArgs = {
  data: LeaseAgreementCreateInput;
};


export type MutationCreateLeaseAgreementsArgs = {
  data: Array<LeaseAgreementCreateInput>;
};


export type MutationCreateLifestyleItemArgs = {
  data: LifestyleItemCreateInput;
};


export type MutationCreateLifestyleItemsArgs = {
  data: Array<LifestyleItemCreateInput>;
};


export type MutationCreateLuReasonArgs = {
  data: LuReasonCreateInput;
};


export type MutationCreateLuReasonsArgs = {
  data: Array<LuReasonCreateInput>;
};


export type MutationCreateMasterLicenseArgs = {
  data: MasterLicenseCreateInput;
};


export type MutationCreateMasterLicensesArgs = {
  data: Array<MasterLicenseCreateInput>;
};


export type MutationCreateMedicalHistoryLinkArgs = {
  validTo: Scalars['DateTime'];
};


export type MutationCreateMedicationArgs = {
  data: MedicationCreateInput;
};


export type MutationCreateMedicationItemArgs = {
  data: MedicationItemCreateInput;
};


export type MutationCreateMedicationItemsArgs = {
  data: Array<MedicationItemCreateInput>;
};


export type MutationCreateMedicationsArgs = {
  data: Array<MedicationCreateInput>;
};


export type MutationCreateMemberArgs = {
  data: MemberCreateInput;
};


export type MutationCreateMemberDataImportIntentArgs = {
  memberId: Scalars['ID'];
  source: Scalars['String'];
};


export type MutationCreateMembersArgs = {
  data: Array<MemberCreateInput>;
};


export type MutationCreateNotificationDispatchArgs = {
  data: NotificationDispatchCreateInput;
};


export type MutationCreateNotificationDispatchItemArgs = {
  data: NotificationDispatchItemCreateInput;
};


export type MutationCreateNotificationDispatchItemsArgs = {
  data: Array<NotificationDispatchItemCreateInput>;
};


export type MutationCreateNotificationDispatchesArgs = {
  data: Array<NotificationDispatchCreateInput>;
};


export type MutationCreateOrUpdateTaskArgs = {
  appointmentId: Scalars['ID'];
  assignedToId: Scalars['ID'];
  companyId?: Maybe<Scalars['ID']>;
  description: Scalars['String'];
  dueAt?: Maybe<Scalars['String']>;
  patientId: Scalars['ID'];
  priority: TaskPriorityType;
  taskId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
};


export type MutationCreatePatientArgs = {
  data: PatientCreateInput;
};


export type MutationCreatePatientsArgs = {
  data: Array<PatientCreateInput>;
};


export type MutationCreatePharmaciesArgs = {
  data: Array<PharmacyCreateInput>;
};


export type MutationCreatePharmacyArgs = {
  data: PharmacyCreateInput;
};


export type MutationCreatePharmacyLocationArgs = {
  data: PharmacyLocationCreateInput;
};


export type MutationCreatePharmacyLocationsArgs = {
  data: Array<PharmacyLocationCreateInput>;
};


export type MutationCreatePrescriptionArgs = {
  data: PrescriptionCreateInput;
};


export type MutationCreatePrescriptionItemArgs = {
  data: PrescriptionItemCreateInput;
};


export type MutationCreatePrescriptionItemsArgs = {
  data: Array<PrescriptionItemCreateInput>;
};


export type MutationCreatePrescriptionsArgs = {
  data: Array<PrescriptionCreateInput>;
};


export type MutationCreateProfilePhotoArgs = {
  data: ProfilePhotoCreateInput;
};


export type MutationCreateProfilePhotosArgs = {
  data: Array<ProfilePhotoCreateInput>;
};


export type MutationCreatePromptArgs = {
  data: PromptCreateInput;
};


export type MutationCreatePromptsArgs = {
  data: Array<PromptCreateInput>;
};


export type MutationCreateProofOfIdentificationArgs = {
  data: ProofOfIdentificationCreateInput;
};


export type MutationCreateProofOfIdentificationsArgs = {
  data: Array<ProofOfIdentificationCreateInput>;
};


export type MutationCreateProofOfInsuranceArgs = {
  data: ProofOfInsuranceCreateInput;
};


export type MutationCreateProofOfInsurancesArgs = {
  data: Array<ProofOfInsuranceCreateInput>;
};


export type MutationCreateProofOfLicenseArgs = {
  data: ProofOfLicenseCreateInput;
};


export type MutationCreateProofOfLicensesArgs = {
  data: Array<ProofOfLicenseCreateInput>;
};


export type MutationCreateRecurringSlotArgs = {
  data: RecurringSlotCreateInput;
};


export type MutationCreateRecurringSlotsArgs = {
  data: Array<RecurringSlotCreateInput>;
};


export type MutationCreateRemittanceAdviceArgs = {
  data: RemittanceAdviceCreateInput;
};


export type MutationCreateRemittanceAdviceRequestArgs = {
  data: RemittanceAdviceRequestCreateInput;
};


export type MutationCreateRemittanceAdviceRequestsArgs = {
  data: Array<RemittanceAdviceRequestCreateInput>;
};


export type MutationCreateRemittanceAdvicesArgs = {
  data: Array<RemittanceAdviceCreateInput>;
};


export type MutationCreateRoleArgs = {
  data: RoleCreateInput;
};


export type MutationCreateRolesArgs = {
  data: Array<RoleCreateInput>;
};


export type MutationCreateScheduleArgs = {
  data: ScheduleCreateInput;
};


export type MutationCreateSchedulesArgs = {
  data: Array<ScheduleCreateInput>;
};


export type MutationCreateScreeningTestArgs = {
  data: ScreeningTestCreateInput;
};


export type MutationCreateScreeningTestsArgs = {
  data: Array<ScreeningTestCreateInput>;
};


export type MutationCreateSessionArgs = {
  data: SessionCreateInput;
};


export type MutationCreateSessionEventArgs = {
  data: SessionEventCreateInput;
};


export type MutationCreateSessionEventsArgs = {
  data: Array<SessionEventCreateInput>;
};


export type MutationCreateSessionsArgs = {
  data: Array<SessionCreateInput>;
};


export type MutationCreateSignatureArgs = {
  data: SignatureCreateInput;
};


export type MutationCreateSignaturesArgs = {
  data: Array<SignatureCreateInput>;
};


export type MutationCreateStepperArgs = {
  data: StepperCreateInput;
};


export type MutationCreateStepperProgArgs = {
  data: StepperProgCreateInput;
};


export type MutationCreateStepperProgsArgs = {
  data: Array<StepperProgCreateInput>;
};


export type MutationCreateStepperStepArgs = {
  data: StepperStepCreateInput;
};


export type MutationCreateStepperStepProgArgs = {
  data: StepperStepProgCreateInput;
};


export type MutationCreateStepperStepProgsArgs = {
  data: Array<StepperStepProgCreateInput>;
};


export type MutationCreateStepperStepsArgs = {
  data: Array<StepperStepCreateInput>;
};


export type MutationCreateSteppersArgs = {
  data: Array<StepperCreateInput>;
};


export type MutationCreateTaskArgs = {
  data: TaskCreateInput;
};


export type MutationCreateTasksArgs = {
  data: Array<TaskCreateInput>;
};


export type MutationCreateTestOrderArgs = {
  data: TestOrderCreateInput;
};


export type MutationCreateTestOrdersArgs = {
  data: Array<TestOrderCreateInput>;
};


export type MutationCreateTestsBatchArgs = {
  data: TestsBatchCreateInput;
};


export type MutationCreateTestsBatchesArgs = {
  data: Array<TestsBatchCreateInput>;
};


export type MutationCreateTimeIntervalArgs = {
  data: TimeIntervalCreateInput;
};


export type MutationCreateTimeIntervalsArgs = {
  data: Array<TimeIntervalCreateInput>;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateUserInviteArgs = {
  data: UserInviteCreateInput;
};


export type MutationCreateUserInvitesArgs = {
  data: Array<UserInviteCreateInput>;
};


export type MutationCreateUserSessionArgs = {
  data: UserSessionCreateInput;
};


export type MutationCreateUserSessionsArgs = {
  data: Array<UserSessionCreateInput>;
};


export type MutationCreateUsersArgs = {
  data: Array<UserCreateInput>;
};


export type MutationCreateVaccinationArgs = {
  data: VaccinationCreateInput;
};


export type MutationCreateVaccinationsArgs = {
  data: Array<VaccinationCreateInput>;
};


export type MutationCreateVerificationTokenArgs = {
  data: VerificationTokenCreateInput;
};


export type MutationCreateVerificationTokensArgs = {
  data: Array<VerificationTokenCreateInput>;
};


export type MutationCreateWalkInAppointmentArgs = {
  clinicId: Scalars['ID'];
  eventId: Scalars['ID'];
  isInvalidHealthCard?: Maybe<Scalars['Boolean']>;
  memberId: Scalars['ID'];
  patientId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationDeleteAccessTokenArgs = {
  where: AccessTokenWhereUniqueInput;
};


export type MutationDeleteAccessTokensArgs = {
  where: Array<AccessTokenWhereUniqueInput>;
};


export type MutationDeleteAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type MutationDeleteAccountsArgs = {
  where: Array<AccountWhereUniqueInput>;
};


export type MutationDeleteActiveIngredientArgs = {
  where: ActiveIngredientWhereUniqueInput;
};


export type MutationDeleteActiveIngredientsArgs = {
  where: Array<ActiveIngredientWhereUniqueInput>;
};


export type MutationDeleteAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type MutationDeleteAddressesArgs = {
  where: Array<AddressWhereUniqueInput>;
};


export type MutationDeleteAdministrativeAreaArgs = {
  where: AdministrativeAreaWhereUniqueInput;
};


export type MutationDeleteAdministrativeAreasArgs = {
  where: Array<AdministrativeAreaWhereUniqueInput>;
};


export type MutationDeleteAllergyItemArgs = {
  where: AllergyItemWhereUniqueInput;
};


export type MutationDeleteAllergyItemsArgs = {
  where: Array<AllergyItemWhereUniqueInput>;
};


export type MutationDeleteAppointmentArgs = {
  where: AppointmentWhereUniqueInput;
};


export type MutationDeleteAppointmentBillingArgs = {
  where: AppointmentBillingWhereUniqueInput;
};


export type MutationDeleteAppointmentBillingExceptionArgs = {
  where: AppointmentBillingExceptionWhereUniqueInput;
};


export type MutationDeleteAppointmentBillingExceptionsArgs = {
  where: Array<AppointmentBillingExceptionWhereUniqueInput>;
};


export type MutationDeleteAppointmentBillingItemArgs = {
  where: AppointmentBillingItemWhereUniqueInput;
};


export type MutationDeleteAppointmentBillingItemsArgs = {
  where: Array<AppointmentBillingItemWhereUniqueInput>;
};


export type MutationDeleteAppointmentBillingsArgs = {
  where: Array<AppointmentBillingWhereUniqueInput>;
};


export type MutationDeleteAppointmentDraftArgs = {
  where: AppointmentDraftWhereUniqueInput;
};


export type MutationDeleteAppointmentDraftsArgs = {
  where: Array<AppointmentDraftWhereUniqueInput>;
};


export type MutationDeleteAppointmentNoteArgs = {
  where: AppointmentNoteWhereUniqueInput;
};


export type MutationDeleteAppointmentNotesArgs = {
  where: Array<AppointmentNoteWhereUniqueInput>;
};


export type MutationDeleteAppointmentRequestArgs = {
  where: AppointmentRequestWhereUniqueInput;
};


export type MutationDeleteAppointmentRequestsArgs = {
  where: Array<AppointmentRequestWhereUniqueInput>;
};


export type MutationDeleteAppointmentSessionArgs = {
  where: AppointmentSessionWhereUniqueInput;
};


export type MutationDeleteAppointmentSessionsArgs = {
  where: Array<AppointmentSessionWhereUniqueInput>;
};


export type MutationDeleteAppointmentVitalArgs = {
  where: AppointmentVitalWhereUniqueInput;
};


export type MutationDeleteAppointmentVitalsArgs = {
  where: Array<AppointmentVitalWhereUniqueInput>;
};


export type MutationDeleteAppointmentsArgs = {
  where: Array<AppointmentWhereUniqueInput>;
};


export type MutationDeleteArchiveArgs = {
  where: ArchiveWhereUniqueInput;
};


export type MutationDeleteArchiveItemArgs = {
  where: ArchiveItemWhereUniqueInput;
};


export type MutationDeleteArchiveItemsArgs = {
  where: Array<ArchiveItemWhereUniqueInput>;
};


export type MutationDeleteArchivesArgs = {
  where: Array<ArchiveWhereUniqueInput>;
};


export type MutationDeleteBillingClaimArgs = {
  where: BillingClaimWhereUniqueInput;
};


export type MutationDeleteBillingClaimsArgs = {
  where: Array<BillingClaimWhereUniqueInput>;
};


export type MutationDeleteBillingDiagnosesArgs = {
  where: Array<BillingDiagnosisWhereUniqueInput>;
};


export type MutationDeleteBillingDiagnosisArgs = {
  where: BillingDiagnosisWhereUniqueInput;
};


export type MutationDeleteBillingPremiumArgs = {
  where: BillingPremiumWhereUniqueInput;
};


export type MutationDeleteBillingPremiumsArgs = {
  where: Array<BillingPremiumWhereUniqueInput>;
};


export type MutationDeleteBillingSubmissionArgs = {
  where: BillingSubmissionWhereUniqueInput;
};


export type MutationDeleteBillingSubmissionsArgs = {
  where: Array<BillingSubmissionWhereUniqueInput>;
};


export type MutationDeleteBirdSummaryIntentArgs = {
  where: BirdSummaryIntentWhereUniqueInput;
};


export type MutationDeleteBirdSummaryIntentsArgs = {
  where: Array<BirdSummaryIntentWhereUniqueInput>;
};


export type MutationDeleteBookingArgs = {
  where: BookingWhereUniqueInput;
};


export type MutationDeleteBookingsArgs = {
  where: Array<BookingWhereUniqueInput>;
};


export type MutationDeleteCalendarArgs = {
  where: CalendarWhereUniqueInput;
};


export type MutationDeleteCalendarEventArgs = {
  where: CalendarEventWhereUniqueInput;
};


export type MutationDeleteCalendarEventTypeArgs = {
  where: CalendarEventTypeWhereUniqueInput;
};


export type MutationDeleteCalendarEventTypesArgs = {
  where: Array<CalendarEventTypeWhereUniqueInput>;
};


export type MutationDeleteCalendarEventsArgs = {
  where: Array<CalendarEventWhereUniqueInput>;
};


export type MutationDeleteCalendarsArgs = {
  where: Array<CalendarWhereUniqueInput>;
};


export type MutationDeleteChatArgs = {
  where: ChatWhereUniqueInput;
};


export type MutationDeleteChatMessageArgs = {
  where: ChatMessageWhereUniqueInput;
};


export type MutationDeleteChatMessagesArgs = {
  where: Array<ChatMessageWhereUniqueInput>;
};


export type MutationDeleteChatsArgs = {
  where: Array<ChatWhereUniqueInput>;
};


export type MutationDeleteClinicArgs = {
  where: ClinicWhereUniqueInput;
};


export type MutationDeleteClinicsArgs = {
  where: Array<ClinicWhereUniqueInput>;
};


export type MutationDeleteCompaniesArgs = {
  where: Array<CompanyWhereUniqueInput>;
};


export type MutationDeleteCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationDeleteCompanyLogoArgs = {
  where: CompanyLogoWhereUniqueInput;
};


export type MutationDeleteCompanyLogosArgs = {
  where: Array<CompanyLogoWhereUniqueInput>;
};


export type MutationDeleteContractArgs = {
  where: ContractWhereUniqueInput;
};


export type MutationDeleteContractsArgs = {
  where: Array<ContractWhereUniqueInput>;
};


export type MutationDeleteCountriesArgs = {
  where: Array<CountryWhereUniqueInput>;
};


export type MutationDeleteCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type MutationDeleteCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type MutationDeleteCouponsArgs = {
  where: Array<CouponWhereUniqueInput>;
};


export type MutationDeleteDataImportArgs = {
  where: DataImportWhereUniqueInput;
};


export type MutationDeleteDataImportIntentArgs = {
  where: DataImportIntentWhereUniqueInput;
};


export type MutationDeleteDataImportIntentsArgs = {
  where: Array<DataImportIntentWhereUniqueInput>;
};


export type MutationDeleteDataImportItemArgs = {
  where: DataImportItemWhereUniqueInput;
};


export type MutationDeleteDataImportItemsArgs = {
  where: Array<DataImportItemWhereUniqueInput>;
};


export type MutationDeleteDataImportsArgs = {
  where: Array<DataImportWhereUniqueInput>;
};


export type MutationDeleteDoctorArgs = {
  where: DoctorWhereUniqueInput;
};


export type MutationDeleteDoctorSpecialtiesArgs = {
  where: Array<DoctorSpecialtyWhereUniqueInput>;
};


export type MutationDeleteDoctorSpecialtyArgs = {
  where: DoctorSpecialtyWhereUniqueInput;
};


export type MutationDeleteDoctorSubSpecialtiesArgs = {
  where: Array<DoctorSubSpecialtyWhereUniqueInput>;
};


export type MutationDeleteDoctorSubSpecialtyArgs = {
  where: DoctorSubSpecialtyWhereUniqueInput;
};


export type MutationDeleteDoctorsArgs = {
  where: Array<DoctorWhereUniqueInput>;
};


export type MutationDeleteDocumentArgs = {
  where: DocumentWhereUniqueInput;
};


export type MutationDeleteDocumentsArgs = {
  where: Array<DocumentWhereUniqueInput>;
};


export type MutationDeleteEmergencyContactArgs = {
  where: EmergencyContactWhereUniqueInput;
};


export type MutationDeleteEmergencyContactsArgs = {
  where: Array<EmergencyContactWhereUniqueInput>;
};


export type MutationDeleteFaxArgs = {
  where: FaxWhereUniqueInput;
};


export type MutationDeleteFaxBlastArgs = {
  where: FaxBlastWhereUniqueInput;
};


export type MutationDeleteFaxBlastItemArgs = {
  where: FaxBlastItemWhereUniqueInput;
};


export type MutationDeleteFaxBlastItemsArgs = {
  where: Array<FaxBlastItemWhereUniqueInput>;
};


export type MutationDeleteFaxBlastsArgs = {
  where: Array<FaxBlastWhereUniqueInput>;
};


export type MutationDeleteFaxRecipientArgs = {
  where: FaxRecipientWhereUniqueInput;
};


export type MutationDeleteFaxRecipientsArgs = {
  where: Array<FaxRecipientWhereUniqueInput>;
};


export type MutationDeleteFaxesArgs = {
  where: Array<FaxWhereUniqueInput>;
};


export type MutationDeleteFeedbackItemArgs = {
  where: FeedbackItemWhereUniqueInput;
};


export type MutationDeleteFeedbackItemsArgs = {
  where: Array<FeedbackItemWhereUniqueInput>;
};


export type MutationDeleteFileArgs = {
  where: FileWhereUniqueInput;
};


export type MutationDeleteFilesArgs = {
  where: Array<FileWhereUniqueInput>;
};


export type MutationDeleteFormArgs = {
  where: FormWhereUniqueInput;
};


export type MutationDeleteFormTestArgs = {
  where: FormTestWhereUniqueInput;
};


export type MutationDeleteFormTestsArgs = {
  where: Array<FormTestWhereUniqueInput>;
};


export type MutationDeleteFormTypeArgs = {
  where: FormTypeWhereUniqueInput;
};


export type MutationDeleteFormTypesArgs = {
  where: Array<FormTypeWhereUniqueInput>;
};


export type MutationDeleteFormsArgs = {
  where: Array<FormWhereUniqueInput>;
};


export type MutationDeleteHealthCardArgs = {
  where: HealthCardWhereUniqueInput;
};


export type MutationDeleteHealthCardsArgs = {
  where: Array<HealthCardWhereUniqueInput>;
};


export type MutationDeleteHealthConditionArgs = {
  where: HealthConditionWhereUniqueInput;
};


export type MutationDeleteHealthConditionsArgs = {
  where: Array<HealthConditionWhereUniqueInput>;
};


export type MutationDeleteInboundFaxArgs = {
  where: InboundFaxWhereUniqueInput;
};


export type MutationDeleteInboundFaxesArgs = {
  where: Array<InboundFaxWhereUniqueInput>;
};


export type MutationDeleteLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type MutationDeleteLanguagesArgs = {
  where: Array<LanguageWhereUniqueInput>;
};


export type MutationDeleteLeaseAgreementArgs = {
  where: LeaseAgreementWhereUniqueInput;
};


export type MutationDeleteLeaseAgreementsArgs = {
  where: Array<LeaseAgreementWhereUniqueInput>;
};


export type MutationDeleteLifestyleItemArgs = {
  where: LifestyleItemWhereUniqueInput;
};


export type MutationDeleteLifestyleItemsArgs = {
  where: Array<LifestyleItemWhereUniqueInput>;
};


export type MutationDeleteLuReasonArgs = {
  where: LuReasonWhereUniqueInput;
};


export type MutationDeleteLuReasonsArgs = {
  where: Array<LuReasonWhereUniqueInput>;
};


export type MutationDeleteMasterLicenseArgs = {
  where: MasterLicenseWhereUniqueInput;
};


export type MutationDeleteMasterLicensesArgs = {
  where: Array<MasterLicenseWhereUniqueInput>;
};


export type MutationDeleteMedicationArgs = {
  where: MedicationWhereUniqueInput;
};


export type MutationDeleteMedicationItemArgs = {
  where: MedicationItemWhereUniqueInput;
};


export type MutationDeleteMedicationItemsArgs = {
  where: Array<MedicationItemWhereUniqueInput>;
};


export type MutationDeleteMedicationsArgs = {
  where: Array<MedicationWhereUniqueInput>;
};


export type MutationDeleteMemberArgs = {
  where: MemberWhereUniqueInput;
};


export type MutationDeleteMembersArgs = {
  where: Array<MemberWhereUniqueInput>;
};


export type MutationDeleteNotificationDispatchArgs = {
  where: NotificationDispatchWhereUniqueInput;
};


export type MutationDeleteNotificationDispatchItemArgs = {
  where: NotificationDispatchItemWhereUniqueInput;
};


export type MutationDeleteNotificationDispatchItemsArgs = {
  where: Array<NotificationDispatchItemWhereUniqueInput>;
};


export type MutationDeleteNotificationDispatchesArgs = {
  where: Array<NotificationDispatchWhereUniqueInput>;
};


export type MutationDeletePatientArgs = {
  where: PatientWhereUniqueInput;
};


export type MutationDeletePatientsArgs = {
  where: Array<PatientWhereUniqueInput>;
};


export type MutationDeletePharmaciesArgs = {
  where: Array<PharmacyWhereUniqueInput>;
};


export type MutationDeletePharmacyArgs = {
  where: PharmacyWhereUniqueInput;
};


export type MutationDeletePharmacyLocationArgs = {
  where: PharmacyLocationWhereUniqueInput;
};


export type MutationDeletePharmacyLocationsArgs = {
  where: Array<PharmacyLocationWhereUniqueInput>;
};


export type MutationDeletePrescriptionArgs = {
  where: PrescriptionWhereUniqueInput;
};


export type MutationDeletePrescriptionItemArgs = {
  where: PrescriptionItemWhereUniqueInput;
};


export type MutationDeletePrescriptionItemsArgs = {
  where: Array<PrescriptionItemWhereUniqueInput>;
};


export type MutationDeletePrescriptionsArgs = {
  where: Array<PrescriptionWhereUniqueInput>;
};


export type MutationDeleteProfilePhotoArgs = {
  where: ProfilePhotoWhereUniqueInput;
};


export type MutationDeleteProfilePhotosArgs = {
  where: Array<ProfilePhotoWhereUniqueInput>;
};


export type MutationDeletePromptArgs = {
  where: PromptWhereUniqueInput;
};


export type MutationDeletePromptsArgs = {
  where: Array<PromptWhereUniqueInput>;
};


export type MutationDeleteProofOfIdentificationArgs = {
  where: ProofOfIdentificationWhereUniqueInput;
};


export type MutationDeleteProofOfIdentificationsArgs = {
  where: Array<ProofOfIdentificationWhereUniqueInput>;
};


export type MutationDeleteProofOfInsuranceArgs = {
  where: ProofOfInsuranceWhereUniqueInput;
};


export type MutationDeleteProofOfInsurancesArgs = {
  where: Array<ProofOfInsuranceWhereUniqueInput>;
};


export type MutationDeleteProofOfLicenseArgs = {
  where: ProofOfLicenseWhereUniqueInput;
};


export type MutationDeleteProofOfLicensesArgs = {
  where: Array<ProofOfLicenseWhereUniqueInput>;
};


export type MutationDeleteRecurringSlotArgs = {
  where: RecurringSlotWhereUniqueInput;
};


export type MutationDeleteRecurringSlotsArgs = {
  where: Array<RecurringSlotWhereUniqueInput>;
};


export type MutationDeleteRemittanceAdviceArgs = {
  where: RemittanceAdviceWhereUniqueInput;
};


export type MutationDeleteRemittanceAdviceRequestArgs = {
  where: RemittanceAdviceRequestWhereUniqueInput;
};


export type MutationDeleteRemittanceAdviceRequestsArgs = {
  where: Array<RemittanceAdviceRequestWhereUniqueInput>;
};


export type MutationDeleteRemittanceAdvicesArgs = {
  where: Array<RemittanceAdviceWhereUniqueInput>;
};


export type MutationDeleteRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type MutationDeleteRolesArgs = {
  where: Array<RoleWhereUniqueInput>;
};


export type MutationDeleteScheduleArgs = {
  where: ScheduleWhereUniqueInput;
};


export type MutationDeleteSchedulesArgs = {
  where: Array<ScheduleWhereUniqueInput>;
};


export type MutationDeleteScreeningTestArgs = {
  where: ScreeningTestWhereUniqueInput;
};


export type MutationDeleteScreeningTestsArgs = {
  where: Array<ScreeningTestWhereUniqueInput>;
};


export type MutationDeleteSessionArgs = {
  where: SessionWhereUniqueInput;
};


export type MutationDeleteSessionEventArgs = {
  where: SessionEventWhereUniqueInput;
};


export type MutationDeleteSessionEventsArgs = {
  where: Array<SessionEventWhereUniqueInput>;
};


export type MutationDeleteSessionsArgs = {
  where: Array<SessionWhereUniqueInput>;
};


export type MutationDeleteSignatureArgs = {
  where: SignatureWhereUniqueInput;
};


export type MutationDeleteSignaturesArgs = {
  where: Array<SignatureWhereUniqueInput>;
};


export type MutationDeleteStepperArgs = {
  where: StepperWhereUniqueInput;
};


export type MutationDeleteStepperProgArgs = {
  where: StepperProgWhereUniqueInput;
};


export type MutationDeleteStepperProgsArgs = {
  where: Array<StepperProgWhereUniqueInput>;
};


export type MutationDeleteStepperStepArgs = {
  where: StepperStepWhereUniqueInput;
};


export type MutationDeleteStepperStepProgArgs = {
  where: StepperStepProgWhereUniqueInput;
};


export type MutationDeleteStepperStepProgsArgs = {
  where: Array<StepperStepProgWhereUniqueInput>;
};


export type MutationDeleteStepperStepsArgs = {
  where: Array<StepperStepWhereUniqueInput>;
};


export type MutationDeleteSteppersArgs = {
  where: Array<StepperWhereUniqueInput>;
};


export type MutationDeleteTaskArgs = {
  where: TaskWhereUniqueInput;
};


export type MutationDeleteTasksArgs = {
  where: Array<TaskWhereUniqueInput>;
};


export type MutationDeleteTestOrderArgs = {
  where: TestOrderWhereUniqueInput;
};


export type MutationDeleteTestOrdersArgs = {
  where: Array<TestOrderWhereUniqueInput>;
};


export type MutationDeleteTestsBatchArgs = {
  where: TestsBatchWhereUniqueInput;
};


export type MutationDeleteTestsBatchesArgs = {
  where: Array<TestsBatchWhereUniqueInput>;
};


export type MutationDeleteTimeIntervalArgs = {
  where: TimeIntervalWhereUniqueInput;
};


export type MutationDeleteTimeIntervalsArgs = {
  where: Array<TimeIntervalWhereUniqueInput>;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteUserInviteArgs = {
  where: UserInviteWhereUniqueInput;
};


export type MutationDeleteUserInvitesArgs = {
  where: Array<UserInviteWhereUniqueInput>;
};


export type MutationDeleteUserSessionArgs = {
  where: UserSessionWhereUniqueInput;
};


export type MutationDeleteUserSessionsArgs = {
  where: Array<UserSessionWhereUniqueInput>;
};


export type MutationDeleteUsersArgs = {
  where: Array<UserWhereUniqueInput>;
};


export type MutationDeleteVaccinationArgs = {
  where: VaccinationWhereUniqueInput;
};


export type MutationDeleteVaccinationsArgs = {
  where: Array<VaccinationWhereUniqueInput>;
};


export type MutationDeleteVerificationTokenArgs = {
  where: VerificationTokenWhereUniqueInput;
};


export type MutationDeleteVerificationTokensArgs = {
  where: Array<VerificationTokenWhereUniqueInput>;
};


export type MutationInviteUserByDoctorArgs = {
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  healthCardExpiryDate?: Maybe<Scalars['DateTime']>;
  healthCardNumber?: Maybe<Scalars['String']>;
  healthCardVersionCode?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
};


export type MutationIssueFormArgs = {
  file: Scalars['Upload'];
  formId: Scalars['ID'];
};


export type MutationLogUserSessionArgs = {
  lastPath?: Maybe<Scalars['String']>;
  userSessionId?: Maybe<Scalars['ID']>;
};


export type MutationMarkAppointmentCancelledArgs = {
  appointmentId: Scalars['ID'];
  cancelledAt: Scalars['DateTime'];
};


export type MutationMarkAppointmentMissedArgs = {
  appointmentId: Scalars['ID'];
};


export type MutationMarkBillingArgs = {
  billingId: Scalars['ID'];
  status: AppointmentBillingStatusType;
};


export type MutationMoveFileToArchiveArgs = {
  archiveName: Scalars['String'];
  fileId: Scalars['ID'];
};


export type MutationOrderFaxNumberArgs = {
  companyId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationPatientCancelAppointmentArgs = {
  appointmentId: Scalars['ID'];
  cancelledAt: Scalars['DateTime'];
};


export type MutationPlaygroundSendFaxArgs = {
  faxFileUrl: Scalars['String'];
  faxNumber: Scalars['String'];
};


export type MutationReSubmitMyClaimsInCompanyArgs = {
  companyId: Scalars['ID'];
  couponId?: Maybe<Scalars['ID']>;
};


export type MutationRefreshRemittancesArgs = {
  companyId: Scalars['ID'];
};


export type MutationRemoveClinicArgs = {
  clinicId: Scalars['ID'];
};


export type MutationRemoveCompanyMemberArgs = {
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemovePatientFromCompanyArgs = {
  companyId: Scalars['ID'];
  patientId: Scalars['ID'];
};


export type MutationReportAdverseReactionArgs = {
  medicationItemId: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationResendFaxArgs = {
  faxId: Scalars['ID'];
};


export type MutationResendUserInviteByDoctorArgs = {
  inviteId: Scalars['ID'];
};


export type MutationResolveTaskArgs = {
  resolvedNote?: Maybe<Scalars['String']>;
  taskId: Scalars['ID'];
};


export type MutationRetrySubmissionArgs = {
  billingId: Scalars['ID'];
};


export type MutationSendFaxArgs = {
  companyId?: Maybe<Scalars['ID']>;
  doctorId?: Maybe<Scalars['ID']>;
  existingFaxId?: Maybe<Scalars['ID']>;
  fileId?: Maybe<Scalars['ID']>;
  fromFaxNumber?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['ID']>;
  toFaxNumber: Scalars['String'];
};


export type MutationStartFaxBlastArgs = {
  faxBlastId: Scalars['ID'];
};


export type MutationSubmitMyClaimsInCompanyArgs = {
  companyId: Scalars['ID'];
  couponId?: Maybe<Scalars['ID']>;
};


export type MutationSummarizeDocumentArgs = {
  key: Scalars['String'];
  sectionIdsString: Scalars['String'];
};


export type MutationUnmarkBillingArgs = {
  billingId: Scalars['ID'];
};


export type MutationUpdateAccessTokenArgs = {
  data: AccessTokenUpdateInput;
  where: AccessTokenWhereUniqueInput;
};


export type MutationUpdateAccessTokensArgs = {
  data: Array<AccessTokenUpdateArgs>;
};


export type MutationUpdateAccountArgs = {
  data: AccountUpdateInput;
  where: AccountWhereUniqueInput;
};


export type MutationUpdateAccountsArgs = {
  data: Array<AccountUpdateArgs>;
};


export type MutationUpdateActiveIngredientArgs = {
  data: ActiveIngredientUpdateInput;
  where: ActiveIngredientWhereUniqueInput;
};


export type MutationUpdateActiveIngredientsArgs = {
  data: Array<ActiveIngredientUpdateArgs>;
};


export type MutationUpdateAddressArgs = {
  data: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpdateAddressesArgs = {
  data: Array<AddressUpdateArgs>;
};


export type MutationUpdateAdministrativeAreaArgs = {
  data: AdministrativeAreaUpdateInput;
  where: AdministrativeAreaWhereUniqueInput;
};


export type MutationUpdateAdministrativeAreasArgs = {
  data: Array<AdministrativeAreaUpdateArgs>;
};


export type MutationUpdateAllergyItemArgs = {
  data: AllergyItemUpdateInput;
  where: AllergyItemWhereUniqueInput;
};


export type MutationUpdateAllergyItemsArgs = {
  data: Array<AllergyItemUpdateArgs>;
};


export type MutationUpdateAppointmentArgs = {
  data: AppointmentUpdateInput;
  where: AppointmentWhereUniqueInput;
};


export type MutationUpdateAppointmentBillingArgs = {
  data: AppointmentBillingUpdateInput;
  where: AppointmentBillingWhereUniqueInput;
};


export type MutationUpdateAppointmentBillingExceptionArgs = {
  data: AppointmentBillingExceptionUpdateInput;
  where: AppointmentBillingExceptionWhereUniqueInput;
};


export type MutationUpdateAppointmentBillingExceptionsArgs = {
  data: Array<AppointmentBillingExceptionUpdateArgs>;
};


export type MutationUpdateAppointmentBillingItemArgs = {
  data: AppointmentBillingItemUpdateInput;
  where: AppointmentBillingItemWhereUniqueInput;
};


export type MutationUpdateAppointmentBillingItemsArgs = {
  data: Array<AppointmentBillingItemUpdateArgs>;
};


export type MutationUpdateAppointmentBillingsArgs = {
  data: Array<AppointmentBillingUpdateArgs>;
};


export type MutationUpdateAppointmentDraftArgs = {
  data: AppointmentDraftUpdateInput;
  where: AppointmentDraftWhereUniqueInput;
};


export type MutationUpdateAppointmentDraftsArgs = {
  data: Array<AppointmentDraftUpdateArgs>;
};


export type MutationUpdateAppointmentNoteArgs = {
  data: AppointmentNoteUpdateInput;
  where: AppointmentNoteWhereUniqueInput;
};


export type MutationUpdateAppointmentNotesArgs = {
  data: Array<AppointmentNoteUpdateArgs>;
};


export type MutationUpdateAppointmentRequestArgs = {
  data: AppointmentRequestUpdateInput;
  where: AppointmentRequestWhereUniqueInput;
};


export type MutationUpdateAppointmentRequestsArgs = {
  data: Array<AppointmentRequestUpdateArgs>;
};


export type MutationUpdateAppointmentSessionArgs = {
  data: AppointmentSessionUpdateInput;
  where: AppointmentSessionWhereUniqueInput;
};


export type MutationUpdateAppointmentSessionsArgs = {
  data: Array<AppointmentSessionUpdateArgs>;
};


export type MutationUpdateAppointmentVitalArgs = {
  data: AppointmentVitalUpdateInput;
  where: AppointmentVitalWhereUniqueInput;
};


export type MutationUpdateAppointmentVitalsArgs = {
  data: Array<AppointmentVitalUpdateArgs>;
};


export type MutationUpdateAppointmentsArgs = {
  data: Array<AppointmentUpdateArgs>;
};


export type MutationUpdateArchiveArgs = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};


export type MutationUpdateArchiveItemArgs = {
  data: ArchiveItemUpdateInput;
  where: ArchiveItemWhereUniqueInput;
};


export type MutationUpdateArchiveItemsArgs = {
  data: Array<ArchiveItemUpdateArgs>;
};


export type MutationUpdateArchivesArgs = {
  data: Array<ArchiveUpdateArgs>;
};


export type MutationUpdateBillingClaimArgs = {
  data: BillingClaimUpdateInput;
  where: BillingClaimWhereUniqueInput;
};


export type MutationUpdateBillingClaimsArgs = {
  data: Array<BillingClaimUpdateArgs>;
};


export type MutationUpdateBillingDiagnosesArgs = {
  data: Array<BillingDiagnosisUpdateArgs>;
};


export type MutationUpdateBillingDiagnosisArgs = {
  data: BillingDiagnosisUpdateInput;
  where: BillingDiagnosisWhereUniqueInput;
};


export type MutationUpdateBillingPremiumArgs = {
  data: BillingPremiumUpdateInput;
  where: BillingPremiumWhereUniqueInput;
};


export type MutationUpdateBillingPremiumsArgs = {
  data: Array<BillingPremiumUpdateArgs>;
};


export type MutationUpdateBillingSubmissionArgs = {
  data: BillingSubmissionUpdateInput;
  where: BillingSubmissionWhereUniqueInput;
};


export type MutationUpdateBillingSubmissionsArgs = {
  data: Array<BillingSubmissionUpdateArgs>;
};


export type MutationUpdateBirdSummaryIntentArgs = {
  data: BirdSummaryIntentUpdateInput;
  where: BirdSummaryIntentWhereUniqueInput;
};


export type MutationUpdateBirdSummaryIntentsArgs = {
  data: Array<BirdSummaryIntentUpdateArgs>;
};


export type MutationUpdateBookingArgs = {
  data: BookingUpdateInput;
  where: BookingWhereUniqueInput;
};


export type MutationUpdateBookingsArgs = {
  data: Array<BookingUpdateArgs>;
};


export type MutationUpdateCalendarArgs = {
  data: CalendarUpdateInput;
  where: CalendarWhereUniqueInput;
};


export type MutationUpdateCalendarEventArgs = {
  data: CalendarEventUpdateInput;
  where: CalendarEventWhereUniqueInput;
};


export type MutationUpdateCalendarEventTypeArgs = {
  data: CalendarEventTypeUpdateInput;
  where: CalendarEventTypeWhereUniqueInput;
};


export type MutationUpdateCalendarEventTypesArgs = {
  data: Array<CalendarEventTypeUpdateArgs>;
};


export type MutationUpdateCalendarEventsArgs = {
  data: Array<CalendarEventUpdateArgs>;
};


export type MutationUpdateCalendarsArgs = {
  data: Array<CalendarUpdateArgs>;
};


export type MutationUpdateChatArgs = {
  data: ChatUpdateInput;
  where: ChatWhereUniqueInput;
};


export type MutationUpdateChatMessageArgs = {
  data: ChatMessageUpdateInput;
  where: ChatMessageWhereUniqueInput;
};


export type MutationUpdateChatMessagesArgs = {
  data: Array<ChatMessageUpdateArgs>;
};


export type MutationUpdateChatsArgs = {
  data: Array<ChatUpdateArgs>;
};


export type MutationUpdateClinicArgs = {
  data: ClinicUpdateInput;
  where: ClinicWhereUniqueInput;
};


export type MutationUpdateClinicsArgs = {
  data: Array<ClinicUpdateArgs>;
};


export type MutationUpdateCompaniesArgs = {
  data: Array<CompanyUpdateArgs>;
};


export type MutationUpdateCompanyArgs = {
  data: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};


export type MutationUpdateCompanyLogoArgs = {
  data: CompanyLogoUpdateInput;
  where: CompanyLogoWhereUniqueInput;
};


export type MutationUpdateCompanyLogosArgs = {
  data: Array<CompanyLogoUpdateArgs>;
};


export type MutationUpdateContractArgs = {
  data: ContractUpdateInput;
  where: ContractWhereUniqueInput;
};


export type MutationUpdateContractsArgs = {
  data: Array<ContractUpdateArgs>;
};


export type MutationUpdateCountriesArgs = {
  data: Array<CountryUpdateArgs>;
};


export type MutationUpdateCountryArgs = {
  data: CountryUpdateInput;
  where: CountryWhereUniqueInput;
};


export type MutationUpdateCouponArgs = {
  data: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};


export type MutationUpdateCouponsArgs = {
  data: Array<CouponUpdateArgs>;
};


export type MutationUpdateDataImportArgs = {
  data: DataImportUpdateInput;
  where: DataImportWhereUniqueInput;
};


export type MutationUpdateDataImportIntentArgs = {
  data: DataImportIntentUpdateInput;
  where: DataImportIntentWhereUniqueInput;
};


export type MutationUpdateDataImportIntentsArgs = {
  data: Array<DataImportIntentUpdateArgs>;
};


export type MutationUpdateDataImportItemArgs = {
  data: DataImportItemUpdateInput;
  where: DataImportItemWhereUniqueInput;
};


export type MutationUpdateDataImportItemsArgs = {
  data: Array<DataImportItemUpdateArgs>;
};


export type MutationUpdateDataImportsArgs = {
  data: Array<DataImportUpdateArgs>;
};


export type MutationUpdateDoctorArgs = {
  data: DoctorUpdateInput;
  where: DoctorWhereUniqueInput;
};


export type MutationUpdateDoctorSpecialtiesArgs = {
  data: Array<DoctorSpecialtyUpdateArgs>;
};


export type MutationUpdateDoctorSpecialtyArgs = {
  data: DoctorSpecialtyUpdateInput;
  where: DoctorSpecialtyWhereUniqueInput;
};


export type MutationUpdateDoctorSubSpecialtiesArgs = {
  data: Array<DoctorSubSpecialtyUpdateArgs>;
};


export type MutationUpdateDoctorSubSpecialtyArgs = {
  data: DoctorSubSpecialtyUpdateInput;
  where: DoctorSubSpecialtyWhereUniqueInput;
};


export type MutationUpdateDoctorsArgs = {
  data: Array<DoctorUpdateArgs>;
};


export type MutationUpdateDocumentArgs = {
  data: DocumentUpdateInput;
  where: DocumentWhereUniqueInput;
};


export type MutationUpdateDocumentsArgs = {
  data: Array<DocumentUpdateArgs>;
};


export type MutationUpdateEmergencyContactArgs = {
  data: EmergencyContactUpdateInput;
  where: EmergencyContactWhereUniqueInput;
};


export type MutationUpdateEmergencyContactsArgs = {
  data: Array<EmergencyContactUpdateArgs>;
};


export type MutationUpdateFaxArgs = {
  data: FaxUpdateInput;
  where: FaxWhereUniqueInput;
};


export type MutationUpdateFaxBlastArgs = {
  data: FaxBlastUpdateInput;
  where: FaxBlastWhereUniqueInput;
};


export type MutationUpdateFaxBlastItemArgs = {
  data: FaxBlastItemUpdateInput;
  where: FaxBlastItemWhereUniqueInput;
};


export type MutationUpdateFaxBlastItemsArgs = {
  data: Array<FaxBlastItemUpdateArgs>;
};


export type MutationUpdateFaxBlastsArgs = {
  data: Array<FaxBlastUpdateArgs>;
};


export type MutationUpdateFaxRecipientArgs = {
  data: FaxRecipientUpdateInput;
  where: FaxRecipientWhereUniqueInput;
};


export type MutationUpdateFaxRecipientsArgs = {
  data: Array<FaxRecipientUpdateArgs>;
};


export type MutationUpdateFaxesArgs = {
  data: Array<FaxUpdateArgs>;
};


export type MutationUpdateFeedbackItemArgs = {
  data: FeedbackItemUpdateInput;
  where: FeedbackItemWhereUniqueInput;
};


export type MutationUpdateFeedbackItemsArgs = {
  data: Array<FeedbackItemUpdateArgs>;
};


export type MutationUpdateFileArgs = {
  data: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpdateFilesArgs = {
  data: Array<FileUpdateArgs>;
};


export type MutationUpdateFormArgs = {
  data: FormUpdateInput;
  where: FormWhereUniqueInput;
};


export type MutationUpdateFormTestArgs = {
  data: FormTestUpdateInput;
  where: FormTestWhereUniqueInput;
};


export type MutationUpdateFormTestsArgs = {
  data: Array<FormTestUpdateArgs>;
};


export type MutationUpdateFormTypeArgs = {
  data: FormTypeUpdateInput;
  where: FormTypeWhereUniqueInput;
};


export type MutationUpdateFormTypesArgs = {
  data: Array<FormTypeUpdateArgs>;
};


export type MutationUpdateFormsArgs = {
  data: Array<FormUpdateArgs>;
};


export type MutationUpdateHealthCardArgs = {
  data: HealthCardUpdateInput;
  where: HealthCardWhereUniqueInput;
};


export type MutationUpdateHealthCardsArgs = {
  data: Array<HealthCardUpdateArgs>;
};


export type MutationUpdateHealthConditionArgs = {
  data: HealthConditionUpdateInput;
  where: HealthConditionWhereUniqueInput;
};


export type MutationUpdateHealthConditionsArgs = {
  data: Array<HealthConditionUpdateArgs>;
};


export type MutationUpdateInboundFaxArgs = {
  data: InboundFaxUpdateInput;
  where: InboundFaxWhereUniqueInput;
};


export type MutationUpdateInboundFaxesArgs = {
  data: Array<InboundFaxUpdateArgs>;
};


export type MutationUpdateLanguageArgs = {
  data: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};


export type MutationUpdateLanguagesArgs = {
  data: Array<LanguageUpdateArgs>;
};


export type MutationUpdateLeaseAgreementArgs = {
  data: LeaseAgreementUpdateInput;
  where: LeaseAgreementWhereUniqueInput;
};


export type MutationUpdateLeaseAgreementsArgs = {
  data: Array<LeaseAgreementUpdateArgs>;
};


export type MutationUpdateLifestyleItemArgs = {
  data: LifestyleItemUpdateInput;
  where: LifestyleItemWhereUniqueInput;
};


export type MutationUpdateLifestyleItemsArgs = {
  data: Array<LifestyleItemUpdateArgs>;
};


export type MutationUpdateLuReasonArgs = {
  data: LuReasonUpdateInput;
  where: LuReasonWhereUniqueInput;
};


export type MutationUpdateLuReasonsArgs = {
  data: Array<LuReasonUpdateArgs>;
};


export type MutationUpdateMasterLicenseArgs = {
  data: MasterLicenseUpdateInput;
  where: MasterLicenseWhereUniqueInput;
};


export type MutationUpdateMasterLicensesArgs = {
  data: Array<MasterLicenseUpdateArgs>;
};


export type MutationUpdateMedicationArgs = {
  data: MedicationUpdateInput;
  where: MedicationWhereUniqueInput;
};


export type MutationUpdateMedicationItemArgs = {
  data: MedicationItemUpdateInput;
  where: MedicationItemWhereUniqueInput;
};


export type MutationUpdateMedicationItemsArgs = {
  data: Array<MedicationItemUpdateArgs>;
};


export type MutationUpdateMedicationsArgs = {
  data: Array<MedicationUpdateArgs>;
};


export type MutationUpdateMemberArgs = {
  data: MemberUpdateInput;
  where: MemberWhereUniqueInput;
};


export type MutationUpdateMembersArgs = {
  data: Array<MemberUpdateArgs>;
};


export type MutationUpdateNotificationDispatchArgs = {
  data: NotificationDispatchUpdateInput;
  where: NotificationDispatchWhereUniqueInput;
};


export type MutationUpdateNotificationDispatchItemArgs = {
  data: NotificationDispatchItemUpdateInput;
  where: NotificationDispatchItemWhereUniqueInput;
};


export type MutationUpdateNotificationDispatchItemsArgs = {
  data: Array<NotificationDispatchItemUpdateArgs>;
};


export type MutationUpdateNotificationDispatchesArgs = {
  data: Array<NotificationDispatchUpdateArgs>;
};


export type MutationUpdatePatientArgs = {
  data: PatientUpdateInput;
  where: PatientWhereUniqueInput;
};


export type MutationUpdatePatientsArgs = {
  data: Array<PatientUpdateArgs>;
};


export type MutationUpdatePharmaciesArgs = {
  data: Array<PharmacyUpdateArgs>;
};


export type MutationUpdatePharmacyArgs = {
  data: PharmacyUpdateInput;
  where: PharmacyWhereUniqueInput;
};


export type MutationUpdatePharmacyLocationArgs = {
  data: PharmacyLocationUpdateInput;
  where: PharmacyLocationWhereUniqueInput;
};


export type MutationUpdatePharmacyLocationsArgs = {
  data: Array<PharmacyLocationUpdateArgs>;
};


export type MutationUpdatePrescriptionArgs = {
  data: PrescriptionUpdateInput;
  where: PrescriptionWhereUniqueInput;
};


export type MutationUpdatePrescriptionItemArgs = {
  data: PrescriptionItemUpdateInput;
  where: PrescriptionItemWhereUniqueInput;
};


export type MutationUpdatePrescriptionItemsArgs = {
  data: Array<PrescriptionItemUpdateArgs>;
};


export type MutationUpdatePrescriptionsArgs = {
  data: Array<PrescriptionUpdateArgs>;
};


export type MutationUpdateProfilePhotoArgs = {
  data: ProfilePhotoUpdateInput;
  where: ProfilePhotoWhereUniqueInput;
};


export type MutationUpdateProfilePhotosArgs = {
  data: Array<ProfilePhotoUpdateArgs>;
};


export type MutationUpdatePromptArgs = {
  data: PromptUpdateInput;
  where: PromptWhereUniqueInput;
};


export type MutationUpdatePromptsArgs = {
  data: Array<PromptUpdateArgs>;
};


export type MutationUpdateProofOfIdentificationArgs = {
  data: ProofOfIdentificationUpdateInput;
  where: ProofOfIdentificationWhereUniqueInput;
};


export type MutationUpdateProofOfIdentificationsArgs = {
  data: Array<ProofOfIdentificationUpdateArgs>;
};


export type MutationUpdateProofOfInsuranceArgs = {
  data: ProofOfInsuranceUpdateInput;
  where: ProofOfInsuranceWhereUniqueInput;
};


export type MutationUpdateProofOfInsurancesArgs = {
  data: Array<ProofOfInsuranceUpdateArgs>;
};


export type MutationUpdateProofOfLicenseArgs = {
  data: ProofOfLicenseUpdateInput;
  where: ProofOfLicenseWhereUniqueInput;
};


export type MutationUpdateProofOfLicensesArgs = {
  data: Array<ProofOfLicenseUpdateArgs>;
};


export type MutationUpdateRecurringSlotArgs = {
  data: RecurringSlotUpdateInput;
  where: RecurringSlotWhereUniqueInput;
};


export type MutationUpdateRecurringSlotsArgs = {
  data: Array<RecurringSlotUpdateArgs>;
};


export type MutationUpdateRemittanceAdviceArgs = {
  data: RemittanceAdviceUpdateInput;
  where: RemittanceAdviceWhereUniqueInput;
};


export type MutationUpdateRemittanceAdviceRequestArgs = {
  data: RemittanceAdviceRequestUpdateInput;
  where: RemittanceAdviceRequestWhereUniqueInput;
};


export type MutationUpdateRemittanceAdviceRequestsArgs = {
  data: Array<RemittanceAdviceRequestUpdateArgs>;
};


export type MutationUpdateRemittanceAdvicesArgs = {
  data: Array<RemittanceAdviceUpdateArgs>;
};


export type MutationUpdateRoleArgs = {
  data: RoleUpdateInput;
  where: RoleWhereUniqueInput;
};


export type MutationUpdateRolesArgs = {
  data: Array<RoleUpdateArgs>;
};


export type MutationUpdateScheduleArgs = {
  data: ScheduleUpdateInput;
  where: ScheduleWhereUniqueInput;
};


export type MutationUpdateSchedulesArgs = {
  data: Array<ScheduleUpdateArgs>;
};


export type MutationUpdateScreeningTestArgs = {
  data: ScreeningTestUpdateInput;
  where: ScreeningTestWhereUniqueInput;
};


export type MutationUpdateScreeningTestsArgs = {
  data: Array<ScreeningTestUpdateArgs>;
};


export type MutationUpdateSessionArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationUpdateSessionEventArgs = {
  data: SessionEventUpdateInput;
  where: SessionEventWhereUniqueInput;
};


export type MutationUpdateSessionEventsArgs = {
  data: Array<SessionEventUpdateArgs>;
};


export type MutationUpdateSessionsArgs = {
  data: Array<SessionUpdateArgs>;
};


export type MutationUpdateSignatureArgs = {
  data: SignatureUpdateInput;
  where: SignatureWhereUniqueInput;
};


export type MutationUpdateSignaturesArgs = {
  data: Array<SignatureUpdateArgs>;
};


export type MutationUpdateStepperArgs = {
  data: StepperUpdateInput;
  where: StepperWhereUniqueInput;
};


export type MutationUpdateStepperProgArgs = {
  data: StepperProgUpdateInput;
  where: StepperProgWhereUniqueInput;
};


export type MutationUpdateStepperProgsArgs = {
  data: Array<StepperProgUpdateArgs>;
};


export type MutationUpdateStepperStepArgs = {
  data: StepperStepUpdateInput;
  where: StepperStepWhereUniqueInput;
};


export type MutationUpdateStepperStepProgArgs = {
  data: StepperStepProgUpdateInput;
  where: StepperStepProgWhereUniqueInput;
};


export type MutationUpdateStepperStepProgsArgs = {
  data: Array<StepperStepProgUpdateArgs>;
};


export type MutationUpdateStepperStepsArgs = {
  data: Array<StepperStepUpdateArgs>;
};


export type MutationUpdateSteppersArgs = {
  data: Array<StepperUpdateArgs>;
};


export type MutationUpdateTaskArgs = {
  data: TaskUpdateInput;
  where: TaskWhereUniqueInput;
};


export type MutationUpdateTasksArgs = {
  data: Array<TaskUpdateArgs>;
};


export type MutationUpdateTestOrderArgs = {
  data: TestOrderUpdateInput;
  where: TestOrderWhereUniqueInput;
};


export type MutationUpdateTestOrdersArgs = {
  data: Array<TestOrderUpdateArgs>;
};


export type MutationUpdateTestsBatchArgs = {
  data: TestsBatchUpdateInput;
  where: TestsBatchWhereUniqueInput;
};


export type MutationUpdateTestsBatchesArgs = {
  data: Array<TestsBatchUpdateArgs>;
};


export type MutationUpdateTimeIntervalArgs = {
  data: TimeIntervalUpdateInput;
  where: TimeIntervalWhereUniqueInput;
};


export type MutationUpdateTimeIntervalsArgs = {
  data: Array<TimeIntervalUpdateArgs>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserInviteArgs = {
  data: UserInviteUpdateInput;
  where: UserInviteWhereUniqueInput;
};


export type MutationUpdateUserInvitesArgs = {
  data: Array<UserInviteUpdateArgs>;
};


export type MutationUpdateUserSessionArgs = {
  data: UserSessionUpdateInput;
  where: UserSessionWhereUniqueInput;
};


export type MutationUpdateUserSessionsArgs = {
  data: Array<UserSessionUpdateArgs>;
};


export type MutationUpdateUsersArgs = {
  data: Array<UserUpdateArgs>;
};


export type MutationUpdateVaccinationArgs = {
  data: VaccinationUpdateInput;
  where: VaccinationWhereUniqueInput;
};


export type MutationUpdateVaccinationsArgs = {
  data: Array<VaccinationUpdateArgs>;
};


export type MutationUpdateVerificationTokenArgs = {
  data: VerificationTokenUpdateInput;
  where: VerificationTokenWhereUniqueInput;
};


export type MutationUpdateVerificationTokensArgs = {
  data: Array<VerificationTokenUpdateArgs>;
};


export type MutationUploadBlastListArgs = {
  faxBlastId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationUploadDataImportArgs = {
  file: Scalars['Upload'];
  notes?: Maybe<Scalars['String']>;
  notifyEmail?: Maybe<Scalars['String']>;
};


export type MutationValidateHealthCardArgs = {
  healthCardId: Scalars['ID'];
};

export type NestedStringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NotificationDispatch = {
  __typename?: 'NotificationDispatch';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  notificationDispatchItems?: Maybe<Array<NotificationDispatchItem>>;
  notificationDispatchItemsCount?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  targetEmails?: Maybe<Scalars['String']>;
  targetSlackChannelIds?: Maybe<Scalars['String']>;
  targets?: Maybe<Array<Scalars['String']>>;
};


export type NotificationDispatchNotificationDispatchItemsArgs = {
  cursor?: Maybe<NotificationDispatchItemWhereUniqueInput>;
  orderBy?: Array<NotificationDispatchItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: NotificationDispatchItemWhereInput;
};


export type NotificationDispatchNotificationDispatchItemsCountArgs = {
  where?: NotificationDispatchItemWhereInput;
};

export type NotificationDispatchCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  notificationDispatchItems?: Maybe<NotificationDispatchItemRelateToManyForCreateInput>;
  purpose?: Maybe<Scalars['String']>;
  targetEmails?: Maybe<Scalars['String']>;
  targetSlackChannelIds?: Maybe<Scalars['String']>;
  targets?: Maybe<Array<Scalars['String']>>;
};

export type NotificationDispatchItem = {
  __typename?: 'NotificationDispatchItem';
  author?: Maybe<User>;
  auxData?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  notificationDispatch?: Maybe<NotificationDispatch>;
};

export type NotificationDispatchItemCreateInput = {
  author?: Maybe<UserRelateToOneForCreateInput>;
  auxData?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  notificationDispatch?: Maybe<NotificationDispatchRelateToOneForCreateInput>;
};

export type NotificationDispatchItemManyRelationFilter = {
  every?: Maybe<NotificationDispatchItemWhereInput>;
  none?: Maybe<NotificationDispatchItemWhereInput>;
  some?: Maybe<NotificationDispatchItemWhereInput>;
};

export type NotificationDispatchItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type NotificationDispatchItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<NotificationDispatchItemWhereUniqueInput>>;
  create?: Maybe<Array<NotificationDispatchItemCreateInput>>;
};

export type NotificationDispatchItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<NotificationDispatchItemWhereUniqueInput>>;
  create?: Maybe<Array<NotificationDispatchItemCreateInput>>;
  disconnect?: Maybe<Array<NotificationDispatchItemWhereUniqueInput>>;
  set?: Maybe<Array<NotificationDispatchItemWhereUniqueInput>>;
};

export type NotificationDispatchItemUpdateArgs = {
  data: NotificationDispatchItemUpdateInput;
  where: NotificationDispatchItemWhereUniqueInput;
};

export type NotificationDispatchItemUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  auxData?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  notificationDispatch?: Maybe<NotificationDispatchRelateToOneForUpdateInput>;
};

export type NotificationDispatchItemWhereInput = {
  AND?: Maybe<Array<NotificationDispatchItemWhereInput>>;
  NOT?: Maybe<Array<NotificationDispatchItemWhereInput>>;
  OR?: Maybe<Array<NotificationDispatchItemWhereInput>>;
  author?: Maybe<UserWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  notificationDispatch?: Maybe<NotificationDispatchWhereInput>;
};

export type NotificationDispatchItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type NotificationDispatchManyRelationFilter = {
  every?: Maybe<NotificationDispatchWhereInput>;
  none?: Maybe<NotificationDispatchWhereInput>;
  some?: Maybe<NotificationDispatchWhereInput>;
};

export type NotificationDispatchOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  purpose?: Maybe<OrderDirection>;
  targetEmails?: Maybe<OrderDirection>;
  targetSlackChannelIds?: Maybe<OrderDirection>;
};

export type NotificationDispatchRelateToManyForCreateInput = {
  connect?: Maybe<Array<NotificationDispatchWhereUniqueInput>>;
  create?: Maybe<Array<NotificationDispatchCreateInput>>;
};

export type NotificationDispatchRelateToManyForUpdateInput = {
  connect?: Maybe<Array<NotificationDispatchWhereUniqueInput>>;
  create?: Maybe<Array<NotificationDispatchCreateInput>>;
  disconnect?: Maybe<Array<NotificationDispatchWhereUniqueInput>>;
  set?: Maybe<Array<NotificationDispatchWhereUniqueInput>>;
};

export type NotificationDispatchRelateToOneForCreateInput = {
  connect?: Maybe<NotificationDispatchWhereUniqueInput>;
  create?: Maybe<NotificationDispatchCreateInput>;
};

export type NotificationDispatchRelateToOneForUpdateInput = {
  connect?: Maybe<NotificationDispatchWhereUniqueInput>;
  create?: Maybe<NotificationDispatchCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type NotificationDispatchUpdateArgs = {
  data: NotificationDispatchUpdateInput;
  where: NotificationDispatchWhereUniqueInput;
};

export type NotificationDispatchUpdateInput = {
  author?: Maybe<UserRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  notificationDispatchItems?: Maybe<NotificationDispatchItemRelateToManyForUpdateInput>;
  purpose?: Maybe<Scalars['String']>;
  targetEmails?: Maybe<Scalars['String']>;
  targetSlackChannelIds?: Maybe<Scalars['String']>;
  targets?: Maybe<Array<Scalars['String']>>;
};

export type NotificationDispatchWhereInput = {
  AND?: Maybe<Array<NotificationDispatchWhereInput>>;
  NOT?: Maybe<Array<NotificationDispatchWhereInput>>;
  OR?: Maybe<Array<NotificationDispatchWhereInput>>;
  author?: Maybe<UserWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  notificationDispatchItems?: Maybe<NotificationDispatchItemManyRelationFilter>;
  purpose?: Maybe<StringNullableFilter>;
  targetEmails?: Maybe<StringFilter>;
  targetSlackChannelIds?: Maybe<StringFilter>;
};

export type NotificationDispatchWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  purpose?: Maybe<Scalars['String']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Patient = {
  __typename?: 'Patient';
  allergies?: Maybe<Array<AllergyItem>>;
  allergiesCount?: Maybe<Scalars['Int']>;
  appointmentNotes?: Maybe<Array<AppointmentNote>>;
  appointmentNotesCount?: Maybe<Scalars['Int']>;
  appointmentRequests?: Maybe<Array<AppointmentRequest>>;
  appointmentRequestsCount?: Maybe<Scalars['Int']>;
  appointmentSessions?: Maybe<Array<AppointmentSession>>;
  appointmentSessionsCount?: Maybe<Scalars['Int']>;
  appointmentVitals?: Maybe<Array<AppointmentVital>>;
  appointmentVitalsCount?: Maybe<Scalars['Int']>;
  appointments?: Maybe<Array<Appointment>>;
  appointmentsCount?: Maybe<Scalars['Int']>;
  bookings?: Maybe<Array<Booking>>;
  bookingsCount?: Maybe<Scalars['Int']>;
  caredByDoctors?: Maybe<Array<Doctor>>;
  caredByDoctorsCount?: Maybe<Scalars['Int']>;
  companies?: Maybe<Array<Company>>;
  companiesCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportItems?: Maybe<Array<DataImportItem>>;
  dataImportItemsCount?: Maybe<Scalars['Int']>;
  documents?: Maybe<Array<Document>>;
  documentsCount?: Maybe<Scalars['Int']>;
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  emergencyContactsCount?: Maybe<Scalars['Int']>;
  faxes?: Maybe<Array<Fax>>;
  faxesCount?: Maybe<Scalars['Int']>;
  forms?: Maybe<Array<Form>>;
  formsCount?: Maybe<Scalars['Int']>;
  healthCards?: Maybe<Array<HealthCard>>;
  healthCardsCount?: Maybe<Scalars['Int']>;
  healthConditions?: Maybe<Array<HealthCondition>>;
  healthConditionsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  interactedDoctors?: Maybe<Array<Doctor>>;
  interactedDoctorsCount?: Maybe<Scalars['Int']>;
  isCompleteProfile?: Maybe<Scalars['Boolean']>;
  lifestyleItems?: Maybe<Array<LifestyleItem>>;
  lifestyleItemsCount?: Maybe<Scalars['Int']>;
  medicationItems?: Maybe<Array<MedicationItem>>;
  medicationItemsCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pharmacyLocations?: Maybe<Array<PharmacyLocation>>;
  pharmacyLocationsCount?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<Array<Prescription>>;
  prescriptionsCount?: Maybe<Scalars['Int']>;
  savedDoctors?: Maybe<Array<Doctor>>;
  savedDoctorsCount?: Maybe<Scalars['Int']>;
  screeningTests?: Maybe<Array<ScreeningTest>>;
  screeningTestsCount?: Maybe<Scalars['Int']>;
  tasks?: Maybe<Array<Task>>;
  tasksCount?: Maybe<Scalars['Int']>;
  testOrders?: Maybe<Array<TestOrder>>;
  testOrdersCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  vaccinations?: Maybe<Array<Vaccination>>;
  vaccinationsCount?: Maybe<Scalars['Int']>;
  visitedDoctors?: Maybe<Array<Doctor>>;
  visitedDoctorsCount?: Maybe<Scalars['Int']>;
};


export type PatientAllergiesArgs = {
  cursor?: Maybe<AllergyItemWhereUniqueInput>;
  orderBy?: Array<AllergyItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AllergyItemWhereInput;
};


export type PatientAllergiesCountArgs = {
  where?: AllergyItemWhereInput;
};


export type PatientAppointmentNotesArgs = {
  cursor?: Maybe<AppointmentNoteWhereUniqueInput>;
  orderBy?: Array<AppointmentNoteOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentNoteWhereInput;
};


export type PatientAppointmentNotesCountArgs = {
  where?: AppointmentNoteWhereInput;
};


export type PatientAppointmentRequestsArgs = {
  cursor?: Maybe<AppointmentRequestWhereUniqueInput>;
  orderBy?: Array<AppointmentRequestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentRequestWhereInput;
};


export type PatientAppointmentRequestsCountArgs = {
  where?: AppointmentRequestWhereInput;
};


export type PatientAppointmentSessionsArgs = {
  cursor?: Maybe<AppointmentSessionWhereUniqueInput>;
  orderBy?: Array<AppointmentSessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentSessionWhereInput;
};


export type PatientAppointmentSessionsCountArgs = {
  where?: AppointmentSessionWhereInput;
};


export type PatientAppointmentVitalsArgs = {
  cursor?: Maybe<AppointmentVitalWhereUniqueInput>;
  orderBy?: Array<AppointmentVitalOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentVitalWhereInput;
};


export type PatientAppointmentVitalsCountArgs = {
  where?: AppointmentVitalWhereInput;
};


export type PatientAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  orderBy?: Array<AppointmentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentWhereInput;
};


export type PatientAppointmentsCountArgs = {
  where?: AppointmentWhereInput;
};


export type PatientBookingsArgs = {
  cursor?: Maybe<BookingWhereUniqueInput>;
  orderBy?: Array<BookingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BookingWhereInput;
};


export type PatientBookingsCountArgs = {
  where?: BookingWhereInput;
};


export type PatientCaredByDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type PatientCaredByDoctorsCountArgs = {
  where?: DoctorWhereInput;
};


export type PatientCompaniesArgs = {
  cursor?: Maybe<CompanyWhereUniqueInput>;
  orderBy?: Array<CompanyOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CompanyWhereInput;
};


export type PatientCompaniesCountArgs = {
  where?: CompanyWhereInput;
};


export type PatientDataImportItemsArgs = {
  cursor?: Maybe<DataImportItemWhereUniqueInput>;
  orderBy?: Array<DataImportItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportItemWhereInput;
};


export type PatientDataImportItemsCountArgs = {
  where?: DataImportItemWhereInput;
};


export type PatientDocumentsArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  orderBy?: Array<DocumentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DocumentWhereInput;
};


export type PatientDocumentsCountArgs = {
  where?: DocumentWhereInput;
};


export type PatientEmergencyContactsArgs = {
  cursor?: Maybe<EmergencyContactWhereUniqueInput>;
  orderBy?: Array<EmergencyContactOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: EmergencyContactWhereInput;
};


export type PatientEmergencyContactsCountArgs = {
  where?: EmergencyContactWhereInput;
};


export type PatientFaxesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type PatientFaxesCountArgs = {
  where?: FaxWhereInput;
};


export type PatientFormsArgs = {
  cursor?: Maybe<FormWhereUniqueInput>;
  orderBy?: Array<FormOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormWhereInput;
};


export type PatientFormsCountArgs = {
  where?: FormWhereInput;
};


export type PatientHealthCardsArgs = {
  cursor?: Maybe<HealthCardWhereUniqueInput>;
  orderBy?: Array<HealthCardOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: HealthCardWhereInput;
};


export type PatientHealthCardsCountArgs = {
  where?: HealthCardWhereInput;
};


export type PatientHealthConditionsArgs = {
  cursor?: Maybe<HealthConditionWhereUniqueInput>;
  orderBy?: Array<HealthConditionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: HealthConditionWhereInput;
};


export type PatientHealthConditionsCountArgs = {
  where?: HealthConditionWhereInput;
};


export type PatientInteractedDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type PatientInteractedDoctorsCountArgs = {
  where?: DoctorWhereInput;
};


export type PatientLifestyleItemsArgs = {
  cursor?: Maybe<LifestyleItemWhereUniqueInput>;
  orderBy?: Array<LifestyleItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: LifestyleItemWhereInput;
};


export type PatientLifestyleItemsCountArgs = {
  where?: LifestyleItemWhereInput;
};


export type PatientMedicationItemsArgs = {
  cursor?: Maybe<MedicationItemWhereUniqueInput>;
  orderBy?: Array<MedicationItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MedicationItemWhereInput;
};


export type PatientMedicationItemsCountArgs = {
  where?: MedicationItemWhereInput;
};


export type PatientPharmacyLocationsArgs = {
  cursor?: Maybe<PharmacyLocationWhereUniqueInput>;
  orderBy?: Array<PharmacyLocationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PharmacyLocationWhereInput;
};


export type PatientPharmacyLocationsCountArgs = {
  where?: PharmacyLocationWhereInput;
};


export type PatientPrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  orderBy?: Array<PrescriptionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PrescriptionWhereInput;
};


export type PatientPrescriptionsCountArgs = {
  where?: PrescriptionWhereInput;
};


export type PatientSavedDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type PatientSavedDoctorsCountArgs = {
  where?: DoctorWhereInput;
};


export type PatientScreeningTestsArgs = {
  cursor?: Maybe<ScreeningTestWhereUniqueInput>;
  orderBy?: Array<ScreeningTestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ScreeningTestWhereInput;
};


export type PatientScreeningTestsCountArgs = {
  where?: ScreeningTestWhereInput;
};


export type PatientTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  orderBy?: Array<TaskOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TaskWhereInput;
};


export type PatientTasksCountArgs = {
  where?: TaskWhereInput;
};


export type PatientTestOrdersArgs = {
  cursor?: Maybe<TestOrderWhereUniqueInput>;
  orderBy?: Array<TestOrderOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TestOrderWhereInput;
};


export type PatientTestOrdersCountArgs = {
  where?: TestOrderWhereInput;
};


export type PatientVaccinationsArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  orderBy?: Array<VaccinationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: VaccinationWhereInput;
};


export type PatientVaccinationsCountArgs = {
  where?: VaccinationWhereInput;
};


export type PatientVisitedDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type PatientVisitedDoctorsCountArgs = {
  where?: DoctorWhereInput;
};

export type PatientCreateInput = {
  allergies?: Maybe<AllergyItemRelateToManyForCreateInput>;
  appointmentNotes?: Maybe<AppointmentNoteRelateToManyForCreateInput>;
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForCreateInput>;
  appointmentSessions?: Maybe<AppointmentSessionRelateToManyForCreateInput>;
  appointmentVitals?: Maybe<AppointmentVitalRelateToManyForCreateInput>;
  appointments?: Maybe<AppointmentRelateToManyForCreateInput>;
  bookings?: Maybe<BookingRelateToManyForCreateInput>;
  caredByDoctors?: Maybe<DoctorRelateToManyForCreateInput>;
  companies?: Maybe<CompanyRelateToManyForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportItems?: Maybe<DataImportItemRelateToManyForCreateInput>;
  documents?: Maybe<DocumentRelateToManyForCreateInput>;
  emergencyContacts?: Maybe<EmergencyContactRelateToManyForCreateInput>;
  faxes?: Maybe<FaxRelateToManyForCreateInput>;
  forms?: Maybe<FormRelateToManyForCreateInput>;
  healthCards?: Maybe<HealthCardRelateToManyForCreateInput>;
  healthConditions?: Maybe<HealthConditionRelateToManyForCreateInput>;
  interactedDoctors?: Maybe<DoctorRelateToManyForCreateInput>;
  isCompleteProfile?: Maybe<Scalars['Boolean']>;
  lifestyleItems?: Maybe<LifestyleItemRelateToManyForCreateInput>;
  medicationItems?: Maybe<MedicationItemRelateToManyForCreateInput>;
  name?: Maybe<Scalars['String']>;
  pharmacyLocations?: Maybe<PharmacyLocationRelateToManyForCreateInput>;
  prescriptions?: Maybe<PrescriptionRelateToManyForCreateInput>;
  savedDoctors?: Maybe<DoctorRelateToManyForCreateInput>;
  screeningTests?: Maybe<ScreeningTestRelateToManyForCreateInput>;
  tasks?: Maybe<TaskRelateToManyForCreateInput>;
  testOrders?: Maybe<TestOrderRelateToManyForCreateInput>;
  user?: Maybe<UserRelateToOneForCreateInput>;
  vaccinations?: Maybe<VaccinationRelateToManyForCreateInput>;
  visitedDoctors?: Maybe<DoctorRelateToManyForCreateInput>;
};

export type PatientManyRelationFilter = {
  every?: Maybe<PatientWhereInput>;
  none?: Maybe<PatientWhereInput>;
  some?: Maybe<PatientWhereInput>;
};

export type PatientOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isCompleteProfile?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
};

export type PatientRelateToManyForCreateInput = {
  connect?: Maybe<Array<PatientWhereUniqueInput>>;
  create?: Maybe<Array<PatientCreateInput>>;
};

export type PatientRelateToManyForUpdateInput = {
  connect?: Maybe<Array<PatientWhereUniqueInput>>;
  create?: Maybe<Array<PatientCreateInput>>;
  disconnect?: Maybe<Array<PatientWhereUniqueInput>>;
  set?: Maybe<Array<PatientWhereUniqueInput>>;
};

export type PatientRelateToOneForCreateInput = {
  connect?: Maybe<PatientWhereUniqueInput>;
  create?: Maybe<PatientCreateInput>;
};

export type PatientRelateToOneForUpdateInput = {
  connect?: Maybe<PatientWhereUniqueInput>;
  create?: Maybe<PatientCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type PatientUpdateArgs = {
  data: PatientUpdateInput;
  where: PatientWhereUniqueInput;
};

export type PatientUpdateInput = {
  allergies?: Maybe<AllergyItemRelateToManyForUpdateInput>;
  appointmentNotes?: Maybe<AppointmentNoteRelateToManyForUpdateInput>;
  appointmentRequests?: Maybe<AppointmentRequestRelateToManyForUpdateInput>;
  appointmentSessions?: Maybe<AppointmentSessionRelateToManyForUpdateInput>;
  appointmentVitals?: Maybe<AppointmentVitalRelateToManyForUpdateInput>;
  appointments?: Maybe<AppointmentRelateToManyForUpdateInput>;
  bookings?: Maybe<BookingRelateToManyForUpdateInput>;
  caredByDoctors?: Maybe<DoctorRelateToManyForUpdateInput>;
  companies?: Maybe<CompanyRelateToManyForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportItems?: Maybe<DataImportItemRelateToManyForUpdateInput>;
  documents?: Maybe<DocumentRelateToManyForUpdateInput>;
  emergencyContacts?: Maybe<EmergencyContactRelateToManyForUpdateInput>;
  faxes?: Maybe<FaxRelateToManyForUpdateInput>;
  forms?: Maybe<FormRelateToManyForUpdateInput>;
  healthCards?: Maybe<HealthCardRelateToManyForUpdateInput>;
  healthConditions?: Maybe<HealthConditionRelateToManyForUpdateInput>;
  interactedDoctors?: Maybe<DoctorRelateToManyForUpdateInput>;
  isCompleteProfile?: Maybe<Scalars['Boolean']>;
  lifestyleItems?: Maybe<LifestyleItemRelateToManyForUpdateInput>;
  medicationItems?: Maybe<MedicationItemRelateToManyForUpdateInput>;
  name?: Maybe<Scalars['String']>;
  pharmacyLocations?: Maybe<PharmacyLocationRelateToManyForUpdateInput>;
  prescriptions?: Maybe<PrescriptionRelateToManyForUpdateInput>;
  savedDoctors?: Maybe<DoctorRelateToManyForUpdateInput>;
  screeningTests?: Maybe<ScreeningTestRelateToManyForUpdateInput>;
  tasks?: Maybe<TaskRelateToManyForUpdateInput>;
  testOrders?: Maybe<TestOrderRelateToManyForUpdateInput>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
  vaccinations?: Maybe<VaccinationRelateToManyForUpdateInput>;
  visitedDoctors?: Maybe<DoctorRelateToManyForUpdateInput>;
};

export type PatientWhereInput = {
  AND?: Maybe<Array<PatientWhereInput>>;
  NOT?: Maybe<Array<PatientWhereInput>>;
  OR?: Maybe<Array<PatientWhereInput>>;
  allergies?: Maybe<AllergyItemManyRelationFilter>;
  appointmentNotes?: Maybe<AppointmentNoteManyRelationFilter>;
  appointmentRequests?: Maybe<AppointmentRequestManyRelationFilter>;
  appointmentSessions?: Maybe<AppointmentSessionManyRelationFilter>;
  appointmentVitals?: Maybe<AppointmentVitalManyRelationFilter>;
  appointments?: Maybe<AppointmentManyRelationFilter>;
  bookings?: Maybe<BookingManyRelationFilter>;
  caredByDoctors?: Maybe<DoctorManyRelationFilter>;
  companies?: Maybe<CompanyManyRelationFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  dataImportItems?: Maybe<DataImportItemManyRelationFilter>;
  documents?: Maybe<DocumentManyRelationFilter>;
  emergencyContacts?: Maybe<EmergencyContactManyRelationFilter>;
  faxes?: Maybe<FaxManyRelationFilter>;
  forms?: Maybe<FormManyRelationFilter>;
  healthCards?: Maybe<HealthCardManyRelationFilter>;
  healthConditions?: Maybe<HealthConditionManyRelationFilter>;
  id?: Maybe<IdFilter>;
  interactedDoctors?: Maybe<DoctorManyRelationFilter>;
  isCompleteProfile?: Maybe<BooleanFilter>;
  lifestyleItems?: Maybe<LifestyleItemManyRelationFilter>;
  medicationItems?: Maybe<MedicationItemManyRelationFilter>;
  name?: Maybe<StringFilter>;
  pharmacyLocations?: Maybe<PharmacyLocationManyRelationFilter>;
  prescriptions?: Maybe<PrescriptionManyRelationFilter>;
  savedDoctors?: Maybe<DoctorManyRelationFilter>;
  screeningTests?: Maybe<ScreeningTestManyRelationFilter>;
  tasks?: Maybe<TaskManyRelationFilter>;
  testOrders?: Maybe<TestOrderManyRelationFilter>;
  user?: Maybe<UserWhereInput>;
  vaccinations?: Maybe<VaccinationManyRelationFilter>;
  visitedDoctors?: Maybe<DoctorManyRelationFilter>;
};

export type PatientWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Pharmacy = {
  __typename?: 'Pharmacy';
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  locations?: Maybe<Array<PharmacyLocation>>;
  locationsCount?: Maybe<Scalars['Int']>;
};


export type PharmacyLocationsArgs = {
  cursor?: Maybe<PharmacyLocationWhereUniqueInput>;
  orderBy?: Array<PharmacyLocationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PharmacyLocationWhereInput;
};


export type PharmacyLocationsCountArgs = {
  where?: PharmacyLocationWhereInput;
};

export type PharmacyCreateInput = {
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locations?: Maybe<PharmacyLocationRelateToManyForCreateInput>;
};

export type PharmacyLocation = {
  __typename?: 'PharmacyLocation';
  accreditationNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxString?: Maybe<Scalars['String']>;
  faxes?: Maybe<Array<Fax>>;
  faxesCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  patients?: Maybe<Array<Patient>>;
  patientsCount?: Maybe<Scalars['Int']>;
  pharmacy?: Maybe<Pharmacy>;
  phoneString?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};


export type PharmacyLocationFaxesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type PharmacyLocationFaxesCountArgs = {
  where?: FaxWhereInput;
};


export type PharmacyLocationPatientsArgs = {
  cursor?: Maybe<PatientWhereUniqueInput>;
  orderBy?: Array<PatientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PatientWhereInput;
};


export type PharmacyLocationPatientsCountArgs = {
  where?: PatientWhereInput;
};

export type PharmacyLocationCreateInput = {
  accreditationNumber?: Maybe<Scalars['String']>;
  address?: Maybe<AddressRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxString?: Maybe<Scalars['String']>;
  faxes?: Maybe<FaxRelateToManyForCreateInput>;
  patients?: Maybe<PatientRelateToManyForCreateInput>;
  pharmacy?: Maybe<PharmacyRelateToOneForCreateInput>;
  phoneString?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PharmacyLocationManyRelationFilter = {
  every?: Maybe<PharmacyLocationWhereInput>;
  none?: Maybe<PharmacyLocationWhereInput>;
  some?: Maybe<PharmacyLocationWhereInput>;
};

export type PharmacyLocationOrderByInput = {
  accreditationNumber?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  faxString?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  phoneString?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
};

export type PharmacyLocationRelateToManyForCreateInput = {
  connect?: Maybe<Array<PharmacyLocationWhereUniqueInput>>;
  create?: Maybe<Array<PharmacyLocationCreateInput>>;
};

export type PharmacyLocationRelateToManyForUpdateInput = {
  connect?: Maybe<Array<PharmacyLocationWhereUniqueInput>>;
  create?: Maybe<Array<PharmacyLocationCreateInput>>;
  disconnect?: Maybe<Array<PharmacyLocationWhereUniqueInput>>;
  set?: Maybe<Array<PharmacyLocationWhereUniqueInput>>;
};

export type PharmacyLocationRelateToOneForCreateInput = {
  connect?: Maybe<PharmacyLocationWhereUniqueInput>;
  create?: Maybe<PharmacyLocationCreateInput>;
};

export type PharmacyLocationRelateToOneForUpdateInput = {
  connect?: Maybe<PharmacyLocationWhereUniqueInput>;
  create?: Maybe<PharmacyLocationCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type PharmacyLocationUpdateArgs = {
  data: PharmacyLocationUpdateInput;
  where: PharmacyLocationWhereUniqueInput;
};

export type PharmacyLocationUpdateInput = {
  accreditationNumber?: Maybe<Scalars['String']>;
  address?: Maybe<AddressRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  faxString?: Maybe<Scalars['String']>;
  faxes?: Maybe<FaxRelateToManyForUpdateInput>;
  patients?: Maybe<PatientRelateToManyForUpdateInput>;
  pharmacy?: Maybe<PharmacyRelateToOneForUpdateInput>;
  phoneString?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PharmacyLocationWhereInput = {
  AND?: Maybe<Array<PharmacyLocationWhereInput>>;
  NOT?: Maybe<Array<PharmacyLocationWhereInput>>;
  OR?: Maybe<Array<PharmacyLocationWhereInput>>;
  accreditationNumber?: Maybe<StringFilter>;
  address?: Maybe<AddressWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  faxString?: Maybe<StringFilter>;
  faxes?: Maybe<FaxManyRelationFilter>;
  id?: Maybe<IdFilter>;
  patients?: Maybe<PatientManyRelationFilter>;
  pharmacy?: Maybe<PharmacyWhereInput>;
  phoneString?: Maybe<StringFilter>;
  status?: Maybe<StringFilter>;
};

export type PharmacyLocationWhereUniqueInput = {
  accreditationNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type PharmacyOrderByInput = {
  companyName?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type PharmacyRelateToOneForCreateInput = {
  connect?: Maybe<PharmacyWhereUniqueInput>;
  create?: Maybe<PharmacyCreateInput>;
};

export type PharmacyRelateToOneForUpdateInput = {
  connect?: Maybe<PharmacyWhereUniqueInput>;
  create?: Maybe<PharmacyCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type PharmacyUpdateArgs = {
  data: PharmacyUpdateInput;
  where: PharmacyWhereUniqueInput;
};

export type PharmacyUpdateInput = {
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locations?: Maybe<PharmacyLocationRelateToManyForUpdateInput>;
};

export type PharmacyWhereInput = {
  AND?: Maybe<Array<PharmacyWhereInput>>;
  NOT?: Maybe<Array<PharmacyWhereInput>>;
  OR?: Maybe<Array<PharmacyWhereInput>>;
  companyName?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  locations?: Maybe<PharmacyLocationManyRelationFilter>;
};

export type PharmacyWhereUniqueInput = {
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type Prescription = {
  __typename?: 'Prescription';
  appointment?: Maybe<Appointment>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  id: Scalars['ID'];
  isSubstitutionAllowed?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<Patient>;
  preferredPharmacyLocation?: Maybe<PharmacyLocation>;
  prescriptionItems?: Maybe<Array<PrescriptionItem>>;
  prescriptionItemsCount?: Maybe<Scalars['Int']>;
};


export type PrescriptionPrescriptionItemsArgs = {
  cursor?: Maybe<PrescriptionItemWhereUniqueInput>;
  orderBy?: Array<PrescriptionItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PrescriptionItemWhereInput;
};


export type PrescriptionPrescriptionItemsCountArgs = {
  where?: PrescriptionItemWhereInput;
};

export type PrescriptionCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  isSubstitutionAllowed?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  preferredPharmacyLocation?: Maybe<PharmacyLocationRelateToOneForCreateInput>;
  prescriptionItems?: Maybe<PrescriptionItemRelateToManyForCreateInput>;
};

export type PrescriptionItem = {
  __typename?: 'PrescriptionItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  luCode?: Maybe<Scalars['String']>;
  medication?: Maybe<Medication>;
  prescription?: Maybe<Prescription>;
  refills?: Maybe<Scalars['String']>;
};

export type PrescriptionItemCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  instructions?: Maybe<Scalars['String']>;
  luCode?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForCreateInput>;
  prescription?: Maybe<PrescriptionRelateToOneForCreateInput>;
  refills?: Maybe<Scalars['String']>;
};

export type PrescriptionItemManyRelationFilter = {
  every?: Maybe<PrescriptionItemWhereInput>;
  none?: Maybe<PrescriptionItemWhereInput>;
  some?: Maybe<PrescriptionItemWhereInput>;
};

export type PrescriptionItemOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  instructions?: Maybe<OrderDirection>;
  luCode?: Maybe<OrderDirection>;
  refills?: Maybe<OrderDirection>;
};

export type PrescriptionItemRelateToManyForCreateInput = {
  connect?: Maybe<Array<PrescriptionItemWhereUniqueInput>>;
  create?: Maybe<Array<PrescriptionItemCreateInput>>;
};

export type PrescriptionItemRelateToManyForUpdateInput = {
  connect?: Maybe<Array<PrescriptionItemWhereUniqueInput>>;
  create?: Maybe<Array<PrescriptionItemCreateInput>>;
  disconnect?: Maybe<Array<PrescriptionItemWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionItemWhereUniqueInput>>;
};

export type PrescriptionItemUpdateArgs = {
  data: PrescriptionItemUpdateInput;
  where: PrescriptionItemWhereUniqueInput;
};

export type PrescriptionItemUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  instructions?: Maybe<Scalars['String']>;
  luCode?: Maybe<Scalars['String']>;
  medication?: Maybe<MedicationRelateToOneForUpdateInput>;
  prescription?: Maybe<PrescriptionRelateToOneForUpdateInput>;
  refills?: Maybe<Scalars['String']>;
};

export type PrescriptionItemWhereInput = {
  AND?: Maybe<Array<PrescriptionItemWhereInput>>;
  NOT?: Maybe<Array<PrescriptionItemWhereInput>>;
  OR?: Maybe<Array<PrescriptionItemWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  instructions?: Maybe<StringFilter>;
  luCode?: Maybe<StringFilter>;
  medication?: Maybe<MedicationWhereInput>;
  prescription?: Maybe<PrescriptionWhereInput>;
  refills?: Maybe<StringFilter>;
};

export type PrescriptionItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type PrescriptionManyRelationFilter = {
  every?: Maybe<PrescriptionWhereInput>;
  none?: Maybe<PrescriptionWhereInput>;
  some?: Maybe<PrescriptionWhereInput>;
};

export type PrescriptionOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isSubstitutionAllowed?: Maybe<OrderDirection>;
};

export type PrescriptionRelateToManyForCreateInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  create?: Maybe<Array<PrescriptionCreateInput>>;
};

export type PrescriptionRelateToManyForUpdateInput = {
  connect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  create?: Maybe<Array<PrescriptionCreateInput>>;
  disconnect?: Maybe<Array<PrescriptionWhereUniqueInput>>;
  set?: Maybe<Array<PrescriptionWhereUniqueInput>>;
};

export type PrescriptionRelateToOneForCreateInput = {
  connect?: Maybe<PrescriptionWhereUniqueInput>;
  create?: Maybe<PrescriptionCreateInput>;
};

export type PrescriptionRelateToOneForUpdateInput = {
  connect?: Maybe<PrescriptionWhereUniqueInput>;
  create?: Maybe<PrescriptionCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type PrescriptionUpdateArgs = {
  data: PrescriptionUpdateInput;
  where: PrescriptionWhereUniqueInput;
};

export type PrescriptionUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  isSubstitutionAllowed?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  preferredPharmacyLocation?: Maybe<PharmacyLocationRelateToOneForUpdateInput>;
  prescriptionItems?: Maybe<PrescriptionItemRelateToManyForUpdateInput>;
};

export type PrescriptionWhereInput = {
  AND?: Maybe<Array<PrescriptionWhereInput>>;
  NOT?: Maybe<Array<PrescriptionWhereInput>>;
  OR?: Maybe<Array<PrescriptionWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  id?: Maybe<IdFilter>;
  isSubstitutionAllowed?: Maybe<BooleanFilter>;
  patient?: Maybe<PatientWhereInput>;
  preferredPharmacyLocation?: Maybe<PharmacyLocationWhereInput>;
  prescriptionItems?: Maybe<PrescriptionItemManyRelationFilter>;
};

export type PrescriptionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type ProfilePhoto = {
  __typename?: 'ProfilePhoto';
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  src?: Maybe<CloudinaryImage_File>;
  user?: Maybe<User>;
};

export type ProfilePhotoCreateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  src?: Maybe<Scalars['Upload']>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type ProfilePhotoOrderByInput = {
  altText?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type ProfilePhotoRelateToOneForCreateInput = {
  connect?: Maybe<ProfilePhotoWhereUniqueInput>;
  create?: Maybe<ProfilePhotoCreateInput>;
};

export type ProfilePhotoRelateToOneForUpdateInput = {
  connect?: Maybe<ProfilePhotoWhereUniqueInput>;
  create?: Maybe<ProfilePhotoCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ProfilePhotoUpdateArgs = {
  data: ProfilePhotoUpdateInput;
  where: ProfilePhotoWhereUniqueInput;
};

export type ProfilePhotoUpdateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  src?: Maybe<Scalars['Upload']>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type ProfilePhotoWhereInput = {
  AND?: Maybe<Array<ProfilePhotoWhereInput>>;
  NOT?: Maybe<Array<ProfilePhotoWhereInput>>;
  OR?: Maybe<Array<ProfilePhotoWhereInput>>;
  altText?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  user?: Maybe<UserWhereInput>;
};

export type ProfilePhotoWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Prompt = {
  __typename?: 'Prompt';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  promptType?: Maybe<Scalars['String']>;
  promptValue?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  stepper?: Maybe<Stepper>;
  user?: Maybe<User>;
};

export type PromptCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  promptType?: Maybe<Scalars['String']>;
  promptValue?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  stepper?: Maybe<StepperRelateToOneForCreateInput>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type PromptManyRelationFilter = {
  every?: Maybe<PromptWhereInput>;
  none?: Maybe<PromptWhereInput>;
  some?: Maybe<PromptWhereInput>;
};

export type PromptOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  promptType?: Maybe<OrderDirection>;
  promptValue?: Maybe<OrderDirection>;
  slug?: Maybe<OrderDirection>;
};

export type PromptRelateToManyForCreateInput = {
  connect?: Maybe<Array<PromptWhereUniqueInput>>;
  create?: Maybe<Array<PromptCreateInput>>;
};

export type PromptRelateToManyForUpdateInput = {
  connect?: Maybe<Array<PromptWhereUniqueInput>>;
  create?: Maybe<Array<PromptCreateInput>>;
  disconnect?: Maybe<Array<PromptWhereUniqueInput>>;
  set?: Maybe<Array<PromptWhereUniqueInput>>;
};

export type PromptRelateToOneForCreateInput = {
  connect?: Maybe<PromptWhereUniqueInput>;
  create?: Maybe<PromptCreateInput>;
};

export type PromptRelateToOneForUpdateInput = {
  connect?: Maybe<PromptWhereUniqueInput>;
  create?: Maybe<PromptCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type PromptUpdateArgs = {
  data: PromptUpdateInput;
  where: PromptWhereUniqueInput;
};

export type PromptUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  promptType?: Maybe<Scalars['String']>;
  promptValue?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  stepper?: Maybe<StepperRelateToOneForUpdateInput>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type PromptWhereInput = {
  AND?: Maybe<Array<PromptWhereInput>>;
  NOT?: Maybe<Array<PromptWhereInput>>;
  OR?: Maybe<Array<PromptWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  name?: Maybe<StringFilter>;
  promptType?: Maybe<StringFilter>;
  promptValue?: Maybe<StringFilter>;
  slug?: Maybe<StringFilter>;
  stepper?: Maybe<StepperWhereInput>;
  user?: Maybe<UserWhereInput>;
};

export type PromptWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type ProofOfIdentification = {
  __typename?: 'ProofOfIdentification';
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  file?: Maybe<File>;
  id: Scalars['ID'];
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<CloudinaryImage_File>;
};

export type ProofOfIdentificationCreateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['Upload']>;
};

export type ProofOfIdentificationOrderByInput = {
  altText?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isVerified?: Maybe<OrderDirection>;
};

export type ProofOfIdentificationRelateToOneForCreateInput = {
  connect?: Maybe<ProofOfIdentificationWhereUniqueInput>;
  create?: Maybe<ProofOfIdentificationCreateInput>;
};

export type ProofOfIdentificationRelateToOneForUpdateInput = {
  connect?: Maybe<ProofOfIdentificationWhereUniqueInput>;
  create?: Maybe<ProofOfIdentificationCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ProofOfIdentificationUpdateArgs = {
  data: ProofOfIdentificationUpdateInput;
  where: ProofOfIdentificationWhereUniqueInput;
};

export type ProofOfIdentificationUpdateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['Upload']>;
};

export type ProofOfIdentificationWhereInput = {
  AND?: Maybe<Array<ProofOfIdentificationWhereInput>>;
  NOT?: Maybe<Array<ProofOfIdentificationWhereInput>>;
  OR?: Maybe<Array<ProofOfIdentificationWhereInput>>;
  altText?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
  isVerified?: Maybe<BooleanFilter>;
};

export type ProofOfIdentificationWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type ProofOfInsurance = {
  __typename?: 'ProofOfInsurance';
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  file?: Maybe<File>;
  id: Scalars['ID'];
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<CloudinaryImage_File>;
};

export type ProofOfInsuranceCreateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['Upload']>;
};

export type ProofOfInsuranceOrderByInput = {
  altText?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isVerified?: Maybe<OrderDirection>;
};

export type ProofOfInsuranceRelateToOneForCreateInput = {
  connect?: Maybe<ProofOfInsuranceWhereUniqueInput>;
  create?: Maybe<ProofOfInsuranceCreateInput>;
};

export type ProofOfInsuranceRelateToOneForUpdateInput = {
  connect?: Maybe<ProofOfInsuranceWhereUniqueInput>;
  create?: Maybe<ProofOfInsuranceCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ProofOfInsuranceUpdateArgs = {
  data: ProofOfInsuranceUpdateInput;
  where: ProofOfInsuranceWhereUniqueInput;
};

export type ProofOfInsuranceUpdateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['Upload']>;
};

export type ProofOfInsuranceWhereInput = {
  AND?: Maybe<Array<ProofOfInsuranceWhereInput>>;
  NOT?: Maybe<Array<ProofOfInsuranceWhereInput>>;
  OR?: Maybe<Array<ProofOfInsuranceWhereInput>>;
  altText?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
  isVerified?: Maybe<BooleanFilter>;
};

export type ProofOfInsuranceWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type ProofOfLicense = {
  __typename?: 'ProofOfLicense';
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  file?: Maybe<File>;
  id: Scalars['ID'];
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<CloudinaryImage_File>;
};

export type ProofOfLicenseCreateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['Upload']>;
};

export type ProofOfLicenseOrderByInput = {
  altText?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isVerified?: Maybe<OrderDirection>;
};

export type ProofOfLicenseRelateToOneForCreateInput = {
  connect?: Maybe<ProofOfLicenseWhereUniqueInput>;
  create?: Maybe<ProofOfLicenseCreateInput>;
};

export type ProofOfLicenseRelateToOneForUpdateInput = {
  connect?: Maybe<ProofOfLicenseWhereUniqueInput>;
  create?: Maybe<ProofOfLicenseCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ProofOfLicenseUpdateArgs = {
  data: ProofOfLicenseUpdateInput;
  where: ProofOfLicenseWhereUniqueInput;
};

export type ProofOfLicenseUpdateInput = {
  altText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
  isVerified?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['Upload']>;
};

export type ProofOfLicenseWhereInput = {
  AND?: Maybe<Array<ProofOfLicenseWhereInput>>;
  NOT?: Maybe<Array<ProofOfLicenseWhereInput>>;
  OR?: Maybe<Array<ProofOfLicenseWhereInput>>;
  altText?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
  isVerified?: Maybe<BooleanFilter>;
};

export type ProofOfLicenseWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Query = {
  __typename?: 'Query';
  accessToken?: Maybe<AccessToken>;
  accessTokens?: Maybe<Array<AccessToken>>;
  accessTokensCount?: Maybe<Scalars['Int']>;
  account?: Maybe<Account>;
  accounts?: Maybe<Array<Account>>;
  accountsCount?: Maybe<Scalars['Int']>;
  activeIngredient?: Maybe<ActiveIngredient>;
  activeIngredients?: Maybe<Array<ActiveIngredient>>;
  activeIngredientsCount?: Maybe<Scalars['Int']>;
  address?: Maybe<Address>;
  addresses?: Maybe<Array<Address>>;
  addressesCount?: Maybe<Scalars['Int']>;
  administrativeArea?: Maybe<AdministrativeArea>;
  administrativeAreas?: Maybe<Array<AdministrativeArea>>;
  administrativeAreasCount?: Maybe<Scalars['Int']>;
  allergyItem?: Maybe<AllergyItem>;
  allergyItems?: Maybe<Array<AllergyItem>>;
  allergyItemsCount?: Maybe<Scalars['Int']>;
  appointment?: Maybe<Appointment>;
  appointmentBilling?: Maybe<AppointmentBilling>;
  appointmentBillingException?: Maybe<AppointmentBillingException>;
  appointmentBillingExceptions?: Maybe<Array<AppointmentBillingException>>;
  appointmentBillingExceptionsCount?: Maybe<Scalars['Int']>;
  appointmentBillingItem?: Maybe<AppointmentBillingItem>;
  appointmentBillingItems?: Maybe<Array<AppointmentBillingItem>>;
  appointmentBillingItemsCount?: Maybe<Scalars['Int']>;
  appointmentBillings?: Maybe<Array<AppointmentBilling>>;
  appointmentBillingsCount?: Maybe<Scalars['Int']>;
  appointmentDraft?: Maybe<AppointmentDraft>;
  appointmentDrafts?: Maybe<Array<AppointmentDraft>>;
  appointmentDraftsCount?: Maybe<Scalars['Int']>;
  appointmentNote?: Maybe<AppointmentNote>;
  appointmentNotes?: Maybe<Array<AppointmentNote>>;
  appointmentNotesCount?: Maybe<Scalars['Int']>;
  appointmentRequest?: Maybe<AppointmentRequest>;
  appointmentRequests?: Maybe<Array<AppointmentRequest>>;
  appointmentRequestsCount?: Maybe<Scalars['Int']>;
  appointmentSession?: Maybe<AppointmentSession>;
  appointmentSessions?: Maybe<Array<AppointmentSession>>;
  appointmentSessionsCount?: Maybe<Scalars['Int']>;
  appointmentVital?: Maybe<AppointmentVital>;
  appointmentVitals?: Maybe<Array<AppointmentVital>>;
  appointmentVitalsCount?: Maybe<Scalars['Int']>;
  appointments?: Maybe<Array<Appointment>>;
  appointmentsCount?: Maybe<Scalars['Int']>;
  archive?: Maybe<Archive>;
  archiveItem?: Maybe<ArchiveItem>;
  archiveItems?: Maybe<Array<ArchiveItem>>;
  archiveItemsCount?: Maybe<Scalars['Int']>;
  archives?: Maybe<Array<Archive>>;
  archivesCount?: Maybe<Scalars['Int']>;
  authenticatedItem?: Maybe<AuthenticatedItem>;
  billingClaim?: Maybe<BillingClaim>;
  billingClaims?: Maybe<Array<BillingClaim>>;
  billingClaimsCount?: Maybe<Scalars['Int']>;
  billingDiagnoses?: Maybe<Array<BillingDiagnosis>>;
  billingDiagnosesCount?: Maybe<Scalars['Int']>;
  billingDiagnosis?: Maybe<BillingDiagnosis>;
  billingPremium?: Maybe<BillingPremium>;
  billingPremiums?: Maybe<Array<BillingPremium>>;
  billingPremiumsCount?: Maybe<Scalars['Int']>;
  billingSubmission?: Maybe<BillingSubmission>;
  billingSubmissions?: Maybe<Array<BillingSubmission>>;
  billingSubmissionsCount?: Maybe<Scalars['Int']>;
  birdSummaryIntent?: Maybe<BirdSummaryIntent>;
  birdSummaryIntents?: Maybe<Array<BirdSummaryIntent>>;
  birdSummaryIntentsCount?: Maybe<Scalars['Int']>;
  booking?: Maybe<Booking>;
  bookings?: Maybe<Array<Booking>>;
  bookingsCount?: Maybe<Scalars['Int']>;
  calendar?: Maybe<Calendar>;
  calendarEvent?: Maybe<CalendarEvent>;
  calendarEventType?: Maybe<CalendarEventType>;
  calendarEventTypes?: Maybe<Array<CalendarEventType>>;
  calendarEventTypesCount?: Maybe<Scalars['Int']>;
  calendarEvents?: Maybe<Array<CalendarEvent>>;
  calendarEventsCount?: Maybe<Scalars['Int']>;
  calendars?: Maybe<Array<Calendar>>;
  calendarsCount?: Maybe<Scalars['Int']>;
  chat?: Maybe<Chat>;
  chatMessage?: Maybe<ChatMessage>;
  chatMessages?: Maybe<Array<ChatMessage>>;
  chatMessagesCount?: Maybe<Scalars['Int']>;
  chats?: Maybe<Array<Chat>>;
  chatsCount?: Maybe<Scalars['Int']>;
  checkUserMembership?: Maybe<User>;
  clinic?: Maybe<Clinic>;
  clinics?: Maybe<Array<Clinic>>;
  clinicsCount?: Maybe<Scalars['Int']>;
  companies?: Maybe<Array<Company>>;
  companiesCount?: Maybe<Scalars['Int']>;
  company?: Maybe<Company>;
  companyLogo?: Maybe<CompanyLogo>;
  companyLogos?: Maybe<Array<CompanyLogo>>;
  companyLogosCount?: Maybe<Scalars['Int']>;
  contract?: Maybe<Contract>;
  contracts?: Maybe<Array<Contract>>;
  contractsCount?: Maybe<Scalars['Int']>;
  countries?: Maybe<Array<Country>>;
  countriesCount?: Maybe<Scalars['Int']>;
  country?: Maybe<Country>;
  coupon?: Maybe<Coupon>;
  coupons?: Maybe<Array<Coupon>>;
  couponsCount?: Maybe<Scalars['Int']>;
  dataImport?: Maybe<DataImport>;
  dataImportIntent?: Maybe<DataImportIntent>;
  dataImportIntents?: Maybe<Array<DataImportIntent>>;
  dataImportIntentsCount?: Maybe<Scalars['Int']>;
  dataImportItem?: Maybe<DataImportItem>;
  dataImportItems?: Maybe<Array<DataImportItem>>;
  dataImportItemsCount?: Maybe<Scalars['Int']>;
  dataImports?: Maybe<Array<DataImport>>;
  dataImportsCount?: Maybe<Scalars['Int']>;
  doctor?: Maybe<Doctor>;
  doctorSpecialties?: Maybe<Array<DoctorSpecialty>>;
  doctorSpecialtiesCount?: Maybe<Scalars['Int']>;
  doctorSpecialty?: Maybe<DoctorSpecialty>;
  doctorSubSpecialties?: Maybe<Array<DoctorSubSpecialty>>;
  doctorSubSpecialtiesCount?: Maybe<Scalars['Int']>;
  doctorSubSpecialty?: Maybe<DoctorSubSpecialty>;
  doctors?: Maybe<Array<Doctor>>;
  doctorsCount?: Maybe<Scalars['Int']>;
  document?: Maybe<Document>;
  documents?: Maybe<Array<Document>>;
  documentsCount?: Maybe<Scalars['Int']>;
  emergencyContact?: Maybe<EmergencyContact>;
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  emergencyContactsCount?: Maybe<Scalars['Int']>;
  fax?: Maybe<Fax>;
  faxBlast?: Maybe<FaxBlast>;
  faxBlastItem?: Maybe<FaxBlastItem>;
  faxBlastItems?: Maybe<Array<FaxBlastItem>>;
  faxBlastItemsCount?: Maybe<Scalars['Int']>;
  faxBlasts?: Maybe<Array<FaxBlast>>;
  faxBlastsCount?: Maybe<Scalars['Int']>;
  faxRecipient?: Maybe<FaxRecipient>;
  faxRecipients?: Maybe<Array<FaxRecipient>>;
  faxRecipientsCount?: Maybe<Scalars['Int']>;
  faxes?: Maybe<Array<Fax>>;
  faxesCount?: Maybe<Scalars['Int']>;
  feedbackItem?: Maybe<FeedbackItem>;
  feedbackItems?: Maybe<Array<FeedbackItem>>;
  feedbackItemsCount?: Maybe<Scalars['Int']>;
  file?: Maybe<File>;
  files?: Maybe<Array<File>>;
  filesCount?: Maybe<Scalars['Int']>;
  form?: Maybe<Form>;
  formTest?: Maybe<FormTest>;
  formTests?: Maybe<Array<FormTest>>;
  formTestsCount?: Maybe<Scalars['Int']>;
  formType?: Maybe<FormType>;
  formTypes?: Maybe<Array<FormType>>;
  formTypesCount?: Maybe<Scalars['Int']>;
  forms?: Maybe<Array<Form>>;
  formsCount?: Maybe<Scalars['Int']>;
  getAppointmentBillings?: Maybe<Array<Maybe<AppointmentBilling>>>;
  getAvailableTimeSlots?: Maybe<Array<Maybe<Scalars['String']>>>;
  getCompanyMembers?: Maybe<Array<Maybe<CompanyMemberWithRoles>>>;
  getInvitePublicData?: Maybe<Scalars['JSON']>;
  getSOAPCompletion?: Maybe<Scalars['JSON']>;
  healthCard?: Maybe<HealthCard>;
  healthCards?: Maybe<Array<HealthCard>>;
  healthCardsCount?: Maybe<Scalars['Int']>;
  healthCondition?: Maybe<HealthCondition>;
  healthConditions?: Maybe<Array<HealthCondition>>;
  healthConditionsCount?: Maybe<Scalars['Int']>;
  inboundFax?: Maybe<InboundFax>;
  inboundFaxes?: Maybe<Array<InboundFax>>;
  inboundFaxesCount?: Maybe<Scalars['Int']>;
  keystone: KeystoneMeta;
  language?: Maybe<Language>;
  languages?: Maybe<Array<Language>>;
  languagesCount?: Maybe<Scalars['Int']>;
  leaseAgreement?: Maybe<LeaseAgreement>;
  leaseAgreements?: Maybe<Array<LeaseAgreement>>;
  leaseAgreementsCount?: Maybe<Scalars['Int']>;
  lifestyleItem?: Maybe<LifestyleItem>;
  lifestyleItems?: Maybe<Array<LifestyleItem>>;
  lifestyleItemsCount?: Maybe<Scalars['Int']>;
  luReason?: Maybe<LuReason>;
  luReasons?: Maybe<Array<LuReason>>;
  luReasonsCount?: Maybe<Scalars['Int']>;
  masterLicense?: Maybe<MasterLicense>;
  masterLicenses?: Maybe<Array<MasterLicense>>;
  masterLicensesCount?: Maybe<Scalars['Int']>;
  medication?: Maybe<Medication>;
  medicationItem?: Maybe<MedicationItem>;
  medicationItems?: Maybe<Array<MedicationItem>>;
  medicationItemsCount?: Maybe<Scalars['Int']>;
  medications?: Maybe<Array<Medication>>;
  medicationsCount?: Maybe<Scalars['Int']>;
  member?: Maybe<Member>;
  members?: Maybe<Array<Member>>;
  membersCount?: Maybe<Scalars['Int']>;
  notificationDispatch?: Maybe<NotificationDispatch>;
  notificationDispatchItem?: Maybe<NotificationDispatchItem>;
  notificationDispatchItems?: Maybe<Array<NotificationDispatchItem>>;
  notificationDispatchItemsCount?: Maybe<Scalars['Int']>;
  notificationDispatches?: Maybe<Array<NotificationDispatch>>;
  notificationDispatchesCount?: Maybe<Scalars['Int']>;
  patient?: Maybe<Patient>;
  patients?: Maybe<Array<Patient>>;
  patientsCount?: Maybe<Scalars['Int']>;
  pharmacies?: Maybe<Array<Pharmacy>>;
  pharmaciesCount?: Maybe<Scalars['Int']>;
  pharmacy?: Maybe<Pharmacy>;
  pharmacyLocation?: Maybe<PharmacyLocation>;
  pharmacyLocations?: Maybe<Array<PharmacyLocation>>;
  pharmacyLocationsCount?: Maybe<Scalars['Int']>;
  prescription?: Maybe<Prescription>;
  prescriptionItem?: Maybe<PrescriptionItem>;
  prescriptionItems?: Maybe<Array<PrescriptionItem>>;
  prescriptionItemsCount?: Maybe<Scalars['Int']>;
  prescriptions?: Maybe<Array<Prescription>>;
  prescriptionsCount?: Maybe<Scalars['Int']>;
  profilePhoto?: Maybe<ProfilePhoto>;
  profilePhotos?: Maybe<Array<ProfilePhoto>>;
  profilePhotosCount?: Maybe<Scalars['Int']>;
  prompt?: Maybe<Prompt>;
  prompts?: Maybe<Array<Prompt>>;
  promptsCount?: Maybe<Scalars['Int']>;
  proofOfIdentification?: Maybe<ProofOfIdentification>;
  proofOfIdentifications?: Maybe<Array<ProofOfIdentification>>;
  proofOfIdentificationsCount?: Maybe<Scalars['Int']>;
  proofOfInsurance?: Maybe<ProofOfInsurance>;
  proofOfInsurances?: Maybe<Array<ProofOfInsurance>>;
  proofOfInsurancesCount?: Maybe<Scalars['Int']>;
  proofOfLicense?: Maybe<ProofOfLicense>;
  proofOfLicenses?: Maybe<Array<ProofOfLicense>>;
  proofOfLicensesCount?: Maybe<Scalars['Int']>;
  recurringSlot?: Maybe<RecurringSlot>;
  recurringSlots?: Maybe<Array<RecurringSlot>>;
  recurringSlotsCount?: Maybe<Scalars['Int']>;
  remittanceAdvice?: Maybe<RemittanceAdvice>;
  remittanceAdviceRequest?: Maybe<RemittanceAdviceRequest>;
  remittanceAdviceRequests?: Maybe<Array<RemittanceAdviceRequest>>;
  remittanceAdviceRequestsCount?: Maybe<Scalars['Int']>;
  remittanceAdvices?: Maybe<Array<RemittanceAdvice>>;
  remittanceAdvicesCount?: Maybe<Scalars['Int']>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Role>>;
  rolesCount?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Schedule>;
  schedules?: Maybe<Array<Schedule>>;
  schedulesCount?: Maybe<Scalars['Int']>;
  screeningTest?: Maybe<ScreeningTest>;
  screeningTests?: Maybe<Array<ScreeningTest>>;
  screeningTestsCount?: Maybe<Scalars['Int']>;
  session?: Maybe<Session>;
  sessionEvent?: Maybe<SessionEvent>;
  sessionEvents?: Maybe<Array<SessionEvent>>;
  sessionEventsCount?: Maybe<Scalars['Int']>;
  sessions?: Maybe<Array<Session>>;
  sessionsCount?: Maybe<Scalars['Int']>;
  signature?: Maybe<Signature>;
  signatures?: Maybe<Array<Signature>>;
  signaturesCount?: Maybe<Scalars['Int']>;
  stepper?: Maybe<Stepper>;
  stepperProg?: Maybe<StepperProg>;
  stepperProgs?: Maybe<Array<StepperProg>>;
  stepperProgsCount?: Maybe<Scalars['Int']>;
  stepperStep?: Maybe<StepperStep>;
  stepperStepProg?: Maybe<StepperStepProg>;
  stepperStepProgs?: Maybe<Array<StepperStepProg>>;
  stepperStepProgsCount?: Maybe<Scalars['Int']>;
  stepperSteps?: Maybe<Array<StepperStep>>;
  stepperStepsCount?: Maybe<Scalars['Int']>;
  steppers?: Maybe<Array<Stepper>>;
  steppersCount?: Maybe<Scalars['Int']>;
  task?: Maybe<Task>;
  tasks?: Maybe<Array<Task>>;
  tasksCount?: Maybe<Scalars['Int']>;
  testOrder?: Maybe<TestOrder>;
  testOrders?: Maybe<Array<TestOrder>>;
  testOrdersCount?: Maybe<Scalars['Int']>;
  testsBatch?: Maybe<TestsBatch>;
  testsBatches?: Maybe<Array<TestsBatch>>;
  testsBatchesCount?: Maybe<Scalars['Int']>;
  timeInterval?: Maybe<TimeInterval>;
  timeIntervals?: Maybe<Array<TimeInterval>>;
  timeIntervalsCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userInvite?: Maybe<UserInvite>;
  userInvites?: Maybe<Array<UserInvite>>;
  userInvitesCount?: Maybe<Scalars['Int']>;
  userSession?: Maybe<UserSession>;
  userSessions?: Maybe<Array<UserSession>>;
  userSessionsCount?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']>;
  vaccination?: Maybe<Vaccination>;
  vaccinations?: Maybe<Array<Vaccination>>;
  vaccinationsCount?: Maybe<Scalars['Int']>;
  verificationToken?: Maybe<VerificationToken>;
  verificationTokens?: Maybe<Array<VerificationToken>>;
  verificationTokensCount?: Maybe<Scalars['Int']>;
};


export type QueryAccessTokenArgs = {
  where: AccessTokenWhereUniqueInput;
};


export type QueryAccessTokensArgs = {
  cursor?: Maybe<AccessTokenWhereUniqueInput>;
  orderBy?: Array<AccessTokenOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AccessTokenWhereInput;
};


export type QueryAccessTokensCountArgs = {
  where?: AccessTokenWhereInput;
};


export type QueryAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type QueryAccountsArgs = {
  cursor?: Maybe<AccountWhereUniqueInput>;
  orderBy?: Array<AccountOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AccountWhereInput;
};


export type QueryAccountsCountArgs = {
  where?: AccountWhereInput;
};


export type QueryActiveIngredientArgs = {
  where: ActiveIngredientWhereUniqueInput;
};


export type QueryActiveIngredientsArgs = {
  cursor?: Maybe<ActiveIngredientWhereUniqueInput>;
  orderBy?: Array<ActiveIngredientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ActiveIngredientWhereInput;
};


export type QueryActiveIngredientsCountArgs = {
  where?: ActiveIngredientWhereInput;
};


export type QueryAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type QueryAddressesArgs = {
  cursor?: Maybe<AddressWhereUniqueInput>;
  orderBy?: Array<AddressOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AddressWhereInput;
};


export type QueryAddressesCountArgs = {
  where?: AddressWhereInput;
};


export type QueryAdministrativeAreaArgs = {
  where: AdministrativeAreaWhereUniqueInput;
};


export type QueryAdministrativeAreasArgs = {
  cursor?: Maybe<AdministrativeAreaWhereUniqueInput>;
  orderBy?: Array<AdministrativeAreaOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AdministrativeAreaWhereInput;
};


export type QueryAdministrativeAreasCountArgs = {
  where?: AdministrativeAreaWhereInput;
};


export type QueryAllergyItemArgs = {
  where: AllergyItemWhereUniqueInput;
};


export type QueryAllergyItemsArgs = {
  cursor?: Maybe<AllergyItemWhereUniqueInput>;
  orderBy?: Array<AllergyItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AllergyItemWhereInput;
};


export type QueryAllergyItemsCountArgs = {
  where?: AllergyItemWhereInput;
};


export type QueryAppointmentArgs = {
  where: AppointmentWhereUniqueInput;
};


export type QueryAppointmentBillingArgs = {
  where: AppointmentBillingWhereUniqueInput;
};


export type QueryAppointmentBillingExceptionArgs = {
  where: AppointmentBillingExceptionWhereUniqueInput;
};


export type QueryAppointmentBillingExceptionsArgs = {
  cursor?: Maybe<AppointmentBillingExceptionWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingExceptionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingExceptionWhereInput;
};


export type QueryAppointmentBillingExceptionsCountArgs = {
  where?: AppointmentBillingExceptionWhereInput;
};


export type QueryAppointmentBillingItemArgs = {
  where: AppointmentBillingItemWhereUniqueInput;
};


export type QueryAppointmentBillingItemsArgs = {
  cursor?: Maybe<AppointmentBillingItemWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingItemWhereInput;
};


export type QueryAppointmentBillingItemsCountArgs = {
  where?: AppointmentBillingItemWhereInput;
};


export type QueryAppointmentBillingsArgs = {
  cursor?: Maybe<AppointmentBillingWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingWhereInput;
};


export type QueryAppointmentBillingsCountArgs = {
  where?: AppointmentBillingWhereInput;
};


export type QueryAppointmentDraftArgs = {
  where: AppointmentDraftWhereUniqueInput;
};


export type QueryAppointmentDraftsArgs = {
  cursor?: Maybe<AppointmentDraftWhereUniqueInput>;
  orderBy?: Array<AppointmentDraftOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentDraftWhereInput;
};


export type QueryAppointmentDraftsCountArgs = {
  where?: AppointmentDraftWhereInput;
};


export type QueryAppointmentNoteArgs = {
  where: AppointmentNoteWhereUniqueInput;
};


export type QueryAppointmentNotesArgs = {
  cursor?: Maybe<AppointmentNoteWhereUniqueInput>;
  orderBy?: Array<AppointmentNoteOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentNoteWhereInput;
};


export type QueryAppointmentNotesCountArgs = {
  where?: AppointmentNoteWhereInput;
};


export type QueryAppointmentRequestArgs = {
  where: AppointmentRequestWhereUniqueInput;
};


export type QueryAppointmentRequestsArgs = {
  cursor?: Maybe<AppointmentRequestWhereUniqueInput>;
  orderBy?: Array<AppointmentRequestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentRequestWhereInput;
};


export type QueryAppointmentRequestsCountArgs = {
  where?: AppointmentRequestWhereInput;
};


export type QueryAppointmentSessionArgs = {
  where: AppointmentSessionWhereUniqueInput;
};


export type QueryAppointmentSessionsArgs = {
  cursor?: Maybe<AppointmentSessionWhereUniqueInput>;
  orderBy?: Array<AppointmentSessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentSessionWhereInput;
};


export type QueryAppointmentSessionsCountArgs = {
  where?: AppointmentSessionWhereInput;
};


export type QueryAppointmentVitalArgs = {
  where: AppointmentVitalWhereUniqueInput;
};


export type QueryAppointmentVitalsArgs = {
  cursor?: Maybe<AppointmentVitalWhereUniqueInput>;
  orderBy?: Array<AppointmentVitalOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentVitalWhereInput;
};


export type QueryAppointmentVitalsCountArgs = {
  where?: AppointmentVitalWhereInput;
};


export type QueryAppointmentsArgs = {
  cursor?: Maybe<AppointmentWhereUniqueInput>;
  orderBy?: Array<AppointmentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentWhereInput;
};


export type QueryAppointmentsCountArgs = {
  where?: AppointmentWhereInput;
};


export type QueryArchiveArgs = {
  where: ArchiveWhereUniqueInput;
};


export type QueryArchiveItemArgs = {
  where: ArchiveItemWhereUniqueInput;
};


export type QueryArchiveItemsArgs = {
  cursor?: Maybe<ArchiveItemWhereUniqueInput>;
  orderBy?: Array<ArchiveItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ArchiveItemWhereInput;
};


export type QueryArchiveItemsCountArgs = {
  where?: ArchiveItemWhereInput;
};


export type QueryArchivesArgs = {
  cursor?: Maybe<ArchiveWhereUniqueInput>;
  orderBy?: Array<ArchiveOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ArchiveWhereInput;
};


export type QueryArchivesCountArgs = {
  where?: ArchiveWhereInput;
};


export type QueryBillingClaimArgs = {
  where: BillingClaimWhereUniqueInput;
};


export type QueryBillingClaimsArgs = {
  cursor?: Maybe<BillingClaimWhereUniqueInput>;
  orderBy?: Array<BillingClaimOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BillingClaimWhereInput;
};


export type QueryBillingClaimsCountArgs = {
  where?: BillingClaimWhereInput;
};


export type QueryBillingDiagnosesArgs = {
  cursor?: Maybe<BillingDiagnosisWhereUniqueInput>;
  orderBy?: Array<BillingDiagnosisOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BillingDiagnosisWhereInput;
};


export type QueryBillingDiagnosesCountArgs = {
  where?: BillingDiagnosisWhereInput;
};


export type QueryBillingDiagnosisArgs = {
  where: BillingDiagnosisWhereUniqueInput;
};


export type QueryBillingPremiumArgs = {
  where: BillingPremiumWhereUniqueInput;
};


export type QueryBillingPremiumsArgs = {
  cursor?: Maybe<BillingPremiumWhereUniqueInput>;
  orderBy?: Array<BillingPremiumOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BillingPremiumWhereInput;
};


export type QueryBillingPremiumsCountArgs = {
  where?: BillingPremiumWhereInput;
};


export type QueryBillingSubmissionArgs = {
  where: BillingSubmissionWhereUniqueInput;
};


export type QueryBillingSubmissionsArgs = {
  cursor?: Maybe<BillingSubmissionWhereUniqueInput>;
  orderBy?: Array<BillingSubmissionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BillingSubmissionWhereInput;
};


export type QueryBillingSubmissionsCountArgs = {
  where?: BillingSubmissionWhereInput;
};


export type QueryBirdSummaryIntentArgs = {
  where: BirdSummaryIntentWhereUniqueInput;
};


export type QueryBirdSummaryIntentsArgs = {
  cursor?: Maybe<BirdSummaryIntentWhereUniqueInput>;
  orderBy?: Array<BirdSummaryIntentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BirdSummaryIntentWhereInput;
};


export type QueryBirdSummaryIntentsCountArgs = {
  where?: BirdSummaryIntentWhereInput;
};


export type QueryBookingArgs = {
  where: BookingWhereUniqueInput;
};


export type QueryBookingsArgs = {
  cursor?: Maybe<BookingWhereUniqueInput>;
  orderBy?: Array<BookingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: BookingWhereInput;
};


export type QueryBookingsCountArgs = {
  where?: BookingWhereInput;
};


export type QueryCalendarArgs = {
  where: CalendarWhereUniqueInput;
};


export type QueryCalendarEventArgs = {
  where: CalendarEventWhereUniqueInput;
};


export type QueryCalendarEventTypeArgs = {
  where: CalendarEventTypeWhereUniqueInput;
};


export type QueryCalendarEventTypesArgs = {
  cursor?: Maybe<CalendarEventTypeWhereUniqueInput>;
  orderBy?: Array<CalendarEventTypeOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CalendarEventTypeWhereInput;
};


export type QueryCalendarEventTypesCountArgs = {
  where?: CalendarEventTypeWhereInput;
};


export type QueryCalendarEventsArgs = {
  cursor?: Maybe<CalendarEventWhereUniqueInput>;
  orderBy?: Array<CalendarEventOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CalendarEventWhereInput;
};


export type QueryCalendarEventsCountArgs = {
  where?: CalendarEventWhereInput;
};


export type QueryCalendarsArgs = {
  cursor?: Maybe<CalendarWhereUniqueInput>;
  orderBy?: Array<CalendarOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CalendarWhereInput;
};


export type QueryCalendarsCountArgs = {
  where?: CalendarWhereInput;
};


export type QueryChatArgs = {
  where: ChatWhereUniqueInput;
};


export type QueryChatMessageArgs = {
  where: ChatMessageWhereUniqueInput;
};


export type QueryChatMessagesArgs = {
  cursor?: Maybe<ChatMessageWhereUniqueInput>;
  orderBy?: Array<ChatMessageOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ChatMessageWhereInput;
};


export type QueryChatMessagesCountArgs = {
  where?: ChatMessageWhereInput;
};


export type QueryChatsArgs = {
  cursor?: Maybe<ChatWhereUniqueInput>;
  orderBy?: Array<ChatOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ChatWhereInput;
};


export type QueryChatsCountArgs = {
  where?: ChatWhereInput;
};


export type QueryCheckUserMembershipArgs = {
  clinicId?: Maybe<Scalars['ID']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  memberEmail: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};


export type QueryClinicArgs = {
  where: ClinicWhereUniqueInput;
};


export type QueryClinicsArgs = {
  cursor?: Maybe<ClinicWhereUniqueInput>;
  orderBy?: Array<ClinicOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ClinicWhereInput;
};


export type QueryClinicsCountArgs = {
  where?: ClinicWhereInput;
};


export type QueryCompaniesArgs = {
  cursor?: Maybe<CompanyWhereUniqueInput>;
  orderBy?: Array<CompanyOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CompanyWhereInput;
};


export type QueryCompaniesCountArgs = {
  where?: CompanyWhereInput;
};


export type QueryCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type QueryCompanyLogoArgs = {
  where: CompanyLogoWhereUniqueInput;
};


export type QueryCompanyLogosArgs = {
  cursor?: Maybe<CompanyLogoWhereUniqueInput>;
  orderBy?: Array<CompanyLogoOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CompanyLogoWhereInput;
};


export type QueryCompanyLogosCountArgs = {
  where?: CompanyLogoWhereInput;
};


export type QueryContractArgs = {
  where: ContractWhereUniqueInput;
};


export type QueryContractsArgs = {
  cursor?: Maybe<ContractWhereUniqueInput>;
  orderBy?: Array<ContractOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ContractWhereInput;
};


export type QueryContractsCountArgs = {
  where?: ContractWhereInput;
};


export type QueryCountriesArgs = {
  cursor?: Maybe<CountryWhereUniqueInput>;
  orderBy?: Array<CountryOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CountryWhereInput;
};


export type QueryCountriesCountArgs = {
  where?: CountryWhereInput;
};


export type QueryCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type QueryCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type QueryCouponsArgs = {
  cursor?: Maybe<CouponWhereUniqueInput>;
  orderBy?: Array<CouponOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CouponWhereInput;
};


export type QueryCouponsCountArgs = {
  where?: CouponWhereInput;
};


export type QueryDataImportArgs = {
  where: DataImportWhereUniqueInput;
};


export type QueryDataImportIntentArgs = {
  where: DataImportIntentWhereUniqueInput;
};


export type QueryDataImportIntentsArgs = {
  cursor?: Maybe<DataImportIntentWhereUniqueInput>;
  orderBy?: Array<DataImportIntentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportIntentWhereInput;
};


export type QueryDataImportIntentsCountArgs = {
  where?: DataImportIntentWhereInput;
};


export type QueryDataImportItemArgs = {
  where: DataImportItemWhereUniqueInput;
};


export type QueryDataImportItemsArgs = {
  cursor?: Maybe<DataImportItemWhereUniqueInput>;
  orderBy?: Array<DataImportItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportItemWhereInput;
};


export type QueryDataImportItemsCountArgs = {
  where?: DataImportItemWhereInput;
};


export type QueryDataImportsArgs = {
  cursor?: Maybe<DataImportWhereUniqueInput>;
  orderBy?: Array<DataImportOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportWhereInput;
};


export type QueryDataImportsCountArgs = {
  where?: DataImportWhereInput;
};


export type QueryDoctorArgs = {
  where: DoctorWhereUniqueInput;
};


export type QueryDoctorSpecialtiesArgs = {
  cursor?: Maybe<DoctorSpecialtyWhereUniqueInput>;
  orderBy?: Array<DoctorSpecialtyOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorSpecialtyWhereInput;
};


export type QueryDoctorSpecialtiesCountArgs = {
  where?: DoctorSpecialtyWhereInput;
};


export type QueryDoctorSpecialtyArgs = {
  where: DoctorSpecialtyWhereUniqueInput;
};


export type QueryDoctorSubSpecialtiesArgs = {
  cursor?: Maybe<DoctorSubSpecialtyWhereUniqueInput>;
  orderBy?: Array<DoctorSubSpecialtyOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorSubSpecialtyWhereInput;
};


export type QueryDoctorSubSpecialtiesCountArgs = {
  where?: DoctorSubSpecialtyWhereInput;
};


export type QueryDoctorSubSpecialtyArgs = {
  where: DoctorSubSpecialtyWhereUniqueInput;
};


export type QueryDoctorsArgs = {
  cursor?: Maybe<DoctorWhereUniqueInput>;
  orderBy?: Array<DoctorOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DoctorWhereInput;
};


export type QueryDoctorsCountArgs = {
  where?: DoctorWhereInput;
};


export type QueryDocumentArgs = {
  where: DocumentWhereUniqueInput;
};


export type QueryDocumentsArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  orderBy?: Array<DocumentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DocumentWhereInput;
};


export type QueryDocumentsCountArgs = {
  where?: DocumentWhereInput;
};


export type QueryEmergencyContactArgs = {
  where: EmergencyContactWhereUniqueInput;
};


export type QueryEmergencyContactsArgs = {
  cursor?: Maybe<EmergencyContactWhereUniqueInput>;
  orderBy?: Array<EmergencyContactOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: EmergencyContactWhereInput;
};


export type QueryEmergencyContactsCountArgs = {
  where?: EmergencyContactWhereInput;
};


export type QueryFaxArgs = {
  where: FaxWhereUniqueInput;
};


export type QueryFaxBlastArgs = {
  where: FaxBlastWhereUniqueInput;
};


export type QueryFaxBlastItemArgs = {
  where: FaxBlastItemWhereUniqueInput;
};


export type QueryFaxBlastItemsArgs = {
  cursor?: Maybe<FaxBlastItemWhereUniqueInput>;
  orderBy?: Array<FaxBlastItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxBlastItemWhereInput;
};


export type QueryFaxBlastItemsCountArgs = {
  where?: FaxBlastItemWhereInput;
};


export type QueryFaxBlastsArgs = {
  cursor?: Maybe<FaxBlastWhereUniqueInput>;
  orderBy?: Array<FaxBlastOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxBlastWhereInput;
};


export type QueryFaxBlastsCountArgs = {
  where?: FaxBlastWhereInput;
};


export type QueryFaxRecipientArgs = {
  where: FaxRecipientWhereUniqueInput;
};


export type QueryFaxRecipientsArgs = {
  cursor?: Maybe<FaxRecipientWhereUniqueInput>;
  orderBy?: Array<FaxRecipientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxRecipientWhereInput;
};


export type QueryFaxRecipientsCountArgs = {
  where?: FaxRecipientWhereInput;
};


export type QueryFaxesArgs = {
  cursor?: Maybe<FaxWhereUniqueInput>;
  orderBy?: Array<FaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxWhereInput;
};


export type QueryFaxesCountArgs = {
  where?: FaxWhereInput;
};


export type QueryFeedbackItemArgs = {
  where: FeedbackItemWhereUniqueInput;
};


export type QueryFeedbackItemsArgs = {
  cursor?: Maybe<FeedbackItemWhereUniqueInput>;
  orderBy?: Array<FeedbackItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FeedbackItemWhereInput;
};


export type QueryFeedbackItemsCountArgs = {
  where?: FeedbackItemWhereInput;
};


export type QueryFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryFilesArgs = {
  cursor?: Maybe<FileWhereUniqueInput>;
  orderBy?: Array<FileOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FileWhereInput;
};


export type QueryFilesCountArgs = {
  where?: FileWhereInput;
};


export type QueryFormArgs = {
  where: FormWhereUniqueInput;
};


export type QueryFormTestArgs = {
  where: FormTestWhereUniqueInput;
};


export type QueryFormTestsArgs = {
  cursor?: Maybe<FormTestWhereUniqueInput>;
  orderBy?: Array<FormTestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormTestWhereInput;
};


export type QueryFormTestsCountArgs = {
  where?: FormTestWhereInput;
};


export type QueryFormTypeArgs = {
  where: FormTypeWhereUniqueInput;
};


export type QueryFormTypesArgs = {
  cursor?: Maybe<FormTypeWhereUniqueInput>;
  orderBy?: Array<FormTypeOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormTypeWhereInput;
};


export type QueryFormTypesCountArgs = {
  where?: FormTypeWhereInput;
};


export type QueryFormsArgs = {
  cursor?: Maybe<FormWhereUniqueInput>;
  orderBy?: Array<FormOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormWhereInput;
};


export type QueryFormsCountArgs = {
  where?: FormWhereInput;
};


export type QueryGetAppointmentBillingsArgs = {
  companyId: Scalars['ID'];
  filters?: Maybe<AppointmentBillingWhereInput>;
  orderBy?: Maybe<Scalars['JSON']>;
  searchTerm?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  status: AppointmentBillingStatusTypeNullableFilter;
  take?: Maybe<Scalars['Int']>;
};


export type QueryGetAvailableTimeSlotsArgs = {
  dateFromUTC: Scalars['DateTime'];
  dateToUTC: Scalars['DateTime'];
  memberId: Scalars['ID'];
  patientId: Scalars['ID'];
};


export type QueryGetCompanyMembersArgs = {
  companyId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
};


export type QueryGetInvitePublicDataArgs = {
  inviteId: Scalars['ID'];
};


export type QueryGetSoapCompletionArgs = {
  note: Scalars['String'];
};


export type QueryHealthCardArgs = {
  where: HealthCardWhereUniqueInput;
};


export type QueryHealthCardsArgs = {
  cursor?: Maybe<HealthCardWhereUniqueInput>;
  orderBy?: Array<HealthCardOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: HealthCardWhereInput;
};


export type QueryHealthCardsCountArgs = {
  where?: HealthCardWhereInput;
};


export type QueryHealthConditionArgs = {
  where: HealthConditionWhereUniqueInput;
};


export type QueryHealthConditionsArgs = {
  cursor?: Maybe<HealthConditionWhereUniqueInput>;
  orderBy?: Array<HealthConditionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: HealthConditionWhereInput;
};


export type QueryHealthConditionsCountArgs = {
  where?: HealthConditionWhereInput;
};


export type QueryInboundFaxArgs = {
  where: InboundFaxWhereUniqueInput;
};


export type QueryInboundFaxesArgs = {
  cursor?: Maybe<InboundFaxWhereUniqueInput>;
  orderBy?: Array<InboundFaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: InboundFaxWhereInput;
};


export type QueryInboundFaxesCountArgs = {
  where?: InboundFaxWhereInput;
};


export type QueryLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type QueryLanguagesArgs = {
  cursor?: Maybe<LanguageWhereUniqueInput>;
  orderBy?: Array<LanguageOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: LanguageWhereInput;
};


export type QueryLanguagesCountArgs = {
  where?: LanguageWhereInput;
};


export type QueryLeaseAgreementArgs = {
  where: LeaseAgreementWhereUniqueInput;
};


export type QueryLeaseAgreementsArgs = {
  cursor?: Maybe<LeaseAgreementWhereUniqueInput>;
  orderBy?: Array<LeaseAgreementOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: LeaseAgreementWhereInput;
};


export type QueryLeaseAgreementsCountArgs = {
  where?: LeaseAgreementWhereInput;
};


export type QueryLifestyleItemArgs = {
  where: LifestyleItemWhereUniqueInput;
};


export type QueryLifestyleItemsArgs = {
  cursor?: Maybe<LifestyleItemWhereUniqueInput>;
  orderBy?: Array<LifestyleItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: LifestyleItemWhereInput;
};


export type QueryLifestyleItemsCountArgs = {
  where?: LifestyleItemWhereInput;
};


export type QueryLuReasonArgs = {
  where: LuReasonWhereUniqueInput;
};


export type QueryLuReasonsArgs = {
  cursor?: Maybe<LuReasonWhereUniqueInput>;
  orderBy?: Array<LuReasonOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: LuReasonWhereInput;
};


export type QueryLuReasonsCountArgs = {
  where?: LuReasonWhereInput;
};


export type QueryMasterLicenseArgs = {
  where: MasterLicenseWhereUniqueInput;
};


export type QueryMasterLicensesArgs = {
  cursor?: Maybe<MasterLicenseWhereUniqueInput>;
  orderBy?: Array<MasterLicenseOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MasterLicenseWhereInput;
};


export type QueryMasterLicensesCountArgs = {
  where?: MasterLicenseWhereInput;
};


export type QueryMedicationArgs = {
  where: MedicationWhereUniqueInput;
};


export type QueryMedicationItemArgs = {
  where: MedicationItemWhereUniqueInput;
};


export type QueryMedicationItemsArgs = {
  cursor?: Maybe<MedicationItemWhereUniqueInput>;
  orderBy?: Array<MedicationItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MedicationItemWhereInput;
};


export type QueryMedicationItemsCountArgs = {
  where?: MedicationItemWhereInput;
};


export type QueryMedicationsArgs = {
  cursor?: Maybe<MedicationWhereUniqueInput>;
  orderBy?: Array<MedicationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MedicationWhereInput;
};


export type QueryMedicationsCountArgs = {
  where?: MedicationWhereInput;
};


export type QueryMemberArgs = {
  where: MemberWhereUniqueInput;
};


export type QueryMembersArgs = {
  cursor?: Maybe<MemberWhereUniqueInput>;
  orderBy?: Array<MemberOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MemberWhereInput;
};


export type QueryMembersCountArgs = {
  where?: MemberWhereInput;
};


export type QueryNotificationDispatchArgs = {
  where: NotificationDispatchWhereUniqueInput;
};


export type QueryNotificationDispatchItemArgs = {
  where: NotificationDispatchItemWhereUniqueInput;
};


export type QueryNotificationDispatchItemsArgs = {
  cursor?: Maybe<NotificationDispatchItemWhereUniqueInput>;
  orderBy?: Array<NotificationDispatchItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: NotificationDispatchItemWhereInput;
};


export type QueryNotificationDispatchItemsCountArgs = {
  where?: NotificationDispatchItemWhereInput;
};


export type QueryNotificationDispatchesArgs = {
  cursor?: Maybe<NotificationDispatchWhereUniqueInput>;
  orderBy?: Array<NotificationDispatchOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: NotificationDispatchWhereInput;
};


export type QueryNotificationDispatchesCountArgs = {
  where?: NotificationDispatchWhereInput;
};


export type QueryPatientArgs = {
  where: PatientWhereUniqueInput;
};


export type QueryPatientsArgs = {
  cursor?: Maybe<PatientWhereUniqueInput>;
  orderBy?: Array<PatientOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PatientWhereInput;
};


export type QueryPatientsCountArgs = {
  where?: PatientWhereInput;
};


export type QueryPharmaciesArgs = {
  cursor?: Maybe<PharmacyWhereUniqueInput>;
  orderBy?: Array<PharmacyOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PharmacyWhereInput;
};


export type QueryPharmaciesCountArgs = {
  where?: PharmacyWhereInput;
};


export type QueryPharmacyArgs = {
  where: PharmacyWhereUniqueInput;
};


export type QueryPharmacyLocationArgs = {
  where: PharmacyLocationWhereUniqueInput;
};


export type QueryPharmacyLocationsArgs = {
  cursor?: Maybe<PharmacyLocationWhereUniqueInput>;
  orderBy?: Array<PharmacyLocationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PharmacyLocationWhereInput;
};


export type QueryPharmacyLocationsCountArgs = {
  where?: PharmacyLocationWhereInput;
};


export type QueryPrescriptionArgs = {
  where: PrescriptionWhereUniqueInput;
};


export type QueryPrescriptionItemArgs = {
  where: PrescriptionItemWhereUniqueInput;
};


export type QueryPrescriptionItemsArgs = {
  cursor?: Maybe<PrescriptionItemWhereUniqueInput>;
  orderBy?: Array<PrescriptionItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PrescriptionItemWhereInput;
};


export type QueryPrescriptionItemsCountArgs = {
  where?: PrescriptionItemWhereInput;
};


export type QueryPrescriptionsArgs = {
  cursor?: Maybe<PrescriptionWhereUniqueInput>;
  orderBy?: Array<PrescriptionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PrescriptionWhereInput;
};


export type QueryPrescriptionsCountArgs = {
  where?: PrescriptionWhereInput;
};


export type QueryProfilePhotoArgs = {
  where: ProfilePhotoWhereUniqueInput;
};


export type QueryProfilePhotosArgs = {
  cursor?: Maybe<ProfilePhotoWhereUniqueInput>;
  orderBy?: Array<ProfilePhotoOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ProfilePhotoWhereInput;
};


export type QueryProfilePhotosCountArgs = {
  where?: ProfilePhotoWhereInput;
};


export type QueryPromptArgs = {
  where: PromptWhereUniqueInput;
};


export type QueryPromptsArgs = {
  cursor?: Maybe<PromptWhereUniqueInput>;
  orderBy?: Array<PromptOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PromptWhereInput;
};


export type QueryPromptsCountArgs = {
  where?: PromptWhereInput;
};


export type QueryProofOfIdentificationArgs = {
  where: ProofOfIdentificationWhereUniqueInput;
};


export type QueryProofOfIdentificationsArgs = {
  cursor?: Maybe<ProofOfIdentificationWhereUniqueInput>;
  orderBy?: Array<ProofOfIdentificationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ProofOfIdentificationWhereInput;
};


export type QueryProofOfIdentificationsCountArgs = {
  where?: ProofOfIdentificationWhereInput;
};


export type QueryProofOfInsuranceArgs = {
  where: ProofOfInsuranceWhereUniqueInput;
};


export type QueryProofOfInsurancesArgs = {
  cursor?: Maybe<ProofOfInsuranceWhereUniqueInput>;
  orderBy?: Array<ProofOfInsuranceOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ProofOfInsuranceWhereInput;
};


export type QueryProofOfInsurancesCountArgs = {
  where?: ProofOfInsuranceWhereInput;
};


export type QueryProofOfLicenseArgs = {
  where: ProofOfLicenseWhereUniqueInput;
};


export type QueryProofOfLicensesArgs = {
  cursor?: Maybe<ProofOfLicenseWhereUniqueInput>;
  orderBy?: Array<ProofOfLicenseOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ProofOfLicenseWhereInput;
};


export type QueryProofOfLicensesCountArgs = {
  where?: ProofOfLicenseWhereInput;
};


export type QueryRecurringSlotArgs = {
  where: RecurringSlotWhereUniqueInput;
};


export type QueryRecurringSlotsArgs = {
  cursor?: Maybe<RecurringSlotWhereUniqueInput>;
  orderBy?: Array<RecurringSlotOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: RecurringSlotWhereInput;
};


export type QueryRecurringSlotsCountArgs = {
  where?: RecurringSlotWhereInput;
};


export type QueryRemittanceAdviceArgs = {
  where: RemittanceAdviceWhereUniqueInput;
};


export type QueryRemittanceAdviceRequestArgs = {
  where: RemittanceAdviceRequestWhereUniqueInput;
};


export type QueryRemittanceAdviceRequestsArgs = {
  cursor?: Maybe<RemittanceAdviceRequestWhereUniqueInput>;
  orderBy?: Array<RemittanceAdviceRequestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: RemittanceAdviceRequestWhereInput;
};


export type QueryRemittanceAdviceRequestsCountArgs = {
  where?: RemittanceAdviceRequestWhereInput;
};


export type QueryRemittanceAdvicesArgs = {
  cursor?: Maybe<RemittanceAdviceWhereUniqueInput>;
  orderBy?: Array<RemittanceAdviceOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: RemittanceAdviceWhereInput;
};


export type QueryRemittanceAdvicesCountArgs = {
  where?: RemittanceAdviceWhereInput;
};


export type QueryRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type QueryRolesArgs = {
  cursor?: Maybe<RoleWhereUniqueInput>;
  orderBy?: Array<RoleOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: RoleWhereInput;
};


export type QueryRolesCountArgs = {
  where?: RoleWhereInput;
};


export type QueryScheduleArgs = {
  where: ScheduleWhereUniqueInput;
};


export type QuerySchedulesArgs = {
  cursor?: Maybe<ScheduleWhereUniqueInput>;
  orderBy?: Array<ScheduleOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ScheduleWhereInput;
};


export type QuerySchedulesCountArgs = {
  where?: ScheduleWhereInput;
};


export type QueryScreeningTestArgs = {
  where: ScreeningTestWhereUniqueInput;
};


export type QueryScreeningTestsArgs = {
  cursor?: Maybe<ScreeningTestWhereUniqueInput>;
  orderBy?: Array<ScreeningTestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ScreeningTestWhereInput;
};


export type QueryScreeningTestsCountArgs = {
  where?: ScreeningTestWhereInput;
};


export type QuerySessionArgs = {
  where: SessionWhereUniqueInput;
};


export type QuerySessionEventArgs = {
  where: SessionEventWhereUniqueInput;
};


export type QuerySessionEventsArgs = {
  cursor?: Maybe<SessionEventWhereUniqueInput>;
  orderBy?: Array<SessionEventOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: SessionEventWhereInput;
};


export type QuerySessionEventsCountArgs = {
  where?: SessionEventWhereInput;
};


export type QuerySessionsArgs = {
  cursor?: Maybe<SessionWhereUniqueInput>;
  orderBy?: Array<SessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: SessionWhereInput;
};


export type QuerySessionsCountArgs = {
  where?: SessionWhereInput;
};


export type QuerySignatureArgs = {
  where: SignatureWhereUniqueInput;
};


export type QuerySignaturesArgs = {
  cursor?: Maybe<SignatureWhereUniqueInput>;
  orderBy?: Array<SignatureOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: SignatureWhereInput;
};


export type QuerySignaturesCountArgs = {
  where?: SignatureWhereInput;
};


export type QueryStepperArgs = {
  where: StepperWhereUniqueInput;
};


export type QueryStepperProgArgs = {
  where: StepperProgWhereUniqueInput;
};


export type QueryStepperProgsArgs = {
  cursor?: Maybe<StepperProgWhereUniqueInput>;
  orderBy?: Array<StepperProgOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperProgWhereInput;
};


export type QueryStepperProgsCountArgs = {
  where?: StepperProgWhereInput;
};


export type QueryStepperStepArgs = {
  where: StepperStepWhereUniqueInput;
};


export type QueryStepperStepProgArgs = {
  where: StepperStepProgWhereUniqueInput;
};


export type QueryStepperStepProgsArgs = {
  cursor?: Maybe<StepperStepProgWhereUniqueInput>;
  orderBy?: Array<StepperStepProgOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperStepProgWhereInput;
};


export type QueryStepperStepProgsCountArgs = {
  where?: StepperStepProgWhereInput;
};


export type QueryStepperStepsArgs = {
  cursor?: Maybe<StepperStepWhereUniqueInput>;
  orderBy?: Array<StepperStepOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperStepWhereInput;
};


export type QueryStepperStepsCountArgs = {
  where?: StepperStepWhereInput;
};


export type QuerySteppersArgs = {
  cursor?: Maybe<StepperWhereUniqueInput>;
  orderBy?: Array<StepperOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperWhereInput;
};


export type QuerySteppersCountArgs = {
  where?: StepperWhereInput;
};


export type QueryTaskArgs = {
  where: TaskWhereUniqueInput;
};


export type QueryTasksArgs = {
  cursor?: Maybe<TaskWhereUniqueInput>;
  orderBy?: Array<TaskOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TaskWhereInput;
};


export type QueryTasksCountArgs = {
  where?: TaskWhereInput;
};


export type QueryTestOrderArgs = {
  where: TestOrderWhereUniqueInput;
};


export type QueryTestOrdersArgs = {
  cursor?: Maybe<TestOrderWhereUniqueInput>;
  orderBy?: Array<TestOrderOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TestOrderWhereInput;
};


export type QueryTestOrdersCountArgs = {
  where?: TestOrderWhereInput;
};


export type QueryTestsBatchArgs = {
  where: TestsBatchWhereUniqueInput;
};


export type QueryTestsBatchesArgs = {
  cursor?: Maybe<TestsBatchWhereUniqueInput>;
  orderBy?: Array<TestsBatchOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TestsBatchWhereInput;
};


export type QueryTestsBatchesCountArgs = {
  where?: TestsBatchWhereInput;
};


export type QueryTimeIntervalArgs = {
  where: TimeIntervalWhereUniqueInput;
};


export type QueryTimeIntervalsArgs = {
  cursor?: Maybe<TimeIntervalWhereUniqueInput>;
  orderBy?: Array<TimeIntervalOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TimeIntervalWhereInput;
};


export type QueryTimeIntervalsCountArgs = {
  where?: TimeIntervalWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserInviteArgs = {
  where: UserInviteWhereUniqueInput;
};


export type QueryUserInvitesArgs = {
  cursor?: Maybe<UserInviteWhereUniqueInput>;
  orderBy?: Array<UserInviteOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserInviteWhereInput;
};


export type QueryUserInvitesCountArgs = {
  where?: UserInviteWhereInput;
};


export type QueryUserSessionArgs = {
  where: UserSessionWhereUniqueInput;
};


export type QueryUserSessionsArgs = {
  cursor?: Maybe<UserSessionWhereUniqueInput>;
  orderBy?: Array<UserSessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserSessionWhereInput;
};


export type QueryUserSessionsCountArgs = {
  where?: UserSessionWhereInput;
};


export type QueryUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserWhereInput;
};


export type QueryUsersCountArgs = {
  where?: UserWhereInput;
};


export type QueryVaccinationArgs = {
  where: VaccinationWhereUniqueInput;
};


export type QueryVaccinationsArgs = {
  cursor?: Maybe<VaccinationWhereUniqueInput>;
  orderBy?: Array<VaccinationOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: VaccinationWhereInput;
};


export type QueryVaccinationsCountArgs = {
  where?: VaccinationWhereInput;
};


export type QueryVerificationTokenArgs = {
  where: VerificationTokenWhereUniqueInput;
};


export type QueryVerificationTokensArgs = {
  cursor?: Maybe<VerificationTokenWhereUniqueInput>;
  orderBy?: Array<VerificationTokenOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: VerificationTokenWhereInput;
};


export type QueryVerificationTokensCountArgs = {
  where?: VerificationTokenWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RecurringSlot = {
  __typename?: 'RecurringSlot';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  interval?: Maybe<Scalars['String']>;
  intervalCount?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  schedule?: Maybe<Schedule>;
  timeIntervals?: Maybe<Array<TimeInterval>>;
  timeIntervalsCount?: Maybe<Scalars['Int']>;
  wday?: Maybe<Scalars['String']>;
};


export type RecurringSlotTimeIntervalsArgs = {
  cursor?: Maybe<TimeIntervalWhereUniqueInput>;
  orderBy?: Array<TimeIntervalOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TimeIntervalWhereInput;
};


export type RecurringSlotTimeIntervalsCountArgs = {
  where?: TimeIntervalWhereInput;
};

export type RecurringSlotCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  interval?: Maybe<Scalars['String']>;
  intervalCount?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  schedule?: Maybe<ScheduleRelateToOneForCreateInput>;
  timeIntervals?: Maybe<TimeIntervalRelateToManyForCreateInput>;
  wday?: Maybe<Scalars['String']>;
};

export type RecurringSlotManyRelationFilter = {
  every?: Maybe<RecurringSlotWhereInput>;
  none?: Maybe<RecurringSlotWhereInput>;
  some?: Maybe<RecurringSlotWhereInput>;
};

export type RecurringSlotOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  interval?: Maybe<OrderDirection>;
  intervalCount?: Maybe<OrderDirection>;
  isActive?: Maybe<OrderDirection>;
  wday?: Maybe<OrderDirection>;
};

export type RecurringSlotRelateToManyForCreateInput = {
  connect?: Maybe<Array<RecurringSlotWhereUniqueInput>>;
  create?: Maybe<Array<RecurringSlotCreateInput>>;
};

export type RecurringSlotRelateToManyForUpdateInput = {
  connect?: Maybe<Array<RecurringSlotWhereUniqueInput>>;
  create?: Maybe<Array<RecurringSlotCreateInput>>;
  disconnect?: Maybe<Array<RecurringSlotWhereUniqueInput>>;
  set?: Maybe<Array<RecurringSlotWhereUniqueInput>>;
};

export type RecurringSlotRelateToOneForCreateInput = {
  connect?: Maybe<RecurringSlotWhereUniqueInput>;
  create?: Maybe<RecurringSlotCreateInput>;
};

export type RecurringSlotRelateToOneForUpdateInput = {
  connect?: Maybe<RecurringSlotWhereUniqueInput>;
  create?: Maybe<RecurringSlotCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type RecurringSlotUpdateArgs = {
  data: RecurringSlotUpdateInput;
  where: RecurringSlotWhereUniqueInput;
};

export type RecurringSlotUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  interval?: Maybe<Scalars['String']>;
  intervalCount?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  schedule?: Maybe<ScheduleRelateToOneForUpdateInput>;
  timeIntervals?: Maybe<TimeIntervalRelateToManyForUpdateInput>;
  wday?: Maybe<Scalars['String']>;
};

export type RecurringSlotWhereInput = {
  AND?: Maybe<Array<RecurringSlotWhereInput>>;
  NOT?: Maybe<Array<RecurringSlotWhereInput>>;
  OR?: Maybe<Array<RecurringSlotWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  interval?: Maybe<StringFilter>;
  intervalCount?: Maybe<IntNullableFilter>;
  isActive?: Maybe<BooleanFilter>;
  schedule?: Maybe<ScheduleWhereInput>;
  timeIntervals?: Maybe<TimeIntervalManyRelationFilter>;
  wday?: Maybe<StringFilter>;
};

export type RecurringSlotWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type RemittanceAdvice = {
  __typename?: 'RemittanceAdvice';
  billings?: Maybe<Array<AppointmentBilling>>;
  billingsCount?: Maybe<Scalars['Int']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  externalClaims?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  request?: Maybe<RemittanceAdviceRequest>;
  resourceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};


export type RemittanceAdviceBillingsArgs = {
  cursor?: Maybe<AppointmentBillingWhereUniqueInput>;
  orderBy?: Array<AppointmentBillingOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AppointmentBillingWhereInput;
};


export type RemittanceAdviceBillingsCountArgs = {
  where?: AppointmentBillingWhereInput;
};

export type RemittanceAdviceCreateInput = {
  billings?: Maybe<AppointmentBillingRelateToManyForCreateInput>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  externalClaims?: Maybe<Scalars['JSON']>;
  request?: Maybe<RemittanceAdviceRequestRelateToOneForCreateInput>;
  resourceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type RemittanceAdviceManyRelationFilter = {
  every?: Maybe<RemittanceAdviceWhereInput>;
  none?: Maybe<RemittanceAdviceWhereInput>;
  some?: Maybe<RemittanceAdviceWhereInput>;
};

export type RemittanceAdviceOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  resourceId?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
  updatedAt?: Maybe<OrderDirection>;
};

export type RemittanceAdviceRelateToManyForCreateInput = {
  connect?: Maybe<Array<RemittanceAdviceWhereUniqueInput>>;
  create?: Maybe<Array<RemittanceAdviceCreateInput>>;
};

export type RemittanceAdviceRelateToManyForUpdateInput = {
  connect?: Maybe<Array<RemittanceAdviceWhereUniqueInput>>;
  create?: Maybe<Array<RemittanceAdviceCreateInput>>;
  disconnect?: Maybe<Array<RemittanceAdviceWhereUniqueInput>>;
  set?: Maybe<Array<RemittanceAdviceWhereUniqueInput>>;
};

export type RemittanceAdviceRelateToOneForCreateInput = {
  connect?: Maybe<RemittanceAdviceWhereUniqueInput>;
  create?: Maybe<RemittanceAdviceCreateInput>;
};

export type RemittanceAdviceRelateToOneForUpdateInput = {
  connect?: Maybe<RemittanceAdviceWhereUniqueInput>;
  create?: Maybe<RemittanceAdviceCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type RemittanceAdviceRequest = {
  __typename?: 'RemittanceAdviceRequest';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  remittances?: Maybe<Array<RemittanceAdvice>>;
  remittancesCount?: Maybe<Scalars['Int']>;
  resourceIds?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};


export type RemittanceAdviceRequestRemittancesArgs = {
  cursor?: Maybe<RemittanceAdviceWhereUniqueInput>;
  orderBy?: Array<RemittanceAdviceOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: RemittanceAdviceWhereInput;
};


export type RemittanceAdviceRequestRemittancesCountArgs = {
  where?: RemittanceAdviceWhereInput;
};

export type RemittanceAdviceRequestCreateInput = {
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  remittances?: Maybe<RemittanceAdviceRelateToManyForCreateInput>;
  resourceIds?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type RemittanceAdviceRequestOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  resourceIds?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
};

export type RemittanceAdviceRequestRelateToOneForCreateInput = {
  connect?: Maybe<RemittanceAdviceRequestWhereUniqueInput>;
  create?: Maybe<RemittanceAdviceRequestCreateInput>;
};

export type RemittanceAdviceRequestRelateToOneForUpdateInput = {
  connect?: Maybe<RemittanceAdviceRequestWhereUniqueInput>;
  create?: Maybe<RemittanceAdviceRequestCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type RemittanceAdviceRequestUpdateArgs = {
  data: RemittanceAdviceRequestUpdateInput;
  where: RemittanceAdviceRequestWhereUniqueInput;
};

export type RemittanceAdviceRequestUpdateInput = {
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  remittances?: Maybe<RemittanceAdviceRelateToManyForUpdateInput>;
  resourceIds?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type RemittanceAdviceRequestWhereInput = {
  AND?: Maybe<Array<RemittanceAdviceRequestWhereInput>>;
  NOT?: Maybe<Array<RemittanceAdviceRequestWhereInput>>;
  OR?: Maybe<Array<RemittanceAdviceRequestWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  remittances?: Maybe<RemittanceAdviceManyRelationFilter>;
  resourceIds?: Maybe<StringFilter>;
  status?: Maybe<StringNullableFilter>;
  user?: Maybe<UserWhereInput>;
};

export type RemittanceAdviceRequestWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type RemittanceAdviceUpdateArgs = {
  data: RemittanceAdviceUpdateInput;
  where: RemittanceAdviceWhereUniqueInput;
};

export type RemittanceAdviceUpdateInput = {
  billings?: Maybe<AppointmentBillingRelateToManyForUpdateInput>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  externalClaims?: Maybe<Scalars['JSON']>;
  request?: Maybe<RemittanceAdviceRequestRelateToOneForUpdateInput>;
  resourceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type RemittanceAdviceWhereInput = {
  AND?: Maybe<Array<RemittanceAdviceWhereInput>>;
  NOT?: Maybe<Array<RemittanceAdviceWhereInput>>;
  OR?: Maybe<Array<RemittanceAdviceWhereInput>>;
  billings?: Maybe<AppointmentBillingManyRelationFilter>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  request?: Maybe<RemittanceAdviceRequestWhereInput>;
  resourceId?: Maybe<StringFilter>;
  status?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  user?: Maybe<UserWhereInput>;
};

export type RemittanceAdviceWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  resourceId?: Maybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  members?: Maybe<Array<Member>>;
  membersCount?: Maybe<Scalars['Int']>;
  name?: Maybe<RoleNameType>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']>;
};


export type RoleMembersArgs = {
  cursor?: Maybe<MemberWhereUniqueInput>;
  orderBy?: Array<MemberOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MemberWhereInput;
};


export type RoleMembersCountArgs = {
  where?: MemberWhereInput;
};


export type RoleUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserWhereInput;
};


export type RoleUsersCountArgs = {
  where?: UserWhereInput;
};

export type RoleCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  members?: Maybe<MemberRelateToManyForCreateInput>;
  name?: Maybe<RoleNameType>;
  users?: Maybe<UserRelateToManyForCreateInput>;
};

export type RoleManyRelationFilter = {
  every?: Maybe<RoleWhereInput>;
  none?: Maybe<RoleWhereInput>;
  some?: Maybe<RoleWhereInput>;
};

export enum RoleNameType {
  Admin = 'admin',
  Doctor = 'doctor',
  Manager = 'manager',
  Nurse = 'nurse',
  Other = 'other',
  SysAdmin = 'sysAdmin',
  SysManager = 'sysManager'
}

export type RoleNameTypeNullableFilter = {
  equals?: Maybe<RoleNameType>;
  in?: Maybe<Array<RoleNameType>>;
  not?: Maybe<RoleNameTypeNullableFilter>;
  notIn?: Maybe<Array<RoleNameType>>;
};

export type RoleOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
};

export type RoleRelateToManyForCreateInput = {
  connect?: Maybe<Array<RoleWhereUniqueInput>>;
  create?: Maybe<Array<RoleCreateInput>>;
};

export type RoleRelateToManyForUpdateInput = {
  connect?: Maybe<Array<RoleWhereUniqueInput>>;
  create?: Maybe<Array<RoleCreateInput>>;
  disconnect?: Maybe<Array<RoleWhereUniqueInput>>;
  set?: Maybe<Array<RoleWhereUniqueInput>>;
};

export type RoleRelateToOneForCreateInput = {
  connect?: Maybe<RoleWhereUniqueInput>;
  create?: Maybe<RoleCreateInput>;
};

export type RoleRelateToOneForUpdateInput = {
  connect?: Maybe<RoleWhereUniqueInput>;
  create?: Maybe<RoleCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type RoleUpdateArgs = {
  data: RoleUpdateInput;
  where: RoleWhereUniqueInput;
};

export type RoleUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  members?: Maybe<MemberRelateToManyForUpdateInput>;
  name?: Maybe<RoleNameType>;
  users?: Maybe<UserRelateToManyForUpdateInput>;
};

export type RoleWhereInput = {
  AND?: Maybe<Array<RoleWhereInput>>;
  NOT?: Maybe<Array<RoleWhereInput>>;
  OR?: Maybe<Array<RoleWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  members?: Maybe<MemberManyRelationFilter>;
  name?: Maybe<RoleNameTypeNullableFilter>;
  users?: Maybe<UserManyRelationFilter>;
};

export type RoleWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<RoleNameType>;
};

export type Schedule = {
  __typename?: 'Schedule';
  blockedDates?: Maybe<Scalars['JSON']>;
  blockedTimeIntervals?: Maybe<Array<TimeInterval>>;
  blockedTimeIntervalsCount?: Maybe<Scalars['Int']>;
  calendar?: Maybe<Calendar>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultOn?: Maybe<Calendar>;
  description?: Maybe<Scalars['String']>;
  futureLimit?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  recurringSlots?: Maybe<Array<RecurringSlot>>;
  recurringSlotsCount?: Maybe<Scalars['Int']>;
  slotInterval?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  tz?: Maybe<Scalars['String']>;
};


export type ScheduleBlockedTimeIntervalsArgs = {
  cursor?: Maybe<TimeIntervalWhereUniqueInput>;
  orderBy?: Array<TimeIntervalOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: TimeIntervalWhereInput;
};


export type ScheduleBlockedTimeIntervalsCountArgs = {
  where?: TimeIntervalWhereInput;
};


export type ScheduleRecurringSlotsArgs = {
  cursor?: Maybe<RecurringSlotWhereUniqueInput>;
  orderBy?: Array<RecurringSlotOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: RecurringSlotWhereInput;
};


export type ScheduleRecurringSlotsCountArgs = {
  where?: RecurringSlotWhereInput;
};

export type ScheduleCreateInput = {
  blockedDates?: Maybe<Scalars['JSON']>;
  blockedTimeIntervals?: Maybe<TimeIntervalRelateToManyForCreateInput>;
  calendar?: Maybe<CalendarRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultOn?: Maybe<CalendarRelateToOneForCreateInput>;
  description?: Maybe<Scalars['String']>;
  futureLimit?: Maybe<Scalars['String']>;
  recurringSlots?: Maybe<RecurringSlotRelateToManyForCreateInput>;
  slotInterval?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  tz?: Maybe<Scalars['String']>;
};

export type ScheduleManyRelationFilter = {
  every?: Maybe<ScheduleWhereInput>;
  none?: Maybe<ScheduleWhereInput>;
  some?: Maybe<ScheduleWhereInput>;
};

export type ScheduleOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  futureLimit?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  slotInterval?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
  tz?: Maybe<OrderDirection>;
};

export type ScheduleRelateToManyForCreateInput = {
  connect?: Maybe<Array<ScheduleWhereUniqueInput>>;
  create?: Maybe<Array<ScheduleCreateInput>>;
};

export type ScheduleRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ScheduleWhereUniqueInput>>;
  create?: Maybe<Array<ScheduleCreateInput>>;
  disconnect?: Maybe<Array<ScheduleWhereUniqueInput>>;
  set?: Maybe<Array<ScheduleWhereUniqueInput>>;
};

export type ScheduleRelateToOneForCreateInput = {
  connect?: Maybe<ScheduleWhereUniqueInput>;
  create?: Maybe<ScheduleCreateInput>;
};

export type ScheduleRelateToOneForUpdateInput = {
  connect?: Maybe<ScheduleWhereUniqueInput>;
  create?: Maybe<ScheduleCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type ScheduleUpdateArgs = {
  data: ScheduleUpdateInput;
  where: ScheduleWhereUniqueInput;
};

export type ScheduleUpdateInput = {
  blockedDates?: Maybe<Scalars['JSON']>;
  blockedTimeIntervals?: Maybe<TimeIntervalRelateToManyForUpdateInput>;
  calendar?: Maybe<CalendarRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultOn?: Maybe<CalendarRelateToOneForUpdateInput>;
  description?: Maybe<Scalars['String']>;
  futureLimit?: Maybe<Scalars['String']>;
  recurringSlots?: Maybe<RecurringSlotRelateToManyForUpdateInput>;
  slotInterval?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  tz?: Maybe<Scalars['String']>;
};

export type ScheduleWhereInput = {
  AND?: Maybe<Array<ScheduleWhereInput>>;
  NOT?: Maybe<Array<ScheduleWhereInput>>;
  OR?: Maybe<Array<ScheduleWhereInput>>;
  blockedTimeIntervals?: Maybe<TimeIntervalManyRelationFilter>;
  calendar?: Maybe<CalendarWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  defaultOn?: Maybe<CalendarWhereInput>;
  description?: Maybe<StringFilter>;
  futureLimit?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  recurringSlots?: Maybe<RecurringSlotManyRelationFilter>;
  slotInterval?: Maybe<IntNullableFilter>;
  title?: Maybe<StringFilter>;
  tz?: Maybe<StringFilter>;
};

export type ScheduleWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type ScreeningTest = {
  __typename?: 'ScreeningTest';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  testedAt?: Maybe<Scalars['DateTime']>;
};

export type ScreeningTestCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  testedAt?: Maybe<Scalars['DateTime']>;
};

export type ScreeningTestManyRelationFilter = {
  every?: Maybe<ScreeningTestWhereInput>;
  none?: Maybe<ScreeningTestWhereInput>;
  some?: Maybe<ScreeningTestWhereInput>;
};

export type ScreeningTestOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  testedAt?: Maybe<OrderDirection>;
};

export type ScreeningTestRelateToManyForCreateInput = {
  connect?: Maybe<Array<ScreeningTestWhereUniqueInput>>;
  create?: Maybe<Array<ScreeningTestCreateInput>>;
};

export type ScreeningTestRelateToManyForUpdateInput = {
  connect?: Maybe<Array<ScreeningTestWhereUniqueInput>>;
  create?: Maybe<Array<ScreeningTestCreateInput>>;
  disconnect?: Maybe<Array<ScreeningTestWhereUniqueInput>>;
  set?: Maybe<Array<ScreeningTestWhereUniqueInput>>;
};

export type ScreeningTestUpdateArgs = {
  data: ScreeningTestUpdateInput;
  where: ScreeningTestWhereUniqueInput;
};

export type ScreeningTestUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  testedAt?: Maybe<Scalars['DateTime']>;
};

export type ScreeningTestWhereInput = {
  AND?: Maybe<Array<ScreeningTestWhereInput>>;
  NOT?: Maybe<Array<ScreeningTestWhereInput>>;
  OR?: Maybe<Array<ScreeningTestWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  name?: Maybe<StringFilter>;
  patient?: Maybe<PatientWhereInput>;
  testedAt?: Maybe<DateTimeNullableFilter>;
};

export type ScreeningTestWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Session = {
  __typename?: 'Session';
  createdAt?: Maybe<Scalars['DateTime']>;
  expires?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  sessionToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type SessionCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expires?: Maybe<Scalars['DateTime']>;
  sessionToken?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type SessionEvent = {
  __typename?: 'SessionEvent';
  createdAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isContinuous?: Maybe<Scalars['Boolean']>;
  session?: Maybe<AppointmentSession>;
  startedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type SessionEventCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  isContinuous?: Maybe<Scalars['Boolean']>;
  session?: Maybe<AppointmentSessionRelateToOneForCreateInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type SessionEventManyRelationFilter = {
  every?: Maybe<SessionEventWhereInput>;
  none?: Maybe<SessionEventWhereInput>;
  some?: Maybe<SessionEventWhereInput>;
};

export type SessionEventOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  duration?: Maybe<OrderDirection>;
  endedAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isContinuous?: Maybe<OrderDirection>;
  startedAt?: Maybe<OrderDirection>;
  type?: Maybe<OrderDirection>;
};

export type SessionEventRelateToManyForCreateInput = {
  connect?: Maybe<Array<SessionEventWhereUniqueInput>>;
  create?: Maybe<Array<SessionEventCreateInput>>;
};

export type SessionEventRelateToManyForUpdateInput = {
  connect?: Maybe<Array<SessionEventWhereUniqueInput>>;
  create?: Maybe<Array<SessionEventCreateInput>>;
  disconnect?: Maybe<Array<SessionEventWhereUniqueInput>>;
  set?: Maybe<Array<SessionEventWhereUniqueInput>>;
};

export type SessionEventUpdateArgs = {
  data: SessionEventUpdateInput;
  where: SessionEventWhereUniqueInput;
};

export type SessionEventUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  isContinuous?: Maybe<Scalars['Boolean']>;
  session?: Maybe<AppointmentSessionRelateToOneForUpdateInput>;
  startedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type SessionEventWhereInput = {
  AND?: Maybe<Array<SessionEventWhereInput>>;
  NOT?: Maybe<Array<SessionEventWhereInput>>;
  OR?: Maybe<Array<SessionEventWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  duration?: Maybe<IntNullableFilter>;
  endedAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  isContinuous?: Maybe<BooleanFilter>;
  session?: Maybe<AppointmentSessionWhereInput>;
  startedAt?: Maybe<DateTimeNullableFilter>;
  type?: Maybe<StringNullableFilter>;
};

export type SessionEventWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type SessionManyRelationFilter = {
  every?: Maybe<SessionWhereInput>;
  none?: Maybe<SessionWhereInput>;
  some?: Maybe<SessionWhereInput>;
};

export type SessionOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  expires?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  sessionToken?: Maybe<OrderDirection>;
};

export type SessionRelateToManyForCreateInput = {
  connect?: Maybe<Array<SessionWhereUniqueInput>>;
  create?: Maybe<Array<SessionCreateInput>>;
};

export type SessionRelateToManyForUpdateInput = {
  connect?: Maybe<Array<SessionWhereUniqueInput>>;
  create?: Maybe<Array<SessionCreateInput>>;
  disconnect?: Maybe<Array<SessionWhereUniqueInput>>;
  set?: Maybe<Array<SessionWhereUniqueInput>>;
};

export type SessionUpdateArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};

export type SessionUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expires?: Maybe<Scalars['DateTime']>;
  sessionToken?: Maybe<Scalars['String']>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type SessionWhereInput = {
  AND?: Maybe<Array<SessionWhereInput>>;
  NOT?: Maybe<Array<SessionWhereInput>>;
  OR?: Maybe<Array<SessionWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  expires?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  sessionToken?: Maybe<StringFilter>;
  user?: Maybe<UserWhereInput>;
};

export type SessionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  sessionToken?: Maybe<Scalars['String']>;
};

export type Signature = {
  __typename?: 'Signature';
  addedAt?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<FileFieldOutput>;
  doctor?: Maybe<Doctor>;
  file?: Maybe<File>;
  id: Scalars['ID'];
};

export type SignatureCreateInput = {
  addedAt?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<FileFieldInput>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  file?: Maybe<FileRelateToOneForCreateInput>;
};

export type SignatureOrderByInput = {
  addedAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
};

export type SignatureRelateToOneForCreateInput = {
  connect?: Maybe<SignatureWhereUniqueInput>;
  create?: Maybe<SignatureCreateInput>;
};

export type SignatureRelateToOneForUpdateInput = {
  connect?: Maybe<SignatureWhereUniqueInput>;
  create?: Maybe<SignatureCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type SignatureUpdateArgs = {
  data: SignatureUpdateInput;
  where: SignatureWhereUniqueInput;
};

export type SignatureUpdateInput = {
  addedAt?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<FileFieldInput>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  file?: Maybe<FileRelateToOneForUpdateInput>;
};

export type SignatureWhereInput = {
  AND?: Maybe<Array<SignatureWhereInput>>;
  NOT?: Maybe<Array<SignatureWhereInput>>;
  OR?: Maybe<Array<SignatureWhereInput>>;
  addedAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  file?: Maybe<FileWhereInput>;
  id?: Maybe<IdFilter>;
};

export type SignatureWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Stepper = {
  __typename?: 'Stepper';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eyebrow?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  prompt?: Maybe<Prompt>;
  slug?: Maybe<Scalars['String']>;
  stepperProgs?: Maybe<Array<StepperProg>>;
  stepperProgsCount?: Maybe<Scalars['Int']>;
  stepperStepProgs?: Maybe<Array<StepperStepProg>>;
  stepperStepProgsCount?: Maybe<Scalars['Int']>;
  stepperSteps?: Maybe<Array<StepperStep>>;
  stepperStepsCount?: Maybe<Scalars['Int']>;
  stepsOrderBySlugs?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type StepperStepperProgsArgs = {
  cursor?: Maybe<StepperProgWhereUniqueInput>;
  orderBy?: Array<StepperProgOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperProgWhereInput;
};


export type StepperStepperProgsCountArgs = {
  where?: StepperProgWhereInput;
};


export type StepperStepperStepProgsArgs = {
  cursor?: Maybe<StepperStepProgWhereUniqueInput>;
  orderBy?: Array<StepperStepProgOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperStepProgWhereInput;
};


export type StepperStepperStepProgsCountArgs = {
  where?: StepperStepProgWhereInput;
};


export type StepperStepperStepsArgs = {
  cursor?: Maybe<StepperStepWhereUniqueInput>;
  orderBy?: Array<StepperStepOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperStepWhereInput;
};


export type StepperStepperStepsCountArgs = {
  where?: StepperStepWhereInput;
};

export type StepperCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eyebrow?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  prompt?: Maybe<PromptRelateToOneForCreateInput>;
  slug?: Maybe<Scalars['String']>;
  stepperProgs?: Maybe<StepperProgRelateToManyForCreateInput>;
  stepperStepProgs?: Maybe<StepperStepProgRelateToManyForCreateInput>;
  stepperSteps?: Maybe<StepperStepRelateToManyForCreateInput>;
  stepsOrderBySlugs?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type StepperOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  eyebrow?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  slug?: Maybe<OrderDirection>;
  stepsOrderBySlugs?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
};

export type StepperProg = {
  __typename?: 'StepperProg';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stepper?: Maybe<Stepper>;
  stepperStepProgs?: Maybe<Array<StepperStepProg>>;
  stepperStepProgsCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};


export type StepperProgStepperStepProgsArgs = {
  cursor?: Maybe<StepperStepProgWhereUniqueInput>;
  orderBy?: Array<StepperStepProgOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperStepProgWhereInput;
};


export type StepperProgStepperStepProgsCountArgs = {
  where?: StepperStepProgWhereInput;
};

export type StepperProgCreateInput = {
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stepper?: Maybe<StepperRelateToOneForCreateInput>;
  stepperStepProgs?: Maybe<StepperStepProgRelateToManyForCreateInput>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type StepperProgManyRelationFilter = {
  every?: Maybe<StepperProgWhereInput>;
  none?: Maybe<StepperProgWhereInput>;
  some?: Maybe<StepperProgWhereInput>;
};

export type StepperProgOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isCompleted?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
};

export type StepperProgRelateToManyForCreateInput = {
  connect?: Maybe<Array<StepperProgWhereUniqueInput>>;
  create?: Maybe<Array<StepperProgCreateInput>>;
};

export type StepperProgRelateToManyForUpdateInput = {
  connect?: Maybe<Array<StepperProgWhereUniqueInput>>;
  create?: Maybe<Array<StepperProgCreateInput>>;
  disconnect?: Maybe<Array<StepperProgWhereUniqueInput>>;
  set?: Maybe<Array<StepperProgWhereUniqueInput>>;
};

export type StepperProgRelateToOneForCreateInput = {
  connect?: Maybe<StepperProgWhereUniqueInput>;
  create?: Maybe<StepperProgCreateInput>;
};

export type StepperProgRelateToOneForUpdateInput = {
  connect?: Maybe<StepperProgWhereUniqueInput>;
  create?: Maybe<StepperProgCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type StepperProgUpdateArgs = {
  data: StepperProgUpdateInput;
  where: StepperProgWhereUniqueInput;
};

export type StepperProgUpdateInput = {
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  stepper?: Maybe<StepperRelateToOneForUpdateInput>;
  stepperStepProgs?: Maybe<StepperStepProgRelateToManyForUpdateInput>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type StepperProgWhereInput = {
  AND?: Maybe<Array<StepperProgWhereInput>>;
  NOT?: Maybe<Array<StepperProgWhereInput>>;
  OR?: Maybe<Array<StepperProgWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  isCompleted?: Maybe<BooleanFilter>;
  name?: Maybe<StringFilter>;
  stepper?: Maybe<StepperWhereInput>;
  stepperStepProgs?: Maybe<StepperStepProgManyRelationFilter>;
  user?: Maybe<UserWhereInput>;
};

export type StepperProgWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type StepperRelateToOneForCreateInput = {
  connect?: Maybe<StepperWhereUniqueInput>;
  create?: Maybe<StepperCreateInput>;
};

export type StepperRelateToOneForUpdateInput = {
  connect?: Maybe<StepperWhereUniqueInput>;
  create?: Maybe<StepperCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type StepperStep = {
  __typename?: 'StepperStep';
  component?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFinal?: Maybe<Scalars['Boolean']>;
  isOptional?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stepper?: Maybe<Stepper>;
  stepperStepProg?: Maybe<StepperStepProg>;
  title?: Maybe<Scalars['String']>;
};

export type StepperStepCreateInput = {
  component?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  isFinal?: Maybe<Scalars['Boolean']>;
  isOptional?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stepper?: Maybe<StepperRelateToOneForCreateInput>;
  stepperStepProg?: Maybe<StepperStepProgRelateToOneForCreateInput>;
  title?: Maybe<Scalars['String']>;
};

export type StepperStepManyRelationFilter = {
  every?: Maybe<StepperStepWhereInput>;
  none?: Maybe<StepperStepWhereInput>;
  some?: Maybe<StepperStepWhereInput>;
};

export type StepperStepOrderByInput = {
  component?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isFinal?: Maybe<OrderDirection>;
  isOptional?: Maybe<OrderDirection>;
  label?: Maybe<OrderDirection>;
  order?: Maybe<OrderDirection>;
  slug?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
};

export type StepperStepProg = {
  __typename?: 'StepperStepProg';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percentDone?: Maybe<Scalars['Int']>;
  stepper?: Maybe<Stepper>;
  stepperProg?: Maybe<StepperProg>;
  stepperStep?: Maybe<StepperStep>;
  user?: Maybe<User>;
};

export type StepperStepProgCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percentDone?: Maybe<Scalars['Int']>;
  stepper?: Maybe<StepperRelateToOneForCreateInput>;
  stepperProg?: Maybe<StepperProgRelateToOneForCreateInput>;
  stepperStep?: Maybe<StepperStepRelateToOneForCreateInput>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type StepperStepProgManyRelationFilter = {
  every?: Maybe<StepperStepProgWhereInput>;
  none?: Maybe<StepperStepProgWhereInput>;
  some?: Maybe<StepperStepProgWhereInput>;
};

export type StepperStepProgOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isCompleted?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
  percentDone?: Maybe<OrderDirection>;
};

export type StepperStepProgRelateToManyForCreateInput = {
  connect?: Maybe<Array<StepperStepProgWhereUniqueInput>>;
  create?: Maybe<Array<StepperStepProgCreateInput>>;
};

export type StepperStepProgRelateToManyForUpdateInput = {
  connect?: Maybe<Array<StepperStepProgWhereUniqueInput>>;
  create?: Maybe<Array<StepperStepProgCreateInput>>;
  disconnect?: Maybe<Array<StepperStepProgWhereUniqueInput>>;
  set?: Maybe<Array<StepperStepProgWhereUniqueInput>>;
};

export type StepperStepProgRelateToOneForCreateInput = {
  connect?: Maybe<StepperStepProgWhereUniqueInput>;
  create?: Maybe<StepperStepProgCreateInput>;
};

export type StepperStepProgRelateToOneForUpdateInput = {
  connect?: Maybe<StepperStepProgWhereUniqueInput>;
  create?: Maybe<StepperStepProgCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type StepperStepProgUpdateArgs = {
  data: StepperStepProgUpdateInput;
  where: StepperStepProgWhereUniqueInput;
};

export type StepperStepProgUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percentDone?: Maybe<Scalars['Int']>;
  stepper?: Maybe<StepperRelateToOneForUpdateInput>;
  stepperProg?: Maybe<StepperProgRelateToOneForUpdateInput>;
  stepperStep?: Maybe<StepperStepRelateToOneForUpdateInput>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type StepperStepProgWhereInput = {
  AND?: Maybe<Array<StepperStepProgWhereInput>>;
  NOT?: Maybe<Array<StepperStepProgWhereInput>>;
  OR?: Maybe<Array<StepperStepProgWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  isCompleted?: Maybe<BooleanFilter>;
  name?: Maybe<StringFilter>;
  percentDone?: Maybe<IntNullableFilter>;
  stepper?: Maybe<StepperWhereInput>;
  stepperProg?: Maybe<StepperProgWhereInput>;
  stepperStep?: Maybe<StepperStepWhereInput>;
  user?: Maybe<UserWhereInput>;
};

export type StepperStepProgWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type StepperStepRelateToManyForCreateInput = {
  connect?: Maybe<Array<StepperStepWhereUniqueInput>>;
  create?: Maybe<Array<StepperStepCreateInput>>;
};

export type StepperStepRelateToManyForUpdateInput = {
  connect?: Maybe<Array<StepperStepWhereUniqueInput>>;
  create?: Maybe<Array<StepperStepCreateInput>>;
  disconnect?: Maybe<Array<StepperStepWhereUniqueInput>>;
  set?: Maybe<Array<StepperStepWhereUniqueInput>>;
};

export type StepperStepRelateToOneForCreateInput = {
  connect?: Maybe<StepperStepWhereUniqueInput>;
  create?: Maybe<StepperStepCreateInput>;
};

export type StepperStepRelateToOneForUpdateInput = {
  connect?: Maybe<StepperStepWhereUniqueInput>;
  create?: Maybe<StepperStepCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type StepperStepUpdateArgs = {
  data: StepperStepUpdateInput;
  where: StepperStepWhereUniqueInput;
};

export type StepperStepUpdateInput = {
  component?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  isFinal?: Maybe<Scalars['Boolean']>;
  isOptional?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stepper?: Maybe<StepperRelateToOneForUpdateInput>;
  stepperStepProg?: Maybe<StepperStepProgRelateToOneForUpdateInput>;
  title?: Maybe<Scalars['String']>;
};

export type StepperStepWhereInput = {
  AND?: Maybe<Array<StepperStepWhereInput>>;
  NOT?: Maybe<Array<StepperStepWhereInput>>;
  OR?: Maybe<Array<StepperStepWhereInput>>;
  component?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  isFinal?: Maybe<BooleanFilter>;
  isOptional?: Maybe<BooleanFilter>;
  label?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  slug?: Maybe<StringFilter>;
  stepper?: Maybe<StepperWhereInput>;
  stepperStepProg?: Maybe<StepperStepProgWhereInput>;
  title?: Maybe<StringFilter>;
};

export type StepperStepWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type StepperUpdateArgs = {
  data: StepperUpdateInput;
  where: StepperWhereUniqueInput;
};

export type StepperUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eyebrow?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  prompt?: Maybe<PromptRelateToOneForUpdateInput>;
  slug?: Maybe<Scalars['String']>;
  stepperProgs?: Maybe<StepperProgRelateToManyForUpdateInput>;
  stepperStepProgs?: Maybe<StepperStepProgRelateToManyForUpdateInput>;
  stepperSteps?: Maybe<StepperStepRelateToManyForUpdateInput>;
  stepsOrderBySlugs?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type StepperWhereInput = {
  AND?: Maybe<Array<StepperWhereInput>>;
  NOT?: Maybe<Array<StepperWhereInput>>;
  OR?: Maybe<Array<StepperWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  eyebrow?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  name?: Maybe<StringFilter>;
  prompt?: Maybe<PromptWhereInput>;
  slug?: Maybe<StringFilter>;
  stepperProgs?: Maybe<StepperProgManyRelationFilter>;
  stepperStepProgs?: Maybe<StepperStepProgManyRelationFilter>;
  stepperSteps?: Maybe<StepperStepManyRelationFilter>;
  stepsOrderBySlugs?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
};

export type StepperWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<StringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  appointmentSessionChanged?: Maybe<AppointmentSession>;
  chatMessageUpdated?: Maybe<ChatMessage>;
};


export type SubscriptionAppointmentSessionChangedArgs = {
  appointmentId: Scalars['ID'];
};


export type SubscriptionChatMessageUpdatedArgs = {
  chatId: Scalars['ID'];
};

export type Task = {
  __typename?: 'Task';
  appointment?: Maybe<Appointment>;
  assignedTo?: Maybe<Member>;
  author?: Maybe<User>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  patient?: Maybe<Patient>;
  priority?: Maybe<TaskPriorityType>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedBy?: Maybe<User>;
  resolvedNote?: Maybe<Scalars['String']>;
  status?: Maybe<TaskStatusType>;
  title?: Maybe<Scalars['String']>;
};

export type TaskCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  assignedTo?: Maybe<MemberRelateToOneForCreateInput>;
  author?: Maybe<UserRelateToOneForCreateInput>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  priority?: Maybe<TaskPriorityType>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedBy?: Maybe<UserRelateToOneForCreateInput>;
  resolvedNote?: Maybe<Scalars['String']>;
  status?: Maybe<TaskStatusType>;
  title?: Maybe<Scalars['String']>;
};

export type TaskManyRelationFilter = {
  every?: Maybe<TaskWhereInput>;
  none?: Maybe<TaskWhereInput>;
  some?: Maybe<TaskWhereInput>;
};

export type TaskOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  description?: Maybe<OrderDirection>;
  dueAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  priority?: Maybe<OrderDirection>;
  resolvedAt?: Maybe<OrderDirection>;
  resolvedNote?: Maybe<OrderDirection>;
  status?: Maybe<OrderDirection>;
  title?: Maybe<OrderDirection>;
};

export enum TaskPriorityType {
  Routine = 'ROUTINE',
  Urgent = 'URGENT'
}

export type TaskPriorityTypeNullableFilter = {
  equals?: Maybe<TaskPriorityType>;
  in?: Maybe<Array<TaskPriorityType>>;
  not?: Maybe<TaskPriorityTypeNullableFilter>;
  notIn?: Maybe<Array<TaskPriorityType>>;
};

export type TaskRelateToManyForCreateInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  create?: Maybe<Array<TaskCreateInput>>;
};

export type TaskRelateToManyForUpdateInput = {
  connect?: Maybe<Array<TaskWhereUniqueInput>>;
  create?: Maybe<Array<TaskCreateInput>>;
  disconnect?: Maybe<Array<TaskWhereUniqueInput>>;
  set?: Maybe<Array<TaskWhereUniqueInput>>;
};

export enum TaskStatusType {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type TaskStatusTypeNullableFilter = {
  equals?: Maybe<TaskStatusType>;
  in?: Maybe<Array<TaskStatusType>>;
  not?: Maybe<TaskStatusTypeNullableFilter>;
  notIn?: Maybe<Array<TaskStatusType>>;
};

export type TaskUpdateArgs = {
  data: TaskUpdateInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  assignedTo?: Maybe<MemberRelateToOneForUpdateInput>;
  author?: Maybe<UserRelateToOneForUpdateInput>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  priority?: Maybe<TaskPriorityType>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedBy?: Maybe<UserRelateToOneForUpdateInput>;
  resolvedNote?: Maybe<Scalars['String']>;
  status?: Maybe<TaskStatusType>;
  title?: Maybe<Scalars['String']>;
};

export type TaskWhereInput = {
  AND?: Maybe<Array<TaskWhereInput>>;
  NOT?: Maybe<Array<TaskWhereInput>>;
  OR?: Maybe<Array<TaskWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  assignedTo?: Maybe<MemberWhereInput>;
  author?: Maybe<UserWhereInput>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  description?: Maybe<StringFilter>;
  dueAt?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  patient?: Maybe<PatientWhereInput>;
  priority?: Maybe<TaskPriorityTypeNullableFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  resolvedBy?: Maybe<UserWhereInput>;
  resolvedNote?: Maybe<StringFilter>;
  status?: Maybe<TaskStatusTypeNullableFilter>;
  title?: Maybe<StringFilter>;
};

export type TaskWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type TestOrder = {
  __typename?: 'TestOrder';
  appointment?: Maybe<Appointment>;
  appointmentRequest?: Maybe<AppointmentRequest>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  doctor?: Maybe<Doctor>;
  id: Scalars['ID'];
  inboundFaxes?: Maybe<Array<InboundFax>>;
  inboundFaxesCount?: Maybe<Scalars['Int']>;
  orderedAt?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<Patient>;
  requestedAppointmentAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
};


export type TestOrderInboundFaxesArgs = {
  cursor?: Maybe<InboundFaxWhereUniqueInput>;
  orderBy?: Array<InboundFaxOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: InboundFaxWhereInput;
};


export type TestOrderInboundFaxesCountArgs = {
  where?: InboundFaxWhereInput;
};

export type TestOrderCreateInput = {
  appointment?: Maybe<AppointmentRelateToOneForCreateInput>;
  appointmentRequest?: Maybe<AppointmentRequestRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  inboundFaxes?: Maybe<InboundFaxRelateToManyForCreateInput>;
  orderedAt?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  requestedAppointmentAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
};

export type TestOrderManyRelationFilter = {
  every?: Maybe<TestOrderWhereInput>;
  none?: Maybe<TestOrderWhereInput>;
  some?: Maybe<TestOrderWhereInput>;
};

export type TestOrderOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  orderedAt?: Maybe<OrderDirection>;
  requestedAppointmentAt?: Maybe<OrderDirection>;
  resolvedAt?: Maybe<OrderDirection>;
  slug?: Maybe<OrderDirection>;
};

export type TestOrderRelateToManyForCreateInput = {
  connect?: Maybe<Array<TestOrderWhereUniqueInput>>;
  create?: Maybe<Array<TestOrderCreateInput>>;
};

export type TestOrderRelateToManyForUpdateInput = {
  connect?: Maybe<Array<TestOrderWhereUniqueInput>>;
  create?: Maybe<Array<TestOrderCreateInput>>;
  disconnect?: Maybe<Array<TestOrderWhereUniqueInput>>;
  set?: Maybe<Array<TestOrderWhereUniqueInput>>;
};

export type TestOrderRelateToOneForCreateInput = {
  connect?: Maybe<TestOrderWhereUniqueInput>;
  create?: Maybe<TestOrderCreateInput>;
};

export type TestOrderRelateToOneForUpdateInput = {
  connect?: Maybe<TestOrderWhereUniqueInput>;
  create?: Maybe<TestOrderCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type TestOrderUpdateArgs = {
  data: TestOrderUpdateInput;
  where: TestOrderWhereUniqueInput;
};

export type TestOrderUpdateInput = {
  appointment?: Maybe<AppointmentRelateToOneForUpdateInput>;
  appointmentRequest?: Maybe<AppointmentRequestRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  inboundFaxes?: Maybe<InboundFaxRelateToManyForUpdateInput>;
  orderedAt?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  requestedAppointmentAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
};

export type TestOrderWhereInput = {
  AND?: Maybe<Array<TestOrderWhereInput>>;
  NOT?: Maybe<Array<TestOrderWhereInput>>;
  OR?: Maybe<Array<TestOrderWhereInput>>;
  appointment?: Maybe<AppointmentWhereInput>;
  appointmentRequest?: Maybe<AppointmentRequestWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  id?: Maybe<IdFilter>;
  inboundFaxes?: Maybe<InboundFaxManyRelationFilter>;
  orderedAt?: Maybe<DateTimeNullableFilter>;
  patient?: Maybe<PatientWhereInput>;
  requestedAppointmentAt?: Maybe<DateTimeNullableFilter>;
  resolvedAt?: Maybe<DateTimeNullableFilter>;
  slug?: Maybe<StringFilter>;
};

export type TestOrderWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type TestsBatch = {
  __typename?: 'TestsBatch';
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  formTests?: Maybe<Array<FormTest>>;
  formTestsCount?: Maybe<Scalars['Int']>;
  formType?: Maybe<FormType>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};


export type TestsBatchFormTestsArgs = {
  cursor?: Maybe<FormTestWhereUniqueInput>;
  orderBy?: Array<FormTestOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FormTestWhereInput;
};


export type TestsBatchFormTestsCountArgs = {
  where?: FormTestWhereInput;
};

export type TestsBatchCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  formTests?: Maybe<FormTestRelateToManyForCreateInput>;
  formType?: Maybe<FormTypeRelateToOneForCreateInput>;
  name?: Maybe<Scalars['String']>;
};

export type TestsBatchManyRelationFilter = {
  every?: Maybe<TestsBatchWhereInput>;
  none?: Maybe<TestsBatchWhereInput>;
  some?: Maybe<TestsBatchWhereInput>;
};

export type TestsBatchOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  name?: Maybe<OrderDirection>;
};

export type TestsBatchRelateToManyForCreateInput = {
  connect?: Maybe<Array<TestsBatchWhereUniqueInput>>;
  create?: Maybe<Array<TestsBatchCreateInput>>;
};

export type TestsBatchRelateToManyForUpdateInput = {
  connect?: Maybe<Array<TestsBatchWhereUniqueInput>>;
  create?: Maybe<Array<TestsBatchCreateInput>>;
  disconnect?: Maybe<Array<TestsBatchWhereUniqueInput>>;
  set?: Maybe<Array<TestsBatchWhereUniqueInput>>;
};

export type TestsBatchUpdateArgs = {
  data: TestsBatchUpdateInput;
  where: TestsBatchWhereUniqueInput;
};

export type TestsBatchUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  formTests?: Maybe<FormTestRelateToManyForUpdateInput>;
  formType?: Maybe<FormTypeRelateToOneForUpdateInput>;
  name?: Maybe<Scalars['String']>;
};

export type TestsBatchWhereInput = {
  AND?: Maybe<Array<TestsBatchWhereInput>>;
  NOT?: Maybe<Array<TestsBatchWhereInput>>;
  OR?: Maybe<Array<TestsBatchWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  formTests?: Maybe<FormTestManyRelationFilter>;
  formType?: Maybe<FormTypeWhereInput>;
  id?: Maybe<IdFilter>;
  name?: Maybe<StringFilter>;
};

export type TestsBatchWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type TimeInterval = {
  __typename?: 'TimeInterval';
  createdAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  recurringSlot?: Maybe<RecurringSlot>;
  to?: Maybe<Scalars['String']>;
};

export type TimeIntervalCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  recurringSlot?: Maybe<RecurringSlotRelateToOneForCreateInput>;
  to?: Maybe<Scalars['String']>;
};

export type TimeIntervalManyRelationFilter = {
  every?: Maybe<TimeIntervalWhereInput>;
  none?: Maybe<TimeIntervalWhereInput>;
  some?: Maybe<TimeIntervalWhereInput>;
};

export type TimeIntervalOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  from?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  to?: Maybe<OrderDirection>;
};

export type TimeIntervalRelateToManyForCreateInput = {
  connect?: Maybe<Array<TimeIntervalWhereUniqueInput>>;
  create?: Maybe<Array<TimeIntervalCreateInput>>;
};

export type TimeIntervalRelateToManyForUpdateInput = {
  connect?: Maybe<Array<TimeIntervalWhereUniqueInput>>;
  create?: Maybe<Array<TimeIntervalCreateInput>>;
  disconnect?: Maybe<Array<TimeIntervalWhereUniqueInput>>;
  set?: Maybe<Array<TimeIntervalWhereUniqueInput>>;
};

export type TimeIntervalUpdateArgs = {
  data: TimeIntervalUpdateInput;
  where: TimeIntervalWhereUniqueInput;
};

export type TimeIntervalUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['String']>;
  recurringSlot?: Maybe<RecurringSlotRelateToOneForUpdateInput>;
  to?: Maybe<Scalars['String']>;
};

export type TimeIntervalWhereInput = {
  AND?: Maybe<Array<TimeIntervalWhereInput>>;
  NOT?: Maybe<Array<TimeIntervalWhereInput>>;
  OR?: Maybe<Array<TimeIntervalWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  from?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  recurringSlot?: Maybe<RecurringSlotWhereInput>;
  to?: Maybe<StringFilter>;
};

export type TimeIntervalWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};


export type User = {
  __typename?: 'User';
  accessTokens?: Maybe<Array<AccessToken>>;
  accessTokensCount?: Maybe<Scalars['Int']>;
  accounts?: Maybe<Array<Account>>;
  accountsCount?: Maybe<Scalars['Int']>;
  address?: Maybe<Address>;
  archives?: Maybe<Array<Archive>>;
  archivesCount?: Maybe<Scalars['Int']>;
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Company>>;
  companiesCount?: Maybe<Scalars['Int']>;
  contracts?: Maybe<Array<Contract>>;
  contractsCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntents?: Maybe<Array<DataImportIntent>>;
  dataImportIntentsCount?: Maybe<Scalars['Int']>;
  dataImports?: Maybe<Array<DataImport>>;
  dataImportsCount?: Maybe<Scalars['Int']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['DateTime']>;
  faxBlasts?: Maybe<Array<FaxBlast>>;
  faxBlastsCount?: Maybe<Scalars['Int']>;
  feedbackItems?: Maybe<Array<FeedbackItem>>;
  feedbackItemsCount?: Maybe<Scalars['Int']>;
  files?: Maybe<Array<File>>;
  filesCount?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  homePhoneNumberString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  isBirdConsentObtained?: Maybe<Scalars['Boolean']>;
  isDummy?: Maybe<Scalars['Boolean']>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isOnboardedDoctor?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  memberships?: Maybe<Array<Member>>;
  membershipsCount?: Maybe<Scalars['Int']>;
  middleName?: Maybe<Scalars['String']>;
  notificationDispatchItems?: Maybe<Array<NotificationDispatchItem>>;
  notificationDispatchItemsCount?: Maybe<Scalars['Int']>;
  notificationDispatches?: Maybe<Array<NotificationDispatch>>;
  notificationDispatchesCount?: Maybe<Scalars['Int']>;
  patient?: Maybe<Patient>;
  photoSrc?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<ProfilePhoto>;
  prompts?: Maybe<Array<Prompt>>;
  promptsCount?: Maybe<Scalars['Int']>;
  roles?: Maybe<Array<Role>>;
  rolesCount?: Maybe<Scalars['Int']>;
  sessions?: Maybe<Array<Session>>;
  sessionsCount?: Maybe<Scalars['Int']>;
  sex?: Maybe<Scalars['String']>;
  signUpInvite?: Maybe<UserInvite>;
  signUpProvider?: Maybe<Scalars['String']>;
  signedContracts?: Maybe<Array<Contract>>;
  signedContractsCount?: Maybe<Scalars['Int']>;
  stepperProgs?: Maybe<Array<StepperProg>>;
  stepperProgsCount?: Maybe<Scalars['Int']>;
  stepperStepProgs?: Maybe<Array<StepperStepProg>>;
  stepperStepProgsCount?: Maybe<Scalars['Int']>;
  stripeCusId?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['String']>;
  userInvites?: Maybe<Array<UserInvite>>;
  userInvitesCount?: Maybe<Scalars['Int']>;
  userSessions?: Maybe<Array<UserSession>>;
  userSessionsCount?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};


export type UserAccessTokensArgs = {
  cursor?: Maybe<AccessTokenWhereUniqueInput>;
  orderBy?: Array<AccessTokenOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AccessTokenWhereInput;
};


export type UserAccessTokensCountArgs = {
  where?: AccessTokenWhereInput;
};


export type UserAccountsArgs = {
  cursor?: Maybe<AccountWhereUniqueInput>;
  orderBy?: Array<AccountOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: AccountWhereInput;
};


export type UserAccountsCountArgs = {
  where?: AccountWhereInput;
};


export type UserArchivesArgs = {
  cursor?: Maybe<ArchiveWhereUniqueInput>;
  orderBy?: Array<ArchiveOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ArchiveWhereInput;
};


export type UserArchivesCountArgs = {
  where?: ArchiveWhereInput;
};


export type UserCompaniesArgs = {
  cursor?: Maybe<CompanyWhereUniqueInput>;
  orderBy?: Array<CompanyOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: CompanyWhereInput;
};


export type UserCompaniesCountArgs = {
  where?: CompanyWhereInput;
};


export type UserContractsArgs = {
  cursor?: Maybe<ContractWhereUniqueInput>;
  orderBy?: Array<ContractOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ContractWhereInput;
};


export type UserContractsCountArgs = {
  where?: ContractWhereInput;
};


export type UserDataImportIntentsArgs = {
  cursor?: Maybe<DataImportIntentWhereUniqueInput>;
  orderBy?: Array<DataImportIntentOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportIntentWhereInput;
};


export type UserDataImportIntentsCountArgs = {
  where?: DataImportIntentWhereInput;
};


export type UserDataImportsArgs = {
  cursor?: Maybe<DataImportWhereUniqueInput>;
  orderBy?: Array<DataImportOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: DataImportWhereInput;
};


export type UserDataImportsCountArgs = {
  where?: DataImportWhereInput;
};


export type UserFaxBlastsArgs = {
  cursor?: Maybe<FaxBlastWhereUniqueInput>;
  orderBy?: Array<FaxBlastOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FaxBlastWhereInput;
};


export type UserFaxBlastsCountArgs = {
  where?: FaxBlastWhereInput;
};


export type UserFeedbackItemsArgs = {
  cursor?: Maybe<FeedbackItemWhereUniqueInput>;
  orderBy?: Array<FeedbackItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FeedbackItemWhereInput;
};


export type UserFeedbackItemsCountArgs = {
  where?: FeedbackItemWhereInput;
};


export type UserFilesArgs = {
  cursor?: Maybe<FileWhereUniqueInput>;
  orderBy?: Array<FileOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: FileWhereInput;
};


export type UserFilesCountArgs = {
  where?: FileWhereInput;
};


export type UserMembershipsArgs = {
  cursor?: Maybe<MemberWhereUniqueInput>;
  orderBy?: Array<MemberOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: MemberWhereInput;
};


export type UserMembershipsCountArgs = {
  where?: MemberWhereInput;
};


export type UserNotificationDispatchItemsArgs = {
  cursor?: Maybe<NotificationDispatchItemWhereUniqueInput>;
  orderBy?: Array<NotificationDispatchItemOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: NotificationDispatchItemWhereInput;
};


export type UserNotificationDispatchItemsCountArgs = {
  where?: NotificationDispatchItemWhereInput;
};


export type UserNotificationDispatchesArgs = {
  cursor?: Maybe<NotificationDispatchWhereUniqueInput>;
  orderBy?: Array<NotificationDispatchOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: NotificationDispatchWhereInput;
};


export type UserNotificationDispatchesCountArgs = {
  where?: NotificationDispatchWhereInput;
};


export type UserPromptsArgs = {
  cursor?: Maybe<PromptWhereUniqueInput>;
  orderBy?: Array<PromptOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: PromptWhereInput;
};


export type UserPromptsCountArgs = {
  where?: PromptWhereInput;
};


export type UserRolesArgs = {
  cursor?: Maybe<RoleWhereUniqueInput>;
  orderBy?: Array<RoleOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: RoleWhereInput;
};


export type UserRolesCountArgs = {
  where?: RoleWhereInput;
};


export type UserSessionsArgs = {
  cursor?: Maybe<SessionWhereUniqueInput>;
  orderBy?: Array<SessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: SessionWhereInput;
};


export type UserSessionsCountArgs = {
  where?: SessionWhereInput;
};


export type UserSignedContractsArgs = {
  cursor?: Maybe<ContractWhereUniqueInput>;
  orderBy?: Array<ContractOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: ContractWhereInput;
};


export type UserSignedContractsCountArgs = {
  where?: ContractWhereInput;
};


export type UserStepperProgsArgs = {
  cursor?: Maybe<StepperProgWhereUniqueInput>;
  orderBy?: Array<StepperProgOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperProgWhereInput;
};


export type UserStepperProgsCountArgs = {
  where?: StepperProgWhereInput;
};


export type UserStepperStepProgsArgs = {
  cursor?: Maybe<StepperStepProgWhereUniqueInput>;
  orderBy?: Array<StepperStepProgOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: StepperStepProgWhereInput;
};


export type UserStepperStepProgsCountArgs = {
  where?: StepperStepProgWhereInput;
};


export type UserUserInvitesArgs = {
  cursor?: Maybe<UserInviteWhereUniqueInput>;
  orderBy?: Array<UserInviteOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserInviteWhereInput;
};


export type UserUserInvitesCountArgs = {
  where?: UserInviteWhereInput;
};


export type UserUserSessionsArgs = {
  cursor?: Maybe<UserSessionWhereUniqueInput>;
  orderBy?: Array<UserSessionOrderByInput>;
  skip?: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
  where?: UserSessionWhereInput;
};


export type UserUserSessionsCountArgs = {
  where?: UserSessionWhereInput;
};

export type UserCreateInput = {
  accessTokens?: Maybe<AccessTokenRelateToManyForCreateInput>;
  accounts?: Maybe<AccountRelateToManyForCreateInput>;
  address?: Maybe<AddressRelateToOneForCreateInput>;
  archives?: Maybe<ArchiveRelateToManyForCreateInput>;
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  companies?: Maybe<CompanyRelateToManyForCreateInput>;
  contracts?: Maybe<ContractRelateToManyForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntents?: Maybe<DataImportIntentRelateToManyForCreateInput>;
  dataImports?: Maybe<DataImportRelateToManyForCreateInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['DateTime']>;
  faxBlasts?: Maybe<FaxBlastRelateToManyForCreateInput>;
  feedbackItems?: Maybe<FeedbackItemRelateToManyForCreateInput>;
  files?: Maybe<FileRelateToManyForCreateInput>;
  firstName?: Maybe<Scalars['String']>;
  homePhoneNumberString?: Maybe<Scalars['String']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isBirdConsentObtained?: Maybe<Scalars['Boolean']>;
  isDummy?: Maybe<Scalars['Boolean']>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isOnboardedDoctor?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  memberships?: Maybe<MemberRelateToManyForCreateInput>;
  middleName?: Maybe<Scalars['String']>;
  notificationDispatchItems?: Maybe<NotificationDispatchItemRelateToManyForCreateInput>;
  notificationDispatches?: Maybe<NotificationDispatchRelateToManyForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
  photoSrc?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<ProfilePhotoRelateToOneForCreateInput>;
  prompts?: Maybe<PromptRelateToManyForCreateInput>;
  roles?: Maybe<RoleRelateToManyForCreateInput>;
  sessions?: Maybe<SessionRelateToManyForCreateInput>;
  sex?: Maybe<Scalars['String']>;
  signUpInvite?: Maybe<UserInviteRelateToOneForCreateInput>;
  signUpProvider?: Maybe<Scalars['String']>;
  signedContracts?: Maybe<ContractRelateToManyForCreateInput>;
  stepperProgs?: Maybe<StepperProgRelateToManyForCreateInput>;
  stepperStepProgs?: Maybe<StepperStepProgRelateToManyForCreateInput>;
  stripeCusId?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['String']>;
  userInvites?: Maybe<UserInviteRelateToManyForCreateInput>;
  userSessions?: Maybe<UserSessionRelateToManyForCreateInput>;
  username?: Maybe<Scalars['String']>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  healthCard?: Maybe<HealthCard>;
  id: Scalars['ID'];
  invitedByUser?: Maybe<User>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  reminderCount?: Maybe<Scalars['Int']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  sex?: Maybe<Scalars['String']>;
  signedUpUser?: Maybe<User>;
};

export type UserInviteCreateInput = {
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyRelateToOneForCreateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  healthCard?: Maybe<HealthCardRelateToOneForCreateInput>;
  invitedByUser?: Maybe<UserRelateToOneForCreateInput>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  reminderCount?: Maybe<Scalars['Int']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  sex?: Maybe<Scalars['String']>;
  signedUpUser?: Maybe<UserRelateToOneForCreateInput>;
};

export type UserInviteManyRelationFilter = {
  every?: Maybe<UserInviteWhereInput>;
  none?: Maybe<UserInviteWhereInput>;
  some?: Maybe<UserInviteWhereInput>;
};

export type UserInviteOrderByInput = {
  cellPhoneNumberString?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  dateOfBirth?: Maybe<OrderDirection>;
  email?: Maybe<OrderDirection>;
  firstName?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  lastName?: Maybe<OrderDirection>;
  middleName?: Maybe<OrderDirection>;
  reminderCount?: Maybe<OrderDirection>;
  revokedAt?: Maybe<OrderDirection>;
  sex?: Maybe<OrderDirection>;
};

export type UserInviteRelateToManyForCreateInput = {
  connect?: Maybe<Array<UserInviteWhereUniqueInput>>;
  create?: Maybe<Array<UserInviteCreateInput>>;
};

export type UserInviteRelateToManyForUpdateInput = {
  connect?: Maybe<Array<UserInviteWhereUniqueInput>>;
  create?: Maybe<Array<UserInviteCreateInput>>;
  disconnect?: Maybe<Array<UserInviteWhereUniqueInput>>;
  set?: Maybe<Array<UserInviteWhereUniqueInput>>;
};

export type UserInviteRelateToOneForCreateInput = {
  connect?: Maybe<UserInviteWhereUniqueInput>;
  create?: Maybe<UserInviteCreateInput>;
};

export type UserInviteRelateToOneForUpdateInput = {
  connect?: Maybe<UserInviteWhereUniqueInput>;
  create?: Maybe<UserInviteCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type UserInviteUpdateArgs = {
  data: UserInviteUpdateInput;
  where: UserInviteWhereUniqueInput;
};

export type UserInviteUpdateInput = {
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyRelateToOneForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  healthCard?: Maybe<HealthCardRelateToOneForUpdateInput>;
  invitedByUser?: Maybe<UserRelateToOneForUpdateInput>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  reminderCount?: Maybe<Scalars['Int']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  sex?: Maybe<Scalars['String']>;
  signedUpUser?: Maybe<UserRelateToOneForUpdateInput>;
};

export type UserInviteWhereInput = {
  AND?: Maybe<Array<UserInviteWhereInput>>;
  NOT?: Maybe<Array<UserInviteWhereInput>>;
  OR?: Maybe<Array<UserInviteWhereInput>>;
  cellPhoneNumberString?: Maybe<StringFilter>;
  company?: Maybe<CompanyWhereInput>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  dateOfBirth?: Maybe<DateTimeNullableFilter>;
  email?: Maybe<StringFilter>;
  firstName?: Maybe<StringFilter>;
  healthCard?: Maybe<HealthCardWhereInput>;
  id?: Maybe<IdFilter>;
  invitedByUser?: Maybe<UserWhereInput>;
  lastName?: Maybe<StringFilter>;
  middleName?: Maybe<StringFilter>;
  reminderCount?: Maybe<IntNullableFilter>;
  revokedAt?: Maybe<DateTimeNullableFilter>;
  sex?: Maybe<StringFilter>;
  signedUpUser?: Maybe<UserWhereInput>;
};

export type UserInviteWhereUniqueInput = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type UserManyRelationFilter = {
  every?: Maybe<UserWhereInput>;
  none?: Maybe<UserWhereInput>;
  some?: Maybe<UserWhereInput>;
};

export type UserOrderByInput = {
  cellPhoneNumberString?: Maybe<OrderDirection>;
  createdAt?: Maybe<OrderDirection>;
  dateOfBirth?: Maybe<OrderDirection>;
  email?: Maybe<OrderDirection>;
  emailVerified?: Maybe<OrderDirection>;
  firstName?: Maybe<OrderDirection>;
  homePhoneNumberString?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  isAdmin?: Maybe<OrderDirection>;
  isBirdConsentObtained?: Maybe<OrderDirection>;
  isDummy?: Maybe<OrderDirection>;
  isOnboarded?: Maybe<OrderDirection>;
  isOnboardedDoctor?: Maybe<OrderDirection>;
  lastName?: Maybe<OrderDirection>;
  middleName?: Maybe<OrderDirection>;
  photoSrc?: Maybe<OrderDirection>;
  sex?: Maybe<OrderDirection>;
  signUpProvider?: Maybe<OrderDirection>;
  stripeCusId?: Maybe<OrderDirection>;
  subjectId?: Maybe<OrderDirection>;
  username?: Maybe<OrderDirection>;
};

export type UserRelateToManyForCreateInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  create?: Maybe<Array<UserCreateInput>>;
};

export type UserRelateToManyForUpdateInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  create?: Maybe<Array<UserCreateInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
};

export type UserRelateToOneForCreateInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  create?: Maybe<UserCreateInput>;
};

export type UserRelateToOneForUpdateInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  create?: Maybe<UserCreateInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
};

export type UserSession = {
  __typename?: 'UserSession';
  anonLastActivity?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  lastActivity?: Maybe<Scalars['DateTime']>;
  lastPath?: Maybe<Scalars['String']>;
  sessionStart?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type UserSessionCreateInput = {
  anonLastActivity?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Scalars['JSON']>;
  lastActivity?: Maybe<Scalars['DateTime']>;
  lastPath?: Maybe<Scalars['String']>;
  sessionStart?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserRelateToOneForCreateInput>;
};

export type UserSessionManyRelationFilter = {
  every?: Maybe<UserSessionWhereInput>;
  none?: Maybe<UserSessionWhereInput>;
  some?: Maybe<UserSessionWhereInput>;
};

export type UserSessionOrderByInput = {
  anonLastActivity?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  lastActivity?: Maybe<OrderDirection>;
  lastPath?: Maybe<OrderDirection>;
  sessionStart?: Maybe<OrderDirection>;
};

export type UserSessionRelateToManyForCreateInput = {
  connect?: Maybe<Array<UserSessionWhereUniqueInput>>;
  create?: Maybe<Array<UserSessionCreateInput>>;
};

export type UserSessionRelateToManyForUpdateInput = {
  connect?: Maybe<Array<UserSessionWhereUniqueInput>>;
  create?: Maybe<Array<UserSessionCreateInput>>;
  disconnect?: Maybe<Array<UserSessionWhereUniqueInput>>;
  set?: Maybe<Array<UserSessionWhereUniqueInput>>;
};

export type UserSessionUpdateArgs = {
  data: UserSessionUpdateInput;
  where: UserSessionWhereUniqueInput;
};

export type UserSessionUpdateInput = {
  anonLastActivity?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Scalars['JSON']>;
  lastActivity?: Maybe<Scalars['DateTime']>;
  lastPath?: Maybe<Scalars['String']>;
  sessionStart?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserRelateToOneForUpdateInput>;
};

export type UserSessionWhereInput = {
  AND?: Maybe<Array<UserSessionWhereInput>>;
  NOT?: Maybe<Array<UserSessionWhereInput>>;
  OR?: Maybe<Array<UserSessionWhereInput>>;
  anonLastActivity?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  lastActivity?: Maybe<DateTimeNullableFilter>;
  lastPath?: Maybe<StringFilter>;
  sessionStart?: Maybe<DateTimeFilter>;
  user?: Maybe<UserWhereInput>;
};

export type UserSessionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type UserUpdateArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateInput = {
  accessTokens?: Maybe<AccessTokenRelateToManyForUpdateInput>;
  accounts?: Maybe<AccountRelateToManyForUpdateInput>;
  address?: Maybe<AddressRelateToOneForUpdateInput>;
  archives?: Maybe<ArchiveRelateToManyForUpdateInput>;
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  companies?: Maybe<CompanyRelateToManyForUpdateInput>;
  contracts?: Maybe<ContractRelateToManyForUpdateInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportIntents?: Maybe<DataImportIntentRelateToManyForUpdateInput>;
  dataImports?: Maybe<DataImportRelateToManyForUpdateInput>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['DateTime']>;
  faxBlasts?: Maybe<FaxBlastRelateToManyForUpdateInput>;
  feedbackItems?: Maybe<FeedbackItemRelateToManyForUpdateInput>;
  files?: Maybe<FileRelateToManyForUpdateInput>;
  firstName?: Maybe<Scalars['String']>;
  homePhoneNumberString?: Maybe<Scalars['String']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isBirdConsentObtained?: Maybe<Scalars['Boolean']>;
  isDummy?: Maybe<Scalars['Boolean']>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isOnboardedDoctor?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  memberships?: Maybe<MemberRelateToManyForUpdateInput>;
  middleName?: Maybe<Scalars['String']>;
  notificationDispatchItems?: Maybe<NotificationDispatchItemRelateToManyForUpdateInput>;
  notificationDispatches?: Maybe<NotificationDispatchRelateToManyForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
  photoSrc?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<ProfilePhotoRelateToOneForUpdateInput>;
  prompts?: Maybe<PromptRelateToManyForUpdateInput>;
  roles?: Maybe<RoleRelateToManyForUpdateInput>;
  sessions?: Maybe<SessionRelateToManyForUpdateInput>;
  sex?: Maybe<Scalars['String']>;
  signUpInvite?: Maybe<UserInviteRelateToOneForUpdateInput>;
  signUpProvider?: Maybe<Scalars['String']>;
  signedContracts?: Maybe<ContractRelateToManyForUpdateInput>;
  stepperProgs?: Maybe<StepperProgRelateToManyForUpdateInput>;
  stepperStepProgs?: Maybe<StepperStepProgRelateToManyForUpdateInput>;
  stripeCusId?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['String']>;
  userInvites?: Maybe<UserInviteRelateToManyForUpdateInput>;
  userSessions?: Maybe<UserSessionRelateToManyForUpdateInput>;
  username?: Maybe<Scalars['String']>;
};

export type UserWhereInput = {
  AND?: Maybe<Array<UserWhereInput>>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  accessTokens?: Maybe<AccessTokenManyRelationFilter>;
  accounts?: Maybe<AccountManyRelationFilter>;
  address?: Maybe<AddressWhereInput>;
  archives?: Maybe<ArchiveManyRelationFilter>;
  cellPhoneNumberString?: Maybe<StringFilter>;
  companies?: Maybe<CompanyManyRelationFilter>;
  contracts?: Maybe<ContractManyRelationFilter>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  dataImportIntents?: Maybe<DataImportIntentManyRelationFilter>;
  dataImports?: Maybe<DataImportManyRelationFilter>;
  dateOfBirth?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  email?: Maybe<StringFilter>;
  emailVerified?: Maybe<DateTimeNullableFilter>;
  faxBlasts?: Maybe<FaxBlastManyRelationFilter>;
  feedbackItems?: Maybe<FeedbackItemManyRelationFilter>;
  files?: Maybe<FileManyRelationFilter>;
  firstName?: Maybe<StringFilter>;
  homePhoneNumberString?: Maybe<StringFilter>;
  id?: Maybe<IdFilter>;
  isAdmin?: Maybe<BooleanFilter>;
  isBirdConsentObtained?: Maybe<BooleanFilter>;
  isDummy?: Maybe<BooleanFilter>;
  isOnboarded?: Maybe<BooleanFilter>;
  isOnboardedDoctor?: Maybe<BooleanFilter>;
  lastName?: Maybe<StringFilter>;
  memberships?: Maybe<MemberManyRelationFilter>;
  middleName?: Maybe<StringFilter>;
  notificationDispatchItems?: Maybe<NotificationDispatchItemManyRelationFilter>;
  notificationDispatches?: Maybe<NotificationDispatchManyRelationFilter>;
  patient?: Maybe<PatientWhereInput>;
  photoSrc?: Maybe<StringFilter>;
  profilePhoto?: Maybe<ProfilePhotoWhereInput>;
  prompts?: Maybe<PromptManyRelationFilter>;
  roles?: Maybe<RoleManyRelationFilter>;
  sessions?: Maybe<SessionManyRelationFilter>;
  sex?: Maybe<StringFilter>;
  signUpInvite?: Maybe<UserInviteWhereInput>;
  signUpProvider?: Maybe<StringFilter>;
  signedContracts?: Maybe<ContractManyRelationFilter>;
  stepperProgs?: Maybe<StepperProgManyRelationFilter>;
  stepperStepProgs?: Maybe<StepperStepProgManyRelationFilter>;
  stripeCusId?: Maybe<StringFilter>;
  subjectId?: Maybe<StringFilter>;
  userInvites?: Maybe<UserInviteManyRelationFilter>;
  userSessions?: Maybe<UserSessionManyRelationFilter>;
  username?: Maybe<StringFilter>;
};

export type UserWhereUniqueInput = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  subjectId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type Vaccination = {
  __typename?: 'Vaccination';
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Doctor>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  immunizedAt?: Maybe<Scalars['DateTime']>;
  medication?: Maybe<Medication>;
  patient?: Maybe<Patient>;
};

export type VaccinationCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForCreateInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  immunizedAt?: Maybe<Scalars['DateTime']>;
  medication?: Maybe<MedicationRelateToOneForCreateInput>;
  patient?: Maybe<PatientRelateToOneForCreateInput>;
};

export type VaccinationManyRelationFilter = {
  every?: Maybe<VaccinationWhereInput>;
  none?: Maybe<VaccinationWhereInput>;
  some?: Maybe<VaccinationWhereInput>;
};

export type VaccinationOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  expirationDate?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  immunizedAt?: Maybe<OrderDirection>;
};

export type VaccinationRelateToManyForCreateInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  create?: Maybe<Array<VaccinationCreateInput>>;
};

export type VaccinationRelateToManyForUpdateInput = {
  connect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  create?: Maybe<Array<VaccinationCreateInput>>;
  disconnect?: Maybe<Array<VaccinationWhereUniqueInput>>;
  set?: Maybe<Array<VaccinationWhereUniqueInput>>;
};

export type VaccinationUpdateArgs = {
  data: VaccinationUpdateInput;
  where: VaccinationWhereUniqueInput;
};

export type VaccinationUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorRelateToOneForUpdateInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  immunizedAt?: Maybe<Scalars['DateTime']>;
  medication?: Maybe<MedicationRelateToOneForUpdateInput>;
  patient?: Maybe<PatientRelateToOneForUpdateInput>;
};

export type VaccinationWhereInput = {
  AND?: Maybe<Array<VaccinationWhereInput>>;
  NOT?: Maybe<Array<VaccinationWhereInput>>;
  OR?: Maybe<Array<VaccinationWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  doctor?: Maybe<DoctorWhereInput>;
  expirationDate?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  immunizedAt?: Maybe<DateTimeNullableFilter>;
  medication?: Maybe<MedicationWhereInput>;
  patient?: Maybe<PatientWhereInput>;
};

export type VaccinationWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type VerificationToken = {
  __typename?: 'VerificationToken';
  createdAt?: Maybe<Scalars['DateTime']>;
  expires?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerificationTokenCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expires?: Maybe<Scalars['DateTime']>;
  identifier?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerificationTokenOrderByInput = {
  createdAt?: Maybe<OrderDirection>;
  expires?: Maybe<OrderDirection>;
  id?: Maybe<OrderDirection>;
  identifier?: Maybe<OrderDirection>;
  token?: Maybe<OrderDirection>;
};

export type VerificationTokenUpdateArgs = {
  data: VerificationTokenUpdateInput;
  where: VerificationTokenWhereUniqueInput;
};

export type VerificationTokenUpdateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  expires?: Maybe<Scalars['DateTime']>;
  identifier?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerificationTokenWhereInput = {
  AND?: Maybe<Array<VerificationTokenWhereInput>>;
  NOT?: Maybe<Array<VerificationTokenWhereInput>>;
  OR?: Maybe<Array<VerificationTokenWhereInput>>;
  createdAt?: Maybe<DateTimeNullableFilter>;
  expires?: Maybe<DateTimeNullableFilter>;
  id?: Maybe<IdFilter>;
  identifier?: Maybe<StringFilter>;
  token?: Maybe<StringFilter>;
};

export type VerificationTokenWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  token?: Maybe<Scalars['String']>;
};

export type AddressFieldsFragment = { __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> };

export type AppointmentBookingFieldsFragment = { __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, isMissed?: Maybe<boolean>, cancelledAt?: Maybe<any>, note?: Maybe<string>, noteMdx?: Maybe<string>, reason?: Maybe<string>, isInvalidHealthCard?: Maybe<boolean>, prescription?: Maybe<{ __typename?: 'Prescription', id: string }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, phoneNumber?: Maybe<string>, faxNumber?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string> }>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, photoSrc?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> };

export type DoctorBasicFieldsFragment = { __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type DoctorProfileFieldsFragment = { __typename?: 'Doctor', contractSignedOn?: Maybe<any>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, summary?: Maybe<string>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type DoctorProDetailsFieldsFragment = { __typename?: 'Doctor', isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string> };

export type DoctorSupportingDocsFieldsFragment = { __typename?: 'Doctor', proofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrl?: Maybe<string>, publicUrlTransformed?: Maybe<string>, originalFilename?: Maybe<string>, mimetype?: Maybe<string> }> }>, proofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrl?: Maybe<string>, publicUrlTransformed?: Maybe<string>, originalFilename?: Maybe<string>, mimetype?: Maybe<string> }> }>, proofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrl?: Maybe<string>, publicUrlTransformed?: Maybe<string>, originalFilename?: Maybe<string>, mimetype?: Maybe<string> }> }> };

export type DoctorAppointmentFieldsFragment = { __typename?: 'Appointment', id: string, reason?: Maybe<string>, prescription?: Maybe<{ __typename?: 'Prescription', id: string, isSubstitutionAllowed?: Maybe<boolean> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string }> };

export type DoctorAppointmentBookingFieldsFragment = { __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, photoSrc?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> };

export type AppointmentNoteFieldsFragment = { __typename?: 'AppointmentNote', id: string, summary?: Maybe<string>, title?: Maybe<string> };

export type EmergencyContactFieldsFragment = { __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> };

export type FileFieldsFragment = { __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> };

export type StepperStepFieldsFragment = { __typename?: 'StepperStep', id: string, component?: Maybe<string>, description?: Maybe<string>, isFinal?: Maybe<boolean>, isOptional?: Maybe<boolean>, label?: Maybe<string>, order?: Maybe<number>, slug?: Maybe<string>, title?: Maybe<string> };

export type HealthCardFieldsFragment = { __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> };

export type PatientAppointmentBookingFieldsFragment = { __typename?: 'Appointment', id: string, reason?: Maybe<string>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, startsAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, photoSrc?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type PatientBasicFieldsFragment = { __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type PatientProfileFieldsFragment = { __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type ProfilePhotoFieldsFragment = { __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> };

export type ScheduleBasicFieldsFragment = { __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string>, slotInterval?: Maybe<number>, tz?: Maybe<string> };

export type UserBasicDataFieldsFragment = { __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> };

export type UserContactFieldsFragment = { __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> };

export type UserPhotoFieldsFragment = { __typename?: 'User', id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> };

export type VitalsFieldsFragment = { __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> };

export type AcceptInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite?: Maybe<{ __typename?: 'User', id: string }> };

export type AddChatMessageMutationVariables = Exact<{
  chatId: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  replyToMessageId?: Maybe<Scalars['ID']>;
  uuid: Scalars['String'];
}>;


export type AddChatMessageMutation = { __typename?: 'Mutation', addChatMessage?: Maybe<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, uuid?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, replyTo?: Maybe<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> };

export type AddPatientToCompanyMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  cellPhoneNumberString: Scalars['String'];
  dateOfBirth: Scalars['String'];
  companyId: Scalars['ID'];
}>;


export type AddPatientToCompanyMutation = { __typename?: 'Mutation', addPatientToCompany?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string>, cellPhoneNumberString?: Maybe<string> }> }> };

export type AddReferringDoctorMutationVariables = Exact<{
  billingId: Scalars['ID'];
  referringDoctorNumber: Scalars['String'];
}>;


export type AddReferringDoctorMutation = { __typename?: 'Mutation', updateAppointmentBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, referringDoctorNumber?: Maybe<string> }> };

export type AssignDoctorToFaxMutationVariables = Exact<{
  inboundFaxId: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type AssignDoctorToFaxMutation = { __typename?: 'Mutation', updateInboundFax?: Maybe<{ __typename?: 'InboundFax', id: string, member?: Maybe<{ __typename?: 'Member', id: string }> }> };

export type AssignPatientToFaxMutationVariables = Exact<{
  inboundFaxId: Scalars['ID'];
  patientId: Scalars['ID'];
}>;


export type AssignPatientToFaxMutation = { __typename?: 'Mutation', updateInboundFax?: Maybe<{ __typename?: 'InboundFax', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string }> }> };

export type BackfillMyStripeMutationVariables = Exact<{ [key: string]: never; }>;


export type BackfillMyStripeMutation = { __typename?: 'Mutation', backfillMyStripe?: Maybe<{ __typename?: 'User', id: string, stripeCusId?: Maybe<string> }> };

export type CancelAppointmentRequestMutationVariables = Exact<{
  appointmentRequestId: Scalars['ID'];
}>;


export type CancelAppointmentRequestMutation = { __typename?: 'Mutation', cancelAppointmentRequest?: Maybe<{ __typename?: 'AppointmentRequest', id: string }> };

export type CancelCompanyOnboardingMutationVariables = Exact<{
  companyId: Scalars['ID'];
  stepperProgId: Scalars['ID'];
}>;


export type CancelCompanyOnboardingMutation = { __typename?: 'Mutation', cancelCompanyOnboarding?: Maybe<{ __typename?: 'Company', id: string }> };

export type CompleteAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
  faxFile?: Maybe<Scalars['Upload']>;
}>;


export type CompleteAppointmentMutation = { __typename?: 'Mutation', completeAppointment?: Maybe<{ __typename?: 'Appointment', id: string, isSigned?: Maybe<boolean>, signedAt?: Maybe<any>, faxes?: Maybe<Array<{ __typename?: 'Fax', id: string, status?: Maybe<FaxStatusType> }>> }> };

export type CompleteCompanyOnboardingMutationVariables = Exact<{
  stepperProgId: Scalars['ID'];
}>;


export type CompleteCompanyOnboardingMutation = { __typename?: 'Mutation', completeCompanyOnboarding?: Maybe<boolean> };

export type CompleteStepProgMutationVariables = Exact<{
  stepId: Scalars['ID'];
}>;


export type CompleteStepProgMutation = { __typename?: 'Mutation', completeMyStepProg?: Maybe<{ __typename?: 'StepperStepProg', id: string, percentDone?: Maybe<number>, isCompleted?: Maybe<boolean>, stepperStep?: Maybe<{ __typename?: 'StepperStep', id: string, slug?: Maybe<string> }> }> };

export type ConnectPatientPharmacyLocationMutationVariables = Exact<{
  patientId: Scalars['ID'];
  pharmacyLocationIds?: Maybe<Array<PharmacyLocationWhereUniqueInput> | PharmacyLocationWhereUniqueInput>;
}>;


export type ConnectPatientPharmacyLocationMutation = { __typename?: 'Mutation', updatePatient?: Maybe<{ __typename?: 'Patient', id: string, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string }>> }> };

export type CreateAllergyItemMutationVariables = Exact<{
  patientId: Scalars['ID'];
  name: Scalars['String'];
  reaction: Scalars['String'];
  onsetDate?: Maybe<Scalars['DateTime']>;
}>;


export type CreateAllergyItemMutation = { __typename?: 'Mutation', createAllergyItem?: Maybe<{ __typename?: 'AllergyItem', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, allergies?: Maybe<Array<{ __typename?: 'AllergyItem', id: string, name?: Maybe<string>, reaction?: Maybe<string>, onsetDate?: Maybe<any> }>> }> }> };

export type CreateAppointmentDraftMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type CreateAppointmentDraftMutation = { __typename?: 'Mutation', createAppointmentDraft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }>, author?: Maybe<{ __typename?: 'User', id: string }> }> };

export type CreateAppointmentRequestMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  doctorId: Scalars['ID'];
  eventId: Scalars['ID'];
  followUpTo?: Maybe<AppointmentRelateToOneForCreateInput>;
  memberId: Scalars['ID'];
  patientId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type CreateAppointmentRequestMutation = { __typename?: 'Mutation', createAppointmentRequest?: Maybe<{ __typename?: 'AppointmentRequest', id: string, createdAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, appointmentRequests?: Maybe<Array<{ __typename?: 'AppointmentRequest', id: string }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, appointmentRequests?: Maybe<Array<{ __typename?: 'AppointmentRequest', id: string }>> }> }> };

export type CreateBillingItemMutationVariables = Exact<{
  billingId: Scalars['ID'];
  claimId: Scalars['ID'];
  diagnosisConnect?: Maybe<BillingDiagnosisRelateToOneForCreateInput>;
  premiumConnect?: Maybe<BillingPremiumRelateToOneForCreateInput>;
  units?: Maybe<Scalars['Int']>;
}>;


export type CreateBillingItemMutation = { __typename?: 'Mutation', createAppointmentBillingItem?: Maybe<{ __typename?: 'AppointmentBillingItem', id: string, billing?: Maybe<{ __typename?: 'AppointmentBilling', id: string, referringDoctorNumber?: Maybe<string>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, code?: Maybe<string> }> }>> }> }> };

export type CreateBookingMutationVariables = Exact<{
  data: BookingCreateInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: Maybe<{ __typename?: 'Booking', id: string }> };

export type CreateBucketFileMutationVariables = Exact<{
  documentId?: Maybe<Scalars['ID']>;
  faxBlastId?: Maybe<Scalars['ID']>;
  faxId?: Maybe<Scalars['ID']>;
  fileKey: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  fileType: Scalars['String'];
  leaseAgreementId?: Maybe<Scalars['ID']>;
  masterLicenseId?: Maybe<Scalars['ID']>;
  proofOfIdentificationId?: Maybe<Scalars['ID']>;
  proofOfInsuranceId?: Maybe<Scalars['ID']>;
  proofOfLicenseId?: Maybe<Scalars['ID']>;
  signatureId?: Maybe<Scalars['ID']>;
}>;


export type CreateBucketFileMutation = { __typename?: 'Mutation', createBucketFile?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string>, document?: Maybe<{ __typename?: 'Document', id: string }>, faxBlast?: Maybe<{ __typename?: 'FaxBlast', id: string }>, fax?: Maybe<{ __typename?: 'Fax', id: string }>, leaseAgreement?: Maybe<{ __typename?: 'LeaseAgreement', id: string }>, masterLicense?: Maybe<{ __typename?: 'MasterLicense', id: string }>, proofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string }>, proofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string }>, proofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string }>, signature?: Maybe<{ __typename?: 'Signature', id: string }> }> };

export type CreateChatMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
  doctorsIds?: Maybe<Array<DoctorWhereUniqueInput> | DoctorWhereUniqueInput>;
  patientId: Scalars['ID'];
}>;


export type CreateChatMutation = { __typename?: 'Mutation', createChat?: Maybe<{ __typename?: 'Chat', id: string }> };

export type CreateChatMessageMutationVariables = Exact<{
  data: ChatMessageCreateInput;
}>;


export type CreateChatMessageMutation = { __typename?: 'Mutation', createChatMessage?: Maybe<{ __typename?: 'ChatMessage', id: string }> };

export type CreateClinicAddressMutationVariables = Exact<{
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea: Scalars['String'];
  country: Scalars['String'];
  locality: Scalars['String'];
  postalCode: Scalars['String'];
  clinicId: Scalars['ID'];
}>;


export type CreateClinicAddressMutation = { __typename?: 'Mutation', createAddress?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, country?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, clinic?: Maybe<{ __typename?: 'Clinic', id: string }> }> };

export type CreateClinicLeaseAgreementMutationVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type CreateClinicLeaseAgreementMutation = { __typename?: 'Mutation', createLeaseAgreement?: Maybe<{ __typename?: 'LeaseAgreement', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string }> }> };

export type CreateClinicMutationVariables = Exact<{
  companyId: Scalars['ID'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea: Scalars['String'];
  clinicDescription?: Maybe<Scalars['String']>;
  clinicMemberRole?: Maybe<RoleNameType>;
  clinicMemberRoleAlias?: Maybe<Scalars['String']>;
  clinicName: Scalars['String'];
  clinicPhoneNumber: Scalars['String'];
  country: Scalars['String'];
  facilityMasterNumber?: Maybe<Scalars['String']>;
  locality: Scalars['String'];
  ohipGroupNumber: Scalars['String'];
  postalCode: Scalars['String'];
  serviceLocationIndicator?: Maybe<Scalars['String']>;
}>;


export type CreateClinicMutation = { __typename?: 'Mutation', addClinic?: Maybe<{ __typename?: 'Clinic', id: string, company?: Maybe<{ __typename?: 'Company', id: string }> }> };

export type CreateCompanyLogoMutationVariables = Exact<{
  image: Scalars['Upload'];
  companyId: Scalars['ID'];
}>;


export type CreateCompanyLogoMutation = { __typename?: 'Mutation', createCompanyLogo?: Maybe<{ __typename?: 'CompanyLogo', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }>, company?: Maybe<{ __typename?: 'Company', id: string }> }> };

export type CreateCompanyMutationVariables = Exact<{
  legalName: Scalars['String'];
  operatingName: Scalars['String'];
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', addCompany?: Maybe<{ __typename?: 'Company', id: string, isOnboarded?: Maybe<boolean>, legalName?: Maybe<string>, logo?: Maybe<{ __typename?: 'CompanyLogo', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type CreateCompanyMasterLicenseMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CreateCompanyMasterLicenseMutation = { __typename?: 'Mutation', createMasterLicense?: Maybe<{ __typename?: 'MasterLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, company?: Maybe<{ __typename?: 'Company', id: string }> }> };

export type CreateContractMutationVariables = Exact<{
  data: ContractCreateInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract?: Maybe<{ __typename?: 'Contract', id: string, content?: Maybe<string>, createdAt?: Maybe<any>, effectiveFrom?: Maybe<any>, isActive?: Maybe<boolean>, lastUpdated?: Maybe<any>, name?: Maybe<string>, slug?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string }>, signedBy?: Maybe<Array<{ __typename?: 'User', id: string }>> }> };

export type CreateCouponMutationVariables = Exact<{
  data: CouponCreateInput;
}>;


export type CreateCouponMutation = { __typename?: 'Mutation', createCoupon?: Maybe<{ __typename?: 'Coupon', id: string }> };

export type CreateDoctorEventBookingMutationVariables = Exact<{
  eventId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  tzTarget: Scalars['String'];
  clinicId: Scalars['ID'];
  memberId: Scalars['ID'];
  patientId: Scalars['ID'];
}>;


export type CreateDoctorEventBookingMutation = { __typename?: 'Mutation', createDoctorCalendarEventBooking?: Maybe<{ __typename?: 'Booking', id: string }> };

export type CreateDocumentAttachmentMutationVariables = Exact<{
  attachment: Scalars['Upload'];
  doctorId: Scalars['ID'];
  patientId: Scalars['ID'];
  title: Scalars['String'];
}>;


export type CreateDocumentAttachmentMutation = { __typename?: 'Mutation', createDocument?: Maybe<{ __typename?: 'Document', id: string, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string> }>> }> }> };

export type CreateDocumentMutationVariables = Exact<{
  form?: Maybe<FormRelateToOneForCreateInput>;
  doctorId: Scalars['ID'];
  patientId: Scalars['ID'];
  title: Scalars['String'];
  file?: Maybe<FileRelateToOneForCreateInput>;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument?: Maybe<{ __typename?: 'Document', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string> }>> }> }> };

export type CreateDrIdMutationVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type CreateDrIdMutation = { __typename?: 'Mutation', createProofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }> }> };

export type CreateDrInsuranceMutationVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type CreateDrInsuranceMutation = { __typename?: 'Mutation', createProofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }> }> };

export type CreateDrLicenseMutationVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type CreateDrLicenseMutation = { __typename?: 'Mutation', createProofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }> }> };

export type CreateDrSignatureMutationVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type CreateDrSignatureMutation = { __typename?: 'Mutation', createSignature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }> }> };

export type CreateEmergencyContactMutationVariables = Exact<{
  cellPhoneNumberString: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  homePhoneNumberString?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  patientId: Scalars['ID'];
}>;


export type CreateEmergencyContactMutation = { __typename?: 'Mutation', createEmergencyContact?: Maybe<{ __typename?: 'EmergencyContact', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>> }> }> }> }> };

export type CreateEventBookingMutationVariables = Exact<{
  eventId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  tzTarget: Scalars['String'];
  clinicId: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type CreateEventBookingMutation = { __typename?: 'Mutation', createCalendarEventBooking?: Maybe<{ __typename?: 'Booking', id: string }> };

export type CreateEventMutationVariables = Exact<{
  calendarId: Scalars['ID'];
  doctorId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  durationMins: Scalars['Int'];
  eventTypeValue: Scalars['String'];
  title: Scalars['String'];
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createCalendarEvent?: Maybe<{ __typename?: 'CalendarEvent', id: string }> };

export type CreateFaxBlastMutationVariables = Exact<{
  data: FaxBlastCreateInput;
}>;


export type CreateFaxBlastMutation = { __typename?: 'Mutation', createFaxBlast?: Maybe<{ __typename?: 'FaxBlast', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, title?: Maybe<string> }> };

export type CreateFaxMutationVariables = Exact<{
  data: FaxCreateInput;
}>;


export type CreateFaxMutation = { __typename?: 'Mutation', createFax?: Maybe<{ __typename?: 'Fax', id: string }> };

export type CreateFeedbackItemMutationVariables = Exact<{
  summary: Scalars['String'];
}>;


export type CreateFeedbackItemMutation = { __typename?: 'Mutation', createFeedbackItem?: Maybe<{ __typename?: 'FeedbackItem', id: string }> };

export type CreateFormMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
  doctorId: Scalars['ID'];
  formFields: Scalars['JSON'];
  formTypeSlug: Scalars['String'];
  name: Scalars['String'];
  patientId: Scalars['ID'];
  slug: Scalars['String'];
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm?: Maybe<{ __typename?: 'Form', id: string }> };

export type CreateTestOptionMutationVariables = Exact<{
  label: Scalars['String'];
  value: Scalars['String'];
  testFor: Scalars['String'];
}>;


export type CreateTestOptionMutation = { __typename?: 'Mutation', createFormTest?: Maybe<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, value?: Maybe<string>, testFor?: Maybe<string> }> };

export type CreateHealthCardMutationVariables = Exact<{
  patientId: Scalars['ID'];
  expiryDate: Scalars['DateTime'];
  versionCode?: Maybe<Scalars['String']>;
  insurancePolicyNumber: Scalars['String'];
}>;


export type CreateHealthCardMutation = { __typename?: 'Mutation', createHealthCard?: Maybe<{ __typename?: 'HealthCard', id: string, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>> }> }> }> }> };

export type CreateHealthConditionMutationVariables = Exact<{
  patientId: Scalars['ID'];
  diagnosedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  relation: Scalars['String'];
}>;


export type CreateHealthConditionMutation = { __typename?: 'Mutation', createHealthCondition?: Maybe<{ __typename?: 'HealthCondition', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, healthConditions?: Maybe<Array<{ __typename?: 'HealthCondition', id: string, diagnosedAt?: Maybe<any>, name?: Maybe<string>, relation?: Maybe<string> }>> }> }> };

export type CreateLifestyleItemMutationVariables = Exact<{
  patientId: Scalars['ID'];
  activity: Scalars['String'];
  frequency: Scalars['String'];
  item: Scalars['String'];
}>;


export type CreateLifestyleItemMutation = { __typename?: 'Mutation', createLifestyleItem?: Maybe<{ __typename?: 'LifestyleItem', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, lifestyleItems?: Maybe<Array<{ __typename?: 'LifestyleItem', id: string, activity?: Maybe<string>, frequency?: Maybe<string>, item?: Maybe<string> }>> }> }> };

export type CreateMedicalHistoryLinkMutationVariables = Exact<{
  validTo: Scalars['DateTime'];
}>;


export type CreateMedicalHistoryLinkMutation = { __typename?: 'Mutation', createMedicalHistoryLink?: Maybe<{ __typename?: 'AccessToken', id: string }> };

export type CreateMedicationItemsMutationVariables = Exact<{
  medicationItemsData: Array<MedicationItemCreateInput> | MedicationItemCreateInput;
}>;


export type CreateMedicationItemsMutation = { __typename?: 'Mutation', createMedicationItems?: Maybe<Array<Maybe<{ __typename?: 'MedicationItem', id: string }>>> };

export type CreateMedicationItemMutationVariables = Exact<{
  doctorId: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  medicationId: Scalars['ID'];
  patientId: Scalars['ID'];
  prescribedAt: Scalars['DateTime'];
  refills: Scalars['Int'];
}>;


export type CreateMedicationItemMutation = { __typename?: 'Mutation', createMedicationItem?: Maybe<{ __typename?: 'MedicationItem', id: string }> };

export type CreateMemberDataImportIntentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  source: Scalars['String'];
}>;


export type CreateMemberDataImportIntentMutation = { __typename?: 'Mutation', createMemberDataImportIntent?: Maybe<{ __typename?: 'DataImportIntent', id: string }> };

export type AddMemberMutationVariables = Exact<{
  userId: Scalars['ID'];
  companyId: Scalars['ID'];
  clinicId: Scalars['ID'];
  clinicMemberRole: RoleNameType;
  clinicMemberRoleAlias?: Maybe<Scalars['String']>;
}>;


export type AddMemberMutation = { __typename?: 'Mutation', addMember?: Maybe<{ __typename?: 'Member', id: string, clinic?: Maybe<{ __typename?: 'Clinic', id: string, company?: Maybe<{ __typename?: 'Company', id: string }> }> }> };

export type CreatePrescriptionItemMutationVariables = Exact<{
  prescriptionId: Scalars['ID'];
  refills?: Maybe<Scalars['String']>;
  luCode?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  drugCode: Scalars['String'];
}>;


export type CreatePrescriptionItemMutation = { __typename?: 'Mutation', createPrescriptionItem?: Maybe<{ __typename?: 'PrescriptionItem', id: string, prescription?: Maybe<{ __typename?: 'Prescription', id: string, prescriptionItems?: Maybe<Array<{ __typename?: 'PrescriptionItem', id: string, instructions?: Maybe<string>, luCode?: Maybe<string>, refills?: Maybe<string>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string> }> }>> }> }> };

export type CreateRecurringSlotMutationVariables = Exact<{
  wday: Scalars['String'];
  interval: Scalars['String'];
  intervalCount: Scalars['Int'];
  scheduleId: Scalars['ID'];
}>;


export type CreateRecurringSlotMutation = { __typename?: 'Mutation', createRecurringSlot?: Maybe<{ __typename?: 'RecurringSlot', id: string }> };

export type CreateScheduleMutationVariables = Exact<{
  calendarId: Scalars['ID'];
  defaultOn?: Maybe<CalendarRelateToOneForCreateInput>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
}>;


export type CreateScheduleMutation = { __typename?: 'Mutation', createSchedule?: Maybe<{ __typename?: 'Schedule', id: string }> };

export type CreateScreeningTestMutationVariables = Exact<{
  patientId: Scalars['ID'];
  name: Scalars['String'];
  testedAt: Scalars['DateTime'];
}>;


export type CreateScreeningTestMutation = { __typename?: 'Mutation', createScreeningTest?: Maybe<{ __typename?: 'ScreeningTest', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, screeningTests?: Maybe<Array<{ __typename?: 'ScreeningTest', id: string, name?: Maybe<string>, testedAt?: Maybe<any> }>> }> }> };

export type CreateStepperProgMutationVariables = Exact<{
  stepperId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type CreateStepperProgMutation = { __typename?: 'Mutation', createStepperProg?: Maybe<{ __typename?: 'StepperProg', id: string }> };

export type CreateTaskMutationVariables = Exact<{
  data: TaskCreateInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask?: Maybe<{ __typename?: 'Task', id: string }> };

export type CreateTestsBatchMutationVariables = Exact<{
  data: TestsBatchCreateInput;
}>;


export type CreateTestsBatchMutation = { __typename?: 'Mutation', createTestsBatch?: Maybe<{ __typename?: 'TestsBatch', id: string, name?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, formTests?: Maybe<Array<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, formType?: Maybe<{ __typename?: 'FormType', id: string, name?: Maybe<string>, slug?: Maybe<string> }> }> };

export type CreateTestOrdersMutationVariables = Exact<{
  data: Array<TestOrderCreateInput> | TestOrderCreateInput;
}>;


export type CreateTestOrdersMutation = { __typename?: 'Mutation', createTestOrders?: Maybe<Array<Maybe<{ __typename?: 'TestOrder', id: string }>>> };

export type CreateTimeIntervalMutationVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
  recurringSlotId: Scalars['ID'];
}>;


export type CreateTimeIntervalMutation = { __typename?: 'Mutation', createTimeInterval?: Maybe<{ __typename?: 'TimeInterval', id: string }> };

export type CreateUserAddressMutationVariables = Exact<{
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea: Scalars['String'];
  country: Scalars['String'];
  locality: Scalars['String'];
  postalCode: Scalars['String'];
  userId: Scalars['ID'];
}>;


export type CreateUserAddressMutation = { __typename?: 'Mutation', createAddress?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, country?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, user?: Maybe<{ __typename?: 'User', id: string }> }> };

export type CreateUserDoctorMutationVariables = Exact<{
  userId: Scalars['ID'];
  doctorSince?: Maybe<Scalars['DateTime']>;
}>;


export type CreateUserDoctorMutation = { __typename?: 'Mutation', createDoctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type CreateUserProfilePhotoMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type CreateUserProfilePhotoMutation = { __typename?: 'Mutation', createProfilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string }> }> };

export type CreateVaccinationMutationVariables = Exact<{
  doctorId: Scalars['ID'];
  patientId: Scalars['ID'];
  immunizedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  drugCode: Scalars['String'];
}>;


export type CreateVaccinationMutation = { __typename?: 'Mutation', createVaccination?: Maybe<{ __typename?: 'Vaccination', id: string, doctor?: Maybe<{ __typename?: 'Doctor', id: string, vaccinations?: Maybe<Array<{ __typename?: 'Vaccination', id: string, expirationDate?: Maybe<any>, immunizedAt?: Maybe<any>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string> }> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, vaccinations?: Maybe<Array<{ __typename?: 'Vaccination', id: string, expirationDate?: Maybe<any>, immunizedAt?: Maybe<any>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string> }> }>> }> }> };

export type CreateWalkInAppointmentMutationVariables = Exact<{
  eventId: Scalars['ID'];
  isInvalidHealthCard?: Maybe<Scalars['Boolean']>;
  patientId: Scalars['ID'];
  reason: Scalars['String'];
  clinicId: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type CreateWalkInAppointmentMutation = { __typename?: 'Mutation', createWalkInAppointment?: Maybe<{ __typename?: 'Appointment', id: string }> };

export type DeleteBillingItemMutationVariables = Exact<{
  billingItemId: Scalars['ID'];
}>;


export type DeleteBillingItemMutation = { __typename?: 'Mutation', deleteAppointmentBillingItem?: Maybe<{ __typename?: 'AppointmentBillingItem', id: string, billing?: Maybe<{ __typename?: 'AppointmentBilling', id: string, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string }>> }> }> };

export type DeleteCompanyLogoMutationVariables = Exact<{
  companyLogoId: Scalars['ID'];
}>;


export type DeleteCompanyLogoMutation = { __typename?: 'Mutation', deleteCompanyLogo?: Maybe<{ __typename?: 'CompanyLogo', id: string }> };

export type DeleteDrIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDrIdMutation = { __typename?: 'Mutation', deleteProofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string }> };

export type DeleteDrInsuranceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDrInsuranceMutation = { __typename?: 'Mutation', deleteProofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string }> };

export type DeleteDrLicenseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDrLicenseMutation = { __typename?: 'Mutation', deleteProofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string }> };

export type DeleteEmergencyContactMutationVariables = Exact<{
  emergencyContactId: Scalars['ID'];
}>;


export type DeleteEmergencyContactMutation = { __typename?: 'Mutation', deleteEmergencyContact?: Maybe<{ __typename?: 'EmergencyContact', id: string }> };

export type DeleteFormMutationVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', deleteForm?: Maybe<{ __typename?: 'Form', id: string }> };

export type DeleteHealthCardMutationVariables = Exact<{
  healthCardId: Scalars['ID'];
}>;


export type DeleteHealthCardMutation = { __typename?: 'Mutation', deleteHealthCard?: Maybe<{ __typename?: 'HealthCard', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string }>> }> }> };

export type DeletePrescriptionItemMutationVariables = Exact<{
  prescriptionItemId: Scalars['ID'];
}>;


export type DeletePrescriptionItemMutation = { __typename?: 'Mutation', deletePrescriptionItem?: Maybe<{ __typename?: 'PrescriptionItem', id: string, prescription?: Maybe<{ __typename?: 'Prescription', id: string, prescriptionItems?: Maybe<Array<{ __typename?: 'PrescriptionItem', id: string }>> }> }> };

export type DeleteProfilePhotoMutationVariables = Exact<{
  profilePhotoId: Scalars['ID'];
}>;


export type DeleteProfilePhotoMutation = { __typename?: 'Mutation', deleteProfilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, user?: Maybe<{ __typename?: 'User', id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type DeleteScheduleMutationVariables = Exact<{
  scheduleId: Scalars['ID'];
}>;


export type DeleteScheduleMutation = { __typename?: 'Mutation', deleteSchedule?: Maybe<{ __typename?: 'Schedule', id: string }> };

export type DeleteTestsBatchMutationVariables = Exact<{
  testsBatchId: Scalars['ID'];
}>;


export type DeleteTestsBatchMutation = { __typename?: 'Mutation', deleteTestsBatch?: Maybe<{ __typename?: 'TestsBatch', id: string, name?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, formTests?: Maybe<Array<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, formType?: Maybe<{ __typename?: 'FormType', id: string, name?: Maybe<string>, slug?: Maybe<string> }> }> };

export type DeleteTimeIntervalMutationVariables = Exact<{
  timeIntervalId: Scalars['ID'];
}>;


export type DeleteTimeIntervalMutation = { __typename?: 'Mutation', deleteTimeInterval?: Maybe<{ __typename?: 'TimeInterval', id: string }> };

export type DocUpdateVitalsDataMutationVariables = Exact<{
  vitalsDataId: Scalars['ID'];
  bloodPressure?: Maybe<Scalars['String']>;
  cm?: Maybe<Scalars['Int']>;
  headCm?: Maybe<Scalars['Int']>;
  heartRate?: Maybe<Scalars['Int']>;
  kg?: Maybe<Scalars['Float']>;
  meters?: Maybe<Scalars['Int']>;
  oxygenSaturation?: Maybe<Scalars['Int']>;
  resp?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
}>;


export type DocUpdateVitalsDataMutation = { __typename?: 'Mutation', updateAppointmentVital?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> };

export type DrUpdateAppointmentNoteMutationVariables = Exact<{
  apptId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  noteMdx?: Maybe<Scalars['String']>;
}>;


export type DrUpdateAppointmentNoteMutation = { __typename?: 'Mutation', updateAppointment?: Maybe<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string> }> };

export type InactivateHealthConditionMutationVariables = Exact<{
  healthConditionId: Scalars['ID'];
  inactivatedAt: Scalars['DateTime'];
}>;


export type InactivateHealthConditionMutation = { __typename?: 'Mutation', updateHealthCondition?: Maybe<{ __typename?: 'HealthCondition', id: string, inactivatedAt?: Maybe<any>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }> };

export type InactivateLifestyleItemMutationVariables = Exact<{
  lifestyleItemId: Scalars['ID'];
  inactivatedAt: Scalars['DateTime'];
}>;


export type InactivateLifestyleItemMutation = { __typename?: 'Mutation', updateLifestyleItem?: Maybe<{ __typename?: 'LifestyleItem', id: string, inactivatedAt?: Maybe<any>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }> };

export type InactivateMedicationItemMutationVariables = Exact<{
  medicationItemId: Scalars['ID'];
  inactivatedAt: Scalars['DateTime'];
}>;


export type InactivateMedicationItemMutation = { __typename?: 'Mutation', updateMedicationItem?: Maybe<{ __typename?: 'MedicationItem', id: string, inactivatedAt?: Maybe<any>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }> };

export type InviteUserByDoctorMutationVariables = Exact<{
  healthCardNumber?: Maybe<Scalars['String']>;
  healthCardVersionCode?: Maybe<Scalars['String']>;
  healthCardExpiryDate?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
}>;


export type InviteUserByDoctorMutation = { __typename?: 'Mutation', inviteUserByDoctor?: Maybe<{ __typename?: 'UserInvite', id: string }> };

export type IssueFormMutationVariables = Exact<{
  formId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type IssueFormMutation = { __typename?: 'Mutation', issueForm?: Maybe<{ __typename?: 'Form', id: string }> };

export type LinkTestOrderToFaxMutationVariables = Exact<{
  inboundFaxId: Scalars['ID'];
  testOrderId: Scalars['ID'];
}>;


export type LinkTestOrderToFaxMutation = { __typename?: 'Mutation', updateInboundFax?: Maybe<{ __typename?: 'InboundFax', id: string, testOrder?: Maybe<{ __typename?: 'TestOrder', id: string }> }> };

export type LogUserSessionMutationVariables = Exact<{
  lastPath: Scalars['String'];
  userSessionId?: Maybe<Scalars['ID']>;
}>;


export type LogUserSessionMutation = { __typename?: 'Mutation', logUserSession?: Maybe<{ __typename?: 'UserSession', id: string, lastPath?: Maybe<string> }> };

export type ManageCreatePharmacyLocationMutationVariables = Exact<{
  data: PharmacyLocationCreateInput;
}>;


export type ManageCreatePharmacyLocationMutation = { __typename?: 'Mutation', createPharmacyLocation?: Maybe<{ __typename?: 'PharmacyLocation', id: string }> };

export type ManageCreatePharmacyMutationVariables = Exact<{
  data: PharmacyCreateInput;
}>;


export type ManageCreatePharmacyMutation = { __typename?: 'Mutation', createPharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string }> };

export type MarkAppointmentCancelledMutationVariables = Exact<{
  cancelledAt: Scalars['DateTime'];
  apptId: Scalars['ID'];
}>;


export type MarkAppointmentCancelledMutation = { __typename?: 'Mutation', markAppointmentCancelled?: Maybe<{ __typename?: 'Appointment', id: string, cancelledAt?: Maybe<any> }> };

export type MarkAppointmentMissedMutationVariables = Exact<{
  apptId: Scalars['ID'];
}>;


export type MarkAppointmentMissedMutation = { __typename?: 'Mutation', markAppointmentMissed?: Maybe<{ __typename?: 'Appointment', id: string, isMissed?: Maybe<boolean> }> };

export type MarkBillingMutationVariables = Exact<{
  billingId: Scalars['ID'];
  status: AppointmentBillingStatusType;
}>;


export type MarkBillingMutation = { __typename?: 'Mutation', markBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, status?: Maybe<AppointmentBillingStatusType> }> };

export type MarkInboundFaxReviewedMutationVariables = Exact<{
  inboundFaxId: Scalars['ID'];
  reviewedAt: Scalars['DateTime'];
}>;


export type MarkInboundFaxReviewedMutation = { __typename?: 'Mutation', updateInboundFax?: Maybe<{ __typename?: 'InboundFax', id: string, reviewedAt?: Maybe<any> }> };

export type MoveFileToArchiveMutationVariables = Exact<{
  fileId: Scalars['ID'];
  archiveName: Scalars['String'];
}>;


export type MoveFileToArchiveMutation = { __typename?: 'Mutation', moveFileToArchive?: Maybe<{ __typename?: 'ArchiveItem', id: string }> };

export type OrderFaxNumberMutationVariables = Exact<{
  companyId: Scalars['ID'];
  memberId: Scalars['ID'];
}>;


export type OrderFaxNumberMutation = { __typename?: 'Mutation', orderFaxNumber?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, photoSrc?: Maybe<string>, memberships?: Maybe<Array<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string>, role?: Maybe<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }> }>>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type PatientCancelAppointmentMutationVariables = Exact<{
  cancelledAt: Scalars['DateTime'];
  apptId: Scalars['ID'];
}>;


export type PatientCancelAppointmentMutation = { __typename?: 'Mutation', patientCancelAppointment?: Maybe<{ __typename?: 'Appointment', id: string, cancelledAt?: Maybe<any> }> };

export type PlaygroundSendFaxMutationVariables = Exact<{
  faxFileUrl: Scalars['String'];
  faxNumber: Scalars['String'];
}>;


export type PlaygroundSendFaxMutation = { __typename?: 'Mutation', playgroundSendFax?: Maybe<{ __typename?: 'InboundFax', id: string, to?: Maybe<string> }> };

export type RefreshRemittancesMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type RefreshRemittancesMutation = { __typename?: 'Mutation', refreshRemittances?: Maybe<{ __typename?: 'RemittanceAdviceRequest', id: string, remittances?: Maybe<Array<{ __typename?: 'RemittanceAdvice', id: string, externalClaims?: Maybe<any>, billings?: Maybe<Array<{ __typename?: 'AppointmentBilling', id: string, status?: Maybe<AppointmentBillingStatusType>, createdAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> }> }>> }>> }> };

export type RemoveClinicMutationVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type RemoveClinicMutation = { __typename?: 'Mutation', removeClinic?: Maybe<{ __typename?: 'Clinic', id: string, createdAt?: Maybe<any>, faxNumber?: Maybe<string>, name?: Maybe<string>, phoneNumber?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }> };

export type RemoveCompanyMemberMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveCompanyMemberMutation = { __typename?: 'Mutation', removeCompanyMember?: Maybe<{ __typename?: 'CompanyMemberWithRoles', id: string, userId: string, roles: Array<string>, user: { __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> } }> };

export type RemovePatientFromCompanyMutationVariables = Exact<{
  patientId: Scalars['ID'];
  companyId: Scalars['ID'];
}>;


export type RemovePatientFromCompanyMutation = { __typename?: 'Mutation', removePatientFromCompany?: Maybe<{ __typename?: 'Patient', id: string }> };

export type ReportAdverseReactionMutationVariables = Exact<{
  medicationItemId: Scalars['ID'];
  message: Scalars['String'];
}>;


export type ReportAdverseReactionMutation = { __typename?: 'Mutation', reportAdverseReaction?: Maybe<{ __typename?: 'NotificationDispatchItem', id: string }> };

export type RescheduleAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
  rescheduledAt: Scalars['DateTime'];
}>;


export type RescheduleAppointmentMutation = { __typename?: 'Mutation', updateAppointment?: Maybe<{ __typename?: 'Appointment', id: string, rescheduledAt?: Maybe<any> }> };

export type ResendFaxMutationVariables = Exact<{
  faxId: Scalars['ID'];
}>;


export type ResendFaxMutation = { __typename?: 'Mutation', resendFax?: Maybe<{ __typename?: 'Fax', id: string, status?: Maybe<FaxStatusType> }> };

export type ResendUserInviteByDoctorMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type ResendUserInviteByDoctorMutation = { __typename?: 'Mutation', resendUserInviteByDoctor?: Maybe<{ __typename?: 'UserInvite', id: string }> };

export type ResolveInboundFaxMutationVariables = Exact<{
  inboundFaxId: Scalars['ID'];
  resolvedAt: Scalars['DateTime'];
}>;


export type ResolveInboundFaxMutation = { __typename?: 'Mutation', updateInboundFax?: Maybe<{ __typename?: 'InboundFax', id: string, resolvedAt?: Maybe<any> }> };

export type ResolveTaskMutationVariables = Exact<{
  resolvedNote?: Maybe<Scalars['String']>;
  taskId: Scalars['ID'];
}>;


export type ResolveTaskMutation = { __typename?: 'Mutation', resolveTask?: Maybe<{ __typename?: 'Task', id: string, resolvedAt?: Maybe<any>, resolvedNote?: Maybe<string>, status?: Maybe<TaskStatusType>, resolvedBy?: Maybe<{ __typename?: 'User', id: string }> }> };

export type ResolveTestOrderMutationVariables = Exact<{
  testOrderId: Scalars['ID'];
  resolvedAt: Scalars['DateTime'];
}>;


export type ResolveTestOrderMutation = { __typename?: 'Mutation', updateTestOrder?: Maybe<{ __typename?: 'TestOrder', id: string, resolvedAt?: Maybe<any> }> };

export type ResolveTestOrderByRequestMutationVariables = Exact<{
  appointmentRequestId: Scalars['ID'];
  resolvedAt: Scalars['DateTime'];
  requestedAppointmentAt: Scalars['DateTime'];
  testOrderId: Scalars['ID'];
}>;


export type ResolveTestOrderByRequestMutation = { __typename?: 'Mutation', updateTestOrder?: Maybe<{ __typename?: 'TestOrder', id: string, resolvedAt?: Maybe<any>, requestedAppointmentAt?: Maybe<any>, appointmentRequest?: Maybe<{ __typename?: 'AppointmentRequest', id: string }> }> };

export type RetrySubmissionMutationVariables = Exact<{
  billingId: Scalars['ID'];
}>;


export type RetrySubmissionMutation = { __typename?: 'Mutation', retrySubmission?: Maybe<{ __typename?: 'AppointmentBilling', id: string }> };

export type RevokeUserInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
  revokedAt: Scalars['DateTime'];
}>;


export type RevokeUserInviteMutation = { __typename?: 'Mutation', updateUserInvite?: Maybe<{ __typename?: 'UserInvite', id: string, revokedAt?: Maybe<any> }> };

export type ReSubmitMyClaimsInCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  couponId?: Maybe<Scalars['ID']>;
}>;


export type ReSubmitMyClaimsInCompanyMutation = { __typename?: 'Mutation', reSubmitMyClaimsInCompany?: Maybe<{ __typename?: 'GenericResponse', success?: Maybe<boolean> }> };

export type SaveAppointmentDraftMutationVariables = Exact<{
  appointmentDraftId: Scalars['ID'];
  data: AppointmentDraftUpdateInput;
}>;


export type SaveAppointmentDraftMutation = { __typename?: 'Mutation', updateAppointmentDraft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, lastEditedAt?: Maybe<any>, savedAt?: Maybe<any> }> };

export type SaveDoctorMutationVariables = Exact<{
  doctorId: Scalars['ID'];
  patientId: Scalars['ID'];
}>;


export type SaveDoctorMutation = { __typename?: 'Mutation', updatePatient?: Maybe<{ __typename?: 'Patient', id: string, savedDoctors?: Maybe<Array<{ __typename?: 'Doctor', id: string }>> }> };

export type SendFaxMutationVariables = Exact<{
  companyId?: Maybe<Scalars['ID']>;
  doctorId?: Maybe<Scalars['ID']>;
  existingFaxId?: Maybe<Scalars['ID']>;
  fileId?: Maybe<Scalars['ID']>;
  fromFaxNumber?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['ID']>;
  toFaxNumber: Scalars['String'];
}>;


export type SendFaxMutation = { __typename?: 'Mutation', sendFax?: Maybe<{ __typename?: 'Fax', id: string, status?: Maybe<FaxStatusType> }> };

export type SetAcceptingNewPatientsMutationVariables = Exact<{
  calendarId: Scalars['ID'];
  acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>;
}>;


export type SetAcceptingNewPatientsMutation = { __typename?: 'Mutation', updateCalendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType> }> };

export type StartAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
  startTime: Scalars['DateTime'];
}>;


export type StartAppointmentMutation = { __typename?: 'Mutation', updateAppointment?: Maybe<{ __typename?: 'Appointment', id: string, startedAt?: Maybe<any> }> };

export type StartFaxBlastMutationVariables = Exact<{
  faxBlastId: Scalars['ID'];
}>;


export type StartFaxBlastMutation = { __typename?: 'Mutation', startFaxBlast?: Maybe<{ __typename?: 'FaxBlast', id: string }> };

export type SubmitMyClaimsInCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  couponId?: Maybe<Scalars['ID']>;
}>;


export type SubmitMyClaimsInCompanyMutation = { __typename?: 'Mutation', submitMyClaimsInCompany?: Maybe<{ __typename?: 'GenericResponse', success?: Maybe<boolean> }> };

export type UnlinkTestOrderToFaxMutationVariables = Exact<{
  inboundFaxId: Scalars['ID'];
}>;


export type UnlinkTestOrderToFaxMutation = { __typename?: 'Mutation', updateInboundFax?: Maybe<{ __typename?: 'InboundFax', id: string, testOrder?: Maybe<{ __typename?: 'TestOrder', id: string }> }> };

export type UnmarkBillingMutationVariables = Exact<{
  billingId: Scalars['ID'];
}>;


export type UnmarkBillingMutation = { __typename?: 'Mutation', unmarkBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, status?: Maybe<AppointmentBillingStatusType> }> };

export type UpdateAddressMutationVariables = Exact<{
  addressId: Scalars['ID'];
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  administrativeArea?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  thoroughfare?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string> }> };

export type UpdateAppointmentMutationVariables = Exact<{
  data: AppointmentUpdateInput;
  where: AppointmentWhereUniqueInput;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', updateAppointment?: Maybe<{ __typename?: 'Appointment', id: string }> };

export type UpdateBillingClinicMutationVariables = Exact<{
  billingId: Scalars['ID'];
  clinicId: Scalars['ID'];
}>;


export type UpdateBillingClinicMutation = { __typename?: 'Mutation', updateAppointmentBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, billingClinic?: Maybe<{ __typename?: 'Clinic', id: string, ohipGroupNumber?: Maybe<string> }> }> };

export type UpdateBillingManualReviewMutationVariables = Exact<{
  billingId: Scalars['ID'];
  isManualReviewRequired?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateBillingManualReviewMutation = { __typename?: 'Mutation', updateAppointmentBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, isManualReviewRequired?: Maybe<boolean> }> };

export type UpdateCalendarDefaultScheduleMutationVariables = Exact<{
  calendarId: Scalars['ID'];
  scheduleId: Scalars['ID'];
}>;


export type UpdateCalendarDefaultScheduleMutation = { __typename?: 'Mutation', updateCalendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string }> }> };

export type UpdateChatMessageMutationVariables = Exact<{
  chatMessageId: Scalars['ID'];
  data: ChatMessageUpdateInput;
}>;


export type UpdateChatMessageMutation = { __typename?: 'Mutation', updateChatMessage?: Maybe<{ __typename?: 'ChatMessage', id: string }> };

export type UpdateClinicMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  data: ClinicUpdateInput;
}>;


export type UpdateClinicMutation = { __typename?: 'Mutation', updateClinic?: Maybe<{ __typename?: 'Clinic', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, facilityMasterNumber?: Maybe<string>, faxNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, phoneNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string>, operatingName?: Maybe<string> }> }> };

export type UpdateCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: CompanyUpdateInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: Maybe<{ __typename?: 'Company', id: string }> };

export type UpdateContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
  data: ContractUpdateInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract?: Maybe<{ __typename?: 'Contract', id: string, content?: Maybe<string>, createdAt?: Maybe<any>, effectiveFrom?: Maybe<any>, isActive?: Maybe<boolean>, lastUpdated?: Maybe<any>, name?: Maybe<string>, slug?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string }>, signedBy?: Maybe<Array<{ __typename?: 'User', id: string }>> }> };

export type UpdateContractSignatureMutationVariables = Exact<{
  contractId: Scalars['ID'];
  signedByUserId: Scalars['ID'];
}>;


export type UpdateContractSignatureMutation = { __typename?: 'Mutation', updateContract?: Maybe<{ __typename?: 'Contract', id: string, signedBy?: Maybe<Array<{ __typename?: 'User', id: string }>> }> };

export type UpdateDoctorGosGrantedMutationVariables = Exact<{
  doctorId: Scalars['ID'];
  isGoSecureGranted?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateDoctorGosGrantedMutation = { __typename?: 'Mutation', updateDoctor?: Maybe<{ __typename?: 'Doctor', id: string, isGoSecureGranted?: Maybe<boolean> }> };

export type UpdateDoctorMutationVariables = Exact<{
  contractSignedOn?: Maybe<Scalars['DateTime']>;
  doctorId: Scalars['ID'];
  doctorSince?: Maybe<Scalars['DateTime']>;
  doctorSpecialty?: Maybe<DoctorSpecialtyRelateToOneForUpdateInput>;
  doctorSubSpecialties?: Maybe<DoctorSubSpecialtyRelateToManyForUpdateInput>;
  email?: Maybe<Scalars['String']>;
  languages?: Maybe<LanguageRelateToManyForUpdateInput>;
  licenseNumber?: Maybe<Scalars['String']>;
  licenseProvider?: Maybe<Scalars['String']>;
  medicalLiabilityNumber?: Maybe<Scalars['String']>;
  medicalLiabilityProvider?: Maybe<Scalars['String']>;
  ohipPractitionerNumber?: Maybe<Scalars['String']>;
  ohipSpecialityCode?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  clinicFMN?: Maybe<Scalars['String']>;
  clinicFaxNumber?: Maybe<Scalars['String']>;
  clinicOHIPBillingCode?: Maybe<Scalars['String']>;
  clinicPhoneNumber?: Maybe<Scalars['String']>;
  clinicSLI?: Maybe<Scalars['String']>;
  signature?: Maybe<SignatureRelateToOneForUpdateInput>;
}>;


export type UpdateDoctorMutation = { __typename?: 'Mutation', updateDoctor?: Maybe<{ __typename?: 'Doctor', clinicFMN?: Maybe<string>, clinicFaxNumber?: Maybe<string>, clinicOHIPBillingCode?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, clinicSLI?: Maybe<string>, contractSignedOn?: Maybe<any>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, summary?: Maybe<string>, id: string, doctorSince?: Maybe<any>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', url: string }> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type UpdateDoctorVerifiedMutationVariables = Exact<{
  doctorId: Scalars['ID'];
  isVerified: Scalars['Boolean'];
}>;


export type UpdateDoctorVerifiedMutation = { __typename?: 'Mutation', updateDoctor?: Maybe<{ __typename?: 'Doctor', id: string, isVerified?: Maybe<boolean> }> };

export type UpdateEmergencyContactMutationVariables = Exact<{
  emergencyContactId: Scalars['ID'];
  cellPhoneNumberString: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  homePhoneNumberString: Scalars['String'];
  lastName: Scalars['String'];
  relation?: Maybe<Scalars['String']>;
}>;


export type UpdateEmergencyContactMutation = { __typename?: 'Mutation', updateEmergencyContact?: Maybe<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> };

export type UpdateEventsDurationMutationVariables = Exact<{
  durationEventsData: Array<CalendarEventUpdateArgs> | CalendarEventUpdateArgs;
}>;


export type UpdateEventsDurationMutation = { __typename?: 'Mutation', updateCalendarEvents?: Maybe<Array<Maybe<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number> }>>> };

export type UpdateEventMutationVariables = Exact<{
  address?: Maybe<AddressRelateToOneForUpdateInput>;
  companyName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  durationMins?: Maybe<Scalars['Int']>;
  eventId: Scalars['ID'];
  facilityMasterNumber?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  serviceLocationIndicator?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateCalendarEvent?: Maybe<{ __typename?: 'CalendarEvent', id: string, companyName?: Maybe<string>, description?: Maybe<string>, durationMins?: Maybe<number>, facilityMasterNumber?: Maybe<string>, isActive?: Maybe<boolean>, isAcceptingInPerson?: Maybe<boolean>, isAcceptingVirtual?: Maybe<boolean>, serviceLocationIndicator?: Maybe<string>, title?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }> };

export type UpdateFaxBlastMutationVariables = Exact<{
  faxBlastId: Scalars['ID'];
  data: FaxBlastUpdateInput;
}>;


export type UpdateFaxBlastMutation = { __typename?: 'Mutation', updateFaxBlast?: Maybe<{ __typename?: 'FaxBlast', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, title?: Maybe<string> }> };

export type UpdateFaxMutationVariables = Exact<{
  faxId: Scalars['ID'];
  data: FaxUpdateInput;
}>;


export type UpdateFaxMutation = { __typename?: 'Mutation', updateFax?: Maybe<{ __typename?: 'Fax', id: string, status?: Maybe<FaxStatusType> }> };

export type UpdateFaxRecipientMutationVariables = Exact<{
  faxRecipientId: Scalars['ID'];
  data: FaxRecipientUpdateInput;
}>;


export type UpdateFaxRecipientMutation = { __typename?: 'Mutation', updateFaxRecipient?: Maybe<{ __typename?: 'FaxRecipient', id: string }> };

export type UpdateFileMutationVariables = Exact<{
  fileId: Scalars['ID'];
  data: FileUpdateInput;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateFile?: Maybe<{ __typename?: 'File', id: string, fileName?: Maybe<string> }> };

export type UpdateFormMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  formId: Scalars['ID'];
  formFields?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['String']>;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', updateForm?: Maybe<{ __typename?: 'Form', id: string, formFields?: Maybe<any>, name?: Maybe<string>, slug?: Maybe<string> }> };

export type UpdateHealthCardMutationVariables = Exact<{
  healthCardId: Scalars['ID'];
  expiryDate: Scalars['DateTime'];
  versionCode?: Maybe<Scalars['String']>;
  insurancePolicyNumber: Scalars['String'];
}>;


export type UpdateHealthCardMutation = { __typename?: 'Mutation', updateHealthCard?: Maybe<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> };

export type UpdateMyProfileMutationVariables = Exact<{
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  cellPhoneNumberString?: Maybe<Scalars['String']>;
  homePhoneNumberString?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  photoSrc?: Maybe<Scalars['String']>;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateUser?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, sex?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, photoSrc?: Maybe<string> }> };

export type UpdatePrescriptionMutationVariables = Exact<{
  prescriptionId: Scalars['ID'];
  data: PrescriptionUpdateInput;
}>;


export type UpdatePrescriptionMutation = { __typename?: 'Mutation', updatePrescription?: Maybe<{ __typename?: 'Prescription', id: string, isSubstitutionAllowed?: Maybe<boolean>, patient?: Maybe<{ __typename?: 'Patient', id: string, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, faxString?: Maybe<string>, phoneString?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, preferredPharmacyLocation?: Maybe<{ __typename?: 'PharmacyLocation', id: string, faxString?: Maybe<string>, phoneString?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>, prescriptionItems?: Maybe<Array<{ __typename?: 'PrescriptionItem', id: string, instructions?: Maybe<string>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string> }> }>> }> };

export type UpdateScheduleIntervalMutationVariables = Exact<{
  scheduleId: Scalars['ID'];
  slotInterval: Scalars['Int'];
}>;


export type UpdateScheduleIntervalMutation = { __typename?: 'Mutation', updateSchedule?: Maybe<{ __typename?: 'Schedule', id: string }> };

export type UpdateScheduleMutationVariables = Exact<{
  scheduleId: Scalars['ID'];
  data: ScheduleUpdateInput;
}>;


export type UpdateScheduleMutation = { __typename?: 'Mutation', updateSchedule?: Maybe<{ __typename?: 'Schedule', id: string, blockedDates?: Maybe<any>, description?: Maybe<string>, futureLimit?: Maybe<string>, slotInterval?: Maybe<number>, title?: Maybe<string>, tz?: Maybe<string>, blockedTimeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string> }>>, defaultOn?: Maybe<{ __typename?: 'Calendar', id: string }> }> };

export type UpdateScheduleTimezoneMutationVariables = Exact<{
  scheduleId: Scalars['ID'];
  tz: Scalars['String'];
}>;


export type UpdateScheduleTimezoneMutation = { __typename?: 'Mutation', updateSchedule?: Maybe<{ __typename?: 'Schedule', id: string, tz?: Maybe<string> }> };

export type UpdateStepperProgMutationVariables = Exact<{
  stepperProgId: Scalars['ID'];
  companyId: Scalars['ID'];
}>;


export type UpdateStepperProgMutation = { __typename?: 'Mutation', updateStepperProg?: Maybe<{ __typename?: 'StepperProg', id: string }> };

export type UpdateTaskMutationVariables = Exact<{
  data: TaskUpdateInput;
  where: TaskWhereUniqueInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask?: Maybe<{ __typename?: 'Task', id: string }> };

export type UpdateTestsBatchMutationVariables = Exact<{
  testsBatchId: Scalars['ID'];
  data: TestsBatchUpdateInput;
}>;


export type UpdateTestsBatchMutation = { __typename?: 'Mutation', updateTestsBatch?: Maybe<{ __typename?: 'TestsBatch', id: string, name?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, formTests?: Maybe<Array<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, formType?: Maybe<{ __typename?: 'FormType', id: string, name?: Maybe<string>, slug?: Maybe<string> }> }> };

export type UpdateTimeIntervalMutationVariables = Exact<{
  timeIntervalId: Scalars['ID'];
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
}>;


export type UpdateTimeIntervalMutation = { __typename?: 'Mutation', updateTimeInterval?: Maybe<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string> }> };

export type UpdateUserAddressMutationVariables = Exact<{
  addressId: Scalars['ID'];
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  administrativeArea?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
}>;


export type UpdateUserAddressMutation = { __typename?: 'Mutation', updateAddress?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, administrativeArea?: Maybe<string>, postalCode?: Maybe<string> }> };

export type UpdateUserBirdConsentMutationVariables = Exact<{
  userId: Scalars['ID'];
  isBirdConsentObtained: Scalars['Boolean'];
}>;


export type UpdateUserBirdConsentMutation = { __typename?: 'Mutation', updateUser?: Maybe<{ __typename?: 'User', id: string, isBirdConsentObtained?: Maybe<boolean> }> };

export type UploadBlastListMutationVariables = Exact<{
  faxBlastId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type UploadBlastListMutation = { __typename?: 'Mutation', uploadBlastList?: Maybe<{ __typename?: 'FaxBlast', id: string }> };

export type UploadDataImportMutationVariables = Exact<{
  file: Scalars['Upload'];
  notes?: Maybe<Scalars['String']>;
}>;


export type UploadDataImportMutation = { __typename?: 'Mutation', uploadDataImport?: Maybe<{ __typename?: 'DataImport', id: string }> };

export type UploadMyPhotoMutationVariables = Exact<{
  image: Scalars['Upload'];
  userId: Scalars['ID'];
}>;


export type UploadMyPhotoMutation = { __typename?: 'Mutation', createProfilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> };

export type ValidateHealthCardMutationVariables = Exact<{
  healthCardId: Scalars['ID'];
}>;


export type ValidateHealthCardMutation = { __typename?: 'Mutation', validateHealthCard?: Maybe<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> };

export type AccessPatientAllergiesSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
}>;


export type AccessPatientAllergiesSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, allergies?: Maybe<Array<{ __typename?: 'AllergyItem', id: string, name?: Maybe<string>, onsetDate?: Maybe<any>, reaction?: Maybe<string> }>> }> }>> };

export type AccessPatientDocumentsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
}>;


export type AccessPatientDocumentsSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, form?: Maybe<{ __typename?: 'Form', id: string, name?: Maybe<string>, slug?: Maybe<string>, issuedAt?: Maybe<any>, formFields?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, sex?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }> }> }> }> }>> }> }>> };

export type AccessPatientHealthConditionsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
  filters?: Maybe<Array<HealthConditionWhereInput> | HealthConditionWhereInput>;
}>;


export type AccessPatientHealthConditionsSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, healthConditions?: Maybe<Array<{ __typename?: 'HealthCondition', id: string, diagnosedAt?: Maybe<any>, inactivatedAt?: Maybe<any>, name?: Maybe<string>, relation?: Maybe<string>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }>> }> }>> };

export type AccessPatientLifestyleItemsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
  filters?: Maybe<Array<LifestyleItemWhereInput> | LifestyleItemWhereInput>;
}>;


export type AccessPatientLifestyleItemsSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, lifestyleItems?: Maybe<Array<{ __typename?: 'LifestyleItem', id: string, activity?: Maybe<string>, frequency?: Maybe<string>, inactivatedAt?: Maybe<any>, item?: Maybe<string>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }>> }> }>> };

export type AccessPatientMedicationsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
  filters?: Maybe<Array<MedicationItemWhereInput> | MedicationItemWhereInput>;
}>;


export type AccessPatientMedicationsSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, medicationItems?: Maybe<Array<{ __typename?: 'MedicationItem', id: string, inactivatedAt?: Maybe<any>, instructions?: Maybe<string>, prescribedAt?: Maybe<any>, refills?: Maybe<number>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>> }> }>> };

export type AccessPatientScreeningTestsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
}>;


export type AccessPatientScreeningTestsSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, screeningTests?: Maybe<Array<{ __typename?: 'ScreeningTest', id: string, name?: Maybe<string>, testedAt?: Maybe<any> }>> }> }>> };

export type AccessPatientVaccinationsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
}>;


export type AccessPatientVaccinationsSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, vaccinations?: Maybe<Array<{ __typename?: 'Vaccination', id: string, expirationDate?: Maybe<any>, immunizedAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, drugIdentificationNumber?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>> }> }>> };

export type AccessPatientVisitsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
}>;


export type AccessPatientVisitsSearchQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, signedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }>> }> }>> };

export type AccessPatientVisitDetailsQueryVariables = Exact<{
  validDate: Scalars['DateTime'];
  tokenId: Scalars['ID'];
  appointmentId: Scalars['ID'];
}>;


export type AccessPatientVisitDetailsQuery = { __typename?: 'Query', accessTokens?: Maybe<Array<{ __typename?: 'AccessToken', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, signedAt?: Maybe<any>, reason?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }>> }> }>> };

export type AppointmentsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentOrderByInput> | AppointmentOrderByInput>;
  where?: Maybe<AppointmentWhereInput>;
}>;


export type AppointmentsQuery = { __typename?: 'Query', appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, cancelledAt?: Maybe<any>, isMissed?: Maybe<boolean>, isSigned?: Maybe<boolean>, lastDoctorActivity?: Maybe<any>, signedAt?: Maybe<any>, rescheduledAt?: Maybe<any>, draft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, lastEditedAt?: Maybe<any>, savedAt?: Maybe<any>, author?: Maybe<{ __typename?: 'User', id: string }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, startsAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type AppointmentBookingQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type AppointmentBookingQuery = { __typename?: 'Query', booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, isMissed?: Maybe<boolean>, cancelledAt?: Maybe<any>, note?: Maybe<string>, noteMdx?: Maybe<string>, reason?: Maybe<string>, isInvalidHealthCard?: Maybe<boolean>, prescription?: Maybe<{ __typename?: 'Prescription', id: string }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, phoneNumber?: Maybe<string>, faxNumber?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string> }>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, photoSrc?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }> };

export type AppointmentLastActivityQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type AppointmentLastActivityQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', id: string, lastPatientActivity?: Maybe<any>, lastDoctorActivity?: Maybe<any> }> };

export type AppointmentQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type AppointmentQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', cancelledAt?: Maybe<any>, createdAt?: Maybe<any>, startedAt?: Maybe<any>, isMissed?: Maybe<boolean>, reason?: Maybe<string>, scheduledStartsAt?: Maybe<any>, signedAt?: Maybe<any>, id: string, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, draft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, lastEditedAt?: Maybe<any>, savedAt?: Maybe<any>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, phoneNumber?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string>, operatingName?: Maybe<string> }>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, faxNumber?: Maybe<string>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string }> }> }>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, isConfirmed?: Maybe<boolean>, name?: Maybe<string>, startsAt?: Maybe<any>, tzTarget?: Maybe<string>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, prescription?: Maybe<{ __typename?: 'Prescription', id: string, isSubstitutionAllowed?: Maybe<boolean> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string }> }> };

export type AppointmentRequestQueryVariables = Exact<{
  appointmentRequestId: Scalars['ID'];
}>;


export type AppointmentRequestQuery = { __typename?: 'Query', appointmentRequest?: Maybe<{ __typename?: 'AppointmentRequest', id: string, createdAt?: Maybe<any>, reason?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, phoneNumber?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, faxNumber?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string }>, clinic?: Maybe<{ __typename?: 'Clinic', isActive?: Maybe<boolean>, id: string }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', dateOfBirth?: Maybe<any>, id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> };

export type AppointmentReviewQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type AppointmentReviewQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, isSigned?: Maybe<boolean>, startedAt?: Maybe<any>, signedAt?: Maybe<any>, reason?: Maybe<string>, billing?: Maybe<{ __typename?: 'AppointmentBilling', id: string, referringDoctorNumber?: Maybe<string>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }> }>> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, faxNumber?: Maybe<string>, phoneNumber?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string> }> }>, draft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, lastEditedAt?: Maybe<any>, savedAt?: Maybe<any>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string>, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicPhoneNumber?: Maybe<string>, clinicFaxNumber?: Maybe<string>, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, filesize: number, url: string }> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, prescription?: Maybe<{ __typename?: 'Prescription', id: string, isSubstitutionAllowed?: Maybe<boolean>, prescriptionItems?: Maybe<Array<{ __typename?: 'PrescriptionItem', id: string, instructions?: Maybe<string>, luCode?: Maybe<string>, refills?: Maybe<string>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, luReasonsCount?: Maybe<number>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }> };

export type AppointmentSessionsQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type AppointmentSessionsQuery = { __typename?: 'Query', appointmentSessions?: Maybe<Array<{ __typename?: 'AppointmentSession', id: string, duration?: Maybe<number>, endedAt?: Maybe<any>, isActive?: Maybe<boolean>, startedAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, patient?: Maybe<{ __typename?: 'Patient', id: string }> }>> };

export type AvailableTimeSlotsQueryVariables = Exact<{
  dateFromUTC: Scalars['DateTime'];
  dateToUTC: Scalars['DateTime'];
  memberId: Scalars['ID'];
  patientId: Scalars['ID'];
}>;


export type AvailableTimeSlotsQuery = { __typename?: 'Query', getAvailableTimeSlots?: Maybe<Array<Maybe<string>>> };

export type BillingsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filters?: Maybe<AppointmentBillingWhereInput>;
  status: AppointmentBillingStatusTypeNullableFilter;
  searchTerm?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['JSON']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type BillingsQuery = { __typename?: 'Query', getAppointmentBillings?: Maybe<Array<Maybe<{ __typename?: 'AppointmentBilling', id: string, isManualReviewRequired?: Maybe<boolean>, status?: Maybe<AppointmentBillingStatusType>, accountingNumber?: Maybe<string>, billingItemsCount?: Maybe<number>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, description?: Maybe<string>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string> }> }>>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, draft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> }>, submission?: Maybe<{ __typename?: 'BillingSubmission', id: string, createdAt?: Maybe<any>, amountCharged?: Maybe<number>, amountPaid?: Maybe<number>, amountSubmitted?: Maybe<number>, responseDump?: Maybe<any>, paidBy?: Maybe<{ __typename?: 'User', id: string }> }> }>>> };

export type BillingsTotalInfoQueryVariables = Exact<{
  where: AppointmentBillingWhereInput;
}>;


export type BillingsTotalInfoQuery = { __typename?: 'Query', appointmentBillings?: Maybe<Array<{ __typename?: 'AppointmentBilling', id: string, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string> }> }>>, submission?: Maybe<{ __typename?: 'BillingSubmission', id: string }> }>> };

export type BillingClaimsSearchQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type BillingClaimsSearchQuery = { __typename?: 'Query', billingClaims?: Maybe<Array<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, description?: Maybe<string>, feeCode?: Maybe<string> }>> };

export type BillingDetailsQueryVariables = Exact<{
  billingId: Scalars['ID'];
}>;


export type BillingDetailsQuery = { __typename?: 'Query', appointmentBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, isManualReviewRequired?: Maybe<boolean>, referringDoctorNumber?: Maybe<string>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string>, code?: Maybe<string>, description?: Maybe<string>, feeCode?: Maybe<string> }> }>>, billingClinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, facilityMasterNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string> }>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string>, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, facilityMasterNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, summary?: Maybe<string>, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, sex?: Maybe<string> }> }> }>, remittanceAdvice?: Maybe<{ __typename?: 'RemittanceAdvice', id: string, createdAt?: Maybe<any>, data?: Maybe<any>, resourceId?: Maybe<string>, status?: Maybe<string> }>, submission?: Maybe<{ __typename?: 'BillingSubmission', id: string, createdAt?: Maybe<any>, amountPaid?: Maybe<number>, amountSubmitted?: Maybe<number>, explanatoryItems?: Maybe<any> }> }> };

export type BillingDiagnosisSearchQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type BillingDiagnosisSearchQuery = { __typename?: 'Query', billingDiagnoses?: Maybe<Array<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string>, description?: Maybe<string> }>> };

export type BillingPremiumSearchQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type BillingPremiumSearchQuery = { __typename?: 'Query', billingPremiums?: Maybe<Array<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string>, code?: Maybe<string>, description?: Maybe<string> }>> };

export type BillingProcessingDetailsQueryVariables = Exact<{
  billingId: Scalars['ID'];
}>;


export type BillingProcessingDetailsQuery = { __typename?: 'Query', appointmentBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, isManualReviewRequired?: Maybe<boolean>, referringDoctorNumber?: Maybe<string>, status?: Maybe<AppointmentBillingStatusType>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, startedAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>> }> }>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, category?: Maybe<string>, description?: Maybe<string>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string>, code?: Maybe<string>, description?: Maybe<string>, feeCode?: Maybe<string> }> }>>, billingClinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, facilityMasterNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string> }>, submission?: Maybe<{ __typename?: 'BillingSubmission', id: string, createdAt?: Maybe<any>, amountCharged?: Maybe<number>, amountPaid?: Maybe<number>, amountSubmitted?: Maybe<number>, explanatoryItems?: Maybe<any>, responseDump?: Maybe<any>, resultCode?: Maybe<string>, resultMessage?: Maybe<string>, paidBy?: Maybe<{ __typename?: 'User', id: string }> }> }> };

export type BillingSubmissionsQueryVariables = Exact<{
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BillingSubmissionWhereInput>;
}>;


export type BillingSubmissionsQuery = { __typename?: 'Query', billingSubmissions?: Maybe<Array<{ __typename?: 'BillingSubmission', id: string, createdAt?: Maybe<any>, billing?: Maybe<{ __typename?: 'AppointmentBilling', id: string, isManualReviewRequired?: Maybe<boolean>, status?: Maybe<AppointmentBillingStatusType>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, description?: Maybe<string>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string> }> }>>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> }> }> }>> };

export type BillingWithSubmissionDetailsQueryVariables = Exact<{
  billingId: Scalars['ID'];
}>;


export type BillingWithSubmissionDetailsQuery = { __typename?: 'Query', appointmentBilling?: Maybe<{ __typename?: 'AppointmentBilling', id: string, isManualReviewRequired?: Maybe<boolean>, referringDoctorNumber?: Maybe<string>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }> }>>, billingClinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, facilityMasterNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string> }>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string>, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, facilityMasterNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, summary?: Maybe<string>, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, sex?: Maybe<string> }> }> }>, submission?: Maybe<{ __typename?: 'BillingSubmission', id: string, createdAt?: Maybe<any>, actor?: Maybe<BillingSubmissionActorType>, filename?: Maybe<string>, providerNumber?: Maybe<string>, responseDump?: Maybe<any>, sequenceNumber?: Maybe<number>, paidBy?: Maybe<{ __typename?: 'User', id: string }>, submittedBy?: Maybe<{ __typename?: 'User', id: string }>, company?: Maybe<{ __typename?: 'Company', id: string }> }> }> };

export type BookerTimeSlotsQueryVariables = Exact<{
  scheduleId: Scalars['ID'];
  wdays?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type BookerTimeSlotsQuery = { __typename?: 'Query', timeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string>, recurringSlot?: Maybe<{ __typename?: 'RecurringSlot', id: string, wday?: Maybe<string> }> }>> };

export type CalendarEventsQueryVariables = Exact<{
  calendarId: Scalars['ID'];
}>;


export type CalendarEventsQuery = { __typename?: 'Query', calendarEvents?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, companyName?: Maybe<string>, description?: Maybe<string>, durationMins?: Maybe<number>, facilityMasterNumber?: Maybe<string>, isActive?: Maybe<boolean>, serviceLocationIndicator?: Maybe<string>, title?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> };

export type ChatMessagesQueryVariables = Exact<{
  chatId: Scalars['ID'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type ChatMessagesQuery = { __typename?: 'Query', chatMessages?: Maybe<Array<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, uuid?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, replyTo?: Maybe<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type ChatQueryVariables = Exact<{
  chatId: Scalars['ID'];
}>;


export type ChatQuery = { __typename?: 'Query', chat?: Maybe<{ __typename?: 'Chat', id: string, messagesCount?: Maybe<number>, messages?: Maybe<Array<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string }>, replyTo?: Maybe<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string }> }> }>> }> };

export type CheckUserMembershipQueryVariables = Exact<{
  memberEmail: Scalars['String'];
  clinicId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  postalCode?: Maybe<Scalars['String']>;
}>;


export type CheckUserMembershipQuery = { __typename?: 'Query', checkUserMembership?: Maybe<{ __typename?: 'User', id: string, email?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, patient?: Maybe<{ __typename?: 'Patient', id: string }>, memberships?: Maybe<Array<{ __typename?: 'Member', id: string, roleAlias?: Maybe<string>, clinic?: Maybe<{ __typename?: 'Clinic', id: string }>, role?: Maybe<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }> }>> }> };

export type ClinicsMemberCalendarsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type ClinicsMemberCalendarsQuery = { __typename?: 'Query', clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }>>, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, description?: Maybe<string>, slotInterval?: Maybe<number>, title?: Maybe<string>, tz?: Maybe<string>, defaultOn?: Maybe<{ __typename?: 'Calendar', id: string }> }> }>, members?: Maybe<Array<{ __typename?: 'Member', id: string, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string>, label?: Maybe<string> }> }>>, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, blockedDates?: Maybe<any>, description?: Maybe<string>, futureLimit?: Maybe<string>, slotInterval?: Maybe<number>, title?: Maybe<string>, tz?: Maybe<string>, blockedTimeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string>, recurringSlot?: Maybe<{ __typename?: 'RecurringSlot', id: string, wday?: Maybe<string> }> }>>, defaultOn?: Maybe<{ __typename?: 'Calendar', id: string }> }> }>, user?: Maybe<{ __typename?: 'User', id: string, doctor?: Maybe<{ __typename?: 'Doctor', id: string }> }> }>> }>> };

export type ClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type ClinicQuery = { __typename?: 'Query', clinic?: Maybe<{ __typename?: 'Clinic', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, facilityMasterNumber?: Maybe<string>, faxNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, phoneNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, leaseAgreement?: Maybe<{ __typename?: 'LeaseAgreement', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }> }>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string>, operatingName?: Maybe<string> }> }> };

export type CompaniesBookingQueryVariables = Exact<{
  doctorId: Scalars['ID'];
  patientId?: Maybe<Scalars['ID']>;
  eventType: Scalars['String'];
}>;


export type CompaniesBookingQuery = { __typename?: 'Query', companies?: Maybe<Array<{ __typename?: 'Company', id: string, legalName?: Maybe<string>, logo?: Maybe<{ __typename?: 'CompanyLogo', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }>, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, name?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, members?: Maybe<Array<{ __typename?: 'Member', id: string, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }>> }> }>> }>> }>> };

export type CompaniesQueryVariables = Exact<{
  where?: Maybe<CompanyWhereInput>;
}>;


export type CompaniesQuery = { __typename?: 'Query', companies?: Maybe<Array<{ __typename?: 'Company', id: string, isOnboarded?: Maybe<boolean>, legalName?: Maybe<string>, logo?: Maybe<{ __typename?: 'CompanyLogo', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }>, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, name?: Maybe<string>, description?: Maybe<string>, isActive?: Maybe<boolean>, members?: Maybe<Array<{ __typename?: 'Member', id: string, user?: Maybe<{ __typename?: 'User', id: string, doctor?: Maybe<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string> }> }> }> }>> }>> }>> };

export type CompanyAppointmentRequestsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentRequestOrderByInput> | AppointmentRequestOrderByInput>;
  where?: Maybe<AppointmentRequestWhereInput>;
}>;


export type CompanyAppointmentRequestsQuery = { __typename?: 'Query', appointmentRequests?: Maybe<Array<{ __typename?: 'AppointmentRequest', id: string, createdAt?: Maybe<any>, reason?: Maybe<string>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, followUpTo?: Maybe<{ __typename?: 'Appointment', id: string }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type CompanyBookingQueryVariables = Exact<{
  companyId: Scalars['ID'];
  eventType: Scalars['String'];
  calendarFilter?: Maybe<Array<CalendarWhereInput> | CalendarWhereInput>;
}>;


export type CompanyBookingQuery = { __typename?: 'Query', company?: Maybe<{ __typename?: 'Company', id: string, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, name?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, members?: Maybe<Array<{ __typename?: 'Member', id: string, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }>> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>> }>> }> };

export type CompanyClinicsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type CompanyClinicsQuery = { __typename?: 'Query', company?: Maybe<{ __typename?: 'Company', id: string, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, isActive?: Maybe<boolean>, faxNumber?: Maybe<string>, name?: Maybe<string>, phoneNumber?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>> }> };

export type CompanyDoctorsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type CompanyDoctorsQuery = { __typename?: 'Query', doctors?: Maybe<Array<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, photoSrc?: Maybe<string>, memberships?: Maybe<Array<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, clinic?: Maybe<{ __typename?: 'Clinic', id: string }>, role?: Maybe<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>> };

export type CompanyDoctorMembersQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyDoctorMembersQuery = { __typename?: 'Query', users?: Maybe<Array<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, memberships?: Maybe<Array<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string>, label?: Maybe<string> }> }>>, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, blockedDates?: Maybe<any>, title?: Maybe<string>, description?: Maybe<string>, tz?: Maybe<string>, slotInterval?: Maybe<number>, blockedTimeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string>, recurringSlot?: Maybe<{ __typename?: 'RecurringSlot', id: string, wday?: Maybe<string> }> }>>, defaultOn?: Maybe<{ __typename?: 'Calendar', id: string }> }> }> }>> }>> };

export type CompanyMembersQueryVariables = Exact<{
  companyId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type CompanyMembersQuery = { __typename?: 'Query', getCompanyMembers?: Maybe<Array<Maybe<{ __typename?: 'CompanyMemberWithRoles', id: string, faxNumber?: Maybe<string>, userId: string, roles: Array<string>, user: { __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> } }>>> };

export type CompanyQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: Maybe<{ __typename?: 'Company', id: string, createdAt?: Maybe<any>, legalName?: Maybe<string>, operatingName?: Maybe<string>, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, isActive?: Maybe<boolean>, createdAt?: Maybe<any>, description?: Maybe<string>, facilityMasterNumber?: Maybe<string>, faxNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, phoneNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string>, leaseAgreement?: Maybe<{ __typename?: 'LeaseAgreement', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }> }>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, members?: Maybe<Array<{ __typename?: 'Member', id: string, roleAlias?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, name?: Maybe<string> }>, role?: Maybe<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>> }>>, logo?: Maybe<{ __typename?: 'CompanyLogo', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }>, masterLicense?: Maybe<{ __typename?: 'MasterLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }> }>, owner?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> };

export type ContractQueryVariables = Exact<{
  contractSlug: Scalars['String'];
}>;


export type ContractQuery = { __typename?: 'Query', contracts?: Maybe<Array<{ __typename?: 'Contract', id: string, effectiveFrom?: Maybe<any>, lastUpdated?: Maybe<any>, content?: Maybe<string> }>> };

export type CouponQueryVariables = Exact<{
  couponCode: Scalars['String'];
}>;


export type CouponQuery = { __typename?: 'Query', coupon?: Maybe<{ __typename?: 'Coupon', id: string, code?: Maybe<string>, isActive?: Maybe<boolean>, percentOff?: Maybe<number>, validFrom?: Maybe<any>, validTo?: Maybe<any> }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', isBirdConsentObtained?: Maybe<boolean>, membershipsCount?: Maybe<number>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type DataImportIntentsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DataImportIntentOrderByInput> | DataImportIntentOrderByInput>;
  where?: Maybe<DataImportIntentWhereInput>;
}>;


export type DataImportIntentsQuery = { __typename?: 'Query', dataImportIntents?: Maybe<Array<{ __typename?: 'DataImportIntent', id: string, createdAt?: Maybe<any>, dataImportItemsCount?: Maybe<number>, source?: Maybe<string>, status?: Maybe<DataImportIntentStatusType>, owner?: Maybe<{ __typename?: 'User', id: string }>, member?: Maybe<{ __typename?: 'Member', id: string }> }>> };

export type DataImportIntentQueryVariables = Exact<{
  dataImportIntentId: Scalars['ID'];
}>;


export type DataImportIntentQuery = { __typename?: 'Query', dataImportIntent?: Maybe<{ __typename?: 'DataImportIntent', id: string, createdAt?: Maybe<any>, dataImportItemsCount?: Maybe<number>, source?: Maybe<string>, status?: Maybe<DataImportIntentStatusType>, statusMessage?: Maybe<string>, dataImportItemsWithoutPatientCount?: Maybe<number>, dataImportItems?: Maybe<Array<{ __typename?: 'DataImportItem', id: string, createdAt?: Maybe<any>, email?: Maybe<string>, healthCardNumber?: Maybe<string>, healthCardProvince?: Maybe<string>, healthCardVersionCode?: Maybe<string>, status?: Maybe<DataImportItemStatusType>, statusMessage?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> }>>, owner?: Maybe<{ __typename?: 'User', id: string }>, member?: Maybe<{ __typename?: 'Member', id: string }> }> };

export type DataImportItemQueryVariables = Exact<{
  dataImportItemId: Scalars['ID'];
}>;


export type DataImportItemQuery = { __typename?: 'Query', dataImportItem?: Maybe<{ __typename?: 'DataImportItem', id: string, createdAt?: Maybe<any>, email?: Maybe<string>, healthCardNumber?: Maybe<string>, healthCardProvince?: Maybe<string>, healthCardVersionCode?: Maybe<string>, key?: Maybe<string>, status?: Maybe<DataImportItemStatusType>, statusMessage?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> }> };

export type DoctorsForNewPatientsQueryVariables = Exact<{
  eventType?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
  calendarFilter?: Maybe<Array<CalendarWhereInput> | CalendarWhereInput>;
}>;


export type DoctorsForNewPatientsQuery = { __typename?: 'Query', doctors?: Maybe<Array<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>> };

export type DoctorsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DoctorWhereInput>;
  orderBy?: Maybe<Array<DoctorOrderByInput> | DoctorOrderByInput>;
}>;


export type DoctorsQuery = { __typename?: 'Query', doctors?: Maybe<Array<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>> };

export type DoctorBasicInfoQueryVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type DoctorBasicInfoQuery = { __typename?: 'Query', doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type DoctorCalendarsQueryVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type DoctorCalendarsQuery = { __typename?: 'Query', calendars?: Maybe<Array<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, description?: Maybe<string>, tz?: Maybe<string>, title?: Maybe<string> }>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number> }>>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, description?: Maybe<string>, tz?: Maybe<string>, title?: Maybe<string> }>>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }> }>> };

export type DoctorPageQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type DoctorPageQuery = { __typename?: 'Query', doctors?: Maybe<Array<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>> };

export type DoctorProfileQueryVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type DoctorProfileQuery = { __typename?: 'Query', doctor?: Maybe<{ __typename?: 'Doctor', contractSignedOn?: Maybe<any>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, summary?: Maybe<string>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, proofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, mimetype?: Maybe<string>, originalFilename?: Maybe<string>, publicUrl?: Maybe<string> }> }>, proofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, mimetype?: Maybe<string>, originalFilename?: Maybe<string>, publicUrl?: Maybe<string> }> }>, proofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, mimetype?: Maybe<string>, originalFilename?: Maybe<string>, publicUrl?: Maybe<string> }> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', url: string }> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type DoctorQueryVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type DoctorQuery = { __typename?: 'Query', doctor?: Maybe<{ __typename?: 'Doctor', id: string, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, user?: Maybe<{ __typename?: 'User', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> };

export type DoctorSpecialtiesQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type DoctorSpecialtiesQuery = { __typename?: 'Query', doctorSpecialties?: Maybe<Array<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>> };

export type DoctorSubSpecialtiesQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type DoctorSubSpecialtiesQuery = { __typename?: 'Query', doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>> };

export type DoctorAppointmentFormsQueryVariables = Exact<{
  apptId: Scalars['ID'];
}>;


export type DoctorAppointmentFormsQuery = { __typename?: 'Query', forms?: Maybe<Array<{ __typename?: 'Form', id: string, name?: Maybe<string>, slug?: Maybe<string>, issuedAt?: Maybe<any>, formFields?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, faxNumber?: Maybe<string>, phoneNumber?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, formType?: Maybe<{ __typename?: 'FormType', id: string, name?: Maybe<string>, slug?: Maybe<string> }> }>> };

export type DoctorAppointmentNoteQueryVariables = Exact<{
  noteId: Scalars['ID'];
}>;


export type DoctorAppointmentNoteQuery = { __typename?: 'Query', appointmentNote?: Maybe<{ __typename?: 'AppointmentNote', id: string, summary?: Maybe<string>, title?: Maybe<string> }> };

export type DoctorAppointmentRoomQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type DoctorAppointmentRoomQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', id: string, isMissed?: Maybe<boolean>, isInvalidHealthCard?: Maybe<boolean>, note?: Maybe<string>, noteMdx?: Maybe<string>, reason?: Maybe<string>, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, draft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, lastEditedAt?: Maybe<any>, savedAt?: Maybe<any>, author?: Maybe<{ __typename?: 'User', id: string }> }>, chat?: Maybe<{ __typename?: 'Chat', id: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, photoSrc?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, prescription?: Maybe<{ __typename?: 'Prescription', id: string, isSubstitutionAllowed?: Maybe<boolean> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string }>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, startsAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, photoSrc?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }> }> };

export type DoctorAppointmentVitalsQueryVariables = Exact<{
  vitalsDataId: Scalars['ID'];
}>;


export type DoctorAppointmentVitalsQuery = { __typename?: 'Query', appointmentVital?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> };

export type DoctorDashboardQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type DoctorDashboardQuery = { __typename?: 'Query', appointmentRequests?: Maybe<Array<{ __typename?: 'AppointmentRequest', id: string }>>, appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string }>>, userInvites?: Maybe<Array<{ __typename?: 'UserInvite', id: string }>>, patients?: Maybe<Array<{ __typename?: 'Patient', id: string }>> };

export type DoctorRoomStepsQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type DoctorRoomStepsQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, billing?: Maybe<{ __typename?: 'AppointmentBilling', id: string, referringDoctorNumber?: Maybe<string>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, description?: Maybe<string>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string>, description?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string>, code?: Maybe<string>, feeCode?: Maybe<string>, description?: Maybe<string> }> }>> }>, prescription?: Maybe<{ __typename?: 'Prescription', id: string, isSubstitutionAllowed?: Maybe<boolean>, patient?: Maybe<{ __typename?: 'Patient', id: string, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, faxString?: Maybe<string>, phoneString?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, preferredPharmacyLocation?: Maybe<{ __typename?: 'PharmacyLocation', id: string, faxString?: Maybe<string>, phoneString?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>, prescriptionItems?: Maybe<Array<{ __typename?: 'PrescriptionItem', id: string, instructions?: Maybe<string>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string> }> }>> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }> };

export type DoctorRoomVisitsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type DoctorRoomVisitsQuery = { __typename?: 'Query', appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, createdAt?: Maybe<any>, note?: Maybe<string>, noteMdx?: Maybe<string>, signedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }>> };

export type DoctorRoomVisitDetailsQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type DoctorRoomVisitDetailsQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, signedAt?: Maybe<any>, reason?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }> };

export type EventQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type EventQuery = { __typename?: 'Query', calendarEvent?: Maybe<{ __typename?: 'CalendarEvent', id: string, companyName?: Maybe<string>, description?: Maybe<string>, durationMins?: Maybe<number>, facilityMasterNumber?: Maybe<string>, isActive?: Maybe<boolean>, serviceLocationIndicator?: Maybe<string>, title?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }>>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> };

export type ExploreEventDetailsQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type ExploreEventDetailsQuery = { __typename?: 'Query', calendarEvent?: Maybe<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string>, slotInterval?: Maybe<number>, tz?: Maybe<string> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, clinic?: Maybe<{ __typename?: 'Clinic', id: string }>, user?: Maybe<{ __typename?: 'User', id: string, doctor?: Maybe<{ __typename?: 'Doctor', contractSignedOn?: Maybe<any>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, summary?: Maybe<string>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', contractSignedOn?: Maybe<any>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, summary?: Maybe<string>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> };

export type FaxesQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<FaxOrderByInput> | FaxOrderByInput>;
  where?: Maybe<FaxWhereInput>;
}>;


export type FaxesQuery = { __typename?: 'Query', faxes?: Maybe<Array<{ __typename?: 'Fax', id: string, createdAt?: Maybe<any>, status?: Maybe<FaxStatusType>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, replyTo?: Maybe<{ __typename?: 'InboundFax', id: string }> }>> };

export type FaxBlastQueryVariables = Exact<{
  where: FaxBlastWhereUniqueInput;
  faxBlastId: Scalars['ID'];
}>;


export type FaxBlastQuery = { __typename?: 'Query', faxBlast?: Maybe<{ __typename?: 'FaxBlast', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, title?: Maybe<string>, faxBlastItemsCount?: Maybe<number>, faxBlastItemsFaxSuccessCount?: Maybe<number>, faxBlastItemsFaxProcessingCount?: Maybe<number>, faxBlastItemsFaxFailedCount?: Maybe<number>, faxBlastItemsFaxQueuedCount?: Maybe<number>, author?: Maybe<{ __typename?: 'User', id: string }>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }> }> };

export type FaxQueryVariables = Exact<{
  faxId: Scalars['ID'];
}>;


export type FaxQuery = { __typename?: 'Query', fax?: Maybe<{ __typename?: 'Fax', id: string, createdAt?: Maybe<any>, status?: Maybe<FaxStatusType>, to?: Maybe<string>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, pharmacyLocation?: Maybe<{ __typename?: 'PharmacyLocation', id: string, faxString?: Maybe<string>, phoneString?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>, replyTo?: Maybe<{ __typename?: 'InboundFax', id: string }> }> };

export type FilterDoctorsByEventQueryVariables = Exact<{
  eventType?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
  patientId: Scalars['ID'];
}>;


export type FilterDoctorsByEventQuery = { __typename?: 'Query', doctors?: Maybe<Array<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, tz?: Maybe<string> }> }>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>> };

export type FormQueryVariables = Exact<{
  formId: Scalars['ID'];
  doctorId: Scalars['ID'];
}>;


export type FormQuery = { __typename?: 'Query', form?: Maybe<{ __typename?: 'Form', id: string, formFields?: Maybe<any>, issuedAt?: Maybe<any>, name?: Maybe<string>, slug?: Maybe<string>, formType?: Maybe<{ __typename?: 'FormType', id: string, name?: Maybe<string>, slug?: Maybe<string>, testsBatches?: Maybe<Array<{ __typename?: 'TestsBatch', id: string, name?: Maybe<string>, formTests?: Maybe<Array<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>> }> }> };

export type FormTestsQueryVariables = Exact<{
  formTypeSlug: Scalars['String'];
}>;


export type FormTestsQuery = { __typename?: 'Query', formTests?: Maybe<Array<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, testFor?: Maybe<string>, value?: Maybe<string> }>> };

export type FormTypesQueryVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type FormTypesQuery = { __typename?: 'Query', formTypes?: Maybe<Array<{ __typename?: 'FormType', id: string, isActive?: Maybe<boolean>, name?: Maybe<string>, slug?: Maybe<string>, testsBatches?: Maybe<Array<{ __typename?: 'TestsBatch', id: string, name?: Maybe<string> }>> }>> };

export type FormTypeQueryVariables = Exact<{
  formTypeSlug: Scalars['String'];
  doctorId: Scalars['ID'];
}>;


export type FormTypeQuery = { __typename?: 'Query', formType?: Maybe<{ __typename?: 'FormType', id: string, isActive?: Maybe<boolean>, name?: Maybe<string>, slug?: Maybe<string>, forms?: Maybe<Array<{ __typename?: 'Form', id: string, name?: Maybe<string>, slug?: Maybe<string> }>>, testsBatches?: Maybe<Array<{ __typename?: 'TestsBatch', id: string, name?: Maybe<string>, formTests?: Maybe<Array<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>> }> };

export type HealthCardsQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type HealthCardsQuery = { __typename?: 'Query', healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>> };

export type HealthCardQueryVariables = Exact<{
  healthCardId: Scalars['ID'];
}>;


export type HealthCardQuery = { __typename?: 'Query', healthCard?: Maybe<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> };

export type InboundFaxesQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InboundFaxOrderByInput> | InboundFaxOrderByInput>;
  where?: Maybe<InboundFaxWhereInput>;
}>;


export type InboundFaxesQuery = { __typename?: 'Query', inboundFaxes?: Maybe<Array<{ __typename?: 'InboundFax', id: string, receivedAt?: Maybe<any>, resolvedAt?: Maybe<any>, reviewedAt?: Maybe<any>, status?: Maybe<InboundFaxStatusType>, member?: Maybe<{ __typename?: 'Member', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type InboundFaxQueryVariables = Exact<{
  inboundFaxId: Scalars['ID'];
}>;


export type InboundFaxQuery = { __typename?: 'Query', inboundFax?: Maybe<{ __typename?: 'InboundFax', id: string, from?: Maybe<string>, receivedAt?: Maybe<any>, resolvedAt?: Maybe<any>, reviewedAt?: Maybe<any>, status?: Maybe<InboundFaxStatusType>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, member?: Maybe<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, phoneNumber?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, testOrder?: Maybe<{ __typename?: 'TestOrder', id: string, slug?: Maybe<string>, orderedAt?: Maybe<any>, data?: Maybe<any> }> }> };

export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = { __typename?: 'Query', languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> };

export type LatestRemittanceAdviceRequestQueryVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type LatestRemittanceAdviceRequestQuery = { __typename?: 'Query', remittanceAdviceRequests?: Maybe<Array<{ __typename?: 'RemittanceAdviceRequest', id: string, createdAt?: Maybe<any> }>> };

export type LuReasonsSearchQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  medicationId: Scalars['ID'];
}>;


export type LuReasonsSearchQuery = { __typename?: 'Query', luReasons?: Maybe<Array<{ __typename?: 'LuReason', id: string, code?: Maybe<string>, clinicalCriteria?: Maybe<string>, authorizationPeriod?: Maybe<string>, medication?: Maybe<{ __typename?: 'Medication', id: string }> }>> };

export type ManagedCompaniesQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ManagedCompaniesQuery = { __typename?: 'Query', companies?: Maybe<Array<{ __typename?: 'Company', id: string, isOnboarded?: Maybe<boolean>, legalName?: Maybe<string>, logo?: Maybe<{ __typename?: 'CompanyLogo', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>> };

export type ManageAppointmentsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentOrderByInput> | AppointmentOrderByInput>;
  where?: Maybe<AppointmentWhereInput>;
}>;


export type ManageAppointmentsQuery = { __typename?: 'Query', appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, cancelledAt?: Maybe<any>, isMissed?: Maybe<boolean>, isSigned?: Maybe<boolean>, signedAt?: Maybe<any>, rescheduledAt?: Maybe<any>, draft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, lastEditedAt?: Maybe<any>, savedAt?: Maybe<any>, author?: Maybe<{ __typename?: 'User', id: string }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, startsAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type ManageAppointmentQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type ManageAppointmentQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', cancelledAt?: Maybe<any>, createdAt?: Maybe<any>, startedAt?: Maybe<any>, isMissed?: Maybe<boolean>, reason?: Maybe<string>, scheduledStartsAt?: Maybe<any>, signedAt?: Maybe<any>, id: string, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, draft?: Maybe<{ __typename?: 'AppointmentDraft', id: string, createdAt?: Maybe<any>, lastEditedAt?: Maybe<any>, savedAt?: Maybe<any>, author?: Maybe<{ __typename?: 'User', id: string }> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, phoneNumber?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string>, operatingName?: Maybe<string> }>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string }> }> }>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, isConfirmed?: Maybe<boolean>, name?: Maybe<string>, startsAt?: Maybe<any>, tzTarget?: Maybe<string>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, prescription?: Maybe<{ __typename?: 'Prescription', id: string, isSubstitutionAllowed?: Maybe<boolean> }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string }> }> };

export type ManageContractsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type ManageContractsQuery = { __typename?: 'Query', contracts?: Maybe<Array<{ __typename?: 'Contract', id: string, content?: Maybe<string>, createdAt?: Maybe<any>, effectiveFrom?: Maybe<any>, isActive?: Maybe<boolean>, lastUpdated?: Maybe<any>, name?: Maybe<string>, slug?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string }>, signedBy?: Maybe<Array<{ __typename?: 'User', id: string }>> }>> };

export type ManageCouponsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type ManageCouponsQuery = { __typename?: 'Query', coupons?: Maybe<Array<{ __typename?: 'Coupon', id: string, centsOff?: Maybe<number>, code?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, percentOff?: Maybe<number>, validFrom?: Maybe<any>, validTo?: Maybe<any> }>> };

export type ManageCouponQueryVariables = Exact<{
  couponId: Scalars['ID'];
}>;


export type ManageCouponQuery = { __typename?: 'Query', coupon?: Maybe<{ __typename?: 'Coupon', id: string, centsOff?: Maybe<number>, code?: Maybe<string>, isActive?: Maybe<boolean>, percentOff?: Maybe<number>, validFrom?: Maybe<any>, validTo?: Maybe<any> }> };

export type ManageDoctorsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type ManageDoctorsQuery = { __typename?: 'Query', doctorsCount?: Maybe<number>, doctors?: Maybe<Array<{ __typename?: 'Doctor', isVerified?: Maybe<boolean>, isCompleteProfile?: Maybe<boolean>, isGoSecureGranted?: Maybe<boolean>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, calendarEvents?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, isOnboardedDoctor?: Maybe<boolean>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> };

export type ManageDoctorQueryVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type ManageDoctorQuery = { __typename?: 'Query', doctor?: Maybe<{ __typename?: 'Doctor', isCompleteProfile?: Maybe<boolean>, isGoSecureGranted?: Maybe<boolean>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, calendarEvents?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', isOnboardedDoctor?: Maybe<boolean>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, proofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrl?: Maybe<string>, publicUrlTransformed?: Maybe<string>, originalFilename?: Maybe<string>, mimetype?: Maybe<string> }> }>, proofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrl?: Maybe<string>, publicUrlTransformed?: Maybe<string>, originalFilename?: Maybe<string>, mimetype?: Maybe<string> }> }>, proofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrl?: Maybe<string>, publicUrlTransformed?: Maybe<string>, originalFilename?: Maybe<string>, mimetype?: Maybe<string> }> }> }> };

export type ManageFaxBlastsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type ManageFaxBlastsQuery = { __typename?: 'Query', faxBlasts?: Maybe<Array<{ __typename?: 'FaxBlast', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, title?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string }> }>> };

export type ManageFaxRecipientsQueryVariables = Exact<{
  orderBy?: Maybe<Array<FaxRecipientOrderByInput> | FaxRecipientOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FaxRecipientWhereInput>;
}>;


export type ManageFaxRecipientsQuery = { __typename?: 'Query', faxRecipients?: Maybe<Array<{ __typename?: 'FaxRecipient', id: string, cpsoId?: Maybe<string>, faxNumber?: Maybe<string>, firstName?: Maybe<string>, isUnsubscribed?: Maybe<boolean>, lastName?: Maybe<string> }>> };

export type ManageFaxRecipientQueryVariables = Exact<{
  faxRecipientId: Scalars['ID'];
}>;


export type ManageFaxRecipientQuery = { __typename?: 'Query', faxRecipient?: Maybe<{ __typename?: 'FaxRecipient', id: string, createdAt?: Maybe<any>, cpsoId?: Maybe<string>, faxNumber?: Maybe<string>, firstName?: Maybe<string>, isUnsubscribed?: Maybe<boolean>, lastName?: Maybe<string>, metadata?: Maybe<any>, unsubscribedAt?: Maybe<any>, faxBlastItems?: Maybe<Array<{ __typename?: 'FaxBlastItem', id: string }>> }> };

export type ManagePatientsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type ManagePatientsQuery = { __typename?: 'Query', patients?: Maybe<Array<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, documents?: Maybe<Array<{ __typename?: 'Document', id: string }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>> };

export type ManagePatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type ManagePatientQuery = { __typename?: 'Query', patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, documents?: Maybe<Array<{ __typename?: 'Document', id: string, title?: Maybe<string>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', url: string }>, file?: Maybe<{ __typename?: 'File', createdAt?: Maybe<any>, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }> }>>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type ManagePharmaciesQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type ManagePharmaciesQuery = { __typename?: 'Query', pharmacies?: Maybe<Array<{ __typename?: 'Pharmacy', id: string, createdAt?: Maybe<any>, companyName?: Maybe<string>, locationsCount?: Maybe<number> }>> };

export type ManagePharmacyQueryVariables = Exact<{
  pharmacyId: Scalars['ID'];
}>;


export type ManagePharmacyQuery = { __typename?: 'Query', pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, createdAt?: Maybe<any>, companyName?: Maybe<string>, locations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, accreditationNumber?: Maybe<string>, faxString?: Maybe<string>, phoneString?: Maybe<string>, status?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }> }>> }> };

export type ManageUsersQueryVariables = Exact<{
  orderBy?: Maybe<Array<UserOrderByInput> | UserOrderByInput>;
  searchTerm?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type ManageUsersQuery = { __typename?: 'Query', users?: Maybe<Array<{ __typename?: 'User', createdAt?: Maybe<any>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>> };

export type ManageUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ManageUserQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', createdAt?: Maybe<any>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type MedicationsSearchQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MedicationsSearchQuery = { __typename?: 'Query', medications?: Maybe<Array<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, drugIdentificationNumber?: Maybe<string>, luReasonsCount?: Maybe<number>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }>> };

export type MemberCalendarQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type MemberCalendarQuery = { __typename?: 'Query', member?: Maybe<{ __typename?: 'Member', id: string, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string>, label?: Maybe<string> }> }>>, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, blockedDates?: Maybe<any>, description?: Maybe<string>, futureLimit?: Maybe<string>, slotInterval?: Maybe<number>, title?: Maybe<string>, tz?: Maybe<string>, blockedTimeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string>, recurringSlot?: Maybe<{ __typename?: 'RecurringSlot', id: string, wday?: Maybe<string> }> }>>, defaultOn?: Maybe<{ __typename?: 'Calendar', id: string }> }> }>, user?: Maybe<{ __typename?: 'User', id: string, doctor?: Maybe<{ __typename?: 'Doctor', id: string }> }> }> };

export type MemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type MemberQuery = { __typename?: 'Query', member?: Maybe<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, phoneNumber?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string> }> }> }>, role?: Maybe<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }> }> };

export type MemberUserProfileQueryVariables = Exact<{
  userId: Scalars['ID'];
  companyId: Scalars['ID'];
}>;


export type MemberUserProfileQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, photoSrc?: Maybe<string>, memberships?: Maybe<Array<{ __typename?: 'Member', id: string, faxNumber?: Maybe<string>, role?: Maybe<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }> }>>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type MyAppointmentRequestsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyAppointmentRequestsQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, appointmentRequests?: Maybe<Array<{ __typename?: 'AppointmentRequest', id: string, createdAt?: Maybe<any>, reason?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, appointmentRequests?: Maybe<Array<{ __typename?: 'AppointmentRequest', id: string, createdAt?: Maybe<any>, reason?: Maybe<string>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> }> }> };

export type MyCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCompaniesQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, companies?: Maybe<Array<{ __typename?: 'Company', id: string, createdAt?: Maybe<any>, legalName?: Maybe<string>, operatingName?: Maybe<string>, clinics?: Maybe<Array<{ __typename?: 'Clinic', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, facilityMasterNumber?: Maybe<string>, faxNumber?: Maybe<string>, name?: Maybe<string>, ohipGroupNumber?: Maybe<string>, phoneNumber?: Maybe<string>, serviceLocationIndicator?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, members?: Maybe<Array<{ __typename?: 'Member', id: string, roleAlias?: Maybe<string>, role?: Maybe<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>, user?: Maybe<{ __typename?: 'User', id: string }> }>> }>>, owner?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>> }> };

export type MyDoctorApptsMissedQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
}>;


export type MyDoctorApptsMissedQuery = { __typename?: 'Query', appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, cancelledAt?: Maybe<any>, isMissed?: Maybe<boolean>, rescheduledAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, startsAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type MyDoctorApptsSignedQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
}>;


export type MyDoctorApptsSignedQuery = { __typename?: 'Query', appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, isSigned?: Maybe<boolean>, signedAt?: Maybe<any>, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, startsAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, member?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type MyDoctorFaxesFailedQueryVariables = Exact<{
  companyId: Scalars['ID'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyDoctorFaxesFailedQuery = { __typename?: 'Query', faxes?: Maybe<Array<{ __typename?: 'Fax', id: string, createdAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type MyDoctorFaxesProcessingQueryVariables = Exact<{
  companyId: Scalars['ID'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyDoctorFaxesProcessingQuery = { __typename?: 'Query', faxes?: Maybe<Array<{ __typename?: 'Fax', id: string, createdAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type MyDoctorFaxesSuccessfulQueryVariables = Exact<{
  companyId: Scalars['ID'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyDoctorFaxesSuccessfulQuery = { __typename?: 'Query', faxes?: Maybe<Array<{ __typename?: 'Fax', id: string, createdAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type MyEmergencyContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEmergencyContactsQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }>> }> }> };

export type MyHealthCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyHealthCardsQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>> }> }> };

export type MyMedicalHistoryQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type MyMedicalHistoryQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, allergies?: Maybe<Array<{ __typename?: 'AllergyItem', id: string, name?: Maybe<string>, onsetDate?: Maybe<any>, reaction?: Maybe<string> }>>, appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, signedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }>>, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, form?: Maybe<{ __typename?: 'Form', id: string, name?: Maybe<string>, slug?: Maybe<string>, issuedAt?: Maybe<any>, formFields?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> }>>, healthConditions?: Maybe<Array<{ __typename?: 'HealthCondition', id: string, diagnosedAt?: Maybe<any>, name?: Maybe<string>, relation?: Maybe<string> }>>, lifestyleItems?: Maybe<Array<{ __typename?: 'LifestyleItem', id: string, activity?: Maybe<string>, frequency?: Maybe<string>, item?: Maybe<string> }>>, screeningTests?: Maybe<Array<{ __typename?: 'ScreeningTest', id: string, name?: Maybe<string>, testedAt?: Maybe<any> }>>, medicationItems?: Maybe<Array<{ __typename?: 'MedicationItem', id: string, instructions?: Maybe<string>, prescribedAt?: Maybe<any>, refills?: Maybe<number>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>>, vaccinations?: Maybe<Array<{ __typename?: 'Vaccination', id: string, expirationDate?: Maybe<any>, immunizedAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, drugIdentificationNumber?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, username?: Maybe<string> }> }> }> };

export type MyMissedPatientBookingsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyMissedPatientBookingsQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, cancelledAt?: Maybe<any>, isMissed?: Maybe<boolean>, rescheduledAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, startsAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> }>> }> }> };

export type MyPatientsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
}>;


export type MyPatientsQuery = { __typename?: 'Query', patients?: Maybe<Array<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, companies?: Maybe<Array<{ __typename?: 'Company', id: string }>> }>> };

export type MyPatientAllergiesSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyPatientAllergiesSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, allergies?: Maybe<Array<{ __typename?: 'AllergyItem', id: string, name?: Maybe<string>, onsetDate?: Maybe<any>, reaction?: Maybe<string> }>> }> }> };

export type MyPatientBookingsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  startsAt?: Maybe<DateTimeNullableFilter>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyPatientBookingsQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, bookings?: Maybe<Array<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, title?: Maybe<string>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>> }> }> };

export type MyPatientDocumentsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyPatientDocumentsSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, form?: Maybe<{ __typename?: 'Form', id: string, name?: Maybe<string>, slug?: Maybe<string>, issuedAt?: Maybe<any>, formFields?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string>, sex?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }> }> }> }> }>> }> }> };

export type MyPatientHealthConditionsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<HealthConditionWhereInput> | HealthConditionWhereInput>;
}>;


export type MyPatientHealthConditionsSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, healthConditions?: Maybe<Array<{ __typename?: 'HealthCondition', id: string, diagnosedAt?: Maybe<any>, inactivatedAt?: Maybe<any>, name?: Maybe<string>, relation?: Maybe<string>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }>> }> }> };

export type MyPatientLifestyleItemsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<LifestyleItemWhereInput> | LifestyleItemWhereInput>;
}>;


export type MyPatientLifestyleItemsSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, lifestyleItems?: Maybe<Array<{ __typename?: 'LifestyleItem', id: string, activity?: Maybe<string>, frequency?: Maybe<string>, inactivatedAt?: Maybe<any>, item?: Maybe<string>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }>> }> }> };

export type MyPatientMedicationsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<MedicationItemWhereInput> | MedicationItemWhereInput>;
}>;


export type MyPatientMedicationsSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, medicationItems?: Maybe<Array<{ __typename?: 'MedicationItem', id: string, inactivatedAt?: Maybe<any>, instructions?: Maybe<string>, prescribedAt?: Maybe<any>, refills?: Maybe<number>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>> }> }> };

export type MyPatientScreeningTestsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyPatientScreeningTestsSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, screeningTests?: Maybe<Array<{ __typename?: 'ScreeningTest', id: string, name?: Maybe<string>, testedAt?: Maybe<any> }>> }> }> };

export type MyPatientSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPatientSettingsQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, proofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string>, mimetype?: Maybe<string> }> }>, proofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string>, mimetype?: Maybe<string> }> }>, proofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string>, mimetype?: Maybe<string> }> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', url: string }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>>, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string>, country?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type MyPatientVaccinationsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyPatientVaccinationsSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, vaccinations?: Maybe<Array<{ __typename?: 'Vaccination', id: string, expirationDate?: Maybe<any>, immunizedAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, drugIdentificationNumber?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>> }> }> };

export type MyPatientVisitsSearchQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type MyPatientVisitsSearchQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string, appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, signedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }>> }> }> };

export type MyProfileSettingsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type MyProfileSettingsQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', contractSignedOn?: Maybe<any>, doctorSince?: Maybe<any>, ohipPractitionerNumber?: Maybe<string>, ohipSpecialityCode?: Maybe<string>, email?: Maybe<string>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, province?: Maybe<string>, summary?: Maybe<string>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, proofOfIdentification?: Maybe<{ __typename?: 'ProofOfIdentification', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, mimetype?: Maybe<string>, originalFilename?: Maybe<string>, publicUrl?: Maybe<string> }> }>, proofOfInsurance?: Maybe<{ __typename?: 'ProofOfInsurance', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, mimetype?: Maybe<string>, originalFilename?: Maybe<string>, publicUrl?: Maybe<string> }> }>, proofOfLicense?: Maybe<{ __typename?: 'ProofOfLicense', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, mimetype?: Maybe<string>, originalFilename?: Maybe<string>, publicUrl?: Maybe<string> }> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', url: string }> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, relation?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, savedDoctors?: Maybe<Array<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', firstName?: Maybe<string>, lastName?: Maybe<string>, id: string, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type MyStepperProgQueryVariables = Exact<{
  stepperSlug?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
}>;


export type MyStepperProgQuery = { __typename?: 'Query', steppers?: Maybe<Array<{ __typename?: 'Stepper', id: string, stepsOrderBySlugs?: Maybe<string>, eyebrow?: Maybe<string>, title?: Maybe<string>, stepperSteps?: Maybe<Array<{ __typename?: 'StepperStep', id: string, component?: Maybe<string>, description?: Maybe<string>, isFinal?: Maybe<boolean>, isOptional?: Maybe<boolean>, label?: Maybe<string>, order?: Maybe<number>, slug?: Maybe<string>, title?: Maybe<string> }>>, stepperProgs?: Maybe<Array<{ __typename?: 'StepperProg', id: string, stepperStepProgs?: Maybe<Array<{ __typename?: 'StepperStepProg', id: string, percentDone?: Maybe<number>, isCompleted?: Maybe<boolean>, stepperStep?: Maybe<{ __typename?: 'StepperStep', id: string, slug?: Maybe<string>, component?: Maybe<string> }> }>>, company?: Maybe<{ __typename?: 'Company', id: string }>, user?: Maybe<{ __typename?: 'User', id: string }> }>> }>> };

export type MyUserInvitesQueryVariables = Exact<{
  companyId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type MyUserInvitesQuery = { __typename?: 'Query', userInvites?: Maybe<Array<{ __typename?: 'UserInvite', id: string, createdAt?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, revokedAt?: Maybe<any>, healthCard?: Maybe<{ __typename?: 'HealthCard', id: string, insurancePolicyNumber?: Maybe<string>, versionCode?: Maybe<string>, expiryDate?: Maybe<any> }>, signedUpUser?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string }> }> }>> };

export type PatientsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PatientWhereInput>;
  orderBy?: Maybe<Array<PatientOrderByInput> | PatientOrderByInput>;
}>;


export type PatientsQuery = { __typename?: 'Query', patients?: Maybe<Array<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, companies?: Maybe<Array<{ __typename?: 'Company', id: string }>> }>> };

export type PatientAppointmentRoomQueryVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type PatientAppointmentRoomQuery = { __typename?: 'Query', appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string>, chat?: Maybe<{ __typename?: 'Chat', id: string }>, booking?: Maybe<{ __typename?: 'Booking', id: string, durationMins?: Maybe<number>, endsAt?: Maybe<any>, startsAt?: Maybe<any>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, photoSrc?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> };

export type PatientByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type PatientByEmailQuery = { __typename?: 'Query', patients?: Maybe<Array<{ __typename?: 'Patient', id: string }>> };

export type PatientDashboardQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  startsAt: DateTimeNullableFilter;
}>;


export type PatientDashboardQuery = { __typename?: 'Query', authenticatedItem?: Maybe<{ __typename?: 'User', id: string, photoSrc?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, userInvites?: Maybe<Array<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }>> }>, bookings?: Maybe<Array<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string> }>, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, caredByDoctors?: Maybe<Array<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, appointmentRequests?: Maybe<Array<{ __typename?: 'AppointmentRequest', id: string }>> }> }>> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type PatientDashboardStatsQueryVariables = Exact<{
  patientId: Scalars['ID'];
  startsAt: DateTimeNullableFilter;
}>;


export type PatientDashboardStatsQuery = { __typename?: 'Query', bookingsCount?: Maybe<number>, appointmentsCount?: Maybe<number>, appointmentRequestsCount?: Maybe<number>, doctorsCount?: Maybe<number> };

export type PatientDoctorQueryVariables = Exact<{
  doctorId: Scalars['ID'];
  patientId: Scalars['ID'];
  eventType: Scalars['String'];
}>;


export type PatientDoctorQuery = { __typename?: 'Query', doctor?: Maybe<{ __typename?: 'Doctor', isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, doctorSince?: Maybe<any>, summary?: Maybe<string>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>, schedules?: Maybe<Array<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string> }>> }>, calendarEvents?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, username?: Maybe<string>, id: string, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string>, middleName?: Maybe<string>, photoSrc?: Maybe<string>, memberships?: Maybe<Array<{ __typename?: 'Member', id: string, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, company?: Maybe<{ __typename?: 'Company', id: string, legalName?: Maybe<string> }>, members?: Maybe<Array<{ __typename?: 'Member', id: string, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType>, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, durationMins?: Maybe<number>, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string>, label?: Maybe<string> }> }>>, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string>, tz?: Maybe<string>, slotInterval?: Maybe<number>, defaultOn?: Maybe<{ __typename?: 'Calendar', id: string }> }> }> }>> }>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, acceptingNewPatients?: Maybe<CalendarAcceptingNewPatientType> }> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }> }> };

export type PatientProfileQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type PatientProfileQuery = { __typename?: 'Query', patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> };

export type PatientVisitNotesQueryVariables = Exact<{
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type PatientVisitNotesQuery = { __typename?: 'Query', appointments?: Maybe<Array<{ __typename?: 'Appointment', id: string, note?: Maybe<string>, noteMdx?: Maybe<string>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, reason?: Maybe<string> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string }>, vitalsData?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string> }> }>> };

export type PharmaciesQueryVariables = Exact<{
  take?: Maybe<Scalars['Int']>;
}>;


export type PharmaciesQuery = { __typename?: 'Query', pharmacies?: Maybe<Array<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }>> };

export type PharmaciesSearchQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  take?: Maybe<Scalars['Int']>;
}>;


export type PharmaciesSearchQuery = { __typename?: 'Query', pharmacies?: Maybe<Array<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }>> };

export type PharmacyLocationsQueryVariables = Exact<{
  take?: Maybe<Scalars['Int']>;
}>;


export type PharmacyLocationsQuery = { __typename?: 'Query', pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string }>> };

export type PharmacyLocationsSearchQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type PharmacyLocationsSearchQuery = { __typename?: 'Query', pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }>, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string> }> }>> };

export type RecurringIntervalsQueryVariables = Exact<{
  recurringSlotId: Scalars['ID'];
}>;


export type RecurringIntervalsQuery = { __typename?: 'Query', timeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', recurringSlot?: Maybe<{ __typename?: 'RecurringSlot', id: string, timeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string> }>> }> }>> };

export type RemittancesQueryVariables = Exact<{
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RemittanceAdviceWhereInput>;
}>;


export type RemittancesQuery = { __typename?: 'Query', remittanceAdvices?: Maybe<Array<{ __typename?: 'RemittanceAdvice', id: string, externalClaims?: Maybe<any>, billings?: Maybe<Array<{ __typename?: 'AppointmentBilling', id: string, status?: Maybe<AppointmentBillingStatusType>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, description?: Maybe<string>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string> }> }>>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, scheduledStartsAt?: Maybe<any>, startedAt?: Maybe<any>, booking?: Maybe<{ __typename?: 'Booking', id: string, startsAt?: Maybe<any> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string> }> }> }> }>>, request?: Maybe<{ __typename?: 'RemittanceAdviceRequest', id: string, status?: Maybe<string> }> }>> };

export type RemittanceQueryVariables = Exact<{
  where: RemittanceAdviceWhereUniqueInput;
}>;


export type RemittanceQuery = { __typename?: 'Query', remittanceAdvice?: Maybe<{ __typename?: 'RemittanceAdvice', id: string, billings?: Maybe<Array<{ __typename?: 'AppointmentBilling', id: string, status?: Maybe<AppointmentBillingStatusType>, billingItems?: Maybe<Array<{ __typename?: 'AppointmentBillingItem', id: string, units?: Maybe<number>, claim?: Maybe<{ __typename?: 'BillingClaim', id: string, amount?: Maybe<number>, feeCode?: Maybe<string> }>, diagnosis?: Maybe<{ __typename?: 'BillingDiagnosis', id: string, code?: Maybe<string> }>, premium?: Maybe<{ __typename?: 'BillingPremium', id: string, amount?: Maybe<string>, code?: Maybe<string>, description?: Maybe<string>, feeCode?: Maybe<string> }> }>>, submission?: Maybe<{ __typename?: 'BillingSubmission', id: string, createdAt?: Maybe<any>, amountPaid?: Maybe<number>, amountSubmitted?: Maybe<number>, explanatoryItems?: Maybe<any> }> }>> }> };

export type RolesQueryVariables = Exact<{
  where?: Maybe<RoleWhereInput>;
}>;


export type RolesQuery = { __typename?: 'Query', roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>> };

export type ScheduleQueryVariables = Exact<{
  scheduleId: Scalars['ID'];
}>;


export type ScheduleQuery = { __typename?: 'Query', schedule?: Maybe<{ __typename?: 'Schedule', id: string, title?: Maybe<string>, description?: Maybe<string>, tz?: Maybe<string>, slotInterval?: Maybe<number>, defaultOn?: Maybe<{ __typename?: 'Calendar', id: string }> }> };

export type SoapNoteCompletionQueryVariables = Exact<{
  note: Scalars['String'];
}>;


export type SoapNoteCompletionQuery = { __typename?: 'Query', getSOAPCompletion?: Maybe<any> };

export type SteppersQueryVariables = Exact<{
  stepperSlug: Scalars['String'];
}>;


export type SteppersQuery = { __typename?: 'Query', steppers?: Maybe<Array<{ __typename?: 'Stepper', id: string, eyebrow?: Maybe<string>, title?: Maybe<string>, stepsOrderBySlugs?: Maybe<string>, stepperSteps?: Maybe<Array<{ __typename?: 'StepperStep', id: string, component?: Maybe<string>, description?: Maybe<string>, isFinal?: Maybe<boolean>, isOptional?: Maybe<boolean>, label?: Maybe<string>, order?: Maybe<number>, slug?: Maybe<string>, title?: Maybe<string> }>> }>> };

export type StepperStepProgsQueryVariables = Exact<{
  stepperSlug: Scalars['String'];
  username: Scalars['String'];
}>;


export type StepperStepProgsQuery = { __typename?: 'Query', stepperStepProgs?: Maybe<Array<{ __typename?: 'StepperStepProg', id: string, percentDone?: Maybe<number>, isCompleted?: Maybe<boolean>, stepperStep?: Maybe<{ __typename?: 'StepperStep', id: string, slug?: Maybe<string> }> }>> };

export type TasksQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<TaskOrderByInput> | TaskOrderByInput>;
  where?: Maybe<TaskWhereInput>;
}>;


export type TasksQuery = { __typename?: 'Query', tasks?: Maybe<Array<{ __typename?: 'Task', id: string, createdAt?: Maybe<any>, dueAt?: Maybe<any>, priority?: Maybe<TaskPriorityType>, resolvedAt?: Maybe<any>, resolvedNote?: Maybe<string>, status?: Maybe<TaskStatusType>, title?: Maybe<string>, description?: Maybe<string>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }>, assignedTo?: Maybe<{ __typename?: 'Member', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }> }>, author?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type TaskQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type TaskQuery = { __typename?: 'Query', task?: Maybe<{ __typename?: 'Task', id: string, createdAt?: Maybe<any>, description?: Maybe<string>, dueAt?: Maybe<any>, priority?: Maybe<TaskPriorityType>, resolvedAt?: Maybe<any>, resolvedNote?: Maybe<string>, status?: Maybe<TaskStatusType>, title?: Maybe<string>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }>, assignedTo?: Maybe<{ __typename?: 'Member', id: string, isActive?: Maybe<boolean>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }>, clinic?: Maybe<{ __typename?: 'Clinic', id: string, description?: Maybe<string>, isActive?: Maybe<boolean>, name?: Maybe<string>, company?: Maybe<{ __typename?: 'Company', id: string }> }> }>, author?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> };

export type TestsBatchesQueryVariables = Exact<{
  doctorId: Scalars['ID'];
}>;


export type TestsBatchesQuery = { __typename?: 'Query', testsBatches?: Maybe<Array<{ __typename?: 'TestsBatch', id: string, name?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, formTests?: Maybe<Array<{ __typename?: 'FormTest', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, formType?: Maybe<{ __typename?: 'FormType', id: string, name?: Maybe<string>, slug?: Maybe<string> }> }>> };

export type TestsOrderedQueryVariables = Exact<{
  orderBy?: Maybe<Array<TestOrderOrderByInput> | TestOrderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TestOrderWhereInput>;
}>;


export type TestsOrderedQuery = { __typename?: 'Query', testOrders?: Maybe<Array<{ __typename?: 'TestOrder', id: string, orderedAt?: Maybe<any>, resolvedAt?: Maybe<any>, data?: Maybe<any>, slug?: Maybe<string>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }>> };

export type TestOrderQueryVariables = Exact<{
  testOrderId: Scalars['ID'];
}>;


export type TestOrderQuery = { __typename?: 'Query', testOrder?: Maybe<{ __typename?: 'TestOrder', id: string, resolvedAt?: Maybe<any>, orderedAt?: Maybe<any>, data?: Maybe<any>, slug?: Maybe<string>, inboundFaxes?: Maybe<Array<{ __typename?: 'InboundFax', id: string, member?: Maybe<{ __typename?: 'Member', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }> }>>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }> }> };

export type UserAllergiesQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type UserAllergiesQuery = { __typename?: 'Query', patient?: Maybe<{ __typename?: 'Patient', id: string, allergies?: Maybe<Array<{ __typename?: 'AllergyItem', id: string, name?: Maybe<string>, onsetDate?: Maybe<any>, reaction?: Maybe<string> }>>, user?: Maybe<{ __typename?: 'User', id: string, username?: Maybe<string> }> }> };

export type UserDocumentsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type UserDocumentsQuery = { __typename?: 'Query', patient?: Maybe<{ __typename?: 'Patient', id: string, documents?: Maybe<Array<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, form?: Maybe<{ __typename?: 'Form', id: string, name?: Maybe<string>, slug?: Maybe<string>, issuedAt?: Maybe<any>, formFields?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, username?: Maybe<string> }> }> };

export type UserDocumentQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type UserDocumentQuery = { __typename?: 'Query', document?: Maybe<{ __typename?: 'Document', id: string, addedAt?: Maybe<any>, title?: Maybe<string>, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, form?: Maybe<{ __typename?: 'Form', id: string, name?: Maybe<string>, slug?: Maybe<string>, issuedAt?: Maybe<any>, formFields?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string, event?: Maybe<{ __typename?: 'CalendarEvent', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string> }>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, value?: Maybe<string> }> }> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, clinicFaxNumber?: Maybe<string>, clinicPhoneNumber?: Maybe<string>, licenseNumber?: Maybe<string>, ohipPractitionerNumber?: Maybe<string>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, signature?: Maybe<{ __typename?: 'Signature', id: string, file?: Maybe<{ __typename?: 'File', id: string, fileKey?: Maybe<string>, fileName?: Maybe<string>, fileSize?: Maybe<number>, fileType?: Maybe<string> }>, attachment?: Maybe<{ __typename?: 'FileFieldOutput', filename: string, url: string }> }>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, middleName?: Maybe<string>, lastName?: Maybe<string> }> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, emergencyContacts?: Maybe<Array<{ __typename?: 'EmergencyContact', id: string, email?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, homePhoneNumberString?: Maybe<string> }>>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, addressLine1?: Maybe<string>, locality?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, sex?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, homePhoneNumberString?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }> }> }> };

export type UserHealthConditionsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<HealthConditionWhereInput> | HealthConditionWhereInput>;
}>;


export type UserHealthConditionsQuery = { __typename?: 'Query', healthConditions?: Maybe<Array<{ __typename?: 'HealthCondition', id: string, diagnosedAt?: Maybe<any>, name?: Maybe<string>, relation?: Maybe<string>, inactivatedAt?: Maybe<any>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }>> };

export type UserInvitesByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type UserInvitesByEmailQuery = { __typename?: 'Query', userInvites?: Maybe<Array<{ __typename?: 'UserInvite', id: string, createdAt?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, revokedAt?: Maybe<any>, healthCard?: Maybe<{ __typename?: 'HealthCard', id: string, insurancePolicyNumber?: Maybe<string>, versionCode?: Maybe<string>, expiryDate?: Maybe<any> }>, invitedByUser?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }>, signedUpUser?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string }> }> }>> };

export type UserInvitePublicDataQueryVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type UserInvitePublicDataQuery = { __typename?: 'Query', getInvitePublicData?: Maybe<any> };

export type UserInviteQueryVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type UserInviteQuery = { __typename?: 'Query', userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, createdAt?: Maybe<any>, firstName?: Maybe<string>, lastName?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, dateOfBirth?: Maybe<any>, email?: Maybe<string>, revokedAt?: Maybe<any>, healthCard?: Maybe<{ __typename?: 'HealthCard', id: string, insurancePolicyNumber?: Maybe<string>, versionCode?: Maybe<string>, expiryDate?: Maybe<any> }>, invitedByUser?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }>, signedUpUser?: Maybe<{ __typename?: 'User', id: string, patient?: Maybe<{ __typename?: 'Patient', id: string }> }> }> };

export type UserLifestyleQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<LifestyleItemWhereInput> | LifestyleItemWhereInput>;
}>;


export type UserLifestyleQuery = { __typename?: 'Query', lifestyleItems?: Maybe<Array<{ __typename?: 'LifestyleItem', id: string, activity?: Maybe<string>, frequency?: Maybe<string>, item?: Maybe<string>, inactivatedAt?: Maybe<any>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }> }>> };

export type UserMedicationItemsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<MedicationItemWhereInput> | MedicationItemWhereInput>;
}>;


export type UserMedicationItemsQuery = { __typename?: 'Query', medicationItems?: Maybe<Array<{ __typename?: 'MedicationItem', id: string, inactivatedAt?: Maybe<any>, instructions?: Maybe<string>, prescribedAt?: Maybe<any>, refills?: Maybe<number>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, inactivatedBy?: Maybe<{ __typename?: 'User', id: string }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>> };

export type UserProfileQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserProfileQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', id: string, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type UserPromptsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserPromptsQuery = { __typename?: 'Query', prompts?: Maybe<Array<{ __typename?: 'Prompt', id: string, promptType?: Maybe<string>, promptValue?: Maybe<string>, slug?: Maybe<string> }>> };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any>, isAdmin?: Maybe<boolean>, isOnboarded?: Maybe<boolean>, isOnboardedDoctor?: Maybe<boolean>, sex?: Maybe<string>, stripeCusId?: Maybe<string>, cellPhoneNumberString?: Maybe<string>, email?: Maybe<string>, firstName?: Maybe<string>, homePhoneNumberString?: Maybe<string>, lastName?: Maybe<string>, middleName?: Maybe<string>, username?: Maybe<string>, photoSrc?: Maybe<string>, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, contractSignedOn?: Maybe<any>, isCompleteProfile?: Maybe<boolean>, isVerified?: Maybe<boolean>, licenseNumber?: Maybe<string>, licenseProvider?: Maybe<string>, medicalLiabilityNumber?: Maybe<string>, medicalLiabilityProvider?: Maybe<string>, summary?: Maybe<string>, doctorSince?: Maybe<any>, calendar?: Maybe<{ __typename?: 'Calendar', id: string, events?: Maybe<Array<{ __typename?: 'CalendarEvent', id: string, isActive?: Maybe<boolean>, eventType?: Maybe<{ __typename?: 'CalendarEventType', id: string, label?: Maybe<string>, value?: Maybe<string> }> }>> }>, doctorSpecialty?: Maybe<{ __typename?: 'DoctorSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>, doctorSubSpecialties?: Maybe<Array<{ __typename?: 'DoctorSubSpecialty', id: string, label?: Maybe<string>, value?: Maybe<string> }>>, languages?: Maybe<Array<{ __typename?: 'Language', id: string, label?: Maybe<string>, value?: Maybe<string> }>> }>, patient?: Maybe<{ __typename?: 'Patient', id: string, isCompleteProfile?: Maybe<boolean>, healthCards?: Maybe<Array<{ __typename?: 'HealthCard', id: string, expiryDate?: Maybe<any>, insurancePolicyNumber?: Maybe<string>, insuranceProvider?: Maybe<string>, isValid?: Maybe<boolean>, validatedAt?: Maybe<any>, validationCode?: Maybe<string>, stateDescriptor?: Maybe<string>, versionCode?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, dateOfBirth?: Maybe<any>, sex?: Maybe<string> }> }>, userInvite?: Maybe<{ __typename?: 'UserInvite', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>>, pharmacyLocations?: Maybe<Array<{ __typename?: 'PharmacyLocation', id: string, address?: Maybe<{ __typename?: 'Address', id: string, country?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, administrativeArea?: Maybe<string>, locality?: Maybe<string>, postalCode?: Maybe<string>, thoroughfare?: Maybe<string>, premise?: Maybe<string> }>, pharmacy?: Maybe<{ __typename?: 'Pharmacy', id: string, companyName?: Maybe<string> }> }>> }>, roles?: Maybe<Array<{ __typename?: 'Role', id: string, name?: Maybe<RoleNameType> }>>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> };

export type UserScreeningTestsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type UserScreeningTestsQuery = { __typename?: 'Query', patient?: Maybe<{ __typename?: 'Patient', id: string, screeningTests?: Maybe<Array<{ __typename?: 'ScreeningTest', id: string, name?: Maybe<string>, testedAt?: Maybe<any> }>>, user?: Maybe<{ __typename?: 'User', id: string, username?: Maybe<string> }> }> };

export type UserSessionsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UserSessionOrderByInput> | UserSessionOrderByInput>;
  where?: Maybe<UserSessionWhereInput>;
}>;


export type UserSessionsQuery = { __typename?: 'Query', userSessions?: Maybe<Array<{ __typename?: 'UserSession', id: string, lastActivity?: Maybe<any>, lastPath?: Maybe<string>, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>> };

export type UserVaccinationsQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  patientId: Scalars['ID'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type UserVaccinationsQuery = { __typename?: 'Query', patient?: Maybe<{ __typename?: 'Patient', id: string, vaccinations?: Maybe<Array<{ __typename?: 'Vaccination', id: string, expirationDate?: Maybe<any>, immunizedAt?: Maybe<any>, doctor?: Maybe<{ __typename?: 'Doctor', id: string, user?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string> }> }>, medication?: Maybe<{ __typename?: 'Medication', id: string, brandName?: Maybe<string>, drugCode?: Maybe<string>, drugIdentificationNumber?: Maybe<string>, activeIngredients?: Maybe<Array<{ __typename?: 'ActiveIngredient', id: string, drugCode?: Maybe<string>, ingredientName?: Maybe<string>, strengthUnit?: Maybe<string>, strengthValue?: Maybe<string> }>> }> }>>, user?: Maybe<{ __typename?: 'User', id: string, username?: Maybe<string> }> }> };

export type VideoParticipantUsersQueryVariables = Exact<{
  userIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type VideoParticipantUsersQuery = { __typename?: 'Query', users?: Maybe<Array<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, photoSrc?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>> };

export type VitalsQueryVariables = Exact<{
  vitalsId: Scalars['ID'];
}>;


export type VitalsQuery = { __typename?: 'Query', appointmentVital?: Maybe<{ __typename?: 'AppointmentVital', id: string, headCm?: Maybe<number>, meters?: Maybe<number>, cm?: Maybe<number>, kg?: Maybe<number>, oxygenSaturation?: Maybe<number>, heartRate?: Maybe<number>, temperature?: Maybe<number>, resp?: Maybe<number>, bloodPressure?: Maybe<string>, patient?: Maybe<{ __typename?: 'Patient', id: string, user?: Maybe<{ __typename?: 'User', id: string, dateOfBirth?: Maybe<any> }> }> }> };

export type WeekdaySlotsQueryVariables = Exact<{
  scheduleId: Scalars['ID'];
}>;


export type WeekdaySlotsQuery = { __typename?: 'Query', doctors?: Maybe<Array<{ __typename?: 'Doctor', calendar?: Maybe<{ __typename?: 'Calendar', id: string, defaultSchedule?: Maybe<{ __typename?: 'Schedule', id: string, tz?: Maybe<string> }> }> }>>, recurringSlots?: Maybe<Array<{ __typename?: 'RecurringSlot', id: string, wday?: Maybe<string>, interval?: Maybe<string>, intervalCount?: Maybe<number>, timeIntervals?: Maybe<Array<{ __typename?: 'TimeInterval', id: string, from?: Maybe<string>, to?: Maybe<string> }>> }>> };

export type AppointmentSessionChangeSubscriptionVariables = Exact<{
  appointmentId: Scalars['ID'];
}>;


export type AppointmentSessionChangeSubscription = { __typename?: 'Subscription', appointmentSessionChanged?: Maybe<{ __typename?: 'AppointmentSession', id: string, duration?: Maybe<number>, endedAt?: Maybe<any>, isActive?: Maybe<boolean>, startedAt?: Maybe<any>, appointment?: Maybe<{ __typename?: 'Appointment', id: string }>, doctor?: Maybe<{ __typename?: 'Doctor', id: string }>, patient?: Maybe<{ __typename?: 'Patient', id: string }> }> };

export type ChatMessageUpdateSubscriptionVariables = Exact<{
  chatId: Scalars['ID'];
}>;


export type ChatMessageUpdateSubscription = { __typename?: 'Subscription', chatMessageUpdated?: Maybe<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, uuid?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }>, replyTo?: Maybe<{ __typename?: 'ChatMessage', id: string, createdAt?: Maybe<any>, readAt?: Maybe<any>, text?: Maybe<string>, author?: Maybe<{ __typename?: 'User', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, profilePhoto?: Maybe<{ __typename?: 'ProfilePhoto', id: string, src?: Maybe<{ __typename?: 'CloudinaryImage_File', id?: Maybe<string>, publicUrlTransformed?: Maybe<string> }> }> }> }>, chat?: Maybe<{ __typename?: 'Chat', id: string }> }> };

export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  id
  country
  addressLine1
  addressLine2
  administrativeArea
  locality
  postalCode
  thoroughfare
  premise
}
    `;
export const ProfilePhotoFieldsFragmentDoc = gql`
    fragment ProfilePhotoFields on ProfilePhoto {
  id
  src {
    id
    publicUrlTransformed
  }
}
    `;
export const UserPhotoFieldsFragmentDoc = gql`
    fragment UserPhotoFields on User {
  id
  photoSrc
  profilePhoto {
    ...ProfilePhotoFields
  }
}
    ${ProfilePhotoFieldsFragmentDoc}`;
export const DoctorBasicFieldsFragmentDoc = gql`
    fragment DoctorBasicFields on Doctor {
  id
  calendar {
    id
    defaultSchedule {
      id
      title
      description
    }
    schedules {
      id
      title
      description
    }
  }
  clinicFaxNumber
  clinicPhoneNumber
  doctorSince
  languages {
    id
    label
    value
  }
  doctorSpecialty {
    id
    label
    value
  }
  summary
  user {
    ...UserPhotoFields
    email
    firstName
    lastName
    username
  }
}
    ${UserPhotoFieldsFragmentDoc}`;
export const UserContactFieldsFragmentDoc = gql`
    fragment UserContactFields on User {
  id
  cellPhoneNumberString
  email
  firstName
  homePhoneNumberString
  lastName
  middleName
  username
}
    `;
export const HealthCardFieldsFragmentDoc = gql`
    fragment HealthCardFields on HealthCard {
  id
  expiryDate
  insurancePolicyNumber
  insuranceProvider
  isValid
  validatedAt
  validationCode
  stateDescriptor
  versionCode
  patient {
    id
    user {
      id
      firstName
      lastName
      dateOfBirth
      sex
    }
  }
  userInvite {
    id
    firstName
    lastName
  }
}
    `;
export const UserBasicDataFieldsFragmentDoc = gql`
    fragment UserBasicDataFields on User {
  id
  address {
    ...AddressFields
  }
  ...UserContactFields
  ...UserPhotoFields
  dateOfBirth
  doctor {
    id
    calendar {
      id
      events {
        id
        isActive
        eventType {
          id
          label
          value
        }
      }
    }
    contractSignedOn
    doctorSpecialty {
      id
      label
      value
    }
    doctorSubSpecialties {
      id
      label
      value
    }
    isCompleteProfile
    isVerified
    languages {
      id
      label
      value
    }
    licenseNumber
    licenseProvider
    medicalLiabilityNumber
    medicalLiabilityProvider
    summary
    doctorSince
  }
  isAdmin
  isOnboarded
  isOnboardedDoctor
  sex
  stripeCusId
  patient {
    id
    isCompleteProfile
    healthCards {
      ...HealthCardFields
    }
    pharmacyLocations {
      id
      address {
        ...AddressFields
      }
      pharmacy {
        id
        companyName
      }
    }
  }
  roles {
    id
    name
  }
}
    ${AddressFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;
export const EmergencyContactFieldsFragmentDoc = gql`
    fragment EmergencyContactFields on EmergencyContact {
  id
  email
  relation
  cellPhoneNumberString
  homePhoneNumberString
  firstName
  lastName
}
    `;
export const AppointmentBookingFieldsFragmentDoc = gql`
    fragment AppointmentBookingFields on Booking {
  id
  appointment {
    id
    prescription {
      id
    }
    vitalsData {
      id
    }
    isMissed
    cancelledAt
    note
    noteMdx
    reason
    isInvalidHealthCard
    event {
      id
      durationMins
      eventType {
        id
        label
        value
      }
    }
    clinic {
      id
      description
      isActive
      name
      company {
        id
        legalName
      }
      address {
        ...AddressFields
      }
      phoneNumber
      faxNumber
    }
    member {
      id
      faxNumber
    }
  }
  doctor {
    ...DoctorBasicFields
    user {
      ...UserBasicDataFields
    }
  }
  patient {
    id
    emergencyContacts {
      ...EmergencyContactFields
    }
    user {
      ...UserBasicDataFields
    }
  }
  durationMins
  endsAt
  startsAt
  event {
    id
    address {
      ...AddressFields
    }
    durationMins
    eventType {
      id
      label
      value
    }
  }
}
    ${AddressFieldsFragmentDoc}
${DoctorBasicFieldsFragmentDoc}
${UserBasicDataFieldsFragmentDoc}
${EmergencyContactFieldsFragmentDoc}`;
export const DoctorProfileFieldsFragmentDoc = gql`
    fragment DoctorProfileFields on Doctor {
  ...DoctorBasicFields
  contractSignedOn
  doctorSpecialty {
    id
    label
    value
  }
  doctorSubSpecialties {
    id
    label
    value
  }
  licenseNumber
  licenseProvider
  medicalLiabilityProvider
  medicalLiabilityNumber
  ohipPractitionerNumber
  ohipSpecialityCode
  summary
}
    ${DoctorBasicFieldsFragmentDoc}`;
export const DoctorProDetailsFieldsFragmentDoc = gql`
    fragment DoctorProDetailsFields on Doctor {
  isVerified
  licenseNumber
  licenseProvider
  medicalLiabilityProvider
  medicalLiabilityNumber
}
    `;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  id
  fileKey
  fileName
  fileSize
  fileType
}
    `;
export const DoctorSupportingDocsFieldsFragmentDoc = gql`
    fragment DoctorSupportingDocsFields on Doctor {
  proofOfInsurance {
    id
    file {
      ...FileFields
    }
    src {
      id
      publicUrl
      publicUrlTransformed
      originalFilename
      mimetype
    }
  }
  proofOfIdentification {
    id
    file {
      ...FileFields
    }
    src {
      id
      publicUrl
      publicUrlTransformed
      originalFilename
      mimetype
    }
  }
  proofOfLicense {
    id
    file {
      ...FileFields
    }
    src {
      id
      publicUrl
      publicUrlTransformed
      originalFilename
      mimetype
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export const DoctorAppointmentFieldsFragmentDoc = gql`
    fragment DoctorAppointmentFields on Appointment {
  id
  prescription {
    id
    isSubstitutionAllowed
  }
  vitalsData {
    id
  }
  reason
}
    `;
export const DoctorAppointmentBookingFieldsFragmentDoc = gql`
    fragment DoctorAppointmentBookingFields on Booking {
  id
  appointment {
    id
    reason
  }
  doctor {
    ...DoctorBasicFields
    user {
      ...UserBasicDataFields
      dateOfBirth
    }
  }
  patient {
    id
    emergencyContacts {
      id
      firstName
      lastName
    }
    user {
      ...UserBasicDataFields
    }
  }
  durationMins
  endsAt
  startsAt
  event {
    id
    eventType {
      id
      label
      value
    }
  }
}
    ${DoctorBasicFieldsFragmentDoc}
${UserBasicDataFieldsFragmentDoc}`;
export const AppointmentNoteFieldsFragmentDoc = gql`
    fragment AppointmentNoteFields on AppointmentNote {
  id
  summary
  title
}
    `;
export const StepperStepFieldsFragmentDoc = gql`
    fragment StepperStepFields on StepperStep {
  id
  component
  description
  isFinal
  isOptional
  label
  order
  slug
  title
}
    `;
export const PatientAppointmentBookingFieldsFragmentDoc = gql`
    fragment PatientAppointmentBookingFields on Appointment {
  id
  booking {
    id
    durationMins
    endsAt
    startsAt
    event {
      id
      eventType {
        id
        label
        value
      }
    }
  }
  doctor {
    ...DoctorBasicFields
    user {
      ...UserBasicDataFields
    }
  }
  patient {
    id
    user {
      ...UserBasicDataFields
    }
  }
  reason
}
    ${DoctorBasicFieldsFragmentDoc}
${UserBasicDataFieldsFragmentDoc}`;
export const PatientBasicFieldsFragmentDoc = gql`
    fragment PatientBasicFields on Patient {
  id
  isCompleteProfile
  emergencyContacts {
    id
    email
    firstName
    lastName
    cellPhoneNumberString
    homePhoneNumberString
  }
  healthCards {
    ...HealthCardFields
  }
  pharmacyLocations {
    id
    address {
      id
      addressLine1
      locality
    }
    pharmacy {
      id
      companyName
    }
  }
  user {
    id
    address {
      ...AddressFields
    }
    ...UserContactFields
    dateOfBirth
    firstName
    lastName
    middleName
    sex
    ...UserPhotoFields
  }
}
    ${HealthCardFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;
export const PatientProfileFieldsFragmentDoc = gql`
    fragment PatientProfileFields on Patient {
  ...PatientBasicFields
}
    ${PatientBasicFieldsFragmentDoc}`;
export const ScheduleBasicFieldsFragmentDoc = gql`
    fragment ScheduleBasicFields on Schedule {
  id
  title
  description
  slotInterval
  tz
}
    `;
export const VitalsFieldsFragmentDoc = gql`
    fragment VitalsFields on AppointmentVital {
  id
  headCm
  meters
  cm
  kg
  oxygenSaturation
  heartRate
  temperature
  resp
  bloodPressure
}
    `;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($inviteId: ID!) {
  acceptInvite(inviteId: $inviteId) {
    id
  }
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const AddChatMessageDocument = gql`
    mutation AddChatMessage($chatId: ID!, $text: String, $replyToMessageId: ID, $uuid: String!) {
  addChatMessage(
    chatId: $chatId
    text: $text
    replyToMessageId: $replyToMessageId
    uuid: $uuid
  ) {
    id
    createdAt
    readAt
    text
    author {
      id
      firstName
      lastName
      profilePhoto {
        id
        src {
          id
          publicUrlTransformed
        }
      }
    }
    replyTo {
      id
      createdAt
      readAt
      text
      author {
        id
        firstName
        lastName
        profilePhoto {
          id
          src {
            id
            publicUrlTransformed
          }
        }
      }
    }
    uuid
  }
}
    `;
export type AddChatMessageMutationFn = Apollo.MutationFunction<AddChatMessageMutation, AddChatMessageMutationVariables>;

/**
 * __useAddChatMessageMutation__
 *
 * To run a mutation, you first call `useAddChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChatMessageMutation, { data, loading, error }] = useAddChatMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      text: // value for 'text'
 *      replyToMessageId: // value for 'replyToMessageId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAddChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddChatMessageMutation, AddChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChatMessageMutation, AddChatMessageMutationVariables>(AddChatMessageDocument, options);
      }
export type AddChatMessageMutationHookResult = ReturnType<typeof useAddChatMessageMutation>;
export type AddChatMessageMutationResult = Apollo.MutationResult<AddChatMessageMutation>;
export type AddChatMessageMutationOptions = Apollo.BaseMutationOptions<AddChatMessageMutation, AddChatMessageMutationVariables>;
export const AddPatientToCompanyDocument = gql`
    mutation AddPatientToCompany($firstName: String!, $lastName: String!, $email: String!, $cellPhoneNumberString: String!, $dateOfBirth: String!, $companyId: ID!) {
  addPatientToCompany(
    firstName: $firstName
    lastName: $lastName
    email: $email
    cellPhoneNumberString: $cellPhoneNumberString
    dateOfBirth: $dateOfBirth
    companyId: $companyId
  ) {
    id
    user {
      id
      firstName
      lastName
      email
      email
      cellPhoneNumberString
    }
  }
}
    `;
export type AddPatientToCompanyMutationFn = Apollo.MutationFunction<AddPatientToCompanyMutation, AddPatientToCompanyMutationVariables>;

/**
 * __useAddPatientToCompanyMutation__
 *
 * To run a mutation, you first call `useAddPatientToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPatientToCompanyMutation, { data, loading, error }] = useAddPatientToCompanyMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      cellPhoneNumberString: // value for 'cellPhoneNumberString'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAddPatientToCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddPatientToCompanyMutation, AddPatientToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPatientToCompanyMutation, AddPatientToCompanyMutationVariables>(AddPatientToCompanyDocument, options);
      }
export type AddPatientToCompanyMutationHookResult = ReturnType<typeof useAddPatientToCompanyMutation>;
export type AddPatientToCompanyMutationResult = Apollo.MutationResult<AddPatientToCompanyMutation>;
export type AddPatientToCompanyMutationOptions = Apollo.BaseMutationOptions<AddPatientToCompanyMutation, AddPatientToCompanyMutationVariables>;
export const AddReferringDoctorDocument = gql`
    mutation AddReferringDoctor($billingId: ID!, $referringDoctorNumber: String!) {
  updateAppointmentBilling(
    where: {id: $billingId}
    data: {referringDoctorNumber: $referringDoctorNumber}
  ) {
    id
    referringDoctorNumber
  }
}
    `;
export type AddReferringDoctorMutationFn = Apollo.MutationFunction<AddReferringDoctorMutation, AddReferringDoctorMutationVariables>;

/**
 * __useAddReferringDoctorMutation__
 *
 * To run a mutation, you first call `useAddReferringDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReferringDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReferringDoctorMutation, { data, loading, error }] = useAddReferringDoctorMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *      referringDoctorNumber: // value for 'referringDoctorNumber'
 *   },
 * });
 */
export function useAddReferringDoctorMutation(baseOptions?: Apollo.MutationHookOptions<AddReferringDoctorMutation, AddReferringDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReferringDoctorMutation, AddReferringDoctorMutationVariables>(AddReferringDoctorDocument, options);
      }
export type AddReferringDoctorMutationHookResult = ReturnType<typeof useAddReferringDoctorMutation>;
export type AddReferringDoctorMutationResult = Apollo.MutationResult<AddReferringDoctorMutation>;
export type AddReferringDoctorMutationOptions = Apollo.BaseMutationOptions<AddReferringDoctorMutation, AddReferringDoctorMutationVariables>;
export const AssignDoctorToFaxDocument = gql`
    mutation AssignDoctorToFax($inboundFaxId: ID!, $memberId: ID!) {
  updateInboundFax(
    where: {id: $inboundFaxId}
    data: {member: {connect: {id: $memberId}}}
  ) {
    id
    member {
      id
    }
  }
}
    `;
export type AssignDoctorToFaxMutationFn = Apollo.MutationFunction<AssignDoctorToFaxMutation, AssignDoctorToFaxMutationVariables>;

/**
 * __useAssignDoctorToFaxMutation__
 *
 * To run a mutation, you first call `useAssignDoctorToFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDoctorToFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDoctorToFaxMutation, { data, loading, error }] = useAssignDoctorToFaxMutation({
 *   variables: {
 *      inboundFaxId: // value for 'inboundFaxId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useAssignDoctorToFaxMutation(baseOptions?: Apollo.MutationHookOptions<AssignDoctorToFaxMutation, AssignDoctorToFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDoctorToFaxMutation, AssignDoctorToFaxMutationVariables>(AssignDoctorToFaxDocument, options);
      }
export type AssignDoctorToFaxMutationHookResult = ReturnType<typeof useAssignDoctorToFaxMutation>;
export type AssignDoctorToFaxMutationResult = Apollo.MutationResult<AssignDoctorToFaxMutation>;
export type AssignDoctorToFaxMutationOptions = Apollo.BaseMutationOptions<AssignDoctorToFaxMutation, AssignDoctorToFaxMutationVariables>;
export const AssignPatientToFaxDocument = gql`
    mutation AssignPatientToFax($inboundFaxId: ID!, $patientId: ID!) {
  updateInboundFax(
    where: {id: $inboundFaxId}
    data: {patient: {connect: {id: $patientId}}}
  ) {
    id
    patient {
      id
    }
  }
}
    `;
export type AssignPatientToFaxMutationFn = Apollo.MutationFunction<AssignPatientToFaxMutation, AssignPatientToFaxMutationVariables>;

/**
 * __useAssignPatientToFaxMutation__
 *
 * To run a mutation, you first call `useAssignPatientToFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPatientToFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPatientToFaxMutation, { data, loading, error }] = useAssignPatientToFaxMutation({
 *   variables: {
 *      inboundFaxId: // value for 'inboundFaxId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useAssignPatientToFaxMutation(baseOptions?: Apollo.MutationHookOptions<AssignPatientToFaxMutation, AssignPatientToFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignPatientToFaxMutation, AssignPatientToFaxMutationVariables>(AssignPatientToFaxDocument, options);
      }
export type AssignPatientToFaxMutationHookResult = ReturnType<typeof useAssignPatientToFaxMutation>;
export type AssignPatientToFaxMutationResult = Apollo.MutationResult<AssignPatientToFaxMutation>;
export type AssignPatientToFaxMutationOptions = Apollo.BaseMutationOptions<AssignPatientToFaxMutation, AssignPatientToFaxMutationVariables>;
export const BackfillMyStripeDocument = gql`
    mutation BackfillMyStripe {
  backfillMyStripe {
    id
    stripeCusId
  }
}
    `;
export type BackfillMyStripeMutationFn = Apollo.MutationFunction<BackfillMyStripeMutation, BackfillMyStripeMutationVariables>;

/**
 * __useBackfillMyStripeMutation__
 *
 * To run a mutation, you first call `useBackfillMyStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackfillMyStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backfillMyStripeMutation, { data, loading, error }] = useBackfillMyStripeMutation({
 *   variables: {
 *   },
 * });
 */
export function useBackfillMyStripeMutation(baseOptions?: Apollo.MutationHookOptions<BackfillMyStripeMutation, BackfillMyStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackfillMyStripeMutation, BackfillMyStripeMutationVariables>(BackfillMyStripeDocument, options);
      }
export type BackfillMyStripeMutationHookResult = ReturnType<typeof useBackfillMyStripeMutation>;
export type BackfillMyStripeMutationResult = Apollo.MutationResult<BackfillMyStripeMutation>;
export type BackfillMyStripeMutationOptions = Apollo.BaseMutationOptions<BackfillMyStripeMutation, BackfillMyStripeMutationVariables>;
export const CancelAppointmentRequestDocument = gql`
    mutation CancelAppointmentRequest($appointmentRequestId: ID!) {
  cancelAppointmentRequest(appointmentRequestId: $appointmentRequestId) {
    id
  }
}
    `;
export type CancelAppointmentRequestMutationFn = Apollo.MutationFunction<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>;

/**
 * __useCancelAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentRequestMutation, { data, loading, error }] = useCancelAppointmentRequestMutation({
 *   variables: {
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *   },
 * });
 */
export function useCancelAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>(CancelAppointmentRequestDocument, options);
      }
export type CancelAppointmentRequestMutationHookResult = ReturnType<typeof useCancelAppointmentRequestMutation>;
export type CancelAppointmentRequestMutationResult = Apollo.MutationResult<CancelAppointmentRequestMutation>;
export type CancelAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>;
export const CancelCompanyOnboardingDocument = gql`
    mutation CancelCompanyOnboarding($companyId: ID!, $stepperProgId: ID!) {
  cancelCompanyOnboarding(companyId: $companyId, stepperProgId: $stepperProgId) {
    id
  }
}
    `;
export type CancelCompanyOnboardingMutationFn = Apollo.MutationFunction<CancelCompanyOnboardingMutation, CancelCompanyOnboardingMutationVariables>;

/**
 * __useCancelCompanyOnboardingMutation__
 *
 * To run a mutation, you first call `useCancelCompanyOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCompanyOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCompanyOnboardingMutation, { data, loading, error }] = useCancelCompanyOnboardingMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      stepperProgId: // value for 'stepperProgId'
 *   },
 * });
 */
export function useCancelCompanyOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CancelCompanyOnboardingMutation, CancelCompanyOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCompanyOnboardingMutation, CancelCompanyOnboardingMutationVariables>(CancelCompanyOnboardingDocument, options);
      }
export type CancelCompanyOnboardingMutationHookResult = ReturnType<typeof useCancelCompanyOnboardingMutation>;
export type CancelCompanyOnboardingMutationResult = Apollo.MutationResult<CancelCompanyOnboardingMutation>;
export type CancelCompanyOnboardingMutationOptions = Apollo.BaseMutationOptions<CancelCompanyOnboardingMutation, CancelCompanyOnboardingMutationVariables>;
export const CompleteAppointmentDocument = gql`
    mutation CompleteAppointment($appointmentId: ID!, $faxFile: Upload) {
  completeAppointment(appointmentId: $appointmentId, faxFile: $faxFile) {
    id
    isSigned
    signedAt
    faxes {
      id
      status
    }
  }
}
    `;
export type CompleteAppointmentMutationFn = Apollo.MutationFunction<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;

/**
 * __useCompleteAppointmentMutation__
 *
 * To run a mutation, you first call `useCompleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAppointmentMutation, { data, loading, error }] = useCompleteAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      faxFile: // value for 'faxFile'
 *   },
 * });
 */
export function useCompleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>(CompleteAppointmentDocument, options);
      }
export type CompleteAppointmentMutationHookResult = ReturnType<typeof useCompleteAppointmentMutation>;
export type CompleteAppointmentMutationResult = Apollo.MutationResult<CompleteAppointmentMutation>;
export type CompleteAppointmentMutationOptions = Apollo.BaseMutationOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;
export const CompleteCompanyOnboardingDocument = gql`
    mutation CompleteCompanyOnboarding($stepperProgId: ID!) {
  completeCompanyOnboarding(stepperProgId: $stepperProgId)
}
    `;
export type CompleteCompanyOnboardingMutationFn = Apollo.MutationFunction<CompleteCompanyOnboardingMutation, CompleteCompanyOnboardingMutationVariables>;

/**
 * __useCompleteCompanyOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteCompanyOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompanyOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCompanyOnboardingMutation, { data, loading, error }] = useCompleteCompanyOnboardingMutation({
 *   variables: {
 *      stepperProgId: // value for 'stepperProgId'
 *   },
 * });
 */
export function useCompleteCompanyOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCompanyOnboardingMutation, CompleteCompanyOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteCompanyOnboardingMutation, CompleteCompanyOnboardingMutationVariables>(CompleteCompanyOnboardingDocument, options);
      }
export type CompleteCompanyOnboardingMutationHookResult = ReturnType<typeof useCompleteCompanyOnboardingMutation>;
export type CompleteCompanyOnboardingMutationResult = Apollo.MutationResult<CompleteCompanyOnboardingMutation>;
export type CompleteCompanyOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteCompanyOnboardingMutation, CompleteCompanyOnboardingMutationVariables>;
export const CompleteStepProgDocument = gql`
    mutation CompleteStepProg($stepId: ID!) {
  completeMyStepProg(stepId: $stepId) {
    id
    stepperStep {
      id
      slug
    }
    percentDone
    isCompleted
  }
}
    `;
export type CompleteStepProgMutationFn = Apollo.MutationFunction<CompleteStepProgMutation, CompleteStepProgMutationVariables>;

/**
 * __useCompleteStepProgMutation__
 *
 * To run a mutation, you first call `useCompleteStepProgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStepProgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStepProgMutation, { data, loading, error }] = useCompleteStepProgMutation({
 *   variables: {
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useCompleteStepProgMutation(baseOptions?: Apollo.MutationHookOptions<CompleteStepProgMutation, CompleteStepProgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteStepProgMutation, CompleteStepProgMutationVariables>(CompleteStepProgDocument, options);
      }
export type CompleteStepProgMutationHookResult = ReturnType<typeof useCompleteStepProgMutation>;
export type CompleteStepProgMutationResult = Apollo.MutationResult<CompleteStepProgMutation>;
export type CompleteStepProgMutationOptions = Apollo.BaseMutationOptions<CompleteStepProgMutation, CompleteStepProgMutationVariables>;
export const ConnectPatientPharmacyLocationDocument = gql`
    mutation ConnectPatientPharmacyLocation($patientId: ID!, $pharmacyLocationIds: [PharmacyLocationWhereUniqueInput!]) {
  updatePatient(
    where: {id: $patientId}
    data: {pharmacyLocations: {set: $pharmacyLocationIds}}
  ) {
    id
    pharmacyLocations {
      id
    }
  }
}
    `;
export type ConnectPatientPharmacyLocationMutationFn = Apollo.MutationFunction<ConnectPatientPharmacyLocationMutation, ConnectPatientPharmacyLocationMutationVariables>;

/**
 * __useConnectPatientPharmacyLocationMutation__
 *
 * To run a mutation, you first call `useConnectPatientPharmacyLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPatientPharmacyLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPatientPharmacyLocationMutation, { data, loading, error }] = useConnectPatientPharmacyLocationMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      pharmacyLocationIds: // value for 'pharmacyLocationIds'
 *   },
 * });
 */
export function useConnectPatientPharmacyLocationMutation(baseOptions?: Apollo.MutationHookOptions<ConnectPatientPharmacyLocationMutation, ConnectPatientPharmacyLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectPatientPharmacyLocationMutation, ConnectPatientPharmacyLocationMutationVariables>(ConnectPatientPharmacyLocationDocument, options);
      }
export type ConnectPatientPharmacyLocationMutationHookResult = ReturnType<typeof useConnectPatientPharmacyLocationMutation>;
export type ConnectPatientPharmacyLocationMutationResult = Apollo.MutationResult<ConnectPatientPharmacyLocationMutation>;
export type ConnectPatientPharmacyLocationMutationOptions = Apollo.BaseMutationOptions<ConnectPatientPharmacyLocationMutation, ConnectPatientPharmacyLocationMutationVariables>;
export const CreateAllergyItemDocument = gql`
    mutation CreateAllergyItem($patientId: ID!, $name: String!, $reaction: String!, $onsetDate: DateTime) {
  createAllergyItem(
    data: {patient: {connect: {id: $patientId}}, name: $name, reaction: $reaction, onsetDate: $onsetDate}
  ) {
    id
    patient {
      id
      allergies {
        id
        name
        reaction
        onsetDate
      }
    }
  }
}
    `;
export type CreateAllergyItemMutationFn = Apollo.MutationFunction<CreateAllergyItemMutation, CreateAllergyItemMutationVariables>;

/**
 * __useCreateAllergyItemMutation__
 *
 * To run a mutation, you first call `useCreateAllergyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllergyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllergyItemMutation, { data, loading, error }] = useCreateAllergyItemMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      name: // value for 'name'
 *      reaction: // value for 'reaction'
 *      onsetDate: // value for 'onsetDate'
 *   },
 * });
 */
export function useCreateAllergyItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllergyItemMutation, CreateAllergyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllergyItemMutation, CreateAllergyItemMutationVariables>(CreateAllergyItemDocument, options);
      }
export type CreateAllergyItemMutationHookResult = ReturnType<typeof useCreateAllergyItemMutation>;
export type CreateAllergyItemMutationResult = Apollo.MutationResult<CreateAllergyItemMutation>;
export type CreateAllergyItemMutationOptions = Apollo.BaseMutationOptions<CreateAllergyItemMutation, CreateAllergyItemMutationVariables>;
export const CreateAppointmentDraftDocument = gql`
    mutation CreateAppointmentDraft($appointmentId: ID!) {
  createAppointmentDraft(data: {appointment: {connect: {id: $appointmentId}}}) {
    id
    createdAt
    appointment {
      id
    }
    author {
      id
    }
  }
}
    `;
export type CreateAppointmentDraftMutationFn = Apollo.MutationFunction<CreateAppointmentDraftMutation, CreateAppointmentDraftMutationVariables>;

/**
 * __useCreateAppointmentDraftMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentDraftMutation, { data, loading, error }] = useCreateAppointmentDraftMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useCreateAppointmentDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentDraftMutation, CreateAppointmentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentDraftMutation, CreateAppointmentDraftMutationVariables>(CreateAppointmentDraftDocument, options);
      }
export type CreateAppointmentDraftMutationHookResult = ReturnType<typeof useCreateAppointmentDraftMutation>;
export type CreateAppointmentDraftMutationResult = Apollo.MutationResult<CreateAppointmentDraftMutation>;
export type CreateAppointmentDraftMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentDraftMutation, CreateAppointmentDraftMutationVariables>;
export const CreateAppointmentRequestDocument = gql`
    mutation CreateAppointmentRequest($clinicId: ID!, $doctorId: ID!, $eventId: ID!, $followUpTo: AppointmentRelateToOneForCreateInput, $memberId: ID!, $patientId: ID!, $reason: String!) {
  createAppointmentRequest(
    data: {clinic: {connect: {id: $clinicId}}, doctor: {connect: {id: $doctorId}}, event: {connect: {id: $eventId}}, followUpTo: $followUpTo, member: {connect: {id: $memberId}}, patient: {connect: {id: $patientId}}, reason: $reason}
  ) {
    id
    createdAt
    doctor {
      id
      appointmentRequests {
        id
      }
    }
    patient {
      id
      appointmentRequests {
        id
      }
    }
  }
}
    `;
export type CreateAppointmentRequestMutationFn = Apollo.MutationFunction<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;

/**
 * __useCreateAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentRequestMutation, { data, loading, error }] = useCreateAppointmentRequestMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      doctorId: // value for 'doctorId'
 *      eventId: // value for 'eventId'
 *      followUpTo: // value for 'followUpTo'
 *      memberId: // value for 'memberId'
 *      patientId: // value for 'patientId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>(CreateAppointmentRequestDocument, options);
      }
export type CreateAppointmentRequestMutationHookResult = ReturnType<typeof useCreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationResult = Apollo.MutationResult<CreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;
export const CreateBillingItemDocument = gql`
    mutation CreateBillingItem($billingId: ID!, $claimId: ID!, $diagnosisConnect: BillingDiagnosisRelateToOneForCreateInput, $premiumConnect: BillingPremiumRelateToOneForCreateInput, $units: Int) {
  createAppointmentBillingItem(
    data: {billing: {connect: {id: $billingId}}, claim: {connect: {id: $claimId}}, diagnosis: $diagnosisConnect, premium: $premiumConnect, units: $units}
  ) {
    id
    billing {
      id
      billingItems {
        id
        claim {
          id
          amount
          feeCode
        }
        diagnosis {
          id
          code
        }
        premium {
          id
          code
        }
        units
      }
      referringDoctorNumber
    }
  }
}
    `;
export type CreateBillingItemMutationFn = Apollo.MutationFunction<CreateBillingItemMutation, CreateBillingItemMutationVariables>;

/**
 * __useCreateBillingItemMutation__
 *
 * To run a mutation, you first call `useCreateBillingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingItemMutation, { data, loading, error }] = useCreateBillingItemMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *      claimId: // value for 'claimId'
 *      diagnosisConnect: // value for 'diagnosisConnect'
 *      premiumConnect: // value for 'premiumConnect'
 *      units: // value for 'units'
 *   },
 * });
 */
export function useCreateBillingItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingItemMutation, CreateBillingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingItemMutation, CreateBillingItemMutationVariables>(CreateBillingItemDocument, options);
      }
export type CreateBillingItemMutationHookResult = ReturnType<typeof useCreateBillingItemMutation>;
export type CreateBillingItemMutationResult = Apollo.MutationResult<CreateBillingItemMutation>;
export type CreateBillingItemMutationOptions = Apollo.BaseMutationOptions<CreateBillingItemMutation, CreateBillingItemMutationVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($data: BookingCreateInput!) {
  createBooking(data: $data) {
    id
  }
}
    `;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const CreateBucketFileDocument = gql`
    mutation CreateBucketFile($documentId: ID, $faxBlastId: ID, $faxId: ID, $fileKey: String!, $fileName: String!, $fileSize: Int!, $fileType: String!, $leaseAgreementId: ID, $masterLicenseId: ID, $proofOfIdentificationId: ID, $proofOfInsuranceId: ID, $proofOfLicenseId: ID, $signatureId: ID) {
  createBucketFile(
    documentId: $documentId
    faxBlastId: $faxBlastId
    faxId: $faxId
    fileKey: $fileKey
    fileName: $fileName
    fileSize: $fileSize
    fileType: $fileType
    leaseAgreementId: $leaseAgreementId
    masterLicenseId: $masterLicenseId
    proofOfIdentificationId: $proofOfIdentificationId
    proofOfInsuranceId: $proofOfInsuranceId
    proofOfLicenseId: $proofOfLicenseId
    signatureId: $signatureId
  ) {
    id
    document {
      id
    }
    faxBlast {
      id
    }
    fax {
      id
    }
    fileKey
    fileName
    fileSize
    fileType
    leaseAgreement {
      id
    }
    masterLicense {
      id
    }
    proofOfIdentification {
      id
    }
    proofOfInsurance {
      id
    }
    proofOfLicense {
      id
    }
    signature {
      id
    }
  }
}
    `;
export type CreateBucketFileMutationFn = Apollo.MutationFunction<CreateBucketFileMutation, CreateBucketFileMutationVariables>;

/**
 * __useCreateBucketFileMutation__
 *
 * To run a mutation, you first call `useCreateBucketFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBucketFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBucketFileMutation, { data, loading, error }] = useCreateBucketFileMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      faxBlastId: // value for 'faxBlastId'
 *      faxId: // value for 'faxId'
 *      fileKey: // value for 'fileKey'
 *      fileName: // value for 'fileName'
 *      fileSize: // value for 'fileSize'
 *      fileType: // value for 'fileType'
 *      leaseAgreementId: // value for 'leaseAgreementId'
 *      masterLicenseId: // value for 'masterLicenseId'
 *      proofOfIdentificationId: // value for 'proofOfIdentificationId'
 *      proofOfInsuranceId: // value for 'proofOfInsuranceId'
 *      proofOfLicenseId: // value for 'proofOfLicenseId'
 *      signatureId: // value for 'signatureId'
 *   },
 * });
 */
export function useCreateBucketFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateBucketFileMutation, CreateBucketFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBucketFileMutation, CreateBucketFileMutationVariables>(CreateBucketFileDocument, options);
      }
export type CreateBucketFileMutationHookResult = ReturnType<typeof useCreateBucketFileMutation>;
export type CreateBucketFileMutationResult = Apollo.MutationResult<CreateBucketFileMutation>;
export type CreateBucketFileMutationOptions = Apollo.BaseMutationOptions<CreateBucketFileMutation, CreateBucketFileMutationVariables>;
export const CreateChatDocument = gql`
    mutation CreateChat($appointmentId: ID!, $doctorsIds: [DoctorWhereUniqueInput!], $patientId: ID!) {
  createChat(
    data: {appointment: {connect: {id: $appointmentId}}, doctors: {connect: $doctorsIds}, patient: {connect: {id: $patientId}}}
  ) {
    id
  }
}
    `;
export type CreateChatMutationFn = Apollo.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      doctorsIds: // value for 'doctorsIds'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;
export const CreateChatMessageDocument = gql`
    mutation CreateChatMessage($data: ChatMessageCreateInput!) {
  createChatMessage(data: $data) {
    id
  }
}
    `;
export type CreateChatMessageMutationFn = Apollo.MutationFunction<CreateChatMessageMutation, CreateChatMessageMutationVariables>;

/**
 * __useCreateChatMessageMutation__
 *
 * To run a mutation, you first call `useCreateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMessageMutation, { data, loading, error }] = useCreateChatMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMessageMutation, CreateChatMessageMutationVariables>(CreateChatMessageDocument, options);
      }
export type CreateChatMessageMutationHookResult = ReturnType<typeof useCreateChatMessageMutation>;
export type CreateChatMessageMutationResult = Apollo.MutationResult<CreateChatMessageMutation>;
export type CreateChatMessageMutationOptions = Apollo.BaseMutationOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>;
export const CreateClinicAddressDocument = gql`
    mutation CreateClinicAddress($addressLine1: String!, $addressLine2: String, $administrativeArea: String!, $country: String!, $locality: String!, $postalCode: String!, $clinicId: ID!) {
  createAddress(
    data: {addressLine1: $addressLine1, addressLine2: $addressLine2, administrativeArea: $administrativeArea, country: $country, locality: $locality, postalCode: $postalCode, clinic: {connect: {id: $clinicId}}}
  ) {
    id
    addressLine1
    addressLine2
    administrativeArea
    country
    locality
    postalCode
    clinic {
      id
    }
  }
}
    `;
export type CreateClinicAddressMutationFn = Apollo.MutationFunction<CreateClinicAddressMutation, CreateClinicAddressMutationVariables>;

/**
 * __useCreateClinicAddressMutation__
 *
 * To run a mutation, you first call `useCreateClinicAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicAddressMutation, { data, loading, error }] = useCreateClinicAddressMutation({
 *   variables: {
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      administrativeArea: // value for 'administrativeArea'
 *      country: // value for 'country'
 *      locality: // value for 'locality'
 *      postalCode: // value for 'postalCode'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useCreateClinicAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicAddressMutation, CreateClinicAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicAddressMutation, CreateClinicAddressMutationVariables>(CreateClinicAddressDocument, options);
      }
export type CreateClinicAddressMutationHookResult = ReturnType<typeof useCreateClinicAddressMutation>;
export type CreateClinicAddressMutationResult = Apollo.MutationResult<CreateClinicAddressMutation>;
export type CreateClinicAddressMutationOptions = Apollo.BaseMutationOptions<CreateClinicAddressMutation, CreateClinicAddressMutationVariables>;
export const CreateClinicLeaseAgreementDocument = gql`
    mutation CreateClinicLeaseAgreement($clinicId: ID!) {
  createLeaseAgreement(data: {clinic: {connect: {id: $clinicId}}}) {
    id
    file {
      ...FileFields
    }
    clinic {
      id
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateClinicLeaseAgreementMutationFn = Apollo.MutationFunction<CreateClinicLeaseAgreementMutation, CreateClinicLeaseAgreementMutationVariables>;

/**
 * __useCreateClinicLeaseAgreementMutation__
 *
 * To run a mutation, you first call `useCreateClinicLeaseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicLeaseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicLeaseAgreementMutation, { data, loading, error }] = useCreateClinicLeaseAgreementMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useCreateClinicLeaseAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicLeaseAgreementMutation, CreateClinicLeaseAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicLeaseAgreementMutation, CreateClinicLeaseAgreementMutationVariables>(CreateClinicLeaseAgreementDocument, options);
      }
export type CreateClinicLeaseAgreementMutationHookResult = ReturnType<typeof useCreateClinicLeaseAgreementMutation>;
export type CreateClinicLeaseAgreementMutationResult = Apollo.MutationResult<CreateClinicLeaseAgreementMutation>;
export type CreateClinicLeaseAgreementMutationOptions = Apollo.BaseMutationOptions<CreateClinicLeaseAgreementMutation, CreateClinicLeaseAgreementMutationVariables>;
export const CreateClinicDocument = gql`
    mutation CreateClinic($companyId: ID!, $addressLine1: String!, $addressLine2: String, $administrativeArea: String!, $clinicDescription: String, $clinicMemberRole: RoleNameType, $clinicMemberRoleAlias: String, $clinicName: String!, $clinicPhoneNumber: String!, $country: String!, $facilityMasterNumber: String, $locality: String!, $ohipGroupNumber: String!, $postalCode: String!, $serviceLocationIndicator: String) {
  addClinic(
    companyId: $companyId
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    administrativeArea: $administrativeArea
    clinicDescription: $clinicDescription
    clinicMemberRole: $clinicMemberRole
    clinicMemberRoleAlias: $clinicMemberRoleAlias
    clinicName: $clinicName
    clinicPhoneNumber: $clinicPhoneNumber
    country: $country
    facilityMasterNumber: $facilityMasterNumber
    locality: $locality
    ohipGroupNumber: $ohipGroupNumber
    postalCode: $postalCode
    serviceLocationIndicator: $serviceLocationIndicator
  ) {
    id
    company {
      id
    }
  }
}
    `;
export type CreateClinicMutationFn = Apollo.MutationFunction<CreateClinicMutation, CreateClinicMutationVariables>;

/**
 * __useCreateClinicMutation__
 *
 * To run a mutation, you first call `useCreateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicMutation, { data, loading, error }] = useCreateClinicMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      administrativeArea: // value for 'administrativeArea'
 *      clinicDescription: // value for 'clinicDescription'
 *      clinicMemberRole: // value for 'clinicMemberRole'
 *      clinicMemberRoleAlias: // value for 'clinicMemberRoleAlias'
 *      clinicName: // value for 'clinicName'
 *      clinicPhoneNumber: // value for 'clinicPhoneNumber'
 *      country: // value for 'country'
 *      facilityMasterNumber: // value for 'facilityMasterNumber'
 *      locality: // value for 'locality'
 *      ohipGroupNumber: // value for 'ohipGroupNumber'
 *      postalCode: // value for 'postalCode'
 *      serviceLocationIndicator: // value for 'serviceLocationIndicator'
 *   },
 * });
 */
export function useCreateClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicMutation, CreateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicMutation, CreateClinicMutationVariables>(CreateClinicDocument, options);
      }
export type CreateClinicMutationHookResult = ReturnType<typeof useCreateClinicMutation>;
export type CreateClinicMutationResult = Apollo.MutationResult<CreateClinicMutation>;
export type CreateClinicMutationOptions = Apollo.BaseMutationOptions<CreateClinicMutation, CreateClinicMutationVariables>;
export const CreateCompanyLogoDocument = gql`
    mutation CreateCompanyLogo($image: Upload!, $companyId: ID!) {
  createCompanyLogo(data: {src: $image, company: {connect: {id: $companyId}}}) {
    id
    src {
      id
      publicUrlTransformed
    }
    company {
      id
    }
  }
}
    `;
export type CreateCompanyLogoMutationFn = Apollo.MutationFunction<CreateCompanyLogoMutation, CreateCompanyLogoMutationVariables>;

/**
 * __useCreateCompanyLogoMutation__
 *
 * To run a mutation, you first call `useCreateCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyLogoMutation, { data, loading, error }] = useCreateCompanyLogoMutation({
 *   variables: {
 *      image: // value for 'image'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyLogoMutation, CreateCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyLogoMutation, CreateCompanyLogoMutationVariables>(CreateCompanyLogoDocument, options);
      }
export type CreateCompanyLogoMutationHookResult = ReturnType<typeof useCreateCompanyLogoMutation>;
export type CreateCompanyLogoMutationResult = Apollo.MutationResult<CreateCompanyLogoMutation>;
export type CreateCompanyLogoMutationOptions = Apollo.BaseMutationOptions<CreateCompanyLogoMutation, CreateCompanyLogoMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($legalName: String!, $operatingName: String!) {
  addCompany(legalName: $legalName, operatingName: $operatingName) {
    id
    isOnboarded
    legalName
    logo {
      id
      src {
        id
        publicUrlTransformed
      }
    }
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      legalName: // value for 'legalName'
 *      operatingName: // value for 'operatingName'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateCompanyMasterLicenseDocument = gql`
    mutation CreateCompanyMasterLicense($companyId: ID!) {
  createMasterLicense(data: {company: {connect: {id: $companyId}}}) {
    id
    file {
      ...FileFields
    }
    company {
      id
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateCompanyMasterLicenseMutationFn = Apollo.MutationFunction<CreateCompanyMasterLicenseMutation, CreateCompanyMasterLicenseMutationVariables>;

/**
 * __useCreateCompanyMasterLicenseMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMasterLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMasterLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMasterLicenseMutation, { data, loading, error }] = useCreateCompanyMasterLicenseMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateCompanyMasterLicenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMasterLicenseMutation, CreateCompanyMasterLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMasterLicenseMutation, CreateCompanyMasterLicenseMutationVariables>(CreateCompanyMasterLicenseDocument, options);
      }
export type CreateCompanyMasterLicenseMutationHookResult = ReturnType<typeof useCreateCompanyMasterLicenseMutation>;
export type CreateCompanyMasterLicenseMutationResult = Apollo.MutationResult<CreateCompanyMasterLicenseMutation>;
export type CreateCompanyMasterLicenseMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMasterLicenseMutation, CreateCompanyMasterLicenseMutationVariables>;
export const CreateContractDocument = gql`
    mutation CreateContract($data: ContractCreateInput!) {
  createContract(data: $data) {
    id
    content
    createdAt
    effectiveFrom
    isActive
    lastUpdated
    name
    slug
    author {
      id
    }
    signedBy {
      id
    }
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const CreateCouponDocument = gql`
    mutation CreateCoupon($data: CouponCreateInput!) {
  createCoupon(data: $data) {
    id
  }
}
    `;
export type CreateCouponMutationFn = Apollo.MutationFunction<CreateCouponMutation, CreateCouponMutationVariables>;

/**
 * __useCreateCouponMutation__
 *
 * To run a mutation, you first call `useCreateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponMutation, { data, loading, error }] = useCreateCouponMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCouponMutation(baseOptions?: Apollo.MutationHookOptions<CreateCouponMutation, CreateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCouponMutation, CreateCouponMutationVariables>(CreateCouponDocument, options);
      }
export type CreateCouponMutationHookResult = ReturnType<typeof useCreateCouponMutation>;
export type CreateCouponMutationResult = Apollo.MutationResult<CreateCouponMutation>;
export type CreateCouponMutationOptions = Apollo.BaseMutationOptions<CreateCouponMutation, CreateCouponMutationVariables>;
export const CreateDoctorEventBookingDocument = gql`
    mutation CreateDoctorEventBooking($eventId: ID!, $reason: String, $startsAt: DateTime!, $tzTarget: String!, $clinicId: ID!, $memberId: ID!, $patientId: ID!) {
  createDoctorCalendarEventBooking(
    eventId: $eventId
    reason: $reason
    startsAt: $startsAt
    tzTarget: $tzTarget
    clinicId: $clinicId
    memberId: $memberId
    patientId: $patientId
  ) {
    id
  }
}
    `;
export type CreateDoctorEventBookingMutationFn = Apollo.MutationFunction<CreateDoctorEventBookingMutation, CreateDoctorEventBookingMutationVariables>;

/**
 * __useCreateDoctorEventBookingMutation__
 *
 * To run a mutation, you first call `useCreateDoctorEventBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDoctorEventBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDoctorEventBookingMutation, { data, loading, error }] = useCreateDoctorEventBookingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      reason: // value for 'reason'
 *      startsAt: // value for 'startsAt'
 *      tzTarget: // value for 'tzTarget'
 *      clinicId: // value for 'clinicId'
 *      memberId: // value for 'memberId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useCreateDoctorEventBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateDoctorEventBookingMutation, CreateDoctorEventBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDoctorEventBookingMutation, CreateDoctorEventBookingMutationVariables>(CreateDoctorEventBookingDocument, options);
      }
export type CreateDoctorEventBookingMutationHookResult = ReturnType<typeof useCreateDoctorEventBookingMutation>;
export type CreateDoctorEventBookingMutationResult = Apollo.MutationResult<CreateDoctorEventBookingMutation>;
export type CreateDoctorEventBookingMutationOptions = Apollo.BaseMutationOptions<CreateDoctorEventBookingMutation, CreateDoctorEventBookingMutationVariables>;
export const CreateDocumentAttachmentDocument = gql`
    mutation CreateDocumentAttachment($attachment: Upload!, $doctorId: ID!, $patientId: ID!, $title: String!) {
  createDocument(
    data: {doctor: {connect: {id: $doctorId}}, patient: {connect: {id: $patientId}}, title: $title, attachment: {upload: $attachment}}
  ) {
    id
    attachment {
      filename
      url
    }
    doctor {
      id
      documents {
        id
        addedAt
        title
      }
    }
    patient {
      id
      documents {
        id
        addedAt
        title
      }
    }
  }
}
    `;
export type CreateDocumentAttachmentMutationFn = Apollo.MutationFunction<CreateDocumentAttachmentMutation, CreateDocumentAttachmentMutationVariables>;

/**
 * __useCreateDocumentAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentAttachmentMutation, { data, loading, error }] = useCreateDocumentAttachmentMutation({
 *   variables: {
 *      attachment: // value for 'attachment'
 *      doctorId: // value for 'doctorId'
 *      patientId: // value for 'patientId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateDocumentAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentAttachmentMutation, CreateDocumentAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentAttachmentMutation, CreateDocumentAttachmentMutationVariables>(CreateDocumentAttachmentDocument, options);
      }
export type CreateDocumentAttachmentMutationHookResult = ReturnType<typeof useCreateDocumentAttachmentMutation>;
export type CreateDocumentAttachmentMutationResult = Apollo.MutationResult<CreateDocumentAttachmentMutation>;
export type CreateDocumentAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentAttachmentMutation, CreateDocumentAttachmentMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation CreateDocument($form: FormRelateToOneForCreateInput, $doctorId: ID!, $patientId: ID!, $title: String!, $file: FileRelateToOneForCreateInput) {
  createDocument(
    data: {form: $form, doctor: {connect: {id: $doctorId}}, patient: {connect: {id: $patientId}}, title: $title, file: $file}
  ) {
    id
    file {
      ...FileFields
    }
    doctor {
      id
      documents {
        id
        addedAt
        title
      }
    }
    patient {
      id
      documents {
        id
        addedAt
        title
      }
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      form: // value for 'form'
 *      doctorId: // value for 'doctorId'
 *      patientId: // value for 'patientId'
 *      title: // value for 'title'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const CreateDrIdDocument = gql`
    mutation CreateDrId($doctorId: ID!) {
  createProofOfIdentification(data: {doctor: {connect: {id: $doctorId}}}) {
    id
    file {
      ...FileFields
    }
    doctor {
      id
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateDrIdMutationFn = Apollo.MutationFunction<CreateDrIdMutation, CreateDrIdMutationVariables>;

/**
 * __useCreateDrIdMutation__
 *
 * To run a mutation, you first call `useCreateDrIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrIdMutation, { data, loading, error }] = useCreateDrIdMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useCreateDrIdMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrIdMutation, CreateDrIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDrIdMutation, CreateDrIdMutationVariables>(CreateDrIdDocument, options);
      }
export type CreateDrIdMutationHookResult = ReturnType<typeof useCreateDrIdMutation>;
export type CreateDrIdMutationResult = Apollo.MutationResult<CreateDrIdMutation>;
export type CreateDrIdMutationOptions = Apollo.BaseMutationOptions<CreateDrIdMutation, CreateDrIdMutationVariables>;
export const CreateDrInsuranceDocument = gql`
    mutation CreateDrInsurance($doctorId: ID!) {
  createProofOfInsurance(data: {doctor: {connect: {id: $doctorId}}}) {
    id
    file {
      ...FileFields
    }
    doctor {
      id
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateDrInsuranceMutationFn = Apollo.MutationFunction<CreateDrInsuranceMutation, CreateDrInsuranceMutationVariables>;

/**
 * __useCreateDrInsuranceMutation__
 *
 * To run a mutation, you first call `useCreateDrInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrInsuranceMutation, { data, loading, error }] = useCreateDrInsuranceMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useCreateDrInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrInsuranceMutation, CreateDrInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDrInsuranceMutation, CreateDrInsuranceMutationVariables>(CreateDrInsuranceDocument, options);
      }
export type CreateDrInsuranceMutationHookResult = ReturnType<typeof useCreateDrInsuranceMutation>;
export type CreateDrInsuranceMutationResult = Apollo.MutationResult<CreateDrInsuranceMutation>;
export type CreateDrInsuranceMutationOptions = Apollo.BaseMutationOptions<CreateDrInsuranceMutation, CreateDrInsuranceMutationVariables>;
export const CreateDrLicenseDocument = gql`
    mutation CreateDrLicense($doctorId: ID!) {
  createProofOfLicense(data: {doctor: {connect: {id: $doctorId}}}) {
    id
    file {
      ...FileFields
    }
    doctor {
      id
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateDrLicenseMutationFn = Apollo.MutationFunction<CreateDrLicenseMutation, CreateDrLicenseMutationVariables>;

/**
 * __useCreateDrLicenseMutation__
 *
 * To run a mutation, you first call `useCreateDrLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrLicenseMutation, { data, loading, error }] = useCreateDrLicenseMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useCreateDrLicenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrLicenseMutation, CreateDrLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDrLicenseMutation, CreateDrLicenseMutationVariables>(CreateDrLicenseDocument, options);
      }
export type CreateDrLicenseMutationHookResult = ReturnType<typeof useCreateDrLicenseMutation>;
export type CreateDrLicenseMutationResult = Apollo.MutationResult<CreateDrLicenseMutation>;
export type CreateDrLicenseMutationOptions = Apollo.BaseMutationOptions<CreateDrLicenseMutation, CreateDrLicenseMutationVariables>;
export const CreateDrSignatureDocument = gql`
    mutation CreateDrSignature($doctorId: ID!) {
  createSignature(data: {doctor: {connect: {id: $doctorId}}}) {
    id
    file {
      ...FileFields
    }
    doctor {
      id
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type CreateDrSignatureMutationFn = Apollo.MutationFunction<CreateDrSignatureMutation, CreateDrSignatureMutationVariables>;

/**
 * __useCreateDrSignatureMutation__
 *
 * To run a mutation, you first call `useCreateDrSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrSignatureMutation, { data, loading, error }] = useCreateDrSignatureMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useCreateDrSignatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrSignatureMutation, CreateDrSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDrSignatureMutation, CreateDrSignatureMutationVariables>(CreateDrSignatureDocument, options);
      }
export type CreateDrSignatureMutationHookResult = ReturnType<typeof useCreateDrSignatureMutation>;
export type CreateDrSignatureMutationResult = Apollo.MutationResult<CreateDrSignatureMutation>;
export type CreateDrSignatureMutationOptions = Apollo.BaseMutationOptions<CreateDrSignatureMutation, CreateDrSignatureMutationVariables>;
export const CreateEmergencyContactDocument = gql`
    mutation CreateEmergencyContact($cellPhoneNumberString: String!, $email: String, $firstName: String!, $homePhoneNumberString: String, $lastName: String!, $patientId: ID!) {
  createEmergencyContact(
    data: {cellPhoneNumberString: $cellPhoneNumberString, email: $email, firstName: $firstName, homePhoneNumberString: $homePhoneNumberString, lastName: $lastName, patient: {connect: {id: $patientId}}}
  ) {
    id
    patient {
      id
      user {
        id
        patient {
          id
          emergencyContacts {
            id
            email
            firstName
            lastName
            cellPhoneNumberString
            homePhoneNumberString
          }
        }
      }
    }
  }
}
    `;
export type CreateEmergencyContactMutationFn = Apollo.MutationFunction<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables>;

/**
 * __useCreateEmergencyContactMutation__
 *
 * To run a mutation, you first call `useCreateEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmergencyContactMutation, { data, loading, error }] = useCreateEmergencyContactMutation({
 *   variables: {
 *      cellPhoneNumberString: // value for 'cellPhoneNumberString'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      homePhoneNumberString: // value for 'homePhoneNumberString'
 *      lastName: // value for 'lastName'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useCreateEmergencyContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables>(CreateEmergencyContactDocument, options);
      }
export type CreateEmergencyContactMutationHookResult = ReturnType<typeof useCreateEmergencyContactMutation>;
export type CreateEmergencyContactMutationResult = Apollo.MutationResult<CreateEmergencyContactMutation>;
export type CreateEmergencyContactMutationOptions = Apollo.BaseMutationOptions<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables>;
export const CreateEventBookingDocument = gql`
    mutation CreateEventBooking($eventId: ID!, $reason: String, $startsAt: DateTime!, $tzTarget: String!, $clinicId: ID!, $memberId: ID!) {
  createCalendarEventBooking(
    eventId: $eventId
    reason: $reason
    startsAt: $startsAt
    tzTarget: $tzTarget
    clinicId: $clinicId
    memberId: $memberId
  ) {
    id
  }
}
    `;
export type CreateEventBookingMutationFn = Apollo.MutationFunction<CreateEventBookingMutation, CreateEventBookingMutationVariables>;

/**
 * __useCreateEventBookingMutation__
 *
 * To run a mutation, you first call `useCreateEventBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventBookingMutation, { data, loading, error }] = useCreateEventBookingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      reason: // value for 'reason'
 *      startsAt: // value for 'startsAt'
 *      tzTarget: // value for 'tzTarget'
 *      clinicId: // value for 'clinicId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCreateEventBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventBookingMutation, CreateEventBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventBookingMutation, CreateEventBookingMutationVariables>(CreateEventBookingDocument, options);
      }
export type CreateEventBookingMutationHookResult = ReturnType<typeof useCreateEventBookingMutation>;
export type CreateEventBookingMutationResult = Apollo.MutationResult<CreateEventBookingMutation>;
export type CreateEventBookingMutationOptions = Apollo.BaseMutationOptions<CreateEventBookingMutation, CreateEventBookingMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($calendarId: ID!, $doctorId: ID!, $description: String, $durationMins: Int!, $eventTypeValue: String!, $title: String!) {
  createCalendarEvent(
    data: {calendar: {connect: {id: $calendarId}}, description: $description, doctor: {connect: {id: $doctorId}}, durationMins: $durationMins, eventType: {connect: {value: $eventTypeValue}}, title: $title}
  ) {
    id
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *      doctorId: // value for 'doctorId'
 *      description: // value for 'description'
 *      durationMins: // value for 'durationMins'
 *      eventTypeValue: // value for 'eventTypeValue'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateFaxBlastDocument = gql`
    mutation CreateFaxBlast($data: FaxBlastCreateInput!) {
  createFaxBlast(data: $data) {
    id
    createdAt
    description
    title
  }
}
    `;
export type CreateFaxBlastMutationFn = Apollo.MutationFunction<CreateFaxBlastMutation, CreateFaxBlastMutationVariables>;

/**
 * __useCreateFaxBlastMutation__
 *
 * To run a mutation, you first call `useCreateFaxBlastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaxBlastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaxBlastMutation, { data, loading, error }] = useCreateFaxBlastMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFaxBlastMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaxBlastMutation, CreateFaxBlastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaxBlastMutation, CreateFaxBlastMutationVariables>(CreateFaxBlastDocument, options);
      }
export type CreateFaxBlastMutationHookResult = ReturnType<typeof useCreateFaxBlastMutation>;
export type CreateFaxBlastMutationResult = Apollo.MutationResult<CreateFaxBlastMutation>;
export type CreateFaxBlastMutationOptions = Apollo.BaseMutationOptions<CreateFaxBlastMutation, CreateFaxBlastMutationVariables>;
export const CreateFaxDocument = gql`
    mutation CreateFax($data: FaxCreateInput!) {
  createFax(data: $data) {
    id
  }
}
    `;
export type CreateFaxMutationFn = Apollo.MutationFunction<CreateFaxMutation, CreateFaxMutationVariables>;

/**
 * __useCreateFaxMutation__
 *
 * To run a mutation, you first call `useCreateFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaxMutation, { data, loading, error }] = useCreateFaxMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFaxMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaxMutation, CreateFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaxMutation, CreateFaxMutationVariables>(CreateFaxDocument, options);
      }
export type CreateFaxMutationHookResult = ReturnType<typeof useCreateFaxMutation>;
export type CreateFaxMutationResult = Apollo.MutationResult<CreateFaxMutation>;
export type CreateFaxMutationOptions = Apollo.BaseMutationOptions<CreateFaxMutation, CreateFaxMutationVariables>;
export const CreateFeedbackItemDocument = gql`
    mutation CreateFeedbackItem($summary: String!) {
  createFeedbackItem(data: {summary: $summary}) {
    id
  }
}
    `;
export type CreateFeedbackItemMutationFn = Apollo.MutationFunction<CreateFeedbackItemMutation, CreateFeedbackItemMutationVariables>;

/**
 * __useCreateFeedbackItemMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackItemMutation, { data, loading, error }] = useCreateFeedbackItemMutation({
 *   variables: {
 *      summary: // value for 'summary'
 *   },
 * });
 */
export function useCreateFeedbackItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackItemMutation, CreateFeedbackItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackItemMutation, CreateFeedbackItemMutationVariables>(CreateFeedbackItemDocument, options);
      }
export type CreateFeedbackItemMutationHookResult = ReturnType<typeof useCreateFeedbackItemMutation>;
export type CreateFeedbackItemMutationResult = Apollo.MutationResult<CreateFeedbackItemMutation>;
export type CreateFeedbackItemMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackItemMutation, CreateFeedbackItemMutationVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($appointmentId: ID!, $doctorId: ID!, $formFields: JSON!, $formTypeSlug: String!, $name: String!, $patientId: ID!, $slug: String!) {
  createForm(
    data: {appointment: {connect: {id: $appointmentId}}, doctor: {connect: {id: $doctorId}}, formFields: $formFields, name: $name, formType: {connect: {slug: $formTypeSlug}}, patient: {connect: {id: $patientId}}, slug: $slug}
  ) {
    id
  }
}
    `;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      doctorId: // value for 'doctorId'
 *      formFields: // value for 'formFields'
 *      formTypeSlug: // value for 'formTypeSlug'
 *      name: // value for 'name'
 *      patientId: // value for 'patientId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const CreateTestOptionDocument = gql`
    mutation CreateTestOption($label: String!, $value: String!, $testFor: String!) {
  createFormTest(data: {label: $label, value: $value, testFor: $testFor}) {
    id
    label
    value
    testFor
  }
}
    `;
export type CreateTestOptionMutationFn = Apollo.MutationFunction<CreateTestOptionMutation, CreateTestOptionMutationVariables>;

/**
 * __useCreateTestOptionMutation__
 *
 * To run a mutation, you first call `useCreateTestOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestOptionMutation, { data, loading, error }] = useCreateTestOptionMutation({
 *   variables: {
 *      label: // value for 'label'
 *      value: // value for 'value'
 *      testFor: // value for 'testFor'
 *   },
 * });
 */
export function useCreateTestOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestOptionMutation, CreateTestOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestOptionMutation, CreateTestOptionMutationVariables>(CreateTestOptionDocument, options);
      }
export type CreateTestOptionMutationHookResult = ReturnType<typeof useCreateTestOptionMutation>;
export type CreateTestOptionMutationResult = Apollo.MutationResult<CreateTestOptionMutation>;
export type CreateTestOptionMutationOptions = Apollo.BaseMutationOptions<CreateTestOptionMutation, CreateTestOptionMutationVariables>;
export const CreateHealthCardDocument = gql`
    mutation CreateHealthCard($patientId: ID!, $expiryDate: DateTime!, $versionCode: String, $insurancePolicyNumber: String!) {
  createHealthCard(
    data: {versionCode: $versionCode, expiryDate: $expiryDate, insurancePolicyNumber: $insurancePolicyNumber, patient: {connect: {id: $patientId}}}
  ) {
    id
    isValid
    validatedAt
    validationCode
    stateDescriptor
    patient {
      id
      user {
        id
        patient {
          id
          healthCards {
            id
            ...HealthCardFields
          }
        }
      }
    }
  }
}
    ${HealthCardFieldsFragmentDoc}`;
export type CreateHealthCardMutationFn = Apollo.MutationFunction<CreateHealthCardMutation, CreateHealthCardMutationVariables>;

/**
 * __useCreateHealthCardMutation__
 *
 * To run a mutation, you first call `useCreateHealthCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthCardMutation, { data, loading, error }] = useCreateHealthCardMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      expiryDate: // value for 'expiryDate'
 *      versionCode: // value for 'versionCode'
 *      insurancePolicyNumber: // value for 'insurancePolicyNumber'
 *   },
 * });
 */
export function useCreateHealthCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateHealthCardMutation, CreateHealthCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHealthCardMutation, CreateHealthCardMutationVariables>(CreateHealthCardDocument, options);
      }
export type CreateHealthCardMutationHookResult = ReturnType<typeof useCreateHealthCardMutation>;
export type CreateHealthCardMutationResult = Apollo.MutationResult<CreateHealthCardMutation>;
export type CreateHealthCardMutationOptions = Apollo.BaseMutationOptions<CreateHealthCardMutation, CreateHealthCardMutationVariables>;
export const CreateHealthConditionDocument = gql`
    mutation CreateHealthCondition($patientId: ID!, $diagnosedAt: DateTime, $name: String!, $relation: String!) {
  createHealthCondition(
    data: {patient: {connect: {id: $patientId}}, diagnosedAt: $diagnosedAt, name: $name, relation: $relation}
  ) {
    id
    patient {
      id
      healthConditions {
        id
        diagnosedAt
        name
        relation
      }
    }
  }
}
    `;
export type CreateHealthConditionMutationFn = Apollo.MutationFunction<CreateHealthConditionMutation, CreateHealthConditionMutationVariables>;

/**
 * __useCreateHealthConditionMutation__
 *
 * To run a mutation, you first call `useCreateHealthConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthConditionMutation, { data, loading, error }] = useCreateHealthConditionMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      diagnosedAt: // value for 'diagnosedAt'
 *      name: // value for 'name'
 *      relation: // value for 'relation'
 *   },
 * });
 */
export function useCreateHealthConditionMutation(baseOptions?: Apollo.MutationHookOptions<CreateHealthConditionMutation, CreateHealthConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHealthConditionMutation, CreateHealthConditionMutationVariables>(CreateHealthConditionDocument, options);
      }
export type CreateHealthConditionMutationHookResult = ReturnType<typeof useCreateHealthConditionMutation>;
export type CreateHealthConditionMutationResult = Apollo.MutationResult<CreateHealthConditionMutation>;
export type CreateHealthConditionMutationOptions = Apollo.BaseMutationOptions<CreateHealthConditionMutation, CreateHealthConditionMutationVariables>;
export const CreateLifestyleItemDocument = gql`
    mutation CreateLifestyleItem($patientId: ID!, $activity: String!, $frequency: String!, $item: String!) {
  createLifestyleItem(
    data: {patient: {connect: {id: $patientId}}, activity: $activity, frequency: $frequency, item: $item}
  ) {
    id
    patient {
      id
      lifestyleItems {
        id
        activity
        frequency
        item
      }
    }
  }
}
    `;
export type CreateLifestyleItemMutationFn = Apollo.MutationFunction<CreateLifestyleItemMutation, CreateLifestyleItemMutationVariables>;

/**
 * __useCreateLifestyleItemMutation__
 *
 * To run a mutation, you first call `useCreateLifestyleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLifestyleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLifestyleItemMutation, { data, loading, error }] = useCreateLifestyleItemMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      activity: // value for 'activity'
 *      frequency: // value for 'frequency'
 *      item: // value for 'item'
 *   },
 * });
 */
export function useCreateLifestyleItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateLifestyleItemMutation, CreateLifestyleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLifestyleItemMutation, CreateLifestyleItemMutationVariables>(CreateLifestyleItemDocument, options);
      }
export type CreateLifestyleItemMutationHookResult = ReturnType<typeof useCreateLifestyleItemMutation>;
export type CreateLifestyleItemMutationResult = Apollo.MutationResult<CreateLifestyleItemMutation>;
export type CreateLifestyleItemMutationOptions = Apollo.BaseMutationOptions<CreateLifestyleItemMutation, CreateLifestyleItemMutationVariables>;
export const CreateMedicalHistoryLinkDocument = gql`
    mutation CreateMedicalHistoryLink($validTo: DateTime!) {
  createMedicalHistoryLink(validTo: $validTo) {
    id
  }
}
    `;
export type CreateMedicalHistoryLinkMutationFn = Apollo.MutationFunction<CreateMedicalHistoryLinkMutation, CreateMedicalHistoryLinkMutationVariables>;

/**
 * __useCreateMedicalHistoryLinkMutation__
 *
 * To run a mutation, you first call `useCreateMedicalHistoryLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicalHistoryLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicalHistoryLinkMutation, { data, loading, error }] = useCreateMedicalHistoryLinkMutation({
 *   variables: {
 *      validTo: // value for 'validTo'
 *   },
 * });
 */
export function useCreateMedicalHistoryLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicalHistoryLinkMutation, CreateMedicalHistoryLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedicalHistoryLinkMutation, CreateMedicalHistoryLinkMutationVariables>(CreateMedicalHistoryLinkDocument, options);
      }
export type CreateMedicalHistoryLinkMutationHookResult = ReturnType<typeof useCreateMedicalHistoryLinkMutation>;
export type CreateMedicalHistoryLinkMutationResult = Apollo.MutationResult<CreateMedicalHistoryLinkMutation>;
export type CreateMedicalHistoryLinkMutationOptions = Apollo.BaseMutationOptions<CreateMedicalHistoryLinkMutation, CreateMedicalHistoryLinkMutationVariables>;
export const CreateMedicationItemsDocument = gql`
    mutation CreateMedicationItems($medicationItemsData: [MedicationItemCreateInput!]!) {
  createMedicationItems(data: $medicationItemsData) {
    id
  }
}
    `;
export type CreateMedicationItemsMutationFn = Apollo.MutationFunction<CreateMedicationItemsMutation, CreateMedicationItemsMutationVariables>;

/**
 * __useCreateMedicationItemsMutation__
 *
 * To run a mutation, you first call `useCreateMedicationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicationItemsMutation, { data, loading, error }] = useCreateMedicationItemsMutation({
 *   variables: {
 *      medicationItemsData: // value for 'medicationItemsData'
 *   },
 * });
 */
export function useCreateMedicationItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicationItemsMutation, CreateMedicationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedicationItemsMutation, CreateMedicationItemsMutationVariables>(CreateMedicationItemsDocument, options);
      }
export type CreateMedicationItemsMutationHookResult = ReturnType<typeof useCreateMedicationItemsMutation>;
export type CreateMedicationItemsMutationResult = Apollo.MutationResult<CreateMedicationItemsMutation>;
export type CreateMedicationItemsMutationOptions = Apollo.BaseMutationOptions<CreateMedicationItemsMutation, CreateMedicationItemsMutationVariables>;
export const CreateMedicationItemDocument = gql`
    mutation CreateMedicationItem($doctorId: ID!, $instructions: String, $medicationId: ID!, $patientId: ID!, $prescribedAt: DateTime!, $refills: Int!) {
  createMedicationItem(
    data: {doctor: {connect: {id: $doctorId}}, instructions: $instructions, medication: {connect: {id: $medicationId}}, patient: {connect: {id: $patientId}}, prescribedAt: $prescribedAt, refills: $refills}
  ) {
    id
  }
}
    `;
export type CreateMedicationItemMutationFn = Apollo.MutationFunction<CreateMedicationItemMutation, CreateMedicationItemMutationVariables>;

/**
 * __useCreateMedicationItemMutation__
 *
 * To run a mutation, you first call `useCreateMedicationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicationItemMutation, { data, loading, error }] = useCreateMedicationItemMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      instructions: // value for 'instructions'
 *      medicationId: // value for 'medicationId'
 *      patientId: // value for 'patientId'
 *      prescribedAt: // value for 'prescribedAt'
 *      refills: // value for 'refills'
 *   },
 * });
 */
export function useCreateMedicationItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicationItemMutation, CreateMedicationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedicationItemMutation, CreateMedicationItemMutationVariables>(CreateMedicationItemDocument, options);
      }
export type CreateMedicationItemMutationHookResult = ReturnType<typeof useCreateMedicationItemMutation>;
export type CreateMedicationItemMutationResult = Apollo.MutationResult<CreateMedicationItemMutation>;
export type CreateMedicationItemMutationOptions = Apollo.BaseMutationOptions<CreateMedicationItemMutation, CreateMedicationItemMutationVariables>;
export const CreateMemberDataImportIntentDocument = gql`
    mutation CreateMemberDataImportIntent($memberId: ID!, $source: String!) {
  createMemberDataImportIntent(memberId: $memberId, source: $source) {
    id
  }
}
    `;
export type CreateMemberDataImportIntentMutationFn = Apollo.MutationFunction<CreateMemberDataImportIntentMutation, CreateMemberDataImportIntentMutationVariables>;

/**
 * __useCreateMemberDataImportIntentMutation__
 *
 * To run a mutation, you first call `useCreateMemberDataImportIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMemberDataImportIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMemberDataImportIntentMutation, { data, loading, error }] = useCreateMemberDataImportIntentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCreateMemberDataImportIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMemberDataImportIntentMutation, CreateMemberDataImportIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMemberDataImportIntentMutation, CreateMemberDataImportIntentMutationVariables>(CreateMemberDataImportIntentDocument, options);
      }
export type CreateMemberDataImportIntentMutationHookResult = ReturnType<typeof useCreateMemberDataImportIntentMutation>;
export type CreateMemberDataImportIntentMutationResult = Apollo.MutationResult<CreateMemberDataImportIntentMutation>;
export type CreateMemberDataImportIntentMutationOptions = Apollo.BaseMutationOptions<CreateMemberDataImportIntentMutation, CreateMemberDataImportIntentMutationVariables>;
export const AddMemberDocument = gql`
    mutation AddMember($userId: ID!, $companyId: ID!, $clinicId: ID!, $clinicMemberRole: RoleNameType!, $clinicMemberRoleAlias: String) {
  addMember(
    userId: $userId
    companyId: $companyId
    clinicId: $clinicId
    clinicMemberRole: $clinicMemberRole
    clinicMemberRoleAlias: $clinicMemberRoleAlias
  ) {
    id
    clinic {
      id
      company {
        id
      }
    }
  }
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *      clinicId: // value for 'clinicId'
 *      clinicMemberRole: // value for 'clinicMemberRole'
 *      clinicMemberRoleAlias: // value for 'clinicMemberRoleAlias'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const CreatePrescriptionItemDocument = gql`
    mutation CreatePrescriptionItem($prescriptionId: ID!, $refills: String, $luCode: String, $instructions: String, $drugCode: String!) {
  createPrescriptionItem(
    data: {prescription: {connect: {id: $prescriptionId}}, refills: $refills, luCode: $luCode, instructions: $instructions, medication: {connect: {drugCode: $drugCode}}}
  ) {
    id
    prescription {
      id
      prescriptionItems {
        id
        instructions
        luCode
        refills
        medication {
          id
          brandName
        }
      }
    }
  }
}
    `;
export type CreatePrescriptionItemMutationFn = Apollo.MutationFunction<CreatePrescriptionItemMutation, CreatePrescriptionItemMutationVariables>;

/**
 * __useCreatePrescriptionItemMutation__
 *
 * To run a mutation, you first call `useCreatePrescriptionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrescriptionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrescriptionItemMutation, { data, loading, error }] = useCreatePrescriptionItemMutation({
 *   variables: {
 *      prescriptionId: // value for 'prescriptionId'
 *      refills: // value for 'refills'
 *      luCode: // value for 'luCode'
 *      instructions: // value for 'instructions'
 *      drugCode: // value for 'drugCode'
 *   },
 * });
 */
export function useCreatePrescriptionItemMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrescriptionItemMutation, CreatePrescriptionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrescriptionItemMutation, CreatePrescriptionItemMutationVariables>(CreatePrescriptionItemDocument, options);
      }
export type CreatePrescriptionItemMutationHookResult = ReturnType<typeof useCreatePrescriptionItemMutation>;
export type CreatePrescriptionItemMutationResult = Apollo.MutationResult<CreatePrescriptionItemMutation>;
export type CreatePrescriptionItemMutationOptions = Apollo.BaseMutationOptions<CreatePrescriptionItemMutation, CreatePrescriptionItemMutationVariables>;
export const CreateRecurringSlotDocument = gql`
    mutation CreateRecurringSlot($wday: String!, $interval: String!, $intervalCount: Int!, $scheduleId: ID!) {
  createRecurringSlot(
    data: {wday: $wday, interval: $interval, intervalCount: $intervalCount, schedule: {connect: {id: $scheduleId}}}
  ) {
    id
  }
}
    `;
export type CreateRecurringSlotMutationFn = Apollo.MutationFunction<CreateRecurringSlotMutation, CreateRecurringSlotMutationVariables>;

/**
 * __useCreateRecurringSlotMutation__
 *
 * To run a mutation, you first call `useCreateRecurringSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringSlotMutation, { data, loading, error }] = useCreateRecurringSlotMutation({
 *   variables: {
 *      wday: // value for 'wday'
 *      interval: // value for 'interval'
 *      intervalCount: // value for 'intervalCount'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useCreateRecurringSlotMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringSlotMutation, CreateRecurringSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringSlotMutation, CreateRecurringSlotMutationVariables>(CreateRecurringSlotDocument, options);
      }
export type CreateRecurringSlotMutationHookResult = ReturnType<typeof useCreateRecurringSlotMutation>;
export type CreateRecurringSlotMutationResult = Apollo.MutationResult<CreateRecurringSlotMutation>;
export type CreateRecurringSlotMutationOptions = Apollo.BaseMutationOptions<CreateRecurringSlotMutation, CreateRecurringSlotMutationVariables>;
export const CreateScheduleDocument = gql`
    mutation CreateSchedule($calendarId: ID!, $defaultOn: CalendarRelateToOneForCreateInput, $description: String, $title: String!) {
  createSchedule(
    data: {calendar: {connect: {id: $calendarId}}, defaultOn: $defaultOn, title: $title, description: $description}
  ) {
    id
  }
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *      defaultOn: // value for 'defaultOn'
 *      description: // value for 'description'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const CreateScreeningTestDocument = gql`
    mutation CreateScreeningTest($patientId: ID!, $name: String!, $testedAt: DateTime!) {
  createScreeningTest(
    data: {patient: {connect: {id: $patientId}}, name: $name, testedAt: $testedAt}
  ) {
    id
    patient {
      id
      screeningTests {
        id
        name
        testedAt
      }
    }
  }
}
    `;
export type CreateScreeningTestMutationFn = Apollo.MutationFunction<CreateScreeningTestMutation, CreateScreeningTestMutationVariables>;

/**
 * __useCreateScreeningTestMutation__
 *
 * To run a mutation, you first call `useCreateScreeningTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreeningTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreeningTestMutation, { data, loading, error }] = useCreateScreeningTestMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      name: // value for 'name'
 *      testedAt: // value for 'testedAt'
 *   },
 * });
 */
export function useCreateScreeningTestMutation(baseOptions?: Apollo.MutationHookOptions<CreateScreeningTestMutation, CreateScreeningTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScreeningTestMutation, CreateScreeningTestMutationVariables>(CreateScreeningTestDocument, options);
      }
export type CreateScreeningTestMutationHookResult = ReturnType<typeof useCreateScreeningTestMutation>;
export type CreateScreeningTestMutationResult = Apollo.MutationResult<CreateScreeningTestMutation>;
export type CreateScreeningTestMutationOptions = Apollo.BaseMutationOptions<CreateScreeningTestMutation, CreateScreeningTestMutationVariables>;
export const CreateStepperProgDocument = gql`
    mutation CreateStepperProg($stepperId: ID!, $userId: ID!) {
  createStepperProg(
    data: {stepper: {connect: {id: $stepperId}}, user: {connect: {id: $userId}}}
  ) {
    id
  }
}
    `;
export type CreateStepperProgMutationFn = Apollo.MutationFunction<CreateStepperProgMutation, CreateStepperProgMutationVariables>;

/**
 * __useCreateStepperProgMutation__
 *
 * To run a mutation, you first call `useCreateStepperProgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStepperProgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStepperProgMutation, { data, loading, error }] = useCreateStepperProgMutation({
 *   variables: {
 *      stepperId: // value for 'stepperId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateStepperProgMutation(baseOptions?: Apollo.MutationHookOptions<CreateStepperProgMutation, CreateStepperProgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStepperProgMutation, CreateStepperProgMutationVariables>(CreateStepperProgDocument, options);
      }
export type CreateStepperProgMutationHookResult = ReturnType<typeof useCreateStepperProgMutation>;
export type CreateStepperProgMutationResult = Apollo.MutationResult<CreateStepperProgMutation>;
export type CreateStepperProgMutationOptions = Apollo.BaseMutationOptions<CreateStepperProgMutation, CreateStepperProgMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($data: TaskCreateInput!) {
  createTask(data: $data) {
    id
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateTestsBatchDocument = gql`
    mutation CreateTestsBatch($data: TestsBatchCreateInput!) {
  createTestsBatch(data: $data) {
    id
    name
    doctor {
      id
    }
    formTests {
      id
      label
      value
    }
    formType {
      id
      name
      slug
    }
  }
}
    `;
export type CreateTestsBatchMutationFn = Apollo.MutationFunction<CreateTestsBatchMutation, CreateTestsBatchMutationVariables>;

/**
 * __useCreateTestsBatchMutation__
 *
 * To run a mutation, you first call `useCreateTestsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestsBatchMutation, { data, loading, error }] = useCreateTestsBatchMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTestsBatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestsBatchMutation, CreateTestsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestsBatchMutation, CreateTestsBatchMutationVariables>(CreateTestsBatchDocument, options);
      }
export type CreateTestsBatchMutationHookResult = ReturnType<typeof useCreateTestsBatchMutation>;
export type CreateTestsBatchMutationResult = Apollo.MutationResult<CreateTestsBatchMutation>;
export type CreateTestsBatchMutationOptions = Apollo.BaseMutationOptions<CreateTestsBatchMutation, CreateTestsBatchMutationVariables>;
export const CreateTestOrdersDocument = gql`
    mutation CreateTestOrders($data: [TestOrderCreateInput!]!) {
  createTestOrders(data: $data) {
    id
  }
}
    `;
export type CreateTestOrdersMutationFn = Apollo.MutationFunction<CreateTestOrdersMutation, CreateTestOrdersMutationVariables>;

/**
 * __useCreateTestOrdersMutation__
 *
 * To run a mutation, you first call `useCreateTestOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestOrdersMutation, { data, loading, error }] = useCreateTestOrdersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTestOrdersMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestOrdersMutation, CreateTestOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestOrdersMutation, CreateTestOrdersMutationVariables>(CreateTestOrdersDocument, options);
      }
export type CreateTestOrdersMutationHookResult = ReturnType<typeof useCreateTestOrdersMutation>;
export type CreateTestOrdersMutationResult = Apollo.MutationResult<CreateTestOrdersMutation>;
export type CreateTestOrdersMutationOptions = Apollo.BaseMutationOptions<CreateTestOrdersMutation, CreateTestOrdersMutationVariables>;
export const CreateTimeIntervalDocument = gql`
    mutation CreateTimeInterval($from: String!, $to: String!, $recurringSlotId: ID!) {
  createTimeInterval(
    data: {from: $from, to: $to, recurringSlot: {connect: {id: $recurringSlotId}}}
  ) {
    id
  }
}
    `;
export type CreateTimeIntervalMutationFn = Apollo.MutationFunction<CreateTimeIntervalMutation, CreateTimeIntervalMutationVariables>;

/**
 * __useCreateTimeIntervalMutation__
 *
 * To run a mutation, you first call `useCreateTimeIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeIntervalMutation, { data, loading, error }] = useCreateTimeIntervalMutation({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      recurringSlotId: // value for 'recurringSlotId'
 *   },
 * });
 */
export function useCreateTimeIntervalMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeIntervalMutation, CreateTimeIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeIntervalMutation, CreateTimeIntervalMutationVariables>(CreateTimeIntervalDocument, options);
      }
export type CreateTimeIntervalMutationHookResult = ReturnType<typeof useCreateTimeIntervalMutation>;
export type CreateTimeIntervalMutationResult = Apollo.MutationResult<CreateTimeIntervalMutation>;
export type CreateTimeIntervalMutationOptions = Apollo.BaseMutationOptions<CreateTimeIntervalMutation, CreateTimeIntervalMutationVariables>;
export const CreateUserAddressDocument = gql`
    mutation CreateUserAddress($addressLine1: String!, $addressLine2: String, $administrativeArea: String!, $country: String!, $locality: String!, $postalCode: String!, $userId: ID!) {
  createAddress(
    data: {addressLine1: $addressLine1, addressLine2: $addressLine2, administrativeArea: $administrativeArea, country: $country, locality: $locality, postalCode: $postalCode, user: {connect: {id: $userId}}}
  ) {
    id
    addressLine1
    addressLine2
    administrativeArea
    country
    locality
    postalCode
    user {
      id
    }
  }
}
    `;
export type CreateUserAddressMutationFn = Apollo.MutationFunction<CreateUserAddressMutation, CreateUserAddressMutationVariables>;

/**
 * __useCreateUserAddressMutation__
 *
 * To run a mutation, you first call `useCreateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAddressMutation, { data, loading, error }] = useCreateUserAddressMutation({
 *   variables: {
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      administrativeArea: // value for 'administrativeArea'
 *      country: // value for 'country'
 *      locality: // value for 'locality'
 *      postalCode: // value for 'postalCode'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserAddressMutation, CreateUserAddressMutationVariables>(CreateUserAddressDocument, options);
      }
export type CreateUserAddressMutationHookResult = ReturnType<typeof useCreateUserAddressMutation>;
export type CreateUserAddressMutationResult = Apollo.MutationResult<CreateUserAddressMutation>;
export type CreateUserAddressMutationOptions = Apollo.BaseMutationOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>;
export const CreateUserDoctorDocument = gql`
    mutation CreateUserDoctor($userId: ID!, $doctorSince: DateTime) {
  createDoctor(data: {doctorSince: $doctorSince, user: {connect: {id: $userId}}}) {
    ...DoctorBasicFields
  }
}
    ${DoctorBasicFieldsFragmentDoc}`;
export type CreateUserDoctorMutationFn = Apollo.MutationFunction<CreateUserDoctorMutation, CreateUserDoctorMutationVariables>;

/**
 * __useCreateUserDoctorMutation__
 *
 * To run a mutation, you first call `useCreateUserDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDoctorMutation, { data, loading, error }] = useCreateUserDoctorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      doctorSince: // value for 'doctorSince'
 *   },
 * });
 */
export function useCreateUserDoctorMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDoctorMutation, CreateUserDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDoctorMutation, CreateUserDoctorMutationVariables>(CreateUserDoctorDocument, options);
      }
export type CreateUserDoctorMutationHookResult = ReturnType<typeof useCreateUserDoctorMutation>;
export type CreateUserDoctorMutationResult = Apollo.MutationResult<CreateUserDoctorMutation>;
export type CreateUserDoctorMutationOptions = Apollo.BaseMutationOptions<CreateUserDoctorMutation, CreateUserDoctorMutationVariables>;
export const CreateUserProfilePhotoDocument = gql`
    mutation CreateUserProfilePhoto($userId: ID!) {
  createProfilePhoto(data: {user: {connect: {id: $userId}}}) {
    id
    src {
      id
      publicUrlTransformed
    }
    user {
      id
    }
  }
}
    `;
export type CreateUserProfilePhotoMutationFn = Apollo.MutationFunction<CreateUserProfilePhotoMutation, CreateUserProfilePhotoMutationVariables>;

/**
 * __useCreateUserProfilePhotoMutation__
 *
 * To run a mutation, you first call `useCreateUserProfilePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserProfilePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserProfilePhotoMutation, { data, loading, error }] = useCreateUserProfilePhotoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateUserProfilePhotoMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserProfilePhotoMutation, CreateUserProfilePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserProfilePhotoMutation, CreateUserProfilePhotoMutationVariables>(CreateUserProfilePhotoDocument, options);
      }
export type CreateUserProfilePhotoMutationHookResult = ReturnType<typeof useCreateUserProfilePhotoMutation>;
export type CreateUserProfilePhotoMutationResult = Apollo.MutationResult<CreateUserProfilePhotoMutation>;
export type CreateUserProfilePhotoMutationOptions = Apollo.BaseMutationOptions<CreateUserProfilePhotoMutation, CreateUserProfilePhotoMutationVariables>;
export const CreateVaccinationDocument = gql`
    mutation CreateVaccination($doctorId: ID!, $patientId: ID!, $immunizedAt: DateTime, $expirationDate: DateTime, $drugCode: String!) {
  createVaccination(
    data: {doctor: {connect: {id: $doctorId}}, patient: {connect: {id: $patientId}}, immunizedAt: $immunizedAt, expirationDate: $expirationDate, medication: {connect: {drugCode: $drugCode}}}
  ) {
    id
    doctor {
      id
      vaccinations {
        id
        expirationDate
        immunizedAt
        medication {
          id
          brandName
        }
      }
    }
    patient {
      id
      vaccinations {
        id
        expirationDate
        immunizedAt
        medication {
          id
          brandName
        }
      }
    }
  }
}
    `;
export type CreateVaccinationMutationFn = Apollo.MutationFunction<CreateVaccinationMutation, CreateVaccinationMutationVariables>;

/**
 * __useCreateVaccinationMutation__
 *
 * To run a mutation, you first call `useCreateVaccinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVaccinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVaccinationMutation, { data, loading, error }] = useCreateVaccinationMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      patientId: // value for 'patientId'
 *      immunizedAt: // value for 'immunizedAt'
 *      expirationDate: // value for 'expirationDate'
 *      drugCode: // value for 'drugCode'
 *   },
 * });
 */
export function useCreateVaccinationMutation(baseOptions?: Apollo.MutationHookOptions<CreateVaccinationMutation, CreateVaccinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVaccinationMutation, CreateVaccinationMutationVariables>(CreateVaccinationDocument, options);
      }
export type CreateVaccinationMutationHookResult = ReturnType<typeof useCreateVaccinationMutation>;
export type CreateVaccinationMutationResult = Apollo.MutationResult<CreateVaccinationMutation>;
export type CreateVaccinationMutationOptions = Apollo.BaseMutationOptions<CreateVaccinationMutation, CreateVaccinationMutationVariables>;
export const CreateWalkInAppointmentDocument = gql`
    mutation CreateWalkInAppointment($eventId: ID!, $isInvalidHealthCard: Boolean, $patientId: ID!, $reason: String!, $clinicId: ID!, $memberId: ID!) {
  createWalkInAppointment(
    eventId: $eventId
    isInvalidHealthCard: $isInvalidHealthCard
    patientId: $patientId
    reason: $reason
    clinicId: $clinicId
    memberId: $memberId
  ) {
    id
  }
}
    `;
export type CreateWalkInAppointmentMutationFn = Apollo.MutationFunction<CreateWalkInAppointmentMutation, CreateWalkInAppointmentMutationVariables>;

/**
 * __useCreateWalkInAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateWalkInAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWalkInAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWalkInAppointmentMutation, { data, loading, error }] = useCreateWalkInAppointmentMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      isInvalidHealthCard: // value for 'isInvalidHealthCard'
 *      patientId: // value for 'patientId'
 *      reason: // value for 'reason'
 *      clinicId: // value for 'clinicId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCreateWalkInAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateWalkInAppointmentMutation, CreateWalkInAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWalkInAppointmentMutation, CreateWalkInAppointmentMutationVariables>(CreateWalkInAppointmentDocument, options);
      }
export type CreateWalkInAppointmentMutationHookResult = ReturnType<typeof useCreateWalkInAppointmentMutation>;
export type CreateWalkInAppointmentMutationResult = Apollo.MutationResult<CreateWalkInAppointmentMutation>;
export type CreateWalkInAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateWalkInAppointmentMutation, CreateWalkInAppointmentMutationVariables>;
export const DeleteBillingItemDocument = gql`
    mutation DeleteBillingItem($billingItemId: ID!) {
  deleteAppointmentBillingItem(where: {id: $billingItemId}) {
    id
    billing {
      id
      billingItems {
        id
      }
    }
  }
}
    `;
export type DeleteBillingItemMutationFn = Apollo.MutationFunction<DeleteBillingItemMutation, DeleteBillingItemMutationVariables>;

/**
 * __useDeleteBillingItemMutation__
 *
 * To run a mutation, you first call `useDeleteBillingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillingItemMutation, { data, loading, error }] = useDeleteBillingItemMutation({
 *   variables: {
 *      billingItemId: // value for 'billingItemId'
 *   },
 * });
 */
export function useDeleteBillingItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBillingItemMutation, DeleteBillingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBillingItemMutation, DeleteBillingItemMutationVariables>(DeleteBillingItemDocument, options);
      }
export type DeleteBillingItemMutationHookResult = ReturnType<typeof useDeleteBillingItemMutation>;
export type DeleteBillingItemMutationResult = Apollo.MutationResult<DeleteBillingItemMutation>;
export type DeleteBillingItemMutationOptions = Apollo.BaseMutationOptions<DeleteBillingItemMutation, DeleteBillingItemMutationVariables>;
export const DeleteCompanyLogoDocument = gql`
    mutation DeleteCompanyLogo($companyLogoId: ID!) {
  deleteCompanyLogo(where: {id: $companyLogoId}) {
    id
  }
}
    `;
export type DeleteCompanyLogoMutationFn = Apollo.MutationFunction<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>;

/**
 * __useDeleteCompanyLogoMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyLogoMutation, { data, loading, error }] = useDeleteCompanyLogoMutation({
 *   variables: {
 *      companyLogoId: // value for 'companyLogoId'
 *   },
 * });
 */
export function useDeleteCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>(DeleteCompanyLogoDocument, options);
      }
export type DeleteCompanyLogoMutationHookResult = ReturnType<typeof useDeleteCompanyLogoMutation>;
export type DeleteCompanyLogoMutationResult = Apollo.MutationResult<DeleteCompanyLogoMutation>;
export type DeleteCompanyLogoMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyLogoMutation, DeleteCompanyLogoMutationVariables>;
export const DeleteDrIdDocument = gql`
    mutation DeleteDrId($id: ID!) {
  deleteProofOfIdentification(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteDrIdMutationFn = Apollo.MutationFunction<DeleteDrIdMutation, DeleteDrIdMutationVariables>;

/**
 * __useDeleteDrIdMutation__
 *
 * To run a mutation, you first call `useDeleteDrIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDrIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDrIdMutation, { data, loading, error }] = useDeleteDrIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDrIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDrIdMutation, DeleteDrIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDrIdMutation, DeleteDrIdMutationVariables>(DeleteDrIdDocument, options);
      }
export type DeleteDrIdMutationHookResult = ReturnType<typeof useDeleteDrIdMutation>;
export type DeleteDrIdMutationResult = Apollo.MutationResult<DeleteDrIdMutation>;
export type DeleteDrIdMutationOptions = Apollo.BaseMutationOptions<DeleteDrIdMutation, DeleteDrIdMutationVariables>;
export const DeleteDrInsuranceDocument = gql`
    mutation DeleteDrInsurance($id: ID!) {
  deleteProofOfInsurance(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteDrInsuranceMutationFn = Apollo.MutationFunction<DeleteDrInsuranceMutation, DeleteDrInsuranceMutationVariables>;

/**
 * __useDeleteDrInsuranceMutation__
 *
 * To run a mutation, you first call `useDeleteDrInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDrInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDrInsuranceMutation, { data, loading, error }] = useDeleteDrInsuranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDrInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDrInsuranceMutation, DeleteDrInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDrInsuranceMutation, DeleteDrInsuranceMutationVariables>(DeleteDrInsuranceDocument, options);
      }
export type DeleteDrInsuranceMutationHookResult = ReturnType<typeof useDeleteDrInsuranceMutation>;
export type DeleteDrInsuranceMutationResult = Apollo.MutationResult<DeleteDrInsuranceMutation>;
export type DeleteDrInsuranceMutationOptions = Apollo.BaseMutationOptions<DeleteDrInsuranceMutation, DeleteDrInsuranceMutationVariables>;
export const DeleteDrLicenseDocument = gql`
    mutation DeleteDrLicense($id: ID!) {
  deleteProofOfLicense(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteDrLicenseMutationFn = Apollo.MutationFunction<DeleteDrLicenseMutation, DeleteDrLicenseMutationVariables>;

/**
 * __useDeleteDrLicenseMutation__
 *
 * To run a mutation, you first call `useDeleteDrLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDrLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDrLicenseMutation, { data, loading, error }] = useDeleteDrLicenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDrLicenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDrLicenseMutation, DeleteDrLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDrLicenseMutation, DeleteDrLicenseMutationVariables>(DeleteDrLicenseDocument, options);
      }
export type DeleteDrLicenseMutationHookResult = ReturnType<typeof useDeleteDrLicenseMutation>;
export type DeleteDrLicenseMutationResult = Apollo.MutationResult<DeleteDrLicenseMutation>;
export type DeleteDrLicenseMutationOptions = Apollo.BaseMutationOptions<DeleteDrLicenseMutation, DeleteDrLicenseMutationVariables>;
export const DeleteEmergencyContactDocument = gql`
    mutation DeleteEmergencyContact($emergencyContactId: ID!) {
  deleteEmergencyContact(where: {id: $emergencyContactId}) {
    id
  }
}
    `;
export type DeleteEmergencyContactMutationFn = Apollo.MutationFunction<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables>;

/**
 * __useDeleteEmergencyContactMutation__
 *
 * To run a mutation, you first call `useDeleteEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmergencyContactMutation, { data, loading, error }] = useDeleteEmergencyContactMutation({
 *   variables: {
 *      emergencyContactId: // value for 'emergencyContactId'
 *   },
 * });
 */
export function useDeleteEmergencyContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables>(DeleteEmergencyContactDocument, options);
      }
export type DeleteEmergencyContactMutationHookResult = ReturnType<typeof useDeleteEmergencyContactMutation>;
export type DeleteEmergencyContactMutationResult = Apollo.MutationResult<DeleteEmergencyContactMutation>;
export type DeleteEmergencyContactMutationOptions = Apollo.BaseMutationOptions<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables>;
export const DeleteFormDocument = gql`
    mutation DeleteForm($formId: ID!) {
  deleteForm(where: {id: $formId}) {
    id
  }
}
    `;
export type DeleteFormMutationFn = Apollo.MutationFunction<DeleteFormMutation, DeleteFormMutationVariables>;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDeleteFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(DeleteFormDocument, options);
      }
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>;
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>;
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormMutation, DeleteFormMutationVariables>;
export const DeleteHealthCardDocument = gql`
    mutation DeleteHealthCard($healthCardId: ID!) {
  deleteHealthCard(where: {id: $healthCardId}) {
    id
    patient {
      id
      healthCards {
        id
      }
    }
  }
}
    `;
export type DeleteHealthCardMutationFn = Apollo.MutationFunction<DeleteHealthCardMutation, DeleteHealthCardMutationVariables>;

/**
 * __useDeleteHealthCardMutation__
 *
 * To run a mutation, you first call `useDeleteHealthCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHealthCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHealthCardMutation, { data, loading, error }] = useDeleteHealthCardMutation({
 *   variables: {
 *      healthCardId: // value for 'healthCardId'
 *   },
 * });
 */
export function useDeleteHealthCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHealthCardMutation, DeleteHealthCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHealthCardMutation, DeleteHealthCardMutationVariables>(DeleteHealthCardDocument, options);
      }
export type DeleteHealthCardMutationHookResult = ReturnType<typeof useDeleteHealthCardMutation>;
export type DeleteHealthCardMutationResult = Apollo.MutationResult<DeleteHealthCardMutation>;
export type DeleteHealthCardMutationOptions = Apollo.BaseMutationOptions<DeleteHealthCardMutation, DeleteHealthCardMutationVariables>;
export const DeletePrescriptionItemDocument = gql`
    mutation DeletePrescriptionItem($prescriptionItemId: ID!) {
  deletePrescriptionItem(where: {id: $prescriptionItemId}) {
    id
    prescription {
      id
      prescriptionItems {
        id
      }
    }
  }
}
    `;
export type DeletePrescriptionItemMutationFn = Apollo.MutationFunction<DeletePrescriptionItemMutation, DeletePrescriptionItemMutationVariables>;

/**
 * __useDeletePrescriptionItemMutation__
 *
 * To run a mutation, you first call `useDeletePrescriptionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrescriptionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrescriptionItemMutation, { data, loading, error }] = useDeletePrescriptionItemMutation({
 *   variables: {
 *      prescriptionItemId: // value for 'prescriptionItemId'
 *   },
 * });
 */
export function useDeletePrescriptionItemMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrescriptionItemMutation, DeletePrescriptionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrescriptionItemMutation, DeletePrescriptionItemMutationVariables>(DeletePrescriptionItemDocument, options);
      }
export type DeletePrescriptionItemMutationHookResult = ReturnType<typeof useDeletePrescriptionItemMutation>;
export type DeletePrescriptionItemMutationResult = Apollo.MutationResult<DeletePrescriptionItemMutation>;
export type DeletePrescriptionItemMutationOptions = Apollo.BaseMutationOptions<DeletePrescriptionItemMutation, DeletePrescriptionItemMutationVariables>;
export const DeleteProfilePhotoDocument = gql`
    mutation DeleteProfilePhoto($profilePhotoId: ID!) {
  deleteProfilePhoto(where: {id: $profilePhotoId}) {
    id
    user {
      ...UserPhotoFields
    }
  }
}
    ${UserPhotoFieldsFragmentDoc}`;
export type DeleteProfilePhotoMutationFn = Apollo.MutationFunction<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>;

/**
 * __useDeleteProfilePhotoMutation__
 *
 * To run a mutation, you first call `useDeleteProfilePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfilePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfilePhotoMutation, { data, loading, error }] = useDeleteProfilePhotoMutation({
 *   variables: {
 *      profilePhotoId: // value for 'profilePhotoId'
 *   },
 * });
 */
export function useDeleteProfilePhotoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>(DeleteProfilePhotoDocument, options);
      }
export type DeleteProfilePhotoMutationHookResult = ReturnType<typeof useDeleteProfilePhotoMutation>;
export type DeleteProfilePhotoMutationResult = Apollo.MutationResult<DeleteProfilePhotoMutation>;
export type DeleteProfilePhotoMutationOptions = Apollo.BaseMutationOptions<DeleteProfilePhotoMutation, DeleteProfilePhotoMutationVariables>;
export const DeleteScheduleDocument = gql`
    mutation DeleteSchedule($scheduleId: ID!) {
  deleteSchedule(where: {id: $scheduleId}) {
    id
  }
}
    `;
export type DeleteScheduleMutationFn = Apollo.MutationFunction<DeleteScheduleMutation, DeleteScheduleMutationVariables>;

/**
 * __useDeleteScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutation, { data, loading, error }] = useDeleteScheduleMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useDeleteScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleMutation, DeleteScheduleMutationVariables>(DeleteScheduleDocument, options);
      }
export type DeleteScheduleMutationHookResult = ReturnType<typeof useDeleteScheduleMutation>;
export type DeleteScheduleMutationResult = Apollo.MutationResult<DeleteScheduleMutation>;
export type DeleteScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export const DeleteTestsBatchDocument = gql`
    mutation DeleteTestsBatch($testsBatchId: ID!) {
  deleteTestsBatch(where: {id: $testsBatchId}) {
    id
    name
    doctor {
      id
    }
    formTests {
      id
      label
      value
    }
    formType {
      id
      name
      slug
    }
  }
}
    `;
export type DeleteTestsBatchMutationFn = Apollo.MutationFunction<DeleteTestsBatchMutation, DeleteTestsBatchMutationVariables>;

/**
 * __useDeleteTestsBatchMutation__
 *
 * To run a mutation, you first call `useDeleteTestsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestsBatchMutation, { data, loading, error }] = useDeleteTestsBatchMutation({
 *   variables: {
 *      testsBatchId: // value for 'testsBatchId'
 *   },
 * });
 */
export function useDeleteTestsBatchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTestsBatchMutation, DeleteTestsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTestsBatchMutation, DeleteTestsBatchMutationVariables>(DeleteTestsBatchDocument, options);
      }
export type DeleteTestsBatchMutationHookResult = ReturnType<typeof useDeleteTestsBatchMutation>;
export type DeleteTestsBatchMutationResult = Apollo.MutationResult<DeleteTestsBatchMutation>;
export type DeleteTestsBatchMutationOptions = Apollo.BaseMutationOptions<DeleteTestsBatchMutation, DeleteTestsBatchMutationVariables>;
export const DeleteTimeIntervalDocument = gql`
    mutation DeleteTimeInterval($timeIntervalId: ID!) {
  deleteTimeInterval(where: {id: $timeIntervalId}) {
    id
  }
}
    `;
export type DeleteTimeIntervalMutationFn = Apollo.MutationFunction<DeleteTimeIntervalMutation, DeleteTimeIntervalMutationVariables>;

/**
 * __useDeleteTimeIntervalMutation__
 *
 * To run a mutation, you first call `useDeleteTimeIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeIntervalMutation, { data, loading, error }] = useDeleteTimeIntervalMutation({
 *   variables: {
 *      timeIntervalId: // value for 'timeIntervalId'
 *   },
 * });
 */
export function useDeleteTimeIntervalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeIntervalMutation, DeleteTimeIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeIntervalMutation, DeleteTimeIntervalMutationVariables>(DeleteTimeIntervalDocument, options);
      }
export type DeleteTimeIntervalMutationHookResult = ReturnType<typeof useDeleteTimeIntervalMutation>;
export type DeleteTimeIntervalMutationResult = Apollo.MutationResult<DeleteTimeIntervalMutation>;
export type DeleteTimeIntervalMutationOptions = Apollo.BaseMutationOptions<DeleteTimeIntervalMutation, DeleteTimeIntervalMutationVariables>;
export const DocUpdateVitalsDataDocument = gql`
    mutation DocUpdateVitalsData($vitalsDataId: ID!, $bloodPressure: String, $cm: Int, $headCm: Int, $heartRate: Int, $kg: Float, $meters: Int, $oxygenSaturation: Int, $resp: Int, $temperature: Float) {
  updateAppointmentVital(
    where: {id: $vitalsDataId}
    data: {bloodPressure: $bloodPressure, cm: $cm, headCm: $headCm, heartRate: $heartRate, kg: $kg, meters: $meters, oxygenSaturation: $oxygenSaturation, resp: $resp, temperature: $temperature}
  ) {
    ...VitalsFields
  }
}
    ${VitalsFieldsFragmentDoc}`;
export type DocUpdateVitalsDataMutationFn = Apollo.MutationFunction<DocUpdateVitalsDataMutation, DocUpdateVitalsDataMutationVariables>;

/**
 * __useDocUpdateVitalsDataMutation__
 *
 * To run a mutation, you first call `useDocUpdateVitalsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocUpdateVitalsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [docUpdateVitalsDataMutation, { data, loading, error }] = useDocUpdateVitalsDataMutation({
 *   variables: {
 *      vitalsDataId: // value for 'vitalsDataId'
 *      bloodPressure: // value for 'bloodPressure'
 *      cm: // value for 'cm'
 *      headCm: // value for 'headCm'
 *      heartRate: // value for 'heartRate'
 *      kg: // value for 'kg'
 *      meters: // value for 'meters'
 *      oxygenSaturation: // value for 'oxygenSaturation'
 *      resp: // value for 'resp'
 *      temperature: // value for 'temperature'
 *   },
 * });
 */
export function useDocUpdateVitalsDataMutation(baseOptions?: Apollo.MutationHookOptions<DocUpdateVitalsDataMutation, DocUpdateVitalsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocUpdateVitalsDataMutation, DocUpdateVitalsDataMutationVariables>(DocUpdateVitalsDataDocument, options);
      }
export type DocUpdateVitalsDataMutationHookResult = ReturnType<typeof useDocUpdateVitalsDataMutation>;
export type DocUpdateVitalsDataMutationResult = Apollo.MutationResult<DocUpdateVitalsDataMutation>;
export type DocUpdateVitalsDataMutationOptions = Apollo.BaseMutationOptions<DocUpdateVitalsDataMutation, DocUpdateVitalsDataMutationVariables>;
export const DrUpdateAppointmentNoteDocument = gql`
    mutation DrUpdateAppointmentNote($apptId: ID!, $note: String, $noteMdx: String) {
  updateAppointment(where: {id: $apptId}, data: {note: $note, noteMdx: $noteMdx}) {
    id
    note
    noteMdx
  }
}
    `;
export type DrUpdateAppointmentNoteMutationFn = Apollo.MutationFunction<DrUpdateAppointmentNoteMutation, DrUpdateAppointmentNoteMutationVariables>;

/**
 * __useDrUpdateAppointmentNoteMutation__
 *
 * To run a mutation, you first call `useDrUpdateAppointmentNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDrUpdateAppointmentNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [drUpdateAppointmentNoteMutation, { data, loading, error }] = useDrUpdateAppointmentNoteMutation({
 *   variables: {
 *      apptId: // value for 'apptId'
 *      note: // value for 'note'
 *      noteMdx: // value for 'noteMdx'
 *   },
 * });
 */
export function useDrUpdateAppointmentNoteMutation(baseOptions?: Apollo.MutationHookOptions<DrUpdateAppointmentNoteMutation, DrUpdateAppointmentNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DrUpdateAppointmentNoteMutation, DrUpdateAppointmentNoteMutationVariables>(DrUpdateAppointmentNoteDocument, options);
      }
export type DrUpdateAppointmentNoteMutationHookResult = ReturnType<typeof useDrUpdateAppointmentNoteMutation>;
export type DrUpdateAppointmentNoteMutationResult = Apollo.MutationResult<DrUpdateAppointmentNoteMutation>;
export type DrUpdateAppointmentNoteMutationOptions = Apollo.BaseMutationOptions<DrUpdateAppointmentNoteMutation, DrUpdateAppointmentNoteMutationVariables>;
export const InactivateHealthConditionDocument = gql`
    mutation InactivateHealthCondition($healthConditionId: ID!, $inactivatedAt: DateTime!) {
  updateHealthCondition(
    where: {id: $healthConditionId}
    data: {inactivatedAt: $inactivatedAt}
  ) {
    id
    inactivatedAt
    inactivatedBy {
      id
    }
  }
}
    `;
export type InactivateHealthConditionMutationFn = Apollo.MutationFunction<InactivateHealthConditionMutation, InactivateHealthConditionMutationVariables>;

/**
 * __useInactivateHealthConditionMutation__
 *
 * To run a mutation, you first call `useInactivateHealthConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateHealthConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateHealthConditionMutation, { data, loading, error }] = useInactivateHealthConditionMutation({
 *   variables: {
 *      healthConditionId: // value for 'healthConditionId'
 *      inactivatedAt: // value for 'inactivatedAt'
 *   },
 * });
 */
export function useInactivateHealthConditionMutation(baseOptions?: Apollo.MutationHookOptions<InactivateHealthConditionMutation, InactivateHealthConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateHealthConditionMutation, InactivateHealthConditionMutationVariables>(InactivateHealthConditionDocument, options);
      }
export type InactivateHealthConditionMutationHookResult = ReturnType<typeof useInactivateHealthConditionMutation>;
export type InactivateHealthConditionMutationResult = Apollo.MutationResult<InactivateHealthConditionMutation>;
export type InactivateHealthConditionMutationOptions = Apollo.BaseMutationOptions<InactivateHealthConditionMutation, InactivateHealthConditionMutationVariables>;
export const InactivateLifestyleItemDocument = gql`
    mutation InactivateLifestyleItem($lifestyleItemId: ID!, $inactivatedAt: DateTime!) {
  updateLifestyleItem(
    where: {id: $lifestyleItemId}
    data: {inactivatedAt: $inactivatedAt}
  ) {
    id
    inactivatedAt
    inactivatedBy {
      id
    }
  }
}
    `;
export type InactivateLifestyleItemMutationFn = Apollo.MutationFunction<InactivateLifestyleItemMutation, InactivateLifestyleItemMutationVariables>;

/**
 * __useInactivateLifestyleItemMutation__
 *
 * To run a mutation, you first call `useInactivateLifestyleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateLifestyleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateLifestyleItemMutation, { data, loading, error }] = useInactivateLifestyleItemMutation({
 *   variables: {
 *      lifestyleItemId: // value for 'lifestyleItemId'
 *      inactivatedAt: // value for 'inactivatedAt'
 *   },
 * });
 */
export function useInactivateLifestyleItemMutation(baseOptions?: Apollo.MutationHookOptions<InactivateLifestyleItemMutation, InactivateLifestyleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateLifestyleItemMutation, InactivateLifestyleItemMutationVariables>(InactivateLifestyleItemDocument, options);
      }
export type InactivateLifestyleItemMutationHookResult = ReturnType<typeof useInactivateLifestyleItemMutation>;
export type InactivateLifestyleItemMutationResult = Apollo.MutationResult<InactivateLifestyleItemMutation>;
export type InactivateLifestyleItemMutationOptions = Apollo.BaseMutationOptions<InactivateLifestyleItemMutation, InactivateLifestyleItemMutationVariables>;
export const InactivateMedicationItemDocument = gql`
    mutation InactivateMedicationItem($medicationItemId: ID!, $inactivatedAt: DateTime!) {
  updateMedicationItem(
    where: {id: $medicationItemId}
    data: {inactivatedAt: $inactivatedAt}
  ) {
    id
    inactivatedAt
    inactivatedBy {
      id
    }
  }
}
    `;
export type InactivateMedicationItemMutationFn = Apollo.MutationFunction<InactivateMedicationItemMutation, InactivateMedicationItemMutationVariables>;

/**
 * __useInactivateMedicationItemMutation__
 *
 * To run a mutation, you first call `useInactivateMedicationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateMedicationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateMedicationItemMutation, { data, loading, error }] = useInactivateMedicationItemMutation({
 *   variables: {
 *      medicationItemId: // value for 'medicationItemId'
 *      inactivatedAt: // value for 'inactivatedAt'
 *   },
 * });
 */
export function useInactivateMedicationItemMutation(baseOptions?: Apollo.MutationHookOptions<InactivateMedicationItemMutation, InactivateMedicationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateMedicationItemMutation, InactivateMedicationItemMutationVariables>(InactivateMedicationItemDocument, options);
      }
export type InactivateMedicationItemMutationHookResult = ReturnType<typeof useInactivateMedicationItemMutation>;
export type InactivateMedicationItemMutationResult = Apollo.MutationResult<InactivateMedicationItemMutation>;
export type InactivateMedicationItemMutationOptions = Apollo.BaseMutationOptions<InactivateMedicationItemMutation, InactivateMedicationItemMutationVariables>;
export const InviteUserByDoctorDocument = gql`
    mutation InviteUserByDoctor($healthCardNumber: String, $healthCardVersionCode: String, $healthCardExpiryDate: DateTime, $dateOfBirth: DateTime, $email: String!, $firstName: String!, $lastName: String!, $middleName: String, $cellPhoneNumberString: String, $sex: String, $companyId: ID!) {
  inviteUserByDoctor(
    healthCardNumber: $healthCardNumber
    healthCardVersionCode: $healthCardVersionCode
    healthCardExpiryDate: $healthCardExpiryDate
    dateOfBirth: $dateOfBirth
    email: $email
    firstName: $firstName
    lastName: $lastName
    middleName: $middleName
    cellPhoneNumberString: $cellPhoneNumberString
    sex: $sex
    companyId: $companyId
  ) {
    id
  }
}
    `;
export type InviteUserByDoctorMutationFn = Apollo.MutationFunction<InviteUserByDoctorMutation, InviteUserByDoctorMutationVariables>;

/**
 * __useInviteUserByDoctorMutation__
 *
 * To run a mutation, you first call `useInviteUserByDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserByDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserByDoctorMutation, { data, loading, error }] = useInviteUserByDoctorMutation({
 *   variables: {
 *      healthCardNumber: // value for 'healthCardNumber'
 *      healthCardVersionCode: // value for 'healthCardVersionCode'
 *      healthCardExpiryDate: // value for 'healthCardExpiryDate'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      middleName: // value for 'middleName'
 *      cellPhoneNumberString: // value for 'cellPhoneNumberString'
 *      sex: // value for 'sex'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useInviteUserByDoctorMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserByDoctorMutation, InviteUserByDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserByDoctorMutation, InviteUserByDoctorMutationVariables>(InviteUserByDoctorDocument, options);
      }
export type InviteUserByDoctorMutationHookResult = ReturnType<typeof useInviteUserByDoctorMutation>;
export type InviteUserByDoctorMutationResult = Apollo.MutationResult<InviteUserByDoctorMutation>;
export type InviteUserByDoctorMutationOptions = Apollo.BaseMutationOptions<InviteUserByDoctorMutation, InviteUserByDoctorMutationVariables>;
export const IssueFormDocument = gql`
    mutation IssueForm($formId: ID!, $file: Upload!) {
  issueForm(formId: $formId, file: $file) {
    id
  }
}
    `;
export type IssueFormMutationFn = Apollo.MutationFunction<IssueFormMutation, IssueFormMutationVariables>;

/**
 * __useIssueFormMutation__
 *
 * To run a mutation, you first call `useIssueFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueFormMutation, { data, loading, error }] = useIssueFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useIssueFormMutation(baseOptions?: Apollo.MutationHookOptions<IssueFormMutation, IssueFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueFormMutation, IssueFormMutationVariables>(IssueFormDocument, options);
      }
export type IssueFormMutationHookResult = ReturnType<typeof useIssueFormMutation>;
export type IssueFormMutationResult = Apollo.MutationResult<IssueFormMutation>;
export type IssueFormMutationOptions = Apollo.BaseMutationOptions<IssueFormMutation, IssueFormMutationVariables>;
export const LinkTestOrderToFaxDocument = gql`
    mutation LinkTestOrderToFax($inboundFaxId: ID!, $testOrderId: ID!) {
  updateInboundFax(
    where: {id: $inboundFaxId}
    data: {testOrder: {connect: {id: $testOrderId}}}
  ) {
    id
    testOrder {
      id
    }
  }
}
    `;
export type LinkTestOrderToFaxMutationFn = Apollo.MutationFunction<LinkTestOrderToFaxMutation, LinkTestOrderToFaxMutationVariables>;

/**
 * __useLinkTestOrderToFaxMutation__
 *
 * To run a mutation, you first call `useLinkTestOrderToFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTestOrderToFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTestOrderToFaxMutation, { data, loading, error }] = useLinkTestOrderToFaxMutation({
 *   variables: {
 *      inboundFaxId: // value for 'inboundFaxId'
 *      testOrderId: // value for 'testOrderId'
 *   },
 * });
 */
export function useLinkTestOrderToFaxMutation(baseOptions?: Apollo.MutationHookOptions<LinkTestOrderToFaxMutation, LinkTestOrderToFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkTestOrderToFaxMutation, LinkTestOrderToFaxMutationVariables>(LinkTestOrderToFaxDocument, options);
      }
export type LinkTestOrderToFaxMutationHookResult = ReturnType<typeof useLinkTestOrderToFaxMutation>;
export type LinkTestOrderToFaxMutationResult = Apollo.MutationResult<LinkTestOrderToFaxMutation>;
export type LinkTestOrderToFaxMutationOptions = Apollo.BaseMutationOptions<LinkTestOrderToFaxMutation, LinkTestOrderToFaxMutationVariables>;
export const LogUserSessionDocument = gql`
    mutation LogUserSession($lastPath: String!, $userSessionId: ID) {
  logUserSession(lastPath: $lastPath, userSessionId: $userSessionId) {
    id
    lastPath
  }
}
    `;
export type LogUserSessionMutationFn = Apollo.MutationFunction<LogUserSessionMutation, LogUserSessionMutationVariables>;

/**
 * __useLogUserSessionMutation__
 *
 * To run a mutation, you first call `useLogUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logUserSessionMutation, { data, loading, error }] = useLogUserSessionMutation({
 *   variables: {
 *      lastPath: // value for 'lastPath'
 *      userSessionId: // value for 'userSessionId'
 *   },
 * });
 */
export function useLogUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<LogUserSessionMutation, LogUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogUserSessionMutation, LogUserSessionMutationVariables>(LogUserSessionDocument, options);
      }
export type LogUserSessionMutationHookResult = ReturnType<typeof useLogUserSessionMutation>;
export type LogUserSessionMutationResult = Apollo.MutationResult<LogUserSessionMutation>;
export type LogUserSessionMutationOptions = Apollo.BaseMutationOptions<LogUserSessionMutation, LogUserSessionMutationVariables>;
export const ManageCreatePharmacyLocationDocument = gql`
    mutation ManageCreatePharmacyLocation($data: PharmacyLocationCreateInput!) {
  createPharmacyLocation(data: $data) {
    id
  }
}
    `;
export type ManageCreatePharmacyLocationMutationFn = Apollo.MutationFunction<ManageCreatePharmacyLocationMutation, ManageCreatePharmacyLocationMutationVariables>;

/**
 * __useManageCreatePharmacyLocationMutation__
 *
 * To run a mutation, you first call `useManageCreatePharmacyLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageCreatePharmacyLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageCreatePharmacyLocationMutation, { data, loading, error }] = useManageCreatePharmacyLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useManageCreatePharmacyLocationMutation(baseOptions?: Apollo.MutationHookOptions<ManageCreatePharmacyLocationMutation, ManageCreatePharmacyLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageCreatePharmacyLocationMutation, ManageCreatePharmacyLocationMutationVariables>(ManageCreatePharmacyLocationDocument, options);
      }
export type ManageCreatePharmacyLocationMutationHookResult = ReturnType<typeof useManageCreatePharmacyLocationMutation>;
export type ManageCreatePharmacyLocationMutationResult = Apollo.MutationResult<ManageCreatePharmacyLocationMutation>;
export type ManageCreatePharmacyLocationMutationOptions = Apollo.BaseMutationOptions<ManageCreatePharmacyLocationMutation, ManageCreatePharmacyLocationMutationVariables>;
export const ManageCreatePharmacyDocument = gql`
    mutation ManageCreatePharmacy($data: PharmacyCreateInput!) {
  createPharmacy(data: $data) {
    id
  }
}
    `;
export type ManageCreatePharmacyMutationFn = Apollo.MutationFunction<ManageCreatePharmacyMutation, ManageCreatePharmacyMutationVariables>;

/**
 * __useManageCreatePharmacyMutation__
 *
 * To run a mutation, you first call `useManageCreatePharmacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageCreatePharmacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageCreatePharmacyMutation, { data, loading, error }] = useManageCreatePharmacyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useManageCreatePharmacyMutation(baseOptions?: Apollo.MutationHookOptions<ManageCreatePharmacyMutation, ManageCreatePharmacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageCreatePharmacyMutation, ManageCreatePharmacyMutationVariables>(ManageCreatePharmacyDocument, options);
      }
export type ManageCreatePharmacyMutationHookResult = ReturnType<typeof useManageCreatePharmacyMutation>;
export type ManageCreatePharmacyMutationResult = Apollo.MutationResult<ManageCreatePharmacyMutation>;
export type ManageCreatePharmacyMutationOptions = Apollo.BaseMutationOptions<ManageCreatePharmacyMutation, ManageCreatePharmacyMutationVariables>;
export const MarkAppointmentCancelledDocument = gql`
    mutation MarkAppointmentCancelled($cancelledAt: DateTime!, $apptId: ID!) {
  markAppointmentCancelled(appointmentId: $apptId, cancelledAt: $cancelledAt) {
    id
    cancelledAt
  }
}
    `;
export type MarkAppointmentCancelledMutationFn = Apollo.MutationFunction<MarkAppointmentCancelledMutation, MarkAppointmentCancelledMutationVariables>;

/**
 * __useMarkAppointmentCancelledMutation__
 *
 * To run a mutation, you first call `useMarkAppointmentCancelledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAppointmentCancelledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAppointmentCancelledMutation, { data, loading, error }] = useMarkAppointmentCancelledMutation({
 *   variables: {
 *      cancelledAt: // value for 'cancelledAt'
 *      apptId: // value for 'apptId'
 *   },
 * });
 */
export function useMarkAppointmentCancelledMutation(baseOptions?: Apollo.MutationHookOptions<MarkAppointmentCancelledMutation, MarkAppointmentCancelledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAppointmentCancelledMutation, MarkAppointmentCancelledMutationVariables>(MarkAppointmentCancelledDocument, options);
      }
export type MarkAppointmentCancelledMutationHookResult = ReturnType<typeof useMarkAppointmentCancelledMutation>;
export type MarkAppointmentCancelledMutationResult = Apollo.MutationResult<MarkAppointmentCancelledMutation>;
export type MarkAppointmentCancelledMutationOptions = Apollo.BaseMutationOptions<MarkAppointmentCancelledMutation, MarkAppointmentCancelledMutationVariables>;
export const MarkAppointmentMissedDocument = gql`
    mutation MarkAppointmentMissed($apptId: ID!) {
  markAppointmentMissed(appointmentId: $apptId) {
    id
    isMissed
  }
}
    `;
export type MarkAppointmentMissedMutationFn = Apollo.MutationFunction<MarkAppointmentMissedMutation, MarkAppointmentMissedMutationVariables>;

/**
 * __useMarkAppointmentMissedMutation__
 *
 * To run a mutation, you first call `useMarkAppointmentMissedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAppointmentMissedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAppointmentMissedMutation, { data, loading, error }] = useMarkAppointmentMissedMutation({
 *   variables: {
 *      apptId: // value for 'apptId'
 *   },
 * });
 */
export function useMarkAppointmentMissedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAppointmentMissedMutation, MarkAppointmentMissedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAppointmentMissedMutation, MarkAppointmentMissedMutationVariables>(MarkAppointmentMissedDocument, options);
      }
export type MarkAppointmentMissedMutationHookResult = ReturnType<typeof useMarkAppointmentMissedMutation>;
export type MarkAppointmentMissedMutationResult = Apollo.MutationResult<MarkAppointmentMissedMutation>;
export type MarkAppointmentMissedMutationOptions = Apollo.BaseMutationOptions<MarkAppointmentMissedMutation, MarkAppointmentMissedMutationVariables>;
export const MarkBillingDocument = gql`
    mutation MarkBilling($billingId: ID!, $status: AppointmentBillingStatusType!) {
  markBilling(billingId: $billingId, status: $status) {
    id
    status
  }
}
    `;
export type MarkBillingMutationFn = Apollo.MutationFunction<MarkBillingMutation, MarkBillingMutationVariables>;

/**
 * __useMarkBillingMutation__
 *
 * To run a mutation, you first call `useMarkBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markBillingMutation, { data, loading, error }] = useMarkBillingMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMarkBillingMutation(baseOptions?: Apollo.MutationHookOptions<MarkBillingMutation, MarkBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkBillingMutation, MarkBillingMutationVariables>(MarkBillingDocument, options);
      }
export type MarkBillingMutationHookResult = ReturnType<typeof useMarkBillingMutation>;
export type MarkBillingMutationResult = Apollo.MutationResult<MarkBillingMutation>;
export type MarkBillingMutationOptions = Apollo.BaseMutationOptions<MarkBillingMutation, MarkBillingMutationVariables>;
export const MarkInboundFaxReviewedDocument = gql`
    mutation MarkInboundFaxReviewed($inboundFaxId: ID!, $reviewedAt: DateTime!) {
  updateInboundFax(where: {id: $inboundFaxId}, data: {reviewedAt: $reviewedAt}) {
    id
    reviewedAt
  }
}
    `;
export type MarkInboundFaxReviewedMutationFn = Apollo.MutationFunction<MarkInboundFaxReviewedMutation, MarkInboundFaxReviewedMutationVariables>;

/**
 * __useMarkInboundFaxReviewedMutation__
 *
 * To run a mutation, you first call `useMarkInboundFaxReviewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboundFaxReviewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboundFaxReviewedMutation, { data, loading, error }] = useMarkInboundFaxReviewedMutation({
 *   variables: {
 *      inboundFaxId: // value for 'inboundFaxId'
 *      reviewedAt: // value for 'reviewedAt'
 *   },
 * });
 */
export function useMarkInboundFaxReviewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkInboundFaxReviewedMutation, MarkInboundFaxReviewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInboundFaxReviewedMutation, MarkInboundFaxReviewedMutationVariables>(MarkInboundFaxReviewedDocument, options);
      }
export type MarkInboundFaxReviewedMutationHookResult = ReturnType<typeof useMarkInboundFaxReviewedMutation>;
export type MarkInboundFaxReviewedMutationResult = Apollo.MutationResult<MarkInboundFaxReviewedMutation>;
export type MarkInboundFaxReviewedMutationOptions = Apollo.BaseMutationOptions<MarkInboundFaxReviewedMutation, MarkInboundFaxReviewedMutationVariables>;
export const MoveFileToArchiveDocument = gql`
    mutation MoveFileToArchive($fileId: ID!, $archiveName: String!) {
  moveFileToArchive(fileId: $fileId, archiveName: $archiveName) {
    id
  }
}
    `;
export type MoveFileToArchiveMutationFn = Apollo.MutationFunction<MoveFileToArchiveMutation, MoveFileToArchiveMutationVariables>;

/**
 * __useMoveFileToArchiveMutation__
 *
 * To run a mutation, you first call `useMoveFileToArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFileToArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFileToArchiveMutation, { data, loading, error }] = useMoveFileToArchiveMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      archiveName: // value for 'archiveName'
 *   },
 * });
 */
export function useMoveFileToArchiveMutation(baseOptions?: Apollo.MutationHookOptions<MoveFileToArchiveMutation, MoveFileToArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveFileToArchiveMutation, MoveFileToArchiveMutationVariables>(MoveFileToArchiveDocument, options);
      }
export type MoveFileToArchiveMutationHookResult = ReturnType<typeof useMoveFileToArchiveMutation>;
export type MoveFileToArchiveMutationResult = Apollo.MutationResult<MoveFileToArchiveMutation>;
export type MoveFileToArchiveMutationOptions = Apollo.BaseMutationOptions<MoveFileToArchiveMutation, MoveFileToArchiveMutationVariables>;
export const OrderFaxNumberDocument = gql`
    mutation OrderFaxNumber($companyId: ID!, $memberId: ID!) {
  orderFaxNumber(companyId: $companyId, memberId: $memberId) {
    id
    cellPhoneNumberString
    dateOfBirth
    email
    firstName
    homePhoneNumberString
    lastName
    memberships(where: {clinic: {company: {id: {equals: $companyId}}}}) {
      id
      faxNumber
      role {
        id
        name
      }
    }
    patient {
      id
      emergencyContacts {
        id
        email
        firstName
        lastName
        cellPhoneNumberString
        homePhoneNumberString
      }
    }
    ...UserPhotoFields
  }
}
    ${UserPhotoFieldsFragmentDoc}`;
export type OrderFaxNumberMutationFn = Apollo.MutationFunction<OrderFaxNumberMutation, OrderFaxNumberMutationVariables>;

/**
 * __useOrderFaxNumberMutation__
 *
 * To run a mutation, you first call `useOrderFaxNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderFaxNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderFaxNumberMutation, { data, loading, error }] = useOrderFaxNumberMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useOrderFaxNumberMutation(baseOptions?: Apollo.MutationHookOptions<OrderFaxNumberMutation, OrderFaxNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderFaxNumberMutation, OrderFaxNumberMutationVariables>(OrderFaxNumberDocument, options);
      }
export type OrderFaxNumberMutationHookResult = ReturnType<typeof useOrderFaxNumberMutation>;
export type OrderFaxNumberMutationResult = Apollo.MutationResult<OrderFaxNumberMutation>;
export type OrderFaxNumberMutationOptions = Apollo.BaseMutationOptions<OrderFaxNumberMutation, OrderFaxNumberMutationVariables>;
export const PatientCancelAppointmentDocument = gql`
    mutation PatientCancelAppointment($cancelledAt: DateTime!, $apptId: ID!) {
  patientCancelAppointment(appointmentId: $apptId, cancelledAt: $cancelledAt) {
    id
    cancelledAt
  }
}
    `;
export type PatientCancelAppointmentMutationFn = Apollo.MutationFunction<PatientCancelAppointmentMutation, PatientCancelAppointmentMutationVariables>;

/**
 * __usePatientCancelAppointmentMutation__
 *
 * To run a mutation, you first call `usePatientCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientCancelAppointmentMutation, { data, loading, error }] = usePatientCancelAppointmentMutation({
 *   variables: {
 *      cancelledAt: // value for 'cancelledAt'
 *      apptId: // value for 'apptId'
 *   },
 * });
 */
export function usePatientCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<PatientCancelAppointmentMutation, PatientCancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientCancelAppointmentMutation, PatientCancelAppointmentMutationVariables>(PatientCancelAppointmentDocument, options);
      }
export type PatientCancelAppointmentMutationHookResult = ReturnType<typeof usePatientCancelAppointmentMutation>;
export type PatientCancelAppointmentMutationResult = Apollo.MutationResult<PatientCancelAppointmentMutation>;
export type PatientCancelAppointmentMutationOptions = Apollo.BaseMutationOptions<PatientCancelAppointmentMutation, PatientCancelAppointmentMutationVariables>;
export const PlaygroundSendFaxDocument = gql`
    mutation PlaygroundSendFax($faxFileUrl: String!, $faxNumber: String!) {
  playgroundSendFax(faxFileUrl: $faxFileUrl, faxNumber: $faxNumber) {
    id
    to
  }
}
    `;
export type PlaygroundSendFaxMutationFn = Apollo.MutationFunction<PlaygroundSendFaxMutation, PlaygroundSendFaxMutationVariables>;

/**
 * __usePlaygroundSendFaxMutation__
 *
 * To run a mutation, you first call `usePlaygroundSendFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaygroundSendFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playgroundSendFaxMutation, { data, loading, error }] = usePlaygroundSendFaxMutation({
 *   variables: {
 *      faxFileUrl: // value for 'faxFileUrl'
 *      faxNumber: // value for 'faxNumber'
 *   },
 * });
 */
export function usePlaygroundSendFaxMutation(baseOptions?: Apollo.MutationHookOptions<PlaygroundSendFaxMutation, PlaygroundSendFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaygroundSendFaxMutation, PlaygroundSendFaxMutationVariables>(PlaygroundSendFaxDocument, options);
      }
export type PlaygroundSendFaxMutationHookResult = ReturnType<typeof usePlaygroundSendFaxMutation>;
export type PlaygroundSendFaxMutationResult = Apollo.MutationResult<PlaygroundSendFaxMutation>;
export type PlaygroundSendFaxMutationOptions = Apollo.BaseMutationOptions<PlaygroundSendFaxMutation, PlaygroundSendFaxMutationVariables>;
export const RefreshRemittancesDocument = gql`
    mutation RefreshRemittances($companyId: ID!) {
  refreshRemittances(companyId: $companyId) {
    id
    remittances {
      id
      billings {
        id
        appointment {
          id
          patient {
            id
            user {
              id
              firstName
              lastName
            }
          }
        }
        status
        createdAt
      }
      externalClaims
    }
  }
}
    `;
export type RefreshRemittancesMutationFn = Apollo.MutationFunction<RefreshRemittancesMutation, RefreshRemittancesMutationVariables>;

/**
 * __useRefreshRemittancesMutation__
 *
 * To run a mutation, you first call `useRefreshRemittancesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshRemittancesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshRemittancesMutation, { data, loading, error }] = useRefreshRemittancesMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRefreshRemittancesMutation(baseOptions?: Apollo.MutationHookOptions<RefreshRemittancesMutation, RefreshRemittancesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshRemittancesMutation, RefreshRemittancesMutationVariables>(RefreshRemittancesDocument, options);
      }
export type RefreshRemittancesMutationHookResult = ReturnType<typeof useRefreshRemittancesMutation>;
export type RefreshRemittancesMutationResult = Apollo.MutationResult<RefreshRemittancesMutation>;
export type RefreshRemittancesMutationOptions = Apollo.BaseMutationOptions<RefreshRemittancesMutation, RefreshRemittancesMutationVariables>;
export const RemoveClinicDocument = gql`
    mutation RemoveClinic($clinicId: ID!) {
  removeClinic(clinicId: $clinicId) {
    id
    createdAt
    faxNumber
    name
    phoneNumber
    address {
      ...AddressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`;
export type RemoveClinicMutationFn = Apollo.MutationFunction<RemoveClinicMutation, RemoveClinicMutationVariables>;

/**
 * __useRemoveClinicMutation__
 *
 * To run a mutation, you first call `useRemoveClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClinicMutation, { data, loading, error }] = useRemoveClinicMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useRemoveClinicMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClinicMutation, RemoveClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClinicMutation, RemoveClinicMutationVariables>(RemoveClinicDocument, options);
      }
export type RemoveClinicMutationHookResult = ReturnType<typeof useRemoveClinicMutation>;
export type RemoveClinicMutationResult = Apollo.MutationResult<RemoveClinicMutation>;
export type RemoveClinicMutationOptions = Apollo.BaseMutationOptions<RemoveClinicMutation, RemoveClinicMutationVariables>;
export const RemoveCompanyMemberDocument = gql`
    mutation RemoveCompanyMember($companyId: ID!, $userId: ID!) {
  removeCompanyMember(companyId: $companyId, userId: $userId) {
    id
    userId
    roles
    user {
      id
      firstName
      lastName
      ...UserPhotoFields
    }
  }
}
    ${UserPhotoFieldsFragmentDoc}`;
export type RemoveCompanyMemberMutationFn = Apollo.MutationFunction<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>;

/**
 * __useRemoveCompanyMemberMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyMemberMutation, { data, loading, error }] = useRemoveCompanyMemberMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveCompanyMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>(RemoveCompanyMemberDocument, options);
      }
export type RemoveCompanyMemberMutationHookResult = ReturnType<typeof useRemoveCompanyMemberMutation>;
export type RemoveCompanyMemberMutationResult = Apollo.MutationResult<RemoveCompanyMemberMutation>;
export type RemoveCompanyMemberMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>;
export const RemovePatientFromCompanyDocument = gql`
    mutation RemovePatientFromCompany($patientId: ID!, $companyId: ID!) {
  removePatientFromCompany(patientId: $patientId, companyId: $companyId) {
    id
  }
}
    `;
export type RemovePatientFromCompanyMutationFn = Apollo.MutationFunction<RemovePatientFromCompanyMutation, RemovePatientFromCompanyMutationVariables>;

/**
 * __useRemovePatientFromCompanyMutation__
 *
 * To run a mutation, you first call `useRemovePatientFromCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientFromCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePatientFromCompanyMutation, { data, loading, error }] = useRemovePatientFromCompanyMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRemovePatientFromCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RemovePatientFromCompanyMutation, RemovePatientFromCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePatientFromCompanyMutation, RemovePatientFromCompanyMutationVariables>(RemovePatientFromCompanyDocument, options);
      }
export type RemovePatientFromCompanyMutationHookResult = ReturnType<typeof useRemovePatientFromCompanyMutation>;
export type RemovePatientFromCompanyMutationResult = Apollo.MutationResult<RemovePatientFromCompanyMutation>;
export type RemovePatientFromCompanyMutationOptions = Apollo.BaseMutationOptions<RemovePatientFromCompanyMutation, RemovePatientFromCompanyMutationVariables>;
export const ReportAdverseReactionDocument = gql`
    mutation ReportAdverseReaction($medicationItemId: ID!, $message: String!) {
  reportAdverseReaction(medicationItemId: $medicationItemId, message: $message) {
    id
  }
}
    `;
export type ReportAdverseReactionMutationFn = Apollo.MutationFunction<ReportAdverseReactionMutation, ReportAdverseReactionMutationVariables>;

/**
 * __useReportAdverseReactionMutation__
 *
 * To run a mutation, you first call `useReportAdverseReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAdverseReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAdverseReactionMutation, { data, loading, error }] = useReportAdverseReactionMutation({
 *   variables: {
 *      medicationItemId: // value for 'medicationItemId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useReportAdverseReactionMutation(baseOptions?: Apollo.MutationHookOptions<ReportAdverseReactionMutation, ReportAdverseReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportAdverseReactionMutation, ReportAdverseReactionMutationVariables>(ReportAdverseReactionDocument, options);
      }
export type ReportAdverseReactionMutationHookResult = ReturnType<typeof useReportAdverseReactionMutation>;
export type ReportAdverseReactionMutationResult = Apollo.MutationResult<ReportAdverseReactionMutation>;
export type ReportAdverseReactionMutationOptions = Apollo.BaseMutationOptions<ReportAdverseReactionMutation, ReportAdverseReactionMutationVariables>;
export const RescheduleAppointmentDocument = gql`
    mutation RescheduleAppointment($appointmentId: ID!, $rescheduledAt: DateTime!) {
  updateAppointment(
    where: {id: $appointmentId}
    data: {rescheduledAt: $rescheduledAt}
  ) {
    id
    rescheduledAt
  }
}
    `;
export type RescheduleAppointmentMutationFn = Apollo.MutationFunction<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;

/**
 * __useRescheduleAppointmentMutation__
 *
 * To run a mutation, you first call `useRescheduleAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleAppointmentMutation, { data, loading, error }] = useRescheduleAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      rescheduledAt: // value for 'rescheduledAt'
 *   },
 * });
 */
export function useRescheduleAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>(RescheduleAppointmentDocument, options);
      }
export type RescheduleAppointmentMutationHookResult = ReturnType<typeof useRescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationResult = Apollo.MutationResult<RescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationOptions = Apollo.BaseMutationOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;
export const ResendFaxDocument = gql`
    mutation ResendFax($faxId: ID!) {
  resendFax(faxId: $faxId) {
    id
    status
  }
}
    `;
export type ResendFaxMutationFn = Apollo.MutationFunction<ResendFaxMutation, ResendFaxMutationVariables>;

/**
 * __useResendFaxMutation__
 *
 * To run a mutation, you first call `useResendFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendFaxMutation, { data, loading, error }] = useResendFaxMutation({
 *   variables: {
 *      faxId: // value for 'faxId'
 *   },
 * });
 */
export function useResendFaxMutation(baseOptions?: Apollo.MutationHookOptions<ResendFaxMutation, ResendFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendFaxMutation, ResendFaxMutationVariables>(ResendFaxDocument, options);
      }
export type ResendFaxMutationHookResult = ReturnType<typeof useResendFaxMutation>;
export type ResendFaxMutationResult = Apollo.MutationResult<ResendFaxMutation>;
export type ResendFaxMutationOptions = Apollo.BaseMutationOptions<ResendFaxMutation, ResendFaxMutationVariables>;
export const ResendUserInviteByDoctorDocument = gql`
    mutation ResendUserInviteByDoctor($inviteId: ID!) {
  resendUserInviteByDoctor(inviteId: $inviteId) {
    id
  }
}
    `;
export type ResendUserInviteByDoctorMutationFn = Apollo.MutationFunction<ResendUserInviteByDoctorMutation, ResendUserInviteByDoctorMutationVariables>;

/**
 * __useResendUserInviteByDoctorMutation__
 *
 * To run a mutation, you first call `useResendUserInviteByDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInviteByDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInviteByDoctorMutation, { data, loading, error }] = useResendUserInviteByDoctorMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useResendUserInviteByDoctorMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInviteByDoctorMutation, ResendUserInviteByDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserInviteByDoctorMutation, ResendUserInviteByDoctorMutationVariables>(ResendUserInviteByDoctorDocument, options);
      }
export type ResendUserInviteByDoctorMutationHookResult = ReturnType<typeof useResendUserInviteByDoctorMutation>;
export type ResendUserInviteByDoctorMutationResult = Apollo.MutationResult<ResendUserInviteByDoctorMutation>;
export type ResendUserInviteByDoctorMutationOptions = Apollo.BaseMutationOptions<ResendUserInviteByDoctorMutation, ResendUserInviteByDoctorMutationVariables>;
export const ResolveInboundFaxDocument = gql`
    mutation ResolveInboundFax($inboundFaxId: ID!, $resolvedAt: DateTime!) {
  updateInboundFax(where: {id: $inboundFaxId}, data: {resolvedAt: $resolvedAt}) {
    id
    resolvedAt
  }
}
    `;
export type ResolveInboundFaxMutationFn = Apollo.MutationFunction<ResolveInboundFaxMutation, ResolveInboundFaxMutationVariables>;

/**
 * __useResolveInboundFaxMutation__
 *
 * To run a mutation, you first call `useResolveInboundFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveInboundFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveInboundFaxMutation, { data, loading, error }] = useResolveInboundFaxMutation({
 *   variables: {
 *      inboundFaxId: // value for 'inboundFaxId'
 *      resolvedAt: // value for 'resolvedAt'
 *   },
 * });
 */
export function useResolveInboundFaxMutation(baseOptions?: Apollo.MutationHookOptions<ResolveInboundFaxMutation, ResolveInboundFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveInboundFaxMutation, ResolveInboundFaxMutationVariables>(ResolveInboundFaxDocument, options);
      }
export type ResolveInboundFaxMutationHookResult = ReturnType<typeof useResolveInboundFaxMutation>;
export type ResolveInboundFaxMutationResult = Apollo.MutationResult<ResolveInboundFaxMutation>;
export type ResolveInboundFaxMutationOptions = Apollo.BaseMutationOptions<ResolveInboundFaxMutation, ResolveInboundFaxMutationVariables>;
export const ResolveTaskDocument = gql`
    mutation ResolveTask($resolvedNote: String, $taskId: ID!) {
  resolveTask(resolvedNote: $resolvedNote, taskId: $taskId) {
    id
    resolvedAt
    resolvedBy {
      id
    }
    resolvedNote
    status
  }
}
    `;
export type ResolveTaskMutationFn = Apollo.MutationFunction<ResolveTaskMutation, ResolveTaskMutationVariables>;

/**
 * __useResolveTaskMutation__
 *
 * To run a mutation, you first call `useResolveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveTaskMutation, { data, loading, error }] = useResolveTaskMutation({
 *   variables: {
 *      resolvedNote: // value for 'resolvedNote'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useResolveTaskMutation(baseOptions?: Apollo.MutationHookOptions<ResolveTaskMutation, ResolveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveTaskMutation, ResolveTaskMutationVariables>(ResolveTaskDocument, options);
      }
export type ResolveTaskMutationHookResult = ReturnType<typeof useResolveTaskMutation>;
export type ResolveTaskMutationResult = Apollo.MutationResult<ResolveTaskMutation>;
export type ResolveTaskMutationOptions = Apollo.BaseMutationOptions<ResolveTaskMutation, ResolveTaskMutationVariables>;
export const ResolveTestOrderDocument = gql`
    mutation ResolveTestOrder($testOrderId: ID!, $resolvedAt: DateTime!) {
  updateTestOrder(where: {id: $testOrderId}, data: {resolvedAt: $resolvedAt}) {
    id
    resolvedAt
  }
}
    `;
export type ResolveTestOrderMutationFn = Apollo.MutationFunction<ResolveTestOrderMutation, ResolveTestOrderMutationVariables>;

/**
 * __useResolveTestOrderMutation__
 *
 * To run a mutation, you first call `useResolveTestOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveTestOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveTestOrderMutation, { data, loading, error }] = useResolveTestOrderMutation({
 *   variables: {
 *      testOrderId: // value for 'testOrderId'
 *      resolvedAt: // value for 'resolvedAt'
 *   },
 * });
 */
export function useResolveTestOrderMutation(baseOptions?: Apollo.MutationHookOptions<ResolveTestOrderMutation, ResolveTestOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveTestOrderMutation, ResolveTestOrderMutationVariables>(ResolveTestOrderDocument, options);
      }
export type ResolveTestOrderMutationHookResult = ReturnType<typeof useResolveTestOrderMutation>;
export type ResolveTestOrderMutationResult = Apollo.MutationResult<ResolveTestOrderMutation>;
export type ResolveTestOrderMutationOptions = Apollo.BaseMutationOptions<ResolveTestOrderMutation, ResolveTestOrderMutationVariables>;
export const ResolveTestOrderByRequestDocument = gql`
    mutation ResolveTestOrderByRequest($appointmentRequestId: ID!, $resolvedAt: DateTime!, $requestedAppointmentAt: DateTime!, $testOrderId: ID!) {
  updateTestOrder(
    where: {id: $testOrderId}
    data: {appointmentRequest: {connect: {id: $appointmentRequestId}}, resolvedAt: $resolvedAt, requestedAppointmentAt: $requestedAppointmentAt}
  ) {
    id
    appointmentRequest {
      id
    }
    resolvedAt
    requestedAppointmentAt
  }
}
    `;
export type ResolveTestOrderByRequestMutationFn = Apollo.MutationFunction<ResolveTestOrderByRequestMutation, ResolveTestOrderByRequestMutationVariables>;

/**
 * __useResolveTestOrderByRequestMutation__
 *
 * To run a mutation, you first call `useResolveTestOrderByRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveTestOrderByRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveTestOrderByRequestMutation, { data, loading, error }] = useResolveTestOrderByRequestMutation({
 *   variables: {
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *      resolvedAt: // value for 'resolvedAt'
 *      requestedAppointmentAt: // value for 'requestedAppointmentAt'
 *      testOrderId: // value for 'testOrderId'
 *   },
 * });
 */
export function useResolveTestOrderByRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveTestOrderByRequestMutation, ResolveTestOrderByRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveTestOrderByRequestMutation, ResolveTestOrderByRequestMutationVariables>(ResolveTestOrderByRequestDocument, options);
      }
export type ResolveTestOrderByRequestMutationHookResult = ReturnType<typeof useResolveTestOrderByRequestMutation>;
export type ResolveTestOrderByRequestMutationResult = Apollo.MutationResult<ResolveTestOrderByRequestMutation>;
export type ResolveTestOrderByRequestMutationOptions = Apollo.BaseMutationOptions<ResolveTestOrderByRequestMutation, ResolveTestOrderByRequestMutationVariables>;
export const RetrySubmissionDocument = gql`
    mutation RetrySubmission($billingId: ID!) {
  retrySubmission(billingId: $billingId) {
    id
  }
}
    `;
export type RetrySubmissionMutationFn = Apollo.MutationFunction<RetrySubmissionMutation, RetrySubmissionMutationVariables>;

/**
 * __useRetrySubmissionMutation__
 *
 * To run a mutation, you first call `useRetrySubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySubmissionMutation, { data, loading, error }] = useRetrySubmissionMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *   },
 * });
 */
export function useRetrySubmissionMutation(baseOptions?: Apollo.MutationHookOptions<RetrySubmissionMutation, RetrySubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySubmissionMutation, RetrySubmissionMutationVariables>(RetrySubmissionDocument, options);
      }
export type RetrySubmissionMutationHookResult = ReturnType<typeof useRetrySubmissionMutation>;
export type RetrySubmissionMutationResult = Apollo.MutationResult<RetrySubmissionMutation>;
export type RetrySubmissionMutationOptions = Apollo.BaseMutationOptions<RetrySubmissionMutation, RetrySubmissionMutationVariables>;
export const RevokeUserInviteDocument = gql`
    mutation RevokeUserInvite($inviteId: ID!, $revokedAt: DateTime!) {
  updateUserInvite(where: {id: $inviteId}, data: {revokedAt: $revokedAt}) {
    id
    revokedAt
  }
}
    `;
export type RevokeUserInviteMutationFn = Apollo.MutationFunction<RevokeUserInviteMutation, RevokeUserInviteMutationVariables>;

/**
 * __useRevokeUserInviteMutation__
 *
 * To run a mutation, you first call `useRevokeUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeUserInviteMutation, { data, loading, error }] = useRevokeUserInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      revokedAt: // value for 'revokedAt'
 *   },
 * });
 */
export function useRevokeUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokeUserInviteMutation, RevokeUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeUserInviteMutation, RevokeUserInviteMutationVariables>(RevokeUserInviteDocument, options);
      }
export type RevokeUserInviteMutationHookResult = ReturnType<typeof useRevokeUserInviteMutation>;
export type RevokeUserInviteMutationResult = Apollo.MutationResult<RevokeUserInviteMutation>;
export type RevokeUserInviteMutationOptions = Apollo.BaseMutationOptions<RevokeUserInviteMutation, RevokeUserInviteMutationVariables>;
export const ReSubmitMyClaimsInCompanyDocument = gql`
    mutation ReSubmitMyClaimsInCompany($companyId: ID!, $couponId: ID) {
  reSubmitMyClaimsInCompany(companyId: $companyId, couponId: $couponId) {
    success
  }
}
    `;
export type ReSubmitMyClaimsInCompanyMutationFn = Apollo.MutationFunction<ReSubmitMyClaimsInCompanyMutation, ReSubmitMyClaimsInCompanyMutationVariables>;

/**
 * __useReSubmitMyClaimsInCompanyMutation__
 *
 * To run a mutation, you first call `useReSubmitMyClaimsInCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReSubmitMyClaimsInCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reSubmitMyClaimsInCompanyMutation, { data, loading, error }] = useReSubmitMyClaimsInCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useReSubmitMyClaimsInCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ReSubmitMyClaimsInCompanyMutation, ReSubmitMyClaimsInCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReSubmitMyClaimsInCompanyMutation, ReSubmitMyClaimsInCompanyMutationVariables>(ReSubmitMyClaimsInCompanyDocument, options);
      }
export type ReSubmitMyClaimsInCompanyMutationHookResult = ReturnType<typeof useReSubmitMyClaimsInCompanyMutation>;
export type ReSubmitMyClaimsInCompanyMutationResult = Apollo.MutationResult<ReSubmitMyClaimsInCompanyMutation>;
export type ReSubmitMyClaimsInCompanyMutationOptions = Apollo.BaseMutationOptions<ReSubmitMyClaimsInCompanyMutation, ReSubmitMyClaimsInCompanyMutationVariables>;
export const SaveAppointmentDraftDocument = gql`
    mutation SaveAppointmentDraft($appointmentDraftId: ID!, $data: AppointmentDraftUpdateInput!) {
  updateAppointmentDraft(where: {id: $appointmentDraftId}, data: $data) {
    id
    createdAt
    lastEditedAt
    savedAt
  }
}
    `;
export type SaveAppointmentDraftMutationFn = Apollo.MutationFunction<SaveAppointmentDraftMutation, SaveAppointmentDraftMutationVariables>;

/**
 * __useSaveAppointmentDraftMutation__
 *
 * To run a mutation, you first call `useSaveAppointmentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAppointmentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAppointmentDraftMutation, { data, loading, error }] = useSaveAppointmentDraftMutation({
 *   variables: {
 *      appointmentDraftId: // value for 'appointmentDraftId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveAppointmentDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveAppointmentDraftMutation, SaveAppointmentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAppointmentDraftMutation, SaveAppointmentDraftMutationVariables>(SaveAppointmentDraftDocument, options);
      }
export type SaveAppointmentDraftMutationHookResult = ReturnType<typeof useSaveAppointmentDraftMutation>;
export type SaveAppointmentDraftMutationResult = Apollo.MutationResult<SaveAppointmentDraftMutation>;
export type SaveAppointmentDraftMutationOptions = Apollo.BaseMutationOptions<SaveAppointmentDraftMutation, SaveAppointmentDraftMutationVariables>;
export const SaveDoctorDocument = gql`
    mutation SaveDoctor($doctorId: ID!, $patientId: ID!) {
  updatePatient(
    where: {id: $patientId}
    data: {savedDoctors: {connect: {id: $doctorId}}}
  ) {
    id
    savedDoctors {
      id
    }
  }
}
    `;
export type SaveDoctorMutationFn = Apollo.MutationFunction<SaveDoctorMutation, SaveDoctorMutationVariables>;

/**
 * __useSaveDoctorMutation__
 *
 * To run a mutation, you first call `useSaveDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDoctorMutation, { data, loading, error }] = useSaveDoctorMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useSaveDoctorMutation(baseOptions?: Apollo.MutationHookOptions<SaveDoctorMutation, SaveDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDoctorMutation, SaveDoctorMutationVariables>(SaveDoctorDocument, options);
      }
export type SaveDoctorMutationHookResult = ReturnType<typeof useSaveDoctorMutation>;
export type SaveDoctorMutationResult = Apollo.MutationResult<SaveDoctorMutation>;
export type SaveDoctorMutationOptions = Apollo.BaseMutationOptions<SaveDoctorMutation, SaveDoctorMutationVariables>;
export const SendFaxDocument = gql`
    mutation SendFax($companyId: ID, $doctorId: ID, $existingFaxId: ID, $fileId: ID, $fromFaxNumber: String, $patientId: ID, $toFaxNumber: String!) {
  sendFax(
    companyId: $companyId
    doctorId: $doctorId
    existingFaxId: $existingFaxId
    fileId: $fileId
    fromFaxNumber: $fromFaxNumber
    patientId: $patientId
    toFaxNumber: $toFaxNumber
  ) {
    id
    status
  }
}
    `;
export type SendFaxMutationFn = Apollo.MutationFunction<SendFaxMutation, SendFaxMutationVariables>;

/**
 * __useSendFaxMutation__
 *
 * To run a mutation, you first call `useSendFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFaxMutation, { data, loading, error }] = useSendFaxMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      doctorId: // value for 'doctorId'
 *      existingFaxId: // value for 'existingFaxId'
 *      fileId: // value for 'fileId'
 *      fromFaxNumber: // value for 'fromFaxNumber'
 *      patientId: // value for 'patientId'
 *      toFaxNumber: // value for 'toFaxNumber'
 *   },
 * });
 */
export function useSendFaxMutation(baseOptions?: Apollo.MutationHookOptions<SendFaxMutation, SendFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFaxMutation, SendFaxMutationVariables>(SendFaxDocument, options);
      }
export type SendFaxMutationHookResult = ReturnType<typeof useSendFaxMutation>;
export type SendFaxMutationResult = Apollo.MutationResult<SendFaxMutation>;
export type SendFaxMutationOptions = Apollo.BaseMutationOptions<SendFaxMutation, SendFaxMutationVariables>;
export const SetAcceptingNewPatientsDocument = gql`
    mutation SetAcceptingNewPatients($calendarId: ID!, $acceptingNewPatients: CalendarAcceptingNewPatientType) {
  updateCalendar(
    where: {id: $calendarId}
    data: {acceptingNewPatients: $acceptingNewPatients}
  ) {
    id
    acceptingNewPatients
  }
}
    `;
export type SetAcceptingNewPatientsMutationFn = Apollo.MutationFunction<SetAcceptingNewPatientsMutation, SetAcceptingNewPatientsMutationVariables>;

/**
 * __useSetAcceptingNewPatientsMutation__
 *
 * To run a mutation, you first call `useSetAcceptingNewPatientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAcceptingNewPatientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAcceptingNewPatientsMutation, { data, loading, error }] = useSetAcceptingNewPatientsMutation({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *      acceptingNewPatients: // value for 'acceptingNewPatients'
 *   },
 * });
 */
export function useSetAcceptingNewPatientsMutation(baseOptions?: Apollo.MutationHookOptions<SetAcceptingNewPatientsMutation, SetAcceptingNewPatientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAcceptingNewPatientsMutation, SetAcceptingNewPatientsMutationVariables>(SetAcceptingNewPatientsDocument, options);
      }
export type SetAcceptingNewPatientsMutationHookResult = ReturnType<typeof useSetAcceptingNewPatientsMutation>;
export type SetAcceptingNewPatientsMutationResult = Apollo.MutationResult<SetAcceptingNewPatientsMutation>;
export type SetAcceptingNewPatientsMutationOptions = Apollo.BaseMutationOptions<SetAcceptingNewPatientsMutation, SetAcceptingNewPatientsMutationVariables>;
export const StartAppointmentDocument = gql`
    mutation StartAppointment($appointmentId: ID!, $startTime: DateTime!) {
  updateAppointment(where: {id: $appointmentId}, data: {startedAt: $startTime}) {
    id
    startedAt
  }
}
    `;
export type StartAppointmentMutationFn = Apollo.MutationFunction<StartAppointmentMutation, StartAppointmentMutationVariables>;

/**
 * __useStartAppointmentMutation__
 *
 * To run a mutation, you first call `useStartAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAppointmentMutation, { data, loading, error }] = useStartAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useStartAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<StartAppointmentMutation, StartAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAppointmentMutation, StartAppointmentMutationVariables>(StartAppointmentDocument, options);
      }
export type StartAppointmentMutationHookResult = ReturnType<typeof useStartAppointmentMutation>;
export type StartAppointmentMutationResult = Apollo.MutationResult<StartAppointmentMutation>;
export type StartAppointmentMutationOptions = Apollo.BaseMutationOptions<StartAppointmentMutation, StartAppointmentMutationVariables>;
export const StartFaxBlastDocument = gql`
    mutation StartFaxBlast($faxBlastId: ID!) {
  startFaxBlast(faxBlastId: $faxBlastId) {
    id
  }
}
    `;
export type StartFaxBlastMutationFn = Apollo.MutationFunction<StartFaxBlastMutation, StartFaxBlastMutationVariables>;

/**
 * __useStartFaxBlastMutation__
 *
 * To run a mutation, you first call `useStartFaxBlastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFaxBlastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFaxBlastMutation, { data, loading, error }] = useStartFaxBlastMutation({
 *   variables: {
 *      faxBlastId: // value for 'faxBlastId'
 *   },
 * });
 */
export function useStartFaxBlastMutation(baseOptions?: Apollo.MutationHookOptions<StartFaxBlastMutation, StartFaxBlastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartFaxBlastMutation, StartFaxBlastMutationVariables>(StartFaxBlastDocument, options);
      }
export type StartFaxBlastMutationHookResult = ReturnType<typeof useStartFaxBlastMutation>;
export type StartFaxBlastMutationResult = Apollo.MutationResult<StartFaxBlastMutation>;
export type StartFaxBlastMutationOptions = Apollo.BaseMutationOptions<StartFaxBlastMutation, StartFaxBlastMutationVariables>;
export const SubmitMyClaimsInCompanyDocument = gql`
    mutation SubmitMyClaimsInCompany($companyId: ID!, $couponId: ID) {
  submitMyClaimsInCompany(companyId: $companyId, couponId: $couponId) {
    success
  }
}
    `;
export type SubmitMyClaimsInCompanyMutationFn = Apollo.MutationFunction<SubmitMyClaimsInCompanyMutation, SubmitMyClaimsInCompanyMutationVariables>;

/**
 * __useSubmitMyClaimsInCompanyMutation__
 *
 * To run a mutation, you first call `useSubmitMyClaimsInCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMyClaimsInCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMyClaimsInCompanyMutation, { data, loading, error }] = useSubmitMyClaimsInCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useSubmitMyClaimsInCompanyMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMyClaimsInCompanyMutation, SubmitMyClaimsInCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMyClaimsInCompanyMutation, SubmitMyClaimsInCompanyMutationVariables>(SubmitMyClaimsInCompanyDocument, options);
      }
export type SubmitMyClaimsInCompanyMutationHookResult = ReturnType<typeof useSubmitMyClaimsInCompanyMutation>;
export type SubmitMyClaimsInCompanyMutationResult = Apollo.MutationResult<SubmitMyClaimsInCompanyMutation>;
export type SubmitMyClaimsInCompanyMutationOptions = Apollo.BaseMutationOptions<SubmitMyClaimsInCompanyMutation, SubmitMyClaimsInCompanyMutationVariables>;
export const UnlinkTestOrderToFaxDocument = gql`
    mutation UnlinkTestOrderToFax($inboundFaxId: ID!) {
  updateInboundFax(
    where: {id: $inboundFaxId}
    data: {testOrder: {disconnect: true}}
  ) {
    id
    testOrder {
      id
    }
  }
}
    `;
export type UnlinkTestOrderToFaxMutationFn = Apollo.MutationFunction<UnlinkTestOrderToFaxMutation, UnlinkTestOrderToFaxMutationVariables>;

/**
 * __useUnlinkTestOrderToFaxMutation__
 *
 * To run a mutation, you first call `useUnlinkTestOrderToFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTestOrderToFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTestOrderToFaxMutation, { data, loading, error }] = useUnlinkTestOrderToFaxMutation({
 *   variables: {
 *      inboundFaxId: // value for 'inboundFaxId'
 *   },
 * });
 */
export function useUnlinkTestOrderToFaxMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTestOrderToFaxMutation, UnlinkTestOrderToFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTestOrderToFaxMutation, UnlinkTestOrderToFaxMutationVariables>(UnlinkTestOrderToFaxDocument, options);
      }
export type UnlinkTestOrderToFaxMutationHookResult = ReturnType<typeof useUnlinkTestOrderToFaxMutation>;
export type UnlinkTestOrderToFaxMutationResult = Apollo.MutationResult<UnlinkTestOrderToFaxMutation>;
export type UnlinkTestOrderToFaxMutationOptions = Apollo.BaseMutationOptions<UnlinkTestOrderToFaxMutation, UnlinkTestOrderToFaxMutationVariables>;
export const UnmarkBillingDocument = gql`
    mutation UnmarkBilling($billingId: ID!) {
  unmarkBilling(billingId: $billingId) {
    id
    status
  }
}
    `;
export type UnmarkBillingMutationFn = Apollo.MutationFunction<UnmarkBillingMutation, UnmarkBillingMutationVariables>;

/**
 * __useUnmarkBillingMutation__
 *
 * To run a mutation, you first call `useUnmarkBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmarkBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmarkBillingMutation, { data, loading, error }] = useUnmarkBillingMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *   },
 * });
 */
export function useUnmarkBillingMutation(baseOptions?: Apollo.MutationHookOptions<UnmarkBillingMutation, UnmarkBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmarkBillingMutation, UnmarkBillingMutationVariables>(UnmarkBillingDocument, options);
      }
export type UnmarkBillingMutationHookResult = ReturnType<typeof useUnmarkBillingMutation>;
export type UnmarkBillingMutationResult = Apollo.MutationResult<UnmarkBillingMutation>;
export type UnmarkBillingMutationOptions = Apollo.BaseMutationOptions<UnmarkBillingMutation, UnmarkBillingMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($addressId: ID!, $addressLine1: String, $addressLine2: String, $administrativeArea: String, $locality: String, $postalCode: String, $thoroughfare: String, $country: String) {
  updateAddress(
    where: {id: $addressId}
    data: {addressLine1: $addressLine1, addressLine2: $addressLine2, administrativeArea: $administrativeArea, locality: $locality, postalCode: $postalCode, thoroughfare: $thoroughfare, country: $country}
  ) {
    id
    country
    addressLine1
    addressLine2
    administrativeArea
    locality
    postalCode
    thoroughfare
  }
}
    `;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      administrativeArea: // value for 'administrativeArea'
 *      locality: // value for 'locality'
 *      postalCode: // value for 'postalCode'
 *      thoroughfare: // value for 'thoroughfare'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation UpdateAppointment($data: AppointmentUpdateInput!, $where: AppointmentWhereUniqueInput!) {
  updateAppointment(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const UpdateBillingClinicDocument = gql`
    mutation UpdateBillingClinic($billingId: ID!, $clinicId: ID!) {
  updateAppointmentBilling(
    where: {id: $billingId}
    data: {billingClinic: {connect: {id: $clinicId}}}
  ) {
    id
    billingClinic {
      id
      ohipGroupNumber
    }
  }
}
    `;
export type UpdateBillingClinicMutationFn = Apollo.MutationFunction<UpdateBillingClinicMutation, UpdateBillingClinicMutationVariables>;

/**
 * __useUpdateBillingClinicMutation__
 *
 * To run a mutation, you first call `useUpdateBillingClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingClinicMutation, { data, loading, error }] = useUpdateBillingClinicMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useUpdateBillingClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingClinicMutation, UpdateBillingClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingClinicMutation, UpdateBillingClinicMutationVariables>(UpdateBillingClinicDocument, options);
      }
export type UpdateBillingClinicMutationHookResult = ReturnType<typeof useUpdateBillingClinicMutation>;
export type UpdateBillingClinicMutationResult = Apollo.MutationResult<UpdateBillingClinicMutation>;
export type UpdateBillingClinicMutationOptions = Apollo.BaseMutationOptions<UpdateBillingClinicMutation, UpdateBillingClinicMutationVariables>;
export const UpdateBillingManualReviewDocument = gql`
    mutation UpdateBillingManualReview($billingId: ID!, $isManualReviewRequired: Boolean) {
  updateAppointmentBilling(
    where: {id: $billingId}
    data: {isManualReviewRequired: $isManualReviewRequired}
  ) {
    id
    isManualReviewRequired
  }
}
    `;
export type UpdateBillingManualReviewMutationFn = Apollo.MutationFunction<UpdateBillingManualReviewMutation, UpdateBillingManualReviewMutationVariables>;

/**
 * __useUpdateBillingManualReviewMutation__
 *
 * To run a mutation, you first call `useUpdateBillingManualReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingManualReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingManualReviewMutation, { data, loading, error }] = useUpdateBillingManualReviewMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *      isManualReviewRequired: // value for 'isManualReviewRequired'
 *   },
 * });
 */
export function useUpdateBillingManualReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingManualReviewMutation, UpdateBillingManualReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingManualReviewMutation, UpdateBillingManualReviewMutationVariables>(UpdateBillingManualReviewDocument, options);
      }
export type UpdateBillingManualReviewMutationHookResult = ReturnType<typeof useUpdateBillingManualReviewMutation>;
export type UpdateBillingManualReviewMutationResult = Apollo.MutationResult<UpdateBillingManualReviewMutation>;
export type UpdateBillingManualReviewMutationOptions = Apollo.BaseMutationOptions<UpdateBillingManualReviewMutation, UpdateBillingManualReviewMutationVariables>;
export const UpdateCalendarDefaultScheduleDocument = gql`
    mutation UpdateCalendarDefaultSchedule($calendarId: ID!, $scheduleId: ID!) {
  updateCalendar(
    where: {id: $calendarId}
    data: {defaultSchedule: {connect: {id: $scheduleId}}}
  ) {
    id
    defaultSchedule {
      id
    }
  }
}
    `;
export type UpdateCalendarDefaultScheduleMutationFn = Apollo.MutationFunction<UpdateCalendarDefaultScheduleMutation, UpdateCalendarDefaultScheduleMutationVariables>;

/**
 * __useUpdateCalendarDefaultScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarDefaultScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarDefaultScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarDefaultScheduleMutation, { data, loading, error }] = useUpdateCalendarDefaultScheduleMutation({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useUpdateCalendarDefaultScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarDefaultScheduleMutation, UpdateCalendarDefaultScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarDefaultScheduleMutation, UpdateCalendarDefaultScheduleMutationVariables>(UpdateCalendarDefaultScheduleDocument, options);
      }
export type UpdateCalendarDefaultScheduleMutationHookResult = ReturnType<typeof useUpdateCalendarDefaultScheduleMutation>;
export type UpdateCalendarDefaultScheduleMutationResult = Apollo.MutationResult<UpdateCalendarDefaultScheduleMutation>;
export type UpdateCalendarDefaultScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarDefaultScheduleMutation, UpdateCalendarDefaultScheduleMutationVariables>;
export const UpdateChatMessageDocument = gql`
    mutation UpdateChatMessage($chatMessageId: ID!, $data: ChatMessageUpdateInput!) {
  updateChatMessage(where: {id: $chatMessageId}, data: $data) {
    id
  }
}
    `;
export type UpdateChatMessageMutationFn = Apollo.MutationFunction<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>;

/**
 * __useUpdateChatMessageMutation__
 *
 * To run a mutation, you first call `useUpdateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMessageMutation, { data, loading, error }] = useUpdateChatMessageMutation({
 *   variables: {
 *      chatMessageId: // value for 'chatMessageId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>(UpdateChatMessageDocument, options);
      }
export type UpdateChatMessageMutationHookResult = ReturnType<typeof useUpdateChatMessageMutation>;
export type UpdateChatMessageMutationResult = Apollo.MutationResult<UpdateChatMessageMutation>;
export type UpdateChatMessageMutationOptions = Apollo.BaseMutationOptions<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>;
export const UpdateClinicDocument = gql`
    mutation UpdateClinic($clinicId: ID!, $data: ClinicUpdateInput!) {
  updateClinic(where: {id: $clinicId}, data: $data) {
    id
    createdAt
    description
    facilityMasterNumber
    faxNumber
    name
    ohipGroupNumber
    phoneNumber
    serviceLocationIndicator
    address {
      ...AddressFields
    }
    company {
      id
      legalName
      operatingName
    }
  }
}
    ${AddressFieldsFragmentDoc}`;
export type UpdateClinicMutationFn = Apollo.MutationFunction<UpdateClinicMutation, UpdateClinicMutationVariables>;

/**
 * __useUpdateClinicMutation__
 *
 * To run a mutation, you first call `useUpdateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicMutation, { data, loading, error }] = useUpdateClinicMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicMutation, UpdateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicMutation, UpdateClinicMutationVariables>(UpdateClinicDocument, options);
      }
export type UpdateClinicMutationHookResult = ReturnType<typeof useUpdateClinicMutation>;
export type UpdateClinicMutationResult = Apollo.MutationResult<UpdateClinicMutation>;
export type UpdateClinicMutationOptions = Apollo.BaseMutationOptions<UpdateClinicMutation, UpdateClinicMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($companyId: ID!, $data: CompanyUpdateInput!) {
  updateCompany(where: {id: $companyId}, data: $data) {
    id
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateContractDocument = gql`
    mutation UpdateContract($contractId: ID!, $data: ContractUpdateInput!) {
  updateContract(where: {id: $contractId}, data: $data) {
    id
    content
    createdAt
    effectiveFrom
    isActive
    lastUpdated
    name
    slug
    author {
      id
    }
    signedBy {
      id
    }
  }
}
    `;
export type UpdateContractMutationFn = Apollo.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const UpdateContractSignatureDocument = gql`
    mutation UpdateContractSignature($contractId: ID!, $signedByUserId: ID!) {
  updateContract(
    where: {id: $contractId}
    data: {signedBy: {connect: {id: $signedByUserId}}}
  ) {
    id
    signedBy {
      id
    }
  }
}
    `;
export type UpdateContractSignatureMutationFn = Apollo.MutationFunction<UpdateContractSignatureMutation, UpdateContractSignatureMutationVariables>;

/**
 * __useUpdateContractSignatureMutation__
 *
 * To run a mutation, you first call `useUpdateContractSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractSignatureMutation, { data, loading, error }] = useUpdateContractSignatureMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      signedByUserId: // value for 'signedByUserId'
 *   },
 * });
 */
export function useUpdateContractSignatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractSignatureMutation, UpdateContractSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractSignatureMutation, UpdateContractSignatureMutationVariables>(UpdateContractSignatureDocument, options);
      }
export type UpdateContractSignatureMutationHookResult = ReturnType<typeof useUpdateContractSignatureMutation>;
export type UpdateContractSignatureMutationResult = Apollo.MutationResult<UpdateContractSignatureMutation>;
export type UpdateContractSignatureMutationOptions = Apollo.BaseMutationOptions<UpdateContractSignatureMutation, UpdateContractSignatureMutationVariables>;
export const UpdateDoctorGosGrantedDocument = gql`
    mutation UpdateDoctorGosGranted($doctorId: ID!, $isGoSecureGranted: Boolean) {
  updateDoctor(
    where: {id: $doctorId}
    data: {isGoSecureGranted: $isGoSecureGranted}
  ) {
    id
    isGoSecureGranted
  }
}
    `;
export type UpdateDoctorGosGrantedMutationFn = Apollo.MutationFunction<UpdateDoctorGosGrantedMutation, UpdateDoctorGosGrantedMutationVariables>;

/**
 * __useUpdateDoctorGosGrantedMutation__
 *
 * To run a mutation, you first call `useUpdateDoctorGosGrantedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDoctorGosGrantedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDoctorGosGrantedMutation, { data, loading, error }] = useUpdateDoctorGosGrantedMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      isGoSecureGranted: // value for 'isGoSecureGranted'
 *   },
 * });
 */
export function useUpdateDoctorGosGrantedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDoctorGosGrantedMutation, UpdateDoctorGosGrantedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDoctorGosGrantedMutation, UpdateDoctorGosGrantedMutationVariables>(UpdateDoctorGosGrantedDocument, options);
      }
export type UpdateDoctorGosGrantedMutationHookResult = ReturnType<typeof useUpdateDoctorGosGrantedMutation>;
export type UpdateDoctorGosGrantedMutationResult = Apollo.MutationResult<UpdateDoctorGosGrantedMutation>;
export type UpdateDoctorGosGrantedMutationOptions = Apollo.BaseMutationOptions<UpdateDoctorGosGrantedMutation, UpdateDoctorGosGrantedMutationVariables>;
export const UpdateDoctorDocument = gql`
    mutation UpdateDoctor($contractSignedOn: DateTime, $doctorId: ID!, $doctorSince: DateTime, $doctorSpecialty: DoctorSpecialtyRelateToOneForUpdateInput, $doctorSubSpecialties: DoctorSubSpecialtyRelateToManyForUpdateInput, $email: String, $languages: LanguageRelateToManyForUpdateInput, $licenseNumber: String, $licenseProvider: String, $medicalLiabilityNumber: String, $medicalLiabilityProvider: String, $ohipPractitionerNumber: String, $ohipSpecialityCode: String, $summary: String, $clinicFMN: String, $clinicFaxNumber: String, $clinicOHIPBillingCode: String, $clinicPhoneNumber: String, $clinicSLI: String, $signature: SignatureRelateToOneForUpdateInput) {
  updateDoctor(
    where: {id: $doctorId}
    data: {doctorSpecialty: $doctorSpecialty, doctorSubSpecialties: $doctorSubSpecialties, contractSignedOn: $contractSignedOn, doctorSince: $doctorSince, email: $email, languages: $languages, licenseNumber: $licenseNumber, licenseProvider: $licenseProvider, medicalLiabilityNumber: $medicalLiabilityNumber, medicalLiabilityProvider: $medicalLiabilityProvider, ohipPractitionerNumber: $ohipPractitionerNumber, ohipSpecialityCode: $ohipSpecialityCode, summary: $summary, clinicFMN: $clinicFMN, clinicFaxNumber: $clinicFaxNumber, clinicOHIPBillingCode: $clinicOHIPBillingCode, clinicPhoneNumber: $clinicPhoneNumber, clinicSLI: $clinicSLI, signature: $signature}
  ) {
    ...DoctorProfileFields
    clinicFMN
    clinicFaxNumber
    clinicOHIPBillingCode
    clinicPhoneNumber
    clinicSLI
    signature {
      id
      file {
        ...FileFields
      }
      attachment {
        url
      }
    }
  }
}
    ${DoctorProfileFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export type UpdateDoctorMutationFn = Apollo.MutationFunction<UpdateDoctorMutation, UpdateDoctorMutationVariables>;

/**
 * __useUpdateDoctorMutation__
 *
 * To run a mutation, you first call `useUpdateDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDoctorMutation, { data, loading, error }] = useUpdateDoctorMutation({
 *   variables: {
 *      contractSignedOn: // value for 'contractSignedOn'
 *      doctorId: // value for 'doctorId'
 *      doctorSince: // value for 'doctorSince'
 *      doctorSpecialty: // value for 'doctorSpecialty'
 *      doctorSubSpecialties: // value for 'doctorSubSpecialties'
 *      email: // value for 'email'
 *      languages: // value for 'languages'
 *      licenseNumber: // value for 'licenseNumber'
 *      licenseProvider: // value for 'licenseProvider'
 *      medicalLiabilityNumber: // value for 'medicalLiabilityNumber'
 *      medicalLiabilityProvider: // value for 'medicalLiabilityProvider'
 *      ohipPractitionerNumber: // value for 'ohipPractitionerNumber'
 *      ohipSpecialityCode: // value for 'ohipSpecialityCode'
 *      summary: // value for 'summary'
 *      clinicFMN: // value for 'clinicFMN'
 *      clinicFaxNumber: // value for 'clinicFaxNumber'
 *      clinicOHIPBillingCode: // value for 'clinicOHIPBillingCode'
 *      clinicPhoneNumber: // value for 'clinicPhoneNumber'
 *      clinicSLI: // value for 'clinicSLI'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useUpdateDoctorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDoctorMutation, UpdateDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDoctorMutation, UpdateDoctorMutationVariables>(UpdateDoctorDocument, options);
      }
export type UpdateDoctorMutationHookResult = ReturnType<typeof useUpdateDoctorMutation>;
export type UpdateDoctorMutationResult = Apollo.MutationResult<UpdateDoctorMutation>;
export type UpdateDoctorMutationOptions = Apollo.BaseMutationOptions<UpdateDoctorMutation, UpdateDoctorMutationVariables>;
export const UpdateDoctorVerifiedDocument = gql`
    mutation UpdateDoctorVerified($doctorId: ID!, $isVerified: Boolean!) {
  updateDoctor(where: {id: $doctorId}, data: {isVerified: $isVerified}) {
    id
    isVerified
  }
}
    `;
export type UpdateDoctorVerifiedMutationFn = Apollo.MutationFunction<UpdateDoctorVerifiedMutation, UpdateDoctorVerifiedMutationVariables>;

/**
 * __useUpdateDoctorVerifiedMutation__
 *
 * To run a mutation, you first call `useUpdateDoctorVerifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDoctorVerifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDoctorVerifiedMutation, { data, loading, error }] = useUpdateDoctorVerifiedMutation({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      isVerified: // value for 'isVerified'
 *   },
 * });
 */
export function useUpdateDoctorVerifiedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDoctorVerifiedMutation, UpdateDoctorVerifiedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDoctorVerifiedMutation, UpdateDoctorVerifiedMutationVariables>(UpdateDoctorVerifiedDocument, options);
      }
export type UpdateDoctorVerifiedMutationHookResult = ReturnType<typeof useUpdateDoctorVerifiedMutation>;
export type UpdateDoctorVerifiedMutationResult = Apollo.MutationResult<UpdateDoctorVerifiedMutation>;
export type UpdateDoctorVerifiedMutationOptions = Apollo.BaseMutationOptions<UpdateDoctorVerifiedMutation, UpdateDoctorVerifiedMutationVariables>;
export const UpdateEmergencyContactDocument = gql`
    mutation UpdateEmergencyContact($emergencyContactId: ID!, $cellPhoneNumberString: String!, $email: String, $firstName: String!, $homePhoneNumberString: String!, $lastName: String!, $relation: String) {
  updateEmergencyContact(
    where: {id: $emergencyContactId}
    data: {cellPhoneNumberString: $cellPhoneNumberString, email: $email, firstName: $firstName, homePhoneNumberString: $homePhoneNumberString, lastName: $lastName, relation: $relation}
  ) {
    ...EmergencyContactFields
  }
}
    ${EmergencyContactFieldsFragmentDoc}`;
export type UpdateEmergencyContactMutationFn = Apollo.MutationFunction<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>;

/**
 * __useUpdateEmergencyContactMutation__
 *
 * To run a mutation, you first call `useUpdateEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmergencyContactMutation, { data, loading, error }] = useUpdateEmergencyContactMutation({
 *   variables: {
 *      emergencyContactId: // value for 'emergencyContactId'
 *      cellPhoneNumberString: // value for 'cellPhoneNumberString'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      homePhoneNumberString: // value for 'homePhoneNumberString'
 *      lastName: // value for 'lastName'
 *      relation: // value for 'relation'
 *   },
 * });
 */
export function useUpdateEmergencyContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>(UpdateEmergencyContactDocument, options);
      }
export type UpdateEmergencyContactMutationHookResult = ReturnType<typeof useUpdateEmergencyContactMutation>;
export type UpdateEmergencyContactMutationResult = Apollo.MutationResult<UpdateEmergencyContactMutation>;
export type UpdateEmergencyContactMutationOptions = Apollo.BaseMutationOptions<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>;
export const UpdateEventsDurationDocument = gql`
    mutation UpdateEventsDuration($durationEventsData: [CalendarEventUpdateArgs!]!) {
  updateCalendarEvents(data: $durationEventsData) {
    id
    durationMins
  }
}
    `;
export type UpdateEventsDurationMutationFn = Apollo.MutationFunction<UpdateEventsDurationMutation, UpdateEventsDurationMutationVariables>;

/**
 * __useUpdateEventsDurationMutation__
 *
 * To run a mutation, you first call `useUpdateEventsDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventsDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventsDurationMutation, { data, loading, error }] = useUpdateEventsDurationMutation({
 *   variables: {
 *      durationEventsData: // value for 'durationEventsData'
 *   },
 * });
 */
export function useUpdateEventsDurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventsDurationMutation, UpdateEventsDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventsDurationMutation, UpdateEventsDurationMutationVariables>(UpdateEventsDurationDocument, options);
      }
export type UpdateEventsDurationMutationHookResult = ReturnType<typeof useUpdateEventsDurationMutation>;
export type UpdateEventsDurationMutationResult = Apollo.MutationResult<UpdateEventsDurationMutation>;
export type UpdateEventsDurationMutationOptions = Apollo.BaseMutationOptions<UpdateEventsDurationMutation, UpdateEventsDurationMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($address: AddressRelateToOneForUpdateInput, $companyName: String, $description: String, $durationMins: Int, $eventId: ID!, $facilityMasterNumber: String, $isActive: Boolean, $serviceLocationIndicator: String, $title: String) {
  updateCalendarEvent(
    where: {id: $eventId}
    data: {address: $address, companyName: $companyName, description: $description, durationMins: $durationMins, facilityMasterNumber: $facilityMasterNumber, isActive: $isActive, serviceLocationIndicator: $serviceLocationIndicator, title: $title}
  ) {
    id
    address {
      ...AddressFields
    }
    companyName
    description
    durationMins
    facilityMasterNumber
    isActive
    isAcceptingInPerson
    isAcceptingVirtual
    serviceLocationIndicator
    title
  }
}
    ${AddressFieldsFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      address: // value for 'address'
 *      companyName: // value for 'companyName'
 *      description: // value for 'description'
 *      durationMins: // value for 'durationMins'
 *      eventId: // value for 'eventId'
 *      facilityMasterNumber: // value for 'facilityMasterNumber'
 *      isActive: // value for 'isActive'
 *      serviceLocationIndicator: // value for 'serviceLocationIndicator'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateFaxBlastDocument = gql`
    mutation UpdateFaxBlast($faxBlastId: ID!, $data: FaxBlastUpdateInput!) {
  updateFaxBlast(where: {id: $faxBlastId}, data: $data) {
    id
    createdAt
    description
    title
  }
}
    `;
export type UpdateFaxBlastMutationFn = Apollo.MutationFunction<UpdateFaxBlastMutation, UpdateFaxBlastMutationVariables>;

/**
 * __useUpdateFaxBlastMutation__
 *
 * To run a mutation, you first call `useUpdateFaxBlastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaxBlastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaxBlastMutation, { data, loading, error }] = useUpdateFaxBlastMutation({
 *   variables: {
 *      faxBlastId: // value for 'faxBlastId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFaxBlastMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaxBlastMutation, UpdateFaxBlastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaxBlastMutation, UpdateFaxBlastMutationVariables>(UpdateFaxBlastDocument, options);
      }
export type UpdateFaxBlastMutationHookResult = ReturnType<typeof useUpdateFaxBlastMutation>;
export type UpdateFaxBlastMutationResult = Apollo.MutationResult<UpdateFaxBlastMutation>;
export type UpdateFaxBlastMutationOptions = Apollo.BaseMutationOptions<UpdateFaxBlastMutation, UpdateFaxBlastMutationVariables>;
export const UpdateFaxDocument = gql`
    mutation UpdateFax($faxId: ID!, $data: FaxUpdateInput!) {
  updateFax(where: {id: $faxId}, data: $data) {
    id
    status
  }
}
    `;
export type UpdateFaxMutationFn = Apollo.MutationFunction<UpdateFaxMutation, UpdateFaxMutationVariables>;

/**
 * __useUpdateFaxMutation__
 *
 * To run a mutation, you first call `useUpdateFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaxMutation, { data, loading, error }] = useUpdateFaxMutation({
 *   variables: {
 *      faxId: // value for 'faxId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFaxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaxMutation, UpdateFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaxMutation, UpdateFaxMutationVariables>(UpdateFaxDocument, options);
      }
export type UpdateFaxMutationHookResult = ReturnType<typeof useUpdateFaxMutation>;
export type UpdateFaxMutationResult = Apollo.MutationResult<UpdateFaxMutation>;
export type UpdateFaxMutationOptions = Apollo.BaseMutationOptions<UpdateFaxMutation, UpdateFaxMutationVariables>;
export const UpdateFaxRecipientDocument = gql`
    mutation UpdateFaxRecipient($faxRecipientId: ID!, $data: FaxRecipientUpdateInput!) {
  updateFaxRecipient(where: {id: $faxRecipientId}, data: $data) {
    id
  }
}
    `;
export type UpdateFaxRecipientMutationFn = Apollo.MutationFunction<UpdateFaxRecipientMutation, UpdateFaxRecipientMutationVariables>;

/**
 * __useUpdateFaxRecipientMutation__
 *
 * To run a mutation, you first call `useUpdateFaxRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaxRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaxRecipientMutation, { data, loading, error }] = useUpdateFaxRecipientMutation({
 *   variables: {
 *      faxRecipientId: // value for 'faxRecipientId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFaxRecipientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaxRecipientMutation, UpdateFaxRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaxRecipientMutation, UpdateFaxRecipientMutationVariables>(UpdateFaxRecipientDocument, options);
      }
export type UpdateFaxRecipientMutationHookResult = ReturnType<typeof useUpdateFaxRecipientMutation>;
export type UpdateFaxRecipientMutationResult = Apollo.MutationResult<UpdateFaxRecipientMutation>;
export type UpdateFaxRecipientMutationOptions = Apollo.BaseMutationOptions<UpdateFaxRecipientMutation, UpdateFaxRecipientMutationVariables>;
export const UpdateFileDocument = gql`
    mutation UpdateFile($fileId: ID!, $data: FileUpdateInput!) {
  updateFile(where: {id: $fileId}, data: $data) {
    id
    fileName
  }
}
    `;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($name: String, $formId: ID!, $formFields: JSON, $slug: String) {
  updateForm(
    where: {id: $formId}
    data: {name: $name, formFields: $formFields, slug: $slug}
  ) {
    id
    formFields
    name
    slug
  }
}
    `;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      name: // value for 'name'
 *      formId: // value for 'formId'
 *      formFields: // value for 'formFields'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const UpdateHealthCardDocument = gql`
    mutation UpdateHealthCard($healthCardId: ID!, $expiryDate: DateTime!, $versionCode: String, $insurancePolicyNumber: String!) {
  updateHealthCard(
    where: {id: $healthCardId}
    data: {versionCode: $versionCode, expiryDate: $expiryDate, insurancePolicyNumber: $insurancePolicyNumber}
  ) {
    ...HealthCardFields
  }
}
    ${HealthCardFieldsFragmentDoc}`;
export type UpdateHealthCardMutationFn = Apollo.MutationFunction<UpdateHealthCardMutation, UpdateHealthCardMutationVariables>;

/**
 * __useUpdateHealthCardMutation__
 *
 * To run a mutation, you first call `useUpdateHealthCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHealthCardMutation, { data, loading, error }] = useUpdateHealthCardMutation({
 *   variables: {
 *      healthCardId: // value for 'healthCardId'
 *      expiryDate: // value for 'expiryDate'
 *      versionCode: // value for 'versionCode'
 *      insurancePolicyNumber: // value for 'insurancePolicyNumber'
 *   },
 * });
 */
export function useUpdateHealthCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHealthCardMutation, UpdateHealthCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHealthCardMutation, UpdateHealthCardMutationVariables>(UpdateHealthCardDocument, options);
      }
export type UpdateHealthCardMutationHookResult = ReturnType<typeof useUpdateHealthCardMutation>;
export type UpdateHealthCardMutationResult = Apollo.MutationResult<UpdateHealthCardMutation>;
export type UpdateHealthCardMutationOptions = Apollo.BaseMutationOptions<UpdateHealthCardMutation, UpdateHealthCardMutationVariables>;
export const UpdateMyProfileDocument = gql`
    mutation UpdateMyProfile($dateOfBirth: DateTime, $email: String, $firstName: String, $lastName: String, $middleName: String, $sex: String, $cellPhoneNumberString: String, $homePhoneNumberString: String, $userId: ID!, $photoSrc: String) {
  updateUser(
    where: {id: $userId}
    data: {middleName: $middleName, dateOfBirth: $dateOfBirth, email: $email, firstName: $firstName, lastName: $lastName, sex: $sex, cellPhoneNumberString: $cellPhoneNumberString, homePhoneNumberString: $homePhoneNumberString, photoSrc: $photoSrc}
  ) {
    id
    cellPhoneNumberString
    dateOfBirth
    email
    firstName
    sex
    homePhoneNumberString
    lastName
    middleName
    photoSrc
  }
}
    `;
export type UpdateMyProfileMutationFn = Apollo.MutationFunction<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>;

/**
 * __useUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyProfileMutation, { data, loading, error }] = useUpdateMyProfileMutation({
 *   variables: {
 *      dateOfBirth: // value for 'dateOfBirth'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      middleName: // value for 'middleName'
 *      sex: // value for 'sex'
 *      cellPhoneNumberString: // value for 'cellPhoneNumberString'
 *      homePhoneNumberString: // value for 'homePhoneNumberString'
 *      userId: // value for 'userId'
 *      photoSrc: // value for 'photoSrc'
 *   },
 * });
 */
export function useUpdateMyProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>(UpdateMyProfileDocument, options);
      }
export type UpdateMyProfileMutationHookResult = ReturnType<typeof useUpdateMyProfileMutation>;
export type UpdateMyProfileMutationResult = Apollo.MutationResult<UpdateMyProfileMutation>;
export type UpdateMyProfileMutationOptions = Apollo.BaseMutationOptions<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>;
export const UpdatePrescriptionDocument = gql`
    mutation UpdatePrescription($prescriptionId: ID!, $data: PrescriptionUpdateInput!) {
  updatePrescription(data: $data, where: {id: $prescriptionId}) {
    id
    isSubstitutionAllowed
    patient {
      id
      pharmacyLocations {
        id
        faxString
        phoneString
        address {
          id
          addressLine1
          locality
        }
        pharmacy {
          id
          companyName
        }
      }
    }
    preferredPharmacyLocation {
      id
      faxString
      phoneString
      address {
        id
        addressLine1
        locality
      }
      pharmacy {
        id
        companyName
      }
    }
    prescriptionItems {
      id
      instructions
      medication {
        id
        brandName
      }
    }
  }
}
    `;
export type UpdatePrescriptionMutationFn = Apollo.MutationFunction<UpdatePrescriptionMutation, UpdatePrescriptionMutationVariables>;

/**
 * __useUpdatePrescriptionMutation__
 *
 * To run a mutation, you first call `useUpdatePrescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrescriptionMutation, { data, loading, error }] = useUpdatePrescriptionMutation({
 *   variables: {
 *      prescriptionId: // value for 'prescriptionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePrescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrescriptionMutation, UpdatePrescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrescriptionMutation, UpdatePrescriptionMutationVariables>(UpdatePrescriptionDocument, options);
      }
export type UpdatePrescriptionMutationHookResult = ReturnType<typeof useUpdatePrescriptionMutation>;
export type UpdatePrescriptionMutationResult = Apollo.MutationResult<UpdatePrescriptionMutation>;
export type UpdatePrescriptionMutationOptions = Apollo.BaseMutationOptions<UpdatePrescriptionMutation, UpdatePrescriptionMutationVariables>;
export const UpdateScheduleIntervalDocument = gql`
    mutation UpdateScheduleInterval($scheduleId: ID!, $slotInterval: Int!) {
  updateSchedule(where: {id: $scheduleId}, data: {slotInterval: $slotInterval}) {
    id
  }
}
    `;
export type UpdateScheduleIntervalMutationFn = Apollo.MutationFunction<UpdateScheduleIntervalMutation, UpdateScheduleIntervalMutationVariables>;

/**
 * __useUpdateScheduleIntervalMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleIntervalMutation, { data, loading, error }] = useUpdateScheduleIntervalMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      slotInterval: // value for 'slotInterval'
 *   },
 * });
 */
export function useUpdateScheduleIntervalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleIntervalMutation, UpdateScheduleIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleIntervalMutation, UpdateScheduleIntervalMutationVariables>(UpdateScheduleIntervalDocument, options);
      }
export type UpdateScheduleIntervalMutationHookResult = ReturnType<typeof useUpdateScheduleIntervalMutation>;
export type UpdateScheduleIntervalMutationResult = Apollo.MutationResult<UpdateScheduleIntervalMutation>;
export type UpdateScheduleIntervalMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleIntervalMutation, UpdateScheduleIntervalMutationVariables>;
export const UpdateScheduleDocument = gql`
    mutation UpdateSchedule($scheduleId: ID!, $data: ScheduleUpdateInput!) {
  updateSchedule(where: {id: $scheduleId}, data: $data) {
    id
    blockedDates
    blockedTimeIntervals {
      id
      from
      to
    }
    defaultOn {
      id
    }
    description
    futureLimit
    slotInterval
    title
    tz
  }
}
    `;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, options);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const UpdateScheduleTimezoneDocument = gql`
    mutation UpdateScheduleTimezone($scheduleId: ID!, $tz: String!) {
  updateSchedule(where: {id: $scheduleId}, data: {tz: $tz}) {
    id
    tz
  }
}
    `;
export type UpdateScheduleTimezoneMutationFn = Apollo.MutationFunction<UpdateScheduleTimezoneMutation, UpdateScheduleTimezoneMutationVariables>;

/**
 * __useUpdateScheduleTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleTimezoneMutation, { data, loading, error }] = useUpdateScheduleTimezoneMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      tz: // value for 'tz'
 *   },
 * });
 */
export function useUpdateScheduleTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleTimezoneMutation, UpdateScheduleTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleTimezoneMutation, UpdateScheduleTimezoneMutationVariables>(UpdateScheduleTimezoneDocument, options);
      }
export type UpdateScheduleTimezoneMutationHookResult = ReturnType<typeof useUpdateScheduleTimezoneMutation>;
export type UpdateScheduleTimezoneMutationResult = Apollo.MutationResult<UpdateScheduleTimezoneMutation>;
export type UpdateScheduleTimezoneMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleTimezoneMutation, UpdateScheduleTimezoneMutationVariables>;
export const UpdateStepperProgDocument = gql`
    mutation UpdateStepperProg($stepperProgId: ID!, $companyId: ID!) {
  updateStepperProg(
    where: {id: $stepperProgId}
    data: {company: {connect: {id: $companyId}}}
  ) {
    id
  }
}
    `;
export type UpdateStepperProgMutationFn = Apollo.MutationFunction<UpdateStepperProgMutation, UpdateStepperProgMutationVariables>;

/**
 * __useUpdateStepperProgMutation__
 *
 * To run a mutation, you first call `useUpdateStepperProgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStepperProgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStepperProgMutation, { data, loading, error }] = useUpdateStepperProgMutation({
 *   variables: {
 *      stepperProgId: // value for 'stepperProgId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateStepperProgMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStepperProgMutation, UpdateStepperProgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStepperProgMutation, UpdateStepperProgMutationVariables>(UpdateStepperProgDocument, options);
      }
export type UpdateStepperProgMutationHookResult = ReturnType<typeof useUpdateStepperProgMutation>;
export type UpdateStepperProgMutationResult = Apollo.MutationResult<UpdateStepperProgMutation>;
export type UpdateStepperProgMutationOptions = Apollo.BaseMutationOptions<UpdateStepperProgMutation, UpdateStepperProgMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($data: TaskUpdateInput!, $where: TaskWhereUniqueInput!) {
  updateTask(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateTestsBatchDocument = gql`
    mutation UpdateTestsBatch($testsBatchId: ID!, $data: TestsBatchUpdateInput!) {
  updateTestsBatch(where: {id: $testsBatchId}, data: $data) {
    id
    name
    doctor {
      id
    }
    formTests {
      id
      label
      value
    }
    formType {
      id
      name
      slug
    }
  }
}
    `;
export type UpdateTestsBatchMutationFn = Apollo.MutationFunction<UpdateTestsBatchMutation, UpdateTestsBatchMutationVariables>;

/**
 * __useUpdateTestsBatchMutation__
 *
 * To run a mutation, you first call `useUpdateTestsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestsBatchMutation, { data, loading, error }] = useUpdateTestsBatchMutation({
 *   variables: {
 *      testsBatchId: // value for 'testsBatchId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTestsBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestsBatchMutation, UpdateTestsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestsBatchMutation, UpdateTestsBatchMutationVariables>(UpdateTestsBatchDocument, options);
      }
export type UpdateTestsBatchMutationHookResult = ReturnType<typeof useUpdateTestsBatchMutation>;
export type UpdateTestsBatchMutationResult = Apollo.MutationResult<UpdateTestsBatchMutation>;
export type UpdateTestsBatchMutationOptions = Apollo.BaseMutationOptions<UpdateTestsBatchMutation, UpdateTestsBatchMutationVariables>;
export const UpdateTimeIntervalDocument = gql`
    mutation UpdateTimeInterval($timeIntervalId: ID!, $from: String, $to: String) {
  updateTimeInterval(where: {id: $timeIntervalId}, data: {to: $to, from: $from}) {
    id
    from
    to
  }
}
    `;
export type UpdateTimeIntervalMutationFn = Apollo.MutationFunction<UpdateTimeIntervalMutation, UpdateTimeIntervalMutationVariables>;

/**
 * __useUpdateTimeIntervalMutation__
 *
 * To run a mutation, you first call `useUpdateTimeIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeIntervalMutation, { data, loading, error }] = useUpdateTimeIntervalMutation({
 *   variables: {
 *      timeIntervalId: // value for 'timeIntervalId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUpdateTimeIntervalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeIntervalMutation, UpdateTimeIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeIntervalMutation, UpdateTimeIntervalMutationVariables>(UpdateTimeIntervalDocument, options);
      }
export type UpdateTimeIntervalMutationHookResult = ReturnType<typeof useUpdateTimeIntervalMutation>;
export type UpdateTimeIntervalMutationResult = Apollo.MutationResult<UpdateTimeIntervalMutation>;
export type UpdateTimeIntervalMutationOptions = Apollo.BaseMutationOptions<UpdateTimeIntervalMutation, UpdateTimeIntervalMutationVariables>;
export const UpdateUserAddressDocument = gql`
    mutation UpdateUserAddress($addressId: ID!, $addressLine1: String, $addressLine2: String, $locality: String, $administrativeArea: String, $postalCode: String) {
  updateAddress(
    where: {id: $addressId}
    data: {addressLine1: $addressLine1, addressLine2: $addressLine2, locality: $locality, administrativeArea: $administrativeArea, postalCode: $postalCode}
  ) {
    id
    addressLine1
    addressLine2
    locality
    administrativeArea
    postalCode
  }
}
    `;
export type UpdateUserAddressMutationFn = Apollo.MutationFunction<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;

/**
 * __useUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressMutation, { data, loading, error }] = useUpdateUserAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      locality: // value for 'locality'
 *      administrativeArea: // value for 'administrativeArea'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useUpdateUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>(UpdateUserAddressDocument, options);
      }
export type UpdateUserAddressMutationHookResult = ReturnType<typeof useUpdateUserAddressMutation>;
export type UpdateUserAddressMutationResult = Apollo.MutationResult<UpdateUserAddressMutation>;
export type UpdateUserAddressMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;
export const UpdateUserBirdConsentDocument = gql`
    mutation UpdateUserBirdConsent($userId: ID!, $isBirdConsentObtained: Boolean!) {
  updateUser(
    where: {id: $userId}
    data: {isBirdConsentObtained: $isBirdConsentObtained}
  ) {
    id
    isBirdConsentObtained
  }
}
    `;
export type UpdateUserBirdConsentMutationFn = Apollo.MutationFunction<UpdateUserBirdConsentMutation, UpdateUserBirdConsentMutationVariables>;

/**
 * __useUpdateUserBirdConsentMutation__
 *
 * To run a mutation, you first call `useUpdateUserBirdConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBirdConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserBirdConsentMutation, { data, loading, error }] = useUpdateUserBirdConsentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isBirdConsentObtained: // value for 'isBirdConsentObtained'
 *   },
 * });
 */
export function useUpdateUserBirdConsentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserBirdConsentMutation, UpdateUserBirdConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserBirdConsentMutation, UpdateUserBirdConsentMutationVariables>(UpdateUserBirdConsentDocument, options);
      }
export type UpdateUserBirdConsentMutationHookResult = ReturnType<typeof useUpdateUserBirdConsentMutation>;
export type UpdateUserBirdConsentMutationResult = Apollo.MutationResult<UpdateUserBirdConsentMutation>;
export type UpdateUserBirdConsentMutationOptions = Apollo.BaseMutationOptions<UpdateUserBirdConsentMutation, UpdateUserBirdConsentMutationVariables>;
export const UploadBlastListDocument = gql`
    mutation UploadBlastList($faxBlastId: ID!, $file: Upload!) {
  uploadBlastList(faxBlastId: $faxBlastId, file: $file) {
    id
  }
}
    `;
export type UploadBlastListMutationFn = Apollo.MutationFunction<UploadBlastListMutation, UploadBlastListMutationVariables>;

/**
 * __useUploadBlastListMutation__
 *
 * To run a mutation, you first call `useUploadBlastListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBlastListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBlastListMutation, { data, loading, error }] = useUploadBlastListMutation({
 *   variables: {
 *      faxBlastId: // value for 'faxBlastId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadBlastListMutation(baseOptions?: Apollo.MutationHookOptions<UploadBlastListMutation, UploadBlastListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBlastListMutation, UploadBlastListMutationVariables>(UploadBlastListDocument, options);
      }
export type UploadBlastListMutationHookResult = ReturnType<typeof useUploadBlastListMutation>;
export type UploadBlastListMutationResult = Apollo.MutationResult<UploadBlastListMutation>;
export type UploadBlastListMutationOptions = Apollo.BaseMutationOptions<UploadBlastListMutation, UploadBlastListMutationVariables>;
export const UploadDataImportDocument = gql`
    mutation UploadDataImport($file: Upload!, $notes: String) {
  uploadDataImport(file: $file, notes: $notes) {
    id
  }
}
    `;
export type UploadDataImportMutationFn = Apollo.MutationFunction<UploadDataImportMutation, UploadDataImportMutationVariables>;

/**
 * __useUploadDataImportMutation__
 *
 * To run a mutation, you first call `useUploadDataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDataImportMutation, { data, loading, error }] = useUploadDataImportMutation({
 *   variables: {
 *      file: // value for 'file'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUploadDataImportMutation(baseOptions?: Apollo.MutationHookOptions<UploadDataImportMutation, UploadDataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDataImportMutation, UploadDataImportMutationVariables>(UploadDataImportDocument, options);
      }
export type UploadDataImportMutationHookResult = ReturnType<typeof useUploadDataImportMutation>;
export type UploadDataImportMutationResult = Apollo.MutationResult<UploadDataImportMutation>;
export type UploadDataImportMutationOptions = Apollo.BaseMutationOptions<UploadDataImportMutation, UploadDataImportMutationVariables>;
export const UploadMyPhotoDocument = gql`
    mutation UploadMyPhoto($image: Upload!, $userId: ID!) {
  createProfilePhoto(data: {src: $image, user: {connect: {id: $userId}}}) {
    ...ProfilePhotoFields
  }
}
    ${ProfilePhotoFieldsFragmentDoc}`;
export type UploadMyPhotoMutationFn = Apollo.MutationFunction<UploadMyPhotoMutation, UploadMyPhotoMutationVariables>;

/**
 * __useUploadMyPhotoMutation__
 *
 * To run a mutation, you first call `useUploadMyPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMyPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMyPhotoMutation, { data, loading, error }] = useUploadMyPhotoMutation({
 *   variables: {
 *      image: // value for 'image'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUploadMyPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UploadMyPhotoMutation, UploadMyPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMyPhotoMutation, UploadMyPhotoMutationVariables>(UploadMyPhotoDocument, options);
      }
export type UploadMyPhotoMutationHookResult = ReturnType<typeof useUploadMyPhotoMutation>;
export type UploadMyPhotoMutationResult = Apollo.MutationResult<UploadMyPhotoMutation>;
export type UploadMyPhotoMutationOptions = Apollo.BaseMutationOptions<UploadMyPhotoMutation, UploadMyPhotoMutationVariables>;
export const ValidateHealthCardDocument = gql`
    mutation ValidateHealthCard($healthCardId: ID!) {
  validateHealthCard(healthCardId: $healthCardId) {
    id
    ...HealthCardFields
  }
}
    ${HealthCardFieldsFragmentDoc}`;
export type ValidateHealthCardMutationFn = Apollo.MutationFunction<ValidateHealthCardMutation, ValidateHealthCardMutationVariables>;

/**
 * __useValidateHealthCardMutation__
 *
 * To run a mutation, you first call `useValidateHealthCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateHealthCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateHealthCardMutation, { data, loading, error }] = useValidateHealthCardMutation({
 *   variables: {
 *      healthCardId: // value for 'healthCardId'
 *   },
 * });
 */
export function useValidateHealthCardMutation(baseOptions?: Apollo.MutationHookOptions<ValidateHealthCardMutation, ValidateHealthCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateHealthCardMutation, ValidateHealthCardMutationVariables>(ValidateHealthCardDocument, options);
      }
export type ValidateHealthCardMutationHookResult = ReturnType<typeof useValidateHealthCardMutation>;
export type ValidateHealthCardMutationResult = Apollo.MutationResult<ValidateHealthCardMutation>;
export type ValidateHealthCardMutationOptions = Apollo.BaseMutationOptions<ValidateHealthCardMutation, ValidateHealthCardMutationVariables>;
export const AccessPatientAllergiesSearchDocument = gql`
    query AccessPatientAllergiesSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      allergies(
        skip: $skip
        take: $take
        orderBy: [{onsetDate: desc}, {id: asc}]
        where: {name: {mode: insensitive, contains: $searchTerm}}
      ) {
        id
        name
        onsetDate
        reaction
      }
    }
  }
}
    `;

/**
 * __useAccessPatientAllergiesSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientAllergiesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientAllergiesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientAllergiesSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useAccessPatientAllergiesSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientAllergiesSearchQuery, AccessPatientAllergiesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientAllergiesSearchQuery, AccessPatientAllergiesSearchQueryVariables>(AccessPatientAllergiesSearchDocument, options);
      }
export function useAccessPatientAllergiesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientAllergiesSearchQuery, AccessPatientAllergiesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientAllergiesSearchQuery, AccessPatientAllergiesSearchQueryVariables>(AccessPatientAllergiesSearchDocument, options);
        }
export type AccessPatientAllergiesSearchQueryHookResult = ReturnType<typeof useAccessPatientAllergiesSearchQuery>;
export type AccessPatientAllergiesSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientAllergiesSearchLazyQuery>;
export type AccessPatientAllergiesSearchQueryResult = Apollo.QueryResult<AccessPatientAllergiesSearchQuery, AccessPatientAllergiesSearchQueryVariables>;
export const AccessPatientDocumentsSearchDocument = gql`
    query AccessPatientDocumentsSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      documents(
        skip: $skip
        take: $take
        orderBy: [{addedAt: desc}, {id: asc}]
        where: {title: {mode: insensitive, contains: $searchTerm}}
      ) {
        id
        file {
          ...FileFields
        }
        attachment {
          filename
          url
        }
        doctor {
          id
          user {
            id
            firstName
            middleName
            lastName
          }
        }
        form {
          id
          appointment {
            id
            event {
              id
              eventType {
                id
                value
              }
            }
          }
          name
          slug
          issuedAt
          formFields
          doctor {
            id
            clinicFaxNumber
            clinicPhoneNumber
            licenseNumber
            doctorSpecialty {
              id
              label
              value
            }
            ohipPractitionerNumber
            user {
              id
              firstName
              middleName
              lastName
              address {
                id
                addressLine1
                addressLine2
                locality
                postalCode
              }
            }
          }
          patient {
            id
            user {
              id
              cellPhoneNumberString
              dateOfBirth
              email
              firstName
              middleName
              lastName
              sex
              address {
                id
                addressLine1
                addressLine2
                locality
                postalCode
              }
            }
          }
        }
        addedAt
        title
      }
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useAccessPatientDocumentsSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientDocumentsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientDocumentsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientDocumentsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useAccessPatientDocumentsSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientDocumentsSearchQuery, AccessPatientDocumentsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientDocumentsSearchQuery, AccessPatientDocumentsSearchQueryVariables>(AccessPatientDocumentsSearchDocument, options);
      }
export function useAccessPatientDocumentsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientDocumentsSearchQuery, AccessPatientDocumentsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientDocumentsSearchQuery, AccessPatientDocumentsSearchQueryVariables>(AccessPatientDocumentsSearchDocument, options);
        }
export type AccessPatientDocumentsSearchQueryHookResult = ReturnType<typeof useAccessPatientDocumentsSearchQuery>;
export type AccessPatientDocumentsSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientDocumentsSearchLazyQuery>;
export type AccessPatientDocumentsSearchQueryResult = Apollo.QueryResult<AccessPatientDocumentsSearchQuery, AccessPatientDocumentsSearchQueryVariables>;
export const AccessPatientHealthConditionsSearchDocument = gql`
    query AccessPatientHealthConditionsSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!, $filters: [HealthConditionWhereInput!]) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      healthConditions(
        skip: $skip
        take: $take
        orderBy: [{diagnosedAt: desc}, {id: asc}]
        where: {AND: $filters, name: {mode: insensitive, contains: $searchTerm}}
      ) {
        id
        diagnosedAt
        inactivatedAt
        inactivatedBy {
          id
        }
        name
        relation
      }
    }
  }
}
    `;

/**
 * __useAccessPatientHealthConditionsSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientHealthConditionsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientHealthConditionsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientHealthConditionsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAccessPatientHealthConditionsSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientHealthConditionsSearchQuery, AccessPatientHealthConditionsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientHealthConditionsSearchQuery, AccessPatientHealthConditionsSearchQueryVariables>(AccessPatientHealthConditionsSearchDocument, options);
      }
export function useAccessPatientHealthConditionsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientHealthConditionsSearchQuery, AccessPatientHealthConditionsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientHealthConditionsSearchQuery, AccessPatientHealthConditionsSearchQueryVariables>(AccessPatientHealthConditionsSearchDocument, options);
        }
export type AccessPatientHealthConditionsSearchQueryHookResult = ReturnType<typeof useAccessPatientHealthConditionsSearchQuery>;
export type AccessPatientHealthConditionsSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientHealthConditionsSearchLazyQuery>;
export type AccessPatientHealthConditionsSearchQueryResult = Apollo.QueryResult<AccessPatientHealthConditionsSearchQuery, AccessPatientHealthConditionsSearchQueryVariables>;
export const AccessPatientLifestyleItemsSearchDocument = gql`
    query AccessPatientLifestyleItemsSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!, $filters: [LifestyleItemWhereInput!]) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      lifestyleItems(
        skip: $skip
        take: $take
        where: {AND: $filters, OR: [{activity: {mode: insensitive, contains: $searchTerm}}, {frequency: {mode: insensitive, contains: $searchTerm}}, {item: {mode: insensitive, contains: $searchTerm}}]}
      ) {
        id
        activity
        frequency
        inactivatedAt
        inactivatedBy {
          id
        }
        item
      }
    }
  }
}
    `;

/**
 * __useAccessPatientLifestyleItemsSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientLifestyleItemsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientLifestyleItemsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientLifestyleItemsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAccessPatientLifestyleItemsSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientLifestyleItemsSearchQuery, AccessPatientLifestyleItemsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientLifestyleItemsSearchQuery, AccessPatientLifestyleItemsSearchQueryVariables>(AccessPatientLifestyleItemsSearchDocument, options);
      }
export function useAccessPatientLifestyleItemsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientLifestyleItemsSearchQuery, AccessPatientLifestyleItemsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientLifestyleItemsSearchQuery, AccessPatientLifestyleItemsSearchQueryVariables>(AccessPatientLifestyleItemsSearchDocument, options);
        }
export type AccessPatientLifestyleItemsSearchQueryHookResult = ReturnType<typeof useAccessPatientLifestyleItemsSearchQuery>;
export type AccessPatientLifestyleItemsSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientLifestyleItemsSearchLazyQuery>;
export type AccessPatientLifestyleItemsSearchQueryResult = Apollo.QueryResult<AccessPatientLifestyleItemsSearchQuery, AccessPatientLifestyleItemsSearchQueryVariables>;
export const AccessPatientMedicationsSearchDocument = gql`
    query AccessPatientMedicationsSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!, $filters: [MedicationItemWhereInput!]) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      medicationItems(
        skip: $skip
        take: $take
        where: {AND: $filters, OR: [{doctor: {user: {OR: [{lastName: {contains: $searchTerm, mode: insensitive}}, {firstName: {contains: $searchTerm, mode: insensitive}}]}}}, {medication: {brandName: {mode: insensitive, contains: $searchTerm}}}, {medication: {activeIngredients: {some: {ingredientName: {mode: insensitive, contains: $searchTerm}}}}}]}
        orderBy: [{prescribedAt: desc}, {id: asc}]
      ) {
        id
        doctor {
          id
          user {
            id
            firstName
            lastName
          }
        }
        inactivatedAt
        inactivatedBy {
          id
        }
        instructions
        medication {
          id
          activeIngredients {
            id
            drugCode
            ingredientName
            strengthUnit
            strengthValue
          }
          brandName
          drugCode
        }
        prescribedAt
        refills
      }
    }
  }
}
    `;

/**
 * __useAccessPatientMedicationsSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientMedicationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientMedicationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientMedicationsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAccessPatientMedicationsSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientMedicationsSearchQuery, AccessPatientMedicationsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientMedicationsSearchQuery, AccessPatientMedicationsSearchQueryVariables>(AccessPatientMedicationsSearchDocument, options);
      }
export function useAccessPatientMedicationsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientMedicationsSearchQuery, AccessPatientMedicationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientMedicationsSearchQuery, AccessPatientMedicationsSearchQueryVariables>(AccessPatientMedicationsSearchDocument, options);
        }
export type AccessPatientMedicationsSearchQueryHookResult = ReturnType<typeof useAccessPatientMedicationsSearchQuery>;
export type AccessPatientMedicationsSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientMedicationsSearchLazyQuery>;
export type AccessPatientMedicationsSearchQueryResult = Apollo.QueryResult<AccessPatientMedicationsSearchQuery, AccessPatientMedicationsSearchQueryVariables>;
export const AccessPatientScreeningTestsSearchDocument = gql`
    query AccessPatientScreeningTestsSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      screeningTests(
        skip: $skip
        take: $take
        where: {name: {mode: insensitive, contains: $searchTerm}}
        orderBy: [{testedAt: desc}, {id: asc}]
      ) {
        id
        name
        testedAt
      }
    }
  }
}
    `;

/**
 * __useAccessPatientScreeningTestsSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientScreeningTestsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientScreeningTestsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientScreeningTestsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useAccessPatientScreeningTestsSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientScreeningTestsSearchQuery, AccessPatientScreeningTestsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientScreeningTestsSearchQuery, AccessPatientScreeningTestsSearchQueryVariables>(AccessPatientScreeningTestsSearchDocument, options);
      }
export function useAccessPatientScreeningTestsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientScreeningTestsSearchQuery, AccessPatientScreeningTestsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientScreeningTestsSearchQuery, AccessPatientScreeningTestsSearchQueryVariables>(AccessPatientScreeningTestsSearchDocument, options);
        }
export type AccessPatientScreeningTestsSearchQueryHookResult = ReturnType<typeof useAccessPatientScreeningTestsSearchQuery>;
export type AccessPatientScreeningTestsSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientScreeningTestsSearchLazyQuery>;
export type AccessPatientScreeningTestsSearchQueryResult = Apollo.QueryResult<AccessPatientScreeningTestsSearchQuery, AccessPatientScreeningTestsSearchQueryVariables>;
export const AccessPatientVaccinationsSearchDocument = gql`
    query AccessPatientVaccinationsSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      vaccinations(
        skip: $skip
        take: $take
        where: {medication: {brandName: {mode: insensitive, contains: $searchTerm}}}
        orderBy: [{immunizedAt: desc}, {id: asc}]
      ) {
        id
        doctor {
          id
          user {
            id
            firstName
            lastName
          }
        }
        expirationDate
        immunizedAt
        medication {
          id
          activeIngredients {
            id
            drugCode
            ingredientName
            strengthUnit
            strengthValue
          }
          brandName
          drugCode
          drugIdentificationNumber
        }
      }
    }
  }
}
    `;

/**
 * __useAccessPatientVaccinationsSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientVaccinationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientVaccinationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientVaccinationsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useAccessPatientVaccinationsSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientVaccinationsSearchQuery, AccessPatientVaccinationsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientVaccinationsSearchQuery, AccessPatientVaccinationsSearchQueryVariables>(AccessPatientVaccinationsSearchDocument, options);
      }
export function useAccessPatientVaccinationsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientVaccinationsSearchQuery, AccessPatientVaccinationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientVaccinationsSearchQuery, AccessPatientVaccinationsSearchQueryVariables>(AccessPatientVaccinationsSearchDocument, options);
        }
export type AccessPatientVaccinationsSearchQueryHookResult = ReturnType<typeof useAccessPatientVaccinationsSearchQuery>;
export type AccessPatientVaccinationsSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientVaccinationsSearchLazyQuery>;
export type AccessPatientVaccinationsSearchQueryResult = Apollo.QueryResult<AccessPatientVaccinationsSearchQuery, AccessPatientVaccinationsSearchQueryVariables>;
export const AccessPatientVisitsSearchDocument = gql`
    query AccessPatientVisitsSearch($skip: Int, $take: Int, $searchTerm: String, $validDate: DateTime!, $tokenId: ID!) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      appointments(
        skip: $skip
        take: $take
        where: {isSigned: {equals: true}, OR: [{doctor: {user: {firstName: {mode: insensitive, contains: $searchTerm}}}}, {doctor: {user: {lastName: {mode: insensitive, contains: $searchTerm}}}}]}
        orderBy: {signedAt: desc}
      ) {
        id
        booking {
          id
          appointment {
            id
            reason
          }
          startsAt
        }
        doctor {
          id
          doctorSpecialty {
            id
            label
            value
          }
          user {
            id
            firstName
            lastName
          }
        }
        note
        noteMdx
        signedAt
        patient {
          id
        }
        vitalsData {
          ...VitalsFields
        }
      }
    }
  }
}
    ${VitalsFieldsFragmentDoc}`;

/**
 * __useAccessPatientVisitsSearchQuery__
 *
 * To run a query within a React component, call `useAccessPatientVisitsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientVisitsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientVisitsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useAccessPatientVisitsSearchQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientVisitsSearchQuery, AccessPatientVisitsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientVisitsSearchQuery, AccessPatientVisitsSearchQueryVariables>(AccessPatientVisitsSearchDocument, options);
      }
export function useAccessPatientVisitsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientVisitsSearchQuery, AccessPatientVisitsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientVisitsSearchQuery, AccessPatientVisitsSearchQueryVariables>(AccessPatientVisitsSearchDocument, options);
        }
export type AccessPatientVisitsSearchQueryHookResult = ReturnType<typeof useAccessPatientVisitsSearchQuery>;
export type AccessPatientVisitsSearchLazyQueryHookResult = ReturnType<typeof useAccessPatientVisitsSearchLazyQuery>;
export type AccessPatientVisitsSearchQueryResult = Apollo.QueryResult<AccessPatientVisitsSearchQuery, AccessPatientVisitsSearchQueryVariables>;
export const AccessPatientVisitDetailsDocument = gql`
    query AccessPatientVisitDetails($validDate: DateTime!, $tokenId: ID!, $appointmentId: ID!) {
  accessTokens(where: {id: {equals: $tokenId}, validTo: {gte: $validDate}}) {
    id
    patient {
      id
      appointments(where: {isSigned: {equals: true}, id: {equals: $appointmentId}}) {
        id
        doctor {
          id
          user {
            ...UserBasicDataFields
          }
        }
        note
        noteMdx
        signedAt
        patient {
          id
          user {
            ...UserBasicDataFields
          }
        }
        reason
        vitalsData {
          ...VitalsFields
        }
      }
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${VitalsFieldsFragmentDoc}`;

/**
 * __useAccessPatientVisitDetailsQuery__
 *
 * To run a query within a React component, call `useAccessPatientVisitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPatientVisitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPatientVisitDetailsQuery({
 *   variables: {
 *      validDate: // value for 'validDate'
 *      tokenId: // value for 'tokenId'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAccessPatientVisitDetailsQuery(baseOptions: Apollo.QueryHookOptions<AccessPatientVisitDetailsQuery, AccessPatientVisitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPatientVisitDetailsQuery, AccessPatientVisitDetailsQueryVariables>(AccessPatientVisitDetailsDocument, options);
      }
export function useAccessPatientVisitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPatientVisitDetailsQuery, AccessPatientVisitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPatientVisitDetailsQuery, AccessPatientVisitDetailsQueryVariables>(AccessPatientVisitDetailsDocument, options);
        }
export type AccessPatientVisitDetailsQueryHookResult = ReturnType<typeof useAccessPatientVisitDetailsQuery>;
export type AccessPatientVisitDetailsLazyQueryHookResult = ReturnType<typeof useAccessPatientVisitDetailsLazyQuery>;
export type AccessPatientVisitDetailsQueryResult = Apollo.QueryResult<AccessPatientVisitDetailsQuery, AccessPatientVisitDetailsQueryVariables>;
export const AppointmentsDocument = gql`
    query Appointments($skip: Int, $take: Int, $orderBy: [AppointmentOrderByInput!], $where: AppointmentWhereInput) {
  appointments(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    draft {
      id
      author {
        id
      }
      createdAt
      lastEditedAt
      savedAt
    }
    event {
      id
      title
      eventType {
        id
        label
        value
      }
    }
    member {
      id
      isActive
      user {
        ...UserContactFields
      }
      clinic {
        id
        description
        isActive
        name
        company {
          id
        }
      }
    }
    doctor {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    booking {
      id
      durationMins
      startsAt
      event {
        id
        title
        eventType {
          id
          label
          value
        }
      }
    }
    scheduledStartsAt
    startedAt
    cancelledAt
    isMissed
    isSigned
    lastDoctorActivity
    signedAt
    patient {
      ...PatientBasicFields
    }
    rescheduledAt
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useAppointmentsQuery__
 *
 * To run a query within a React component, call `useAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
      }
export function useAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
        }
export type AppointmentsQueryHookResult = ReturnType<typeof useAppointmentsQuery>;
export type AppointmentsLazyQueryHookResult = ReturnType<typeof useAppointmentsLazyQuery>;
export type AppointmentsQueryResult = Apollo.QueryResult<AppointmentsQuery, AppointmentsQueryVariables>;
export const AppointmentBookingDocument = gql`
    query AppointmentBooking($bookingId: ID!) {
  booking(where: {id: $bookingId}) {
    ...AppointmentBookingFields
  }
}
    ${AppointmentBookingFieldsFragmentDoc}`;

/**
 * __useAppointmentBookingQuery__
 *
 * To run a query within a React component, call `useAppointmentBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useAppointmentBookingQuery(baseOptions: Apollo.QueryHookOptions<AppointmentBookingQuery, AppointmentBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentBookingQuery, AppointmentBookingQueryVariables>(AppointmentBookingDocument, options);
      }
export function useAppointmentBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentBookingQuery, AppointmentBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentBookingQuery, AppointmentBookingQueryVariables>(AppointmentBookingDocument, options);
        }
export type AppointmentBookingQueryHookResult = ReturnType<typeof useAppointmentBookingQuery>;
export type AppointmentBookingLazyQueryHookResult = ReturnType<typeof useAppointmentBookingLazyQuery>;
export type AppointmentBookingQueryResult = Apollo.QueryResult<AppointmentBookingQuery, AppointmentBookingQueryVariables>;
export const AppointmentLastActivityDocument = gql`
    query AppointmentLastActivity($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    id
    lastPatientActivity
    lastDoctorActivity
  }
}
    `;

/**
 * __useAppointmentLastActivityQuery__
 *
 * To run a query within a React component, call `useAppointmentLastActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentLastActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentLastActivityQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentLastActivityQuery(baseOptions: Apollo.QueryHookOptions<AppointmentLastActivityQuery, AppointmentLastActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentLastActivityQuery, AppointmentLastActivityQueryVariables>(AppointmentLastActivityDocument, options);
      }
export function useAppointmentLastActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentLastActivityQuery, AppointmentLastActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentLastActivityQuery, AppointmentLastActivityQueryVariables>(AppointmentLastActivityDocument, options);
        }
export type AppointmentLastActivityQueryHookResult = ReturnType<typeof useAppointmentLastActivityQuery>;
export type AppointmentLastActivityLazyQueryHookResult = ReturnType<typeof useAppointmentLastActivityLazyQuery>;
export type AppointmentLastActivityQueryResult = Apollo.QueryResult<AppointmentLastActivityQuery, AppointmentLastActivityQueryVariables>;
export const AppointmentDocument = gql`
    query Appointment($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    ...DoctorAppointmentFields
    doctor {
      ...DoctorBasicFields
    }
    draft {
      id
      author {
        id
        firstName
        lastName
      }
      createdAt
      lastEditedAt
      savedAt
    }
    clinic {
      id
      description
      isActive
      name
      company {
        id
        legalName
        operatingName
      }
      address {
        ...AddressFields
      }
      phoneNumber
    }
    patient {
      ...PatientBasicFields
    }
    member {
      id
      isActive
      faxNumber
      user {
        ...UserContactFields
      }
      clinic {
        id
        description
        isActive
        name
        company {
          id
        }
      }
    }
    booking {
      id
      durationMins
      endsAt
      isConfirmed
      name
      startsAt
      tzTarget
      event {
        id
        title
        address {
          id
          addressLine1
          addressLine2
          administrativeArea
          locality
          postalCode
        }
        eventType {
          id
          label
          value
        }
      }
    }
    event {
      id
      title
      eventType {
        id
        label
        value
      }
    }
    cancelledAt
    createdAt
    startedAt
    isMissed
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
    }
    reason
    scheduledStartsAt
    signedAt
  }
}
    ${DoctorAppointmentFieldsFragmentDoc}
${DoctorBasicFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useAppointmentQuery__
 *
 * To run a query within a React component, call `useAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentQuery(baseOptions: Apollo.QueryHookOptions<AppointmentQuery, AppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentQuery, AppointmentQueryVariables>(AppointmentDocument, options);
      }
export function useAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentQuery, AppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentQuery, AppointmentQueryVariables>(AppointmentDocument, options);
        }
export type AppointmentQueryHookResult = ReturnType<typeof useAppointmentQuery>;
export type AppointmentLazyQueryHookResult = ReturnType<typeof useAppointmentLazyQuery>;
export type AppointmentQueryResult = Apollo.QueryResult<AppointmentQuery, AppointmentQueryVariables>;
export const AppointmentRequestDocument = gql`
    query AppointmentRequest($appointmentRequestId: ID!) {
  appointmentRequest(where: {id: $appointmentRequestId}) {
    id
    createdAt
    doctor {
      ...DoctorBasicFields
    }
    clinic {
      id
      description
      isActive
      name
      address {
        ...AddressFields
      }
      company {
        id
        legalName
      }
      phoneNumber
    }
    member {
      id
      isActive
      faxNumber
      calendar {
        id
      }
      clinic {
        isActive
        id
      }
    }
    event {
      id
      address {
        ...AddressFields
      }
      eventType {
        id
        label
        value
      }
    }
    patient {
      id
      emergencyContacts {
        ...EmergencyContactFields
      }
      healthCards {
        ...HealthCardFields
      }
      user {
        address {
          ...AddressFields
        }
        ...UserContactFields
        ...UserPhotoFields
        dateOfBirth
      }
    }
    reason
  }
}
    ${DoctorBasicFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${EmergencyContactFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useAppointmentRequestQuery__
 *
 * To run a query within a React component, call `useAppointmentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentRequestQuery({
 *   variables: {
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *   },
 * });
 */
export function useAppointmentRequestQuery(baseOptions: Apollo.QueryHookOptions<AppointmentRequestQuery, AppointmentRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentRequestQuery, AppointmentRequestQueryVariables>(AppointmentRequestDocument, options);
      }
export function useAppointmentRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentRequestQuery, AppointmentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentRequestQuery, AppointmentRequestQueryVariables>(AppointmentRequestDocument, options);
        }
export type AppointmentRequestQueryHookResult = ReturnType<typeof useAppointmentRequestQuery>;
export type AppointmentRequestLazyQueryHookResult = ReturnType<typeof useAppointmentRequestLazyQuery>;
export type AppointmentRequestQueryResult = Apollo.QueryResult<AppointmentRequestQuery, AppointmentRequestQueryVariables>;
export const AppointmentReviewDocument = gql`
    query AppointmentReview($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    id
    billing {
      id
      billingItems {
        id
        claim {
          id
          amount
          feeCode
        }
        diagnosis {
          id
          code
        }
        units
      }
      referringDoctorNumber
    }
    clinic {
      id
      description
      isActive
      name
      address {
        ...AddressFields
      }
      faxNumber
      phoneNumber
      company {
        id
        legalName
      }
    }
    draft {
      id
      author {
        id
        firstName
        lastName
      }
      createdAt
      lastEditedAt
      savedAt
    }
    member {
      id
      faxNumber
      isActive
      user {
        id
      }
    }
    doctor {
      id
      clinicPhoneNumber
      clinicFaxNumber
      licenseNumber
      ohipPractitionerNumber
      doctorSpecialty {
        id
        label
      }
      signature {
        id
        file {
          ...FileFields
        }
        attachment {
          filename
          filesize
          url
        }
      }
      user {
        id
        firstName
        middleName
        lastName
        address {
          id
          addressLine1
          addressLine2
          locality
          postalCode
        }
      }
    }
    note
    noteMdx
    isSigned
    startedAt
    signedAt
    patient {
      ...PatientBasicFields
    }
    prescription {
      id
      isSubstitutionAllowed
      prescriptionItems {
        id
        instructions
        luCode
        refills
        medication {
          id
          brandName
          activeIngredients {
            id
            ingredientName
            strengthUnit
            strengthValue
          }
          luReasonsCount
        }
      }
    }
    vitalsData {
      ...VitalsFields
    }
    reason
  }
}
    ${AddressFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}
${VitalsFieldsFragmentDoc}`;

/**
 * __useAppointmentReviewQuery__
 *
 * To run a query within a React component, call `useAppointmentReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentReviewQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentReviewQuery(baseOptions: Apollo.QueryHookOptions<AppointmentReviewQuery, AppointmentReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentReviewQuery, AppointmentReviewQueryVariables>(AppointmentReviewDocument, options);
      }
export function useAppointmentReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentReviewQuery, AppointmentReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentReviewQuery, AppointmentReviewQueryVariables>(AppointmentReviewDocument, options);
        }
export type AppointmentReviewQueryHookResult = ReturnType<typeof useAppointmentReviewQuery>;
export type AppointmentReviewLazyQueryHookResult = ReturnType<typeof useAppointmentReviewLazyQuery>;
export type AppointmentReviewQueryResult = Apollo.QueryResult<AppointmentReviewQuery, AppointmentReviewQueryVariables>;
export const AppointmentSessionsDocument = gql`
    query AppointmentSessions($appointmentId: ID!) {
  appointmentSessions(
    where: {appointment: {id: {equals: $appointmentId}}, isActive: {equals: true}}
    orderBy: {startedAt: desc}
  ) {
    id
    appointment {
      id
    }
    doctor {
      id
    }
    duration
    endedAt
    isActive
    patient {
      id
    }
    startedAt
  }
}
    `;

/**
 * __useAppointmentSessionsQuery__
 *
 * To run a query within a React component, call `useAppointmentSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentSessionsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentSessionsQuery(baseOptions: Apollo.QueryHookOptions<AppointmentSessionsQuery, AppointmentSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentSessionsQuery, AppointmentSessionsQueryVariables>(AppointmentSessionsDocument, options);
      }
export function useAppointmentSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentSessionsQuery, AppointmentSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentSessionsQuery, AppointmentSessionsQueryVariables>(AppointmentSessionsDocument, options);
        }
export type AppointmentSessionsQueryHookResult = ReturnType<typeof useAppointmentSessionsQuery>;
export type AppointmentSessionsLazyQueryHookResult = ReturnType<typeof useAppointmentSessionsLazyQuery>;
export type AppointmentSessionsQueryResult = Apollo.QueryResult<AppointmentSessionsQuery, AppointmentSessionsQueryVariables>;
export const AvailableTimeSlotsDocument = gql`
    query AvailableTimeSlots($dateFromUTC: DateTime!, $dateToUTC: DateTime!, $memberId: ID!, $patientId: ID!) {
  getAvailableTimeSlots(
    dateFromUTC: $dateFromUTC
    dateToUTC: $dateToUTC
    memberId: $memberId
    patientId: $patientId
  )
}
    `;

/**
 * __useAvailableTimeSlotsQuery__
 *
 * To run a query within a React component, call `useAvailableTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTimeSlotsQuery({
 *   variables: {
 *      dateFromUTC: // value for 'dateFromUTC'
 *      dateToUTC: // value for 'dateToUTC'
 *      memberId: // value for 'memberId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useAvailableTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<AvailableTimeSlotsQuery, AvailableTimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableTimeSlotsQuery, AvailableTimeSlotsQueryVariables>(AvailableTimeSlotsDocument, options);
      }
export function useAvailableTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableTimeSlotsQuery, AvailableTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableTimeSlotsQuery, AvailableTimeSlotsQueryVariables>(AvailableTimeSlotsDocument, options);
        }
export type AvailableTimeSlotsQueryHookResult = ReturnType<typeof useAvailableTimeSlotsQuery>;
export type AvailableTimeSlotsLazyQueryHookResult = ReturnType<typeof useAvailableTimeSlotsLazyQuery>;
export type AvailableTimeSlotsQueryResult = Apollo.QueryResult<AvailableTimeSlotsQuery, AvailableTimeSlotsQueryVariables>;
export const BillingsDocument = gql`
    query Billings($companyId: ID!, $filters: AppointmentBillingWhereInput, $status: AppointmentBillingStatusTypeNullableFilter!, $searchTerm: String, $orderBy: JSON, $skip: Int, $take: Int) {
  getAppointmentBillings(
    companyId: $companyId
    filters: $filters
    orderBy: $orderBy
    searchTerm: $searchTerm
    skip: $skip
    status: $status
    take: $take
  ) {
    id
    isManualReviewRequired
    status
    accountingNumber
    billingItemsCount
    billingItems {
      id
      claim {
        id
        amount
        description
        feeCode
      }
      diagnosis {
        id
        code
      }
      premium {
        id
        amount
      }
      units
    }
    appointment {
      id
      booking {
        id
        startsAt
      }
      doctor {
        id
        user {
          id
          dateOfBirth
          email
          firstName
          lastName
        }
      }
      draft {
        id
        createdAt
        author {
          id
          firstName
          lastName
        }
      }
      patient {
        id
        user {
          id
          dateOfBirth
          email
          firstName
          lastName
        }
      }
      scheduledStartsAt
      startedAt
    }
    submission {
      id
      createdAt
      amountCharged
      amountPaid
      amountSubmitted
      paidBy {
        id
      }
      responseDump
    }
  }
}
    `;

/**
 * __useBillingsQuery__
 *
 * To run a query within a React component, call `useBillingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filters: // value for 'filters'
 *      status: // value for 'status'
 *      searchTerm: // value for 'searchTerm'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useBillingsQuery(baseOptions: Apollo.QueryHookOptions<BillingsQuery, BillingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingsQuery, BillingsQueryVariables>(BillingsDocument, options);
      }
export function useBillingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingsQuery, BillingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingsQuery, BillingsQueryVariables>(BillingsDocument, options);
        }
export type BillingsQueryHookResult = ReturnType<typeof useBillingsQuery>;
export type BillingsLazyQueryHookResult = ReturnType<typeof useBillingsLazyQuery>;
export type BillingsQueryResult = Apollo.QueryResult<BillingsQuery, BillingsQueryVariables>;
export const BillingsTotalInfoDocument = gql`
    query BillingsTotalInfo($where: AppointmentBillingWhereInput!) {
  appointmentBillings(where: $where) {
    id
    billingItems {
      id
      claim {
        id
        amount
      }
      premium {
        id
        amount
      }
      units
    }
    submission {
      id
    }
  }
}
    `;

/**
 * __useBillingsTotalInfoQuery__
 *
 * To run a query within a React component, call `useBillingsTotalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingsTotalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingsTotalInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBillingsTotalInfoQuery(baseOptions: Apollo.QueryHookOptions<BillingsTotalInfoQuery, BillingsTotalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingsTotalInfoQuery, BillingsTotalInfoQueryVariables>(BillingsTotalInfoDocument, options);
      }
export function useBillingsTotalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingsTotalInfoQuery, BillingsTotalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingsTotalInfoQuery, BillingsTotalInfoQueryVariables>(BillingsTotalInfoDocument, options);
        }
export type BillingsTotalInfoQueryHookResult = ReturnType<typeof useBillingsTotalInfoQuery>;
export type BillingsTotalInfoLazyQueryHookResult = ReturnType<typeof useBillingsTotalInfoLazyQuery>;
export type BillingsTotalInfoQueryResult = Apollo.QueryResult<BillingsTotalInfoQuery, BillingsTotalInfoQueryVariables>;
export const BillingClaimsSearchDocument = gql`
    query BillingClaimsSearch($searchTerm: String) {
  billingClaims(
    take: 6
    where: {OR: [{description: {mode: insensitive, contains: $searchTerm}}, {feeCode: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    amount
    description
    feeCode
  }
}
    `;

/**
 * __useBillingClaimsSearchQuery__
 *
 * To run a query within a React component, call `useBillingClaimsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingClaimsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingClaimsSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useBillingClaimsSearchQuery(baseOptions?: Apollo.QueryHookOptions<BillingClaimsSearchQuery, BillingClaimsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingClaimsSearchQuery, BillingClaimsSearchQueryVariables>(BillingClaimsSearchDocument, options);
      }
export function useBillingClaimsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingClaimsSearchQuery, BillingClaimsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingClaimsSearchQuery, BillingClaimsSearchQueryVariables>(BillingClaimsSearchDocument, options);
        }
export type BillingClaimsSearchQueryHookResult = ReturnType<typeof useBillingClaimsSearchQuery>;
export type BillingClaimsSearchLazyQueryHookResult = ReturnType<typeof useBillingClaimsSearchLazyQuery>;
export type BillingClaimsSearchQueryResult = Apollo.QueryResult<BillingClaimsSearchQuery, BillingClaimsSearchQueryVariables>;
export const BillingDetailsDocument = gql`
    query BillingDetails($billingId: ID!) {
  appointmentBilling(where: {id: $billingId}) {
    id
    isManualReviewRequired
    referringDoctorNumber
    billingItems {
      id
      claim {
        id
        amount
        feeCode
      }
      diagnosis {
        id
        code
      }
      premium {
        id
        amount
        code
        description
        feeCode
      }
      units
    }
    billingClinic {
      id
      description
      facilityMasterNumber
      name
      ohipGroupNumber
      serviceLocationIndicator
    }
    appointment {
      id
      booking {
        id
        startsAt
      }
      clinic {
        id
        facilityMasterNumber
        name
        ohipGroupNumber
        serviceLocationIndicator
        company {
          id
          clinics(where: {isActive: {equals: true}}) {
            id
            description
            isActive
            name
            address {
              ...AddressFields
            }
          }
        }
      }
      doctor {
        id
        ...DoctorProfileFields
      }
      patient {
        id
        healthCards {
          ...HealthCardFields
        }
        user {
          id
          cellPhoneNumberString
          homePhoneNumberString
          dateOfBirth
          email
          firstName
          lastName
          sex
        }
      }
      reason
      scheduledStartsAt
      startedAt
    }
    remittanceAdvice {
      id
      createdAt
      data
      resourceId
      status
    }
    submission {
      id
      createdAt
      amountPaid
      amountSubmitted
      explanatoryItems
    }
  }
}
    ${AddressFieldsFragmentDoc}
${DoctorProfileFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useBillingDetailsQuery__
 *
 * To run a query within a React component, call `useBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDetailsQuery({
 *   variables: {
 *      billingId: // value for 'billingId'
 *   },
 * });
 */
export function useBillingDetailsQuery(baseOptions: Apollo.QueryHookOptions<BillingDetailsQuery, BillingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingDetailsQuery, BillingDetailsQueryVariables>(BillingDetailsDocument, options);
      }
export function useBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingDetailsQuery, BillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingDetailsQuery, BillingDetailsQueryVariables>(BillingDetailsDocument, options);
        }
export type BillingDetailsQueryHookResult = ReturnType<typeof useBillingDetailsQuery>;
export type BillingDetailsLazyQueryHookResult = ReturnType<typeof useBillingDetailsLazyQuery>;
export type BillingDetailsQueryResult = Apollo.QueryResult<BillingDetailsQuery, BillingDetailsQueryVariables>;
export const BillingDiagnosisSearchDocument = gql`
    query BillingDiagnosisSearch($searchTerm: String) {
  billingDiagnoses(
    take: 6
    where: {OR: [{description: {mode: insensitive, contains: $searchTerm}}, {code: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    code
    description
  }
}
    `;

/**
 * __useBillingDiagnosisSearchQuery__
 *
 * To run a query within a React component, call `useBillingDiagnosisSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDiagnosisSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDiagnosisSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useBillingDiagnosisSearchQuery(baseOptions?: Apollo.QueryHookOptions<BillingDiagnosisSearchQuery, BillingDiagnosisSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingDiagnosisSearchQuery, BillingDiagnosisSearchQueryVariables>(BillingDiagnosisSearchDocument, options);
      }
export function useBillingDiagnosisSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingDiagnosisSearchQuery, BillingDiagnosisSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingDiagnosisSearchQuery, BillingDiagnosisSearchQueryVariables>(BillingDiagnosisSearchDocument, options);
        }
export type BillingDiagnosisSearchQueryHookResult = ReturnType<typeof useBillingDiagnosisSearchQuery>;
export type BillingDiagnosisSearchLazyQueryHookResult = ReturnType<typeof useBillingDiagnosisSearchLazyQuery>;
export type BillingDiagnosisSearchQueryResult = Apollo.QueryResult<BillingDiagnosisSearchQuery, BillingDiagnosisSearchQueryVariables>;
export const BillingPremiumSearchDocument = gql`
    query BillingPremiumSearch($searchTerm: String) {
  billingPremiums(
    take: 6
    where: {OR: [{description: {mode: insensitive, contains: $searchTerm}}, {code: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    amount
    code
    description
  }
}
    `;

/**
 * __useBillingPremiumSearchQuery__
 *
 * To run a query within a React component, call `useBillingPremiumSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPremiumSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPremiumSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useBillingPremiumSearchQuery(baseOptions?: Apollo.QueryHookOptions<BillingPremiumSearchQuery, BillingPremiumSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingPremiumSearchQuery, BillingPremiumSearchQueryVariables>(BillingPremiumSearchDocument, options);
      }
export function useBillingPremiumSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingPremiumSearchQuery, BillingPremiumSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingPremiumSearchQuery, BillingPremiumSearchQueryVariables>(BillingPremiumSearchDocument, options);
        }
export type BillingPremiumSearchQueryHookResult = ReturnType<typeof useBillingPremiumSearchQuery>;
export type BillingPremiumSearchLazyQueryHookResult = ReturnType<typeof useBillingPremiumSearchLazyQuery>;
export type BillingPremiumSearchQueryResult = Apollo.QueryResult<BillingPremiumSearchQuery, BillingPremiumSearchQueryVariables>;
export const BillingProcessingDetailsDocument = gql`
    query BillingProcessingDetails($billingId: ID!) {
  appointmentBilling(where: {id: $billingId}) {
    id
    appointment {
      id
      event {
        id
        eventType {
          label
          value
        }
      }
      patient {
        id
        user {
          id
          firstName
          lastName
        }
        healthCards {
          ...HealthCardFields
        }
      }
      startedAt
    }
    billingItems {
      id
      claim {
        id
        amount
        category
        description
        feeCode
      }
      diagnosis {
        id
        code
      }
      premium {
        id
        amount
        code
        description
        feeCode
      }
      units
    }
    billingClinic {
      id
      description
      facilityMasterNumber
      name
      ohipGroupNumber
      serviceLocationIndicator
    }
    isManualReviewRequired
    referringDoctorNumber
    submission {
      id
      createdAt
      amountCharged
      amountPaid
      amountSubmitted
      explanatoryItems
      paidBy {
        id
      }
      responseDump
      resultCode
      resultMessage
    }
    status
  }
}
    ${HealthCardFieldsFragmentDoc}`;

/**
 * __useBillingProcessingDetailsQuery__
 *
 * To run a query within a React component, call `useBillingProcessingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingProcessingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingProcessingDetailsQuery({
 *   variables: {
 *      billingId: // value for 'billingId'
 *   },
 * });
 */
export function useBillingProcessingDetailsQuery(baseOptions: Apollo.QueryHookOptions<BillingProcessingDetailsQuery, BillingProcessingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingProcessingDetailsQuery, BillingProcessingDetailsQueryVariables>(BillingProcessingDetailsDocument, options);
      }
export function useBillingProcessingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingProcessingDetailsQuery, BillingProcessingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingProcessingDetailsQuery, BillingProcessingDetailsQueryVariables>(BillingProcessingDetailsDocument, options);
        }
export type BillingProcessingDetailsQueryHookResult = ReturnType<typeof useBillingProcessingDetailsQuery>;
export type BillingProcessingDetailsLazyQueryHookResult = ReturnType<typeof useBillingProcessingDetailsLazyQuery>;
export type BillingProcessingDetailsQueryResult = Apollo.QueryResult<BillingProcessingDetailsQuery, BillingProcessingDetailsQueryVariables>;
export const BillingSubmissionsDocument = gql`
    query BillingSubmissions($take: Int, $where: BillingSubmissionWhereInput) {
  billingSubmissions(where: $where, take: $take, orderBy: {createdAt: desc}) {
    id
    billing {
      id
      isManualReviewRequired
      status
      billingItems {
        id
        claim {
          id
          amount
          description
          feeCode
        }
        diagnosis {
          id
          code
        }
        premium {
          id
          amount
        }
        units
      }
      appointment {
        id
        booking {
          id
          startsAt
        }
        doctor {
          id
          user {
            id
            dateOfBirth
            email
            firstName
            lastName
          }
        }
        patient {
          id
          user {
            id
            dateOfBirth
            email
            firstName
            lastName
          }
        }
        scheduledStartsAt
        startedAt
      }
    }
    createdAt
  }
}
    `;

/**
 * __useBillingSubmissionsQuery__
 *
 * To run a query within a React component, call `useBillingSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingSubmissionsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBillingSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<BillingSubmissionsQuery, BillingSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingSubmissionsQuery, BillingSubmissionsQueryVariables>(BillingSubmissionsDocument, options);
      }
export function useBillingSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingSubmissionsQuery, BillingSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingSubmissionsQuery, BillingSubmissionsQueryVariables>(BillingSubmissionsDocument, options);
        }
export type BillingSubmissionsQueryHookResult = ReturnType<typeof useBillingSubmissionsQuery>;
export type BillingSubmissionsLazyQueryHookResult = ReturnType<typeof useBillingSubmissionsLazyQuery>;
export type BillingSubmissionsQueryResult = Apollo.QueryResult<BillingSubmissionsQuery, BillingSubmissionsQueryVariables>;
export const BillingWithSubmissionDetailsDocument = gql`
    query BillingWithSubmissionDetails($billingId: ID!) {
  appointmentBilling(where: {id: $billingId}) {
    id
    isManualReviewRequired
    referringDoctorNumber
    billingItems {
      id
      claim {
        id
        amount
        feeCode
      }
      diagnosis {
        id
        code
      }
      units
    }
    billingClinic {
      id
      description
      facilityMasterNumber
      name
      ohipGroupNumber
      serviceLocationIndicator
    }
    appointment {
      id
      booking {
        id
        startsAt
      }
      clinic {
        id
        facilityMasterNumber
        name
        ohipGroupNumber
        serviceLocationIndicator
        company {
          id
          clinics(where: {isActive: {equals: true}}) {
            id
            description
            isActive
            name
            address {
              ...AddressFields
            }
          }
        }
      }
      doctor {
        id
        ...DoctorProfileFields
      }
      patient {
        id
        healthCards {
          ...HealthCardFields
        }
        user {
          id
          cellPhoneNumberString
          homePhoneNumberString
          dateOfBirth
          email
          firstName
          lastName
          sex
        }
      }
      reason
      scheduledStartsAt
      startedAt
    }
    submission {
      id
      createdAt
      actor
      filename
      providerNumber
      responseDump
      sequenceNumber
      paidBy {
        id
      }
      submittedBy {
        id
      }
      company {
        id
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}
${DoctorProfileFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useBillingWithSubmissionDetailsQuery__
 *
 * To run a query within a React component, call `useBillingWithSubmissionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingWithSubmissionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingWithSubmissionDetailsQuery({
 *   variables: {
 *      billingId: // value for 'billingId'
 *   },
 * });
 */
export function useBillingWithSubmissionDetailsQuery(baseOptions: Apollo.QueryHookOptions<BillingWithSubmissionDetailsQuery, BillingWithSubmissionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingWithSubmissionDetailsQuery, BillingWithSubmissionDetailsQueryVariables>(BillingWithSubmissionDetailsDocument, options);
      }
export function useBillingWithSubmissionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingWithSubmissionDetailsQuery, BillingWithSubmissionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingWithSubmissionDetailsQuery, BillingWithSubmissionDetailsQueryVariables>(BillingWithSubmissionDetailsDocument, options);
        }
export type BillingWithSubmissionDetailsQueryHookResult = ReturnType<typeof useBillingWithSubmissionDetailsQuery>;
export type BillingWithSubmissionDetailsLazyQueryHookResult = ReturnType<typeof useBillingWithSubmissionDetailsLazyQuery>;
export type BillingWithSubmissionDetailsQueryResult = Apollo.QueryResult<BillingWithSubmissionDetailsQuery, BillingWithSubmissionDetailsQueryVariables>;
export const BookerTimeSlotsDocument = gql`
    query BookerTimeSlots($scheduleId: ID!, $wdays: [String!]) {
  timeIntervals(
    where: {recurringSlot: {schedule: {id: {equals: $scheduleId}}, wday: {in: $wdays}}}
  ) {
    id
    from
    to
    recurringSlot {
      id
      wday
    }
  }
}
    `;

/**
 * __useBookerTimeSlotsQuery__
 *
 * To run a query within a React component, call `useBookerTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerTimeSlotsQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      wdays: // value for 'wdays'
 *   },
 * });
 */
export function useBookerTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<BookerTimeSlotsQuery, BookerTimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerTimeSlotsQuery, BookerTimeSlotsQueryVariables>(BookerTimeSlotsDocument, options);
      }
export function useBookerTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerTimeSlotsQuery, BookerTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerTimeSlotsQuery, BookerTimeSlotsQueryVariables>(BookerTimeSlotsDocument, options);
        }
export type BookerTimeSlotsQueryHookResult = ReturnType<typeof useBookerTimeSlotsQuery>;
export type BookerTimeSlotsLazyQueryHookResult = ReturnType<typeof useBookerTimeSlotsLazyQuery>;
export type BookerTimeSlotsQueryResult = Apollo.QueryResult<BookerTimeSlotsQuery, BookerTimeSlotsQueryVariables>;
export const CalendarEventsDocument = gql`
    query CalendarEvents($calendarId: ID!) {
  calendarEvents(where: {calendar: {id: {equals: $calendarId}}}) {
    id
    address {
      ...AddressFields
    }
    companyName
    description
    doctor {
      ...DoctorBasicFields
    }
    durationMins
    facilityMasterNumber
    isActive
    serviceLocationIndicator
    title
    eventType {
      id
      label
      value
    }
  }
}
    ${AddressFieldsFragmentDoc}
${DoctorBasicFieldsFragmentDoc}`;

/**
 * __useCalendarEventsQuery__
 *
 * To run a query within a React component, call `useCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventsQuery({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *   },
 * });
 */
export function useCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
      }
export function useCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
        }
export type CalendarEventsQueryHookResult = ReturnType<typeof useCalendarEventsQuery>;
export type CalendarEventsLazyQueryHookResult = ReturnType<typeof useCalendarEventsLazyQuery>;
export type CalendarEventsQueryResult = Apollo.QueryResult<CalendarEventsQuery, CalendarEventsQueryVariables>;
export const ChatMessagesDocument = gql`
    query ChatMessages($chatId: ID!, $skip: Int, $take: Int) {
  chatMessages(
    skip: $skip
    take: $take
    where: {chat: {id: {equals: $chatId}}}
    orderBy: {createdAt: desc}
  ) {
    id
    createdAt
    readAt
    text
    author {
      id
      firstName
      lastName
      profilePhoto {
        id
        src {
          id
          publicUrlTransformed
        }
      }
    }
    replyTo {
      id
      createdAt
      readAt
      text
      author {
        id
        firstName
        lastName
        profilePhoto {
          id
          src {
            id
            publicUrlTransformed
          }
        }
      }
    }
    uuid
  }
}
    `;

/**
 * __useChatMessagesQuery__
 *
 * To run a query within a React component, call `useChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessagesQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<ChatMessagesQuery, ChatMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatMessagesQuery, ChatMessagesQueryVariables>(ChatMessagesDocument, options);
      }
export function useChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatMessagesQuery, ChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatMessagesQuery, ChatMessagesQueryVariables>(ChatMessagesDocument, options);
        }
export type ChatMessagesQueryHookResult = ReturnType<typeof useChatMessagesQuery>;
export type ChatMessagesLazyQueryHookResult = ReturnType<typeof useChatMessagesLazyQuery>;
export type ChatMessagesQueryResult = Apollo.QueryResult<ChatMessagesQuery, ChatMessagesQueryVariables>;
export const ChatDocument = gql`
    query Chat($chatId: ID!) {
  chat(where: {id: $chatId}) {
    id
    messages(orderBy: {createdAt: desc}) {
      id
      createdAt
      readAt
      text
      author {
        id
      }
      replyTo {
        id
        createdAt
        readAt
        text
        author {
          id
        }
      }
    }
    messagesCount
  }
}
    `;

/**
 * __useChatQuery__
 *
 * To run a query within a React component, call `useChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatQuery(baseOptions: Apollo.QueryHookOptions<ChatQuery, ChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
      }
export function useChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatQuery, ChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
        }
export type ChatQueryHookResult = ReturnType<typeof useChatQuery>;
export type ChatLazyQueryHookResult = ReturnType<typeof useChatLazyQuery>;
export type ChatQueryResult = Apollo.QueryResult<ChatQuery, ChatQueryVariables>;
export const CheckUserMembershipDocument = gql`
    query CheckUserMembership($memberEmail: String!, $clinicId: ID, $companyId: ID, $dateOfBirth: DateTime, $postalCode: String) {
  checkUserMembership(
    memberEmail: $memberEmail
    clinicId: $clinicId
    dateOfBirth: $dateOfBirth
    postalCode: $postalCode
  ) {
    id
    email
    doctor {
      id
    }
    patient {
      id
    }
    memberships(
      where: {isActive: {equals: true}, clinic: {isActive: {equals: true}, company: {id: {equals: $companyId}}}}
    ) {
      id
      clinic {
        id
      }
      role {
        id
        name
      }
      roleAlias
    }
  }
}
    `;

/**
 * __useCheckUserMembershipQuery__
 *
 * To run a query within a React component, call `useCheckUserMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserMembershipQuery({
 *   variables: {
 *      memberEmail: // value for 'memberEmail'
 *      clinicId: // value for 'clinicId'
 *      companyId: // value for 'companyId'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useCheckUserMembershipQuery(baseOptions: Apollo.QueryHookOptions<CheckUserMembershipQuery, CheckUserMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserMembershipQuery, CheckUserMembershipQueryVariables>(CheckUserMembershipDocument, options);
      }
export function useCheckUserMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserMembershipQuery, CheckUserMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserMembershipQuery, CheckUserMembershipQueryVariables>(CheckUserMembershipDocument, options);
        }
export type CheckUserMembershipQueryHookResult = ReturnType<typeof useCheckUserMembershipQuery>;
export type CheckUserMembershipLazyQueryHookResult = ReturnType<typeof useCheckUserMembershipLazyQuery>;
export type CheckUserMembershipQueryResult = Apollo.QueryResult<CheckUserMembershipQuery, CheckUserMembershipQueryVariables>;
export const ClinicsMemberCalendarsDocument = gql`
    query ClinicsMemberCalendars($companyId: ID!, $userId: ID!) {
  clinics(where: {company: {id: {equals: $companyId}}, isActive: {equals: true}}) {
    id
    description
    isActive
    name
    address {
      ...AddressFields
    }
    calendar {
      id
      acceptingNewPatients
      events {
        id
        durationMins
        isActive
        eventType {
          id
          value
        }
      }
      defaultSchedule {
        id
        defaultOn {
          id
        }
        description
        slotInterval
        title
        tz
      }
    }
    members(
      where: {AND: [{isActive: {equals: true}}, {user: {id: {equals: $userId}}}, {role: {name: {equals: doctor}}}]}
    ) {
      id
      calendar {
        id
        acceptingNewPatients
        events {
          id
          durationMins
          isActive
          eventType {
            id
            value
            label
          }
        }
        defaultSchedule {
          id
          blockedDates
          blockedTimeIntervals {
            id
            from
            to
            recurringSlot {
              id
              wday
            }
          }
          defaultOn {
            id
          }
          description
          futureLimit
          slotInterval
          title
          tz
        }
      }
      user {
        id
        doctor {
          id
        }
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useClinicsMemberCalendarsQuery__
 *
 * To run a query within a React component, call `useClinicsMemberCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicsMemberCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicsMemberCalendarsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClinicsMemberCalendarsQuery(baseOptions: Apollo.QueryHookOptions<ClinicsMemberCalendarsQuery, ClinicsMemberCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicsMemberCalendarsQuery, ClinicsMemberCalendarsQueryVariables>(ClinicsMemberCalendarsDocument, options);
      }
export function useClinicsMemberCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicsMemberCalendarsQuery, ClinicsMemberCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicsMemberCalendarsQuery, ClinicsMemberCalendarsQueryVariables>(ClinicsMemberCalendarsDocument, options);
        }
export type ClinicsMemberCalendarsQueryHookResult = ReturnType<typeof useClinicsMemberCalendarsQuery>;
export type ClinicsMemberCalendarsLazyQueryHookResult = ReturnType<typeof useClinicsMemberCalendarsLazyQuery>;
export type ClinicsMemberCalendarsQueryResult = Apollo.QueryResult<ClinicsMemberCalendarsQuery, ClinicsMemberCalendarsQueryVariables>;
export const ClinicDocument = gql`
    query Clinic($clinicId: ID!) {
  clinic(where: {id: $clinicId}) {
    id
    createdAt
    description
    facilityMasterNumber
    faxNumber
    name
    ohipGroupNumber
    phoneNumber
    serviceLocationIndicator
    address {
      ...AddressFields
    }
    leaseAgreement {
      id
      file {
        ...FileFields
      }
    }
    company {
      id
      legalName
      operatingName
    }
  }
}
    ${AddressFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useClinicQuery__
 *
 * To run a query within a React component, call `useClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicQuery(baseOptions: Apollo.QueryHookOptions<ClinicQuery, ClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicQuery, ClinicQueryVariables>(ClinicDocument, options);
      }
export function useClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicQuery, ClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicQuery, ClinicQueryVariables>(ClinicDocument, options);
        }
export type ClinicQueryHookResult = ReturnType<typeof useClinicQuery>;
export type ClinicLazyQueryHookResult = ReturnType<typeof useClinicLazyQuery>;
export type ClinicQueryResult = Apollo.QueryResult<ClinicQuery, ClinicQueryVariables>;
export const CompaniesBookingDocument = gql`
    query CompaniesBooking($doctorId: ID!, $patientId: ID, $eventType: String!) {
  companies(
    orderBy: [{legalName: asc}, {id: desc}]
    where: {isOnboarded: {equals: true}, patients: {some: {id: {equals: $patientId}}}, clinics: {some: {isActive: {equals: true}, members: {some: {calendar: {events: {some: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}}}, isActive: {equals: true}, role: {name: {equals: doctor}}, user: {doctor: {id: {equals: $doctorId}}}}}}}}
  ) {
    id
    legalName
    logo {
      id
      src {
        id
        publicUrlTransformed
      }
    }
    clinics(
      where: {isActive: {equals: true}, members: {some: {calendar: {events: {some: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}}}, isActive: {equals: true}, role: {name: {equals: doctor}}, user: {doctor: {id: {equals: $doctorId}}}}}}
    ) {
      id
      address {
        ...AddressFields
      }
      description
      name
      members(
        where: {calendar: {events: {some: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}}}, isActive: {equals: true}, role: {name: {equals: doctor}}, user: {doctor: {id: {equals: $doctorId}}}}
      ) {
        id
        calendar {
          id
          events(
            where: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}
          ) {
            id
            eventType {
              id
              value
            }
          }
        }
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useCompaniesBookingQuery__
 *
 * To run a query within a React component, call `useCompaniesBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesBookingQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      patientId: // value for 'patientId'
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useCompaniesBookingQuery(baseOptions: Apollo.QueryHookOptions<CompaniesBookingQuery, CompaniesBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesBookingQuery, CompaniesBookingQueryVariables>(CompaniesBookingDocument, options);
      }
export function useCompaniesBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesBookingQuery, CompaniesBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesBookingQuery, CompaniesBookingQueryVariables>(CompaniesBookingDocument, options);
        }
export type CompaniesBookingQueryHookResult = ReturnType<typeof useCompaniesBookingQuery>;
export type CompaniesBookingLazyQueryHookResult = ReturnType<typeof useCompaniesBookingLazyQuery>;
export type CompaniesBookingQueryResult = Apollo.QueryResult<CompaniesBookingQuery, CompaniesBookingQueryVariables>;
export const CompaniesDocument = gql`
    query Companies($where: CompanyWhereInput) {
  companies(orderBy: [{isOnboarded: desc}, {createdAt: desc}], where: $where) {
    id
    isOnboarded
    legalName
    logo {
      id
      src {
        id
        publicUrlTransformed
      }
    }
    clinics {
      id
      name
      description
      isActive
      members {
        id
        user {
          id
          doctor {
            id
            doctorSpecialty {
              id
              label
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const CompanyAppointmentRequestsDocument = gql`
    query CompanyAppointmentRequests($skip: Int, $take: Int, $orderBy: [AppointmentRequestOrderByInput!], $where: AppointmentRequestWhereInput) {
  appointmentRequests(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    createdAt
    clinic {
      id
      description
      isActive
      name
      company {
        id
        legalName
      }
    }
    event {
      id
      eventType {
        id
        label
        value
      }
    }
    followUpTo {
      id
    }
    member {
      id
      isActive
      user {
        ...UserContactFields
      }
    }
    doctor {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    patient {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    reason
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useCompanyAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useCompanyAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAppointmentRequestsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompanyAppointmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyAppointmentRequestsQuery, CompanyAppointmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAppointmentRequestsQuery, CompanyAppointmentRequestsQueryVariables>(CompanyAppointmentRequestsDocument, options);
      }
export function useCompanyAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAppointmentRequestsQuery, CompanyAppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAppointmentRequestsQuery, CompanyAppointmentRequestsQueryVariables>(CompanyAppointmentRequestsDocument, options);
        }
export type CompanyAppointmentRequestsQueryHookResult = ReturnType<typeof useCompanyAppointmentRequestsQuery>;
export type CompanyAppointmentRequestsLazyQueryHookResult = ReturnType<typeof useCompanyAppointmentRequestsLazyQuery>;
export type CompanyAppointmentRequestsQueryResult = Apollo.QueryResult<CompanyAppointmentRequestsQuery, CompanyAppointmentRequestsQueryVariables>;
export const CompanyBookingDocument = gql`
    query CompanyBooking($companyId: ID!, $eventType: String!, $calendarFilter: [CalendarWhereInput!]) {
  company(where: {id: $companyId}) {
    id
    clinics(
      where: {isActive: {equals: true}, members: {some: {calendar: {AND: $calendarFilter, events: {some: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}}}, isActive: {equals: true}, role: {name: {equals: doctor}}, user: {doctor: {isGoSecureGranted: {equals: true}, isVerified: {equals: true}}}}}}
    ) {
      id
      address {
        ...AddressFields
      }
      description
      name
      members(
        where: {calendar: {AND: $calendarFilter, events: {some: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}}}, isActive: {equals: true}, role: {name: {equals: doctor}}, user: {doctor: {isGoSecureGranted: {equals: true}, isVerified: {equals: true}}}}
      ) {
        id
        calendar {
          id
          acceptingNewPatients
          events(
            where: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}
          ) {
            id
            eventType {
              id
              value
            }
          }
        }
        user {
          id
          firstName
          middleName
          lastName
        }
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useCompanyBookingQuery__
 *
 * To run a query within a React component, call `useCompanyBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyBookingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      eventType: // value for 'eventType'
 *      calendarFilter: // value for 'calendarFilter'
 *   },
 * });
 */
export function useCompanyBookingQuery(baseOptions: Apollo.QueryHookOptions<CompanyBookingQuery, CompanyBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyBookingQuery, CompanyBookingQueryVariables>(CompanyBookingDocument, options);
      }
export function useCompanyBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyBookingQuery, CompanyBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyBookingQuery, CompanyBookingQueryVariables>(CompanyBookingDocument, options);
        }
export type CompanyBookingQueryHookResult = ReturnType<typeof useCompanyBookingQuery>;
export type CompanyBookingLazyQueryHookResult = ReturnType<typeof useCompanyBookingLazyQuery>;
export type CompanyBookingQueryResult = Apollo.QueryResult<CompanyBookingQuery, CompanyBookingQueryVariables>;
export const CompanyClinicsDocument = gql`
    query CompanyClinics($companyId: ID!, $searchTerm: String) {
  company(where: {id: $companyId}) {
    id
    clinics(
      where: {OR: [{name: {mode: insensitive, contains: $searchTerm}}], isActive: {equals: true}}
      orderBy: [{createdAt: desc}, {id: asc}]
    ) {
      id
      createdAt
      description
      isActive
      faxNumber
      name
      phoneNumber
      address {
        ...AddressFields
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useCompanyClinicsQuery__
 *
 * To run a query within a React component, call `useCompanyClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyClinicsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCompanyClinicsQuery(baseOptions: Apollo.QueryHookOptions<CompanyClinicsQuery, CompanyClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyClinicsQuery, CompanyClinicsQueryVariables>(CompanyClinicsDocument, options);
      }
export function useCompanyClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyClinicsQuery, CompanyClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyClinicsQuery, CompanyClinicsQueryVariables>(CompanyClinicsDocument, options);
        }
export type CompanyClinicsQueryHookResult = ReturnType<typeof useCompanyClinicsQuery>;
export type CompanyClinicsLazyQueryHookResult = ReturnType<typeof useCompanyClinicsLazyQuery>;
export type CompanyClinicsQueryResult = Apollo.QueryResult<CompanyClinicsQuery, CompanyClinicsQueryVariables>;
export const CompanyDoctorsDocument = gql`
    query CompanyDoctors($companyId: ID!, $searchTerm: String) {
  doctors(
    where: {OR: [{user: {firstName: {mode: insensitive, contains: $searchTerm}}}, {user: {lastName: {mode: insensitive, contains: $searchTerm}}}], user: {memberships: {some: {AND: [{isActive: {equals: true}}, {clinic: {isActive: {equals: true}}}, {clinic: {company: {id: {equals: $companyId}}}}, {role: {name: {equals: doctor}}}]}}}}
  ) {
    id
    doctorSpecialty {
      id
      label
    }
    user {
      id
      email
      firstName
      lastName
      ...UserPhotoFields
      memberships {
        id
        isActive
        clinic {
          id
        }
        role {
          id
          name
        }
      }
    }
  }
}
    ${UserPhotoFieldsFragmentDoc}`;

/**
 * __useCompanyDoctorsQuery__
 *
 * To run a query within a React component, call `useCompanyDoctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDoctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDoctorsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCompanyDoctorsQuery(baseOptions: Apollo.QueryHookOptions<CompanyDoctorsQuery, CompanyDoctorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDoctorsQuery, CompanyDoctorsQueryVariables>(CompanyDoctorsDocument, options);
      }
export function useCompanyDoctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDoctorsQuery, CompanyDoctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDoctorsQuery, CompanyDoctorsQueryVariables>(CompanyDoctorsDocument, options);
        }
export type CompanyDoctorsQueryHookResult = ReturnType<typeof useCompanyDoctorsQuery>;
export type CompanyDoctorsLazyQueryHookResult = ReturnType<typeof useCompanyDoctorsLazyQuery>;
export type CompanyDoctorsQueryResult = Apollo.QueryResult<CompanyDoctorsQuery, CompanyDoctorsQueryVariables>;
export const CompanyDoctorMembersDocument = gql`
    query CompanyDoctorMembers($companyId: ID!) {
  users(
    where: {memberships: {some: {AND: [{isActive: {equals: true}}, {clinic: {isActive: {equals: true}}}, {clinic: {company: {id: {equals: $companyId}}}}, {role: {name: {equals: doctor}}}, {calendar: {events: {some: {isActive: {equals: true}}}}}]}}}
  ) {
    id
    firstName
    lastName
    email
    doctor {
      id
    }
    memberships(
      where: {AND: [{isActive: {equals: true}}, {clinic: {isActive: {equals: true}}}, {clinic: {company: {id: {equals: $companyId}}}}, {role: {name: {equals: doctor}}}, {calendar: {events: {some: {isActive: {equals: true}}}}}]}
    ) {
      id
      faxNumber
      clinic {
        id
        description
        isActive
        name
        address {
          ...AddressFields
        }
      }
      calendar {
        id
        acceptingNewPatients
        events {
          id
          durationMins
          isActive
          eventType {
            id
            value
            label
          }
        }
        defaultSchedule {
          id
          blockedDates
          blockedTimeIntervals {
            id
            from
            to
            recurringSlot {
              id
              wday
            }
          }
          title
          description
          tz
          slotInterval
          defaultOn {
            id
          }
        }
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useCompanyDoctorMembersQuery__
 *
 * To run a query within a React component, call `useCompanyDoctorMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDoctorMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDoctorMembersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyDoctorMembersQuery(baseOptions: Apollo.QueryHookOptions<CompanyDoctorMembersQuery, CompanyDoctorMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDoctorMembersQuery, CompanyDoctorMembersQueryVariables>(CompanyDoctorMembersDocument, options);
      }
export function useCompanyDoctorMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDoctorMembersQuery, CompanyDoctorMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDoctorMembersQuery, CompanyDoctorMembersQueryVariables>(CompanyDoctorMembersDocument, options);
        }
export type CompanyDoctorMembersQueryHookResult = ReturnType<typeof useCompanyDoctorMembersQuery>;
export type CompanyDoctorMembersLazyQueryHookResult = ReturnType<typeof useCompanyDoctorMembersLazyQuery>;
export type CompanyDoctorMembersQueryResult = Apollo.QueryResult<CompanyDoctorMembersQuery, CompanyDoctorMembersQueryVariables>;
export const CompanyMembersDocument = gql`
    query CompanyMembers($companyId: ID!, $searchTerm: String) {
  getCompanyMembers(companyId: $companyId, searchTerm: $searchTerm) {
    id
    faxNumber
    userId
    roles
    user {
      id
      firstName
      lastName
      ...UserPhotoFields
    }
  }
}
    ${UserPhotoFieldsFragmentDoc}`;

/**
 * __useCompanyMembersQuery__
 *
 * To run a query within a React component, call `useCompanyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyMembersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCompanyMembersQuery(baseOptions: Apollo.QueryHookOptions<CompanyMembersQuery, CompanyMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyMembersQuery, CompanyMembersQueryVariables>(CompanyMembersDocument, options);
      }
export function useCompanyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyMembersQuery, CompanyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyMembersQuery, CompanyMembersQueryVariables>(CompanyMembersDocument, options);
        }
export type CompanyMembersQueryHookResult = ReturnType<typeof useCompanyMembersQuery>;
export type CompanyMembersLazyQueryHookResult = ReturnType<typeof useCompanyMembersLazyQuery>;
export type CompanyMembersQueryResult = Apollo.QueryResult<CompanyMembersQuery, CompanyMembersQueryVariables>;
export const CompanyDocument = gql`
    query Company($companyId: ID!) {
  company(where: {id: $companyId}) {
    id
    clinics(where: {isActive: {equals: true}}) {
      id
      isActive
      createdAt
      description
      facilityMasterNumber
      faxNumber
      name
      ohipGroupNumber
      phoneNumber
      serviceLocationIndicator
      leaseAgreement {
        id
        file {
          ...FileFields
        }
      }
      address {
        ...AddressFields
      }
      members {
        id
        roleAlias
        calendar {
          id
          name
        }
        role {
          id
          name
        }
        user {
          id
          firstName
          lastName
        }
      }
    }
    createdAt
    legalName
    operatingName
    logo {
      id
      src {
        id
        publicUrlTransformed
      }
    }
    masterLicense {
      id
      file {
        ...FileFields
      }
    }
    owner {
      id
      firstName
      lastName
    }
  }
}
    ${FileFieldsFragmentDoc}
${AddressFieldsFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const ContractDocument = gql`
    query Contract($contractSlug: String!) {
  contracts(where: {slug: {equals: $contractSlug}}) {
    id
    effectiveFrom
    lastUpdated
    content
  }
}
    `;

/**
 * __useContractQuery__
 *
 * To run a query within a React component, call `useContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractQuery({
 *   variables: {
 *      contractSlug: // value for 'contractSlug'
 *   },
 * });
 */
export function useContractQuery(baseOptions: Apollo.QueryHookOptions<ContractQuery, ContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
      }
export function useContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractQuery, ContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
        }
export type ContractQueryHookResult = ReturnType<typeof useContractQuery>;
export type ContractLazyQueryHookResult = ReturnType<typeof useContractLazyQuery>;
export type ContractQueryResult = Apollo.QueryResult<ContractQuery, ContractQueryVariables>;
export const CouponDocument = gql`
    query Coupon($couponCode: String!) {
  coupon(where: {code: $couponCode}) {
    id
    code
    isActive
    percentOff
    validFrom
    validTo
  }
}
    `;

/**
 * __useCouponQuery__
 *
 * To run a query within a React component, call `useCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponQuery({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useCouponQuery(baseOptions: Apollo.QueryHookOptions<CouponQuery, CouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponQuery, CouponQueryVariables>(CouponDocument, options);
      }
export function useCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponQuery, CouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponQuery, CouponQueryVariables>(CouponDocument, options);
        }
export type CouponQueryHookResult = ReturnType<typeof useCouponQuery>;
export type CouponLazyQueryHookResult = ReturnType<typeof useCouponLazyQuery>;
export type CouponQueryResult = Apollo.QueryResult<CouponQuery, CouponQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  authenticatedItem {
    ... on User {
      ...UserBasicDataFields
      isBirdConsentObtained
      membershipsCount(where: {isActive: {equals: true}})
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DataImportIntentsDocument = gql`
    query DataImportIntents($skip: Int, $take: Int, $orderBy: [DataImportIntentOrderByInput!], $where: DataImportIntentWhereInput) {
  dataImportIntents(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    createdAt
    dataImportItemsCount
    source
    owner {
      id
    }
    member {
      id
    }
    status
  }
}
    `;

/**
 * __useDataImportIntentsQuery__
 *
 * To run a query within a React component, call `useDataImportIntentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportIntentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportIntentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDataImportIntentsQuery(baseOptions?: Apollo.QueryHookOptions<DataImportIntentsQuery, DataImportIntentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportIntentsQuery, DataImportIntentsQueryVariables>(DataImportIntentsDocument, options);
      }
export function useDataImportIntentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportIntentsQuery, DataImportIntentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportIntentsQuery, DataImportIntentsQueryVariables>(DataImportIntentsDocument, options);
        }
export type DataImportIntentsQueryHookResult = ReturnType<typeof useDataImportIntentsQuery>;
export type DataImportIntentsLazyQueryHookResult = ReturnType<typeof useDataImportIntentsLazyQuery>;
export type DataImportIntentsQueryResult = Apollo.QueryResult<DataImportIntentsQuery, DataImportIntentsQueryVariables>;
export const DataImportIntentDocument = gql`
    query DataImportIntent($dataImportIntentId: ID!) {
  dataImportIntent(where: {id: $dataImportIntentId}) {
    id
    createdAt
    dataImportItems(
      orderBy: {createdAt: desc}
      take: 36
      where: {status: {equals: FOUND}}
    ) {
      id
      createdAt
      email
      healthCardNumber
      healthCardProvince
      healthCardVersionCode
      patient {
        id
        user {
          id
          email
          firstName
          lastName
        }
      }
      status
      statusMessage
    }
    dataImportItemsCount
    dataImportItemsWithoutPatientCount: dataImportItemsCount(where: {patient: null})
    source
    owner {
      id
    }
    member {
      id
    }
    status
    statusMessage
  }
}
    `;

/**
 * __useDataImportIntentQuery__
 *
 * To run a query within a React component, call `useDataImportIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportIntentQuery({
 *   variables: {
 *      dataImportIntentId: // value for 'dataImportIntentId'
 *   },
 * });
 */
export function useDataImportIntentQuery(baseOptions: Apollo.QueryHookOptions<DataImportIntentQuery, DataImportIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportIntentQuery, DataImportIntentQueryVariables>(DataImportIntentDocument, options);
      }
export function useDataImportIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportIntentQuery, DataImportIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportIntentQuery, DataImportIntentQueryVariables>(DataImportIntentDocument, options);
        }
export type DataImportIntentQueryHookResult = ReturnType<typeof useDataImportIntentQuery>;
export type DataImportIntentLazyQueryHookResult = ReturnType<typeof useDataImportIntentLazyQuery>;
export type DataImportIntentQueryResult = Apollo.QueryResult<DataImportIntentQuery, DataImportIntentQueryVariables>;
export const DataImportItemDocument = gql`
    query DataImportItem($dataImportItemId: ID!) {
  dataImportItem(where: {id: $dataImportItemId}) {
    id
    createdAt
    email
    healthCardNumber
    healthCardProvince
    healthCardVersionCode
    key
    patient {
      id
      user {
        id
        email
        firstName
        lastName
      }
    }
    status
    statusMessage
  }
}
    `;

/**
 * __useDataImportItemQuery__
 *
 * To run a query within a React component, call `useDataImportItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportItemQuery({
 *   variables: {
 *      dataImportItemId: // value for 'dataImportItemId'
 *   },
 * });
 */
export function useDataImportItemQuery(baseOptions: Apollo.QueryHookOptions<DataImportItemQuery, DataImportItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportItemQuery, DataImportItemQueryVariables>(DataImportItemDocument, options);
      }
export function useDataImportItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportItemQuery, DataImportItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportItemQuery, DataImportItemQueryVariables>(DataImportItemDocument, options);
        }
export type DataImportItemQueryHookResult = ReturnType<typeof useDataImportItemQuery>;
export type DataImportItemLazyQueryHookResult = ReturnType<typeof useDataImportItemLazyQuery>;
export type DataImportItemQueryResult = Apollo.QueryResult<DataImportItemQuery, DataImportItemQueryVariables>;
export const DoctorsForNewPatientsDocument = gql`
    query DoctorsForNewPatients($eventType: String, $searchTerm: String, $calendarFilter: [CalendarWhereInput!]) {
  doctors(
    where: {OR: [{user: {firstName: {mode: insensitive, contains: $searchTerm}}}, {user: {lastName: {mode: insensitive, contains: $searchTerm}}}, {doctorSpecialty: {value: {mode: insensitive, contains: $searchTerm}}}, {doctorSubSpecialties: {some: {value: {mode: insensitive, contains: $searchTerm}}}}], isGoSecureGranted: {equals: true}, isVerified: {equals: true}, user: {memberships: {some: {isActive: {equals: true}, clinic: {isActive: {equals: true}}, calendar: {AND: $calendarFilter, events: {some: {isActive: {equals: true}, eventType: {value: {equals: $eventType}}}}}}}}}
  ) {
    id
    ...DoctorBasicFields
  }
}
    ${DoctorBasicFieldsFragmentDoc}`;

/**
 * __useDoctorsForNewPatientsQuery__
 *
 * To run a query within a React component, call `useDoctorsForNewPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorsForNewPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorsForNewPatientsQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      searchTerm: // value for 'searchTerm'
 *      calendarFilter: // value for 'calendarFilter'
 *   },
 * });
 */
export function useDoctorsForNewPatientsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorsForNewPatientsQuery, DoctorsForNewPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorsForNewPatientsQuery, DoctorsForNewPatientsQueryVariables>(DoctorsForNewPatientsDocument, options);
      }
export function useDoctorsForNewPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorsForNewPatientsQuery, DoctorsForNewPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorsForNewPatientsQuery, DoctorsForNewPatientsQueryVariables>(DoctorsForNewPatientsDocument, options);
        }
export type DoctorsForNewPatientsQueryHookResult = ReturnType<typeof useDoctorsForNewPatientsQuery>;
export type DoctorsForNewPatientsLazyQueryHookResult = ReturnType<typeof useDoctorsForNewPatientsLazyQuery>;
export type DoctorsForNewPatientsQueryResult = Apollo.QueryResult<DoctorsForNewPatientsQuery, DoctorsForNewPatientsQueryVariables>;
export const DoctorsDocument = gql`
    query Doctors($skip: Int, $take: Int, $where: DoctorWhereInput, $orderBy: [DoctorOrderByInput!]) {
  doctors(skip: $skip, take: $take, where: $where, orderBy: $orderBy) {
    id
    user {
      ...UserPhotoFields
      id
      firstName
      lastName
      email
    }
  }
}
    ${UserPhotoFieldsFragmentDoc}`;

/**
 * __useDoctorsQuery__
 *
 * To run a query within a React component, call `useDoctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDoctorsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorsQuery, DoctorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorsQuery, DoctorsQueryVariables>(DoctorsDocument, options);
      }
export function useDoctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorsQuery, DoctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorsQuery, DoctorsQueryVariables>(DoctorsDocument, options);
        }
export type DoctorsQueryHookResult = ReturnType<typeof useDoctorsQuery>;
export type DoctorsLazyQueryHookResult = ReturnType<typeof useDoctorsLazyQuery>;
export type DoctorsQueryResult = Apollo.QueryResult<DoctorsQuery, DoctorsQueryVariables>;
export const DoctorBasicInfoDocument = gql`
    query DoctorBasicInfo($doctorId: ID!) {
  doctor(where: {id: $doctorId}) {
    ...DoctorBasicFields
  }
}
    ${DoctorBasicFieldsFragmentDoc}`;

/**
 * __useDoctorBasicInfoQuery__
 *
 * To run a query within a React component, call `useDoctorBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorBasicInfoQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useDoctorBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<DoctorBasicInfoQuery, DoctorBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorBasicInfoQuery, DoctorBasicInfoQueryVariables>(DoctorBasicInfoDocument, options);
      }
export function useDoctorBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorBasicInfoQuery, DoctorBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorBasicInfoQuery, DoctorBasicInfoQueryVariables>(DoctorBasicInfoDocument, options);
        }
export type DoctorBasicInfoQueryHookResult = ReturnType<typeof useDoctorBasicInfoQuery>;
export type DoctorBasicInfoLazyQueryHookResult = ReturnType<typeof useDoctorBasicInfoLazyQuery>;
export type DoctorBasicInfoQueryResult = Apollo.QueryResult<DoctorBasicInfoQuery, DoctorBasicInfoQueryVariables>;
export const DoctorCalendarsDocument = gql`
    query DoctorCalendars($doctorId: ID!) {
  calendars(where: {doctor: {id: {equals: $doctorId}}}) {
    id
    defaultSchedule {
      id
      description
      tz
      title
    }
    events {
      id
      durationMins
    }
    schedules {
      id
      description
      tz
      title
    }
    doctor {
      id
    }
  }
}
    `;

/**
 * __useDoctorCalendarsQuery__
 *
 * To run a query within a React component, call `useDoctorCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorCalendarsQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useDoctorCalendarsQuery(baseOptions: Apollo.QueryHookOptions<DoctorCalendarsQuery, DoctorCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorCalendarsQuery, DoctorCalendarsQueryVariables>(DoctorCalendarsDocument, options);
      }
export function useDoctorCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorCalendarsQuery, DoctorCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorCalendarsQuery, DoctorCalendarsQueryVariables>(DoctorCalendarsDocument, options);
        }
export type DoctorCalendarsQueryHookResult = ReturnType<typeof useDoctorCalendarsQuery>;
export type DoctorCalendarsLazyQueryHookResult = ReturnType<typeof useDoctorCalendarsLazyQuery>;
export type DoctorCalendarsQueryResult = Apollo.QueryResult<DoctorCalendarsQuery, DoctorCalendarsQueryVariables>;
export const DoctorPageDocument = gql`
    query DoctorPage($username: String!) {
  doctors(where: {user: {username: {equals: $username}}}) {
    ...DoctorBasicFields
  }
}
    ${DoctorBasicFieldsFragmentDoc}`;

/**
 * __useDoctorPageQuery__
 *
 * To run a query within a React component, call `useDoctorPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPageQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useDoctorPageQuery(baseOptions: Apollo.QueryHookOptions<DoctorPageQuery, DoctorPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPageQuery, DoctorPageQueryVariables>(DoctorPageDocument, options);
      }
export function useDoctorPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPageQuery, DoctorPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPageQuery, DoctorPageQueryVariables>(DoctorPageDocument, options);
        }
export type DoctorPageQueryHookResult = ReturnType<typeof useDoctorPageQuery>;
export type DoctorPageLazyQueryHookResult = ReturnType<typeof useDoctorPageLazyQuery>;
export type DoctorPageQueryResult = Apollo.QueryResult<DoctorPageQuery, DoctorPageQueryVariables>;
export const DoctorProfileDocument = gql`
    query DoctorProfile($doctorId: ID!) {
  doctor(where: {id: $doctorId}) {
    ...DoctorProfileFields
    proofOfIdentification {
      id
      file {
        ...FileFields
      }
      src {
        id
        mimetype
        originalFilename
        publicUrl
      }
    }
    proofOfInsurance {
      id
      file {
        ...FileFields
      }
      src {
        id
        mimetype
        originalFilename
        publicUrl
      }
    }
    proofOfLicense {
      id
      file {
        ...FileFields
      }
      src {
        id
        mimetype
        originalFilename
        publicUrl
      }
    }
    signature {
      id
      file {
        ...FileFields
      }
      attachment {
        url
      }
    }
  }
}
    ${DoctorProfileFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useDoctorProfileQuery__
 *
 * To run a query within a React component, call `useDoctorProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorProfileQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useDoctorProfileQuery(baseOptions: Apollo.QueryHookOptions<DoctorProfileQuery, DoctorProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorProfileQuery, DoctorProfileQueryVariables>(DoctorProfileDocument, options);
      }
export function useDoctorProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorProfileQuery, DoctorProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorProfileQuery, DoctorProfileQueryVariables>(DoctorProfileDocument, options);
        }
export type DoctorProfileQueryHookResult = ReturnType<typeof useDoctorProfileQuery>;
export type DoctorProfileLazyQueryHookResult = ReturnType<typeof useDoctorProfileLazyQuery>;
export type DoctorProfileQueryResult = Apollo.QueryResult<DoctorProfileQuery, DoctorProfileQueryVariables>;
export const DoctorDocument = gql`
    query Doctor($doctorId: ID!) {
  doctor(where: {id: $doctorId}) {
    id
    licenseNumber
    ohipPractitionerNumber
    user {
      id
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useDoctorQuery__
 *
 * To run a query within a React component, call `useDoctorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useDoctorQuery(baseOptions: Apollo.QueryHookOptions<DoctorQuery, DoctorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorQuery, DoctorQueryVariables>(DoctorDocument, options);
      }
export function useDoctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorQuery, DoctorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorQuery, DoctorQueryVariables>(DoctorDocument, options);
        }
export type DoctorQueryHookResult = ReturnType<typeof useDoctorQuery>;
export type DoctorLazyQueryHookResult = ReturnType<typeof useDoctorLazyQuery>;
export type DoctorQueryResult = Apollo.QueryResult<DoctorQuery, DoctorQueryVariables>;
export const DoctorSpecialtiesDocument = gql`
    query DoctorSpecialties($searchTerm: String) {
  doctorSpecialties(
    where: {OR: [{label: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    label
    value
  }
}
    `;

/**
 * __useDoctorSpecialtiesQuery__
 *
 * To run a query within a React component, call `useDoctorSpecialtiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorSpecialtiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorSpecialtiesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useDoctorSpecialtiesQuery(baseOptions?: Apollo.QueryHookOptions<DoctorSpecialtiesQuery, DoctorSpecialtiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorSpecialtiesQuery, DoctorSpecialtiesQueryVariables>(DoctorSpecialtiesDocument, options);
      }
export function useDoctorSpecialtiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorSpecialtiesQuery, DoctorSpecialtiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorSpecialtiesQuery, DoctorSpecialtiesQueryVariables>(DoctorSpecialtiesDocument, options);
        }
export type DoctorSpecialtiesQueryHookResult = ReturnType<typeof useDoctorSpecialtiesQuery>;
export type DoctorSpecialtiesLazyQueryHookResult = ReturnType<typeof useDoctorSpecialtiesLazyQuery>;
export type DoctorSpecialtiesQueryResult = Apollo.QueryResult<DoctorSpecialtiesQuery, DoctorSpecialtiesQueryVariables>;
export const DoctorSubSpecialtiesDocument = gql`
    query DoctorSubSpecialties($searchTerm: String) {
  doctorSubSpecialties(
    where: {OR: [{label: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    label
    value
  }
}
    `;

/**
 * __useDoctorSubSpecialtiesQuery__
 *
 * To run a query within a React component, call `useDoctorSubSpecialtiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorSubSpecialtiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorSubSpecialtiesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useDoctorSubSpecialtiesQuery(baseOptions?: Apollo.QueryHookOptions<DoctorSubSpecialtiesQuery, DoctorSubSpecialtiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorSubSpecialtiesQuery, DoctorSubSpecialtiesQueryVariables>(DoctorSubSpecialtiesDocument, options);
      }
export function useDoctorSubSpecialtiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorSubSpecialtiesQuery, DoctorSubSpecialtiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorSubSpecialtiesQuery, DoctorSubSpecialtiesQueryVariables>(DoctorSubSpecialtiesDocument, options);
        }
export type DoctorSubSpecialtiesQueryHookResult = ReturnType<typeof useDoctorSubSpecialtiesQuery>;
export type DoctorSubSpecialtiesLazyQueryHookResult = ReturnType<typeof useDoctorSubSpecialtiesLazyQuery>;
export type DoctorSubSpecialtiesQueryResult = Apollo.QueryResult<DoctorSubSpecialtiesQuery, DoctorSubSpecialtiesQueryVariables>;
export const DoctorAppointmentFormsDocument = gql`
    query DoctorAppointmentForms($apptId: ID!) {
  forms(where: {issuedAt: {equals: null}, appointment: {id: {equals: $apptId}}}) {
    id
    appointment {
      id
      clinic {
        id
        description
        isActive
        name
        address {
          ...AddressFields
        }
        faxNumber
        phoneNumber
        company {
          id
          legalName
        }
      }
      event {
        id
        address {
          id
          addressLine1
          addressLine2
          administrativeArea
          locality
          postalCode
        }
        eventType {
          id
          value
        }
      }
      member {
        id
        faxNumber
      }
    }
    name
    slug
    issuedAt
    formFields
    doctor {
      id
      clinicFaxNumber
      clinicPhoneNumber
      licenseNumber
      doctorSpecialty {
        id
        label
        value
      }
      ohipPractitionerNumber
      signature {
        id
        file {
          ...FileFields
        }
        attachment {
          filename
          url
        }
      }
      user {
        id
        firstName
        middleName
        lastName
      }
    }
    patient {
      ...PatientBasicFields
    }
    formType {
      id
      name
      slug
    }
  }
}
    ${AddressFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useDoctorAppointmentFormsQuery__
 *
 * To run a query within a React component, call `useDoctorAppointmentFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorAppointmentFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorAppointmentFormsQuery({
 *   variables: {
 *      apptId: // value for 'apptId'
 *   },
 * });
 */
export function useDoctorAppointmentFormsQuery(baseOptions: Apollo.QueryHookOptions<DoctorAppointmentFormsQuery, DoctorAppointmentFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorAppointmentFormsQuery, DoctorAppointmentFormsQueryVariables>(DoctorAppointmentFormsDocument, options);
      }
export function useDoctorAppointmentFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorAppointmentFormsQuery, DoctorAppointmentFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorAppointmentFormsQuery, DoctorAppointmentFormsQueryVariables>(DoctorAppointmentFormsDocument, options);
        }
export type DoctorAppointmentFormsQueryHookResult = ReturnType<typeof useDoctorAppointmentFormsQuery>;
export type DoctorAppointmentFormsLazyQueryHookResult = ReturnType<typeof useDoctorAppointmentFormsLazyQuery>;
export type DoctorAppointmentFormsQueryResult = Apollo.QueryResult<DoctorAppointmentFormsQuery, DoctorAppointmentFormsQueryVariables>;
export const DoctorAppointmentNoteDocument = gql`
    query DoctorAppointmentNote($noteId: ID!) {
  appointmentNote(where: {id: $noteId}) {
    ...AppointmentNoteFields
  }
}
    ${AppointmentNoteFieldsFragmentDoc}`;

/**
 * __useDoctorAppointmentNoteQuery__
 *
 * To run a query within a React component, call `useDoctorAppointmentNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorAppointmentNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorAppointmentNoteQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useDoctorAppointmentNoteQuery(baseOptions: Apollo.QueryHookOptions<DoctorAppointmentNoteQuery, DoctorAppointmentNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorAppointmentNoteQuery, DoctorAppointmentNoteQueryVariables>(DoctorAppointmentNoteDocument, options);
      }
export function useDoctorAppointmentNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorAppointmentNoteQuery, DoctorAppointmentNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorAppointmentNoteQuery, DoctorAppointmentNoteQueryVariables>(DoctorAppointmentNoteDocument, options);
        }
export type DoctorAppointmentNoteQueryHookResult = ReturnType<typeof useDoctorAppointmentNoteQuery>;
export type DoctorAppointmentNoteLazyQueryHookResult = ReturnType<typeof useDoctorAppointmentNoteLazyQuery>;
export type DoctorAppointmentNoteQueryResult = Apollo.QueryResult<DoctorAppointmentNoteQuery, DoctorAppointmentNoteQueryVariables>;
export const DoctorAppointmentRoomDocument = gql`
    query DoctorAppointmentRoom($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    id
    draft {
      id
      author {
        id
      }
      createdAt
      lastEditedAt
      savedAt
    }
    isMissed
    chat {
      id
    }
    doctor {
      ...DoctorBasicFields
      user {
        ...UserBasicDataFields
      }
    }
    event {
      id
      eventType {
        id
        label
        value
      }
    }
    isInvalidHealthCard
    member {
      id
      isActive
      user {
        id
      }
    }
    note
    noteMdx
    patient {
      id
      emergencyContacts {
        ...EmergencyContactFields
      }
      healthCards {
        ...HealthCardFields
      }
      user {
        ...UserBasicDataFields
      }
    }
    prescription {
      id
      isSubstitutionAllowed
    }
    vitalsData {
      id
    }
    reason
    scheduledStartsAt
    startedAt
    booking {
      id
      doctor {
        ...DoctorBasicFields
        user {
          ...UserBasicDataFields
        }
      }
      patient {
        id
        emergencyContacts {
          ...EmergencyContactFields
        }
        user {
          ...UserBasicDataFields
        }
      }
      durationMins
      endsAt
      startsAt
      event {
        id
        durationMins
        eventType {
          id
          label
          value
        }
      }
    }
  }
}
    ${DoctorBasicFieldsFragmentDoc}
${UserBasicDataFieldsFragmentDoc}
${EmergencyContactFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useDoctorAppointmentRoomQuery__
 *
 * To run a query within a React component, call `useDoctorAppointmentRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorAppointmentRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorAppointmentRoomQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useDoctorAppointmentRoomQuery(baseOptions: Apollo.QueryHookOptions<DoctorAppointmentRoomQuery, DoctorAppointmentRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorAppointmentRoomQuery, DoctorAppointmentRoomQueryVariables>(DoctorAppointmentRoomDocument, options);
      }
export function useDoctorAppointmentRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorAppointmentRoomQuery, DoctorAppointmentRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorAppointmentRoomQuery, DoctorAppointmentRoomQueryVariables>(DoctorAppointmentRoomDocument, options);
        }
export type DoctorAppointmentRoomQueryHookResult = ReturnType<typeof useDoctorAppointmentRoomQuery>;
export type DoctorAppointmentRoomLazyQueryHookResult = ReturnType<typeof useDoctorAppointmentRoomLazyQuery>;
export type DoctorAppointmentRoomQueryResult = Apollo.QueryResult<DoctorAppointmentRoomQuery, DoctorAppointmentRoomQueryVariables>;
export const DoctorAppointmentVitalsDocument = gql`
    query DoctorAppointmentVitals($vitalsDataId: ID!) {
  appointmentVital(where: {id: $vitalsDataId}) {
    ...VitalsFields
  }
}
    ${VitalsFieldsFragmentDoc}`;

/**
 * __useDoctorAppointmentVitalsQuery__
 *
 * To run a query within a React component, call `useDoctorAppointmentVitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorAppointmentVitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorAppointmentVitalsQuery({
 *   variables: {
 *      vitalsDataId: // value for 'vitalsDataId'
 *   },
 * });
 */
export function useDoctorAppointmentVitalsQuery(baseOptions: Apollo.QueryHookOptions<DoctorAppointmentVitalsQuery, DoctorAppointmentVitalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorAppointmentVitalsQuery, DoctorAppointmentVitalsQueryVariables>(DoctorAppointmentVitalsDocument, options);
      }
export function useDoctorAppointmentVitalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorAppointmentVitalsQuery, DoctorAppointmentVitalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorAppointmentVitalsQuery, DoctorAppointmentVitalsQueryVariables>(DoctorAppointmentVitalsDocument, options);
        }
export type DoctorAppointmentVitalsQueryHookResult = ReturnType<typeof useDoctorAppointmentVitalsQuery>;
export type DoctorAppointmentVitalsLazyQueryHookResult = ReturnType<typeof useDoctorAppointmentVitalsLazyQuery>;
export type DoctorAppointmentVitalsQueryResult = Apollo.QueryResult<DoctorAppointmentVitalsQuery, DoctorAppointmentVitalsQueryVariables>;
export const DoctorDashboardDocument = gql`
    query DoctorDashboard($companyId: ID!) {
  appointmentRequests(where: {clinic: {company: {id: {equals: $companyId}}}}) {
    id
  }
  appointments(
    where: {clinic: {company: {id: {equals: $companyId}}}, rescheduledAt: {equals: null}, OR: [{isMissed: {equals: true}}, {NOT: {cancelledAt: {equals: null}}}]}
  ) {
    id
  }
  userInvites(where: {company: {id: {equals: $companyId}}}) {
    id
  }
  patients(where: {companies: {some: {id: {equals: $companyId}}}}) {
    id
  }
}
    `;

/**
 * __useDoctorDashboardQuery__
 *
 * To run a query within a React component, call `useDoctorDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorDashboardQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDoctorDashboardQuery(baseOptions: Apollo.QueryHookOptions<DoctorDashboardQuery, DoctorDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorDashboardQuery, DoctorDashboardQueryVariables>(DoctorDashboardDocument, options);
      }
export function useDoctorDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorDashboardQuery, DoctorDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorDashboardQuery, DoctorDashboardQueryVariables>(DoctorDashboardDocument, options);
        }
export type DoctorDashboardQueryHookResult = ReturnType<typeof useDoctorDashboardQuery>;
export type DoctorDashboardLazyQueryHookResult = ReturnType<typeof useDoctorDashboardLazyQuery>;
export type DoctorDashboardQueryResult = Apollo.QueryResult<DoctorDashboardQuery, DoctorDashboardQueryVariables>;
export const DoctorRoomStepsDocument = gql`
    query DoctorRoomSteps($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    id
    billing {
      id
      billingItems {
        id
        claim {
          id
          amount
          description
          feeCode
        }
        diagnosis {
          id
          code
          description
        }
        premium {
          id
          amount
          code
          feeCode
          description
        }
        units
      }
      referringDoctorNumber
    }
    note
    noteMdx
    prescription {
      id
      isSubstitutionAllowed
      patient {
        id
        pharmacyLocations {
          id
          faxString
          phoneString
          address {
            id
            addressLine1
            locality
          }
          pharmacy {
            id
            companyName
          }
        }
      }
      preferredPharmacyLocation {
        id
        faxString
        phoneString
        address {
          id
          addressLine1
          locality
        }
        pharmacy {
          id
          companyName
        }
      }
      prescriptionItems {
        id
        instructions
        medication {
          id
          brandName
        }
      }
    }
    vitalsData {
      ...VitalsFields
    }
  }
}
    ${VitalsFieldsFragmentDoc}`;

/**
 * __useDoctorRoomStepsQuery__
 *
 * To run a query within a React component, call `useDoctorRoomStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorRoomStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorRoomStepsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useDoctorRoomStepsQuery(baseOptions: Apollo.QueryHookOptions<DoctorRoomStepsQuery, DoctorRoomStepsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorRoomStepsQuery, DoctorRoomStepsQueryVariables>(DoctorRoomStepsDocument, options);
      }
export function useDoctorRoomStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorRoomStepsQuery, DoctorRoomStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorRoomStepsQuery, DoctorRoomStepsQueryVariables>(DoctorRoomStepsDocument, options);
        }
export type DoctorRoomStepsQueryHookResult = ReturnType<typeof useDoctorRoomStepsQuery>;
export type DoctorRoomStepsLazyQueryHookResult = ReturnType<typeof useDoctorRoomStepsLazyQuery>;
export type DoctorRoomStepsQueryResult = Apollo.QueryResult<DoctorRoomStepsQuery, DoctorRoomStepsQueryVariables>;
export const DoctorRoomVisitsDocument = gql`
    query DoctorRoomVisits($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String) {
  appointments(
    skip: $skip
    take: $take
    orderBy: {signedAt: desc}
    where: {isSigned: {equals: true}, patient: {id: {equals: $patientId}}, OR: [{doctor: {user: {firstName: {mode: insensitive, contains: $searchTerm}}}}, {doctor: {user: {lastName: {mode: insensitive, contains: $searchTerm}}}}]}
  ) {
    id
    booking {
      id
      startsAt
    }
    createdAt
    doctor {
      id
      doctorSpecialty {
        id
        label
        value
      }
      user {
        ...UserBasicDataFields
      }
    }
    note
    noteMdx
    signedAt
    patient {
      id
      user {
        ...UserBasicDataFields
      }
    }
    vitalsData {
      ...VitalsFields
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${VitalsFieldsFragmentDoc}`;

/**
 * __useDoctorRoomVisitsQuery__
 *
 * To run a query within a React component, call `useDoctorRoomVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorRoomVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorRoomVisitsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useDoctorRoomVisitsQuery(baseOptions: Apollo.QueryHookOptions<DoctorRoomVisitsQuery, DoctorRoomVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorRoomVisitsQuery, DoctorRoomVisitsQueryVariables>(DoctorRoomVisitsDocument, options);
      }
export function useDoctorRoomVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorRoomVisitsQuery, DoctorRoomVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorRoomVisitsQuery, DoctorRoomVisitsQueryVariables>(DoctorRoomVisitsDocument, options);
        }
export type DoctorRoomVisitsQueryHookResult = ReturnType<typeof useDoctorRoomVisitsQuery>;
export type DoctorRoomVisitsLazyQueryHookResult = ReturnType<typeof useDoctorRoomVisitsLazyQuery>;
export type DoctorRoomVisitsQueryResult = Apollo.QueryResult<DoctorRoomVisitsQuery, DoctorRoomVisitsQueryVariables>;
export const DoctorRoomVisitDetailsDocument = gql`
    query DoctorRoomVisitDetails($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    id
    doctor {
      id
      user {
        ...UserBasicDataFields
      }
    }
    note
    noteMdx
    signedAt
    patient {
      id
      user {
        ...UserBasicDataFields
      }
    }
    reason
    vitalsData {
      ...VitalsFields
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${VitalsFieldsFragmentDoc}`;

/**
 * __useDoctorRoomVisitDetailsQuery__
 *
 * To run a query within a React component, call `useDoctorRoomVisitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorRoomVisitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorRoomVisitDetailsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useDoctorRoomVisitDetailsQuery(baseOptions: Apollo.QueryHookOptions<DoctorRoomVisitDetailsQuery, DoctorRoomVisitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorRoomVisitDetailsQuery, DoctorRoomVisitDetailsQueryVariables>(DoctorRoomVisitDetailsDocument, options);
      }
export function useDoctorRoomVisitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorRoomVisitDetailsQuery, DoctorRoomVisitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorRoomVisitDetailsQuery, DoctorRoomVisitDetailsQueryVariables>(DoctorRoomVisitDetailsDocument, options);
        }
export type DoctorRoomVisitDetailsQueryHookResult = ReturnType<typeof useDoctorRoomVisitDetailsQuery>;
export type DoctorRoomVisitDetailsLazyQueryHookResult = ReturnType<typeof useDoctorRoomVisitDetailsLazyQuery>;
export type DoctorRoomVisitDetailsQueryResult = Apollo.QueryResult<DoctorRoomVisitDetailsQuery, DoctorRoomVisitDetailsQueryVariables>;
export const EventDocument = gql`
    query Event($eventId: ID!) {
  calendarEvent(where: {id: $eventId}) {
    id
    address {
      ...AddressFields
    }
    calendar {
      id
      acceptingNewPatients
      events {
        id
        address {
          ...AddressFields
        }
        eventType {
          id
          value
        }
      }
      schedules {
        id
        title
        description
      }
    }
    companyName
    description
    durationMins
    facilityMasterNumber
    isActive
    serviceLocationIndicator
    title
    eventType {
      id
      label
      value
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventQuery(baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
      }
export function useEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export const ExploreEventDetailsDocument = gql`
    query ExploreEventDetails($eventId: ID!) {
  calendarEvent(where: {id: $eventId}) {
    id
    address {
      ...AddressFields
    }
    calendar {
      id
      defaultSchedule {
        ...ScheduleBasicFields
      }
      member {
        id
        isActive
        clinic {
          id
        }
        user {
          id
          doctor {
            ...DoctorProfileFields
          }
        }
      }
    }
    doctor {
      ...DoctorProfileFields
    }
    durationMins
    eventType {
      id
      label
      value
    }
  }
}
    ${AddressFieldsFragmentDoc}
${ScheduleBasicFieldsFragmentDoc}
${DoctorProfileFieldsFragmentDoc}`;

/**
 * __useExploreEventDetailsQuery__
 *
 * To run a query within a React component, call `useExploreEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreEventDetailsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useExploreEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<ExploreEventDetailsQuery, ExploreEventDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExploreEventDetailsQuery, ExploreEventDetailsQueryVariables>(ExploreEventDetailsDocument, options);
      }
export function useExploreEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExploreEventDetailsQuery, ExploreEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExploreEventDetailsQuery, ExploreEventDetailsQueryVariables>(ExploreEventDetailsDocument, options);
        }
export type ExploreEventDetailsQueryHookResult = ReturnType<typeof useExploreEventDetailsQuery>;
export type ExploreEventDetailsLazyQueryHookResult = ReturnType<typeof useExploreEventDetailsLazyQuery>;
export type ExploreEventDetailsQueryResult = Apollo.QueryResult<ExploreEventDetailsQuery, ExploreEventDetailsQueryVariables>;
export const FaxesDocument = gql`
    query Faxes($skip: Int, $take: Int, $orderBy: [FaxOrderByInput!], $where: FaxWhereInput) {
  faxes(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    createdAt
    status
    doctor {
      id
      user {
        ...UserBasicDataFields
      }
    }
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    replyTo {
      id
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useFaxesQuery__
 *
 * To run a query within a React component, call `useFaxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFaxesQuery(baseOptions?: Apollo.QueryHookOptions<FaxesQuery, FaxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxesQuery, FaxesQueryVariables>(FaxesDocument, options);
      }
export function useFaxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxesQuery, FaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxesQuery, FaxesQueryVariables>(FaxesDocument, options);
        }
export type FaxesQueryHookResult = ReturnType<typeof useFaxesQuery>;
export type FaxesLazyQueryHookResult = ReturnType<typeof useFaxesLazyQuery>;
export type FaxesQueryResult = Apollo.QueryResult<FaxesQuery, FaxesQueryVariables>;
export const FaxBlastDocument = gql`
    query FaxBlast($where: FaxBlastWhereUniqueInput!, $faxBlastId: ID!) {
  faxBlast(where: $where) {
    id
    createdAt
    description
    title
    author {
      id
    }
    faxBlastItemsCount
    faxBlastItemsFaxSuccessCount: faxBlastItemsCount(
      where: {faxBlast: {id: {equals: $faxBlastId}}, fax: {status: {equals: successful}}}
    )
    faxBlastItemsFaxProcessingCount: faxBlastItemsCount(
      where: {faxBlast: {id: {equals: $faxBlastId}}, fax: {status: {equals: processing}}}
    )
    faxBlastItemsFaxFailedCount: faxBlastItemsCount(
      where: {faxBlast: {id: {equals: $faxBlastId}}, fax: {status: {equals: failed}}}
    )
    faxBlastItemsFaxQueuedCount: faxBlastItemsCount(
      where: {faxBlast: {id: {equals: $faxBlastId}}, fax: {status: {equals: queued}}}
    )
    file {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useFaxBlastQuery__
 *
 * To run a query within a React component, call `useFaxBlastQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxBlastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxBlastQuery({
 *   variables: {
 *      where: // value for 'where'
 *      faxBlastId: // value for 'faxBlastId'
 *   },
 * });
 */
export function useFaxBlastQuery(baseOptions: Apollo.QueryHookOptions<FaxBlastQuery, FaxBlastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxBlastQuery, FaxBlastQueryVariables>(FaxBlastDocument, options);
      }
export function useFaxBlastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxBlastQuery, FaxBlastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxBlastQuery, FaxBlastQueryVariables>(FaxBlastDocument, options);
        }
export type FaxBlastQueryHookResult = ReturnType<typeof useFaxBlastQuery>;
export type FaxBlastLazyQueryHookResult = ReturnType<typeof useFaxBlastLazyQuery>;
export type FaxBlastQueryResult = Apollo.QueryResult<FaxBlastQuery, FaxBlastQueryVariables>;
export const FaxDocument = gql`
    query Fax($faxId: ID!) {
  fax(where: {id: $faxId}) {
    id
    appointment {
      id
    }
    file {
      ...FileFields
    }
    attachment {
      filename
      url
    }
    createdAt
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
      user {
        id
        dateOfBirth
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    pharmacyLocation {
      id
      address {
        ...AddressFields
      }
      faxString
      pharmacy {
        id
        companyName
      }
      phoneString
    }
    status
    to
    replyTo {
      id
    }
  }
}
    ${FileFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${AddressFieldsFragmentDoc}`;

/**
 * __useFaxQuery__
 *
 * To run a query within a React component, call `useFaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxQuery({
 *   variables: {
 *      faxId: // value for 'faxId'
 *   },
 * });
 */
export function useFaxQuery(baseOptions: Apollo.QueryHookOptions<FaxQuery, FaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxQuery, FaxQueryVariables>(FaxDocument, options);
      }
export function useFaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxQuery, FaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxQuery, FaxQueryVariables>(FaxDocument, options);
        }
export type FaxQueryHookResult = ReturnType<typeof useFaxQuery>;
export type FaxLazyQueryHookResult = ReturnType<typeof useFaxLazyQuery>;
export type FaxQueryResult = Apollo.QueryResult<FaxQuery, FaxQueryVariables>;
export const FilterDoctorsByEventDocument = gql`
    query FilterDoctorsByEvent($eventType: String, $isActive: Boolean, $searchTerm: String, $patientId: ID!) {
  doctors(
    where: {OR: [{user: {firstName: {mode: insensitive, contains: $searchTerm}}}, {user: {lastName: {mode: insensitive, contains: $searchTerm}}}], AND: [{user: {memberships: {some: {AND: [{isActive: {equals: true}}, {clinic: {isActive: {equals: true}, company: {patients: {some: {id: {equals: $patientId}}}}}}, {role: {name: {equals: doctor}}}, {calendar: {events: {some: {eventType: {value: {equals: $eventType}}, isActive: {equals: $isActive}}}}}]}}}}]}
  ) {
    id
    doctorSpecialty {
      id
      label
      value
    }
    calendar {
      id
      defaultSchedule {
        id
        tz
      }
    }
    user {
      ...UserContactFields
      ...UserPhotoFields
    }
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useFilterDoctorsByEventQuery__
 *
 * To run a query within a React component, call `useFilterDoctorsByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterDoctorsByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterDoctorsByEventQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      isActive: // value for 'isActive'
 *      searchTerm: // value for 'searchTerm'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useFilterDoctorsByEventQuery(baseOptions: Apollo.QueryHookOptions<FilterDoctorsByEventQuery, FilterDoctorsByEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterDoctorsByEventQuery, FilterDoctorsByEventQueryVariables>(FilterDoctorsByEventDocument, options);
      }
export function useFilterDoctorsByEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterDoctorsByEventQuery, FilterDoctorsByEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterDoctorsByEventQuery, FilterDoctorsByEventQueryVariables>(FilterDoctorsByEventDocument, options);
        }
export type FilterDoctorsByEventQueryHookResult = ReturnType<typeof useFilterDoctorsByEventQuery>;
export type FilterDoctorsByEventLazyQueryHookResult = ReturnType<typeof useFilterDoctorsByEventLazyQuery>;
export type FilterDoctorsByEventQueryResult = Apollo.QueryResult<FilterDoctorsByEventQuery, FilterDoctorsByEventQueryVariables>;
export const FormDocument = gql`
    query Form($formId: ID!, $doctorId: ID!) {
  form(where: {id: $formId}) {
    id
    formFields
    issuedAt
    name
    slug
    formType {
      id
      name
      slug
      testsBatches(where: {doctor: {id: {equals: $doctorId}}}) {
        id
        name
        formTests {
          id
          label
          value
        }
      }
    }
  }
}
    `;

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options);
      }
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options);
        }
export type FormQueryHookResult = ReturnType<typeof useFormQuery>;
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>;
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>;
export const FormTestsDocument = gql`
    query FormTests($formTypeSlug: String!) {
  formTests(where: {testFor: {equals: $formTypeSlug}}) {
    id
    label
    testFor
    value
  }
}
    `;

/**
 * __useFormTestsQuery__
 *
 * To run a query within a React component, call `useFormTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTestsQuery({
 *   variables: {
 *      formTypeSlug: // value for 'formTypeSlug'
 *   },
 * });
 */
export function useFormTestsQuery(baseOptions: Apollo.QueryHookOptions<FormTestsQuery, FormTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTestsQuery, FormTestsQueryVariables>(FormTestsDocument, options);
      }
export function useFormTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTestsQuery, FormTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTestsQuery, FormTestsQueryVariables>(FormTestsDocument, options);
        }
export type FormTestsQueryHookResult = ReturnType<typeof useFormTestsQuery>;
export type FormTestsLazyQueryHookResult = ReturnType<typeof useFormTestsLazyQuery>;
export type FormTestsQueryResult = Apollo.QueryResult<FormTestsQuery, FormTestsQueryVariables>;
export const FormTypesDocument = gql`
    query FormTypes($doctorId: ID!) {
  formTypes {
    id
    isActive
    name
    slug
    testsBatches(where: {doctor: {id: {equals: $doctorId}}}) {
      id
      name
    }
  }
}
    `;

/**
 * __useFormTypesQuery__
 *
 * To run a query within a React component, call `useFormTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTypesQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useFormTypesQuery(baseOptions: Apollo.QueryHookOptions<FormTypesQuery, FormTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTypesQuery, FormTypesQueryVariables>(FormTypesDocument, options);
      }
export function useFormTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTypesQuery, FormTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTypesQuery, FormTypesQueryVariables>(FormTypesDocument, options);
        }
export type FormTypesQueryHookResult = ReturnType<typeof useFormTypesQuery>;
export type FormTypesLazyQueryHookResult = ReturnType<typeof useFormTypesLazyQuery>;
export type FormTypesQueryResult = Apollo.QueryResult<FormTypesQuery, FormTypesQueryVariables>;
export const FormTypeDocument = gql`
    query FormType($formTypeSlug: String!, $doctorId: ID!) {
  formType(where: {slug: $formTypeSlug}) {
    id
    isActive
    name
    slug
    forms {
      id
      name
      slug
    }
    testsBatches(where: {doctor: {id: {equals: $doctorId}}}) {
      id
      name
      formTests {
        id
        label
        value
      }
    }
  }
}
    `;

/**
 * __useFormTypeQuery__
 *
 * To run a query within a React component, call `useFormTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTypeQuery({
 *   variables: {
 *      formTypeSlug: // value for 'formTypeSlug'
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useFormTypeQuery(baseOptions: Apollo.QueryHookOptions<FormTypeQuery, FormTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTypeQuery, FormTypeQueryVariables>(FormTypeDocument, options);
      }
export function useFormTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTypeQuery, FormTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTypeQuery, FormTypeQueryVariables>(FormTypeDocument, options);
        }
export type FormTypeQueryHookResult = ReturnType<typeof useFormTypeQuery>;
export type FormTypeLazyQueryHookResult = ReturnType<typeof useFormTypeLazyQuery>;
export type FormTypeQueryResult = Apollo.QueryResult<FormTypeQuery, FormTypeQueryVariables>;
export const HealthCardsDocument = gql`
    query HealthCards($patientId: ID!) {
  healthCards(where: {patient: {id: {equals: $patientId}}}) {
    ...HealthCardFields
  }
}
    ${HealthCardFieldsFragmentDoc}`;

/**
 * __useHealthCardsQuery__
 *
 * To run a query within a React component, call `useHealthCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCardsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useHealthCardsQuery(baseOptions: Apollo.QueryHookOptions<HealthCardsQuery, HealthCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HealthCardsQuery, HealthCardsQueryVariables>(HealthCardsDocument, options);
      }
export function useHealthCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthCardsQuery, HealthCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HealthCardsQuery, HealthCardsQueryVariables>(HealthCardsDocument, options);
        }
export type HealthCardsQueryHookResult = ReturnType<typeof useHealthCardsQuery>;
export type HealthCardsLazyQueryHookResult = ReturnType<typeof useHealthCardsLazyQuery>;
export type HealthCardsQueryResult = Apollo.QueryResult<HealthCardsQuery, HealthCardsQueryVariables>;
export const HealthCardDocument = gql`
    query HealthCard($healthCardId: ID!) {
  healthCard(where: {id: $healthCardId}) {
    id
    ...HealthCardFields
  }
}
    ${HealthCardFieldsFragmentDoc}`;

/**
 * __useHealthCardQuery__
 *
 * To run a query within a React component, call `useHealthCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCardQuery({
 *   variables: {
 *      healthCardId: // value for 'healthCardId'
 *   },
 * });
 */
export function useHealthCardQuery(baseOptions: Apollo.QueryHookOptions<HealthCardQuery, HealthCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HealthCardQuery, HealthCardQueryVariables>(HealthCardDocument, options);
      }
export function useHealthCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthCardQuery, HealthCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HealthCardQuery, HealthCardQueryVariables>(HealthCardDocument, options);
        }
export type HealthCardQueryHookResult = ReturnType<typeof useHealthCardQuery>;
export type HealthCardLazyQueryHookResult = ReturnType<typeof useHealthCardLazyQuery>;
export type HealthCardQueryResult = Apollo.QueryResult<HealthCardQuery, HealthCardQueryVariables>;
export const InboundFaxesDocument = gql`
    query InboundFaxes($skip: Int, $take: Int, $orderBy: [InboundFaxOrderByInput!], $where: InboundFaxWhereInput) {
  inboundFaxes(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    receivedAt
    resolvedAt
    reviewedAt
    status
    member {
      id
      user {
        id
        firstName
        lastName
      }
    }
    patient {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useInboundFaxesQuery__
 *
 * To run a query within a React component, call `useInboundFaxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboundFaxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboundFaxesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInboundFaxesQuery(baseOptions?: Apollo.QueryHookOptions<InboundFaxesQuery, InboundFaxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboundFaxesQuery, InboundFaxesQueryVariables>(InboundFaxesDocument, options);
      }
export function useInboundFaxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboundFaxesQuery, InboundFaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboundFaxesQuery, InboundFaxesQueryVariables>(InboundFaxesDocument, options);
        }
export type InboundFaxesQueryHookResult = ReturnType<typeof useInboundFaxesQuery>;
export type InboundFaxesLazyQueryHookResult = ReturnType<typeof useInboundFaxesLazyQuery>;
export type InboundFaxesQueryResult = Apollo.QueryResult<InboundFaxesQuery, InboundFaxesQueryVariables>;
export const InboundFaxDocument = gql`
    query InboundFax($inboundFaxId: ID!) {
  inboundFax(where: {id: $inboundFaxId}) {
    id
    file {
      ...FileFields
    }
    from
    receivedAt
    resolvedAt
    reviewedAt
    status
    member {
      id
      clinic {
        id
        phoneNumber
      }
      faxNumber
      user {
        id
        firstName
        middleName
        lastName
        doctor {
          id
          licenseNumber
          ohipPractitionerNumber
          doctorSpecialty {
            id
            label
          }
        }
      }
    }
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
      user {
        id
        dateOfBirth
        sex
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    testOrder {
      id
      slug
      orderedAt
      data
    }
    status
  }
}
    ${FileFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useInboundFaxQuery__
 *
 * To run a query within a React component, call `useInboundFaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboundFaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboundFaxQuery({
 *   variables: {
 *      inboundFaxId: // value for 'inboundFaxId'
 *   },
 * });
 */
export function useInboundFaxQuery(baseOptions: Apollo.QueryHookOptions<InboundFaxQuery, InboundFaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboundFaxQuery, InboundFaxQueryVariables>(InboundFaxDocument, options);
      }
export function useInboundFaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboundFaxQuery, InboundFaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboundFaxQuery, InboundFaxQueryVariables>(InboundFaxDocument, options);
        }
export type InboundFaxQueryHookResult = ReturnType<typeof useInboundFaxQuery>;
export type InboundFaxLazyQueryHookResult = ReturnType<typeof useInboundFaxLazyQuery>;
export type InboundFaxQueryResult = Apollo.QueryResult<InboundFaxQuery, InboundFaxQueryVariables>;
export const LanguagesDocument = gql`
    query Languages {
  languages {
    id
    label
    value
  }
}
    `;

/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
      }
export function useLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesQueryResult = Apollo.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const LatestRemittanceAdviceRequestDocument = gql`
    query LatestRemittanceAdviceRequest($companyId: ID!, $userId: ID!) {
  remittanceAdviceRequests(
    where: {company: {id: {equals: $companyId}}, user: {id: {equals: $userId}}}
    orderBy: {createdAt: desc}
    take: 1
  ) {
    id
    createdAt
  }
}
    `;

/**
 * __useLatestRemittanceAdviceRequestQuery__
 *
 * To run a query within a React component, call `useLatestRemittanceAdviceRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestRemittanceAdviceRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestRemittanceAdviceRequestQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLatestRemittanceAdviceRequestQuery(baseOptions: Apollo.QueryHookOptions<LatestRemittanceAdviceRequestQuery, LatestRemittanceAdviceRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestRemittanceAdviceRequestQuery, LatestRemittanceAdviceRequestQueryVariables>(LatestRemittanceAdviceRequestDocument, options);
      }
export function useLatestRemittanceAdviceRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestRemittanceAdviceRequestQuery, LatestRemittanceAdviceRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestRemittanceAdviceRequestQuery, LatestRemittanceAdviceRequestQueryVariables>(LatestRemittanceAdviceRequestDocument, options);
        }
export type LatestRemittanceAdviceRequestQueryHookResult = ReturnType<typeof useLatestRemittanceAdviceRequestQuery>;
export type LatestRemittanceAdviceRequestLazyQueryHookResult = ReturnType<typeof useLatestRemittanceAdviceRequestLazyQuery>;
export type LatestRemittanceAdviceRequestQueryResult = Apollo.QueryResult<LatestRemittanceAdviceRequestQuery, LatestRemittanceAdviceRequestQueryVariables>;
export const LuReasonsSearchDocument = gql`
    query LuReasonsSearch($searchTerm: String, $medicationId: ID!) {
  luReasons(
    where: {AND: [{OR: [{code: {mode: insensitive, contains: $searchTerm}}, {clinicalCriteria: {mode: insensitive, contains: $searchTerm}}]}, {medication: {id: {equals: $medicationId}}}]}
  ) {
    id
    code
    clinicalCriteria
    authorizationPeriod
    medication {
      id
    }
  }
}
    `;

/**
 * __useLuReasonsSearchQuery__
 *
 * To run a query within a React component, call `useLuReasonsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLuReasonsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLuReasonsSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      medicationId: // value for 'medicationId'
 *   },
 * });
 */
export function useLuReasonsSearchQuery(baseOptions: Apollo.QueryHookOptions<LuReasonsSearchQuery, LuReasonsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LuReasonsSearchQuery, LuReasonsSearchQueryVariables>(LuReasonsSearchDocument, options);
      }
export function useLuReasonsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LuReasonsSearchQuery, LuReasonsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LuReasonsSearchQuery, LuReasonsSearchQueryVariables>(LuReasonsSearchDocument, options);
        }
export type LuReasonsSearchQueryHookResult = ReturnType<typeof useLuReasonsSearchQuery>;
export type LuReasonsSearchLazyQueryHookResult = ReturnType<typeof useLuReasonsSearchLazyQuery>;
export type LuReasonsSearchQueryResult = Apollo.QueryResult<LuReasonsSearchQuery, LuReasonsSearchQueryVariables>;
export const ManagedCompaniesDocument = gql`
    query ManagedCompanies($userId: ID!) {
  companies(
    orderBy: [{isOnboarded: desc}, {createdAt: desc}]
    where: {isOnboarded: {equals: true}, OR: [{owner: {id: {equals: $userId}}}]}
  ) {
    id
    isOnboarded
    legalName
    logo {
      id
      src {
        id
        publicUrlTransformed
      }
    }
  }
}
    `;

/**
 * __useManagedCompaniesQuery__
 *
 * To run a query within a React component, call `useManagedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedCompaniesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useManagedCompaniesQuery(baseOptions: Apollo.QueryHookOptions<ManagedCompaniesQuery, ManagedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagedCompaniesQuery, ManagedCompaniesQueryVariables>(ManagedCompaniesDocument, options);
      }
export function useManagedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagedCompaniesQuery, ManagedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagedCompaniesQuery, ManagedCompaniesQueryVariables>(ManagedCompaniesDocument, options);
        }
export type ManagedCompaniesQueryHookResult = ReturnType<typeof useManagedCompaniesQuery>;
export type ManagedCompaniesLazyQueryHookResult = ReturnType<typeof useManagedCompaniesLazyQuery>;
export type ManagedCompaniesQueryResult = Apollo.QueryResult<ManagedCompaniesQuery, ManagedCompaniesQueryVariables>;
export const ManageAppointmentsDocument = gql`
    query ManageAppointments($skip: Int, $take: Int, $orderBy: [AppointmentOrderByInput!], $where: AppointmentWhereInput) {
  appointments(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    draft {
      id
      author {
        id
      }
      createdAt
      lastEditedAt
      savedAt
    }
    event {
      id
      title
      eventType {
        id
        label
        value
      }
    }
    member {
      id
      isActive
      user {
        ...UserContactFields
      }
      clinic {
        id
        description
        isActive
        name
        company {
          id
        }
      }
    }
    doctor {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    booking {
      id
      durationMins
      startsAt
      event {
        id
        title
        eventType {
          id
          label
          value
        }
      }
    }
    scheduledStartsAt
    startedAt
    cancelledAt
    isMissed
    isSigned
    signedAt
    patient {
      ...PatientBasicFields
    }
    rescheduledAt
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useManageAppointmentsQuery__
 *
 * To run a query within a React component, call `useManageAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageAppointmentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useManageAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<ManageAppointmentsQuery, ManageAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageAppointmentsQuery, ManageAppointmentsQueryVariables>(ManageAppointmentsDocument, options);
      }
export function useManageAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageAppointmentsQuery, ManageAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageAppointmentsQuery, ManageAppointmentsQueryVariables>(ManageAppointmentsDocument, options);
        }
export type ManageAppointmentsQueryHookResult = ReturnType<typeof useManageAppointmentsQuery>;
export type ManageAppointmentsLazyQueryHookResult = ReturnType<typeof useManageAppointmentsLazyQuery>;
export type ManageAppointmentsQueryResult = Apollo.QueryResult<ManageAppointmentsQuery, ManageAppointmentsQueryVariables>;
export const ManageAppointmentDocument = gql`
    query ManageAppointment($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    ...DoctorAppointmentFields
    doctor {
      ...DoctorBasicFields
    }
    draft {
      id
      author {
        id
      }
      createdAt
      lastEditedAt
      savedAt
    }
    clinic {
      id
      description
      isActive
      name
      company {
        id
        legalName
        operatingName
      }
      address {
        ...AddressFields
      }
      phoneNumber
    }
    patient {
      ...PatientBasicFields
    }
    member {
      id
      isActive
      user {
        ...UserContactFields
      }
      clinic {
        id
        description
        isActive
        name
        company {
          id
        }
      }
    }
    booking {
      id
      durationMins
      endsAt
      isConfirmed
      name
      startsAt
      tzTarget
      event {
        id
        title
        address {
          id
          addressLine1
          addressLine2
          administrativeArea
          locality
          postalCode
        }
        eventType {
          id
          label
          value
        }
      }
    }
    event {
      id
      title
      eventType {
        id
        label
        value
      }
    }
    cancelledAt
    createdAt
    startedAt
    isMissed
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
    }
    reason
    scheduledStartsAt
    signedAt
  }
}
    ${DoctorAppointmentFieldsFragmentDoc}
${DoctorBasicFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useManageAppointmentQuery__
 *
 * To run a query within a React component, call `useManageAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useManageAppointmentQuery(baseOptions: Apollo.QueryHookOptions<ManageAppointmentQuery, ManageAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageAppointmentQuery, ManageAppointmentQueryVariables>(ManageAppointmentDocument, options);
      }
export function useManageAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageAppointmentQuery, ManageAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageAppointmentQuery, ManageAppointmentQueryVariables>(ManageAppointmentDocument, options);
        }
export type ManageAppointmentQueryHookResult = ReturnType<typeof useManageAppointmentQuery>;
export type ManageAppointmentLazyQueryHookResult = ReturnType<typeof useManageAppointmentLazyQuery>;
export type ManageAppointmentQueryResult = Apollo.QueryResult<ManageAppointmentQuery, ManageAppointmentQueryVariables>;
export const ManageContractsDocument = gql`
    query ManageContracts($searchTerm: String) {
  contracts(where: {AND: [{name: {contains: $searchTerm, mode: insensitive}}]}) {
    id
    content
    createdAt
    effectiveFrom
    isActive
    lastUpdated
    name
    slug
    author {
      id
    }
    signedBy {
      id
    }
  }
}
    `;

/**
 * __useManageContractsQuery__
 *
 * To run a query within a React component, call `useManageContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageContractsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useManageContractsQuery(baseOptions?: Apollo.QueryHookOptions<ManageContractsQuery, ManageContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageContractsQuery, ManageContractsQueryVariables>(ManageContractsDocument, options);
      }
export function useManageContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageContractsQuery, ManageContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageContractsQuery, ManageContractsQueryVariables>(ManageContractsDocument, options);
        }
export type ManageContractsQueryHookResult = ReturnType<typeof useManageContractsQuery>;
export type ManageContractsLazyQueryHookResult = ReturnType<typeof useManageContractsLazyQuery>;
export type ManageContractsQueryResult = Apollo.QueryResult<ManageContractsQuery, ManageContractsQueryVariables>;
export const ManageCouponsDocument = gql`
    query ManageCoupons($searchTerm: String, $skip: Int, $take: Int) {
  coupons(
    skip: $skip
    take: $take
    where: {name: {mode: insensitive, contains: $searchTerm}}
  ) {
    id
    centsOff
    code
    isActive
    name
    percentOff
    validFrom
    validTo
  }
}
    `;

/**
 * __useManageCouponsQuery__
 *
 * To run a query within a React component, call `useManageCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageCouponsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useManageCouponsQuery(baseOptions?: Apollo.QueryHookOptions<ManageCouponsQuery, ManageCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageCouponsQuery, ManageCouponsQueryVariables>(ManageCouponsDocument, options);
      }
export function useManageCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageCouponsQuery, ManageCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageCouponsQuery, ManageCouponsQueryVariables>(ManageCouponsDocument, options);
        }
export type ManageCouponsQueryHookResult = ReturnType<typeof useManageCouponsQuery>;
export type ManageCouponsLazyQueryHookResult = ReturnType<typeof useManageCouponsLazyQuery>;
export type ManageCouponsQueryResult = Apollo.QueryResult<ManageCouponsQuery, ManageCouponsQueryVariables>;
export const ManageCouponDocument = gql`
    query ManageCoupon($couponId: ID!) {
  coupon(where: {id: $couponId}) {
    id
    centsOff
    code
    isActive
    percentOff
    validFrom
    validTo
  }
}
    `;

/**
 * __useManageCouponQuery__
 *
 * To run a query within a React component, call `useManageCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageCouponQuery({
 *   variables: {
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useManageCouponQuery(baseOptions: Apollo.QueryHookOptions<ManageCouponQuery, ManageCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageCouponQuery, ManageCouponQueryVariables>(ManageCouponDocument, options);
      }
export function useManageCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageCouponQuery, ManageCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageCouponQuery, ManageCouponQueryVariables>(ManageCouponDocument, options);
        }
export type ManageCouponQueryHookResult = ReturnType<typeof useManageCouponQuery>;
export type ManageCouponLazyQueryHookResult = ReturnType<typeof useManageCouponLazyQuery>;
export type ManageCouponQueryResult = Apollo.QueryResult<ManageCouponQuery, ManageCouponQueryVariables>;
export const ManageDoctorsDocument = gql`
    query ManageDoctors($searchTerm: String, $skip: Int, $take: Int) {
  doctors(
    skip: $skip
    take: $take
    where: {OR: [{user: {firstName: {mode: insensitive, contains: $searchTerm}}}, {user: {lastName: {mode: insensitive, contains: $searchTerm}}}]}
  ) {
    ...DoctorBasicFields
    isVerified
    calendar {
      id
    }
    calendarEvents {
      id
      address {
        id
        addressLine1
        addressLine2
        administrativeArea
        locality
        postalCode
      }
      eventType {
        id
        label
        value
      }
      isActive
    }
    isCompleteProfile
    isGoSecureGranted
    user {
      id
      cellPhoneNumberString
      isOnboardedDoctor
    }
  }
  doctorsCount
}
    ${DoctorBasicFieldsFragmentDoc}`;

/**
 * __useManageDoctorsQuery__
 *
 * To run a query within a React component, call `useManageDoctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageDoctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageDoctorsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useManageDoctorsQuery(baseOptions?: Apollo.QueryHookOptions<ManageDoctorsQuery, ManageDoctorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageDoctorsQuery, ManageDoctorsQueryVariables>(ManageDoctorsDocument, options);
      }
export function useManageDoctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageDoctorsQuery, ManageDoctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageDoctorsQuery, ManageDoctorsQueryVariables>(ManageDoctorsDocument, options);
        }
export type ManageDoctorsQueryHookResult = ReturnType<typeof useManageDoctorsQuery>;
export type ManageDoctorsLazyQueryHookResult = ReturnType<typeof useManageDoctorsLazyQuery>;
export type ManageDoctorsQueryResult = Apollo.QueryResult<ManageDoctorsQuery, ManageDoctorsQueryVariables>;
export const ManageDoctorDocument = gql`
    query ManageDoctor($doctorId: ID!) {
  doctor(where: {id: $doctorId}) {
    ...DoctorBasicFields
    ...DoctorSupportingDocsFields
    ...DoctorProDetailsFields
    calendar {
      id
    }
    calendarEvents {
      id
      address {
        id
        addressLine1
        addressLine2
        administrativeArea
        locality
        postalCode
      }
      eventType {
        id
        label
        value
      }
    }
    isCompleteProfile
    isGoSecureGranted
    user {
      isOnboardedDoctor
    }
  }
}
    ${DoctorBasicFieldsFragmentDoc}
${DoctorSupportingDocsFieldsFragmentDoc}
${DoctorProDetailsFieldsFragmentDoc}`;

/**
 * __useManageDoctorQuery__
 *
 * To run a query within a React component, call `useManageDoctorQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageDoctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageDoctorQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useManageDoctorQuery(baseOptions: Apollo.QueryHookOptions<ManageDoctorQuery, ManageDoctorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageDoctorQuery, ManageDoctorQueryVariables>(ManageDoctorDocument, options);
      }
export function useManageDoctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageDoctorQuery, ManageDoctorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageDoctorQuery, ManageDoctorQueryVariables>(ManageDoctorDocument, options);
        }
export type ManageDoctorQueryHookResult = ReturnType<typeof useManageDoctorQuery>;
export type ManageDoctorLazyQueryHookResult = ReturnType<typeof useManageDoctorLazyQuery>;
export type ManageDoctorQueryResult = Apollo.QueryResult<ManageDoctorQuery, ManageDoctorQueryVariables>;
export const ManageFaxBlastsDocument = gql`
    query ManageFaxBlasts($searchTerm: String) {
  faxBlasts(
    where: {AND: [{title: {contains: $searchTerm, mode: insensitive}}]}
    orderBy: {createdAt: desc}
  ) {
    id
    createdAt
    description
    title
    author {
      id
    }
  }
}
    `;

/**
 * __useManageFaxBlastsQuery__
 *
 * To run a query within a React component, call `useManageFaxBlastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageFaxBlastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageFaxBlastsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useManageFaxBlastsQuery(baseOptions?: Apollo.QueryHookOptions<ManageFaxBlastsQuery, ManageFaxBlastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageFaxBlastsQuery, ManageFaxBlastsQueryVariables>(ManageFaxBlastsDocument, options);
      }
export function useManageFaxBlastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageFaxBlastsQuery, ManageFaxBlastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageFaxBlastsQuery, ManageFaxBlastsQueryVariables>(ManageFaxBlastsDocument, options);
        }
export type ManageFaxBlastsQueryHookResult = ReturnType<typeof useManageFaxBlastsQuery>;
export type ManageFaxBlastsLazyQueryHookResult = ReturnType<typeof useManageFaxBlastsLazyQuery>;
export type ManageFaxBlastsQueryResult = Apollo.QueryResult<ManageFaxBlastsQuery, ManageFaxBlastsQueryVariables>;
export const ManageFaxRecipientsDocument = gql`
    query ManageFaxRecipients($orderBy: [FaxRecipientOrderByInput!], $skip: Int, $take: Int, $where: FaxRecipientWhereInput) {
  faxRecipients(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    id
    cpsoId
    faxNumber
    firstName
    isUnsubscribed
    lastName
  }
}
    `;

/**
 * __useManageFaxRecipientsQuery__
 *
 * To run a query within a React component, call `useManageFaxRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageFaxRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageFaxRecipientsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useManageFaxRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<ManageFaxRecipientsQuery, ManageFaxRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageFaxRecipientsQuery, ManageFaxRecipientsQueryVariables>(ManageFaxRecipientsDocument, options);
      }
export function useManageFaxRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageFaxRecipientsQuery, ManageFaxRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageFaxRecipientsQuery, ManageFaxRecipientsQueryVariables>(ManageFaxRecipientsDocument, options);
        }
export type ManageFaxRecipientsQueryHookResult = ReturnType<typeof useManageFaxRecipientsQuery>;
export type ManageFaxRecipientsLazyQueryHookResult = ReturnType<typeof useManageFaxRecipientsLazyQuery>;
export type ManageFaxRecipientsQueryResult = Apollo.QueryResult<ManageFaxRecipientsQuery, ManageFaxRecipientsQueryVariables>;
export const ManageFaxRecipientDocument = gql`
    query ManageFaxRecipient($faxRecipientId: ID!) {
  faxRecipient(where: {id: $faxRecipientId}) {
    id
    createdAt
    cpsoId
    faxNumber
    firstName
    isUnsubscribed
    lastName
    metadata
    unsubscribedAt
    faxBlastItems {
      id
    }
  }
}
    `;

/**
 * __useManageFaxRecipientQuery__
 *
 * To run a query within a React component, call `useManageFaxRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageFaxRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageFaxRecipientQuery({
 *   variables: {
 *      faxRecipientId: // value for 'faxRecipientId'
 *   },
 * });
 */
export function useManageFaxRecipientQuery(baseOptions: Apollo.QueryHookOptions<ManageFaxRecipientQuery, ManageFaxRecipientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageFaxRecipientQuery, ManageFaxRecipientQueryVariables>(ManageFaxRecipientDocument, options);
      }
export function useManageFaxRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageFaxRecipientQuery, ManageFaxRecipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageFaxRecipientQuery, ManageFaxRecipientQueryVariables>(ManageFaxRecipientDocument, options);
        }
export type ManageFaxRecipientQueryHookResult = ReturnType<typeof useManageFaxRecipientQuery>;
export type ManageFaxRecipientLazyQueryHookResult = ReturnType<typeof useManageFaxRecipientLazyQuery>;
export type ManageFaxRecipientQueryResult = Apollo.QueryResult<ManageFaxRecipientQuery, ManageFaxRecipientQueryVariables>;
export const ManagePatientsDocument = gql`
    query ManagePatients($searchTerm: String, $skip: Int, $take: Int) {
  patients(
    skip: $skip
    take: $take
    where: {OR: [{user: {firstName: {mode: insensitive, contains: $searchTerm}}}, {user: {lastName: {mode: insensitive, contains: $searchTerm}}}]}
  ) {
    ...PatientBasicFields
    documents {
      id
    }
    user {
      id
      cellPhoneNumberString
    }
  }
}
    ${PatientBasicFieldsFragmentDoc}`;

/**
 * __useManagePatientsQuery__
 *
 * To run a query within a React component, call `useManagePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagePatientsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useManagePatientsQuery(baseOptions?: Apollo.QueryHookOptions<ManagePatientsQuery, ManagePatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagePatientsQuery, ManagePatientsQueryVariables>(ManagePatientsDocument, options);
      }
export function useManagePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagePatientsQuery, ManagePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagePatientsQuery, ManagePatientsQueryVariables>(ManagePatientsDocument, options);
        }
export type ManagePatientsQueryHookResult = ReturnType<typeof useManagePatientsQuery>;
export type ManagePatientsLazyQueryHookResult = ReturnType<typeof useManagePatientsLazyQuery>;
export type ManagePatientsQueryResult = Apollo.QueryResult<ManagePatientsQuery, ManagePatientsQueryVariables>;
export const ManagePatientDocument = gql`
    query ManagePatient($patientId: ID!) {
  patient(where: {id: $patientId}) {
    ...PatientBasicFields
    documents {
      id
      attachment {
        url
      }
      file {
        createdAt
        fileKey
        fileName
        fileSize
        fileType
      }
      title
    }
  }
}
    ${PatientBasicFieldsFragmentDoc}`;

/**
 * __useManagePatientQuery__
 *
 * To run a query within a React component, call `useManagePatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagePatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagePatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useManagePatientQuery(baseOptions: Apollo.QueryHookOptions<ManagePatientQuery, ManagePatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagePatientQuery, ManagePatientQueryVariables>(ManagePatientDocument, options);
      }
export function useManagePatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagePatientQuery, ManagePatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagePatientQuery, ManagePatientQueryVariables>(ManagePatientDocument, options);
        }
export type ManagePatientQueryHookResult = ReturnType<typeof useManagePatientQuery>;
export type ManagePatientLazyQueryHookResult = ReturnType<typeof useManagePatientLazyQuery>;
export type ManagePatientQueryResult = Apollo.QueryResult<ManagePatientQuery, ManagePatientQueryVariables>;
export const ManagePharmaciesDocument = gql`
    query ManagePharmacies($searchTerm: String, $skip: Int, $take: Int) {
  pharmacies(
    orderBy: [{companyName: asc}, {id: asc}]
    skip: $skip
    take: $take
    where: {OR: [{companyName: {contains: $searchTerm, mode: insensitive}}]}
  ) {
    id
    createdAt
    companyName
    locationsCount
  }
}
    `;

/**
 * __useManagePharmaciesQuery__
 *
 * To run a query within a React component, call `useManagePharmaciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagePharmaciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagePharmaciesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useManagePharmaciesQuery(baseOptions?: Apollo.QueryHookOptions<ManagePharmaciesQuery, ManagePharmaciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagePharmaciesQuery, ManagePharmaciesQueryVariables>(ManagePharmaciesDocument, options);
      }
export function useManagePharmaciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagePharmaciesQuery, ManagePharmaciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagePharmaciesQuery, ManagePharmaciesQueryVariables>(ManagePharmaciesDocument, options);
        }
export type ManagePharmaciesQueryHookResult = ReturnType<typeof useManagePharmaciesQuery>;
export type ManagePharmaciesLazyQueryHookResult = ReturnType<typeof useManagePharmaciesLazyQuery>;
export type ManagePharmaciesQueryResult = Apollo.QueryResult<ManagePharmaciesQuery, ManagePharmaciesQueryVariables>;
export const ManagePharmacyDocument = gql`
    query ManagePharmacy($pharmacyId: ID!) {
  pharmacy(where: {id: $pharmacyId}) {
    id
    createdAt
    companyName
    locations {
      id
      accreditationNumber
      address {
        ...AddressFields
      }
      faxString
      phoneString
      status
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useManagePharmacyQuery__
 *
 * To run a query within a React component, call `useManagePharmacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagePharmacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagePharmacyQuery({
 *   variables: {
 *      pharmacyId: // value for 'pharmacyId'
 *   },
 * });
 */
export function useManagePharmacyQuery(baseOptions: Apollo.QueryHookOptions<ManagePharmacyQuery, ManagePharmacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagePharmacyQuery, ManagePharmacyQueryVariables>(ManagePharmacyDocument, options);
      }
export function useManagePharmacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagePharmacyQuery, ManagePharmacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagePharmacyQuery, ManagePharmacyQueryVariables>(ManagePharmacyDocument, options);
        }
export type ManagePharmacyQueryHookResult = ReturnType<typeof useManagePharmacyQuery>;
export type ManagePharmacyLazyQueryHookResult = ReturnType<typeof useManagePharmacyLazyQuery>;
export type ManagePharmacyQueryResult = Apollo.QueryResult<ManagePharmacyQuery, ManagePharmacyQueryVariables>;
export const ManageUsersDocument = gql`
    query ManageUsers($orderBy: [UserOrderByInput!], $searchTerm: String, $skip: Int, $take: Int) {
  users(
    orderBy: $orderBy
    skip: $skip
    take: $take
    where: {OR: [{firstName: {mode: insensitive, contains: $searchTerm}}, {lastName: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    ...UserBasicDataFields
    createdAt
  }
}
    ${UserBasicDataFieldsFragmentDoc}`;

/**
 * __useManageUsersQuery__
 *
 * To run a query within a React component, call `useManageUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageUsersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      searchTerm: // value for 'searchTerm'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useManageUsersQuery(baseOptions?: Apollo.QueryHookOptions<ManageUsersQuery, ManageUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageUsersQuery, ManageUsersQueryVariables>(ManageUsersDocument, options);
      }
export function useManageUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageUsersQuery, ManageUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageUsersQuery, ManageUsersQueryVariables>(ManageUsersDocument, options);
        }
export type ManageUsersQueryHookResult = ReturnType<typeof useManageUsersQuery>;
export type ManageUsersLazyQueryHookResult = ReturnType<typeof useManageUsersLazyQuery>;
export type ManageUsersQueryResult = Apollo.QueryResult<ManageUsersQuery, ManageUsersQueryVariables>;
export const ManageUserDocument = gql`
    query ManageUser($userId: ID!) {
  user(where: {id: $userId}) {
    ...UserBasicDataFields
    createdAt
  }
}
    ${UserBasicDataFieldsFragmentDoc}`;

/**
 * __useManageUserQuery__
 *
 * To run a query within a React component, call `useManageUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useManageUserQuery(baseOptions: Apollo.QueryHookOptions<ManageUserQuery, ManageUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageUserQuery, ManageUserQueryVariables>(ManageUserDocument, options);
      }
export function useManageUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageUserQuery, ManageUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageUserQuery, ManageUserQueryVariables>(ManageUserDocument, options);
        }
export type ManageUserQueryHookResult = ReturnType<typeof useManageUserQuery>;
export type ManageUserLazyQueryHookResult = ReturnType<typeof useManageUserLazyQuery>;
export type ManageUserQueryResult = Apollo.QueryResult<ManageUserQuery, ManageUserQueryVariables>;
export const MedicationsSearchDocument = gql`
    query MedicationsSearch($searchTerm: String) {
  medications(
    take: 400
    where: {OR: [{brandName: {mode: insensitive, contains: $searchTerm}}, {drugCode: {mode: insensitive, contains: $searchTerm}}, {activeIngredients: {some: {ingredientName: {mode: insensitive, contains: $searchTerm}}}}, {drugIdentificationNumber: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    brandName
    drugCode
    drugIdentificationNumber
    activeIngredients {
      id
      drugCode
      ingredientName
      strengthUnit
      strengthValue
    }
    luReasonsCount
  }
}
    `;

/**
 * __useMedicationsSearchQuery__
 *
 * To run a query within a React component, call `useMedicationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationsSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMedicationsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MedicationsSearchQuery, MedicationsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicationsSearchQuery, MedicationsSearchQueryVariables>(MedicationsSearchDocument, options);
      }
export function useMedicationsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicationsSearchQuery, MedicationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicationsSearchQuery, MedicationsSearchQueryVariables>(MedicationsSearchDocument, options);
        }
export type MedicationsSearchQueryHookResult = ReturnType<typeof useMedicationsSearchQuery>;
export type MedicationsSearchLazyQueryHookResult = ReturnType<typeof useMedicationsSearchLazyQuery>;
export type MedicationsSearchQueryResult = Apollo.QueryResult<MedicationsSearchQuery, MedicationsSearchQueryVariables>;
export const MemberCalendarDocument = gql`
    query MemberCalendar($memberId: ID!) {
  member(where: {id: $memberId}) {
    id
    calendar {
      id
      acceptingNewPatients
      events {
        id
        durationMins
        isActive
        eventType {
          id
          value
          label
        }
      }
      defaultSchedule {
        id
        blockedDates
        blockedTimeIntervals {
          id
          from
          to
          recurringSlot {
            id
            wday
          }
        }
        defaultOn {
          id
        }
        description
        futureLimit
        slotInterval
        title
        tz
      }
    }
    user {
      id
      doctor {
        id
      }
    }
  }
}
    `;

/**
 * __useMemberCalendarQuery__
 *
 * To run a query within a React component, call `useMemberCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberCalendarQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberCalendarQuery(baseOptions: Apollo.QueryHookOptions<MemberCalendarQuery, MemberCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberCalendarQuery, MemberCalendarQueryVariables>(MemberCalendarDocument, options);
      }
export function useMemberCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberCalendarQuery, MemberCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberCalendarQuery, MemberCalendarQueryVariables>(MemberCalendarDocument, options);
        }
export type MemberCalendarQueryHookResult = ReturnType<typeof useMemberCalendarQuery>;
export type MemberCalendarLazyQueryHookResult = ReturnType<typeof useMemberCalendarLazyQuery>;
export type MemberCalendarQueryResult = Apollo.QueryResult<MemberCalendarQuery, MemberCalendarQueryVariables>;
export const MemberDocument = gql`
    query Member($memberId: ID!) {
  member(where: {id: $memberId}) {
    id
    clinic {
      id
      phoneNumber
    }
    faxNumber
    user {
      id
      firstName
      middleName
      lastName
      doctor {
        id
        licenseNumber
        ohipPractitionerNumber
        doctorSpecialty {
          id
          label
        }
      }
    }
    role {
      id
      name
    }
  }
}
    `;

/**
 * __useMemberQuery__
 *
 * To run a query within a React component, call `useMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberQuery(baseOptions: Apollo.QueryHookOptions<MemberQuery, MemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberQuery, MemberQueryVariables>(MemberDocument, options);
      }
export function useMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberQuery, MemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberQuery, MemberQueryVariables>(MemberDocument, options);
        }
export type MemberQueryHookResult = ReturnType<typeof useMemberQuery>;
export type MemberLazyQueryHookResult = ReturnType<typeof useMemberLazyQuery>;
export type MemberQueryResult = Apollo.QueryResult<MemberQuery, MemberQueryVariables>;
export const MemberUserProfileDocument = gql`
    query MemberUserProfile($userId: ID!, $companyId: ID!) {
  user(where: {id: $userId}) {
    id
    cellPhoneNumberString
    dateOfBirth
    email
    firstName
    homePhoneNumberString
    lastName
    memberships(where: {clinic: {company: {id: {equals: $companyId}}}}) {
      id
      faxNumber
      role {
        id
        name
      }
    }
    patient {
      id
      emergencyContacts {
        id
        email
        firstName
        lastName
        cellPhoneNumberString
        homePhoneNumberString
      }
    }
    ...UserPhotoFields
  }
}
    ${UserPhotoFieldsFragmentDoc}`;

/**
 * __useMemberUserProfileQuery__
 *
 * To run a query within a React component, call `useMemberUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberUserProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMemberUserProfileQuery(baseOptions: Apollo.QueryHookOptions<MemberUserProfileQuery, MemberUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberUserProfileQuery, MemberUserProfileQueryVariables>(MemberUserProfileDocument, options);
      }
export function useMemberUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberUserProfileQuery, MemberUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberUserProfileQuery, MemberUserProfileQueryVariables>(MemberUserProfileDocument, options);
        }
export type MemberUserProfileQueryHookResult = ReturnType<typeof useMemberUserProfileQuery>;
export type MemberUserProfileLazyQueryHookResult = ReturnType<typeof useMemberUserProfileLazyQuery>;
export type MemberUserProfileQueryResult = Apollo.QueryResult<MemberUserProfileQuery, MemberUserProfileQueryVariables>;
export const MyAppointmentRequestsDocument = gql`
    query MyAppointmentRequests($skip: Int, $take: Int, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        appointmentRequests(
          skip: $skip
          take: $take
          orderBy: {createdAt: asc}
          where: {doctor: {user: {OR: [{lastName: {mode: insensitive, contains: $searchTerm}}, {firstName: {mode: insensitive, contains: $searchTerm}}]}}}
        ) {
          id
          createdAt
          patient {
            id
            user {
              ...UserContactFields
              ...UserPhotoFields
            }
          }
          doctor {
            id
            user {
              ...UserContactFields
              ...UserPhotoFields
            }
          }
          event {
            id
            eventType {
              id
              label
              value
            }
          }
          reason
        }
      }
      doctor {
        id
        appointmentRequests(
          skip: $skip
          take: $take
          orderBy: {createdAt: desc}
          where: {patient: {user: {OR: [{lastName: {mode: insensitive, contains: $searchTerm}}, {firstName: {mode: insensitive, contains: $searchTerm}}]}}}
        ) {
          id
          createdAt
          event {
            id
            eventType {
              id
              label
              value
            }
          }
          patient {
            id
            user {
              ...UserContactFields
              ...UserPhotoFields
            }
          }
          reason
        }
      }
    }
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useMyAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useMyAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAppointmentRequestsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyAppointmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<MyAppointmentRequestsQuery, MyAppointmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAppointmentRequestsQuery, MyAppointmentRequestsQueryVariables>(MyAppointmentRequestsDocument, options);
      }
export function useMyAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAppointmentRequestsQuery, MyAppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAppointmentRequestsQuery, MyAppointmentRequestsQueryVariables>(MyAppointmentRequestsDocument, options);
        }
export type MyAppointmentRequestsQueryHookResult = ReturnType<typeof useMyAppointmentRequestsQuery>;
export type MyAppointmentRequestsLazyQueryHookResult = ReturnType<typeof useMyAppointmentRequestsLazyQuery>;
export type MyAppointmentRequestsQueryResult = Apollo.QueryResult<MyAppointmentRequestsQuery, MyAppointmentRequestsQueryVariables>;
export const MyCompaniesDocument = gql`
    query MyCompanies {
  authenticatedItem {
    ... on User {
      id
      companies {
        id
        clinics {
          id
          createdAt
          description
          facilityMasterNumber
          faxNumber
          name
          ohipGroupNumber
          phoneNumber
          serviceLocationIndicator
          address {
            ...AddressFields
          }
          members {
            id
            roleAlias
            role {
              id
              name
            }
            user {
              id
            }
          }
        }
        createdAt
        legalName
        operatingName
        owner {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useMyCompaniesQuery__
 *
 * To run a query within a React component, call `useMyCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<MyCompaniesQuery, MyCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCompaniesQuery, MyCompaniesQueryVariables>(MyCompaniesDocument, options);
      }
export function useMyCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCompaniesQuery, MyCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCompaniesQuery, MyCompaniesQueryVariables>(MyCompaniesDocument, options);
        }
export type MyCompaniesQueryHookResult = ReturnType<typeof useMyCompaniesQuery>;
export type MyCompaniesLazyQueryHookResult = ReturnType<typeof useMyCompaniesLazyQuery>;
export type MyCompaniesQueryResult = Apollo.QueryResult<MyCompaniesQuery, MyCompaniesQueryVariables>;
export const MyDoctorApptsMissedDocument = gql`
    query MyDoctorApptsMissed($skip: Int, $take: Int, $searchTerm: String, $companyId: ID!) {
  appointments(
    skip: $skip
    take: $take
    orderBy: [{scheduledStartsAt: desc}, {id: asc}]
    where: {clinic: {company: {id: {equals: $companyId}}}, rescheduledAt: {equals: null}, OR: [{isMissed: {equals: true}}, {NOT: {cancelledAt: {equals: null}}}], patient: {user: {OR: [{lastName: {mode: insensitive, contains: $searchTerm}}, {firstName: {mode: insensitive, contains: $searchTerm}}]}}}
  ) {
    id
    event {
      id
      title
      eventType {
        id
        label
        value
      }
    }
    member {
      id
      isActive
      user {
        ...UserContactFields
      }
    }
    doctor {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    booking {
      id
      durationMins
      startsAt
      event {
        id
        title
        eventType {
          id
          label
          value
        }
      }
    }
    scheduledStartsAt
    startedAt
    cancelledAt
    isMissed
    patient {
      ...PatientBasicFields
    }
    rescheduledAt
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useMyDoctorApptsMissedQuery__
 *
 * To run a query within a React component, call `useMyDoctorApptsMissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDoctorApptsMissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDoctorApptsMissedQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMyDoctorApptsMissedQuery(baseOptions: Apollo.QueryHookOptions<MyDoctorApptsMissedQuery, MyDoctorApptsMissedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDoctorApptsMissedQuery, MyDoctorApptsMissedQueryVariables>(MyDoctorApptsMissedDocument, options);
      }
export function useMyDoctorApptsMissedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDoctorApptsMissedQuery, MyDoctorApptsMissedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDoctorApptsMissedQuery, MyDoctorApptsMissedQueryVariables>(MyDoctorApptsMissedDocument, options);
        }
export type MyDoctorApptsMissedQueryHookResult = ReturnType<typeof useMyDoctorApptsMissedQuery>;
export type MyDoctorApptsMissedLazyQueryHookResult = ReturnType<typeof useMyDoctorApptsMissedLazyQuery>;
export type MyDoctorApptsMissedQueryResult = Apollo.QueryResult<MyDoctorApptsMissedQuery, MyDoctorApptsMissedQueryVariables>;
export const MyDoctorApptsSignedDocument = gql`
    query MyDoctorApptsSigned($skip: Int, $take: Int, $searchTerm: String, $companyId: ID!) {
  appointments(
    skip: $skip
    take: $take
    orderBy: {signedAt: desc}
    where: {clinic: {company: {id: {equals: $companyId}}}, isSigned: {equals: true}, patient: {user: {OR: [{lastName: {mode: insensitive, contains: $searchTerm}}, {firstName: {mode: insensitive, contains: $searchTerm}}]}}}
  ) {
    id
    booking {
      id
      durationMins
      startsAt
      event {
        id
        title
        eventType {
          id
          label
          value
        }
      }
    }
    member {
      id
      isActive
      user {
        ...UserContactFields
      }
    }
    doctor {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    event {
      id
      title
      eventType {
        id
        label
        value
      }
    }
    patient {
      ...PatientBasicFields
    }
    isSigned
    signedAt
    scheduledStartsAt
    startedAt
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useMyDoctorApptsSignedQuery__
 *
 * To run a query within a React component, call `useMyDoctorApptsSignedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDoctorApptsSignedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDoctorApptsSignedQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMyDoctorApptsSignedQuery(baseOptions: Apollo.QueryHookOptions<MyDoctorApptsSignedQuery, MyDoctorApptsSignedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDoctorApptsSignedQuery, MyDoctorApptsSignedQueryVariables>(MyDoctorApptsSignedDocument, options);
      }
export function useMyDoctorApptsSignedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDoctorApptsSignedQuery, MyDoctorApptsSignedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDoctorApptsSignedQuery, MyDoctorApptsSignedQueryVariables>(MyDoctorApptsSignedDocument, options);
        }
export type MyDoctorApptsSignedQueryHookResult = ReturnType<typeof useMyDoctorApptsSignedQuery>;
export type MyDoctorApptsSignedLazyQueryHookResult = ReturnType<typeof useMyDoctorApptsSignedLazyQuery>;
export type MyDoctorApptsSignedQueryResult = Apollo.QueryResult<MyDoctorApptsSignedQuery, MyDoctorApptsSignedQueryVariables>;
export const MyDoctorFaxesFailedDocument = gql`
    query MyDoctorFaxesFailed($companyId: ID!, $skip: Int, $take: Int, $searchTerm: String) {
  faxes(
    skip: $skip
    take: $take
    orderBy: {createdAt: desc}
    where: {AND: [{OR: [{patient: {user: {firstName: {mode: insensitive, contains: $searchTerm}}}}, {patient: {user: {lastName: {mode: insensitive, contains: $searchTerm}}}}]}, {status: {equals: failed}}, {appointment: {clinic: {company: {id: {equals: $companyId}}}}}]}
  ) {
    id
    createdAt
    doctor {
      user {
        ...UserBasicDataFields
      }
    }
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useMyDoctorFaxesFailedQuery__
 *
 * To run a query within a React component, call `useMyDoctorFaxesFailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDoctorFaxesFailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDoctorFaxesFailedQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyDoctorFaxesFailedQuery(baseOptions: Apollo.QueryHookOptions<MyDoctorFaxesFailedQuery, MyDoctorFaxesFailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDoctorFaxesFailedQuery, MyDoctorFaxesFailedQueryVariables>(MyDoctorFaxesFailedDocument, options);
      }
export function useMyDoctorFaxesFailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDoctorFaxesFailedQuery, MyDoctorFaxesFailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDoctorFaxesFailedQuery, MyDoctorFaxesFailedQueryVariables>(MyDoctorFaxesFailedDocument, options);
        }
export type MyDoctorFaxesFailedQueryHookResult = ReturnType<typeof useMyDoctorFaxesFailedQuery>;
export type MyDoctorFaxesFailedLazyQueryHookResult = ReturnType<typeof useMyDoctorFaxesFailedLazyQuery>;
export type MyDoctorFaxesFailedQueryResult = Apollo.QueryResult<MyDoctorFaxesFailedQuery, MyDoctorFaxesFailedQueryVariables>;
export const MyDoctorFaxesProcessingDocument = gql`
    query MyDoctorFaxesProcessing($companyId: ID!, $skip: Int, $take: Int, $searchTerm: String) {
  faxes(
    skip: $skip
    take: $take
    orderBy: {createdAt: desc}
    where: {AND: [{OR: [{patient: {user: {firstName: {mode: insensitive, contains: $searchTerm}}}}, {patient: {user: {lastName: {mode: insensitive, contains: $searchTerm}}}}]}, {OR: [{status: {equals: processing}}, {status: {equals: queued}}]}, {appointment: {clinic: {company: {id: {equals: $companyId}}}}}]}
  ) {
    id
    createdAt
    doctor {
      user {
        ...UserBasicDataFields
      }
    }
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useMyDoctorFaxesProcessingQuery__
 *
 * To run a query within a React component, call `useMyDoctorFaxesProcessingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDoctorFaxesProcessingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDoctorFaxesProcessingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyDoctorFaxesProcessingQuery(baseOptions: Apollo.QueryHookOptions<MyDoctorFaxesProcessingQuery, MyDoctorFaxesProcessingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDoctorFaxesProcessingQuery, MyDoctorFaxesProcessingQueryVariables>(MyDoctorFaxesProcessingDocument, options);
      }
export function useMyDoctorFaxesProcessingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDoctorFaxesProcessingQuery, MyDoctorFaxesProcessingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDoctorFaxesProcessingQuery, MyDoctorFaxesProcessingQueryVariables>(MyDoctorFaxesProcessingDocument, options);
        }
export type MyDoctorFaxesProcessingQueryHookResult = ReturnType<typeof useMyDoctorFaxesProcessingQuery>;
export type MyDoctorFaxesProcessingLazyQueryHookResult = ReturnType<typeof useMyDoctorFaxesProcessingLazyQuery>;
export type MyDoctorFaxesProcessingQueryResult = Apollo.QueryResult<MyDoctorFaxesProcessingQuery, MyDoctorFaxesProcessingQueryVariables>;
export const MyDoctorFaxesSuccessfulDocument = gql`
    query MyDoctorFaxesSuccessful($companyId: ID!, $skip: Int, $take: Int, $searchTerm: String) {
  faxes(
    skip: $skip
    take: $take
    orderBy: {createdAt: desc}
    where: {AND: [{OR: [{patient: {user: {firstName: {mode: insensitive, contains: $searchTerm}}}}, {patient: {user: {lastName: {mode: insensitive, contains: $searchTerm}}}}]}, {status: {equals: successful}}, {appointment: {clinic: {company: {id: {equals: $companyId}}}}}]}
  ) {
    id
    createdAt
    doctor {
      user {
        ...UserBasicDataFields
      }
    }
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useMyDoctorFaxesSuccessfulQuery__
 *
 * To run a query within a React component, call `useMyDoctorFaxesSuccessfulQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDoctorFaxesSuccessfulQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDoctorFaxesSuccessfulQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyDoctorFaxesSuccessfulQuery(baseOptions: Apollo.QueryHookOptions<MyDoctorFaxesSuccessfulQuery, MyDoctorFaxesSuccessfulQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDoctorFaxesSuccessfulQuery, MyDoctorFaxesSuccessfulQueryVariables>(MyDoctorFaxesSuccessfulDocument, options);
      }
export function useMyDoctorFaxesSuccessfulLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDoctorFaxesSuccessfulQuery, MyDoctorFaxesSuccessfulQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDoctorFaxesSuccessfulQuery, MyDoctorFaxesSuccessfulQueryVariables>(MyDoctorFaxesSuccessfulDocument, options);
        }
export type MyDoctorFaxesSuccessfulQueryHookResult = ReturnType<typeof useMyDoctorFaxesSuccessfulQuery>;
export type MyDoctorFaxesSuccessfulLazyQueryHookResult = ReturnType<typeof useMyDoctorFaxesSuccessfulLazyQuery>;
export type MyDoctorFaxesSuccessfulQueryResult = Apollo.QueryResult<MyDoctorFaxesSuccessfulQuery, MyDoctorFaxesSuccessfulQueryVariables>;
export const MyEmergencyContactsDocument = gql`
    query MyEmergencyContacts {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        emergencyContacts {
          ...EmergencyContactFields
        }
      }
    }
  }
}
    ${EmergencyContactFieldsFragmentDoc}`;

/**
 * __useMyEmergencyContactsQuery__
 *
 * To run a query within a React component, call `useMyEmergencyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEmergencyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEmergencyContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEmergencyContactsQuery(baseOptions?: Apollo.QueryHookOptions<MyEmergencyContactsQuery, MyEmergencyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEmergencyContactsQuery, MyEmergencyContactsQueryVariables>(MyEmergencyContactsDocument, options);
      }
export function useMyEmergencyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEmergencyContactsQuery, MyEmergencyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEmergencyContactsQuery, MyEmergencyContactsQueryVariables>(MyEmergencyContactsDocument, options);
        }
export type MyEmergencyContactsQueryHookResult = ReturnType<typeof useMyEmergencyContactsQuery>;
export type MyEmergencyContactsLazyQueryHookResult = ReturnType<typeof useMyEmergencyContactsLazyQuery>;
export type MyEmergencyContactsQueryResult = Apollo.QueryResult<MyEmergencyContactsQuery, MyEmergencyContactsQueryVariables>;
export const MyHealthCardsDocument = gql`
    query MyHealthCards {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        healthCards {
          ...HealthCardFields
        }
      }
    }
  }
}
    ${HealthCardFieldsFragmentDoc}`;

/**
 * __useMyHealthCardsQuery__
 *
 * To run a query within a React component, call `useMyHealthCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHealthCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHealthCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyHealthCardsQuery(baseOptions?: Apollo.QueryHookOptions<MyHealthCardsQuery, MyHealthCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyHealthCardsQuery, MyHealthCardsQueryVariables>(MyHealthCardsDocument, options);
      }
export function useMyHealthCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyHealthCardsQuery, MyHealthCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyHealthCardsQuery, MyHealthCardsQueryVariables>(MyHealthCardsDocument, options);
        }
export type MyHealthCardsQueryHookResult = ReturnType<typeof useMyHealthCardsQuery>;
export type MyHealthCardsLazyQueryHookResult = ReturnType<typeof useMyHealthCardsLazyQuery>;
export type MyHealthCardsQueryResult = Apollo.QueryResult<MyHealthCardsQuery, MyHealthCardsQueryVariables>;
export const MyMedicalHistoryDocument = gql`
    query MyMedicalHistory($skip: Int, $take: Int) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        allergies(skip: $skip, take: $take, orderBy: [{onsetDate: desc}, {id: asc}]) {
          id
          name
          onsetDate
          reaction
        }
        appointments(
          skip: $skip
          take: $take
          where: {isSigned: {equals: true}}
          orderBy: {signedAt: desc}
        ) {
          id
          booking {
            id
            appointment {
              id
              reason
            }
            startsAt
          }
          doctor {
            id
            doctorSpecialty {
              id
              label
              value
            }
            user {
              id
              firstName
              lastName
            }
          }
          note
          noteMdx
          signedAt
          patient {
            id
          }
          vitalsData {
            ...VitalsFields
          }
        }
        documents(skip: $skip, take: $take, orderBy: [{addedAt: desc}, {id: asc}]) {
          id
          file {
            ...FileFields
          }
          attachment {
            filename
            url
          }
          doctor {
            id
            user {
              id
              firstName
              middleName
              lastName
            }
          }
          form {
            id
            appointment {
              id
              event {
                id
                eventType {
                  id
                  value
                }
              }
            }
            name
            slug
            issuedAt
            formFields
            doctor {
              id
              clinicFaxNumber
              clinicPhoneNumber
              licenseNumber
              doctorSpecialty {
                id
                label
                value
              }
              ohipPractitionerNumber
              signature {
                id
                file {
                  ...FileFields
                }
                attachment {
                  filename
                  url
                }
              }
              user {
                id
                firstName
                middleName
                lastName
                address {
                  id
                  addressLine1
                  addressLine2
                  locality
                  postalCode
                }
              }
            }
            patient {
              ...PatientBasicFields
            }
          }
          addedAt
          title
        }
        healthConditions(
          skip: $skip
          take: $take
          orderBy: [{diagnosedAt: desc}, {id: asc}]
        ) {
          id
          diagnosedAt
          name
          relation
        }
        lifestyleItems(skip: $skip, take: $take) {
          id
          activity
          frequency
          item
        }
        screeningTests(skip: $skip, take: $take, orderBy: [{testedAt: desc}, {id: asc}]) {
          id
          name
          testedAt
        }
        medicationItems(
          skip: $skip
          take: $take
          orderBy: [{prescribedAt: desc}, {id: asc}]
        ) {
          id
          doctor {
            id
            user {
              id
              firstName
              lastName
            }
          }
          instructions
          medication {
            id
            activeIngredients {
              id
              drugCode
              ingredientName
              strengthUnit
              strengthValue
            }
            brandName
            drugCode
          }
          prescribedAt
          refills
        }
        vaccinations(
          skip: $skip
          take: $take
          orderBy: [{immunizedAt: desc}, {id: asc}]
        ) {
          id
          doctor {
            id
            user {
              id
              firstName
              lastName
            }
          }
          expirationDate
          immunizedAt
          medication {
            id
            activeIngredients {
              id
              drugCode
              ingredientName
              strengthUnit
              strengthValue
            }
            brandName
            drugCode
            drugIdentificationNumber
          }
        }
        user {
          id
          username
        }
      }
    }
  }
}
    ${VitalsFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useMyMedicalHistoryQuery__
 *
 * To run a query within a React component, call `useMyMedicalHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyMedicalHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyMedicalHistoryQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useMyMedicalHistoryQuery(baseOptions?: Apollo.QueryHookOptions<MyMedicalHistoryQuery, MyMedicalHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyMedicalHistoryQuery, MyMedicalHistoryQueryVariables>(MyMedicalHistoryDocument, options);
      }
export function useMyMedicalHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyMedicalHistoryQuery, MyMedicalHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyMedicalHistoryQuery, MyMedicalHistoryQueryVariables>(MyMedicalHistoryDocument, options);
        }
export type MyMedicalHistoryQueryHookResult = ReturnType<typeof useMyMedicalHistoryQuery>;
export type MyMedicalHistoryLazyQueryHookResult = ReturnType<typeof useMyMedicalHistoryLazyQuery>;
export type MyMedicalHistoryQueryResult = Apollo.QueryResult<MyMedicalHistoryQuery, MyMedicalHistoryQueryVariables>;
export const MyMissedPatientBookingsDocument = gql`
    query MyMissedPatientBookings($skip: Int, $take: Int, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        appointments(
          skip: $skip
          take: $take
          orderBy: [{scheduledStartsAt: desc}, {id: asc}]
          where: {rescheduledAt: {equals: null}, OR: [{isMissed: {equals: true}}, {NOT: {cancelledAt: {equals: null}}}], event: {eventType: {value: {not: {equals: "walk-in"}}}}, doctor: {user: {OR: [{lastName: {mode: insensitive, contains: $searchTerm}}, {firstName: {mode: insensitive, contains: $searchTerm}}]}}}
        ) {
          id
          booking {
            id
            durationMins
            startsAt
            event {
              id
              title
              eventType {
                id
                label
                value
              }
            }
          }
          event {
            id
            title
            eventType {
              id
              label
              value
            }
          }
          cancelledAt
          isMissed
          doctor {
            ...DoctorBasicFields
            user {
              id
              firstName
              lastName
            }
          }
          patient {
            id
            user {
              id
              firstName
              lastName
            }
          }
          rescheduledAt
        }
      }
    }
  }
}
    ${DoctorBasicFieldsFragmentDoc}`;

/**
 * __useMyMissedPatientBookingsQuery__
 *
 * To run a query within a React component, call `useMyMissedPatientBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyMissedPatientBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyMissedPatientBookingsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyMissedPatientBookingsQuery(baseOptions?: Apollo.QueryHookOptions<MyMissedPatientBookingsQuery, MyMissedPatientBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyMissedPatientBookingsQuery, MyMissedPatientBookingsQueryVariables>(MyMissedPatientBookingsDocument, options);
      }
export function useMyMissedPatientBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyMissedPatientBookingsQuery, MyMissedPatientBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyMissedPatientBookingsQuery, MyMissedPatientBookingsQueryVariables>(MyMissedPatientBookingsDocument, options);
        }
export type MyMissedPatientBookingsQueryHookResult = ReturnType<typeof useMyMissedPatientBookingsQuery>;
export type MyMissedPatientBookingsLazyQueryHookResult = ReturnType<typeof useMyMissedPatientBookingsLazyQuery>;
export type MyMissedPatientBookingsQueryResult = Apollo.QueryResult<MyMissedPatientBookingsQuery, MyMissedPatientBookingsQueryVariables>;
export const MyPatientsDocument = gql`
    query MyPatients($skip: Int, $take: Int, $searchTerm: String, $companyId: ID!) {
  patients(
    skip: $skip
    take: $take
    where: {companies: {some: {id: {equals: $companyId}}}, OR: [{user: {firstName: {mode: insensitive, contains: $searchTerm}}}, {user: {lastName: {mode: insensitive, contains: $searchTerm}}}]}
  ) {
    id
    healthCards {
      ...HealthCardFields
    }
    user {
      ...UserContactFields
      ...UserPhotoFields
    }
    companies {
      id
    }
  }
}
    ${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useMyPatientsQuery__
 *
 * To run a query within a React component, call `useMyPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMyPatientsQuery(baseOptions: Apollo.QueryHookOptions<MyPatientsQuery, MyPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientsQuery, MyPatientsQueryVariables>(MyPatientsDocument, options);
      }
export function useMyPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientsQuery, MyPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientsQuery, MyPatientsQueryVariables>(MyPatientsDocument, options);
        }
export type MyPatientsQueryHookResult = ReturnType<typeof useMyPatientsQuery>;
export type MyPatientsLazyQueryHookResult = ReturnType<typeof useMyPatientsLazyQuery>;
export type MyPatientsQueryResult = Apollo.QueryResult<MyPatientsQuery, MyPatientsQueryVariables>;
export const MyPatientAllergiesSearchDocument = gql`
    query MyPatientAllergiesSearch($skip: Int, $take: Int, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        allergies(
          skip: $skip
          take: $take
          orderBy: [{onsetDate: desc}, {id: asc}]
          where: {name: {mode: insensitive, contains: $searchTerm}}
        ) {
          id
          name
          onsetDate
          reaction
        }
      }
    }
  }
}
    `;

/**
 * __useMyPatientAllergiesSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientAllergiesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientAllergiesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientAllergiesSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyPatientAllergiesSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientAllergiesSearchQuery, MyPatientAllergiesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientAllergiesSearchQuery, MyPatientAllergiesSearchQueryVariables>(MyPatientAllergiesSearchDocument, options);
      }
export function useMyPatientAllergiesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientAllergiesSearchQuery, MyPatientAllergiesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientAllergiesSearchQuery, MyPatientAllergiesSearchQueryVariables>(MyPatientAllergiesSearchDocument, options);
        }
export type MyPatientAllergiesSearchQueryHookResult = ReturnType<typeof useMyPatientAllergiesSearchQuery>;
export type MyPatientAllergiesSearchLazyQueryHookResult = ReturnType<typeof useMyPatientAllergiesSearchLazyQuery>;
export type MyPatientAllergiesSearchQueryResult = Apollo.QueryResult<MyPatientAllergiesSearchQuery, MyPatientAllergiesSearchQueryVariables>;
export const MyPatientBookingsDocument = gql`
    query MyPatientBookings($skip: Int, $take: Int, $startsAt: DateTimeNullableFilter, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        bookings(
          skip: $skip
          take: $take
          orderBy: [{startsAt: asc}, {id: asc}]
          where: {startsAt: $startsAt, appointment: {isMissed: {equals: false}, cancelledAt: {equals: null}, isSigned: {equals: false}}, doctor: {user: {OR: [{lastName: {mode: insensitive, contains: $searchTerm}}, {firstName: {mode: insensitive, contains: $searchTerm}}]}}}
        ) {
          id
          appointment {
            id
          }
          durationMins
          startsAt
          doctor {
            ...DoctorBasicFields
            user {
              id
              firstName
              lastName
            }
          }
          patient {
            id
            user {
              id
              firstName
              lastName
            }
          }
          event {
            id
            title
            eventType {
              id
              label
              value
            }
          }
        }
      }
    }
  }
}
    ${DoctorBasicFieldsFragmentDoc}`;

/**
 * __useMyPatientBookingsQuery__
 *
 * To run a query within a React component, call `useMyPatientBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientBookingsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startsAt: // value for 'startsAt'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyPatientBookingsQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientBookingsQuery, MyPatientBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientBookingsQuery, MyPatientBookingsQueryVariables>(MyPatientBookingsDocument, options);
      }
export function useMyPatientBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientBookingsQuery, MyPatientBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientBookingsQuery, MyPatientBookingsQueryVariables>(MyPatientBookingsDocument, options);
        }
export type MyPatientBookingsQueryHookResult = ReturnType<typeof useMyPatientBookingsQuery>;
export type MyPatientBookingsLazyQueryHookResult = ReturnType<typeof useMyPatientBookingsLazyQuery>;
export type MyPatientBookingsQueryResult = Apollo.QueryResult<MyPatientBookingsQuery, MyPatientBookingsQueryVariables>;
export const MyPatientDocumentsSearchDocument = gql`
    query MyPatientDocumentsSearch($skip: Int, $take: Int, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        documents(
          skip: $skip
          take: $take
          orderBy: [{addedAt: desc}, {id: asc}]
          where: {title: {mode: insensitive, contains: $searchTerm}}
        ) {
          id
          file {
            ...FileFields
          }
          attachment {
            filename
            url
          }
          doctor {
            id
            user {
              id
              firstName
              middleName
              lastName
            }
          }
          form {
            id
            appointment {
              id
              event {
                id
                eventType {
                  id
                  value
                }
              }
            }
            name
            slug
            issuedAt
            formFields
            doctor {
              id
              clinicFaxNumber
              clinicPhoneNumber
              licenseNumber
              doctorSpecialty {
                id
                label
                value
              }
              ohipPractitionerNumber
              user {
                id
                firstName
                middleName
                lastName
                address {
                  id
                  addressLine1
                  addressLine2
                  locality
                  postalCode
                }
              }
            }
            patient {
              id
              user {
                id
                cellPhoneNumberString
                dateOfBirth
                email
                firstName
                middleName
                lastName
                sex
                address {
                  id
                  addressLine1
                  addressLine2
                  locality
                  postalCode
                }
              }
            }
          }
          addedAt
          title
        }
      }
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useMyPatientDocumentsSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientDocumentsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientDocumentsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientDocumentsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyPatientDocumentsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientDocumentsSearchQuery, MyPatientDocumentsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientDocumentsSearchQuery, MyPatientDocumentsSearchQueryVariables>(MyPatientDocumentsSearchDocument, options);
      }
export function useMyPatientDocumentsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientDocumentsSearchQuery, MyPatientDocumentsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientDocumentsSearchQuery, MyPatientDocumentsSearchQueryVariables>(MyPatientDocumentsSearchDocument, options);
        }
export type MyPatientDocumentsSearchQueryHookResult = ReturnType<typeof useMyPatientDocumentsSearchQuery>;
export type MyPatientDocumentsSearchLazyQueryHookResult = ReturnType<typeof useMyPatientDocumentsSearchLazyQuery>;
export type MyPatientDocumentsSearchQueryResult = Apollo.QueryResult<MyPatientDocumentsSearchQuery, MyPatientDocumentsSearchQueryVariables>;
export const MyPatientHealthConditionsSearchDocument = gql`
    query MyPatientHealthConditionsSearch($skip: Int, $take: Int, $searchTerm: String, $filters: [HealthConditionWhereInput!]) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        healthConditions(
          skip: $skip
          take: $take
          orderBy: [{diagnosedAt: desc}, {id: asc}]
          where: {AND: $filters, name: {mode: insensitive, contains: $searchTerm}}
        ) {
          id
          diagnosedAt
          inactivatedAt
          inactivatedBy {
            id
          }
          name
          relation
        }
      }
    }
  }
}
    `;

/**
 * __useMyPatientHealthConditionsSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientHealthConditionsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientHealthConditionsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientHealthConditionsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMyPatientHealthConditionsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientHealthConditionsSearchQuery, MyPatientHealthConditionsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientHealthConditionsSearchQuery, MyPatientHealthConditionsSearchQueryVariables>(MyPatientHealthConditionsSearchDocument, options);
      }
export function useMyPatientHealthConditionsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientHealthConditionsSearchQuery, MyPatientHealthConditionsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientHealthConditionsSearchQuery, MyPatientHealthConditionsSearchQueryVariables>(MyPatientHealthConditionsSearchDocument, options);
        }
export type MyPatientHealthConditionsSearchQueryHookResult = ReturnType<typeof useMyPatientHealthConditionsSearchQuery>;
export type MyPatientHealthConditionsSearchLazyQueryHookResult = ReturnType<typeof useMyPatientHealthConditionsSearchLazyQuery>;
export type MyPatientHealthConditionsSearchQueryResult = Apollo.QueryResult<MyPatientHealthConditionsSearchQuery, MyPatientHealthConditionsSearchQueryVariables>;
export const MyPatientLifestyleItemsSearchDocument = gql`
    query MyPatientLifestyleItemsSearch($skip: Int, $take: Int, $searchTerm: String, $filters: [LifestyleItemWhereInput!]) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        lifestyleItems(
          skip: $skip
          take: $take
          where: {AND: $filters, OR: [{activity: {mode: insensitive, contains: $searchTerm}}, {frequency: {mode: insensitive, contains: $searchTerm}}, {item: {mode: insensitive, contains: $searchTerm}}]}
        ) {
          id
          activity
          frequency
          inactivatedAt
          inactivatedBy {
            id
          }
          item
        }
      }
    }
  }
}
    `;

/**
 * __useMyPatientLifestyleItemsSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientLifestyleItemsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientLifestyleItemsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientLifestyleItemsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMyPatientLifestyleItemsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientLifestyleItemsSearchQuery, MyPatientLifestyleItemsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientLifestyleItemsSearchQuery, MyPatientLifestyleItemsSearchQueryVariables>(MyPatientLifestyleItemsSearchDocument, options);
      }
export function useMyPatientLifestyleItemsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientLifestyleItemsSearchQuery, MyPatientLifestyleItemsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientLifestyleItemsSearchQuery, MyPatientLifestyleItemsSearchQueryVariables>(MyPatientLifestyleItemsSearchDocument, options);
        }
export type MyPatientLifestyleItemsSearchQueryHookResult = ReturnType<typeof useMyPatientLifestyleItemsSearchQuery>;
export type MyPatientLifestyleItemsSearchLazyQueryHookResult = ReturnType<typeof useMyPatientLifestyleItemsSearchLazyQuery>;
export type MyPatientLifestyleItemsSearchQueryResult = Apollo.QueryResult<MyPatientLifestyleItemsSearchQuery, MyPatientLifestyleItemsSearchQueryVariables>;
export const MyPatientMedicationsSearchDocument = gql`
    query MyPatientMedicationsSearch($skip: Int, $take: Int, $searchTerm: String, $filters: [MedicationItemWhereInput!]) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        medicationItems(
          skip: $skip
          take: $take
          where: {AND: $filters, OR: [{doctor: {user: {OR: [{lastName: {contains: $searchTerm, mode: insensitive}}, {firstName: {contains: $searchTerm, mode: insensitive}}]}}}, {medication: {brandName: {mode: insensitive, contains: $searchTerm}}}, {medication: {activeIngredients: {some: {ingredientName: {mode: insensitive, contains: $searchTerm}}}}}]}
          orderBy: [{prescribedAt: desc}, {id: asc}]
        ) {
          id
          doctor {
            id
            user {
              id
              firstName
              lastName
            }
          }
          inactivatedAt
          inactivatedBy {
            id
          }
          instructions
          medication {
            id
            activeIngredients {
              id
              drugCode
              ingredientName
              strengthUnit
              strengthValue
            }
            brandName
            drugCode
          }
          prescribedAt
          refills
        }
      }
    }
  }
}
    `;

/**
 * __useMyPatientMedicationsSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientMedicationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientMedicationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientMedicationsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMyPatientMedicationsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientMedicationsSearchQuery, MyPatientMedicationsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientMedicationsSearchQuery, MyPatientMedicationsSearchQueryVariables>(MyPatientMedicationsSearchDocument, options);
      }
export function useMyPatientMedicationsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientMedicationsSearchQuery, MyPatientMedicationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientMedicationsSearchQuery, MyPatientMedicationsSearchQueryVariables>(MyPatientMedicationsSearchDocument, options);
        }
export type MyPatientMedicationsSearchQueryHookResult = ReturnType<typeof useMyPatientMedicationsSearchQuery>;
export type MyPatientMedicationsSearchLazyQueryHookResult = ReturnType<typeof useMyPatientMedicationsSearchLazyQuery>;
export type MyPatientMedicationsSearchQueryResult = Apollo.QueryResult<MyPatientMedicationsSearchQuery, MyPatientMedicationsSearchQueryVariables>;
export const MyPatientScreeningTestsSearchDocument = gql`
    query MyPatientScreeningTestsSearch($skip: Int, $take: Int, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        screeningTests(
          skip: $skip
          take: $take
          where: {name: {mode: insensitive, contains: $searchTerm}}
          orderBy: [{testedAt: desc}, {id: asc}]
        ) {
          id
          name
          testedAt
        }
      }
    }
  }
}
    `;

/**
 * __useMyPatientScreeningTestsSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientScreeningTestsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientScreeningTestsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientScreeningTestsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyPatientScreeningTestsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientScreeningTestsSearchQuery, MyPatientScreeningTestsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientScreeningTestsSearchQuery, MyPatientScreeningTestsSearchQueryVariables>(MyPatientScreeningTestsSearchDocument, options);
      }
export function useMyPatientScreeningTestsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientScreeningTestsSearchQuery, MyPatientScreeningTestsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientScreeningTestsSearchQuery, MyPatientScreeningTestsSearchQueryVariables>(MyPatientScreeningTestsSearchDocument, options);
        }
export type MyPatientScreeningTestsSearchQueryHookResult = ReturnType<typeof useMyPatientScreeningTestsSearchQuery>;
export type MyPatientScreeningTestsSearchLazyQueryHookResult = ReturnType<typeof useMyPatientScreeningTestsSearchLazyQuery>;
export type MyPatientScreeningTestsSearchQueryResult = Apollo.QueryResult<MyPatientScreeningTestsSearchQuery, MyPatientScreeningTestsSearchQueryVariables>;
export const MyPatientSettingsDocument = gql`
    query MyPatientSettings {
  authenticatedItem {
    ... on User {
      ...UserBasicDataFields
      doctor {
        ...DoctorBasicFields
        proofOfIdentification {
          id
          file {
            ...FileFields
          }
          src {
            id
            publicUrlTransformed
            mimetype
          }
        }
        proofOfInsurance {
          id
          file {
            ...FileFields
          }
          src {
            id
            publicUrlTransformed
            mimetype
          }
        }
        proofOfLicense {
          id
          file {
            ...FileFields
          }
          src {
            id
            publicUrlTransformed
            mimetype
          }
        }
        signature {
          id
          file {
            ...FileFields
          }
          attachment {
            url
          }
        }
      }
      patient {
        ...PatientBasicFields
      }
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${DoctorBasicFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useMyPatientSettingsQuery__
 *
 * To run a query within a React component, call `useMyPatientSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPatientSettingsQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientSettingsQuery, MyPatientSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientSettingsQuery, MyPatientSettingsQueryVariables>(MyPatientSettingsDocument, options);
      }
export function useMyPatientSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientSettingsQuery, MyPatientSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientSettingsQuery, MyPatientSettingsQueryVariables>(MyPatientSettingsDocument, options);
        }
export type MyPatientSettingsQueryHookResult = ReturnType<typeof useMyPatientSettingsQuery>;
export type MyPatientSettingsLazyQueryHookResult = ReturnType<typeof useMyPatientSettingsLazyQuery>;
export type MyPatientSettingsQueryResult = Apollo.QueryResult<MyPatientSettingsQuery, MyPatientSettingsQueryVariables>;
export const MyPatientVaccinationsSearchDocument = gql`
    query MyPatientVaccinationsSearch($skip: Int, $take: Int, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        vaccinations(
          skip: $skip
          take: $take
          where: {medication: {brandName: {mode: insensitive, contains: $searchTerm}}}
          orderBy: [{immunizedAt: desc}, {id: asc}]
        ) {
          id
          doctor {
            id
            user {
              id
              firstName
              lastName
            }
          }
          expirationDate
          immunizedAt
          medication {
            id
            activeIngredients {
              id
              drugCode
              ingredientName
              strengthUnit
              strengthValue
            }
            brandName
            drugCode
            drugIdentificationNumber
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyPatientVaccinationsSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientVaccinationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientVaccinationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientVaccinationsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyPatientVaccinationsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientVaccinationsSearchQuery, MyPatientVaccinationsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientVaccinationsSearchQuery, MyPatientVaccinationsSearchQueryVariables>(MyPatientVaccinationsSearchDocument, options);
      }
export function useMyPatientVaccinationsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientVaccinationsSearchQuery, MyPatientVaccinationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientVaccinationsSearchQuery, MyPatientVaccinationsSearchQueryVariables>(MyPatientVaccinationsSearchDocument, options);
        }
export type MyPatientVaccinationsSearchQueryHookResult = ReturnType<typeof useMyPatientVaccinationsSearchQuery>;
export type MyPatientVaccinationsSearchLazyQueryHookResult = ReturnType<typeof useMyPatientVaccinationsSearchLazyQuery>;
export type MyPatientVaccinationsSearchQueryResult = Apollo.QueryResult<MyPatientVaccinationsSearchQuery, MyPatientVaccinationsSearchQueryVariables>;
export const MyPatientVisitsSearchDocument = gql`
    query MyPatientVisitsSearch($skip: Int, $take: Int, $searchTerm: String) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        appointments(
          skip: $skip
          take: $take
          where: {isSigned: {equals: true}, OR: [{doctor: {user: {firstName: {mode: insensitive, contains: $searchTerm}}}}, {doctor: {user: {lastName: {mode: insensitive, contains: $searchTerm}}}}]}
          orderBy: {signedAt: desc}
        ) {
          id
          booking {
            id
            appointment {
              id
              reason
            }
            startsAt
          }
          doctor {
            id
            doctorSpecialty {
              id
              label
              value
            }
            user {
              id
              firstName
              lastName
            }
          }
          note
          noteMdx
          signedAt
          patient {
            id
          }
          vitalsData {
            ...VitalsFields
          }
        }
      }
    }
  }
}
    ${VitalsFieldsFragmentDoc}`;

/**
 * __useMyPatientVisitsSearchQuery__
 *
 * To run a query within a React component, call `useMyPatientVisitsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPatientVisitsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPatientVisitsSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useMyPatientVisitsSearchQuery(baseOptions?: Apollo.QueryHookOptions<MyPatientVisitsSearchQuery, MyPatientVisitsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPatientVisitsSearchQuery, MyPatientVisitsSearchQueryVariables>(MyPatientVisitsSearchDocument, options);
      }
export function useMyPatientVisitsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPatientVisitsSearchQuery, MyPatientVisitsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPatientVisitsSearchQuery, MyPatientVisitsSearchQueryVariables>(MyPatientVisitsSearchDocument, options);
        }
export type MyPatientVisitsSearchQueryHookResult = ReturnType<typeof useMyPatientVisitsSearchQuery>;
export type MyPatientVisitsSearchLazyQueryHookResult = ReturnType<typeof useMyPatientVisitsSearchLazyQuery>;
export type MyPatientVisitsSearchQueryResult = Apollo.QueryResult<MyPatientVisitsSearchQuery, MyPatientVisitsSearchQueryVariables>;
export const MyProfileSettingsDocument = gql`
    query MyProfileSettings($userId: ID!) {
  user(where: {id: $userId}) {
    id
    address {
      ...AddressFields
    }
    ...UserContactFields
    ...UserPhotoFields
    dateOfBirth
    isOnboardedDoctor
    doctor {
      ...DoctorBasicFields
      contractSignedOn
      doctorSince
      doctorSubSpecialties {
        id
        label
        value
      }
      doctorSpecialty {
        id
        label
        value
      }
      ohipPractitionerNumber
      ohipSpecialityCode
      proofOfIdentification {
        id
        file {
          ...FileFields
        }
        src {
          id
          mimetype
          originalFilename
          publicUrl
        }
      }
      proofOfInsurance {
        id
        file {
          ...FileFields
        }
        src {
          id
          mimetype
          originalFilename
          publicUrl
        }
      }
      proofOfLicense {
        id
        file {
          ...FileFields
        }
        src {
          id
          mimetype
          originalFilename
          publicUrl
        }
      }
      signature {
        id
        file {
          ...FileFields
        }
        attachment {
          url
        }
      }
      email
      isCompleteProfile
      isVerified
      languages {
        id
        label
        value
      }
      licenseNumber
      licenseProvider
      medicalLiabilityProvider
      medicalLiabilityNumber
      province
      summary
    }
    patient {
      id
      emergencyContacts {
        ...EmergencyContactFields
      }
      healthCards {
        ...HealthCardFields
      }
      pharmacyLocations {
        id
        address {
          ...AddressFields
        }
        pharmacy {
          id
          companyName
        }
      }
      savedDoctors {
        id
        user {
          ...UserPhotoFields
          firstName
          lastName
        }
      }
    }
    sex
    stripeCusId
  }
}
    ${AddressFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${DoctorBasicFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${EmergencyContactFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useMyProfileSettingsQuery__
 *
 * To run a query within a React component, call `useMyProfileSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileSettingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMyProfileSettingsQuery(baseOptions: Apollo.QueryHookOptions<MyProfileSettingsQuery, MyProfileSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileSettingsQuery, MyProfileSettingsQueryVariables>(MyProfileSettingsDocument, options);
      }
export function useMyProfileSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileSettingsQuery, MyProfileSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileSettingsQuery, MyProfileSettingsQueryVariables>(MyProfileSettingsDocument, options);
        }
export type MyProfileSettingsQueryHookResult = ReturnType<typeof useMyProfileSettingsQuery>;
export type MyProfileSettingsLazyQueryHookResult = ReturnType<typeof useMyProfileSettingsLazyQuery>;
export type MyProfileSettingsQueryResult = Apollo.QueryResult<MyProfileSettingsQuery, MyProfileSettingsQueryVariables>;
export const MyStepperProgDocument = gql`
    query MyStepperProg($stepperSlug: String, $userId: ID!) {
  steppers(where: {slug: {equals: $stepperSlug}}) {
    id
    stepsOrderBySlugs
    stepperSteps {
      ...StepperStepFields
    }
    stepperProgs(where: {user: {id: {equals: $userId}}}) {
      id
      stepperStepProgs {
        id
        stepperStep {
          id
          slug
          component
        }
        percentDone
        isCompleted
      }
      company {
        id
      }
      user {
        id
      }
    }
    eyebrow
    title
  }
}
    ${StepperStepFieldsFragmentDoc}`;

/**
 * __useMyStepperProgQuery__
 *
 * To run a query within a React component, call `useMyStepperProgQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyStepperProgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyStepperProgQuery({
 *   variables: {
 *      stepperSlug: // value for 'stepperSlug'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMyStepperProgQuery(baseOptions: Apollo.QueryHookOptions<MyStepperProgQuery, MyStepperProgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyStepperProgQuery, MyStepperProgQueryVariables>(MyStepperProgDocument, options);
      }
export function useMyStepperProgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyStepperProgQuery, MyStepperProgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyStepperProgQuery, MyStepperProgQueryVariables>(MyStepperProgDocument, options);
        }
export type MyStepperProgQueryHookResult = ReturnType<typeof useMyStepperProgQuery>;
export type MyStepperProgLazyQueryHookResult = ReturnType<typeof useMyStepperProgLazyQuery>;
export type MyStepperProgQueryResult = Apollo.QueryResult<MyStepperProgQuery, MyStepperProgQueryVariables>;
export const MyUserInvitesDocument = gql`
    query MyUserInvites($companyId: ID!, $searchTerm: String, $skip: Int, $take: Int) {
  userInvites(
    skip: $skip
    take: $take
    where: {company: {id: {equals: $companyId}}, OR: [{firstName: {mode: insensitive, contains: $searchTerm}}, {lastName: {mode: insensitive, contains: $searchTerm}}]}
    orderBy: [{createdAt: desc}, {id: desc}]
  ) {
    id
    createdAt
    firstName
    lastName
    cellPhoneNumberString
    dateOfBirth
    email
    healthCard {
      id
      insurancePolicyNumber
      versionCode
      expiryDate
    }
    revokedAt
    signedUpUser {
      id
      patient {
        id
      }
    }
  }
}
    `;

/**
 * __useMyUserInvitesQuery__
 *
 * To run a query within a React component, call `useMyUserInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUserInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUserInvitesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      searchTerm: // value for 'searchTerm'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useMyUserInvitesQuery(baseOptions: Apollo.QueryHookOptions<MyUserInvitesQuery, MyUserInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyUserInvitesQuery, MyUserInvitesQueryVariables>(MyUserInvitesDocument, options);
      }
export function useMyUserInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyUserInvitesQuery, MyUserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyUserInvitesQuery, MyUserInvitesQueryVariables>(MyUserInvitesDocument, options);
        }
export type MyUserInvitesQueryHookResult = ReturnType<typeof useMyUserInvitesQuery>;
export type MyUserInvitesLazyQueryHookResult = ReturnType<typeof useMyUserInvitesLazyQuery>;
export type MyUserInvitesQueryResult = Apollo.QueryResult<MyUserInvitesQuery, MyUserInvitesQueryVariables>;
export const PatientsDocument = gql`
    query Patients($skip: Int, $take: Int, $where: PatientWhereInput, $orderBy: [PatientOrderByInput!]) {
  patients(skip: $skip, take: $take, where: $where, orderBy: $orderBy) {
    id
    healthCards {
      ...HealthCardFields
    }
    user {
      ...UserContactFields
      ...UserPhotoFields
    }
    companies {
      id
    }
  }
}
    ${HealthCardFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __usePatientsQuery__
 *
 * To run a query within a React component, call `usePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePatientsQuery(baseOptions?: Apollo.QueryHookOptions<PatientsQuery, PatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientsQuery, PatientsQueryVariables>(PatientsDocument, options);
      }
export function usePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientsQuery, PatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientsQuery, PatientsQueryVariables>(PatientsDocument, options);
        }
export type PatientsQueryHookResult = ReturnType<typeof usePatientsQuery>;
export type PatientsLazyQueryHookResult = ReturnType<typeof usePatientsLazyQuery>;
export type PatientsQueryResult = Apollo.QueryResult<PatientsQuery, PatientsQueryVariables>;
export const PatientAppointmentRoomDocument = gql`
    query PatientAppointmentRoom($appointmentId: ID!) {
  appointment(where: {id: $appointmentId}) {
    ...PatientAppointmentBookingFields
    chat {
      id
    }
  }
}
    ${PatientAppointmentBookingFieldsFragmentDoc}`;

/**
 * __usePatientAppointmentRoomQuery__
 *
 * To run a query within a React component, call `usePatientAppointmentRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientAppointmentRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientAppointmentRoomQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function usePatientAppointmentRoomQuery(baseOptions: Apollo.QueryHookOptions<PatientAppointmentRoomQuery, PatientAppointmentRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientAppointmentRoomQuery, PatientAppointmentRoomQueryVariables>(PatientAppointmentRoomDocument, options);
      }
export function usePatientAppointmentRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientAppointmentRoomQuery, PatientAppointmentRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientAppointmentRoomQuery, PatientAppointmentRoomQueryVariables>(PatientAppointmentRoomDocument, options);
        }
export type PatientAppointmentRoomQueryHookResult = ReturnType<typeof usePatientAppointmentRoomQuery>;
export type PatientAppointmentRoomLazyQueryHookResult = ReturnType<typeof usePatientAppointmentRoomLazyQuery>;
export type PatientAppointmentRoomQueryResult = Apollo.QueryResult<PatientAppointmentRoomQuery, PatientAppointmentRoomQueryVariables>;
export const PatientByEmailDocument = gql`
    query PatientByEmail($email: String!) {
  patients(where: {user: {email: {equals: $email, mode: insensitive}}}) {
    id
  }
}
    `;

/**
 * __usePatientByEmailQuery__
 *
 * To run a query within a React component, call `usePatientByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePatientByEmailQuery(baseOptions: Apollo.QueryHookOptions<PatientByEmailQuery, PatientByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientByEmailQuery, PatientByEmailQueryVariables>(PatientByEmailDocument, options);
      }
export function usePatientByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientByEmailQuery, PatientByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientByEmailQuery, PatientByEmailQueryVariables>(PatientByEmailDocument, options);
        }
export type PatientByEmailQueryHookResult = ReturnType<typeof usePatientByEmailQuery>;
export type PatientByEmailLazyQueryHookResult = ReturnType<typeof usePatientByEmailLazyQuery>;
export type PatientByEmailQueryResult = Apollo.QueryResult<PatientByEmailQuery, PatientByEmailQueryVariables>;
export const PatientDashboardDocument = gql`
    query PatientDashboard($skip: Int, $take: Int, $startsAt: DateTimeNullableFilter!) {
  authenticatedItem {
    ... on User {
      id
      patient {
        id
        user {
          id
          firstName
          lastName
          userInvites {
            id
            firstName
            lastName
          }
        }
        bookings(
          skip: $skip
          take: $take
          orderBy: [{startsAt: asc}, {id: asc}]
          where: {appointment: {isMissed: {equals: false}, cancelledAt: {equals: null}}, AND: [{appointment: {isSigned: {equals: false}}}, {startsAt: $startsAt}, {NOT: {appointment: {isMissed: {equals: true}}}}, {NOT: {appointment: {cancelledAt: {not: null}}}}]}
        ) {
          id
          startsAt
          appointment {
            id
            reason
          }
          event {
            id
            eventType {
              id
              label
              value
            }
          }
          doctor {
            id
            user {
              ...UserBasicDataFields
            }
          }
          patient {
            id
            user {
              ...UserBasicDataFields
            }
            caredByDoctors {
              id
              user {
                id
                firstName
                lastName
              }
            }
            appointmentRequests {
              id
            }
          }
        }
      }
      ...UserPhotoFields
    }
  }
}
    ${UserBasicDataFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __usePatientDashboardQuery__
 *
 * To run a query within a React component, call `usePatientDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientDashboardQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startsAt: // value for 'startsAt'
 *   },
 * });
 */
export function usePatientDashboardQuery(baseOptions: Apollo.QueryHookOptions<PatientDashboardQuery, PatientDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientDashboardQuery, PatientDashboardQueryVariables>(PatientDashboardDocument, options);
      }
export function usePatientDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientDashboardQuery, PatientDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientDashboardQuery, PatientDashboardQueryVariables>(PatientDashboardDocument, options);
        }
export type PatientDashboardQueryHookResult = ReturnType<typeof usePatientDashboardQuery>;
export type PatientDashboardLazyQueryHookResult = ReturnType<typeof usePatientDashboardLazyQuery>;
export type PatientDashboardQueryResult = Apollo.QueryResult<PatientDashboardQuery, PatientDashboardQueryVariables>;
export const PatientDashboardStatsDocument = gql`
    query PatientDashboardStats($patientId: ID!, $startsAt: DateTimeNullableFilter!) {
  bookingsCount(
    where: {startsAt: $startsAt, appointment: {isMissed: {equals: false}, cancelledAt: {equals: null}, isSigned: {equals: false}}, patient: {id: {equals: $patientId}}}
  )
  appointmentsCount(
    where: {rescheduledAt: {equals: null}, OR: [{isMissed: {equals: true}}, {NOT: {cancelledAt: {equals: null}}}], event: {eventType: {value: {not: {equals: "walk-in"}}}}, patient: {id: {equals: $patientId}}}
  )
  appointmentRequestsCount(where: {patient: {id: {equals: $patientId}}})
  doctorsCount(
    where: {AND: [{user: {memberships: {some: {AND: [{isActive: {equals: true}}, {clinic: {isActive: {equals: true}, company: {patients: {some: {id: {equals: $patientId}}}}}}, {role: {name: {equals: doctor}}}, {calendar: {events: {some: {isActive: {equals: true}}}}}]}}}}]}
  )
}
    `;

/**
 * __usePatientDashboardStatsQuery__
 *
 * To run a query within a React component, call `usePatientDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientDashboardStatsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      startsAt: // value for 'startsAt'
 *   },
 * });
 */
export function usePatientDashboardStatsQuery(baseOptions: Apollo.QueryHookOptions<PatientDashboardStatsQuery, PatientDashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientDashboardStatsQuery, PatientDashboardStatsQueryVariables>(PatientDashboardStatsDocument, options);
      }
export function usePatientDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientDashboardStatsQuery, PatientDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientDashboardStatsQuery, PatientDashboardStatsQueryVariables>(PatientDashboardStatsDocument, options);
        }
export type PatientDashboardStatsQueryHookResult = ReturnType<typeof usePatientDashboardStatsQuery>;
export type PatientDashboardStatsLazyQueryHookResult = ReturnType<typeof usePatientDashboardStatsLazyQuery>;
export type PatientDashboardStatsQueryResult = Apollo.QueryResult<PatientDashboardStatsQuery, PatientDashboardStatsQueryVariables>;
export const PatientDoctorDocument = gql`
    query PatientDoctor($doctorId: ID!, $patientId: ID!, $eventType: String!) {
  doctor(where: {id: $doctorId}) {
    ...DoctorBasicFields
    calendar {
      id
      acceptingNewPatients
    }
    calendarEvents {
      id
      address {
        id
        addressLine1
        addressLine2
        administrativeArea
        locality
        postalCode
      }
      eventType {
        id
        label
        value
      }
    }
    isVerified
    licenseNumber
    licenseProvider
    medicalLiabilityProvider
    medicalLiabilityNumber
    user {
      ...UserContactFields
      ...UserPhotoFields
      memberships(
        where: {isActive: {equals: true}, clinic: {company: {patients: {some: {id: {equals: $patientId}}}}, isActive: {equals: true}}, calendar: {events: {some: {eventType: {value: {equals: $eventType}}, isActive: {equals: true}}}}}
      ) {
        id
        clinic {
          id
          description
          isActive
          name
          address {
            ...AddressFields
          }
          company {
            id
            legalName
          }
          members(where: {user: {doctor: {id: {equals: $doctorId}}}}) {
            id
            calendar {
              id
              acceptingNewPatients
              events {
                id
                durationMins
                isActive
                eventType {
                  id
                  value
                  label
                }
              }
              defaultSchedule {
                id
                title
                description
                tz
                slotInterval
                defaultOn {
                  id
                }
              }
            }
          }
        }
        calendar {
          id
          acceptingNewPatients
        }
      }
    }
  }
}
    ${DoctorBasicFieldsFragmentDoc}
${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${AddressFieldsFragmentDoc}`;

/**
 * __usePatientDoctorQuery__
 *
 * To run a query within a React component, call `usePatientDoctorQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientDoctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientDoctorQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      patientId: // value for 'patientId'
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function usePatientDoctorQuery(baseOptions: Apollo.QueryHookOptions<PatientDoctorQuery, PatientDoctorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientDoctorQuery, PatientDoctorQueryVariables>(PatientDoctorDocument, options);
      }
export function usePatientDoctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientDoctorQuery, PatientDoctorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientDoctorQuery, PatientDoctorQueryVariables>(PatientDoctorDocument, options);
        }
export type PatientDoctorQueryHookResult = ReturnType<typeof usePatientDoctorQuery>;
export type PatientDoctorLazyQueryHookResult = ReturnType<typeof usePatientDoctorLazyQuery>;
export type PatientDoctorQueryResult = Apollo.QueryResult<PatientDoctorQuery, PatientDoctorQueryVariables>;
export const PatientProfileDocument = gql`
    query PatientProfile($patientId: ID!) {
  patient(where: {id: $patientId}) {
    ...PatientProfileFields
  }
}
    ${PatientProfileFieldsFragmentDoc}`;

/**
 * __usePatientProfileQuery__
 *
 * To run a query within a React component, call `usePatientProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientProfileQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientProfileQuery(baseOptions: Apollo.QueryHookOptions<PatientProfileQuery, PatientProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientProfileQuery, PatientProfileQueryVariables>(PatientProfileDocument, options);
      }
export function usePatientProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientProfileQuery, PatientProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientProfileQuery, PatientProfileQueryVariables>(PatientProfileDocument, options);
        }
export type PatientProfileQueryHookResult = ReturnType<typeof usePatientProfileQuery>;
export type PatientProfileLazyQueryHookResult = ReturnType<typeof usePatientProfileLazyQuery>;
export type PatientProfileQueryResult = Apollo.QueryResult<PatientProfileQuery, PatientProfileQueryVariables>;
export const PatientVisitNotesDocument = gql`
    query PatientVisitNotes($patientId: ID!, $searchTerm: String) {
  appointments(
    where: {isSigned: {equals: true}, patient: {id: {equals: $patientId}}, OR: [{doctor: {user: {firstName: {mode: insensitive, contains: $searchTerm}}}}, {doctor: {user: {lastName: {mode: insensitive, contains: $searchTerm}}}}]}
  ) {
    id
    booking {
      id
      appointment {
        id
        reason
      }
      startsAt
    }
    doctor {
      id
      doctorSpecialty {
        id
        label
        value
      }
      user {
        id
        firstName
        lastName
      }
    }
    note
    noteMdx
    patient {
      id
    }
    vitalsData {
      ...VitalsFields
    }
  }
}
    ${VitalsFieldsFragmentDoc}`;

/**
 * __usePatientVisitNotesQuery__
 *
 * To run a query within a React component, call `usePatientVisitNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientVisitNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientVisitNotesQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function usePatientVisitNotesQuery(baseOptions: Apollo.QueryHookOptions<PatientVisitNotesQuery, PatientVisitNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientVisitNotesQuery, PatientVisitNotesQueryVariables>(PatientVisitNotesDocument, options);
      }
export function usePatientVisitNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientVisitNotesQuery, PatientVisitNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientVisitNotesQuery, PatientVisitNotesQueryVariables>(PatientVisitNotesDocument, options);
        }
export type PatientVisitNotesQueryHookResult = ReturnType<typeof usePatientVisitNotesQuery>;
export type PatientVisitNotesLazyQueryHookResult = ReturnType<typeof usePatientVisitNotesLazyQuery>;
export type PatientVisitNotesQueryResult = Apollo.QueryResult<PatientVisitNotesQuery, PatientVisitNotesQueryVariables>;
export const PharmaciesDocument = gql`
    query Pharmacies($take: Int) {
  pharmacies(take: $take) {
    id
    companyName
  }
}
    `;

/**
 * __usePharmaciesQuery__
 *
 * To run a query within a React component, call `usePharmaciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePharmaciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePharmaciesQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePharmaciesQuery(baseOptions?: Apollo.QueryHookOptions<PharmaciesQuery, PharmaciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PharmaciesQuery, PharmaciesQueryVariables>(PharmaciesDocument, options);
      }
export function usePharmaciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PharmaciesQuery, PharmaciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PharmaciesQuery, PharmaciesQueryVariables>(PharmaciesDocument, options);
        }
export type PharmaciesQueryHookResult = ReturnType<typeof usePharmaciesQuery>;
export type PharmaciesLazyQueryHookResult = ReturnType<typeof usePharmaciesLazyQuery>;
export type PharmaciesQueryResult = Apollo.QueryResult<PharmaciesQuery, PharmaciesQueryVariables>;
export const PharmaciesSearchDocument = gql`
    query PharmaciesSearch($searchTerm: String!, $take: Int) {
  pharmacies(
    take: $take
    where: {OR: [{companyName: {contains: $searchTerm, mode: insensitive}}, {locations: {some: {address: {addressLine1: {contains: $searchTerm, mode: insensitive}}}}}]}
  ) {
    id
    companyName
  }
}
    `;

/**
 * __usePharmaciesSearchQuery__
 *
 * To run a query within a React component, call `usePharmaciesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePharmaciesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePharmaciesSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePharmaciesSearchQuery(baseOptions: Apollo.QueryHookOptions<PharmaciesSearchQuery, PharmaciesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PharmaciesSearchQuery, PharmaciesSearchQueryVariables>(PharmaciesSearchDocument, options);
      }
export function usePharmaciesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PharmaciesSearchQuery, PharmaciesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PharmaciesSearchQuery, PharmaciesSearchQueryVariables>(PharmaciesSearchDocument, options);
        }
export type PharmaciesSearchQueryHookResult = ReturnType<typeof usePharmaciesSearchQuery>;
export type PharmaciesSearchLazyQueryHookResult = ReturnType<typeof usePharmaciesSearchLazyQuery>;
export type PharmaciesSearchQueryResult = Apollo.QueryResult<PharmaciesSearchQuery, PharmaciesSearchQueryVariables>;
export const PharmacyLocationsDocument = gql`
    query PharmacyLocations($take: Int) {
  pharmacyLocations(take: $take) {
    id
  }
}
    `;

/**
 * __usePharmacyLocationsQuery__
 *
 * To run a query within a React component, call `usePharmacyLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePharmacyLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePharmacyLocationsQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePharmacyLocationsQuery(baseOptions?: Apollo.QueryHookOptions<PharmacyLocationsQuery, PharmacyLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PharmacyLocationsQuery, PharmacyLocationsQueryVariables>(PharmacyLocationsDocument, options);
      }
export function usePharmacyLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PharmacyLocationsQuery, PharmacyLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PharmacyLocationsQuery, PharmacyLocationsQueryVariables>(PharmacyLocationsDocument, options);
        }
export type PharmacyLocationsQueryHookResult = ReturnType<typeof usePharmacyLocationsQuery>;
export type PharmacyLocationsLazyQueryHookResult = ReturnType<typeof usePharmacyLocationsLazyQuery>;
export type PharmacyLocationsQueryResult = Apollo.QueryResult<PharmacyLocationsQuery, PharmacyLocationsQueryVariables>;
export const PharmacyLocationsSearchDocument = gql`
    query PharmacyLocationsSearch($searchTerm: String, $take: Int) {
  pharmacyLocations(
    take: $take
    where: {OR: [{pharmacy: {companyName: {contains: $searchTerm, mode: insensitive}}}, {address: {addressLine1: {contains: $searchTerm, mode: insensitive}}}]}
  ) {
    id
    pharmacy {
      id
      companyName
    }
    address {
      id
      addressLine1
      addressLine2
    }
  }
}
    `;

/**
 * __usePharmacyLocationsSearchQuery__
 *
 * To run a query within a React component, call `usePharmacyLocationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePharmacyLocationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePharmacyLocationsSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePharmacyLocationsSearchQuery(baseOptions?: Apollo.QueryHookOptions<PharmacyLocationsSearchQuery, PharmacyLocationsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PharmacyLocationsSearchQuery, PharmacyLocationsSearchQueryVariables>(PharmacyLocationsSearchDocument, options);
      }
export function usePharmacyLocationsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PharmacyLocationsSearchQuery, PharmacyLocationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PharmacyLocationsSearchQuery, PharmacyLocationsSearchQueryVariables>(PharmacyLocationsSearchDocument, options);
        }
export type PharmacyLocationsSearchQueryHookResult = ReturnType<typeof usePharmacyLocationsSearchQuery>;
export type PharmacyLocationsSearchLazyQueryHookResult = ReturnType<typeof usePharmacyLocationsSearchLazyQuery>;
export type PharmacyLocationsSearchQueryResult = Apollo.QueryResult<PharmacyLocationsSearchQuery, PharmacyLocationsSearchQueryVariables>;
export const RecurringIntervalsDocument = gql`
    query RecurringIntervals($recurringSlotId: ID!) {
  timeIntervals(where: {recurringSlot: {id: {equals: $recurringSlotId}}}) {
    recurringSlot {
      id
      timeIntervals {
        id
        from
        to
      }
    }
  }
}
    `;

/**
 * __useRecurringIntervalsQuery__
 *
 * To run a query within a React component, call `useRecurringIntervalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringIntervalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringIntervalsQuery({
 *   variables: {
 *      recurringSlotId: // value for 'recurringSlotId'
 *   },
 * });
 */
export function useRecurringIntervalsQuery(baseOptions: Apollo.QueryHookOptions<RecurringIntervalsQuery, RecurringIntervalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringIntervalsQuery, RecurringIntervalsQueryVariables>(RecurringIntervalsDocument, options);
      }
export function useRecurringIntervalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringIntervalsQuery, RecurringIntervalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringIntervalsQuery, RecurringIntervalsQueryVariables>(RecurringIntervalsDocument, options);
        }
export type RecurringIntervalsQueryHookResult = ReturnType<typeof useRecurringIntervalsQuery>;
export type RecurringIntervalsLazyQueryHookResult = ReturnType<typeof useRecurringIntervalsLazyQuery>;
export type RecurringIntervalsQueryResult = Apollo.QueryResult<RecurringIntervalsQuery, RecurringIntervalsQueryVariables>;
export const RemittancesDocument = gql`
    query Remittances($take: Int, $where: RemittanceAdviceWhereInput) {
  remittanceAdvices(where: $where, take: $take, orderBy: {createdAt: desc}) {
    id
    billings {
      id
      status
      billingItems {
        id
        claim {
          id
          amount
          description
          feeCode
        }
        diagnosis {
          id
          code
        }
        premium {
          id
          amount
        }
        units
      }
      appointment {
        id
        booking {
          id
          startsAt
        }
        doctor {
          id
          user {
            id
            dateOfBirth
            email
            firstName
            lastName
          }
        }
        patient {
          id
          user {
            id
            dateOfBirth
            email
            firstName
            lastName
          }
        }
        scheduledStartsAt
        startedAt
      }
    }
    externalClaims
    request {
      id
      status
    }
  }
}
    `;

/**
 * __useRemittancesQuery__
 *
 * To run a query within a React component, call `useRemittancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemittancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemittancesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRemittancesQuery(baseOptions?: Apollo.QueryHookOptions<RemittancesQuery, RemittancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemittancesQuery, RemittancesQueryVariables>(RemittancesDocument, options);
      }
export function useRemittancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemittancesQuery, RemittancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemittancesQuery, RemittancesQueryVariables>(RemittancesDocument, options);
        }
export type RemittancesQueryHookResult = ReturnType<typeof useRemittancesQuery>;
export type RemittancesLazyQueryHookResult = ReturnType<typeof useRemittancesLazyQuery>;
export type RemittancesQueryResult = Apollo.QueryResult<RemittancesQuery, RemittancesQueryVariables>;
export const RemittanceDocument = gql`
    query Remittance($where: RemittanceAdviceWhereUniqueInput!) {
  remittanceAdvice(where: $where) {
    id
    billings {
      id
      billingItems {
        id
        claim {
          id
          amount
          feeCode
        }
        diagnosis {
          id
          code
        }
        premium {
          id
          amount
          code
          description
          feeCode
        }
        units
      }
      status
      submission {
        id
        createdAt
        amountPaid
        amountSubmitted
        explanatoryItems
      }
    }
  }
}
    `;

/**
 * __useRemittanceQuery__
 *
 * To run a query within a React component, call `useRemittanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemittanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemittanceQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRemittanceQuery(baseOptions: Apollo.QueryHookOptions<RemittanceQuery, RemittanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemittanceQuery, RemittanceQueryVariables>(RemittanceDocument, options);
      }
export function useRemittanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemittanceQuery, RemittanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemittanceQuery, RemittanceQueryVariables>(RemittanceDocument, options);
        }
export type RemittanceQueryHookResult = ReturnType<typeof useRemittanceQuery>;
export type RemittanceLazyQueryHookResult = ReturnType<typeof useRemittanceLazyQuery>;
export type RemittanceQueryResult = Apollo.QueryResult<RemittanceQuery, RemittanceQueryVariables>;
export const RolesDocument = gql`
    query Roles($where: RoleWhereInput) {
  roles(where: $where) {
    id
    name
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const ScheduleDocument = gql`
    query Schedule($scheduleId: ID!) {
  schedule(where: {id: $scheduleId}) {
    id
    title
    description
    tz
    slotInterval
    defaultOn {
      id
    }
  }
}
    `;

/**
 * __useScheduleQuery__
 *
 * To run a query within a React component, call `useScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useScheduleQuery(baseOptions: Apollo.QueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
      }
export function useScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
        }
export type ScheduleQueryHookResult = ReturnType<typeof useScheduleQuery>;
export type ScheduleLazyQueryHookResult = ReturnType<typeof useScheduleLazyQuery>;
export type ScheduleQueryResult = Apollo.QueryResult<ScheduleQuery, ScheduleQueryVariables>;
export const SoapNoteCompletionDocument = gql`
    query SOAPNoteCompletion($note: String!) {
  getSOAPCompletion(note: $note)
}
    `;

/**
 * __useSoapNoteCompletionQuery__
 *
 * To run a query within a React component, call `useSoapNoteCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoapNoteCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoapNoteCompletionQuery({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSoapNoteCompletionQuery(baseOptions: Apollo.QueryHookOptions<SoapNoteCompletionQuery, SoapNoteCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoapNoteCompletionQuery, SoapNoteCompletionQueryVariables>(SoapNoteCompletionDocument, options);
      }
export function useSoapNoteCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoapNoteCompletionQuery, SoapNoteCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoapNoteCompletionQuery, SoapNoteCompletionQueryVariables>(SoapNoteCompletionDocument, options);
        }
export type SoapNoteCompletionQueryHookResult = ReturnType<typeof useSoapNoteCompletionQuery>;
export type SoapNoteCompletionLazyQueryHookResult = ReturnType<typeof useSoapNoteCompletionLazyQuery>;
export type SoapNoteCompletionQueryResult = Apollo.QueryResult<SoapNoteCompletionQuery, SoapNoteCompletionQueryVariables>;
export const SteppersDocument = gql`
    query Steppers($stepperSlug: String!) {
  steppers(where: {slug: {equals: $stepperSlug}}) {
    id
    eyebrow
    title
    stepsOrderBySlugs
    stepperSteps {
      ...StepperStepFields
    }
  }
}
    ${StepperStepFieldsFragmentDoc}`;

/**
 * __useSteppersQuery__
 *
 * To run a query within a React component, call `useSteppersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSteppersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSteppersQuery({
 *   variables: {
 *      stepperSlug: // value for 'stepperSlug'
 *   },
 * });
 */
export function useSteppersQuery(baseOptions: Apollo.QueryHookOptions<SteppersQuery, SteppersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SteppersQuery, SteppersQueryVariables>(SteppersDocument, options);
      }
export function useSteppersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SteppersQuery, SteppersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SteppersQuery, SteppersQueryVariables>(SteppersDocument, options);
        }
export type SteppersQueryHookResult = ReturnType<typeof useSteppersQuery>;
export type SteppersLazyQueryHookResult = ReturnType<typeof useSteppersLazyQuery>;
export type SteppersQueryResult = Apollo.QueryResult<SteppersQuery, SteppersQueryVariables>;
export const StepperStepProgsDocument = gql`
    query StepperStepProgs($stepperSlug: String!, $username: String!) {
  stepperStepProgs(
    where: {stepperStep: {stepper: {slug: {equals: $stepperSlug}}}, user: {username: {equals: $username}}}
  ) {
    id
    stepperStep {
      id
      slug
    }
    percentDone
    isCompleted
  }
}
    `;

/**
 * __useStepperStepProgsQuery__
 *
 * To run a query within a React component, call `useStepperStepProgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStepperStepProgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStepperStepProgsQuery({
 *   variables: {
 *      stepperSlug: // value for 'stepperSlug'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useStepperStepProgsQuery(baseOptions: Apollo.QueryHookOptions<StepperStepProgsQuery, StepperStepProgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StepperStepProgsQuery, StepperStepProgsQueryVariables>(StepperStepProgsDocument, options);
      }
export function useStepperStepProgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StepperStepProgsQuery, StepperStepProgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StepperStepProgsQuery, StepperStepProgsQueryVariables>(StepperStepProgsDocument, options);
        }
export type StepperStepProgsQueryHookResult = ReturnType<typeof useStepperStepProgsQuery>;
export type StepperStepProgsLazyQueryHookResult = ReturnType<typeof useStepperStepProgsLazyQuery>;
export type StepperStepProgsQueryResult = Apollo.QueryResult<StepperStepProgsQuery, StepperStepProgsQueryVariables>;
export const TasksDocument = gql`
    query Tasks($skip: Int, $take: Int, $orderBy: [TaskOrderByInput!], $where: TaskWhereInput) {
  tasks(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    createdAt
    dueAt
    priority
    resolvedAt
    resolvedNote
    status
    title
    description
    appointment {
      id
    }
    assignedTo {
      id
      user {
        ...UserContactFields
      }
    }
    author {
      id
      ...UserContactFields
    }
    patient {
      id
      ...PatientBasicFields
    }
  }
}
    ${UserContactFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTasksQuery(baseOptions?: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
      }
export function useTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksQueryResult = Apollo.QueryResult<TasksQuery, TasksQueryVariables>;
export const TaskDocument = gql`
    query Task($taskId: ID!) {
  task(where: {id: $taskId}) {
    id
    createdAt
    description
    dueAt
    priority
    resolvedAt
    resolvedNote
    status
    title
    appointment {
      id
    }
    assignedTo {
      id
      isActive
      user {
        ...UserContactFields
      }
      clinic {
        id
        description
        isActive
        name
        company {
          id
        }
      }
    }
    author {
      id
      ...UserContactFields
    }
    patient {
      id
      ...PatientBasicFields
      healthCards {
        ...HealthCardFields
      }
    }
  }
}
    ${UserContactFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const TestsBatchesDocument = gql`
    query TestsBatches($doctorId: ID!) {
  testsBatches(where: {doctor: {id: {equals: $doctorId}}}) {
    id
    name
    doctor {
      id
    }
    formTests {
      id
      label
      value
    }
    formType {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useTestsBatchesQuery__
 *
 * To run a query within a React component, call `useTestsBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestsBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestsBatchesQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useTestsBatchesQuery(baseOptions: Apollo.QueryHookOptions<TestsBatchesQuery, TestsBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestsBatchesQuery, TestsBatchesQueryVariables>(TestsBatchesDocument, options);
      }
export function useTestsBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestsBatchesQuery, TestsBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestsBatchesQuery, TestsBatchesQueryVariables>(TestsBatchesDocument, options);
        }
export type TestsBatchesQueryHookResult = ReturnType<typeof useTestsBatchesQuery>;
export type TestsBatchesLazyQueryHookResult = ReturnType<typeof useTestsBatchesLazyQuery>;
export type TestsBatchesQueryResult = Apollo.QueryResult<TestsBatchesQuery, TestsBatchesQueryVariables>;
export const TestsOrderedDocument = gql`
    query TestsOrdered($orderBy: [TestOrderOrderByInput!], $skip: Int, $take: Int, $where: TestOrderWhereInput) {
  testOrders(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    id
    orderedAt
    resolvedAt
    data
    doctor {
      id
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    patient {
      id
      healthCards {
        ...HealthCardFields
      }
      user {
        ...UserContactFields
        ...UserPhotoFields
      }
    }
    slug
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}
${HealthCardFieldsFragmentDoc}`;

/**
 * __useTestsOrderedQuery__
 *
 * To run a query within a React component, call `useTestsOrderedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestsOrderedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestsOrderedQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTestsOrderedQuery(baseOptions?: Apollo.QueryHookOptions<TestsOrderedQuery, TestsOrderedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestsOrderedQuery, TestsOrderedQueryVariables>(TestsOrderedDocument, options);
      }
export function useTestsOrderedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestsOrderedQuery, TestsOrderedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestsOrderedQuery, TestsOrderedQueryVariables>(TestsOrderedDocument, options);
        }
export type TestsOrderedQueryHookResult = ReturnType<typeof useTestsOrderedQuery>;
export type TestsOrderedLazyQueryHookResult = ReturnType<typeof useTestsOrderedLazyQuery>;
export type TestsOrderedQueryResult = Apollo.QueryResult<TestsOrderedQuery, TestsOrderedQueryVariables>;
export const TestOrderDocument = gql`
    query TestOrder($testOrderId: ID!) {
  testOrder(where: {id: $testOrderId}) {
    id
    inboundFaxes {
      id
      member {
        id
        user {
          id
          firstName
          lastName
        }
      }
      patient {
        id
        user {
          id
          firstName
          lastName
        }
      }
      file {
        ...FileFields
      }
    }
    patient {
      ...PatientBasicFields
    }
    appointment {
      id
    }
    resolvedAt
    orderedAt
    data
    slug
  }
}
    ${FileFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useTestOrderQuery__
 *
 * To run a query within a React component, call `useTestOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestOrderQuery({
 *   variables: {
 *      testOrderId: // value for 'testOrderId'
 *   },
 * });
 */
export function useTestOrderQuery(baseOptions: Apollo.QueryHookOptions<TestOrderQuery, TestOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestOrderQuery, TestOrderQueryVariables>(TestOrderDocument, options);
      }
export function useTestOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestOrderQuery, TestOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestOrderQuery, TestOrderQueryVariables>(TestOrderDocument, options);
        }
export type TestOrderQueryHookResult = ReturnType<typeof useTestOrderQuery>;
export type TestOrderLazyQueryHookResult = ReturnType<typeof useTestOrderLazyQuery>;
export type TestOrderQueryResult = Apollo.QueryResult<TestOrderQuery, TestOrderQueryVariables>;
export const UserAllergiesDocument = gql`
    query UserAllergies($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String) {
  patient(where: {id: $patientId}) {
    id
    allergies(
      skip: $skip
      take: $take
      orderBy: [{onsetDate: desc}, {id: asc}]
      where: {OR: [{name: {mode: insensitive, contains: $searchTerm}}]}
    ) {
      id
      name
      onsetDate
      reaction
    }
    user {
      id
      username
    }
  }
}
    `;

/**
 * __useUserAllergiesQuery__
 *
 * To run a query within a React component, call `useUserAllergiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAllergiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAllergiesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useUserAllergiesQuery(baseOptions: Apollo.QueryHookOptions<UserAllergiesQuery, UserAllergiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAllergiesQuery, UserAllergiesQueryVariables>(UserAllergiesDocument, options);
      }
export function useUserAllergiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAllergiesQuery, UserAllergiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAllergiesQuery, UserAllergiesQueryVariables>(UserAllergiesDocument, options);
        }
export type UserAllergiesQueryHookResult = ReturnType<typeof useUserAllergiesQuery>;
export type UserAllergiesLazyQueryHookResult = ReturnType<typeof useUserAllergiesLazyQuery>;
export type UserAllergiesQueryResult = Apollo.QueryResult<UserAllergiesQuery, UserAllergiesQueryVariables>;
export const UserDocumentsDocument = gql`
    query UserDocuments($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String) {
  patient(where: {id: $patientId}) {
    id
    documents(
      skip: $skip
      take: $take
      orderBy: [{addedAt: desc}, {id: asc}]
      where: {OR: [{title: {mode: insensitive, contains: $searchTerm}}]}
    ) {
      id
      file {
        ...FileFields
      }
      attachment {
        filename
        url
      }
      doctor {
        id
        user {
          id
          firstName
          middleName
          lastName
        }
      }
      form {
        id
        appointment {
          id
          event {
            id
            address {
              id
              addressLine1
              addressLine2
              locality
              postalCode
            }
            eventType {
              id
              value
            }
          }
        }
        name
        slug
        issuedAt
        formFields
        doctor {
          id
          clinicFaxNumber
          clinicPhoneNumber
          licenseNumber
          doctorSpecialty {
            id
            label
            value
          }
          ohipPractitionerNumber
          signature {
            id
            file {
              ...FileFields
            }
            attachment {
              filename
              url
            }
          }
          user {
            id
            firstName
            middleName
            lastName
          }
        }
        patient {
          ...PatientBasicFields
        }
      }
      addedAt
      title
    }
    user {
      id
      username
    }
  }
}
    ${FileFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useUserDocumentsQuery__
 *
 * To run a query within a React component, call `useUserDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDocumentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useUserDocumentsQuery(baseOptions: Apollo.QueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
      }
export function useUserDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
        }
export type UserDocumentsQueryHookResult = ReturnType<typeof useUserDocumentsQuery>;
export type UserDocumentsLazyQueryHookResult = ReturnType<typeof useUserDocumentsLazyQuery>;
export type UserDocumentsQueryResult = Apollo.QueryResult<UserDocumentsQuery, UserDocumentsQueryVariables>;
export const UserDocumentDocument = gql`
    query UserDocument($documentId: ID!) {
  document(where: {id: $documentId}) {
    id
    file {
      ...FileFields
    }
    attachment {
      filename
      url
    }
    doctor {
      id
      user {
        id
        firstName
        middleName
        lastName
      }
    }
    form {
      id
      appointment {
        id
        event {
          id
          address {
            id
            addressLine1
            addressLine2
            locality
            postalCode
          }
          eventType {
            id
            value
          }
        }
      }
      name
      slug
      issuedAt
      formFields
      doctor {
        id
        clinicFaxNumber
        clinicPhoneNumber
        licenseNumber
        doctorSpecialty {
          id
          label
          value
        }
        ohipPractitionerNumber
        signature {
          id
          file {
            ...FileFields
          }
          attachment {
            filename
            url
          }
        }
        user {
          id
          firstName
          middleName
          lastName
        }
      }
      patient {
        ...PatientBasicFields
      }
    }
    addedAt
    title
  }
}
    ${FileFieldsFragmentDoc}
${PatientBasicFieldsFragmentDoc}`;

/**
 * __useUserDocumentQuery__
 *
 * To run a query within a React component, call `useUserDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useUserDocumentQuery(baseOptions: Apollo.QueryHookOptions<UserDocumentQuery, UserDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDocumentQuery, UserDocumentQueryVariables>(UserDocumentDocument, options);
      }
export function useUserDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDocumentQuery, UserDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDocumentQuery, UserDocumentQueryVariables>(UserDocumentDocument, options);
        }
export type UserDocumentQueryHookResult = ReturnType<typeof useUserDocumentQuery>;
export type UserDocumentLazyQueryHookResult = ReturnType<typeof useUserDocumentLazyQuery>;
export type UserDocumentQueryResult = Apollo.QueryResult<UserDocumentQuery, UserDocumentQueryVariables>;
export const UserHealthConditionsDocument = gql`
    query UserHealthConditions($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String, $filters: [HealthConditionWhereInput!]) {
  healthConditions(
    skip: $skip
    take: $take
    orderBy: [{diagnosedAt: desc}, {id: asc}]
    where: {AND: $filters, patient: {id: {equals: $patientId}}, OR: [{name: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    diagnosedAt
    name
    relation
    inactivatedAt
    inactivatedBy {
      id
    }
  }
}
    `;

/**
 * __useUserHealthConditionsQuery__
 *
 * To run a query within a React component, call `useUserHealthConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHealthConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHealthConditionsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUserHealthConditionsQuery(baseOptions: Apollo.QueryHookOptions<UserHealthConditionsQuery, UserHealthConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserHealthConditionsQuery, UserHealthConditionsQueryVariables>(UserHealthConditionsDocument, options);
      }
export function useUserHealthConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserHealthConditionsQuery, UserHealthConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserHealthConditionsQuery, UserHealthConditionsQueryVariables>(UserHealthConditionsDocument, options);
        }
export type UserHealthConditionsQueryHookResult = ReturnType<typeof useUserHealthConditionsQuery>;
export type UserHealthConditionsLazyQueryHookResult = ReturnType<typeof useUserHealthConditionsLazyQuery>;
export type UserHealthConditionsQueryResult = Apollo.QueryResult<UserHealthConditionsQuery, UserHealthConditionsQueryVariables>;
export const UserInvitesByEmailDocument = gql`
    query UserInvitesByEmail($email: String!) {
  userInvites(
    where: {email: {equals: $email, mode: insensitive}, revokedAt: {equals: null}}
  ) {
    id
    createdAt
    firstName
    lastName
    cellPhoneNumberString
    dateOfBirth
    email
    healthCard {
      id
      insurancePolicyNumber
      versionCode
      expiryDate
    }
    invitedByUser {
      id
      firstName
      lastName
    }
    revokedAt
    signedUpUser {
      id
      patient {
        id
      }
    }
  }
}
    `;

/**
 * __useUserInvitesByEmailQuery__
 *
 * To run a query within a React component, call `useUserInvitesByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvitesByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvitesByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserInvitesByEmailQuery(baseOptions: Apollo.QueryHookOptions<UserInvitesByEmailQuery, UserInvitesByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInvitesByEmailQuery, UserInvitesByEmailQueryVariables>(UserInvitesByEmailDocument, options);
      }
export function useUserInvitesByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInvitesByEmailQuery, UserInvitesByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInvitesByEmailQuery, UserInvitesByEmailQueryVariables>(UserInvitesByEmailDocument, options);
        }
export type UserInvitesByEmailQueryHookResult = ReturnType<typeof useUserInvitesByEmailQuery>;
export type UserInvitesByEmailLazyQueryHookResult = ReturnType<typeof useUserInvitesByEmailLazyQuery>;
export type UserInvitesByEmailQueryResult = Apollo.QueryResult<UserInvitesByEmailQuery, UserInvitesByEmailQueryVariables>;
export const UserInvitePublicDataDocument = gql`
    query UserInvitePublicData($inviteId: ID!) {
  getInvitePublicData(inviteId: $inviteId)
}
    `;

/**
 * __useUserInvitePublicDataQuery__
 *
 * To run a query within a React component, call `useUserInvitePublicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvitePublicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvitePublicDataQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useUserInvitePublicDataQuery(baseOptions: Apollo.QueryHookOptions<UserInvitePublicDataQuery, UserInvitePublicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInvitePublicDataQuery, UserInvitePublicDataQueryVariables>(UserInvitePublicDataDocument, options);
      }
export function useUserInvitePublicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInvitePublicDataQuery, UserInvitePublicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInvitePublicDataQuery, UserInvitePublicDataQueryVariables>(UserInvitePublicDataDocument, options);
        }
export type UserInvitePublicDataQueryHookResult = ReturnType<typeof useUserInvitePublicDataQuery>;
export type UserInvitePublicDataLazyQueryHookResult = ReturnType<typeof useUserInvitePublicDataLazyQuery>;
export type UserInvitePublicDataQueryResult = Apollo.QueryResult<UserInvitePublicDataQuery, UserInvitePublicDataQueryVariables>;
export const UserInviteDocument = gql`
    query UserInvite($inviteId: ID!) {
  userInvite(where: {id: $inviteId}) {
    id
    createdAt
    firstName
    lastName
    cellPhoneNumberString
    dateOfBirth
    email
    healthCard {
      id
      insurancePolicyNumber
      versionCode
      expiryDate
    }
    invitedByUser {
      id
      firstName
      lastName
    }
    revokedAt
    signedUpUser {
      id
      patient {
        id
      }
    }
  }
}
    `;

/**
 * __useUserInviteQuery__
 *
 * To run a query within a React component, call `useUserInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInviteQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useUserInviteQuery(baseOptions: Apollo.QueryHookOptions<UserInviteQuery, UserInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInviteQuery, UserInviteQueryVariables>(UserInviteDocument, options);
      }
export function useUserInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInviteQuery, UserInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInviteQuery, UserInviteQueryVariables>(UserInviteDocument, options);
        }
export type UserInviteQueryHookResult = ReturnType<typeof useUserInviteQuery>;
export type UserInviteLazyQueryHookResult = ReturnType<typeof useUserInviteLazyQuery>;
export type UserInviteQueryResult = Apollo.QueryResult<UserInviteQuery, UserInviteQueryVariables>;
export const UserLifestyleDocument = gql`
    query UserLifestyle($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String, $filters: [LifestyleItemWhereInput!]) {
  lifestyleItems(
    skip: $skip
    take: $take
    where: {AND: $filters, patient: {id: {equals: $patientId}}, OR: [{activity: {mode: insensitive, contains: $searchTerm}}, {frequency: {mode: insensitive, contains: $searchTerm}}, {item: {mode: insensitive, contains: $searchTerm}}]}
  ) {
    id
    activity
    frequency
    item
    inactivatedAt
    inactivatedBy {
      id
    }
  }
}
    `;

/**
 * __useUserLifestyleQuery__
 *
 * To run a query within a React component, call `useUserLifestyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLifestyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLifestyleQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUserLifestyleQuery(baseOptions: Apollo.QueryHookOptions<UserLifestyleQuery, UserLifestyleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserLifestyleQuery, UserLifestyleQueryVariables>(UserLifestyleDocument, options);
      }
export function useUserLifestyleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserLifestyleQuery, UserLifestyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserLifestyleQuery, UserLifestyleQueryVariables>(UserLifestyleDocument, options);
        }
export type UserLifestyleQueryHookResult = ReturnType<typeof useUserLifestyleQuery>;
export type UserLifestyleLazyQueryHookResult = ReturnType<typeof useUserLifestyleLazyQuery>;
export type UserLifestyleQueryResult = Apollo.QueryResult<UserLifestyleQuery, UserLifestyleQueryVariables>;
export const UserMedicationItemsDocument = gql`
    query UserMedicationItems($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String, $filters: [MedicationItemWhereInput!]) {
  medicationItems(
    skip: $skip
    take: $take
    orderBy: [{prescribedAt: desc}, {id: asc}]
    where: {AND: $filters, patient: {id: {equals: $patientId}}, OR: [{doctor: {user: {OR: [{lastName: {contains: $searchTerm, mode: insensitive}}, {firstName: {contains: $searchTerm, mode: insensitive}}]}}}, {medication: {brandName: {mode: insensitive, contains: $searchTerm}}}, {medication: {activeIngredients: {some: {ingredientName: {mode: insensitive, contains: $searchTerm}}}}}]}
  ) {
    id
    doctor {
      id
      user {
        id
        firstName
        lastName
      }
    }
    inactivatedAt
    inactivatedBy {
      id
    }
    instructions
    medication {
      id
      activeIngredients {
        id
        drugCode
        ingredientName
        strengthUnit
        strengthValue
      }
      brandName
      drugCode
    }
    prescribedAt
    refills
  }
}
    `;

/**
 * __useUserMedicationItemsQuery__
 *
 * To run a query within a React component, call `useUserMedicationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMedicationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMedicationItemsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUserMedicationItemsQuery(baseOptions: Apollo.QueryHookOptions<UserMedicationItemsQuery, UserMedicationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMedicationItemsQuery, UserMedicationItemsQueryVariables>(UserMedicationItemsDocument, options);
      }
export function useUserMedicationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMedicationItemsQuery, UserMedicationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMedicationItemsQuery, UserMedicationItemsQueryVariables>(UserMedicationItemsDocument, options);
        }
export type UserMedicationItemsQueryHookResult = ReturnType<typeof useUserMedicationItemsQuery>;
export type UserMedicationItemsLazyQueryHookResult = ReturnType<typeof useUserMedicationItemsLazyQuery>;
export type UserMedicationItemsQueryResult = Apollo.QueryResult<UserMedicationItemsQuery, UserMedicationItemsQueryVariables>;
export const UserProfileDocument = gql`
    query UserProfile($username: String!) {
  user(where: {username: $username}) {
    ...UserContactFields
    ...UserPhotoFields
  }
}
    ${UserContactFieldsFragmentDoc}
${UserPhotoFieldsFragmentDoc}`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserPromptsDocument = gql`
    query UserPrompts($userId: ID!) {
  prompts(where: {user: {id: {equals: $userId}}}) {
    id
    promptType
    promptValue
    slug
  }
}
    `;

/**
 * __useUserPromptsQuery__
 *
 * To run a query within a React component, call `useUserPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPromptsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPromptsQuery(baseOptions: Apollo.QueryHookOptions<UserPromptsQuery, UserPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPromptsQuery, UserPromptsQueryVariables>(UserPromptsDocument, options);
      }
export function useUserPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPromptsQuery, UserPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPromptsQuery, UserPromptsQueryVariables>(UserPromptsDocument, options);
        }
export type UserPromptsQueryHookResult = ReturnType<typeof useUserPromptsQuery>;
export type UserPromptsLazyQueryHookResult = ReturnType<typeof useUserPromptsLazyQuery>;
export type UserPromptsQueryResult = Apollo.QueryResult<UserPromptsQuery, UserPromptsQueryVariables>;
export const UserDocument = gql`
    query User($userId: ID!) {
  user(where: {id: $userId}) {
    ...UserBasicDataFields
  }
}
    ${UserBasicDataFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserScreeningTestsDocument = gql`
    query UserScreeningTests($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String) {
  patient(where: {id: $patientId}) {
    id
    screeningTests(
      skip: $skip
      take: $take
      orderBy: [{testedAt: desc}, {id: asc}]
      where: {OR: [{name: {mode: insensitive, contains: $searchTerm}}]}
    ) {
      id
      name
      testedAt
    }
    user {
      id
      username
    }
  }
}
    `;

/**
 * __useUserScreeningTestsQuery__
 *
 * To run a query within a React component, call `useUserScreeningTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserScreeningTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserScreeningTestsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useUserScreeningTestsQuery(baseOptions: Apollo.QueryHookOptions<UserScreeningTestsQuery, UserScreeningTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserScreeningTestsQuery, UserScreeningTestsQueryVariables>(UserScreeningTestsDocument, options);
      }
export function useUserScreeningTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserScreeningTestsQuery, UserScreeningTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserScreeningTestsQuery, UserScreeningTestsQueryVariables>(UserScreeningTestsDocument, options);
        }
export type UserScreeningTestsQueryHookResult = ReturnType<typeof useUserScreeningTestsQuery>;
export type UserScreeningTestsLazyQueryHookResult = ReturnType<typeof useUserScreeningTestsLazyQuery>;
export type UserScreeningTestsQueryResult = Apollo.QueryResult<UserScreeningTestsQuery, UserScreeningTestsQueryVariables>;
export const UserSessionsDocument = gql`
    query UserSessions($skip: Int, $take: Int, $orderBy: [UserSessionOrderByInput!], $where: UserSessionWhereInput) {
  userSessions(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    id
    lastActivity
    lastPath
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useUserSessionsQuery__
 *
 * To run a query within a React component, call `useUserSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSessionsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserSessionsQuery(baseOptions?: Apollo.QueryHookOptions<UserSessionsQuery, UserSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSessionsQuery, UserSessionsQueryVariables>(UserSessionsDocument, options);
      }
export function useUserSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSessionsQuery, UserSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSessionsQuery, UserSessionsQueryVariables>(UserSessionsDocument, options);
        }
export type UserSessionsQueryHookResult = ReturnType<typeof useUserSessionsQuery>;
export type UserSessionsLazyQueryHookResult = ReturnType<typeof useUserSessionsLazyQuery>;
export type UserSessionsQueryResult = Apollo.QueryResult<UserSessionsQuery, UserSessionsQueryVariables>;
export const UserVaccinationsDocument = gql`
    query UserVaccinations($skip: Int, $take: Int, $patientId: ID!, $searchTerm: String) {
  patient(where: {id: $patientId}) {
    id
    vaccinations(
      skip: $skip
      take: $take
      orderBy: [{immunizedAt: desc}, {id: asc}]
      where: {OR: [{medication: {brandName: {mode: insensitive, contains: $searchTerm}}}, {medication: {activeIngredients: {some: {ingredientName: {mode: insensitive, contains: $searchTerm}}}}}]}
    ) {
      id
      doctor {
        id
        user {
          id
          firstName
          lastName
        }
      }
      expirationDate
      immunizedAt
      medication {
        id
        activeIngredients {
          id
          drugCode
          ingredientName
          strengthUnit
          strengthValue
        }
        brandName
        drugCode
        drugIdentificationNumber
      }
    }
    user {
      id
      username
    }
  }
}
    `;

/**
 * __useUserVaccinationsQuery__
 *
 * To run a query within a React component, call `useUserVaccinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVaccinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVaccinationsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      patientId: // value for 'patientId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useUserVaccinationsQuery(baseOptions: Apollo.QueryHookOptions<UserVaccinationsQuery, UserVaccinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserVaccinationsQuery, UserVaccinationsQueryVariables>(UserVaccinationsDocument, options);
      }
export function useUserVaccinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserVaccinationsQuery, UserVaccinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserVaccinationsQuery, UserVaccinationsQueryVariables>(UserVaccinationsDocument, options);
        }
export type UserVaccinationsQueryHookResult = ReturnType<typeof useUserVaccinationsQuery>;
export type UserVaccinationsLazyQueryHookResult = ReturnType<typeof useUserVaccinationsLazyQuery>;
export type UserVaccinationsQueryResult = Apollo.QueryResult<UserVaccinationsQuery, UserVaccinationsQueryVariables>;
export const VideoParticipantUsersDocument = gql`
    query VideoParticipantUsers($userIds: [ID!]!) {
  users(where: {id: {in: $userIds}}) {
    id
    firstName
    lastName
    ...UserPhotoFields
  }
}
    ${UserPhotoFieldsFragmentDoc}`;

/**
 * __useVideoParticipantUsersQuery__
 *
 * To run a query within a React component, call `useVideoParticipantUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoParticipantUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoParticipantUsersQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useVideoParticipantUsersQuery(baseOptions: Apollo.QueryHookOptions<VideoParticipantUsersQuery, VideoParticipantUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoParticipantUsersQuery, VideoParticipantUsersQueryVariables>(VideoParticipantUsersDocument, options);
      }
export function useVideoParticipantUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoParticipantUsersQuery, VideoParticipantUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoParticipantUsersQuery, VideoParticipantUsersQueryVariables>(VideoParticipantUsersDocument, options);
        }
export type VideoParticipantUsersQueryHookResult = ReturnType<typeof useVideoParticipantUsersQuery>;
export type VideoParticipantUsersLazyQueryHookResult = ReturnType<typeof useVideoParticipantUsersLazyQuery>;
export type VideoParticipantUsersQueryResult = Apollo.QueryResult<VideoParticipantUsersQuery, VideoParticipantUsersQueryVariables>;
export const VitalsDocument = gql`
    query Vitals($vitalsId: ID!) {
  appointmentVital(where: {id: $vitalsId}) {
    ...VitalsFields
    patient {
      id
      user {
        id
        dateOfBirth
      }
    }
  }
}
    ${VitalsFieldsFragmentDoc}`;

/**
 * __useVitalsQuery__
 *
 * To run a query within a React component, call `useVitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVitalsQuery({
 *   variables: {
 *      vitalsId: // value for 'vitalsId'
 *   },
 * });
 */
export function useVitalsQuery(baseOptions: Apollo.QueryHookOptions<VitalsQuery, VitalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VitalsQuery, VitalsQueryVariables>(VitalsDocument, options);
      }
export function useVitalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VitalsQuery, VitalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VitalsQuery, VitalsQueryVariables>(VitalsDocument, options);
        }
export type VitalsQueryHookResult = ReturnType<typeof useVitalsQuery>;
export type VitalsLazyQueryHookResult = ReturnType<typeof useVitalsLazyQuery>;
export type VitalsQueryResult = Apollo.QueryResult<VitalsQuery, VitalsQueryVariables>;
export const WeekdaySlotsDocument = gql`
    query WeekdaySlots($scheduleId: ID!) {
  doctors(where: {calendar: {schedules: {some: {id: {equals: $scheduleId}}}}}) {
    calendar {
      id
      defaultSchedule {
        id
        tz
      }
    }
  }
  recurringSlots(
    where: {interval: {equals: "week"}, schedule: {id: {equals: $scheduleId}}}
  ) {
    id
    wday
    interval
    intervalCount
    timeIntervals {
      id
      from
      to
    }
  }
}
    `;

/**
 * __useWeekdaySlotsQuery__
 *
 * To run a query within a React component, call `useWeekdaySlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeekdaySlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeekdaySlotsQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useWeekdaySlotsQuery(baseOptions: Apollo.QueryHookOptions<WeekdaySlotsQuery, WeekdaySlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeekdaySlotsQuery, WeekdaySlotsQueryVariables>(WeekdaySlotsDocument, options);
      }
export function useWeekdaySlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeekdaySlotsQuery, WeekdaySlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeekdaySlotsQuery, WeekdaySlotsQueryVariables>(WeekdaySlotsDocument, options);
        }
export type WeekdaySlotsQueryHookResult = ReturnType<typeof useWeekdaySlotsQuery>;
export type WeekdaySlotsLazyQueryHookResult = ReturnType<typeof useWeekdaySlotsLazyQuery>;
export type WeekdaySlotsQueryResult = Apollo.QueryResult<WeekdaySlotsQuery, WeekdaySlotsQueryVariables>;
export const AppointmentSessionChangeDocument = gql`
    subscription AppointmentSessionChange($appointmentId: ID!) {
  appointmentSessionChanged(appointmentId: $appointmentId) {
    id
    appointment {
      id
    }
    doctor {
      id
    }
    duration
    endedAt
    isActive
    patient {
      id
    }
    startedAt
  }
}
    `;

/**
 * __useAppointmentSessionChangeSubscription__
 *
 * To run a query within a React component, call `useAppointmentSessionChangeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentSessionChangeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentSessionChangeSubscription({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentSessionChangeSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentSessionChangeSubscription, AppointmentSessionChangeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentSessionChangeSubscription, AppointmentSessionChangeSubscriptionVariables>(AppointmentSessionChangeDocument, options);
      }
export type AppointmentSessionChangeSubscriptionHookResult = ReturnType<typeof useAppointmentSessionChangeSubscription>;
export type AppointmentSessionChangeSubscriptionResult = Apollo.SubscriptionResult<AppointmentSessionChangeSubscription>;
export const ChatMessageUpdateDocument = gql`
    subscription ChatMessageUpdate($chatId: ID!) {
  chatMessageUpdated(chatId: $chatId) {
    id
    createdAt
    readAt
    text
    author {
      id
      firstName
      lastName
      profilePhoto {
        id
        src {
          id
          publicUrlTransformed
        }
      }
    }
    replyTo {
      id
      createdAt
      readAt
      text
      author {
        id
        firstName
        lastName
        profilePhoto {
          id
          src {
            id
            publicUrlTransformed
          }
        }
      }
    }
    uuid
    chat {
      id
    }
  }
}
    `;

/**
 * __useChatMessageUpdateSubscription__
 *
 * To run a query within a React component, call `useChatMessageUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessageUpdateSubscription({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatMessageUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatMessageUpdateSubscription, ChatMessageUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatMessageUpdateSubscription, ChatMessageUpdateSubscriptionVariables>(ChatMessageUpdateDocument, options);
      }
export type ChatMessageUpdateSubscriptionHookResult = ReturnType<typeof useChatMessageUpdateSubscription>;
export type ChatMessageUpdateSubscriptionResult = Apollo.SubscriptionResult<ChatMessageUpdateSubscription>;